
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6958"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6958"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("l6FST", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5daa5e44059b221$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5daa5e44059b221$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_defaultSxConfig.default;
    }
});

var $f5daa5e44059b221$var$_styleFunctionSx = $f5daa5e44059b221$require$_interopRequireWildcard((parcelRequire("jUGyl")));

var $f5daa5e44059b221$var$_extendSxProp = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("i3YEE")));

var $f5daa5e44059b221$var$_defaultSxConfig = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("epNpO")));

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3pEGv", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $27c3440315f0d929$var$_typeof = $41YNz.default;
function $27c3440315f0d929$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = $27c3440315f0d929$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $27c3440315f0d929$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = $27c3440315f0d929$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jUGyl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7f4416c1e9a283b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx;

var $e7f4416c1e9a283b$var$_capitalize = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("4O6za")));

var $e7f4416c1e9a283b$var$_merge = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fuavR = parcelRequire("fuavR");

var $9mzYC = parcelRequire("9mzYC");

var $18kGB = parcelRequire("18kGB");

var $e7f4416c1e9a283b$var$_defaultSxConfig = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("epNpO")));
function $e7f4416c1e9a283b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $e7f4416c1e9a283b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $fuavR.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $fuavR.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $fuavR.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $e7f4416c1e9a283b$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $e7f4416c1e9a283b$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $9mzYC.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $e7f4416c1e9a283b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $9mzYC.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($e7f4416c1e9a283b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $e7f4416c1e9a283b$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $e7f4416c1e9a283b$var$styleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx();
$e7f4416c1e9a283b$var$styleFunctionSx.filterProps = [
    'sx'
];
var $e7f4416c1e9a283b$var$_default = module.exports.default = $e7f4416c1e9a283b$var$styleFunctionSx;

});
parcelRegister("4O6za", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3800ecdd7c2cde61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3800ecdd7c2cde61$var$_capitalize.default;
    }
});

var $3800ecdd7c2cde61$var$_capitalize = $3800ecdd7c2cde61$require$_interopRequireDefault((parcelRequire("afs59")));

});
parcelRegister("afs59", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $776116989b0b93ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $776116989b0b93ea$var$capitalize;

var $776116989b0b93ea$var$_formatMuiErrorMessage = $776116989b0b93ea$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $776116989b0b93ea$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $776116989b0b93ea$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("4Z6Nd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a1220d25e8f9182$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3a1220d25e8f9182$var$_formatMuiErrorMessage.default;
    }
});

var $3a1220d25e8f9182$var$_formatMuiErrorMessage = $3a1220d25e8f9182$require$_interopRequireDefault((parcelRequire("3goXx")));

});
parcelRegister("3goXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26063a188a6d1521$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $26063a188a6d1521$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});




parcelRegister("3naDD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $274bc59c460c5c83$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $274bc59c460c5c83$var$_merge.default;
    }
});

var $274bc59c460c5c83$var$_merge = $274bc59c460c5c83$require$_interopRequireDefault((parcelRequire("jb2Pw")));

});
parcelRegister("jb2Pw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $df613d60ccca226b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df613d60ccca226b$var$_deepmerge = $df613d60ccca226b$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $df613d60ccca226b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $df613d60ccca226b$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $df613d60ccca226b$var$_default = module.exports.default = $df613d60ccca226b$var$merge;

});
parcelRegister("bQ4jM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $89e7e67df7bfe402$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $89e7e67df7bfe402$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $89e7e67df7bfe402$var$_deepmerge.default;
    }
});

var $89e7e67df7bfe402$var$_deepmerge = $89e7e67df7bfe402$require$_interopRequireWildcard((parcelRequire("7lnJD")));
Object.keys($89e7e67df7bfe402$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($89e7e67df7bfe402$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $89e7e67df7bfe402$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $89e7e67df7bfe402$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("7lnJD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $558ce7df2a941302$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $558ce7df2a941302$var$deepmerge;
module.exports.isPlainObject = $558ce7df2a941302$var$isPlainObject;

var $558ce7df2a941302$var$React = $558ce7df2a941302$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $558ce7df2a941302$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $558ce7df2a941302$var$deepClone(source) {
    if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source) || (0, $4jPKB.isValidElementType)(source) || !$558ce7df2a941302$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $558ce7df2a941302$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $558ce7df2a941302$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($558ce7df2a941302$var$isPlainObject(target) && $558ce7df2a941302$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source[key]) || (0, $4jPKB.isValidElementType)(source[key])) output[key] = source[key];
        else if ($558ce7df2a941302$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $558ce7df2a941302$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $558ce7df2a941302$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $558ce7df2a941302$var$isPlainObject(source[key]) ? $558ce7df2a941302$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                    case $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});






parcelRegister("fuavR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b461d00304dae97f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b461d00304dae97f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b461d00304dae97f$var$_style.default;
    }
});

var $b461d00304dae97f$var$_style = $b461d00304dae97f$require$_interopRequireWildcard((parcelRequire("5Wz76")));
Object.keys($b461d00304dae97f$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b461d00304dae97f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b461d00304dae97f$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b461d00304dae97f$var$_style[key];
        }
    });
});

});
parcelRegister("5Wz76", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $453d9b5a5bc206c2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $453d9b5a5bc206c2$var$getPath;
module.exports.getStyleValue = $453d9b5a5bc206c2$var$getStyleValue;

var $453d9b5a5bc206c2$var$_capitalize = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("4O6za")));

var $453d9b5a5bc206c2$var$_responsivePropType = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");
function $453d9b5a5bc206c2$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $453d9b5a5bc206c2$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $453d9b5a5bc206c2$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $453d9b5a5bc206c2$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $453d9b5a5bc206c2$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $453d9b5a5bc206c2$var$_default = module.exports.default = $453d9b5a5bc206c2$var$style;

});
parcelRegister("h7FAc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c773589584969aa7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c773589584969aa7$var$_responsivePropType.default;
    }
});

var $c773589584969aa7$var$_responsivePropType = $c773589584969aa7$require$_interopRequireDefault((parcelRequire("aLDOi")));

});
parcelRegister("aLDOi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7d6d2ca3605e13f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6d2ca3605e13f8$var$_propTypes = $7d6d2ca3605e13f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $7d6d2ca3605e13f8$var$responsivePropType = {};
var $7d6d2ca3605e13f8$var$_default = module.exports.default = $7d6d2ca3605e13f8$var$responsivePropType;

});


parcelRegister("9mzYC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d12135a7affaa27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d12135a7affaa27$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d12135a7affaa27$var$_breakpoints.default;
    }
});

var $6d12135a7affaa27$var$_breakpoints = $6d12135a7affaa27$require$_interopRequireWildcard((parcelRequire("1D6M1")));
Object.keys($6d12135a7affaa27$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d12135a7affaa27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d12135a7affaa27$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d12135a7affaa27$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("1D6M1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12feb01311e15547$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $12feb01311e15547$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $12feb01311e15547$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $12feb01311e15547$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $12feb01311e15547$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $12feb01311e15547$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $12feb01311e15547$var$resolveBreakpointValues;
module.exports.values = void 0;

var $12feb01311e15547$var$_propTypes = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12feb01311e15547$var$_deepmerge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $12feb01311e15547$var$_merge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("3naDD")));

var $18kGB = parcelRequire("18kGB");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $12feb01311e15547$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $12feb01311e15547$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$12feb01311e15547$var$values[key]}px)`
};
const $12feb01311e15547$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $12feb01311e15547$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $12feb01311e15547$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $18kGB.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $18kGB.getContainerQuery)(theme.containerQueries ? theme : $12feb01311e15547$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $12feb01311e15547$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $12feb01311e15547$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $12feb01311e15547$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $12feb01311e15547$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $12feb01311e15547$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $12feb01311e15547$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $12feb01311e15547$var$_deepmerge.default)(prev, next), {});
    return $12feb01311e15547$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $12feb01311e15547$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $12feb01311e15547$var$_default = module.exports.default = $12feb01311e15547$var$breakpoints;

});
parcelRegister("18kGB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d3695a183c24848$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $0d3695a183c24848$var$_cssContainerQueries = $0d3695a183c24848$require$_interopRequireWildcard((parcelRequire("hkwSq")));

});
parcelRegister("hkwSq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c9ddce8fd7553cea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9ddce8fd7553cea$var$cssContainerQueries;
module.exports.getContainerQuery = $c9ddce8fd7553cea$var$getContainerQuery;
module.exports.isCqShorthand = $c9ddce8fd7553cea$var$isCqShorthand;
module.exports.sortContainerQueries = $c9ddce8fd7553cea$var$sortContainerQueries;

var $c9ddce8fd7553cea$var$_formatMuiErrorMessage = $c9ddce8fd7553cea$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */ function $c9ddce8fd7553cea$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $c9ddce8fd7553cea$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $c9ddce8fd7553cea$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $c9ddce8fd7553cea$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});






parcelRegister("epNpO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ZgMs = parcelRequire("8ZgMs");

var $7G2Ky = parcelRequire("7G2Ky");

var $bvdLQ = parcelRequire("bvdLQ");

var $7Izgs = parcelRequire("7Izgs");

var $lk86k = parcelRequire("lk86k");
const $a7e9bb596240d630$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $7G2Ky.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $7Izgs.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    // spacing
    p: {
        style: $8ZgMs.padding
    },
    pt: {
        style: $8ZgMs.padding
    },
    pr: {
        style: $8ZgMs.padding
    },
    pb: {
        style: $8ZgMs.padding
    },
    pl: {
        style: $8ZgMs.padding
    },
    px: {
        style: $8ZgMs.padding
    },
    py: {
        style: $8ZgMs.padding
    },
    padding: {
        style: $8ZgMs.padding
    },
    paddingTop: {
        style: $8ZgMs.padding
    },
    paddingRight: {
        style: $8ZgMs.padding
    },
    paddingBottom: {
        style: $8ZgMs.padding
    },
    paddingLeft: {
        style: $8ZgMs.padding
    },
    paddingX: {
        style: $8ZgMs.padding
    },
    paddingY: {
        style: $8ZgMs.padding
    },
    paddingInline: {
        style: $8ZgMs.padding
    },
    paddingInlineStart: {
        style: $8ZgMs.padding
    },
    paddingInlineEnd: {
        style: $8ZgMs.padding
    },
    paddingBlock: {
        style: $8ZgMs.padding
    },
    paddingBlockStart: {
        style: $8ZgMs.padding
    },
    paddingBlockEnd: {
        style: $8ZgMs.padding
    },
    m: {
        style: $8ZgMs.margin
    },
    mt: {
        style: $8ZgMs.margin
    },
    mr: {
        style: $8ZgMs.margin
    },
    mb: {
        style: $8ZgMs.margin
    },
    ml: {
        style: $8ZgMs.margin
    },
    mx: {
        style: $8ZgMs.margin
    },
    my: {
        style: $8ZgMs.margin
    },
    margin: {
        style: $8ZgMs.margin
    },
    marginTop: {
        style: $8ZgMs.margin
    },
    marginRight: {
        style: $8ZgMs.margin
    },
    marginBottom: {
        style: $8ZgMs.margin
    },
    marginLeft: {
        style: $8ZgMs.margin
    },
    marginX: {
        style: $8ZgMs.margin
    },
    marginY: {
        style: $8ZgMs.margin
    },
    marginInline: {
        style: $8ZgMs.margin
    },
    marginInlineStart: {
        style: $8ZgMs.margin
    },
    marginInlineEnd: {
        style: $8ZgMs.margin
    },
    marginBlock: {
        style: $8ZgMs.margin
    },
    marginBlockStart: {
        style: $8ZgMs.margin
    },
    marginBlockEnd: {
        style: $8ZgMs.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $bvdLQ.gap
    },
    rowGap: {
        style: $bvdLQ.rowGap
    },
    columnGap: {
        style: $bvdLQ.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $lk86k.sizingTransform
    },
    maxWidth: {
        style: $lk86k.maxWidth
    },
    minWidth: {
        transform: $lk86k.sizingTransform
    },
    height: {
        transform: $lk86k.sizingTransform
    },
    maxHeight: {
        transform: $lk86k.sizingTransform
    },
    minHeight: {
        transform: $lk86k.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a7e9bb596240d630$var$_default = module.exports.default = $a7e9bb596240d630$var$defaultSxConfig;

});
parcelRegister("8ZgMs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68b10981a323f192$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68b10981a323f192$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68b10981a323f192$var$_spacing.default;
    }
});

var $68b10981a323f192$var$_spacing = $68b10981a323f192$require$_interopRequireWildcard((parcelRequire("lJr29")));
Object.keys($68b10981a323f192$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68b10981a323f192$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68b10981a323f192$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68b10981a323f192$var$_spacing[key];
        }
    });
});

});
parcelRegister("lJr29", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd22c53f9de5e49d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $fd22c53f9de5e49d$var$createUnarySpacing;
module.exports.createUnaryUnit = $fd22c53f9de5e49d$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue;
module.exports.getValue = $fd22c53f9de5e49d$var$getValue;
module.exports.margin = $fd22c53f9de5e49d$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $fd22c53f9de5e49d$var$padding;
module.exports.paddingKeys = void 0;

var $fd22c53f9de5e49d$var$_responsivePropType = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");

var $fuavR = parcelRequire("fuavR");

var $fd22c53f9de5e49d$var$_merge = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("3naDD")));

var $fd22c53f9de5e49d$var$_memoize = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("iaYJn")));
const $fd22c53f9de5e49d$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $fd22c53f9de5e49d$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $fd22c53f9de5e49d$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fd22c53f9de5e49d$var$getCssProperties = (0, $fd22c53f9de5e49d$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fd22c53f9de5e49d$var$aliases[prop]) prop = $fd22c53f9de5e49d$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $fd22c53f9de5e49d$var$properties[a];
    const direction = $fd22c53f9de5e49d$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fd22c53f9de5e49d$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $fd22c53f9de5e49d$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $fd22c53f9de5e49d$var$spacingKeys = [
    ...$fd22c53f9de5e49d$var$marginKeys,
    ...$fd22c53f9de5e49d$var$paddingKeys
];
function $fd22c53f9de5e49d$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $fuavR.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $fd22c53f9de5e49d$var$createUnarySpacing(theme) {
    return $fd22c53f9de5e49d$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $fd22c53f9de5e49d$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fd22c53f9de5e49d$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $fd22c53f9de5e49d$var$getCssProperties(prop);
    const styleFromPropValue = $fd22c53f9de5e49d$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $fd22c53f9de5e49d$var$style(props, keys) {
    const transformer = $fd22c53f9de5e49d$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$fd22c53f9de5e49d$var$resolveCssProperty(props, keys, prop, transformer)).reduce($fd22c53f9de5e49d$var$_merge.default, {});
}
function $fd22c53f9de5e49d$var$margin(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$marginKeys);
}
$fd22c53f9de5e49d$var$margin.propTypes = {};
$fd22c53f9de5e49d$var$margin.filterProps = $fd22c53f9de5e49d$var$marginKeys;
function $fd22c53f9de5e49d$var$padding(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$paddingKeys);
}
$fd22c53f9de5e49d$var$padding.propTypes = {};
$fd22c53f9de5e49d$var$padding.filterProps = $fd22c53f9de5e49d$var$paddingKeys;
function $fd22c53f9de5e49d$var$spacing(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$spacingKeys);
}
$fd22c53f9de5e49d$var$spacing.propTypes = {};
$fd22c53f9de5e49d$var$spacing.filterProps = $fd22c53f9de5e49d$var$spacingKeys;
var $fd22c53f9de5e49d$var$_default = module.exports.default = $fd22c53f9de5e49d$var$spacing;

});
parcelRegister("iaYJn", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d3b8450df3f074ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d3b8450df3f074ab$var$_memoize.default;
    }
});

var $d3b8450df3f074ab$var$_memoize = $d3b8450df3f074ab$require$_interopRequireDefault((parcelRequire("9Z7Cd")));

});
parcelRegister("9Z7Cd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $744fb7d21d4e0357$var$memoize;
function $744fb7d21d4e0357$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("7G2Ky", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $596e96b5ea46c9bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $596e96b5ea46c9bd$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $596e96b5ea46c9bd$var$_borders.default;
    }
});

var $596e96b5ea46c9bd$var$_borders = $596e96b5ea46c9bd$require$_interopRequireWildcard((parcelRequire("ey2Y4")));
Object.keys($596e96b5ea46c9bd$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($596e96b5ea46c9bd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $596e96b5ea46c9bd$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $596e96b5ea46c9bd$var$_borders[key];
        }
    });
});

});
parcelRegister("ey2Y4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a9768b07cfcbed12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $a9768b07cfcbed12$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $a9768b07cfcbed12$var$_responsivePropType = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $a9768b07cfcbed12$var$_style = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a9768b07cfcbed12$var$_compose = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");
function $a9768b07cfcbed12$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a9768b07cfcbed12$var$createBorderStyle(prop, transform) {
    return (0, $a9768b07cfcbed12$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a9768b07cfcbed12$var$border = module.exports.border = $a9768b07cfcbed12$var$createBorderStyle('border', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderTop = module.exports.borderTop = $a9768b07cfcbed12$var$createBorderStyle('borderTop', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderRight = module.exports.borderRight = $a9768b07cfcbed12$var$createBorderStyle('borderRight', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderBottom = module.exports.borderBottom = $a9768b07cfcbed12$var$createBorderStyle('borderBottom', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderLeft = module.exports.borderLeft = $a9768b07cfcbed12$var$createBorderStyle('borderLeft', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderColor = module.exports.borderColor = $a9768b07cfcbed12$var$createBorderStyle('borderColor');
const $a9768b07cfcbed12$var$borderTopColor = module.exports.borderTopColor = $a9768b07cfcbed12$var$createBorderStyle('borderTopColor');
const $a9768b07cfcbed12$var$borderRightColor = module.exports.borderRightColor = $a9768b07cfcbed12$var$createBorderStyle('borderRightColor');
const $a9768b07cfcbed12$var$borderBottomColor = module.exports.borderBottomColor = $a9768b07cfcbed12$var$createBorderStyle('borderBottomColor');
const $a9768b07cfcbed12$var$borderLeftColor = module.exports.borderLeftColor = $a9768b07cfcbed12$var$createBorderStyle('borderLeftColor');
const $a9768b07cfcbed12$var$outline = module.exports.outline = $a9768b07cfcbed12$var$createBorderStyle('outline', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$outlineColor = module.exports.outlineColor = $a9768b07cfcbed12$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $a9768b07cfcbed12$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $a9768b07cfcbed12$var$borderRadius;
$a9768b07cfcbed12$var$borderRadius.propTypes = {};
$a9768b07cfcbed12$var$borderRadius.filterProps = [
    'borderRadius'
];
const $a9768b07cfcbed12$var$borders = (0, $a9768b07cfcbed12$var$_compose.default)($a9768b07cfcbed12$var$border, $a9768b07cfcbed12$var$borderTop, $a9768b07cfcbed12$var$borderRight, $a9768b07cfcbed12$var$borderBottom, $a9768b07cfcbed12$var$borderLeft, $a9768b07cfcbed12$var$borderColor, $a9768b07cfcbed12$var$borderTopColor, $a9768b07cfcbed12$var$borderRightColor, $a9768b07cfcbed12$var$borderBottomColor, $a9768b07cfcbed12$var$borderLeftColor, $a9768b07cfcbed12$var$borderRadius, $a9768b07cfcbed12$var$outline, $a9768b07cfcbed12$var$outlineColor);
var $a9768b07cfcbed12$var$_default = module.exports.default = $a9768b07cfcbed12$var$borders;

});
parcelRegister("79Mi4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $535ed5230f7674fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $535ed5230f7674fe$var$_compose.default;
    }
});

var $535ed5230f7674fe$var$_compose = $535ed5230f7674fe$require$_interopRequireDefault((parcelRequire("8J1Q9")));

});
parcelRegister("8J1Q9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65a3f4214179460a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a3f4214179460a$var$_merge = $65a3f4214179460a$require$_interopRequireDefault((parcelRequire("3naDD")));
function $65a3f4214179460a$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $65a3f4214179460a$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $65a3f4214179460a$var$_default = module.exports.default = $65a3f4214179460a$var$compose;

});




parcelRegister("bvdLQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85fd458c5ff1d64f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85fd458c5ff1d64f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85fd458c5ff1d64f$var$_cssGrid.default;
    }
});

var $85fd458c5ff1d64f$var$_cssGrid = $85fd458c5ff1d64f$require$_interopRequireWildcard((parcelRequire("guYP5")));
Object.keys($85fd458c5ff1d64f$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85fd458c5ff1d64f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85fd458c5ff1d64f$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85fd458c5ff1d64f$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("guYP5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c02ea0e0a59e3ff1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $c02ea0e0a59e3ff1$var$_style = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $c02ea0e0a59e3ff1$var$_compose = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");

var $c02ea0e0a59e3ff1$var$_responsivePropType = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("h7FAc")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $c02ea0e0a59e3ff1$var$gap;
$c02ea0e0a59e3ff1$var$gap.propTypes = {};
$c02ea0e0a59e3ff1$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $c02ea0e0a59e3ff1$var$columnGap;
$c02ea0e0a59e3ff1$var$columnGap.propTypes = {};
$c02ea0e0a59e3ff1$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $c02ea0e0a59e3ff1$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $c02ea0e0a59e3ff1$var$rowGap;
$c02ea0e0a59e3ff1$var$rowGap.propTypes = {};
$c02ea0e0a59e3ff1$var$rowGap.filterProps = [
    'rowGap'
];
const $c02ea0e0a59e3ff1$var$gridColumn = module.exports.gridColumn = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridColumn'
});
const $c02ea0e0a59e3ff1$var$gridRow = module.exports.gridRow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridRow'
});
const $c02ea0e0a59e3ff1$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $c02ea0e0a59e3ff1$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $c02ea0e0a59e3ff1$var$gridAutoRows = module.exports.gridAutoRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $c02ea0e0a59e3ff1$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $c02ea0e0a59e3ff1$var$gridArea = module.exports.gridArea = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridArea'
});
const $c02ea0e0a59e3ff1$var$grid = (0, $c02ea0e0a59e3ff1$var$_compose.default)($c02ea0e0a59e3ff1$var$gap, $c02ea0e0a59e3ff1$var$columnGap, $c02ea0e0a59e3ff1$var$rowGap, $c02ea0e0a59e3ff1$var$gridColumn, $c02ea0e0a59e3ff1$var$gridRow, $c02ea0e0a59e3ff1$var$gridAutoFlow, $c02ea0e0a59e3ff1$var$gridAutoColumns, $c02ea0e0a59e3ff1$var$gridAutoRows, $c02ea0e0a59e3ff1$var$gridTemplateColumns, $c02ea0e0a59e3ff1$var$gridTemplateRows, $c02ea0e0a59e3ff1$var$gridTemplateAreas, $c02ea0e0a59e3ff1$var$gridArea);
var $c02ea0e0a59e3ff1$var$_default = module.exports.default = $c02ea0e0a59e3ff1$var$grid;

});


parcelRegister("7Izgs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59e7ff3bb6005a45$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59e7ff3bb6005a45$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59e7ff3bb6005a45$var$_palette.default;
    }
});

var $59e7ff3bb6005a45$var$_palette = $59e7ff3bb6005a45$require$_interopRequireWildcard((parcelRequire("hQFW7")));
Object.keys($59e7ff3bb6005a45$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59e7ff3bb6005a45$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59e7ff3bb6005a45$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59e7ff3bb6005a45$var$_palette[key];
        }
    });
});

});
parcelRegister("hQFW7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cfe7d2b3f50e7c96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $cfe7d2b3f50e7c96$var$paletteTransform;

var $cfe7d2b3f50e7c96$var$_style = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("fuavR")));

var $cfe7d2b3f50e7c96$var$_compose = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("79Mi4")));
function $cfe7d2b3f50e7c96$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $cfe7d2b3f50e7c96$var$color = module.exports.color = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$bgcolor = module.exports.bgcolor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$backgroundColor = module.exports.backgroundColor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$palette = (0, $cfe7d2b3f50e7c96$var$_compose.default)($cfe7d2b3f50e7c96$var$color, $cfe7d2b3f50e7c96$var$bgcolor, $cfe7d2b3f50e7c96$var$backgroundColor);
var $cfe7d2b3f50e7c96$var$_default = module.exports.default = $cfe7d2b3f50e7c96$var$palette;

});


parcelRegister("lk86k", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f861bfedd540c484$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f861bfedd540c484$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f861bfedd540c484$var$_sizing.default;
    }
});

var $f861bfedd540c484$var$_sizing = $f861bfedd540c484$require$_interopRequireWildcard((parcelRequire("8hW4G")));
Object.keys($f861bfedd540c484$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f861bfedd540c484$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f861bfedd540c484$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f861bfedd540c484$var$_sizing[key];
        }
    });
});

});
parcelRegister("8hW4G", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $608cf5a5bac56020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $608cf5a5bac56020$var$sizingTransform;
module.exports.width = void 0;

var $608cf5a5bac56020$var$_style = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("fuavR")));

var $608cf5a5bac56020$var$_compose = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $9mzYC = parcelRequire("9mzYC");
function $608cf5a5bac56020$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $608cf5a5bac56020$var$width = module.exports.width = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $9mzYC.values[propValue];
            if (!breakpoint) return {
                maxWidth: $608cf5a5bac56020$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $608cf5a5bac56020$var$maxWidth;
$608cf5a5bac56020$var$maxWidth.filterProps = [
    'maxWidth'
];
const $608cf5a5bac56020$var$minWidth = module.exports.minWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minWidth',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$height = module.exports.height = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxHeight = module.exports.maxHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'maxHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$minHeight = module.exports.minHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeWidth = module.exports.sizeWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeHeight = module.exports.sizeHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$boxSizing = module.exports.boxSizing = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'boxSizing'
});
const $608cf5a5bac56020$var$sizing = (0, $608cf5a5bac56020$var$_compose.default)($608cf5a5bac56020$var$width, $608cf5a5bac56020$var$maxWidth, $608cf5a5bac56020$var$minWidth, $608cf5a5bac56020$var$height, $608cf5a5bac56020$var$maxHeight, $608cf5a5bac56020$var$minHeight, $608cf5a5bac56020$var$boxSizing);
var $608cf5a5bac56020$var$_default = module.exports.default = $608cf5a5bac56020$var$sizing;

});




parcelRegister("i3YEE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2678e896d0416ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2678e896d0416ce$var$extendSxProp;

var $bQ4jM = parcelRequire("bQ4jM");

var $d2678e896d0416ce$var$_defaultSxConfig = $d2678e896d0416ce$require$_interopRequireDefault((parcelRequire("epNpO")));
const $d2678e896d0416ce$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $d2678e896d0416ce$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d2678e896d0416ce$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $d2678e896d0416ce$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $bQ4jM.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("3zA0b", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29a0913aac547ce8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $29a0913aac547ce8$var$_clamp.default;
    }
});

var $29a0913aac547ce8$var$_clamp = $29a0913aac547ce8$require$_interopRequireDefault((parcelRequire("4CRKF")));

});
parcelRegister("4CRKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $35e4680625b68240$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $35e4680625b68240$var$_default = module.exports.default = $35e4680625b68240$var$clamp;

});


parcelRegister("3Vfwq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2db2bc563e7e5e69$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2db2bc563e7e5e69$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $2db2bc563e7e5e69$var$createCssVarsProvider;

var $2db2bc563e7e5e69$var$React = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2db2bc563e7e5e69$var$_propTypes = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f5O3L = parcelRequire("f5O3L");

var $6s7D4 = parcelRequire("6s7D4");

var $2db2bc563e7e5e69$var$_useEnhancedEffect = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2db2bc563e7e5e69$var$_ThemeProvider = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $2db2bc563e7e5e69$var$_InitColorSchemeScript = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("79OI6")));

var $2db2bc563e7e5e69$var$_useCurrentColorScheme = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("srPro")));

var $ayMG0 = parcelRequire("ayMG0");
const $2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $2db2bc563e7e5e69$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $2db2bc563e7e5e69$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $2db2bc563e7e5e69$var$React.createContext(undefined);
    const useColorScheme = ()=>$2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $2db2bc563e7e5e69$var$React.useRef(false);
        const upperTheme = (0, $6s7D4.default)();
        const ctx = $2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $2db2bc563e7e5e69$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $2db2bc563e7e5e69$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $2db2bc563e7e5e69$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $2db2bc563e7e5e69$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($2db2bc563e7e5e69$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2db2bc563e7e5e69$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($f5O3L.default, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $2db2bc563e7e5e69$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("f5O3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $afce2778e79e00d1$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $afce2778e79e00d1$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $afce2778e79e00d1$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($afce2778e79e00d1$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});



parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});


parcelRegister("6s7D4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0136601b4ac21f95$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $loZnd = parcelRequire("loZnd");
function $0136601b4ac21f95$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $loZnd.default));
    return theme;
}

});
parcelRegister("loZnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94b725db0b0ec0d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $f94b725db0b0ec0d$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $f94b725db0b0ec0d$export$2e2bcd8739ae039 = $f94b725db0b0ec0d$var$ThemeContext;

});


parcelRegister("jdWO4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dfecd8f934112f3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dfecd8f934112f3d$var$_useEnhancedEffect.default;
    }
});

var $dfecd8f934112f3d$var$_useEnhancedEffect = $dfecd8f934112f3d$require$_interopRequireDefault((parcelRequire("89ISn")));

});
parcelRegister("89ISn", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5f01f96cc9bd1b3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f01f96cc9bd1b3c$var$React = $5f01f96cc9bd1b3c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $5f01f96cc9bd1b3c$var$useEnhancedEffect = typeof window !== 'undefined' ? $5f01f96cc9bd1b3c$var$React.useLayoutEffect : $5f01f96cc9bd1b3c$var$React.useEffect;
var $5f01f96cc9bd1b3c$var$_default = module.exports.default = $5f01f96cc9bd1b3c$var$useEnhancedEffect;

});


parcelRegister("ixP4k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d802ec3fa7ccc11e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d802ec3fa7ccc11e$var$_ThemeProvider.default;
    }
});

var $d802ec3fa7ccc11e$var$_ThemeProvider = $d802ec3fa7ccc11e$require$_interopRequireDefault((parcelRequire("411Qv")));

});
parcelRegister("411Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2ec8aff4a7c0cf18$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2ec8aff4a7c0cf18$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ec8aff4a7c0cf18$var$React = $2ec8aff4a7c0cf18$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2ec8aff4a7c0cf18$var$_propTypes = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $1Q4uX = parcelRequire("1Q4uX");
var $6s7D4 = parcelRequire("6s7D4");

var $2ec8aff4a7c0cf18$var$_exactProp = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("5S3aN")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("f18iq")));

var $2ec8aff4a7c0cf18$var$_RtlProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("9uEev")));

var $2ec8aff4a7c0cf18$var$_DefaultPropsProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("buuO7")));

var $ayMG0 = parcelRequire("ayMG0");
const $2ec8aff4a7c0cf18$var$EMPTY_THEME = {};
function $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2ec8aff4a7c0cf18$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2ec8aff4a7c0cf18$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault.default)($2ec8aff4a7c0cf18$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $6s7D4.default)() || $2ec8aff4a7c0cf18$var$EMPTY_THEME;
    const engineTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1Q4uX.default, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.T.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ec8aff4a7c0cf18$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ec8aff4a7c0cf18$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $2ec8aff4a7c0cf18$var$_default = module.exports.default = $2ec8aff4a7c0cf18$var$ThemeProvider;

});
parcelRegister("1Q4uX", function(module, exports) {

$parcel$export(module.exports, "default", () => $156e2307a6178c64$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $loZnd = parcelRequire("loZnd");

var $6s7D4 = parcelRequire("6s7D4");

var $67RTT = parcelRequire("67RTT");

var $ayMG0 = parcelRequire("ayMG0");
function $156e2307a6178c64$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $156e2307a6178c64$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $6s7D4.default)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $156e2307a6178c64$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $67RTT.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $loZnd.default).Provider, {
        value: theme,
        children: children
    });
}
var $156e2307a6178c64$export$2e2bcd8739ae039 = $156e2307a6178c64$var$ThemeProvider;

});
parcelRegister("67RTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $475d3505e656b5eb$export$2e2bcd8739ae039);
const $475d3505e656b5eb$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $475d3505e656b5eb$export$2e2bcd8739ae039 = $475d3505e656b5eb$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("5S3aN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $446475069c751d22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $446475069c751d22$var$_exactProp.default;
    }
});

var $446475069c751d22$var$_exactProp = $446475069c751d22$require$_interopRequireDefault((parcelRequire("9RGCL")));

});
parcelRegister("9RGCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72ea20960eca48cd$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $72ea20960eca48cd$var$specialProperty = 'exact-prop: \u200b';
function $72ea20960eca48cd$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("f18iq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $aeed627b69a58b85$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aeed627b69a58b85$var$_useThemeWithoutDefault.default;
    }
});

var $aeed627b69a58b85$var$_useThemeWithoutDefault = $aeed627b69a58b85$require$_interopRequireDefault((parcelRequire("7zQRf")));

});
parcelRegister("7zQRf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5844cdc266ab80c7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5844cdc266ab80c7$var$React = $5844cdc266ab80c7$require$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
function $5844cdc266ab80c7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5844cdc266ab80c7$var$useTheme(defaultTheme = null) {
    const contextTheme = $5844cdc266ab80c7$var$React.useContext($eP9YU.T);
    return !contextTheme || $5844cdc266ab80c7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5844cdc266ab80c7$var$_default = module.exports.default = $5844cdc266ab80c7$var$useTheme;

});


parcelRegister("9uEev", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e961fcfc1c15c66$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e961fcfc1c15c66$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $6e961fcfc1c15c66$var$React = $6e961fcfc1c15c66$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e961fcfc1c15c66$var$_propTypes = $6e961fcfc1c15c66$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $6e961fcfc1c15c66$var$RtlContext = /*#__PURE__*/ $6e961fcfc1c15c66$var$React.createContext();
function $6e961fcfc1c15c66$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6e961fcfc1c15c66$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $6e961fcfc1c15c66$var$useRtl = ()=>{
    const value = $6e961fcfc1c15c66$var$React.useContext($6e961fcfc1c15c66$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $6e961fcfc1c15c66$var$useRtl;
var $6e961fcfc1c15c66$var$_default = module.exports.default = $6e961fcfc1c15c66$var$RtlProvider;

});

parcelRegister("buuO7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85da64c4cc661dcb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $85da64c4cc661dcb$var$_DefaultPropsProvider = $85da64c4cc661dcb$require$_interopRequireWildcard((parcelRequire("k3xKF")));

});
parcelRegister("k3xKF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e99e44d394b0848b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e99e44d394b0848b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $e99e44d394b0848b$var$useDefaultProps;

var $e99e44d394b0848b$var$React = $e99e44d394b0848b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e99e44d394b0848b$var$_propTypes = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e99e44d394b0848b$var$_resolveProps = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ayMG0 = parcelRequire("ayMG0");
const $e99e44d394b0848b$var$PropsContext = /*#__PURE__*/ $e99e44d394b0848b$var$React.createContext(undefined);
function $e99e44d394b0848b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e99e44d394b0848b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $e99e44d394b0848b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config, props);
    return props;
}
function $e99e44d394b0848b$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $e99e44d394b0848b$var$React.useContext($e99e44d394b0848b$var$PropsContext);
    return $e99e44d394b0848b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e99e44d394b0848b$var$_default = module.exports.default = $e99e44d394b0848b$var$DefaultPropsProvider;

});
parcelRegister("7T9kw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5be4e83746700573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5be4e83746700573$var$_resolveProps.default;
    }
});

var $5be4e83746700573$var$_resolveProps = $5be4e83746700573$require$_interopRequireDefault((parcelRequire("jgIf5")));

});
parcelRegister("jgIf5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e071d488489a190f$var$resolveProps;
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $e071d488489a190f$var$resolveProps(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $e071d488489a190f$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});






parcelRegister("79OI6", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $5360b5aae8294a93$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $5360b5aae8294a93$var$InitColorSchemeScript;

var $5360b5aae8294a93$var$React = $5360b5aae8294a93$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Split this component for RSC import
 */ const $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $5360b5aae8294a93$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("srPro", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $055833d66b0d6531$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $055833d66b0d6531$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $055833d66b0d6531$var$useCurrentColorScheme;
module.exports.getColorScheme = $055833d66b0d6531$var$getColorScheme;
module.exports.getSystemMode = $055833d66b0d6531$var$getSystemMode;

var $055833d66b0d6531$var$React = $055833d66b0d6531$require$_interopRequireWildcard((parcelRequire("acw62")));

var $79OI6 = parcelRequire("79OI6");

var $055833d66b0d6531$var$_localStorageManager = $055833d66b0d6531$require$_interopRequireDefault((parcelRequire("emFGB")));
function $055833d66b0d6531$var$noop() {}
function $055833d66b0d6531$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $055833d66b0d6531$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $055833d66b0d6531$var$getColorScheme(state) {
    return $055833d66b0d6531$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $055833d66b0d6531$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $79OI6.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $79OI6.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $055833d66b0d6531$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $055833d66b0d6531$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $055833d66b0d6531$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $055833d66b0d6531$var$React.useState(noSsr || !isMultiSchemes);
    $055833d66b0d6531$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $055833d66b0d6531$var$getColorScheme(state);
    const setMode = $055833d66b0d6531$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $055833d66b0d6531$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $055833d66b0d6531$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $055833d66b0d6531$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $055833d66b0d6531$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $055833d66b0d6531$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $055833d66b0d6531$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("emFGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $a75374c871ddabd4$var$noop() {}
const $a75374c871ddabd4$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a75374c871ddabd4$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a75374c871ddabd4$var$_default = module.exports.default = $a75374c871ddabd4$var$localStorageManager;

});



parcelRegister("5magr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e66f819b409e224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e66f819b409e224$var$_deepmerge = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3e66f819b409e224$var$_cssVarsParser = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("ejFX8")));
function $3e66f819b409e224$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3e66f819b409e224$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $3e66f819b409e224$var$_default = module.exports.default = $3e66f819b409e224$var$prepareCssVars;

});
parcelRegister("ejFX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $a6c361fa93759ec5$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a6c361fa93759ec5$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $a6c361fa93759ec5$var$assignNestedKeys;
const $a6c361fa93759ec5$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $a6c361fa93759ec5$var$walkObjectDeep;
const $a6c361fa93759ec5$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $a6c361fa93759ec5$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a6c361fa93759ec5$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $a6c361fa93759ec5$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $a6c361fa93759ec5$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $a6c361fa93759ec5$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("ikjX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d579922b6de2dbd6$var$prepareTypographyVars;
function $d579922b6de2dbd6$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("73CWR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5237068774af7ee7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5237068774af7ee7$var$_prepareCssVars = $5237068774af7ee7$require$_interopRequireDefault((parcelRequire("5magr")));

var $9wccP = parcelRequire("9wccP");

var $79OI6 = parcelRequire("79OI6");
function $5237068774af7ee7$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$79OI6.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $5237068774af7ee7$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $9wccP.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $5237068774af7ee7$var$_default = module.exports.default = $5237068774af7ee7$var$createCssVarsTheme;

});
parcelRegister("9wccP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $6ee0921037829b98$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $6ee0921037829b98$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("1dhnG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0e247cd7faad5b27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_applyStyles.default;
    }
});

var $0e247cd7faad5b27$var$_createTheme = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("i6Yz2")));

var $0e247cd7faad5b27$var$_createBreakpoints = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $0e247cd7faad5b27$var$_applyStyles = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("e1wfH")));

});
parcelRegister("i6Yz2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2f7c454ab1ec68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f7c454ab1ec68c$var$_deepmerge = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $d2f7c454ab1ec68c$var$_createBreakpoints = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d2f7c454ab1ec68c$var$_cssContainerQueries = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d2f7c454ab1ec68c$var$_shape = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d2f7c454ab1ec68c$var$_createSpacing = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d2f7c454ab1ec68c$var$_styleFunctionSx = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("jUGyl")));

var $d2f7c454ab1ec68c$var$_defaultSxConfig = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("epNpO")));

var $d2f7c454ab1ec68c$var$_applyStyles = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("e1wfH")));
function $d2f7c454ab1ec68c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $d2f7c454ab1ec68c$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $d2f7c454ab1ec68c$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $d2f7c454ab1ec68c$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$d2f7c454ab1ec68c$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $d2f7c454ab1ec68c$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $d2f7c454ab1ec68c$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $d2f7c454ab1ec68c$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$d2f7c454ab1ec68c$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $d2f7c454ab1ec68c$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d2f7c454ab1ec68c$var$_default = module.exports.default = $d2f7c454ab1ec68c$var$createTheme;

});
parcelRegister("hVW0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $d0e4c1a921a97ae9$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $d0e4c1a921a97ae9$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $d0e4c1a921a97ae9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $d0e4c1a921a97ae9$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $d0e4c1a921a97ae9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("5H6wp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $425606f5c9c02d28$var$shape = {
    borderRadius: 4
};
var $425606f5c9c02d28$var$_default = module.exports.default = $425606f5c9c02d28$var$shape;

});

parcelRegister("5pAhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0b6db0539d6afd$var$createSpacing;

var $8ZgMs = parcelRequire("8ZgMs");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $3f0b6db0539d6afd$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $8ZgMs.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("e1wfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35a2d48af09cdf6$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a35a2d48af09cdf6$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("b14cZ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80530d69cb5af7b9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80530d69cb5af7b9$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80530d69cb5af7b9$var$_generateUtilityClass.default;
    }
});

var $80530d69cb5af7b9$var$_generateUtilityClass = $80530d69cb5af7b9$require$_interopRequireWildcard((parcelRequire("8nnml")));
Object.keys($80530d69cb5af7b9$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80530d69cb5af7b9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80530d69cb5af7b9$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80530d69cb5af7b9$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("8nnml", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $61929767e33fc474$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61929767e33fc474$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $61929767e33fc474$var$isGlobalState;

var $61929767e33fc474$var$_ClassNameGenerator = $61929767e33fc474$require$_interopRequireDefault((parcelRequire("aYaRV")));
const $61929767e33fc474$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $61929767e33fc474$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $61929767e33fc474$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$61929767e33fc474$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $61929767e33fc474$var$isGlobalState(slot) {
    return $61929767e33fc474$var$globalStateClasses[slot] !== undefined;
}

});
parcelRegister("aYaRV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7fc7f047a82393ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7fc7f047a82393ea$var$_ClassNameGenerator.default;
    }
});

var $7fc7f047a82393ea$var$_ClassNameGenerator = $7fc7f047a82393ea$require$_interopRequireDefault((parcelRequire("jyJSW")));

});
parcelRegister("jyJSW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e3d4c91c63801eeb$var$defaultGenerator = (componentName)=>componentName;
const $e3d4c91c63801eeb$var$createClassNameGenerator = ()=>{
    let generate = $e3d4c91c63801eeb$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e3d4c91c63801eeb$var$defaultGenerator;
        }
    };
};
const $e3d4c91c63801eeb$var$ClassNameGenerator = $e3d4c91c63801eeb$var$createClassNameGenerator();
var $e3d4c91c63801eeb$var$_default = module.exports.default = $e3d4c91c63801eeb$var$ClassNameGenerator;

});




parcelRegister("bbeCr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $823c0fd313341cc1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $823c0fd313341cc1$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $823c0fd313341cc1$var$_createStyled.default;
    }
});

var $823c0fd313341cc1$var$_createStyled = $823c0fd313341cc1$require$_interopRequireWildcard((parcelRequire("b8EC5")));
Object.keys($823c0fd313341cc1$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($823c0fd313341cc1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $823c0fd313341cc1$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $823c0fd313341cc1$var$_createStyled[key];
        }
    });
});

});
parcelRegister("b8EC5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $81bff209823fdfab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $81bff209823fdfab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81bff209823fdfab$var$createStyled;
module.exports.shouldForwardProp = $81bff209823fdfab$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $81bff209823fdfab$var$_styledEngine = $81bff209823fdfab$require$_interopRequireWildcard((parcelRequire("8TaLX")));

var $bQ4jM = parcelRequire("bQ4jM");

var $81bff209823fdfab$var$_capitalize = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4O6za")));

var $81bff209823fdfab$var$_getDisplayName = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("3cLs1")));

var $81bff209823fdfab$var$_createTheme = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $81bff209823fdfab$var$_styleFunctionSx = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("l6FST")));

var $81bff209823fdfab$var$_preprocessStyles = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $81bff209823fdfab$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $81bff209823fdfab$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $81bff209823fdfab$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $81bff209823fdfab$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $81bff209823fdfab$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $81bff209823fdfab$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$81bff209823fdfab$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $81bff209823fdfab$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $81bff209823fdfab$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $81bff209823fdfab$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $81bff209823fdfab$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $81bff209823fdfab$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $81bff209823fdfab$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $81bff209823fdfab$var$defaultOverridesResolver($81bff209823fdfab$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $81bff209823fdfab$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($81bff209823fdfab$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $81bff209823fdfab$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $81bff209823fdfab$var$processStyle(props, style);
            };
            if ((0, $bQ4jM.isPlainObject)(style)) {
                const serialized = (0, $81bff209823fdfab$var$_preprocessStyles.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $81bff209823fdfab$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $81bff209823fdfab$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $81bff209823fdfab$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push($81bff209823fdfab$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $81bff209823fdfab$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $81bff209823fdfab$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $81bff209823fdfab$var$_getDisplayName.default)(tag)})`;
}
function $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $81bff209823fdfab$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $81bff209823fdfab$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $81bff209823fdfab$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("8TaLX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $678bd0f6619332de$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_mutateStyles", () => $678bd0f6619332de$export$592c7226e4cb0171);
$parcel$export(module.exports, "internal_serializeStyles", () => $678bd0f6619332de$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("dueOl")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("f5O3L")).default);
/**
 * @mui/styled-engine v7.1.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $dueOl = parcelRequire("dueOl");

var $f5O3L = parcelRequire("f5O3L");
'use client';
function $678bd0f6619332de$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $678bd0f6619332de$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $678bd0f6619332de$var$wrapper = [];
function $678bd0f6619332de$export$13a2d3ef13012b32(styles) {
    $678bd0f6619332de$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($678bd0f6619332de$var$wrapper);
}

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("dueOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d1990dedcb29083$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $jmRmf = parcelRequire("jmRmf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9d1990dedcb29083$var$cacheMap = new Map();
const $9d1990dedcb29083$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $9d1990dedcb29083$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $a9M6v.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $9d1990dedcb29083$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $9d1990dedcb29083$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$9d1990dedcb29083$var$insertionPoint) {
        $9d1990dedcb29083$var$insertionPoint = document.createElement('meta');
        $9d1990dedcb29083$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $9d1990dedcb29083$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($9d1990dedcb29083$var$insertionPoint);
    }
}
function $9d1990dedcb29083$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $jmRmf.StyleSheet) {
            insert(rule, options) {
                if ($9d1990dedcb29083$export$5a3f4e255fc47e86.insert) return $9d1990dedcb29083$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $9d1990dedcb29083$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $9d1990dedcb29083$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $9d1990dedcb29083$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.startsWith('@layer')) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $9d1990dedcb29083$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $acw62.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if ($9d1990dedcb29083$var$cacheMap.has(cacheKey)) return $9d1990dedcb29083$var$cacheMap.get(cacheKey);
        const fresh = $9d1990dedcb29083$var$getCache(injectFirst, enableCssLayer);
        $9d1990dedcb29083$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.C), {
        value: cache,
        children: children
    }) : children;
}

});


parcelRegister("3cLs1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25574cdde2068c11$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $25574cdde2068c11$var$_getDisplayName.default;
    }
});

var $25574cdde2068c11$var$_getDisplayName = $25574cdde2068c11$require$_interopRequireDefault((parcelRequire("98zty")));

});
parcelRegister("98zty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a706129b6f614d1$var$getDisplayName;

var $4jPKB = parcelRequire("4jPKB");
function $6a706129b6f614d1$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $6a706129b6f614d1$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $6a706129b6f614d1$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $6a706129b6f614d1$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $6a706129b6f614d1$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $4jPKB.ForwardRef:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $4jPKB.Memo:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("4bg7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30b4b2e6e89e9da3$var$preprocessStyles;

var $8TaLX = parcelRequire("8TaLX");
function $30b4b2e6e89e9da3$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $8TaLX.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $8TaLX.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("4jPsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3250d9bb994a2d02$var$_default = module.exports.default = '$$material';

});

parcelRegister("2baoW", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1964ad5a35c9e3e3$var$adaptV4Theme;

var $aGAln = parcelRequire("aGAln");
var $2GcsG = parcelRequire("2GcsG");
function $1964ad5a35c9e3e3$var$adaptV4Theme(inputTheme) {
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $2GcsG.default)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $aGAln.default)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

});
parcelRegister("aGAln", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7a04bfefec7c88$export$2e2bcd8739ae039);
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $7c7a04bfefec7c88$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $7c7a04bfefec7c88$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $7c7a04bfefec7c88$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $7c7a04bfefec7c88$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $7kpn1 = parcelRequire("7kpn1");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $7kpn1.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("7kpn1", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $555e14aafbcd0190$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $555e14aafbcd0190$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $555e14aafbcd0190$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $555e14aafbcd0190$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $555e14aafbcd0190$export$6f98e8eaf0be1996);


var $82aMg = parcelRequire("82aMg");

var $ii7BS = parcelRequire("ii7BS");

var $jIr7d = parcelRequire("jIr7d");

var $hjkc5 = parcelRequire("hjkc5");
const $555e14aafbcd0190$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $555e14aafbcd0190$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $555e14aafbcd0190$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $555e14aafbcd0190$var$getCssProperties = (0, $hjkc5.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($555e14aafbcd0190$var$aliases[prop]) prop = $555e14aafbcd0190$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $555e14aafbcd0190$var$properties[a];
    const direction = $555e14aafbcd0190$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $555e14aafbcd0190$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $555e14aafbcd0190$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $555e14aafbcd0190$var$spacingKeys = [
    ...$555e14aafbcd0190$export$aab52a0dde05ad8a,
    ...$555e14aafbcd0190$export$f8397d44f03ab6ad
];
function $555e14aafbcd0190$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $ii7BS.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $555e14aafbcd0190$export$1def6f833384e3d1(theme) {
    return $555e14aafbcd0190$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $555e14aafbcd0190$var$getCssProperties(prop);
    const styleFromPropValue = $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $82aMg.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $555e14aafbcd0190$var$style(props, keys) {
    const transformer = $555e14aafbcd0190$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $jIr7d.default), {});
}
function $555e14aafbcd0190$export$7ede87f9b603dd3c(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$aab52a0dde05ad8a);
}
$555e14aafbcd0190$export$7ede87f9b603dd3c.propTypes = {};
$555e14aafbcd0190$export$7ede87f9b603dd3c.filterProps = $555e14aafbcd0190$export$aab52a0dde05ad8a;
function $555e14aafbcd0190$export$6f98e8eaf0be1996(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$f8397d44f03ab6ad);
}
$555e14aafbcd0190$export$6f98e8eaf0be1996.propTypes = {};
$555e14aafbcd0190$export$6f98e8eaf0be1996.filterProps = $555e14aafbcd0190$export$f8397d44f03ab6ad;
function $555e14aafbcd0190$var$spacing(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$var$spacingKeys);
}
$555e14aafbcd0190$var$spacing.propTypes = {};
$555e14aafbcd0190$var$spacing.filterProps = $555e14aafbcd0190$var$spacingKeys;
var $555e14aafbcd0190$export$2e2bcd8739ae039 = $555e14aafbcd0190$var$spacing;

});
parcelRegister("82aMg", function(module, exports) {

$parcel$export(module.exports, "values", () => $5d96decff5ccffcb$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $5d96decff5ccffcb$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $5d96decff5ccffcb$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $5d96decff5ccffcb$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $5d96decff5ccffcb$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $5d96decff5ccffcb$export$980e6a259d807490);


var $bQ4jM = parcelRequire("bQ4jM");

var $jIr7d = parcelRequire("jIr7d");

var $cvKfd = parcelRequire("cvKfd");
const $5d96decff5ccffcb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $5d96decff5ccffcb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$5d96decff5ccffcb$export$68c286be0e7e55b7[key]}px)`
};
const $5d96decff5ccffcb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $5d96decff5ccffcb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $5d96decff5ccffcb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $cvKfd.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $cvKfd.getContainerQuery)(theme.containerQueries ? theme : $5d96decff5ccffcb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $5d96decff5ccffcb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $5d96decff5ccffcb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $jIr7d.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $5d96decff5ccffcb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $5d96decff5ccffcb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(prev, next), {});
    return $5d96decff5ccffcb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $5d96decff5ccffcb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $5d96decff5ccffcb$export$2e2bcd8739ae039 = $5d96decff5ccffcb$var$breakpoints;

});
parcelRegister("jIr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a728ecb1a1c3c0$export$2e2bcd8739ae039);

var $bQ4jM = parcelRequire("bQ4jM");
function $e5a728ecb1a1c3c0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e5a728ecb1a1c3c0$export$2e2bcd8739ae039 = $e5a728ecb1a1c3c0$var$merge;

});

parcelRegister("cvKfd", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", () => $91bc4077911678f2$export$456f6c1142f990db);
$parcel$export(module.exports, "isCqShorthand", () => $91bc4077911678f2$export$77c7c3e357f440e7);
$parcel$export(module.exports, "getContainerQuery", () => $91bc4077911678f2$export$10a9745dfa00d15);
$parcel$export(module.exports, "default", () => $91bc4077911678f2$export$2e2bcd8739ae039);

function $91bc4077911678f2$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $91bc4077911678f2$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $91bc4077911678f2$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $91bc4077911678f2$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("ii7BS", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $d50fcf9a3ec00b94$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $d50fcf9a3ec00b94$export$2e2bcd8739ae039);

var $4O6za = parcelRequire("4O6za");


var $82aMg = parcelRequire("82aMg");
function $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $d50fcf9a3ec00b94$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($4O6za)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d50fcf9a3ec00b94$export$2e2bcd8739ae039 = $d50fcf9a3ec00b94$var$style;

});

parcelRegister("hjkc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9a3e017c1fe4096$export$2e2bcd8739ae039);
function $c9a3e017c1fe4096$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("ijOKP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d5615f18e5cd04fc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5615f18e5cd04fc$var$createTheme;

var $d5615f18e5cd04fc$var$_createPalette = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $d5615f18e5cd04fc$var$_createThemeWithVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $d5615f18e5cd04fc$var$_createThemeNoVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("8v3fy")));
// eslint-disable-next-line consistent-return
function $d5615f18e5cd04fc$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $d5615f18e5cd04fc$var$_createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $d5615f18e5cd04fc$var$createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $d5615f18e5cd04fc$var$_createThemeWithVars.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("4Gk6P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $368aaef25f6a2997$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dark = void 0;
module.exports.default = $368aaef25f6a2997$var$createPalette;
module.exports.light = void 0;

var $368aaef25f6a2997$var$_formatMuiErrorMessage = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $368aaef25f6a2997$var$_deepmerge = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $h61zw = parcelRequire("h61zw");

var $368aaef25f6a2997$var$_common = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dzxhF")));

var $368aaef25f6a2997$var$_grey = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("eU5ou")));

var $368aaef25f6a2997$var$_purple = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("kSXRh")));

var $368aaef25f6a2997$var$_red = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("ln9F4")));

var $368aaef25f6a2997$var$_orange = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dMYym")));

var $368aaef25f6a2997$var$_blue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bKnBV")));

var $368aaef25f6a2997$var$_lightBlue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("iDVue")));

var $368aaef25f6a2997$var$_green = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("e4nxq")));
function $368aaef25f6a2997$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: $368aaef25f6a2997$var$_common.default.white,
            default: $368aaef25f6a2997$var$_common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $368aaef25f6a2997$var$light = module.exports.light = $368aaef25f6a2997$var$getLight();
function $368aaef25f6a2997$var$getDark() {
    return {
        text: {
            primary: $368aaef25f6a2997$var$_common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: $368aaef25f6a2997$var$_common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $368aaef25f6a2997$var$dark = module.exports.dark = $368aaef25f6a2997$var$getDark();
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $h61zw.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $h61zw.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_blue.default[200],
        light: $368aaef25f6a2997$var$_blue.default[50],
        dark: $368aaef25f6a2997$var$_blue.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_blue.default[700],
        light: $368aaef25f6a2997$var$_blue.default[400],
        dark: $368aaef25f6a2997$var$_blue.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_purple.default[200],
        light: $368aaef25f6a2997$var$_purple.default[50],
        dark: $368aaef25f6a2997$var$_purple.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_purple.default[500],
        light: $368aaef25f6a2997$var$_purple.default[300],
        dark: $368aaef25f6a2997$var$_purple.default[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_red.default[500],
        light: $368aaef25f6a2997$var$_red.default[300],
        dark: $368aaef25f6a2997$var$_red.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_red.default[700],
        light: $368aaef25f6a2997$var$_red.default[400],
        dark: $368aaef25f6a2997$var$_red.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_lightBlue.default[400],
        light: $368aaef25f6a2997$var$_lightBlue.default[300],
        dark: $368aaef25f6a2997$var$_lightBlue.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_lightBlue.default[700],
        light: $368aaef25f6a2997$var$_lightBlue.default[500],
        dark: $368aaef25f6a2997$var$_lightBlue.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_green.default[400],
        light: $368aaef25f6a2997$var$_green.default[300],
        dark: $368aaef25f6a2997$var$_green.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_green.default[800],
        light: $368aaef25f6a2997$var$_green.default[500],
        dark: $368aaef25f6a2997$var$_green.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_orange.default[400],
        light: $368aaef25f6a2997$var$_orange.default[300],
        dark: $368aaef25f6a2997$var$_orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: $368aaef25f6a2997$var$_orange.default[500],
        dark: $368aaef25f6a2997$var$_orange.default[900]
    };
}
function $368aaef25f6a2997$var$createPalette(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $h61zw.getContrastRatio)(background, $368aaef25f6a2997$var$dark.text.primary) >= contrastThreshold ? $368aaef25f6a2997$var$dark.text.primary : $368aaef25f6a2997$var$light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $368aaef25f6a2997$var$_formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $368aaef25f6a2997$var$_formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $368aaef25f6a2997$var$getLight();
    else if (mode === 'dark') modeHydrated = $368aaef25f6a2997$var$getDark();
    const paletteOutput = (0, $368aaef25f6a2997$var$_deepmerge.default)({
        // A collection of common colors.
        common: {
            ...$368aaef25f6a2997$var$_common.default
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: $368aaef25f6a2997$var$_grey.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("h61zw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i0NBZ = parcelRequire("i0NBZ");
Object.keys($i0NBZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i0NBZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i0NBZ[key];
        }
    });
});

});
parcelRegister("i0NBZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1ceb5f718f3f33e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $d1ceb5f718f3f33e$var$alpha;
module.exports.blend = $d1ceb5f718f3f33e$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $d1ceb5f718f3f33e$var$darken;
module.exports.decomposeColor = $d1ceb5f718f3f33e$var$decomposeColor;
module.exports.emphasize = $d1ceb5f718f3f33e$var$emphasize;
module.exports.getContrastRatio = $d1ceb5f718f3f33e$var$getContrastRatio;
module.exports.getLuminance = $d1ceb5f718f3f33e$var$getLuminance;
module.exports.hexToRgb = $d1ceb5f718f3f33e$var$hexToRgb;
module.exports.hslToRgb = $d1ceb5f718f3f33e$var$hslToRgb;
module.exports.lighten = $d1ceb5f718f3f33e$var$lighten;
module.exports.private_safeAlpha = $d1ceb5f718f3f33e$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $d1ceb5f718f3f33e$var$private_safeDarken;
module.exports.private_safeEmphasize = $d1ceb5f718f3f33e$var$private_safeEmphasize;
module.exports.private_safeLighten = $d1ceb5f718f3f33e$var$private_safeLighten;
module.exports.recomposeColor = $d1ceb5f718f3f33e$var$recomposeColor;
module.exports.rgbToHex = $d1ceb5f718f3f33e$var$rgbToHex;

var $d1ceb5f718f3f33e$var$_formatMuiErrorMessage = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $d1ceb5f718f3f33e$var$_clamp = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("3zA0b")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d1ceb5f718f3f33e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $d1ceb5f718f3f33e$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $d1ceb5f718f3f33e$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d1ceb5f718f3f33e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $d1ceb5f718f3f33e$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $d1ceb5f718f3f33e$var$colorChannel = (color)=>{
    const decomposedColor = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $d1ceb5f718f3f33e$var$colorChannel;
const $d1ceb5f718f3f33e$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $d1ceb5f718f3f33e$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $d1ceb5f718f3f33e$var$private_safeColorChannel;
function $d1ceb5f718f3f33e$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $d1ceb5f718f3f33e$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return `#${values.map((n, i)=>$d1ceb5f718f3f33e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $d1ceb5f718f3f33e$var$hslToRgb(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $d1ceb5f718f3f33e$var$getLuminance(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $d1ceb5f718f3f33e$var$getContrastRatio(foreground, background) {
    const lumA = $d1ceb5f718f3f33e$var$getLuminance(foreground);
    const lumB = $d1ceb5f718f3f33e$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$alpha(color, value) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    value = $d1ceb5f718f3f33e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeAlpha(color, value, warning) {
    try {
        return $d1ceb5f718f3f33e$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$darken(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$lighten(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$emphasize(color, coefficient = 0.15) {
    return $d1ceb5f718f3f33e$var$getLuminance(color) > 0.5 ? $d1ceb5f718f3f33e$var$darken(color, coefficient) : $d1ceb5f718f3f33e$var$lighten(color, coefficient);
}
function $d1ceb5f718f3f33e$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $d1ceb5f718f3f33e$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d1ceb5f718f3f33e$var$decomposeColor(background);
    const overlayColor = $d1ceb5f718f3f33e$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});


parcelRegister("dzxhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$var$_default = module.exports.default = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$var$_default = module.exports.default = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$var$_default = module.exports.default = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$var$_default = module.exports.default = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$var$_default = module.exports.default = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$var$_default = module.exports.default = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$var$_default = module.exports.default = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$var$_default = module.exports.default = $a3e3b29cd31a116f$var$green;

});


parcelRegister("eLI0w", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ac07976fc01fdfa9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ac07976fc01fdfa9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetCssVar = void 0;
module.exports.default = $ac07976fc01fdfa9$var$createThemeWithVars;

var $ac07976fc01fdfa9$var$_formatMuiErrorMessage = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $ac07976fc01fdfa9$var$_deepmerge = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $2GcsG = parcelRequire("2GcsG");
var $fOmBr = parcelRequire("fOmBr");

var $8ZgMs = parcelRequire("8ZgMs");

var $fckAO = parcelRequire("fckAO");

var $ac07976fc01fdfa9$var$_styleFunctionSx = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $h61zw = parcelRequire("h61zw");

var $ac07976fc01fdfa9$var$_createThemeNoVars = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("8v3fy")));

var $ac07976fc01fdfa9$var$_createColorScheme = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("2JzIB")));

var $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $ac07976fc01fdfa9$var$_createGetSelector = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("9yYvT")));

var $2ICMq = parcelRequire("2ICMq");
function $ac07976fc01fdfa9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ac07976fc01fdfa9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ac07976fc01fdfa9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $h61zw.hslToRgb)(color);
}
function $ac07976fc01fdfa9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ac07976fc01fdfa9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ac07976fc01fdfa9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ac07976fc01fdfa9$var$createGetCssVar = (cssVarPrefix = 'mui')=>(0, $fOmBr.default)(cssVarPrefix);
module.exports.createGetCssVar = $ac07976fc01fdfa9$var$createGetCssVar;
function $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $ac07976fc01fdfa9$var$_createColorScheme.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ac07976fc01fdfa9$var$_createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $ac07976fc01fdfa9$var$_createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $ac07976fc01fdfa9$var$_createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function $ac07976fc01fdfa9$var$createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ac07976fc01fdfa9$var$createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $ac07976fc01fdfa9$var$_formatMuiErrorMessage.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $fckAO.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ac07976fc01fdfa9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#fff');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#000');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $ac07976fc01fdfa9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', (0, $h61zw.private_safeDarken)(palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', (0, $h61zw.private_safeDarken)(palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', (0, $h61zw.private_safeDarken)(palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', (0, $h61zw.private_safeDarken)(palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', (0, $h61zw.private_safeLighten)(palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', (0, $h61zw.private_safeLighten)(palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', (0, $h61zw.private_safeLighten)(palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', (0, $h61zw.private_safeLighten)(palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $h61zw.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $h61zw.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', (0, $h61zw.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', (0, $h61zw.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', (0, $h61zw.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', (0, $h61zw.private_safeLighten)(palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', (0, $h61zw.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', (0, $h61zw.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', (0, $h61zw.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', (0, $h61zw.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', (0, $h61zw.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', (0, $h61zw.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.8);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $h61zw.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $h61zw.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $h61zw.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $h61zw.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', (0, $h61zw.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $h61zw.private_safeLighten)(palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', (0, $h61zw.private_safeLighten)((0, $h61zw.private_safeAlpha)(palette.divider, 1), 0.88));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', (0, $h61zw.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', (0, $h61zw.private_safeLighten)(palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', (0, $h61zw.private_safeLighten)(palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', (0, $h61zw.private_safeLighten)(palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', (0, $h61zw.private_safeLighten)(palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', (0, $h61zw.private_safeDarken)(palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', (0, $h61zw.private_safeDarken)(palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', (0, $h61zw.private_safeDarken)(palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', (0, $h61zw.private_safeDarken)(palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $h61zw.private_safeDarken)(palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $h61zw.private_safeDarken)(palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', (0, $h61zw.private_safeDarken)(palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', (0, $h61zw.private_safeDarken)(palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', (0, $h61zw.private_safeDarken)(palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', (0, $h61zw.private_safeDarken)(palette.warning.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', (0, $h61zw.private_safeDarken)(palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', (0, $h61zw.private_safeDarken)(palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', (0, $h61zw.private_safeDarken)(palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', (0, $h61zw.private_safeDarken)(palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', (0, $h61zw.private_safeDarken)(palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', (0, $h61zw.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.98);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $h61zw.private_safeDarken)(palette.primary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $h61zw.private_safeDarken)(palette.secondary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $h61zw.private_safeDarken)(palette.error.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $h61zw.private_safeDarken)(palette.info.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', (0, $h61zw.private_safeDarken)(palette.success.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $h61zw.private_safeDarken)(palette.warning.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', (0, $h61zw.private_safeDarken)((0, $h61zw.private_safeAlpha)(palette.divider, 1), 0.68));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', (0, $h61zw.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'paper');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'background');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'onBackground');
        $ac07976fc01fdfa9$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ac07976fc01fdfa9$var$setColor(palette[color], 'mainChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.main)));
                if (colors.light) $ac07976fc01fdfa9$var$setColor(palette[color], 'lightChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.light)));
                if (colors.dark) $ac07976fc01fdfa9$var$setColor(palette[color], 'darkChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.dark)));
                if (colors.contrastText) $ac07976fc01fdfa9$var$setColor(palette[color], 'contrastTextChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'primary');
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $ac07976fc01fdfa9$var$_deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $ac07976fc01fdfa9$var$_createGetSelector.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $fckAO.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $2GcsG.default)(input.spacing, (0, $8ZgMs.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $fckAO.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...$ac07976fc01fdfa9$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $ac07976fc01fdfa9$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fOmBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b82d0f0117f79ef3$export$2e2bcd8739ae039);
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $b82d0f0117f79ef3$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("fckAO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b107f34b17d36dd1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $9wccP.createGetColorSchemeSelector;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareTypographyVars.default;
    }
});

var $b107f34b17d36dd1$var$_createCssVarsProvider = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $b107f34b17d36dd1$var$_prepareCssVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("5magr")));

var $b107f34b17d36dd1$var$_prepareTypographyVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("ikjX2")));

var $b107f34b17d36dd1$var$_createCssVarsTheme = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("73CWR")));

var $9wccP = parcelRequire("9wccP");

});

parcelRegister("8v3fy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6303bd594dbbe1c5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6303bd594dbbe1c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6303bd594dbbe1c5$var$_formatMuiErrorMessage = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $6303bd594dbbe1c5$var$_deepmerge = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $6303bd594dbbe1c5$var$_styleFunctionSx = $6303bd594dbbe1c5$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $6303bd594dbbe1c5$var$_createTheme = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $6303bd594dbbe1c5$var$_generateUtilityClass = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $6303bd594dbbe1c5$var$_createMixins = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("6plKN")));

var $6303bd594dbbe1c5$var$_createPalette = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $6303bd594dbbe1c5$var$_createTypography = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $6303bd594dbbe1c5$var$_shadows = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("jtCFx")));

var $6303bd594dbbe1c5$var$_createTransitions = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bmoVh")));

var $6303bd594dbbe1c5$var$_zIndex = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("lhXgK")));

var $2ICMq = parcelRequire("2ICMq");
function $6303bd594dbbe1c5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $6303bd594dbbe1c5$var$_formatMuiErrorMessage.default)(20));
    const palette = (0, $6303bd594dbbe1c5$var$_createPalette.default)(paletteInput);
    const systemTheme = (0, $6303bd594dbbe1c5$var$_createTheme.default)(options);
    let muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(systemTheme, {
        mixins: (0, $6303bd594dbbe1c5$var$_createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: $6303bd594dbbe1c5$var$_shadows.default.slice(),
        typography: (0, $6303bd594dbbe1c5$var$_createTypography.default)(palette, typographyInput),
        transitions: (0, $6303bd594dbbe1c5$var$_createTransitions.default)(transitionsInput),
        zIndex: {
            ...$6303bd594dbbe1c5$var$_zIndex.default
        }
    });
    muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $6303bd594dbbe1c5$var$_deepmerge.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...$6303bd594dbbe1c5$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6303bd594dbbe1c5$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    return muiTheme;
}
var $6303bd594dbbe1c5$var$_default = module.exports.default = $6303bd594dbbe1c5$var$createThemeNoVars;

});
parcelRegister("6plKN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4aa5f3b4975f3e4c$var$createMixins;
function $4aa5f3b4975f3e4c$var$createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("d6q8u", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $98a01bf22de9dc59$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98a01bf22de9dc59$var$createTypography;

var $98a01bf22de9dc59$var$_deepmerge = $98a01bf22de9dc59$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function $98a01bf22de9dc59$var$createTypography(palette, typography) {
    const { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
                letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $98a01bf22de9dc59$var$_deepmerge.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$var$_default = module.exports.default = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $845514f3678d3888$var$createTransitions;
module.exports.easing = module.exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $845514f3678d3888$var$easing = module.exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const $845514f3678d3888$var$duration = module.exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $845514f3678d3888$var$createTransitions(inputTransitions) {
    const mergedEasing = {
        ...$845514f3678d3888$var$easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$845514f3678d3888$var$duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("lhXgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$var$_default = module.exports.default = $f7f9291b6f07cefb$var$zIndex;

});

parcelRegister("2ICMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTheme = $1fadc5be6a14f8c8$var$stringifyTheme;

var $bQ4jM = parcelRequire("bQ4jM");
/* eslint-disable import/prefer-default-export */ function $1fadc5be6a14f8c8$var$isSerializable(val) {
    return (0, $bQ4jM.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function $1fadc5be6a14f8c8$var$stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$1fadc5be6a14f8c8$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $bQ4jM.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("2JzIB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fdb7dab8864519b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fdb7dab8864519b$var$createColorScheme;
module.exports.getOpacity = $1fdb7dab8864519b$var$getOpacity;
module.exports.getOverlays = $1fdb7dab8864519b$var$getOverlays;

var $1fdb7dab8864519b$var$_createPalette = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $1fdb7dab8864519b$var$_getOverlayAlpha = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("35vyj")));
const $1fdb7dab8864519b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $1fdb7dab8864519b$var$_getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $1fdb7dab8864519b$var$getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $1fdb7dab8864519b$var$getOverlays(mode) {
    return mode === 'dark' ? $1fdb7dab8864519b$var$defaultDarkOverlays : [];
}
function $1fdb7dab8864519b$var$createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $1fdb7dab8864519b$var$_createPalette.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$1fdb7dab8864519b$var$getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || $1fdb7dab8864519b$var$getOverlays(palette.mode),
        ...rest
    };
}

});
parcelRegister("35vyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23fa506264c010ed$var$getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $23fa506264c010ed$var$getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("fPRn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b87504e8f71bd950$var$shouldSkipGeneratingVar;
function $b87504e8f71bd950$var$shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9yYvT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6f663abbabfb57a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f663abbabfb57a0$var$_excludeVariablesFromRoot = $6f663abbabfb57a0$require$_interopRequireDefault((parcelRequire("kKEhy")));
var $6f663abbabfb57a0$var$_default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $6f663abbabfb57a0$var$_excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
module.exports.default = $6f663abbabfb57a0$var$_default;

});
parcelRegister("kKEhy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$var$_default = module.exports.default = $f1b759b2363a287f$var$excludeVariablesFromRoot;

});




parcelRegister("5fr1m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d23504439aa8524$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d23504439aa8524$var$createMuiStrictModeTheme;

var $3d23504439aa8524$var$_deepmerge = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3d23504439aa8524$var$_createTheme = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("ijOKP")));
function $3d23504439aa8524$var$createMuiStrictModeTheme(options, ...args) {
    return (0, $3d23504439aa8524$var$_createTheme.default)((0, $3d23504439aa8524$var$_deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

});

parcelRegister("22wy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17c504046cb9a64c$var$createStyles;
let $17c504046cb9a64c$var$warnedOnce = false;
// To remove in v6
function $17c504046cb9a64c$var$createStyles(styles) {
    if (!$17c504046cb9a64c$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $17c504046cb9a64c$var$warnedOnce = true;
    }
    return styles;
}

});

parcelRegister("eoBMT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a7b09e624fa460c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7b09e624fa460c3$var$responsiveFontSizes;

var $a7b09e624fa460c3$var$_formatMuiErrorMessage = $a7b09e624fa460c3$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $18jQK = parcelRequire("18jQK");
function $a7b09e624fa460c3$var$responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $18jQK.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $18jQK.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $a7b09e624fa460c3$var$_formatMuiErrorMessage.default)(6));
        if (!(0, $18jQK.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $18jQK.alignProperty)({
                size: value,
                grid: (0, $18jQK.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, $18jQK.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform: transform
            })
        };
    });
    return theme;
}

});
parcelRegister("18jQK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignProperty = $0d35ef8a52a98e99$var$alignProperty;
module.exports.convertLength = $0d35ef8a52a98e99$var$convertLength;
module.exports.fontGrid = $0d35ef8a52a98e99$var$fontGrid;
module.exports.getUnit = $0d35ef8a52a98e99$var$getUnit;
module.exports.isUnitless = $0d35ef8a52a98e99$var$isUnitless;
module.exports.responsiveProperty = $0d35ef8a52a98e99$var$responsiveProperty;
module.exports.toUnitless = $0d35ef8a52a98e99$var$toUnitless;
function $0d35ef8a52a98e99$var$isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function $0d35ef8a52a98e99$var$getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function $0d35ef8a52a98e99$var$toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function $0d35ef8a52a98e99$var$convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$var$getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$var$toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$var$alignProperty({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function $0d35ef8a52a98e99$var$fontGrid({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function $0d35ef8a52a98e99$var$responsiveProperty({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});


parcelRegister("14H9o", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0c87a2f38cd49c7a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0c87a2f38cd49c7a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c87a2f38cd49c7a$var$useTheme;

var $0c87a2f38cd49c7a$var$React = $0c87a2f38cd49c7a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $eM1DJ = parcelRequire("eM1DJ");

var $0c87a2f38cd49c7a$var$_defaultTheme = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0c87a2f38cd49c7a$var$_identifier = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $0c87a2f38cd49c7a$var$useTheme() {
    const theme = (0, $eM1DJ.default)($0c87a2f38cd49c7a$var$_defaultTheme.default);
    return theme[$0c87a2f38cd49c7a$var$_identifier.default] || theme;
}

});
parcelRegister("eM1DJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac16d208682bdb3f$export$2e2bcd8739ae039);

var $6o2lr = parcelRequire("6o2lr");

var $g6Om4 = parcelRequire("g6Om4");
'use client';
const $ac16d208682bdb3f$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $ac16d208682bdb3f$var$useTheme(defaultTheme = $ac16d208682bdb3f$export$35e57303dbd8a66) {
    return (0, $g6Om4.default)(defaultTheme);
}
var $ac16d208682bdb3f$export$2e2bcd8739ae039 = $ac16d208682bdb3f$var$useTheme;

});
parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $bQ4jM = parcelRequire("bQ4jM");

var $aGAln = parcelRequire("aGAln");

var $cvKfd = parcelRequire("cvKfd");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $aGAln.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $bVuw0.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $cvKfd.default)(muiTheme);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $4O6za = parcelRequire("4O6za");

var $jIr7d = parcelRequire("jIr7d");

var $ii7BS = parcelRequire("ii7BS");

var $82aMg = parcelRequire("82aMg");

var $cvKfd = parcelRequire("cvKfd");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $ii7BS.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ii7BS.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $ii7BS.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($4O6za)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $82aMg.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $jIr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $82aMg.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $jIr7d.default)(css, breakpointsValues);
                        }
                    } else css = (0, $jIr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $cvKfd.sortContainerQueries)(theme, (0, $82aMg.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $7kpn1 = parcelRequire("7kpn1");

var $gIpS2 = parcelRequire("gIpS2");

var $f70is = parcelRequire("f70is");

var $f9Ko1 = parcelRequire("f9Ko1");

var $8j2JW = parcelRequire("8j2JW");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $gIpS2.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $f9Ko1.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $f9Ko1.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $f9Ko1.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $7kpn1.padding)
    },
    pt: {
        style: (0, $7kpn1.padding)
    },
    pr: {
        style: (0, $7kpn1.padding)
    },
    pb: {
        style: (0, $7kpn1.padding)
    },
    pl: {
        style: (0, $7kpn1.padding)
    },
    px: {
        style: (0, $7kpn1.padding)
    },
    py: {
        style: (0, $7kpn1.padding)
    },
    padding: {
        style: (0, $7kpn1.padding)
    },
    paddingTop: {
        style: (0, $7kpn1.padding)
    },
    paddingRight: {
        style: (0, $7kpn1.padding)
    },
    paddingBottom: {
        style: (0, $7kpn1.padding)
    },
    paddingLeft: {
        style: (0, $7kpn1.padding)
    },
    paddingX: {
        style: (0, $7kpn1.padding)
    },
    paddingY: {
        style: (0, $7kpn1.padding)
    },
    paddingInline: {
        style: (0, $7kpn1.padding)
    },
    paddingInlineStart: {
        style: (0, $7kpn1.padding)
    },
    paddingInlineEnd: {
        style: (0, $7kpn1.padding)
    },
    paddingBlock: {
        style: (0, $7kpn1.padding)
    },
    paddingBlockStart: {
        style: (0, $7kpn1.padding)
    },
    paddingBlockEnd: {
        style: (0, $7kpn1.padding)
    },
    m: {
        style: (0, $7kpn1.margin)
    },
    mt: {
        style: (0, $7kpn1.margin)
    },
    mr: {
        style: (0, $7kpn1.margin)
    },
    mb: {
        style: (0, $7kpn1.margin)
    },
    ml: {
        style: (0, $7kpn1.margin)
    },
    mx: {
        style: (0, $7kpn1.margin)
    },
    my: {
        style: (0, $7kpn1.margin)
    },
    margin: {
        style: (0, $7kpn1.margin)
    },
    marginTop: {
        style: (0, $7kpn1.margin)
    },
    marginRight: {
        style: (0, $7kpn1.margin)
    },
    marginBottom: {
        style: (0, $7kpn1.margin)
    },
    marginLeft: {
        style: (0, $7kpn1.margin)
    },
    marginX: {
        style: (0, $7kpn1.margin)
    },
    marginY: {
        style: (0, $7kpn1.margin)
    },
    marginInline: {
        style: (0, $7kpn1.margin)
    },
    marginInlineStart: {
        style: (0, $7kpn1.margin)
    },
    marginInlineEnd: {
        style: (0, $7kpn1.margin)
    },
    marginBlock: {
        style: (0, $7kpn1.margin)
    },
    marginBlockStart: {
        style: (0, $7kpn1.margin)
    },
    marginBlockEnd: {
        style: (0, $7kpn1.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $f70is.gap)
    },
    rowGap: {
        style: (0, $f70is.rowGap)
    },
    columnGap: {
        style: (0, $f70is.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8j2JW.sizingTransform)
    },
    maxWidth: {
        style: (0, $8j2JW.maxWidth)
    },
    minWidth: {
        transform: (0, $8j2JW.sizingTransform)
    },
    height: {
        transform: (0, $8j2JW.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8j2JW.sizingTransform)
    },
    minHeight: {
        transform: (0, $8j2JW.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("gIpS2", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $c2b4d2c425fe2f29$export$7a57f79000377ca2);


var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $7kpn1 = parcelRequire("7kpn1");

var $82aMg = parcelRequire("82aMg");
function $c2b4d2c425fe2f29$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c2b4d2c425fe2f29$var$createBorderStyle(prop, transform) {
    return (0, $ii7BS.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c2b4d2c425fe2f29$export$1edee58a52776cd9 = $c2b4d2c425fe2f29$var$createBorderStyle('border', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$f9a7b6bd24892946 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTop', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$5abca33e6be905d2 = $c2b4d2c425fe2f29$var$createBorderStyle('borderRight', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e2ce9f12a980a822 = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottom', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$47658cca1a909427 = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeft', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e7fb0694ba2404fc = $c2b4d2c425fe2f29$var$createBorderStyle('borderColor');
const $c2b4d2c425fe2f29$export$126a92c968acdb85 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTopColor');
const $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e = $c2b4d2c425fe2f29$var$createBorderStyle('borderRightColor');
const $c2b4d2c425fe2f29$export$340b0327727f6d1a = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottomColor');
const $c2b4d2c425fe2f29$export$60beef91a985b4bf = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeftColor');
const $c2b4d2c425fe2f29$export$f9258c55612cbed7 = $c2b4d2c425fe2f29$var$createBorderStyle('outline', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$621fe586efeb64b9 = $c2b4d2c425fe2f29$var$createBorderStyle('outlineColor');
const $c2b4d2c425fe2f29$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.propTypes = {};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c2b4d2c425fe2f29$var$borders = (0, $hIpso.default)($c2b4d2c425fe2f29$export$1edee58a52776cd9, $c2b4d2c425fe2f29$export$f9a7b6bd24892946, $c2b4d2c425fe2f29$export$5abca33e6be905d2, $c2b4d2c425fe2f29$export$e2ce9f12a980a822, $c2b4d2c425fe2f29$export$47658cca1a909427, $c2b4d2c425fe2f29$export$e7fb0694ba2404fc, $c2b4d2c425fe2f29$export$126a92c968acdb85, $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e, $c2b4d2c425fe2f29$export$340b0327727f6d1a, $c2b4d2c425fe2f29$export$60beef91a985b4bf, $c2b4d2c425fe2f29$export$7a57f79000377ca2, $c2b4d2c425fe2f29$export$f9258c55612cbed7, $c2b4d2c425fe2f29$export$621fe586efeb64b9);
var $c2b4d2c425fe2f29$export$2e2bcd8739ae039 = $c2b4d2c425fe2f29$var$borders;

});
parcelRegister("hIpso", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a4af256600fcc$export$2e2bcd8739ae039);

var $jIr7d = parcelRequire("jIr7d");
function $ce5a4af256600fcc$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $jIr7d.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $ce5a4af256600fcc$export$2e2bcd8739ae039 = $ce5a4af256600fcc$var$compose;

});


parcelRegister("f70is", function(module, exports) {

$parcel$export(module.exports, "gap", () => $b007bd6739310ca0$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $b007bd6739310ca0$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $b007bd6739310ca0$export$8a833ffa5f5dbeda);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $7kpn1 = parcelRequire("7kpn1");

var $82aMg = parcelRequire("82aMg");

const $b007bd6739310ca0$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$5df9adcb0db95e1e.propTypes = {};
$b007bd6739310ca0$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $b007bd6739310ca0$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$ec60d70ff941a580.propTypes = {};
$b007bd6739310ca0$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $b007bd6739310ca0$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.propTypes = {};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $b007bd6739310ca0$export$baf44164ca3a34e8 = (0, $ii7BS.default)({
    prop: 'gridColumn'
});
const $b007bd6739310ca0$export$8f7213a1cd01e832 = (0, $ii7BS.default)({
    prop: 'gridRow'
});
const $b007bd6739310ca0$export$b0e0abbc49ba668 = (0, $ii7BS.default)({
    prop: 'gridAutoFlow'
});
const $b007bd6739310ca0$export$bcd8b929d4b4142 = (0, $ii7BS.default)({
    prop: 'gridAutoColumns'
});
const $b007bd6739310ca0$export$e5039a674e14c828 = (0, $ii7BS.default)({
    prop: 'gridAutoRows'
});
const $b007bd6739310ca0$export$42bd9088661ffb03 = (0, $ii7BS.default)({
    prop: 'gridTemplateColumns'
});
const $b007bd6739310ca0$export$920682ae05b999bc = (0, $ii7BS.default)({
    prop: 'gridTemplateRows'
});
const $b007bd6739310ca0$export$1b88fbdd482fd33a = (0, $ii7BS.default)({
    prop: 'gridTemplateAreas'
});
const $b007bd6739310ca0$export$bdb486e40d52d26f = (0, $ii7BS.default)({
    prop: 'gridArea'
});
const $b007bd6739310ca0$var$grid = (0, $hIpso.default)($b007bd6739310ca0$export$5df9adcb0db95e1e, $b007bd6739310ca0$export$ec60d70ff941a580, $b007bd6739310ca0$export$8a833ffa5f5dbeda, $b007bd6739310ca0$export$baf44164ca3a34e8, $b007bd6739310ca0$export$8f7213a1cd01e832, $b007bd6739310ca0$export$b0e0abbc49ba668, $b007bd6739310ca0$export$bcd8b929d4b4142, $b007bd6739310ca0$export$e5039a674e14c828, $b007bd6739310ca0$export$42bd9088661ffb03, $b007bd6739310ca0$export$920682ae05b999bc, $b007bd6739310ca0$export$1b88fbdd482fd33a, $b007bd6739310ca0$export$bdb486e40d52d26f);
var $b007bd6739310ca0$export$2e2bcd8739ae039 = $b007bd6739310ca0$var$grid;

});

parcelRegister("f9Ko1", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $b08badac1d124df3$export$dbaffd4420ea0ac6);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");
function $b08badac1d124df3$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b08badac1d124df3$export$35e9368ef982300f = (0, $ii7BS.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$2506f56c10355b33 = (0, $ii7BS.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$8c5a050822fd698c = (0, $ii7BS.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$var$palette = (0, $hIpso.default)($b08badac1d124df3$export$35e9368ef982300f, $b08badac1d124df3$export$2506f56c10355b33, $b08badac1d124df3$export$8c5a050822fd698c);
var $b08badac1d124df3$export$2e2bcd8739ae039 = $b08badac1d124df3$var$palette;

});

parcelRegister("8j2JW", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $60c239303eb89b20$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $60c239303eb89b20$export$488fda99655ff65a);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $82aMg = parcelRequire("82aMg");
function $60c239303eb89b20$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $60c239303eb89b20$export$7e3df82ee760448c = (0, $ii7BS.default)({
    prop: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $82aMg.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $60c239303eb89b20$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$60c239303eb89b20$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $60c239303eb89b20$export$ee148fbbe8357dd2 = (0, $ii7BS.default)({
    prop: 'minWidth',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ac607276a8fe9f0a = (0, $ii7BS.default)({
    prop: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$dc0d8bd0b94f8570 = (0, $ii7BS.default)({
    prop: 'maxHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$a43cf604e12f3b17 = (0, $ii7BS.default)({
    prop: 'minHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ffed9f14fb65e276 = (0, $ii7BS.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$905076ed6620e671 = (0, $ii7BS.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$6ccc93f785106a58 = (0, $ii7BS.default)({
    prop: 'boxSizing'
});
const $60c239303eb89b20$var$sizing = (0, $hIpso.default)($60c239303eb89b20$export$7e3df82ee760448c, $60c239303eb89b20$export$488fda99655ff65a, $60c239303eb89b20$export$ee148fbbe8357dd2, $60c239303eb89b20$export$ac607276a8fe9f0a, $60c239303eb89b20$export$dc0d8bd0b94f8570, $60c239303eb89b20$export$a43cf604e12f3b17, $60c239303eb89b20$export$6ccc93f785106a58);
var $60c239303eb89b20$export$2e2bcd8739ae039 = $60c239303eb89b20$var$sizing;

});



parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("g6Om4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba4444e1ea571ca$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $bba4444e1ea571ca$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $bba4444e1ea571ca$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $bba4444e1ea571ca$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $bba4444e1ea571ca$export$2e2bcd8739ae039 = $bba4444e1ea571ca$var$useTheme;

});


parcelRegister("jR9F1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e74a75f0176cf8e3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74a75f0176cf8e3$var$_createTheme = $e74a75f0176cf8e3$require$_interopRequireDefault((parcelRequire("ijOKP")));
const $e74a75f0176cf8e3$var$defaultTheme = (0, $e74a75f0176cf8e3$var$_createTheme.default)();
var $e74a75f0176cf8e3$var$_default = module.exports.default = $e74a75f0176cf8e3$var$defaultTheme;

});


parcelRegister("6g9fa", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $48eb684ebe9272b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb684ebe9272b4$var$useThemeProps;

var $48eb684ebe9272b4$var$_useThemeProps = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $48eb684ebe9272b4$var$_defaultTheme = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $48eb684ebe9272b4$var$_identifier = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $48eb684ebe9272b4$var$useThemeProps({ props: props, name: name }) {
    return (0, $48eb684ebe9272b4$var$_useThemeProps.default)({
        props: props,
        name: name,
        defaultTheme: $48eb684ebe9272b4$var$_defaultTheme.default,
        themeId: $48eb684ebe9272b4$var$_identifier.default
    });
}

});
parcelRegister("2LgDM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $202ce10b3dfaac20$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_getThemeProps.default;
    }
});

var $202ce10b3dfaac20$var$_useThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("lfKzS")));

var $202ce10b3dfaac20$var$_getThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("6wACh")));

});
parcelRegister("lfKzS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f78f2110a61a7e24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78f2110a61a7e24$var$useThemeProps;

var $f78f2110a61a7e24$var$_getThemeProps = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("6wACh")));

var $f78f2110a61a7e24$var$_useTheme = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("lywMB")));
function $f78f2110a61a7e24$var$useThemeProps({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f78f2110a61a7e24$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f78f2110a61a7e24$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("6wACh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c022282094d7502$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c022282094d7502$var$getThemeProps;

var $4c022282094d7502$var$_resolveProps = $4c022282094d7502$require$_interopRequireDefault((parcelRequire("7T9kw")));
function $4c022282094d7502$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4c022282094d7502$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});

parcelRegister("lywMB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb1633f194eccc90$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb1633f194eccc90$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb1633f194eccc90$var$_useTheme.default;
    }
});

var $fb1633f194eccc90$var$_useTheme = $fb1633f194eccc90$require$_interopRequireWildcard((parcelRequire("cpDNV")));
Object.keys($fb1633f194eccc90$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb1633f194eccc90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb1633f194eccc90$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb1633f194eccc90$var$_useTheme[key];
        }
    });
});

});
parcelRegister("cpDNV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9096b21b03fc4ec3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $9096b21b03fc4ec3$var$_createTheme = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9096b21b03fc4ec3$var$_useThemeWithoutDefault = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("f18iq")));
const $9096b21b03fc4ec3$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $9096b21b03fc4ec3$var$_createTheme.default)();
function $9096b21b03fc4ec3$var$useTheme(defaultTheme = $9096b21b03fc4ec3$var$systemDefaultTheme) {
    return (0, $9096b21b03fc4ec3$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $9096b21b03fc4ec3$var$_default = module.exports.default = $9096b21b03fc4ec3$var$useTheme;

});





parcelRegister("d8seH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0277c5e26ff0d56c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_rootShouldForwardProp.default;
    }
});
Object.defineProperty(module.exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_slotShouldForwardProp.default;
    }
});

var $0277c5e26ff0d56c$var$_createStyled = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("bbeCr")));

var $0277c5e26ff0d56c$var$_defaultTheme = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0277c5e26ff0d56c$var$_identifier = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $0277c5e26ff0d56c$var$_rootShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $0277c5e26ff0d56c$var$_slotShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $0277c5e26ff0d56c$var$styled = (0, $0277c5e26ff0d56c$var$_createStyled.default)({
    themeId: $0277c5e26ff0d56c$var$_identifier.default,
    defaultTheme: $0277c5e26ff0d56c$var$_defaultTheme.default,
    rootShouldForwardProp: $0277c5e26ff0d56c$var$_rootShouldForwardProp.default
});
var $0277c5e26ff0d56c$var$_default = module.exports.default = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("8Uq77", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $67c7cf568a060c3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67c7cf568a060c3d$var$_slotShouldForwardProp = $67c7cf568a060c3d$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $67c7cf568a060c3d$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$var$_default = module.exports.default = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$var$_default = module.exports.default = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("gRp5N", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c4650f6dac4940cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c4650f6dac4940cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4650f6dac4940cb$var$ThemeProvider;

var $c4650f6dac4940cb$var$React = $c4650f6dac4940cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c4650f6dac4940cb$var$_ThemeProviderNoVars = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("6osfi")));

var $b0NgK = parcelRequire("b0NgK");

var $c4650f6dac4940cb$var$_identifier = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $c4650f6dac4940cb$var$ThemeProvider({ theme: theme, ...props }) {
    const noVarsTheme = $c4650f6dac4940cb$var$React.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = $c4650f6dac4940cb$var$_identifier.default in theme ? theme[$c4650f6dac4940cb$var$_identifier.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)($c4650f6dac4940cb$var$_ThemeProviderNoVars.default, {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b0NgK.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

});
parcelRegister("6osfi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a7ae4f41d656e46$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a7ae4f41d656e46$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a7ae4f41d656e46$var$ThemeProviderNoVars;

var $4a7ae4f41d656e46$var$React = $4a7ae4f41d656e46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6WOpW = parcelRequire("6WOpW");

var $4a7ae4f41d656e46$var$_identifier = $4a7ae4f41d656e46$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $4a7ae4f41d656e46$var$ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = $4a7ae4f41d656e46$var$_identifier.default in themeInput ? themeInput[$4a7ae4f41d656e46$var$_identifier.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6WOpW.default, {
        ...props,
        themeId: scopedTheme ? $4a7ae4f41d656e46$var$_identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

});
parcelRegister("6WOpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ef44b883b4d7f9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1Q4uX = parcelRequire("1Q4uX");
var $6s7D4 = parcelRequire("6s7D4");

parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $g6Om4 = parcelRequire("g6Om4");

var $58lXc = parcelRequire("58lXc");

var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $g6Om4.default)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $6s7D4.default)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Q4uX.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58lXc.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;

});
parcelRegister("58lXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bcebab40d8ce666$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value ?? false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;

});

parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $7T9kw = parcelRequire("7T9kw");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, (/*@__PURE__*/$parcel$interopDefault($7T9kw)))(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, (/*@__PURE__*/$parcel$interopDefault($7T9kw)))(config, props);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});



parcelRegister("b0NgK", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8045e99d413e4782$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $8045e99d413e4782$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CssVarsProvider = void 0;
module.exports.Experimental_CssVarsProvider = $8045e99d413e4782$var$Experimental_CssVarsProvider;
module.exports.useColorScheme = module.exports.getInitColorSchemeScript = void 0;

var $8045e99d413e4782$var$React = $8045e99d413e4782$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8045e99d413e4782$var$_styleFunctionSx = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("l6FST")));

var $cbPVn = parcelRequire("cbPVn");

var $8045e99d413e4782$var$_createTheme = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $8045e99d413e4782$var$_createTypography = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $8045e99d413e4782$var$_identifier = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $3K3i6 = parcelRequire("3K3i6");

var $ayMG0 = parcelRequire("ayMG0");
const { CssVarsProvider: $8045e99d413e4782$var$InternalCssVarsProvider, useColorScheme: $8045e99d413e4782$var$useColorScheme, getInitColorSchemeScript: $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript } = (0, $cbPVn.default)({
    themeId: $8045e99d413e4782$var$_identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $8045e99d413e4782$var$_createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: $3K3i6.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: $3K3i6.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: $3K3i6.defaultConfig.defaultLightColorScheme,
        dark: $3K3i6.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $8045e99d413e4782$var$_createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $8045e99d413e4782$var$_styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
module.exports.useColorScheme = $8045e99d413e4782$var$useColorScheme;
let $8045e99d413e4782$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $8045e99d413e4782$var$Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8045e99d413e4782$var$InternalCssVarsProvider, {
        ...props
    });
}
let $8045e99d413e4782$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $8045e99d413e4782$var$getInitColorSchemeScript = (params)=>{
    if (!$8045e99d413e4782$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $8045e99d413e4782$var$warnedInitScriptOnce = true;
    }
    return $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ module.exports.getInitColorSchemeScript = $8045e99d413e4782$var$getInitColorSchemeScript;
const $8045e99d413e4782$var$CssVarsProvider = module.exports.CssVarsProvider = $8045e99d413e4782$var$InternalCssVarsProvider;

});
parcelRegister("cbPVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfeca3d89da820b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $f5O3L = parcelRequire("f5O3L");

var $6s7D4 = parcelRequire("6s7D4");

var $jdWO4 = parcelRequire("jdWO4");

var $6WOpW = parcelRequire("6WOpW");

var $1NWrJ = parcelRequire("1NWrJ");

var $iBtfI = parcelRequire("iBtfI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8dfeca3d89da820b$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dfeca3d89da820b$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $1NWrJ.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $1NWrJ.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>$acw62.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $6s7D4.default)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $acw62.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $acw62.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $iBtfI.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $acw62.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, (/*@__PURE__*/$parcel$interopDefault($jdWO4)))(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dfeca3d89da820b$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6WOpW.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5O3L.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $1NWrJ.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("1NWrJ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", () => $1507b440b55b1cf7$export$ff0fa3047d11164c);
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", () => $1507b440b55b1cf7$export$665054ea9d94dab9);
$parcel$export(module.exports, "default", () => $1507b440b55b1cf7$export$2e2bcd8739ae039);
/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $1507b440b55b1cf7$export$ff0fa3047d11164c = 'mode';
const $1507b440b55b1cf7$export$665054ea9d94dab9 = 'color-scheme';
const $1507b440b55b1cf7$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $1507b440b55b1cf7$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1507b440b55b1cf7$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $1507b440b55b1cf7$export$665054ea9d94dab9, attribute: initialAttribute = $1507b440b55b1cf7$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("iBtfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b25f9d3c9e642d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1NWrJ = parcelRequire("1NWrJ");

var $54Il9 = parcelRequire("54Il9");
'use client';
function $d8b25f9d3c9e642d$var$noop() {}
function $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d8b25f9d3c9e642d$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state) {
    return $d8b25f9d3c9e642d$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d8b25f9d3c9e642d$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $1NWrJ.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $1NWrJ.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $54Il9.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $acw62.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $acw62.useState(noSsr || !isMultiSchemes);
    $acw62.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $d8b25f9d3c9e642d$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("54Il9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1fb882896a7778$export$2e2bcd8739ae039);
function $3b1fb882896a7778$var$noop() {}
const $3b1fb882896a7778$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $3b1fb882896a7778$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $3b1fb882896a7778$export$2e2bcd8739ae039 = $3b1fb882896a7778$var$localStorageManager;

});



parcelRegister("3K3i6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b983880bbf899cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2b983880bbf899cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.default = void 0;

var $2b983880bbf899cb$var$React = $2b983880bbf899cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2b983880bbf899cb$var$_propTypes = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2b983880bbf899cb$var$_InitColorSchemeScript = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("5UPwK")));

var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$var$defaultConfig = module.exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $2b983880bbf899cb$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $2b983880bbf899cb$var$defaultConfig.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $2b983880bbf899cb$var$defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = $2b983880bbf899cb$var$defaultConfig.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2b983880bbf899cb$var$_InitColorSchemeScript.default, {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $2b983880bbf899cb$var$_default = module.exports.default = $2b983880bbf899cb$var$InitColorSchemeScript;

});
parcelRegister("5UPwK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44ea26ea463a672a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $44ea26ea463a672a$var$_InitColorSchemeScript.default;
    }
});

var $44ea26ea463a672a$var$_InitColorSchemeScript = $44ea26ea463a672a$require$_interopRequireDefault((parcelRequire("79OI6")));

});




parcelRegister("kLL7M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f1ecc062bbad3379$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1ecc062bbad3379$var$makeStyles;

var $f1ecc062bbad3379$var$_formatMuiErrorMessage = $f1ecc062bbad3379$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $f1ecc062bbad3379$var$makeStyles() {
    throw new Error((0, $f1ecc062bbad3379$var$_formatMuiErrorMessage.default)(14));
}

});

parcelRegister("7i0uy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $015e9f5cd865f1ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $015e9f5cd865f1ca$var$withStyles;

var $015e9f5cd865f1ca$var$_formatMuiErrorMessage = $015e9f5cd865f1ca$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $015e9f5cd865f1ca$var$withStyles() {
    throw new Error((0, $015e9f5cd865f1ca$var$_formatMuiErrorMessage.default)(15));
}

});

parcelRegister("lXubi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ffc685059eb0526f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffc685059eb0526f$var$withTheme;

var $ffc685059eb0526f$var$_formatMuiErrorMessage = $ffc685059eb0526f$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $ffc685059eb0526f$var$withTheme() {
    throw new Error((0, $ffc685059eb0526f$var$_formatMuiErrorMessage.default)(16));
}

});

parcelRegister("dj1n2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9afe1ce524e8f62d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9afe1ce524e8f62d$var$deprecatedExtendTheme;

var $9afe1ce524e8f62d$var$_createThemeWithVars = $9afe1ce524e8f62d$require$_interopRequireDefault((parcelRequire("eLI0w")));
let $9afe1ce524e8f62d$var$warnedOnce = false;
function $9afe1ce524e8f62d$var$deprecatedExtendTheme(...args) {
    if (!$9afe1ce524e8f62d$var$warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        $9afe1ce524e8f62d$var$warnedOnce = true;
    }
    return (0, $9afe1ce524e8f62d$var$_createThemeWithVars.default)(...args);
}

});

parcelRegister("9QePP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("5nY49", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3ebdb19980d19cf7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3ebdb19980d19cf7$var$_generateUtilityClasses.default;
    }
});

var $3ebdb19980d19cf7$var$_generateUtilityClasses = $3ebdb19980d19cf7$require$_interopRequireDefault((parcelRequire("6q0pz")));

});
parcelRegister("6q0pz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ac57d7e2ab16278$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ac57d7e2ab16278$var$generateUtilityClasses;

var $4ac57d7e2ab16278$var$_generateUtilityClass = $4ac57d7e2ab16278$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ac57d7e2ab16278$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4ac57d7e2ab16278$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});


parcelRegister("3Hg1x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b11d13e9f9cf7db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b11d13e9f9cf7db$var$_composeClasses.default;
    }
});

var $2b11d13e9f9cf7db$var$_composeClasses = $2b11d13e9f9cf7db$require$_interopRequireDefault((parcelRequire("5m3Us")));

});
parcelRegister("5m3Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e620a2ee867e5d5$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $3e620a2ee867e5d5$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});


parcelRegister("hwliF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cc15f294b94b87be$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cc15f294b94b87be$var$_useId.default;
    }
});

var $cc15f294b94b87be$var$_useId = $cc15f294b94b87be$require$_interopRequireDefault((parcelRequire("4NWyA")));

});
parcelRegister("4NWyA", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $37f92932f8526401$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37f92932f8526401$var$useId;

var $37f92932f8526401$var$React = $37f92932f8526401$require$_interopRequireWildcard((parcelRequire("acw62")));
let $37f92932f8526401$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $37f92932f8526401$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $37f92932f8526401$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $37f92932f8526401$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $37f92932f8526401$var$globalId += 1;
            setDefaultId(`mui-${$37f92932f8526401$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $37f92932f8526401$var$safeReact = {
    ...$37f92932f8526401$var$React
};
const $37f92932f8526401$var$maybeReactUseId = $37f92932f8526401$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $37f92932f8526401$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($37f92932f8526401$var$maybeReactUseId !== undefined) {
        const reactId = $37f92932f8526401$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $37f92932f8526401$var$useGlobalId(idOverride);
}

});


parcelRegister("clXxf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fe5a0a4a52682b2$var$isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $8fe5a0a4a52682b2$var$isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("e4pKA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a3e569e96d60bae8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3e569e96d60bae8$var$_useForkRef.default;
    }
});

var $a3e569e96d60bae8$var$_useForkRef = $a3e569e96d60bae8$require$_interopRequireDefault((parcelRequire("kv0Da")));

});
parcelRegister("kv0Da", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eec73129f1331d63$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec73129f1331d63$var$useForkRef;

var $eec73129f1331d63$var$React = $eec73129f1331d63$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $eec73129f1331d63$var$useForkRef(...refs) {
    const cleanupRef = $eec73129f1331d63$var$React.useRef(undefined);
    const refEffect = $eec73129f1331d63$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $eec73129f1331d63$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("6Lbjo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ebfe8299138c5c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ebfe8299138c5c5$var$_useEventCallback.default;
    }
});

var $4ebfe8299138c5c5$var$_useEventCallback = $4ebfe8299138c5c5$require$_interopRequireDefault((parcelRequire("iDWdC")));

});
parcelRegister("iDWdC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d9290782162abf54$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9290782162abf54$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9290782162abf54$var$React = $d9290782162abf54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d9290782162abf54$var$_useEnhancedEffect = $d9290782162abf54$require$_interopRequireDefault((parcelRequire("jdWO4")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $d9290782162abf54$var$useEventCallback(fn) {
    const ref = $d9290782162abf54$var$React.useRef(fn);
    (0, $d9290782162abf54$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $d9290782162abf54$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $d9290782162abf54$var$_default = module.exports.default = $d9290782162abf54$var$useEventCallback;

});


parcelRegister("5vBDv", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $402d0abe25ac8831$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $402d0abe25ac8831$var$useLazyRef;

var $402d0abe25ac8831$var$React = $402d0abe25ac8831$require$_interopRequireWildcard((parcelRequire("acw62")));
const $402d0abe25ac8831$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $402d0abe25ac8831$var$useLazyRef(init, initArg) {
    const ref = $402d0abe25ac8831$var$React.useRef($402d0abe25ac8831$var$UNINITIALIZED);
    if (ref.current === $402d0abe25ac8831$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("lAE8L", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $fb7c18ce8a63cbff$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $fb7c18ce8a63cbff$var$useTimeout;

var $fb7c18ce8a63cbff$var$_useLazyRef = $fb7c18ce8a63cbff$require$_interopRequireDefault((parcelRequire("5vBDv")));

var $fb7c18ce8a63cbff$var$_useOnMount = $fb7c18ce8a63cbff$require$_interopRequireDefault((parcelRequire("kWo5z")));
class $fb7c18ce8a63cbff$var$Timeout {
    static create() {
        return new $fb7c18ce8a63cbff$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $fb7c18ce8a63cbff$var$Timeout;
function $fb7c18ce8a63cbff$var$useTimeout() {
    const timeout = (0, $fb7c18ce8a63cbff$var$_useLazyRef.default)($fb7c18ce8a63cbff$var$Timeout.create).current;
    (0, $fb7c18ce8a63cbff$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("kWo5z", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $f3ebe8fe644f0aa5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3ebe8fe644f0aa5$var$useOnMount;

var $f3ebe8fe644f0aa5$var$React = $f3ebe8fe644f0aa5$require$_interopRequireWildcard((parcelRequire("acw62")));
const $f3ebe8fe644f0aa5$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $f3ebe8fe644f0aa5$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $f3ebe8fe644f0aa5$var$React.useEffect(fn, $f3ebe8fe644f0aa5$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("5yr9V", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40b531ef992288aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $40b531ef992288aa$var$_isMuiElement.default;
    }
});

var $40b531ef992288aa$var$_isMuiElement = $40b531ef992288aa$require$_interopRequireDefault((parcelRequire("cr6gy")));

});
parcelRegister("cr6gy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $90dcddf03243cc11$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90dcddf03243cc11$var$isMuiElement;

var $90dcddf03243cc11$var$React = $90dcddf03243cc11$require$_interopRequireWildcard((parcelRequire("acw62")));
function $90dcddf03243cc11$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $90dcddf03243cc11$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("4UzRg", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $3938350e2a221962$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3938350e2a221962$var$getReactElementRef;

var $3938350e2a221962$var$React = $3938350e2a221962$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Returns the ref of a React element handling differences between React 19 and older versions.
 * It will throw runtime error if the element is not a valid React element.
 *
 * @param element React.ReactElement
 * @returns React.Ref<any> | null
 */ function $3938350e2a221962$var$getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($3938350e2a221962$var$React.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});

parcelRegister("43fuO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f33766ba7c82ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f33766ba7c82ed1$var$_ownerDocument.default;
    }
});

var $2f33766ba7c82ed1$var$_ownerDocument = $2f33766ba7c82ed1$require$_interopRequireDefault((parcelRequire("49EPw")));

});
parcelRegister("49EPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3067acab6211afec$var$ownerDocument;
function $3067acab6211afec$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});


parcelRegister("jjoya", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e0f2d5c8a2ef3c7f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0f2d5c8a2ef3c7f$var$_useForkRef = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $e0f2d5c8a2ef3c7f$var$_appendOwnerState = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("fByHY")));

var $e0f2d5c8a2ef3c7f$var$_mergeSlotProps = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("dfy9C")));

var $e0f2d5c8a2ef3c7f$var$_resolveComponentProps = $e0f2d5c8a2ef3c7f$require$_interopRequireDefault((parcelRequire("jzekU")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $e0f2d5c8a2ef3c7f$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $e0f2d5c8a2ef3c7f$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $e0f2d5c8a2ef3c7f$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $e0f2d5c8a2ef3c7f$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $e0f2d5c8a2ef3c7f$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $e0f2d5c8a2ef3c7f$var$_default = module.exports.default = $e0f2d5c8a2ef3c7f$var$useSlotProps;

});
parcelRegister("fByHY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b5c53c0db043a190$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b5c53c0db043a190$var$_appendOwnerState.default;
    }
});

var $b5c53c0db043a190$var$_appendOwnerState = $b5c53c0db043a190$require$_interopRequireDefault((parcelRequire("SxCI4")));

});
parcelRegister("SxCI4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0a3f2028457854eb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a3f2028457854eb$var$_isHostComponent = $0a3f2028457854eb$require$_interopRequireDefault((parcelRequire("7jqh1")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $0a3f2028457854eb$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $0a3f2028457854eb$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $0a3f2028457854eb$var$_default = module.exports.default = $0a3f2028457854eb$var$appendOwnerState;

});
parcelRegister("7jqh1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $552eb02447a4b108$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $552eb02447a4b108$var$_isHostComponent.default;
    }
});

var $552eb02447a4b108$var$_isHostComponent = $552eb02447a4b108$require$_interopRequireDefault((parcelRequire("1cVk7")));

});
parcelRegister("1cVk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $0e1360ab77873eb8$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $0e1360ab77873eb8$var$_default = module.exports.default = $0e1360ab77873eb8$var$isHostComponent;

});




parcelRegister("dfy9C", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a572b623f6aa29c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a572b623f6aa29c$var$_mergeSlotProps.default;
    }
});

var $9a572b623f6aa29c$var$_mergeSlotProps = $9a572b623f6aa29c$require$_interopRequireDefault((parcelRequire("3vQQW")));

});
parcelRegister("3vQQW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28ed43d991ccc074$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28ed43d991ccc074$var$_clsx = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("9QePP")));

var $28ed43d991ccc074$var$_extractEventHandlers = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("bhYgh")));

var $28ed43d991ccc074$var$_omitEventHandlers = $28ed43d991ccc074$require$_interopRequireDefault((parcelRequire("dgDmX")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $28ed43d991ccc074$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $28ed43d991ccc074$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $28ed43d991ccc074$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $28ed43d991ccc074$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $28ed43d991ccc074$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $28ed43d991ccc074$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $28ed43d991ccc074$var$_default = module.exports.default = $28ed43d991ccc074$var$mergeSlotProps;

});
parcelRegister("bhYgh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $838006f6038ae26f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $838006f6038ae26f$var$_extractEventHandlers.default;
    }
});

var $838006f6038ae26f$var$_extractEventHandlers = $838006f6038ae26f$require$_interopRequireDefault((parcelRequire("foye3")));

});
parcelRegister("foye3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $b353a56c2b32b8fb$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $b353a56c2b32b8fb$var$_default = module.exports.default = $b353a56c2b32b8fb$var$extractEventHandlers;

});


parcelRegister("dgDmX", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9a8b4ee879070d7d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a8b4ee879070d7d$var$_omitEventHandlers.default;
    }
});

var $9a8b4ee879070d7d$var$_omitEventHandlers = $9a8b4ee879070d7d$require$_interopRequireDefault((parcelRequire("21PNK")));

});
parcelRegister("21PNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $17a3db7502283a72$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $17a3db7502283a72$var$_default = module.exports.default = $17a3db7502283a72$var$omitEventHandlers;

});




parcelRegister("jzekU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e3ec68142ab190e2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e3ec68142ab190e2$var$_resolveComponentProps.default;
    }
});

var $e3ec68142ab190e2$var$_resolveComponentProps = $e3ec68142ab190e2$require$_interopRequireDefault((parcelRequire("cgoZX")));

});
parcelRegister("cgoZX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $8eda5ecc2288dedf$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $8eda5ecc2288dedf$var$_default = module.exports.default = $8eda5ecc2288dedf$var$resolveComponentProps;

});



parcelRegister("2Fa2r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f0732850f39cffc$var$getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $1f0732850f39cffc$var$getScrollbarSize(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});

parcelRegister("4Rhws", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3899b44489cdde78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3899b44489cdde78$var$_ownerWindow.default;
    }
});

var $3899b44489cdde78$var$_ownerWindow = $3899b44489cdde78$require$_interopRequireDefault((parcelRequire("l4FpR")));

});
parcelRegister("l4FpR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f57a191378fb6173$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f57a191378fb6173$var$ownerWindow;

var $f57a191378fb6173$var$_ownerDocument = $f57a191378fb6173$require$_interopRequireDefault((parcelRequire("43fuO")));
function $f57a191378fb6173$var$ownerWindow(node) {
    const doc = (0, $f57a191378fb6173$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("9NXOO", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $723717646d90af53$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $723717646d90af53$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $723717646d90af53$var$_debounce.default;
    }
});

var $723717646d90af53$var$_debounce = $723717646d90af53$require$_interopRequireWildcard((parcelRequire("7VOF5")));
Object.keys($723717646d90af53$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($723717646d90af53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $723717646d90af53$var$_debounce[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $723717646d90af53$var$_debounce[key];
        }
    });
});

});
parcelRegister("7VOF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c6527a444bb8d00$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $5c6527a444bb8d00$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("dGvj8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9f677ba749dc745d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9f677ba749dc745d$var$_setRef.default;
    }
});

var $9f677ba749dc745d$var$_setRef = $9f677ba749dc745d$require$_interopRequireDefault((parcelRequire("01n9P")));

});
parcelRegister("01n9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00420eb250698fce$var$setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $00420eb250698fce$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("7QInQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5b6fd168e06dd390$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5b6fd168e06dd390$var$_createChainedFunction.default;
    }
});

var $5b6fd168e06dd390$var$_createChainedFunction = $5b6fd168e06dd390$require$_interopRequireDefault((parcelRequire("ZfLEz")));

});
parcelRegister("ZfLEz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b81edbcaacf3a52$var$createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $0b81edbcaacf3a52$var$createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});


parcelRegister("iSpB2", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $dbe1201302318660$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dbe1201302318660$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dbe1201302318660$var$_useControlled.default;
    }
});

var $dbe1201302318660$var$_useControlled = $dbe1201302318660$require$_interopRequireWildcard((parcelRequire("cEttN")));
Object.keys($dbe1201302318660$var$_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dbe1201302318660$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dbe1201302318660$var$_useControlled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dbe1201302318660$var$_useControlled[key];
        }
    });
});

});
parcelRegister("cEttN", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $936016844ea5135f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $936016844ea5135f$var$useControlled;

var $936016844ea5135f$var$React = $936016844ea5135f$require$_interopRequireWildcard((parcelRequire("acw62")));
function $936016844ea5135f$var$useControlled(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $936016844ea5135f$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $936016844ea5135f$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $936016844ea5135f$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefiend.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("jreHA", function(module, exports) {
"use strict";
var $e26bf16cebf2d56f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $e26bf16cebf2d56f$var$PostgrestQueryBuilder_1 = $e26bf16cebf2d56f$var$__importDefault((parcelRequire("dBXeq")));

const $e26bf16cebf2d56f$var$PostgrestFilterBuilder_1 = $e26bf16cebf2d56f$var$__importDefault((parcelRequire("dSHX3")));

var $3C7Gg = parcelRequire("3C7Gg");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class $e26bf16cebf2d56f$var$PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $3C7Gg.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new $e26bf16cebf2d56f$var$PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $e26bf16cebf2d56f$var$PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new $e26bf16cebf2d56f$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $e26bf16cebf2d56f$var$PostgrestClient;

});
parcelRegister("dBXeq", function(module, exports) {
"use strict";
var $9e8cad397b4a7e77$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1 = $9e8cad397b4a7e77$var$__importDefault((parcelRequire("dSHX3")));
class $9e8cad397b4a7e77$var$PostgrestQueryBuilder {
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new $9e8cad397b4a7e77$var$PostgrestFilterBuilder_1.default({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
module.exports.default = $9e8cad397b4a7e77$var$PostgrestQueryBuilder;

});
parcelRegister("dSHX3", function(module, exports) {
"use strict";
var $a1b269604a69632c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a1b269604a69632c$var$PostgrestTransformBuilder_1 = $a1b269604a69632c$var$__importDefault((parcelRequire("kkZ1b")));
class $a1b269604a69632c$var$PostgrestFilterBuilder extends $a1b269604a69632c$var$PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
module.exports.default = $a1b269604a69632c$var$PostgrestFilterBuilder;

});
parcelRegister("kkZ1b", function(module, exports) {
"use strict";
var $ece501d5ff408d7d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ece501d5ff408d7d$var$PostgrestBuilder_1 = $ece501d5ff408d7d$var$__importDefault((parcelRequire("9WNOL")));
class $ece501d5ff408d7d$var$PostgrestTransformBuilder extends $ece501d5ff408d7d$var$PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        return this;
    }
}
module.exports.default = $ece501d5ff408d7d$var$PostgrestTransformBuilder;

});
parcelRegister("9WNOL", function(module, exports) {
"use strict";
var $73e02ca1f3b16d8b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
const $73e02ca1f3b16d8b$var$node_fetch_1 = $73e02ca1f3b16d8b$var$__importDefault((parcelRequire("979Ct")));

const $73e02ca1f3b16d8b$var$PostgrestError_1 = $73e02ca1f3b16d8b$var$__importDefault((parcelRequire("iN95t")));
class $73e02ca1f3b16d8b$var$PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $73e02ca1f3b16d8b$var$node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new $73e02ca1f3b16d8b$var$PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     * @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
     */ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
     * Override the type of the returned `data` field in the response.
     *
     * @typeParam NewResult - The new type to cast the response data to
     * @typeParam Options - Optional type configuration (defaults to { merge: true })
     * @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
     * @example
     * ```typescript
     * // Merge with existing types (default behavior)
     * const query = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ custom_field: string }>()
     *
     * // Replace existing types completely
     * const replaceQuery = supabase
     *   .from('users')
     *   .select()
     *   .overrideTypes<{ id: number; name: string }, { merge: false }>()
     * ```
     * @returns A PostgrestBuilder instance with the new type
     */ overrideTypes() {
        return this;
    }
}
module.exports.default = $73e02ca1f3b16d8b$var$PostgrestBuilder;

});
parcelRegister("979Ct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", () => $6a2c3abb9894d801$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "default", () => $6a2c3abb9894d801$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Headers", () => $6a2c3abb9894d801$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $6a2c3abb9894d801$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $6a2c3abb9894d801$export$9f633d56d7ec90d3);
"use strict";
// ref: https://github.com/tc39/proposal-global
var $6a2c3abb9894d801$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $6a2c3abb9894d801$var$globalObject = $6a2c3abb9894d801$var$getGlobal();
const $6a2c3abb9894d801$export$e7aa7bc5c1b3cfb3 = $6a2c3abb9894d801$var$globalObject.fetch;
var $6a2c3abb9894d801$export$2e2bcd8739ae039 = $6a2c3abb9894d801$var$globalObject.fetch.bind($6a2c3abb9894d801$var$globalObject);
const $6a2c3abb9894d801$export$79b704688b15c0f4 = $6a2c3abb9894d801$var$globalObject.Headers;
const $6a2c3abb9894d801$export$7fa6c5b6f8193917 = $6a2c3abb9894d801$var$globalObject.Request;
const $6a2c3abb9894d801$export$9f633d56d7ec90d3 = $6a2c3abb9894d801$var$globalObject.Response;

});

parcelRegister("iN95t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class $dae3da29d0e217db$var$PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
module.exports.default = $dae3da29d0e217db$var$PostgrestError;

});





parcelRegister("3C7Gg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $k7pAC = parcelRequire("k7pAC");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${$k7pAC.version}`
};

});
parcelRegister("k7pAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("fvaAM", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRegister("jTnBY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7b578196486f177$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7b578196486f177$var$_capitalize = $e7b578196486f177$require$_interopRequireDefault((parcelRequire("4O6za")));
var $e7b578196486f177$var$_default = module.exports.default = $e7b578196486f177$var$_capitalize.default;

});

parcelRegister("5gbhl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d47321b9fcbcb38$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d47321b9fcbcb38$var$_createChainedFunction = $3d47321b9fcbcb38$require$_interopRequireDefault((parcelRequire("7QInQ")));
var $3d47321b9fcbcb38$var$_default = module.exports.default = $3d47321b9fcbcb38$var$_createChainedFunction.default;

});

parcelRegister("bbT5Q", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $825b752ac2a74c27$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $825b752ac2a74c27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $825b752ac2a74c27$var$createSvgIcon;

var $825b752ac2a74c27$var$React = $825b752ac2a74c27$require$_interopRequireWildcard((parcelRequire("acw62")));

var $825b752ac2a74c27$var$_SvgIcon = $825b752ac2a74c27$require$_interopRequireDefault((parcelRequire("loOwp")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * Private module reserved for @mui packages.
 */ function $825b752ac2a74c27$var$createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($825b752ac2a74c27$var$_SvgIcon.default, {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = $825b752ac2a74c27$var$_SvgIcon.default.muiName;
    return /*#__PURE__*/ $825b752ac2a74c27$var$React.memo(/*#__PURE__*/ $825b752ac2a74c27$var$React.forwardRef(Component));
}

});
parcelRegister("loOwp", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f943077249b43968$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $f943077249b43968$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f943077249b43968$var$_exportNames = {
    svgIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f943077249b43968$var$_SvgIcon.default;
    }
});
Object.defineProperty(module.exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return $f943077249b43968$var$_svgIconClasses.default;
    }
});

var $f943077249b43968$var$_SvgIcon = $f943077249b43968$require$_interopRequireDefault((parcelRequire("3ErGR")));

var $f943077249b43968$var$_svgIconClasses = $f943077249b43968$require$_interopRequireWildcard((parcelRequire("aiIP4")));
Object.keys($f943077249b43968$var$_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f943077249b43968$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f943077249b43968$var$_svgIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f943077249b43968$var$_svgIconClasses[key];
        }
    });
});

});
parcelRegister("3ErGR", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2a8a963e5702921b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2a8a963e5702921b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a8a963e5702921b$var$React = $2a8a963e5702921b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2a8a963e5702921b$var$_propTypes = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2a8a963e5702921b$var$_clsx = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("9QePP")));

var $2a8a963e5702921b$var$_composeClasses = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $2a8a963e5702921b$var$_capitalize = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $aAbgT = parcelRequire("aAbgT");

var $2a8a963e5702921b$var$_memoTheme = $2a8a963e5702921b$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $2a8a963e5702921b$var$_capitalize.default)(color)}`,
            `fontSize${(0, $2a8a963e5702921b$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $2a8a963e5702921b$var$_composeClasses.default)(slots, $aiIP4.getSvgIconUtilityClass, classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $aAbgT.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $2a8a963e5702921b$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $2a8a963e5702921b$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $2a8a963e5702921b$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $2a8a963e5702921b$var$React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $2a8a963e5702921b$var$React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, {
        as: component,
        className: (0, $2a8a963e5702921b$var$_clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$var$_default = module.exports.default = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("aAbgT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7b460279bb5c09c1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $7b460279bb5c09c1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.globalCss = $7b460279bb5c09c1$var$globalCss;
module.exports.internal_createExtendSxProp = $7b460279bb5c09c1$var$internal_createExtendSxProp;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_useTheme.default;
    }
});

var $7b460279bb5c09c1$var$React = $7b460279bb5c09c1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $l6FST = parcelRequire("l6FST");

var $7b460279bb5c09c1$var$_useTheme = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("14H9o")));

var $7b460279bb5c09c1$var$_GlobalStyles = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("kjVW8")));

var $ayMG0 = parcelRequire("ayMG0");

var $jjlaj = parcelRequire("jjlaj");

var $7b460279bb5c09c1$var$_styled = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("d8seH")));
function $7b460279bb5c09c1$var$globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)($7b460279bb5c09c1$var$_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $7b460279bb5c09c1$var$internal_createExtendSxProp() {
    return $l6FST.extendSxProp;
}

});
parcelRegister("kjVW8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ecb286025e88fbf5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ecb286025e88fbf5$var$_GlobalStyles.default;
    }
});

var $ecb286025e88fbf5$var$_GlobalStyles = $ecb286025e88fbf5$require$_interopRequireDefault((parcelRequire("ldx2z")));

});
parcelRegister("ldx2z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $03fc756f7adfd498$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $03fc756f7adfd498$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03fc756f7adfd498$var$React = $03fc756f7adfd498$require$_interopRequireWildcard((parcelRequire("acw62")));

var $03fc756f7adfd498$var$_propTypes = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $92iK7 = parcelRequire("92iK7");

var $03fc756f7adfd498$var$_defaultTheme = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $03fc756f7adfd498$var$_identifier = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($92iK7.default, {
        ...props,
        defaultTheme: $03fc756f7adfd498$var$_defaultTheme.default,
        themeId: $03fc756f7adfd498$var$_identifier.default
    });
}
var $03fc756f7adfd498$var$_default = module.exports.default = $03fc756f7adfd498$var$GlobalStyles;

});
parcelRegister("92iK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942d6ec85232a9d$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $f5O3L = parcelRequire("f5O3L");

var $eM1DJ = parcelRequire("eM1DJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $eM1DJ.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5O3L.default), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;

});




parcelRegister("aeD7H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jgzqq = parcelRequire("jgzqq");
const $77398f38c6229912$var$memoTheme = $jgzqq.default;
var $77398f38c6229912$var$_default = module.exports.default = $77398f38c6229912$var$memoTheme;

});
parcelRegister("jgzqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06afda6b2197864$export$2e2bcd8739ae039);

var $aFFCY = parcelRequire("aFFCY");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $e06afda6b2197864$var$arg = {
    theme: undefined
};
function $e06afda6b2197864$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $e06afda6b2197864$var$arg.theme = props.theme;
            value = (0, $aFFCY.default)(styleFn($e06afda6b2197864$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});
parcelRegister("aFFCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4e0616915ca3a0$export$2e2bcd8739ae039);

var $8TaLX = parcelRequire("8TaLX");
function $7c4e0616915ca3a0$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $8TaLX.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $8TaLX.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("hL1nr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ced7e4e89ca5cfee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $ced7e4e89ca5cfee$var$_DefaultPropsProvider = $ced7e4e89ca5cfee$require$_interopRequireWildcard((parcelRequire("1iOpW")));

});
parcelRegister("1iOpW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0f2e94b8fca67639$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0f2e94b8fca67639$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $0f2e94b8fca67639$var$useDefaultProps;

var $0f2e94b8fca67639$var$React = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0f2e94b8fca67639$var$_propTypes = $0f2e94b8fca67639$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0f2e94b8fca67639$var$_DefaultPropsProvider = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("buuO7")));

var $ayMG0 = parcelRequire("ayMG0");
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0f2e94b8fca67639$var$_DefaultPropsProvider.default, {
        ...props
    });
}
var $0f2e94b8fca67639$var$_default = module.exports.default = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$var$useDefaultProps(params) {
    return (0, $0f2e94b8fca67639$var$_DefaultPropsProvider.useDefaultProps)(params);
}

});


parcelRegister("aiIP4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $77fe5ab326d42cdb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSvgIconUtilityClass = $77fe5ab326d42cdb$var$getSvgIconUtilityClass;

var $77fe5ab326d42cdb$var$_generateUtilityClasses = $77fe5ab326d42cdb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $77fe5ab326d42cdb$var$_generateUtilityClass = $77fe5ab326d42cdb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $77fe5ab326d42cdb$var$getSvgIconUtilityClass(slot) {
    return (0, $77fe5ab326d42cdb$var$_generateUtilityClass.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $77fe5ab326d42cdb$var$_generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$var$_default = module.exports.default = $77fe5ab326d42cdb$var$svgIconClasses;

});




parcelRegister("1iGrQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0f2866359d6621f3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f2866359d6621f3$var$_debounce = $0f2866359d6621f3$require$_interopRequireDefault((parcelRequire("9NXOO")));
var $0f2866359d6621f3$var$_default = module.exports.default = $0f2866359d6621f3$var$_debounce.default;

});

parcelRegister("gIZJw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c2d0a44fb35b2388$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2d0a44fb35b2388$var$_deprecatedPropType = $c2d0a44fb35b2388$require$_interopRequireDefault((parcelRequire("aDYnb")));
var $c2d0a44fb35b2388$var$_default = module.exports.default = $c2d0a44fb35b2388$var$_deprecatedPropType.default;

});
parcelRegister("aDYnb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7bfc60b9ae966df9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7bfc60b9ae966df9$var$_deprecatedPropType.default;
    }
});

var $7bfc60b9ae966df9$var$_deprecatedPropType = $7bfc60b9ae966df9$require$_interopRequireDefault((parcelRequire("6icuG")));

});
parcelRegister("6icuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $494e1d8c1b97aa71$var$deprecatedPropType;
function $494e1d8c1b97aa71$var$deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

});



parcelRegister("cpXNi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $90a633ad7a979daa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90a633ad7a979daa$var$_isMuiElement = $90a633ad7a979daa$require$_interopRequireDefault((parcelRequire("5yr9V")));
var $90a633ad7a979daa$var$_default = module.exports.default = $90a633ad7a979daa$var$_isMuiElement.default;

});

parcelRegister("gzyUk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c10afe25107351d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10afe25107351d9$var$_ownerDocument = $c10afe25107351d9$require$_interopRequireDefault((parcelRequire("43fuO")));
var $c10afe25107351d9$var$_default = module.exports.default = $c10afe25107351d9$var$_ownerDocument.default;

});

parcelRegister("9Evvr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $707049eb9639aeac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $707049eb9639aeac$var$_ownerWindow = $707049eb9639aeac$require$_interopRequireDefault((parcelRequire("4Rhws")));
var $707049eb9639aeac$var$_default = module.exports.default = $707049eb9639aeac$var$_ownerWindow.default;

});

parcelRegister("3VqP0", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2dbb80310490cb08$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dbb80310490cb08$var$_requirePropFactory = $2dbb80310490cb08$require$_interopRequireDefault((parcelRequire("2IZ5o")));
var $2dbb80310490cb08$var$_default = module.exports.default = $2dbb80310490cb08$var$_requirePropFactory.default;

});
parcelRegister("2IZ5o", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fbf133d7c4f4f16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1fbf133d7c4f4f16$var$_requirePropFactory.default;
    }
});

var $1fbf133d7c4f4f16$var$_requirePropFactory = $1fbf133d7c4f4f16$require$_interopRequireDefault((parcelRequire("iJohf")));

});
parcelRegister("iJohf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $da2f42eafa577c28$var$requirePropFactory;
function $da2f42eafa577c28$var$requirePropFactory(componentNameInError, Component) {
    return ()=>()=>null;
}

});



parcelRegister("e6E85", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a450c11ad3ab84fa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a450c11ad3ab84fa$var$_setRef = $a450c11ad3ab84fa$require$_interopRequireDefault((parcelRequire("dGvj8")));
var $a450c11ad3ab84fa$var$_default = module.exports.default = $a450c11ad3ab84fa$var$_setRef.default;

});

parcelRegister("khjmj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec346974df496fc5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec346974df496fc5$var$_useEnhancedEffect = $ec346974df496fc5$require$_interopRequireDefault((parcelRequire("jdWO4")));
var $ec346974df496fc5$var$_default = module.exports.default = $ec346974df496fc5$var$_useEnhancedEffect.default;

});

parcelRegister("5A6d3", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4105219ee6538ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4105219ee6538ed1$var$_useId = $4105219ee6538ed1$require$_interopRequireDefault((parcelRequire("hwliF")));
var $4105219ee6538ed1$var$_default = module.exports.default = $4105219ee6538ed1$var$_useId.default;

});

parcelRegister("gUzNi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c4fda44a4aac44a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4fda44a4aac44a5$var$_unsupportedProp = $c4fda44a4aac44a5$require$_interopRequireDefault((parcelRequire("kf98i")));
var $c4fda44a4aac44a5$var$_default = module.exports.default = $c4fda44a4aac44a5$var$_unsupportedProp.default;

});
parcelRegister("kf98i", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ebcc4af23e3dfede$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ebcc4af23e3dfede$var$_unsupportedProp.default;
    }
});

var $ebcc4af23e3dfede$var$_unsupportedProp = $ebcc4af23e3dfede$require$_interopRequireDefault((parcelRequire("hgZZv")));

});
parcelRegister("hgZZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9340465e04eedf1$var$unsupportedProp;
function $c9340465e04eedf1$var$unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

});



parcelRegister("3yddg", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $295ecbe78b5bad73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295ecbe78b5bad73$var$_useControlled = $295ecbe78b5bad73$require$_interopRequireDefault((parcelRequire("iSpB2")));
var $295ecbe78b5bad73$var$_default = module.exports.default = $295ecbe78b5bad73$var$_useControlled.default;

});

parcelRegister("4o7uD", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $331f3746e6346411$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $331f3746e6346411$var$_useEventCallback = $331f3746e6346411$require$_interopRequireDefault((parcelRequire("6Lbjo")));
var $331f3746e6346411$var$_default = module.exports.default = $331f3746e6346411$var$_useEventCallback.default;

});

parcelRegister("9Rgf1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $72d5a979b2ad8bc9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72d5a979b2ad8bc9$var$_useForkRef = $72d5a979b2ad8bc9$require$_interopRequireDefault((parcelRequire("e4pKA")));
var $72d5a979b2ad8bc9$var$_default = module.exports.default = $72d5a979b2ad8bc9$var$_useForkRef.default;

});

parcelRegister("f8X1n", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b06562c0a3ca8f02$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b06562c0a3ca8f02$var$mergeSlotProps;

var $b06562c0a3ca8f02$var$_clsx = $b06562c0a3ca8f02$require$_interopRequireDefault((parcelRequire("9QePP")));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $b06562c0a3ca8f02$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $b06562c0a3ca8f02$var$mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($b06562c0a3ca8f02$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $b06562c0a3ca8f02$var$_clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $b06562c0a3ca8f02$var$_clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});

parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $hGPki.createSvgIcon;
    }
});

var $hGPki = parcelRequire("hGPki");

});
parcelRegister("hGPki", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ce0e2c401cd11493$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "capitalize", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_capitalize.default;
    }
});
Object.defineProperty(module.exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_createChainedFunction.default;
    }
});
Object.defineProperty(module.exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_createSvgIcon.default;
    }
});
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_debounce.default;
    }
});
Object.defineProperty(module.exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_deprecatedPropType.default;
    }
});
Object.defineProperty(module.exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_isMuiElement.default;
    }
});
Object.defineProperty(module.exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_mergeSlotProps.default;
    }
});
Object.defineProperty(module.exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_ownerDocument.default;
    }
});
Object.defineProperty(module.exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_ownerWindow.default;
    }
});
Object.defineProperty(module.exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_requirePropFactory.default;
    }
});
Object.defineProperty(module.exports, "setRef", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_setRef.default;
    }
});
module.exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useEnhancedEffect.default;
    }
});
Object.defineProperty(module.exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useId.default;
    }
});
Object.defineProperty(module.exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_unsupportedProp.default;
    }
});
Object.defineProperty(module.exports, "useControlled", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useControlled.default;
    }
});
Object.defineProperty(module.exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useEventCallback.default;
    }
});
Object.defineProperty(module.exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return $ce0e2c401cd11493$var$_useForkRef.default;
    }
});

var $ce0e2c401cd11493$var$_ClassNameGenerator = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("aYaRV")));

var $ce0e2c401cd11493$var$_capitalize = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $ce0e2c401cd11493$var$_createChainedFunction = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("5gbhl")));

var $ce0e2c401cd11493$var$_createSvgIcon = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("bbT5Q")));

var $ce0e2c401cd11493$var$_debounce = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("1iGrQ")));

var $ce0e2c401cd11493$var$_deprecatedPropType = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gIZJw")));

var $ce0e2c401cd11493$var$_isMuiElement = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("cpXNi")));

var $ce0e2c401cd11493$var$_memoTheme = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $ce0e2c401cd11493$var$_ownerDocument = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $ce0e2c401cd11493$var$_ownerWindow = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("9Evvr")));

var $ce0e2c401cd11493$var$_requirePropFactory = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("3VqP0")));

var $ce0e2c401cd11493$var$_setRef = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("e6E85")));

var $ce0e2c401cd11493$var$_useEnhancedEffect = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("khjmj")));

var $ce0e2c401cd11493$var$_useId = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("5A6d3")));

var $ce0e2c401cd11493$var$_unsupportedProp = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("gUzNi")));

var $ce0e2c401cd11493$var$_useControlled = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("3yddg")));

var $ce0e2c401cd11493$var$_useEventCallback = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("4o7uD")));

var $ce0e2c401cd11493$var$_useForkRef = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $ce0e2c401cd11493$var$_mergeSlotProps = $ce0e2c401cd11493$require$_interopRequireDefault((parcelRequire("f8X1n")));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const $ce0e2c401cd11493$var$unstable_ClassNameGenerator = module.exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        $ce0e2c401cd11493$var$_ClassNameGenerator.default.configure(generator);
    }
};

});


parcelRegister("78KYM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $532db8df695edb5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $532db8df695edb5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery;

var $532db8df695edb5e$var$React = $532db8df695edb5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $532db8df695edb5e$var$_useEnhancedEffect = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2LgDM = parcelRequire("2LgDM");

var $532db8df695edb5e$var$_useThemeWithoutDefault = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("f18iq")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $532db8df695edb5e$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $532db8df695edb5e$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $532db8df695edb5e$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $532db8df695edb5e$var$safeReact = {
    ...$532db8df695edb5e$var$React
};
const $532db8df695edb5e$var$maybeReactUseSyncExternalStore = $532db8df695edb5e$var$safeReact.useSyncExternalStore;
function $532db8df695edb5e$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $532db8df695edb5e$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $532db8df695edb5e$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $532db8df695edb5e$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $532db8df695edb5e$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $532db8df695edb5e$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $532db8df695edb5e$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $2LgDM.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $532db8df695edb5e$var$maybeReactUseSyncExternalStore !== undefined ? $532db8df695edb5e$var$useMediaQueryNew : $532db8df695edb5e$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $532db8df695edb5e$var$useMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery();
var $532db8df695edb5e$var$_default = module.exports.default = $532db8df695edb5e$var$useMediaQuery;

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");

var $l6FST = parcelRequire("l6FST");
parcelRequire("acw62");

var $eM1DJ = parcelRequire("eM1DJ");

var $4Z6Nd = parcelRequire("4Z6Nd");

var $bQ4jM = parcelRequire("bQ4jM");

var $h61zw = parcelRequire("h61zw");
const $d37ba043b695a86b$var$common = {
    black: '#000',
    white: '#fff'
};
var $d37ba043b695a86b$export$2e2bcd8739ae039 = $d37ba043b695a86b$var$common;


const $f6d26248a242c674$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $f6d26248a242c674$export$2e2bcd8739ae039 = $f6d26248a242c674$var$grey;


const $e9a31dd7cc73b986$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $e9a31dd7cc73b986$export$2e2bcd8739ae039 = $e9a31dd7cc73b986$var$purple;


const $54cad5d9f2acbb0d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $54cad5d9f2acbb0d$export$2e2bcd8739ae039 = $54cad5d9f2acbb0d$var$red;


const $228fc37206d3e0db$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $228fc37206d3e0db$export$2e2bcd8739ae039 = $228fc37206d3e0db$var$orange;


const $cc48e8508d197286$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $cc48e8508d197286$export$2e2bcd8739ae039 = $cc48e8508d197286$var$blue;


const $29fdcd59f703e693$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $29fdcd59f703e693$export$2e2bcd8739ae039 = $29fdcd59f703e693$var$lightBlue;


const $506551f203a25923$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $506551f203a25923$export$2e2bcd8739ae039 = $506551f203a25923$var$green;


function $5763e0c539a251df$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white,
            default: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $5763e0c539a251df$export$a43af521ac8c3202 = $5763e0c539a251df$var$getLight();
function $5763e0c539a251df$var$getDark() {
    return {
        text: {
            primary: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $5763e0c539a251df$export$55ce6f3a06c59543 = $5763e0c539a251df$var$getDark();
function $5763e0c539a251df$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $h61zw.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $h61zw.darken)(intent.main, tonalOffsetDark);
    }
}
function $5763e0c539a251df$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[200],
        light: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[50],
        dark: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[700],
        light: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[400],
        dark: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[800]
    };
}
function $5763e0c539a251df$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[200],
        light: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[50],
        dark: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[500],
        light: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[300],
        dark: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[700]
    };
}
function $5763e0c539a251df$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[500],
        light: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[300],
        dark: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[700],
        light: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[400],
        dark: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[800]
    };
}
function $5763e0c539a251df$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[400],
        light: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[300],
        dark: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[700],
        light: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[500],
        dark: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[900]
    };
}
function $5763e0c539a251df$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $506551f203a25923$export$2e2bcd8739ae039)[400],
        light: (0, $506551f203a25923$export$2e2bcd8739ae039)[300],
        dark: (0, $506551f203a25923$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $506551f203a25923$export$2e2bcd8739ae039)[800],
        light: (0, $506551f203a25923$export$2e2bcd8739ae039)[500],
        dark: (0, $506551f203a25923$export$2e2bcd8739ae039)[900]
    };
}
function $5763e0c539a251df$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[400],
        light: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[300],
        dark: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[500],
        dark: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[900]
    };
}
function $5763e0c539a251df$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $5763e0c539a251df$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5763e0c539a251df$var$getDefaultSecondary(mode);
    const error = palette.error || $5763e0c539a251df$var$getDefaultError(mode);
    const info = palette.info || $5763e0c539a251df$var$getDefaultInfo(mode);
    const success = palette.success || $5763e0c539a251df$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5763e0c539a251df$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $h61zw.getContrastRatio)(background, $5763e0c539a251df$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5763e0c539a251df$export$55ce6f3a06c59543.text.primary : $5763e0c539a251df$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $5763e0c539a251df$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $5763e0c539a251df$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $5763e0c539a251df$var$getLight();
    else if (mode === 'dark') modeHydrated = $5763e0c539a251df$var$getDark();
    const paletteOutput = (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))({
        // A collection of common colors.
        common: {
            ...(0, $d37ba043b695a86b$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $f6d26248a242c674$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}



var $4Z6Nd = parcelRequire("4Z6Nd");

var $bQ4jM = parcelRequire("bQ4jM");

var $2GcsG = parcelRequire("2GcsG");
var $fOmBr = parcelRequire("fOmBr");

var $8ZgMs = parcelRequire("8ZgMs");

var $fckAO = parcelRequire("fckAO");

var $l6FST = parcelRequire("l6FST");

var $h61zw = parcelRequire("h61zw");

var $4Z6Nd = parcelRequire("4Z6Nd");

var $bQ4jM = parcelRequire("bQ4jM");

var $l6FST = parcelRequire("l6FST");

var $1dhnG = parcelRequire("1dhnG");

function $359d1cd3c99dce0c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




var $bQ4jM = parcelRequire("bQ4jM");
function $807f5ad944800d5b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $807f5ad944800d5b$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $807f5ad944800d5b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $807f5ad944800d5b$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $807f5ad944800d5b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $807f5ad944800d5b$var$defaultFontFamily ? {
                letterSpacing: `${$807f5ad944800d5b$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $807f5ad944800d5b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $807f5ad944800d5b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $5e676e189e322653$var$shadowKeyUmbraOpacity = 0.2;
const $5e676e189e322653$var$shadowKeyPenumbraOpacity = 0.14;
const $5e676e189e322653$var$shadowAmbientShadowOpacity = 0.12;
function $5e676e189e322653$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$5e676e189e322653$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $5e676e189e322653$var$shadows = [
    'none',
    $5e676e189e322653$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $5e676e189e322653$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $5e676e189e322653$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $5e676e189e322653$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $5e676e189e322653$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $5e676e189e322653$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $5e676e189e322653$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $5e676e189e322653$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $5e676e189e322653$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $5e676e189e322653$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $5e676e189e322653$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $5e676e189e322653$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $5e676e189e322653$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $5e676e189e322653$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $5e676e189e322653$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $5e676e189e322653$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $5e676e189e322653$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $5e676e189e322653$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $5e676e189e322653$export$2e2bcd8739ae039 = $5e676e189e322653$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $b3dcd50dcf07bac9$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b3dcd50dcf07bac9$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3dcd50dcf07bac9$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b3dcd50dcf07bac9$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $b3dcd50dcf07bac9$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$b3dcd50dcf07bac9$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$b3dcd50dcf07bac9$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b3dcd50dcf07bac9$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b3dcd50dcf07bac9$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $b3dcd50dcf07bac9$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $6899f6a23f8dea0a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $6899f6a23f8dea0a$export$2e2bcd8739ae039 = $6899f6a23f8dea0a$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
var $bQ4jM = parcelRequire("bQ4jM");
function $158c2acb0a4a3031$var$isSerializable(val) {
    return (0, $bQ4jM.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $158c2acb0a4a3031$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$158c2acb0a4a3031$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $bQ4jM.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $ccb5a5a44382729b$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(20));
    const palette = (0, $5763e0c539a251df$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, (/*@__PURE__*/$parcel$interopDefault($1dhnG)))(options);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(systemTheme, {
        mixins: (0, $359d1cd3c99dce0c$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $5e676e189e322653$export$2e2bcd8739ae039).slice(),
        typography: (0, $807f5ad944800d5b$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $b3dcd50dcf07bac9$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $6899f6a23f8dea0a$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $l6FST.unstable_defaultSxConfig),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($l6FST)))({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $158c2acb0a4a3031$export$32c2afa5f91892aa); // for Pigment CSS integration
    return muiTheme;
}
var $ccb5a5a44382729b$export$2e2bcd8739ae039 = $ccb5a5a44382729b$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $399a169bab06dc0f$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $baf1ba368e53b158$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $399a169bab06dc0f$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $baf1ba368e53b158$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $baf1ba368e53b158$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $baf1ba368e53b158$var$defaultDarkOverlays : [];
}
function $baf1ba368e53b158$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $5763e0c539a251df$export$2e2bcd8739ae039)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$baf1ba368e53b158$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $baf1ba368e53b158$export$dd191566510330d3(palette.mode),
        ...rest
    };
}


function $367a4b35286320ec$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $eeb996f5fdb0285b$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $eeb996f5fdb0285b$export$2e2bcd8739ae039 = $eeb996f5fdb0285b$var$excludeVariablesFromRoot;


var $4027f8c8ae6e8b1d$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $eeb996f5fdb0285b$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };



function $a8fc49caae8a6210$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $a8fc49caae8a6210$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $a8fc49caae8a6210$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $h61zw.hslToRgb)(color);
}
function $a8fc49caae8a6210$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $h61zw.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $a8fc49caae8a6210$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $a8fc49caae8a6210$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $a8fc49caae8a6210$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $fOmBr.default)(cssVarPrefix);
function $a8fc49caae8a6210$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $baf1ba368e53b158$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ccb5a5a44382729b$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $baf1ba368e53b158$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $baf1ba368e53b158$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $a8fc49caae8a6210$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $367a4b35286320ec$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $a8fc49caae8a6210$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $a8fc49caae8a6210$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $a8fc49caae8a6210$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $a8fc49caae8a6210$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $fckAO.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $a8fc49caae8a6210$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $a8fc49caae8a6210$var$setColor(palette.common, 'background', '#fff');
            $a8fc49caae8a6210$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $a8fc49caae8a6210$var$setColor(palette.common, 'background', '#000');
            $a8fc49caae8a6210$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $a8fc49caae8a6210$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorColor', (0, $h61zw.private_safeDarken)(palette.error.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoColor', (0, $h61zw.private_safeDarken)(palette.info.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successColor', (0, $h61zw.private_safeDarken)(palette.success.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningColor', (0, $h61zw.private_safeDarken)(palette.warning.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.error.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.info.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.success.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorStandardBg', (0, $h61zw.private_safeLighten)(palette.error.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoStandardBg', (0, $h61zw.private_safeLighten)(palette.info.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successStandardBg', (0, $h61zw.private_safeLighten)(palette.success.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningStandardBg', (0, $h61zw.private_safeLighten)(palette.warning.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $a8fc49caae8a6210$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'primaryBg', (0, $h61zw.private_safeLighten)(palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $h61zw.private_safeLighten)(palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'errorBg', (0, $h61zw.private_safeLighten)(palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'infoBg', (0, $h61zw.private_safeLighten)(palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'successBg', (0, $h61zw.private_safeLighten)(palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'warningBg', (0, $h61zw.private_safeLighten)(palette.warning.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'primaryTrack', (0, $h61zw.private_safeLighten)(palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'secondaryTrack', (0, $h61zw.private_safeLighten)(palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'errorTrack', (0, $h61zw.private_safeLighten)(palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'infoTrack', (0, $h61zw.private_safeLighten)(palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'successTrack', (0, $h61zw.private_safeLighten)(palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'warningTrack', (0, $h61zw.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.8);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'color', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $a8fc49caae8a6210$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $a8fc49caae8a6210$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $h61zw.private_safeLighten)(palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $h61zw.private_safeLighten)(palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'errorDisabledColor', (0, $h61zw.private_safeLighten)(palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'infoDisabledColor', (0, $h61zw.private_safeLighten)(palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'successDisabledColor', (0, $h61zw.private_safeLighten)(palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'warningDisabledColor', (0, $h61zw.private_safeLighten)(palette.warning.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.TableCell, 'border', (0, $h61zw.private_safeLighten)((0, $h61zw.private_safeAlpha)(palette.divider, 1), 0.88));
            $a8fc49caae8a6210$var$setColor(palette.Tooltip, 'bg', (0, $h61zw.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorColor', (0, $h61zw.private_safeLighten)(palette.error.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoColor', (0, $h61zw.private_safeLighten)(palette.info.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successColor', (0, $h61zw.private_safeLighten)(palette.success.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningColor', (0, $h61zw.private_safeLighten)(palette.warning.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorStandardBg', (0, $h61zw.private_safeDarken)(palette.error.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoStandardBg', (0, $h61zw.private_safeDarken)(palette.info.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successStandardBg', (0, $h61zw.private_safeDarken)(palette.success.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningStandardBg', (0, $h61zw.private_safeDarken)(palette.warning.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $a8fc49caae8a6210$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'primaryBg', (0, $h61zw.private_safeDarken)(palette.primary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $h61zw.private_safeDarken)(palette.secondary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'errorBg', (0, $h61zw.private_safeDarken)(palette.error.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'infoBg', (0, $h61zw.private_safeDarken)(palette.info.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'successBg', (0, $h61zw.private_safeDarken)(palette.success.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'warningBg', (0, $h61zw.private_safeDarken)(palette.warning.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'primaryTrack', (0, $h61zw.private_safeDarken)(palette.primary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'secondaryTrack', (0, $h61zw.private_safeDarken)(palette.secondary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'errorTrack', (0, $h61zw.private_safeDarken)(palette.error.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'infoTrack', (0, $h61zw.private_safeDarken)(palette.info.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'successTrack', (0, $h61zw.private_safeDarken)(palette.success.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'warningTrack', (0, $h61zw.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.98);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'color', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $a8fc49caae8a6210$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $a8fc49caae8a6210$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $h61zw.private_safeDarken)(palette.primary.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $h61zw.private_safeDarken)(palette.secondary.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'errorDisabledColor', (0, $h61zw.private_safeDarken)(palette.error.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'infoDisabledColor', (0, $h61zw.private_safeDarken)(palette.info.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'successDisabledColor', (0, $h61zw.private_safeDarken)(palette.success.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'warningDisabledColor', (0, $h61zw.private_safeDarken)(palette.warning.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.TableCell, 'border', (0, $h61zw.private_safeDarken)((0, $h61zw.private_safeAlpha)(palette.divider, 1), 0.68));
            $a8fc49caae8a6210$var$setColor(palette.Tooltip, 'bg', (0, $h61zw.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $a8fc49caae8a6210$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $a8fc49caae8a6210$var$setColorChannel(palette.background, 'paper');
        $a8fc49caae8a6210$var$setColorChannel(palette.common, 'background');
        $a8fc49caae8a6210$var$setColorChannel(palette.common, 'onBackground');
        $a8fc49caae8a6210$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $a8fc49caae8a6210$var$setColor(palette[color], 'mainChannel', (0, $h61zw.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.main)));
                if (colors.light) $a8fc49caae8a6210$var$setColor(palette[color], 'lightChannel', (0, $h61zw.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.light)));
                if (colors.dark) $a8fc49caae8a6210$var$setColor(palette[color], 'darkChannel', (0, $h61zw.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.dark)));
                if (colors.contrastText) $a8fc49caae8a6210$var$setColor(palette[color], 'contrastTextChannel', (0, $h61zw.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $a8fc49caae8a6210$var$setColorChannel(palette[color], 'primary');
                    $a8fc49caae8a6210$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $a8fc49caae8a6210$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $a8fc49caae8a6210$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $4027f8c8ae6e8b1d$export$2e2bcd8739ae039)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $fckAO.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $2GcsG.default)(input.spacing, (0, $8ZgMs.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $fckAO.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $l6FST.unstable_defaultSxConfig),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($l6FST)))({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $158c2acb0a4a3031$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $1c8355eadf532640$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $5763e0c539a251df$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $1c8355eadf532640$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $ccb5a5a44382729b$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $ccb5a5a44382729b$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $1c8355eadf532640$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $1c8355eadf532640$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $a8fc49caae8a6210$export$2e2bcd8739ae039)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $a477e5500cafdc51$var$defaultTheme = (0, $1c8355eadf532640$export$2e2bcd8739ae039)();
var $a477e5500cafdc51$export$2e2bcd8739ae039 = $a477e5500cafdc51$var$defaultTheme;


var $8b4c3f6e5c407120$export$2e2bcd8739ae039 = '$$material';


'use client';
function $81976569638fc3b7$export$2e2bcd8739ae039() {
    const theme = (0, $eM1DJ.default)((0, $a477e5500cafdc51$export$2e2bcd8739ae039));
    return theme[0, $8b4c3f6e5c407120$export$2e2bcd8739ae039] || theme;
}


parcelRequire("acw62");


var $92iK7 = parcelRequire("92iK7");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7daa246831c829f7$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), {
        ...props,
        defaultTheme: (0, $a477e5500cafdc51$export$2e2bcd8739ae039),
        themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039)
    });
}
var $7daa246831c829f7$export$2e2bcd8739ae039 = $7daa246831c829f7$var$GlobalStyles;



var $ayMG0 = parcelRequire("ayMG0");

var $jjlaj = parcelRequire("jjlaj");

var $bbeCr = parcelRequire("bbeCr");


// copied from @mui/system/createStyled
function $7109435727661db9$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $7109435727661db9$export$2e2bcd8739ae039 = $7109435727661db9$var$slotShouldForwardProp;


const $7f9f996b464e1691$var$rootShouldForwardProp = (prop)=>(0, $7109435727661db9$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $7f9f996b464e1691$export$2e2bcd8739ae039 = $7f9f996b464e1691$var$rootShouldForwardProp;



'use client';
const $13f99d5fb06222df$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($bbeCr)))({
    themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039),
    defaultTheme: $a477e5500cafdc51$export$2e2bcd8739ae039,
    rootShouldForwardProp: $7f9f996b464e1691$export$2e2bcd8739ae039
});
var $13f99d5fb06222df$export$2e2bcd8739ae039 = $13f99d5fb06222df$var$styled;


function $76e91e24afb64923$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)((0, $7daa246831c829f7$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $76e91e24afb64923$export$7e7f5719ff4debb1() {
    return 0, $l6FST.extendSxProp;
}


parcelRequire("acw62");


var $buuO7 = parcelRequire("buuO7");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $1bc4906ad0338fb8$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buuO7))), {
        ...props
    });
}
var $1bc4906ad0338fb8$export$2e2bcd8739ae039 = $1bc4906ad0338fb8$var$DefaultPropsProvider;
function $1bc4906ad0338fb8$export$2440da353cedad43(params) {
    return (0, $buuO7.useDefaultProps)(params);
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $888b8a9d3c5d3650$var$isDynamicSupport = typeof (0, $76e91e24afb64923$export$db53682eef82cc11)({}) === 'function';
const $888b8a9d3c5d3650$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $888b8a9d3c5d3650$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $888b8a9d3c5d3650$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $888b8a9d3c5d3650$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$888b8a9d3c5d3650$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $888b8a9d3c5d3650$var$SELECTOR = 'mui-ecs';
const $888b8a9d3c5d3650$var$staticStyles = (theme)=>{
    const result = $888b8a9d3c5d3650$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$888b8a9d3c5d3650$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$888b8a9d3c5d3650$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$888b8a9d3c5d3650$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $888b8a9d3c5d3650$var$GlobalStyles = (0, $76e91e24afb64923$export$db53682eef82cc11)($888b8a9d3c5d3650$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$888b8a9d3c5d3650$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$888b8a9d3c5d3650$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $888b8a9d3c5d3650$var$CssBaseline(inProps) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            $888b8a9d3c5d3650$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($888b8a9d3c5d3650$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$888b8a9d3c5d3650$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $888b8a9d3c5d3650$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $888b8a9d3c5d3650$export$2e2bcd8739ae039 = $888b8a9d3c5d3650$var$CssBaseline;


var $019ad789c5f8c324$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $019ad789c5f8c324$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $019ad789c5f8c324$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($019ad789c5f8c324$exports, "__esModule", {
    value: true
});
var $019ad789c5f8c324$var$_exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty($019ad789c5f8c324$exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $dueOl.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_identifier.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_ThemeProvider.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_adaptV4Theme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "alpha", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$58f0f39f63f3cf42;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createColorScheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createStyles.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "darken", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$4b073707ff63303;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$677b39864803984e;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "duration", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.duration;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "easing", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.easing;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "emphasize", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$e665714f76e581fd;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_experimental_extendTheme.default;
    }
});
$019ad789c5f8c324$exports.experimental_sx = $019ad789c5f8c324$var$experimental_sx;
Object.defineProperty($019ad789c5f8c324$exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createThemeWithVars.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$d061e26956a60b0a;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$c852d90bf7403b62;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_getOverlayAlpha.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$5a544e13ad4e1fa5;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$29fb7152bd3f781a;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "lighten", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$c0816ed86df316af;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_makeStyles.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMixins.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTypography.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_excludeVariablesFromRoot.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$211a73f2b8c10ce4;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_responsiveFontSizes.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return $7ebe803ced17df29$export$34d09c4a771c46ef;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "styled", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_styled.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $47898848065fef37$exports.unstable_createBreakpoints;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMuiStrictModeTheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return $18jQK.getUnit;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return $18jQK.toUnitless;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useTheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useThemeProps.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "withStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withStyles.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "withTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withTheme.default;
    }
});

var $019ad789c5f8c324$var$_formatMuiErrorMessage = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $019ad789c5f8c324$var$_identifier = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $019ad789c5f8c324$var$_adaptV4Theme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2baoW")));

var $4Z6Nd = parcelRequire("4Z6Nd");

var $3zA0b = parcelRequire("3zA0b");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7ebe803ced17df29$var$clampWrapper(value, min = 0, max = 1) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3zA0b)))(value, min, max);
}
function $7ebe803ced17df29$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7ebe803ced17df29$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $7ebe803ced17df29$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $7ebe803ced17df29$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $7ebe803ced17df29$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $7ebe803ced17df29$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $7ebe803ced17df29$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $7ebe803ced17df29$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $7ebe803ced17df29$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $7ebe803ced17df29$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$7ebe803ced17df29$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $7ebe803ced17df29$export$29fb7152bd3f781a(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $7ebe803ced17df29$export$c852d90bf7403b62(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $7ebe803ced17df29$export$d061e26956a60b0a(foreground, background) {
    const lumA = $7ebe803ced17df29$export$c852d90bf7403b62(foreground);
    const lumB = $7ebe803ced17df29$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    value = $7ebe803ced17df29$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $7ebe803ced17df29$export$c852d90bf7403b62(color) > 0.5 ? $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) : $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
}
function $7ebe803ced17df29$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7ebe803ced17df29$export$677b39864803984e(background);
    const overlayColor = $7ebe803ced17df29$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $jjlaj = parcelRequire("jjlaj");
var $dueOl = parcelRequire("dueOl");
var $47898848065fef37$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $47898848065fef37$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($47898848065fef37$exports, "__esModule", {
    value: true
});
Object.defineProperty($47898848065fef37$exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $47898848065fef37$var$_createBreakpoints.default;
    }
});

var $47898848065fef37$var$_createBreakpoints = $47898848065fef37$require$_interopRequireDefault((parcelRequire("hVW0x")));



var $019ad789c5f8c324$var$_createTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $019ad789c5f8c324$var$_createMuiStrictModeTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("5fr1m")));

var $019ad789c5f8c324$var$_createStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("22wy2")));

var $18jQK = parcelRequire("18jQK");

var $019ad789c5f8c324$var$_responsiveFontSizes = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eoBMT")));

var $019ad789c5f8c324$var$_createTransitions = $019ad789c5f8c324$require$_interopRequireWildcard((parcelRequire("bmoVh")));

var $019ad789c5f8c324$var$_createColorScheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2JzIB")));

var $019ad789c5f8c324$var$_useTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("14H9o")));

var $019ad789c5f8c324$var$_useThemeProps = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6g9fa")));

var $019ad789c5f8c324$var$_styled = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d8seH")));

var $019ad789c5f8c324$var$_ThemeProvider = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("gRp5N")));

var $019ad789c5f8c324$var$_makeStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kLL7M")));

var $019ad789c5f8c324$var$_withStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("7i0uy")));

var $019ad789c5f8c324$var$_withTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("lXubi")));

var $b0NgK = parcelRequire("b0NgK");
Object.keys($b0NgK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($019ad789c5f8c324$var$_exportNames, key)) return;
    if (key in $019ad789c5f8c324$exports && $019ad789c5f8c324$exports[key] === $b0NgK[key]) return;
    Object.defineProperty($019ad789c5f8c324$exports, key, {
        enumerable: true,
        get: function() {
            return $b0NgK[key];
        }
    });
});

var $019ad789c5f8c324$var$_createThemeWithVars = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $019ad789c5f8c324$var$_experimental_extendTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("dj1n2")));

var $019ad789c5f8c324$var$_getOverlayAlpha = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("35vyj")));

var $019ad789c5f8c324$var$_shouldSkipGeneratingVar = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $019ad789c5f8c324$var$_createTypography = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $019ad789c5f8c324$var$_createMixins = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6plKN")));

var $019ad789c5f8c324$var$_excludeVariablesFromRoot = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kKEhy")));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function $019ad789c5f8c324$var$experimental_sx() {
    throw new Error((0, $019ad789c5f8c324$var$_formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme



var $acw62 = parcelRequire("acw62");
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8TaLX = parcelRequire("8TaLX");

var $9dZwz = parcelRequire("9dZwz");
var $bQ4jM = parcelRequire("bQ4jM");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $bQ4jM.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



var $eM1DJ = parcelRequire("eM1DJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $47b3077c5e8d33a3$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $8TaLX.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $eM1DJ.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}




var $aYaRV = parcelRequire("aYaRV");



var $5nY49 = parcelRequire("5nY49");
const $ae8612b04aef23cf$var$boxClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiBox', [
    'root'
]);
var $ae8612b04aef23cf$export$2e2bcd8739ae039 = $ae8612b04aef23cf$var$boxClasses;


'use client';
const $ed0dc78f73685bb9$var$defaultTheme = (0, $1c8355eadf532640$export$2e2bcd8739ae039)();
const $ed0dc78f73685bb9$var$Box = (0, $47b3077c5e8d33a3$export$2e2bcd8739ae039)({
    themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039),
    defaultTheme: $ed0dc78f73685bb9$var$defaultTheme,
    defaultClassName: (0, $ae8612b04aef23cf$export$2e2bcd8739ae039).root,
    generateClassName: (0, (/*@__PURE__*/$parcel$interopDefault($aYaRV))).generate
});
var $ed0dc78f73685bb9$export$2e2bcd8739ae039 = $ed0dc78f73685bb9$var$Box;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $7T9kw = parcelRequire("7T9kw");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");

var $hwliF = parcelRequire("hwliF");
'use client';
var $51b2e046136200b6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($hwliF)));





var $jgzqq = parcelRequire("jgzqq");
const $fac58cb18f36893e$var$memoTheme = (0, $jgzqq.default);
var $fac58cb18f36893e$export$2e2bcd8739ae039 = $fac58cb18f36893e$var$memoTheme;




var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $3Hg1x = parcelRequire("3Hg1x");
var $95efffca1849a5b5$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $95efffca1849a5b5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($95efffca1849a5b5$exports, "__esModule", {
    value: true
});
Object.defineProperty($95efffca1849a5b5$exports, "default", {
    enumerable: true,
    get: function() {
        return $95efffca1849a5b5$var$_isFocusVisible.default;
    }
});

var $95efffca1849a5b5$var$_isFocusVisible = $95efffca1849a5b5$require$_interopRequireDefault((parcelRequire("clXxf")));





var $e4pKA = parcelRequire("e4pKA");
'use client';
var $0a9974d6176bfa01$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($e4pKA)));



var $6Lbjo = parcelRequire("6Lbjo");
'use client';
var $52726edc538865d0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($6Lbjo)));



var $acw62 = parcelRequire("acw62");
var $9c19c6af0ae205c1$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9c19c6af0ae205c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($9c19c6af0ae205c1$exports, "__esModule", {
    value: true
});
Object.defineProperty($9c19c6af0ae205c1$exports, "default", {
    enumerable: true,
    get: function() {
        return $9c19c6af0ae205c1$var$_useLazyRef.default;
    }
});

var $9c19c6af0ae205c1$var$_useLazyRef = $9c19c6af0ae205c1$require$_interopRequireDefault((parcelRequire("5vBDv")));


'use client';
class $ad3b5cbf2e7edbd2$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $ad3b5cbf2e7edbd2$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, (/*@__PURE__*/$parcel$interopDefault($9c19c6af0ae205c1$exports)))($ad3b5cbf2e7edbd2$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $ad3b5cbf2e7edbd2$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $ad3b5cbf2e7edbd2$export$2e2bcd8739ae039() {
    return $ad3b5cbf2e7edbd2$export$f5de0641c7db4154.use();
}
function $ad3b5cbf2e7edbd2$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $acw62 = parcelRequire("acw62");

function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $8nd05 = parcelRequire("8nd05");
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $9QePP = parcelRequire("9QePP");
var $9cac7318e3bb01ed$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $9cac7318e3bb01ed$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($9cac7318e3bb01ed$exports, "__esModule", {
    value: true
});
Object.defineProperty($9cac7318e3bb01ed$exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $9cac7318e3bb01ed$var$_useTimeout.Timeout;
    }
});
Object.defineProperty($9cac7318e3bb01ed$exports, "default", {
    enumerable: true,
    get: function() {
        return $9cac7318e3bb01ed$var$_useTimeout.default;
    }
});

var $9cac7318e3bb01ed$var$_useTimeout = $9cac7318e3bb01ed$require$_interopRequireWildcard((parcelRequire("lAE8L")));



var $jjlaj = parcelRequire("jjlaj");


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $171a3e689242bc25$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $171a3e689242bc25$export$2e2bcd8739ae039 = $171a3e689242bc25$var$Ripple;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $71da1f2c906d4bee$export$b464606f735ab902(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTouchRipple', slot);
}
const $71da1f2c906d4bee$var$touchRippleClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $71da1f2c906d4bee$export$2e2bcd8739ae039 = $71da1f2c906d4bee$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ed95ec2260a9d464$var$DURATION = 550;
const $ed95ec2260a9d464$export$95d0c9356b2231a3 = 80;
const $ed95ec2260a9d464$var$enterKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $ed95ec2260a9d464$var$exitKeyframe = (0, $jjlaj.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $ed95ec2260a9d464$var$pulsateKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $ed95ec2260a9d464$export$f6b7418508c72c25 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $ed95ec2260a9d464$export$676cfe7b12693c4b = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $171a3e689242bc25$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$ed95ec2260a9d464$var$enterKeyframe};
    animation-duration: ${$ed95ec2260a9d464$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$ed95ec2260a9d464$var$exitKeyframe};
    animation-duration: ${$ed95ec2260a9d464$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$ed95ec2260a9d464$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $ed95ec2260a9d464$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, (/*@__PURE__*/$parcel$interopDefault($9cac7318e3bb01ed$exports)))();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($ed95ec2260a9d464$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $ed95ec2260a9d464$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($ed95ec2260a9d464$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed95ec2260a9d464$export$f6b7418508c72c25, {
        className: (0, $9QePP.default)((0, $71da1f2c906d4bee$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $ed95ec2260a9d464$export$2e2bcd8739ae039 = $ed95ec2260a9d464$var$TouchRipple;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $fcd0c39d812092df$export$fccb0498dcd99783(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiButtonBase', slot);
}
const $fcd0c39d812092df$var$buttonBaseClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $fcd0c39d812092df$export$2e2bcd8739ae039 = $fcd0c39d812092df$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $21d0be68de155ec6$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $fcd0c39d812092df$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $21d0be68de155ec6$export$7ec0dcc5e3cdcd36 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $fcd0c39d812092df$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $21d0be68de155ec6$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $acw62.useRef(null);
    const ripple = (0, $ad3b5cbf2e7edbd2$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $21d0be68de155ec6$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $21d0be68de155ec6$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($95efffca1849a5b5$exports)))(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($95efffca1849a5b5$exports)))(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $21d0be68de155ec6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($21d0be68de155ec6$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed95ec2260a9d464$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $21d0be68de155ec6$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $21d0be68de155ec6$export$2e2bcd8739ae039 = $21d0be68de155ec6$var$ButtonBase;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $3Hg1x = parcelRequire("3Hg1x");

var $jjlaj = parcelRequire("jjlaj");



var $4O6za = parcelRequire("4O6za");
var $29da0f32997f4b8c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4O6za)));


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $9bc172c5d9139290$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $9bc172c5d9139290$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$9bc172c5d9139290$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $9bc172c5d9139290$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $9bc172c5d9139290$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $fd7829380e349eb6$export$29cad1383b3f235d(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiCircularProgress', slot);
}
const $fd7829380e349eb6$var$circularProgressClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $fd7829380e349eb6$export$2e2bcd8739ae039 = $fd7829380e349eb6$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $32db5964c492ae2d$var$SIZE = 44;
const $32db5964c492ae2d$var$circularRotateKeyframe = (0, $jjlaj.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $32db5964c492ae2d$var$circularDashKeyframe = (0, $jjlaj.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $32db5964c492ae2d$var$rotateAnimation = typeof $32db5964c492ae2d$var$circularRotateKeyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$32db5964c492ae2d$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $32db5964c492ae2d$var$dashAnimation = typeof $32db5964c492ae2d$var$circularDashKeyframe !== 'string' ? (0, $jjlaj.css)`
        animation: ${$32db5964c492ae2d$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $32db5964c492ae2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $fd7829380e349eb6$export$29cad1383b3f235d), classes);
};
const $32db5964c492ae2d$var$CircularProgressRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $32db5964c492ae2d$var$rotateAnimation || {
                    animation: `${$32db5964c492ae2d$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $32db5964c492ae2d$var$CircularProgressSVG = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $32db5964c492ae2d$var$CircularProgressCircle = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $32db5964c492ae2d$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$32db5964c492ae2d$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $32db5964c492ae2d$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $32db5964c492ae2d$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($32db5964c492ae2d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE} ${$32db5964c492ae2d$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $32db5964c492ae2d$var$SIZE,
                cy: $32db5964c492ae2d$var$SIZE,
                r: ($32db5964c492ae2d$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $32db5964c492ae2d$export$2e2bcd8739ae039 = $32db5964c492ae2d$var$CircularProgress;





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $1c400751848b9b57$export$5a6f9035944c8119(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiButton', slot);
}
const $1c400751848b9b57$var$buttonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $1c400751848b9b57$export$2e2bcd8739ae039 = $1c400751848b9b57$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $17e2bbdd939aa1be$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $17e2bbdd939aa1be$export$2e2bcd8739ae039 = $17e2bbdd939aa1be$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $c83825b43ed55336$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $c83825b43ed55336$export$2e2bcd8739ae039 = $c83825b43ed55336$var$ButtonGroupButtonContext;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $00a06c270f3ebd57$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $1c400751848b9b57$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $00a06c270f3ebd57$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $00a06c270f3ebd57$var$ButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $h61zw.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $00a06c270f3ebd57$var$ButtonStartIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$00a06c270f3ebd57$var$commonIconStyles
        ]
    }));
const $00a06c270f3ebd57$var$ButtonEndIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$00a06c270f3ebd57$var$commonIconStyles
        ]
    }));
const $00a06c270f3ebd57$var$ButtonLoadingIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $00a06c270f3ebd57$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $17e2bbdd939aa1be$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $c83825b43ed55336$export$2e2bcd8739ae039));
    const resolvedProps = (0, (/*@__PURE__*/$parcel$interopDefault($7T9kw)))(contextProps, inProps);
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $00a06c270f3ebd57$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($00a06c270f3ebd57$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $00a06c270f3ebd57$export$2e2bcd8739ae039 = $00a06c270f3ebd57$var$Button;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $beb6670688e6a4c6$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $beb6670688e6a4c6$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($beb6670688e6a4c6$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $beb6670688e6a4c6$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $beb6670688e6a4c6$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




var $5yr9V = parcelRequire("5yr9V");
var $a313fb4a2074834f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5yr9V)));



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $c51e307705f35677$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $c51e307705f35677$export$2e2bcd8739ae039 = $c51e307705f35677$var$FormControlContext;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $9e00b477c7793448$export$149c8b8bab2289d1(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiFormControl', slot);
}
const $9e00b477c7793448$var$formControlClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $9e00b477c7793448$export$2e2bcd8739ae039 = $9e00b477c7793448$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $88a0f3656f701f08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $9e00b477c7793448$export$149c8b8bab2289d1), classes);
};
const $88a0f3656f701f08$var$FormControlRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $88a0f3656f701f08$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $88a0f3656f701f08$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $beb6670688e6a4c6$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(child.props, true) || (0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $acw62.useRef(false);
    const onFilled = $acw62.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $acw62.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($88a0f3656f701f08$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $88a0f3656f701f08$export$2e2bcd8739ae039 = $88a0f3656f701f08$var$FormControl;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");






var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $6e9163c6dd169139$export$24c1f8f60cbac79e(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTypography', slot);
}
const $6e9163c6dd169139$var$typographyClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $6e9163c6dd169139$export$2e2bcd8739ae039 = $6e9163c6dd169139$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5ca16cb6e72a53f1$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $5ca16cb6e72a53f1$var$extendSxProp = (0, $76e91e24afb64923$export$7e7f5719ff4debb1)();
const $5ca16cb6e72a53f1$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $6e9163c6dd169139$export$24c1f8f60cbac79e), classes);
};
const $5ca16cb6e72a53f1$export$140e2f5526d3cad8 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $5ca16cb6e72a53f1$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $5ca16cb6e72a53f1$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$5ca16cb6e72a53f1$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $5ca16cb6e72a53f1$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $5ca16cb6e72a53f1$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $5ca16cb6e72a53f1$var$defaultVariantMapping[variant]) || 'span';
    const classes = $5ca16cb6e72a53f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5ca16cb6e72a53f1$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $5ca16cb6e72a53f1$export$2e2bcd8739ae039 = $5ca16cb6e72a53f1$var$Typography;




var $acw62 = parcelRequire("acw62");

'use client';
function $343072e2ec7ced8d$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $c51e307705f35677$export$2e2bcd8739ae039));
}






var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $df1adf37dbd0f6dd$export$4b135a4b3a6c4550(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiInputAdornment', slot);
}
const $df1adf37dbd0f6dd$var$inputAdornmentClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $df1adf37dbd0f6dd$export$2e2bcd8739ae039 = $df1adf37dbd0f6dd$var$inputAdornmentClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0ffab78552448ba6$var$_span;
const $0ffab78552448ba6$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $0ffab78552448ba6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $df1adf37dbd0f6dd$export$4b135a4b3a6c4550), classes);
};
const $0ffab78552448ba6$var$InputAdornmentRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $0ffab78552448ba6$var$overridesResolver
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $0ffab78552448ba6$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $0ffab78552448ba6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0ffab78552448ba6$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $0ffab78552448ba6$var$_span || ($0ffab78552448ba6$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $0ffab78552448ba6$export$2e2bcd8739ae039 = $0ffab78552448ba6$var$InputAdornment;


var $acw62 = parcelRequire("acw62");


var $3Hg1x = parcelRequire("3Hg1x");

var $9QePP = parcelRequire("9QePP");
function $23f47324c549140d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}




var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");








var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $f349e4b76c0b885d$export$f7d501e40371cd17(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiFormLabel', slot);
}
const $f349e4b76c0b885d$var$formLabelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $f349e4b76c0b885d$export$2e2bcd8739ae039 = $f349e4b76c0b885d$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db3da65b5688c8f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $f349e4b76c0b885d$export$f7d501e40371cd17), classes);
};
const $db3da65b5688c8f8$export$aa5bc7f8a4705b27 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $db3da65b5688c8f8$var$AsteriskComponent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $db3da65b5688c8f8$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $db3da65b5688c8f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($db3da65b5688c8f8$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($db3da65b5688c8f8$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $db3da65b5688c8f8$export$2e2bcd8739ae039 = $db3da65b5688c8f8$var$FormLabel;








var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $73574a1c301dedd6$export$c1c4b4545ad2ea5f(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiInputLabel', slot);
}
const $73574a1c301dedd6$var$inputLabelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $73574a1c301dedd6$export$2e2bcd8739ae039 = $73574a1c301dedd6$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $499ac2a9f7a67cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $73574a1c301dedd6$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $499ac2a9f7a67cb8$var$InputLabelRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $db3da65b5688c8f8$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $499ac2a9f7a67cb8$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $499ac2a9f7a67cb8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($499ac2a9f7a67cb8$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $499ac2a9f7a67cb8$export$2e2bcd8739ae039 = $499ac2a9f7a67cb8$var$InputLabel;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");





var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $ccdf08267bdb07b4$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $ccdf08267bdb07b4$export$2e2bcd8739ae039 = $ccdf08267bdb07b4$var$ListContext;




var $jdWO4 = parcelRequire("jdWO4");
'use client';
var $6d0031115bbee1bb$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jdWO4)));




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $0fc9796113f6362d$export$46f01d01378ec5a2(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDivider', slot);
}
const $0fc9796113f6362d$var$dividerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $0fc9796113f6362d$export$2e2bcd8739ae039 = $0fc9796113f6362d$var$dividerClasses;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $863c8b42c24a5d20$export$81478e24460c57f2(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiListItemIcon', slot);
}
const $863c8b42c24a5d20$var$listItemIconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $863c8b42c24a5d20$export$2e2bcd8739ae039 = $863c8b42c24a5d20$var$listItemIconClasses;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $8ffc2f5b8ea69aff$export$1061006a0db3aeb5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiListItemText', slot);
}
const $8ffc2f5b8ea69aff$var$listItemTextClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $8ffc2f5b8ea69aff$export$2e2bcd8739ae039 = $8ffc2f5b8ea69aff$var$listItemTextClasses;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $52ee1ef7b0f3c27a$export$515f8c67b5305377(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiMenuItem', slot);
}
const $52ee1ef7b0f3c27a$var$menuItemClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $52ee1ef7b0f3c27a$export$2e2bcd8739ae039 = $52ee1ef7b0f3c27a$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45389177b9c2b08c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $45389177b9c2b08c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $52ee1ef7b0f3c27a$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $45389177b9c2b08c$var$MenuItemRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $45389177b9c2b08c$export$4334bb34c76fef24
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $0fc9796113f6362d$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $0fc9796113f6362d$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $863c8b42c24a5d20$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $863c8b42c24a5d20$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $45389177b9c2b08c$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $45389177b9c2b08c$var$useUtilityClasses(props);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($45389177b9c2b08c$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $45389177b9c2b08c$export$2e2bcd8739ae039 = $45389177b9c2b08c$var$MenuItem;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $bQ4jM = parcelRequire("bQ4jM");

var $3Hg1x = parcelRequire("3Hg1x");
var $1e42b4067cc53dea$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1e42b4067cc53dea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1e42b4067cc53dea$exports, "__esModule", {
    value: true
});
Object.defineProperty($1e42b4067cc53dea$exports, "default", {
    enumerable: true,
    get: function() {
        return $1e42b4067cc53dea$var$_getReactElementRef.default;
    }
});

var $1e42b4067cc53dea$var$_getReactElementRef = $1e42b4067cc53dea$require$_interopRequireDefault((parcelRequire("4UzRg")));



var $4Z6Nd = parcelRequire("4Z6Nd");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $hwliF = parcelRequire("hwliF");


var $43fuO = parcelRequire("43fuO");
var $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($43fuO)));




var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");


var $9uEev = parcelRequire("9uEev");
var $5dc628ec8311fc9a$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5dc628ec8311fc9a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($5dc628ec8311fc9a$exports, "__esModule", {
    value: true
});
Object.defineProperty($5dc628ec8311fc9a$exports, "default", {
    enumerable: true,
    get: function() {
        return $5dc628ec8311fc9a$var$_useSlotProps.default;
    }
});

var $5dc628ec8311fc9a$var$_useSlotProps = $5dc628ec8311fc9a$require$_interopRequireDefault((parcelRequire("jjoya")));



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $2036eb6d4835ac15$export$c6bd6795ed6e3203(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiList', slot);
}
const $2036eb6d4835ac15$var$listClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $2036eb6d4835ac15$export$2e2bcd8739ae039 = $2036eb6d4835ac15$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d987fddc25cef197$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $2036eb6d4835ac15$export$c6bd6795ed6e3203), classes);
};
const $d987fddc25cef197$var$ListRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $d987fddc25cef197$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $d987fddc25cef197$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($d987fddc25cef197$var$ListRoot, {
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $d987fddc25cef197$export$2e2bcd8739ae039 = $d987fddc25cef197$var$List;


var $51c0e6a6ca0c4663$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c0e6a6ca0c4663$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($51c0e6a6ca0c4663$exports, "__esModule", {
    value: true
});
Object.defineProperty($51c0e6a6ca0c4663$exports, "default", {
    enumerable: true,
    get: function() {
        return $51c0e6a6ca0c4663$var$_getScrollbarSize.default;
    }
});

var $51c0e6a6ca0c4663$var$_getScrollbarSize = $51c0e6a6ca0c4663$require$_interopRequireDefault((parcelRequire("2Fa2r")));


var $6e949a478f594883$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($51c0e6a6ca0c4663$exports)));





var $4Rhws = parcelRequire("4Rhws");
var $85795f3c4e07aecf$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)));



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7c6e657321c9c45b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $7c6e657321c9c45b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $7c6e657321c9c45b$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $6e949a478f594883$export$2e2bcd8739ae039)((0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $7c6e657321c9c45b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $7c6e657321c9c45b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $7c6e657321c9c45b$export$2e2bcd8739ae039 = $7c6e657321c9c45b$var$MenuList;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");





/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $31c91637cf4b438e$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $31c91637cf4b438e$export$2e2bcd8739ae039 = $31c91637cf4b438e$var$isHostComponent;





var $9NXOO = parcelRequire("9NXOO");
var $83167607eb9ed060$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9NXOO)));





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



const $09228c405c75d141$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $09228c405c75d141$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $5a8449c70e836e71$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $5a8449c70e836e71$var$styles = {
    entering: {
        opacity: 1,
        transform: $5a8449c70e836e71$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $5a8449c70e836e71$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5a8449c70e836e71$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, (/*@__PURE__*/$parcel$interopDefault($9cac7318e3bb01ed$exports)))();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(nodeRef, (0, (/*@__PURE__*/$parcel$interopDefault($1e42b4067cc53dea$exports)))(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: $5a8449c70e836e71$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $5a8449c70e836e71$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $5a8449c70e836e71$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5a8449c70e836e71$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($5a8449c70e836e71$var$Grow) $5a8449c70e836e71$var$Grow.muiSupportAuto = true;
var $5a8449c70e836e71$export$2e2bcd8739ae039 = $5a8449c70e836e71$var$Grow;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $3Hg1x = parcelRequire("3Hg1x");

var $acw62 = parcelRequire("acw62");


var $e4pKA = parcelRequire("e4pKA");

var $43fuO = parcelRequire("43fuO");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $29292f9ac60f4a63$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $29292f9ac60f4a63$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $29292f9ac60f4a63$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $29292f9ac60f4a63$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $29292f9ac60f4a63$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $29292f9ac60f4a63$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($29292f9ac60f4a63$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $29292f9ac60f4a63$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$29292f9ac60f4a63$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $29292f9ac60f4a63$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $29292f9ac60f4a63$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $29292f9ac60f4a63$var$defaultGetTabbable, isEnabled: isEnabled = $29292f9ac60f4a63$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($e4pKA)))((0, (/*@__PURE__*/$parcel$interopDefault($1e42b4067cc53dea$exports)))(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, (/*@__PURE__*/$parcel$interopDefault($43fuO)))(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, (/*@__PURE__*/$parcel$interopDefault($43fuO)))(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $29292f9ac60f4a63$export$2e2bcd8739ae039 = $29292f9ac60f4a63$var$FocusTrap;



var $acw62 = parcelRequire("acw62");



var $jdWO4 = parcelRequire("jdWO4");

var $e4pKA = parcelRequire("e4pKA");

var $dGvj8 = parcelRequire("dGvj8");



'use client';
function $652518a1db38c266$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $652518a1db38c266$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($e4pKA)))(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($1e42b4067cc53dea$exports)))(children) : null, forwardedRef);
    (0, (/*@__PURE__*/$parcel$interopDefault($jdWO4)))(()=>{
        if (!disablePortal) setMountNode($652518a1db38c266$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jdWO4)))(()=>{
        if (mountNode && !disablePortal) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dGvj8)))(forwardedRef, mountNode);
            return ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($dGvj8)))(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode;
});
var $652518a1db38c266$export$2e2bcd8739ae039 = $652518a1db38c266$var$Portal;






var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");



var $e4pKA = parcelRequire("e4pKA");

var $fByHY = parcelRequire("fByHY");

var $jzekU = parcelRequire("jzekU");

var $dfy9C = parcelRequire("dfy9C");
'use client';
function $25e19e282016bf82$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, (/*@__PURE__*/$parcel$interopDefault($jzekU)))(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, (/*@__PURE__*/$parcel$interopDefault($dfy9C)))({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($e4pKA)))(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, (/*@__PURE__*/$parcel$interopDefault($fByHY)))(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b0a9dc0bcc2977a8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b0a9dc0bcc2977a8$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(nodeRef, (0, (/*@__PURE__*/$parcel$interopDefault($1e42b4067cc53dea$exports)))(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$b0a9dc0bcc2977a8$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $b0a9dc0bcc2977a8$export$2e2bcd8739ae039 = $b0a9dc0bcc2977a8$var$Fade;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $8aee358ee862b8d1$export$9927a91fd93152bd(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiBackdrop', slot);
}
const $8aee358ee862b8d1$var$backdropClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiBackdrop', [
    'root',
    'invisible'
]);
var $8aee358ee862b8d1$export$2e2bcd8739ae039 = $8aee358ee862b8d1$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $89da4f4236459888$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $8aee358ee862b8d1$export$9927a91fd93152bd), classes);
};
const $89da4f4236459888$var$BackdropRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $89da4f4236459888$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $89da4f4236459888$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $89da4f4236459888$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $89da4f4236459888$export$2e2bcd8739ae039 = $89da4f4236459888$var$Backdrop;



var $acw62 = parcelRequire("acw62");

var $43fuO = parcelRequire("43fuO");

var $e4pKA = parcelRequire("e4pKA");

var $6Lbjo = parcelRequire("6Lbjo");

var $7QInQ = parcelRequire("7QInQ");

var $bhYgh = parcelRequire("bhYgh");

var $4Rhws = parcelRequire("4Rhws");

var $43fuO = parcelRequire("43fuO");

// Is a vertical scrollbar displayed?
function $c082533c6a49e8e9$var$isOverflowing(container) {
    const doc = (0, (/*@__PURE__*/$parcel$interopDefault($43fuO)))(container);
    if (doc.body === container) return (0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)))(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $c082533c6a49e8e9$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $c082533c6a49e8e9$var$getPaddingRight(element) {
    return parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)))(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $c082533c6a49e8e9$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $c082533c6a49e8e9$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$c082533c6a49e8e9$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $c082533c6a49e8e9$export$e1bd0c6150f13d96(element, hide);
    });
}
function $c082533c6a49e8e9$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $c082533c6a49e8e9$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($c082533c6a49e8e9$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, (/*@__PURE__*/$parcel$interopDefault($51c0e6a6ca0c4663$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)))(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$c082533c6a49e8e9$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, (/*@__PURE__*/$parcel$interopDefault($43fuO)))(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$c082533c6a49e8e9$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, (/*@__PURE__*/$parcel$interopDefault($43fuO)))(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)))(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $c082533c6a49e8e9$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $c082533c6a49e8e9$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $c082533c6a49e8e9$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $c082533c6a49e8e9$var$getHiddenSiblings(container);
        $c082533c6a49e8e9$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $c082533c6a49e8e9$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $c082533c6a49e8e9$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $c082533c6a49e8e9$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $c082533c6a49e8e9$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $d27dad1a2ce77a45$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $d27dad1a2ce77a45$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $d27dad1a2ce77a45$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $d27dad1a2ce77a45$var$manager = new (0, $c082533c6a49e8e9$export$ce11c4ecd08cea67)();
function $d27dad1a2ce77a45$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($e4pKA)))(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $d27dad1a2ce77a45$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($43fuO)))(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $d27dad1a2ce77a45$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, (/*@__PURE__*/$parcel$interopDefault($6Lbjo)))(()=>{
        const resolvedContainer = $d27dad1a2ce77a45$var$getContainer(container) || getDoc().body;
        $d27dad1a2ce77a45$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$d27dad1a2ce77a45$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, (/*@__PURE__*/$parcel$interopDefault($6Lbjo)))((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $c082533c6a49e8e9$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        $d27dad1a2ce77a45$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($bhYgh)))(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($7QInQ)))(handleEnter, children?.props.onEnter ?? $d27dad1a2ce77a45$var$noop),
            onExited: (0, (/*@__PURE__*/$parcel$interopDefault($7QInQ)))(handleExited, children?.props.onExited ?? $d27dad1a2ce77a45$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $d27dad1a2ce77a45$export$2e2bcd8739ae039 = $d27dad1a2ce77a45$var$useModal;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $9e1e7c05d81416a0$export$67960e22b12a638d(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiModal', slot);
}
const $9e1e7c05d81416a0$var$modalClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $9e1e7c05d81416a0$export$2e2bcd8739ae039 = $9e1e7c05d81416a0$var$modalClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4e95d56438178f01$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $9e1e7c05d81416a0$export$67960e22b12a638d), classes);
};
const $4e95d56438178f01$var$ModalRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $4e95d56438178f01$var$ModalBackdrop = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4e95d56438178f01$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4e95d56438178f01$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $d27dad1a2ce77a45$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $4e95d56438178f01$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $4e95d56438178f01$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $9QePP.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $652518a1db38c266$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29292f9ac60f4a63$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $4e95d56438178f01$export$2e2bcd8739ae039 = $4e95d56438178f01$var$Modal;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $5ce2784ff2666cf4$export$29cdb466b9b6f20b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiPaper', slot);
}
const $5ce2784ff2666cf4$var$paperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $5ce2784ff2666cf4$export$2e2bcd8739ae039 = $5ce2784ff2666cf4$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bca3355350079f94$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $5ce2784ff2666cf4$export$29cdb466b9b6f20b), classes);
};
const $bca3355350079f94$var$PaperRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $bca3355350079f94$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $bca3355350079f94$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bca3355350079f94$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $h61zw.alpha)('#fff', (0, $399a169bab06dc0f$export$2e2bcd8739ae039)(elevation))}, ${(0, $h61zw.alpha)('#fff', (0, $399a169bab06dc0f$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $bca3355350079f94$export$2e2bcd8739ae039 = $bca3355350079f94$var$Paper;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $d57438dc3523b8a0$export$88f455dd56c95edb(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiPopover', slot);
}
const $d57438dc3523b8a0$var$popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiPopover', [
    'root',
    'paper'
]);
var $d57438dc3523b8a0$export$2e2bcd8739ae039 = $d57438dc3523b8a0$var$popoverClasses;




var $9QePP = parcelRequire("9QePP");
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $b748e9827e4898eb$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $b748e9827e4898eb$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($b748e9827e4898eb$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $9QePP.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $9QePP.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0420c70951dd1796$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $0420c70951dd1796$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $0420c70951dd1796$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $0420c70951dd1796$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $0420c70951dd1796$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $d57438dc3523b8a0$export$88f455dd56c95edb), classes);
};
const $0420c70951dd1796$export$bcce13685275fc99 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $0420c70951dd1796$export$821346c38a2d9390 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0420c70951dd1796$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $acw62.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $0420c70951dd1796$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $0420c70951dd1796$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $0420c70951dd1796$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $0420c70951dd1796$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $0420c70951dd1796$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $0420c70951dd1796$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $5a8449c70e836e71$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $0420c70951dd1796$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $b748e9827e4898eb$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $0420c70951dd1796$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $31c91637cf4b438e$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $0420c70951dd1796$export$2e2bcd8739ae039 = $0420c70951dd1796$var$Popover;






var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $ef00757e7f408a3f$export$2cf86a63a84fe23d(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiMenu', slot);
}
const $ef00757e7f408a3f$var$menuClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $ef00757e7f408a3f$export$2e2bcd8739ae039 = $ef00757e7f408a3f$var$menuClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $81db31f1007c14e1$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $81db31f1007c14e1$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $81db31f1007c14e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $ef00757e7f408a3f$export$2cf86a63a84fe23d), classes);
};
const $81db31f1007c14e1$var$MenuRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $0420c70951dd1796$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $81db31f1007c14e1$export$4f7c51a5920c9f33 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $0420c70951dd1796$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $81db31f1007c14e1$var$MenuMenuList = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $7c6e657321c9c45b$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $81db31f1007c14e1$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $81db31f1007c14e1$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, (/*@__PURE__*/$parcel$interopDefault($5dc628ec8311fc9a$exports)))({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $81db31f1007c14e1$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('list', {
        className: (0, $9QePP.default)(classes.list, MenuListProps.className),
        elementType: $81db31f1007c14e1$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81db31f1007c14e1$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $81db31f1007c14e1$var$RTL_ORIGIN : $81db31f1007c14e1$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $81db31f1007c14e1$export$2e2bcd8739ae039 = $81db31f1007c14e1$var$Menu;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $3Hg1x = parcelRequire("3Hg1x");


var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $d0b029d306802dc1$export$1ee13051fd9e2ab5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiNativeSelect', slot);
}
const $d0b029d306802dc1$var$nativeSelectClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $d0b029d306802dc1$export$2e2bcd8739ae039 = $d0b029d306802dc1$var$nativeSelectClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5218b8cdffce5874$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $d0b029d306802dc1$export$1ee13051fd9e2ab5), classes);
};
const $5218b8cdffce5874$export$50b3545a8ccd87af = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('select')(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $5218b8cdffce5874$var$NativeSelectSelect = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)($5218b8cdffce5874$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $5218b8cdffce5874$export$7dd4d92f143902e3 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('svg')(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $5218b8cdffce5874$var$NativeSelectIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)($5218b8cdffce5874$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $5218b8cdffce5874$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $5218b8cdffce5874$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5218b8cdffce5874$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5218b8cdffce5874$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $5218b8cdffce5874$export$2e2bcd8739ae039 = $5218b8cdffce5874$var$NativeSelectInput;







var $iSpB2 = parcelRequire("iSpB2");
'use client';
var $3c946fbcfb716a43$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($iSpB2)));



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $384af05952ac69db$export$2c0c1ee5a3392e(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiSelect', slot);
}
const $384af05952ac69db$var$selectClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $384af05952ac69db$export$2e2bcd8739ae039 = $384af05952ac69db$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0dd118e425182cac$var$_span;
const $0dd118e425182cac$var$SelectSelect = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5218b8cdffce5874$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $0dd118e425182cac$var$SelectIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5218b8cdffce5874$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $0dd118e425182cac$var$SelectNativeInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $7109435727661db9$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $0dd118e425182cac$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $0dd118e425182cac$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $0dd118e425182cac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $384af05952ac69db$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $0dd118e425182cac$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(2));
            selected = value.some((v)=>$0dd118e425182cac$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0dd118e425182cac$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $0dd118e425182cac$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, (/*@__PURE__*/$parcel$interopDefault($hwliF)))();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $0dd118e425182cac$var$isEmpty(display) ? $0dd118e425182cac$var$_span || ($0dd118e425182cac$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81db31f1007c14e1$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $0dd118e425182cac$export$2e2bcd8739ae039 = $0dd118e425182cac$var$SelectInput;




parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $4ec9549e6ca0a145$export$c7c50641356bdfa5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiSvgIcon', slot);
}
const $4ec9549e6ca0a145$var$svgIconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $4ec9549e6ca0a145$export$2e2bcd8739ae039 = $4ec9549e6ca0a145$var$svgIconClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $221b46e996ce82df$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $4ec9549e6ca0a145$export$c7c50641356bdfa5), classes);
};
const $221b46e996ce82df$var$SvgIconRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $221b46e996ce82df$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $221b46e996ce82df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($221b46e996ce82df$var$SvgIconRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$221b46e996ce82df$var$SvgIcon.muiName = 'SvgIcon';
var $221b46e996ce82df$export$2e2bcd8739ae039 = $221b46e996ce82df$var$SvgIcon;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2f130330883526cb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $221b46e996ce82df$export$2e2bcd8739ae039), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $221b46e996ce82df$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $ade182381ccbdcec$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $acw62 = parcelRequire("acw62");


var $3Hg1x = parcelRequire("3Hg1x");

var $bQ4jM = parcelRequire("bQ4jM");


var $4Z6Nd = parcelRequire("4Z6Nd");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $3Hg1x = parcelRequire("3Hg1x");

var $acw62 = parcelRequire("acw62");


var $9NXOO = parcelRequire("9NXOO");

var $e4pKA = parcelRequire("e4pKA");

var $jdWO4 = parcelRequire("jdWO4");

var $6Lbjo = parcelRequire("6Lbjo");

var $4Rhws = parcelRequire("4Rhws");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2bf53bc833721b52$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $2bf53bc833721b52$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $2bf53bc833721b52$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $2bf53bc833721b52$var$isEmpty(obj) {
    return $2bf53bc833721b52$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $2bf53bc833721b52$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, (/*@__PURE__*/$parcel$interopDefault($e4pKA)))(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)))(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $2bf53bc833721b52$var$getStyleValue(computedStyle.paddingBottom) + $2bf53bc833721b52$var$getStyleValue(computedStyle.paddingTop);
        const border = $2bf53bc833721b52$var$getStyleValue(computedStyle.borderBottomWidth) + $2bf53bc833721b52$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, (/*@__PURE__*/$parcel$interopDefault($6Lbjo)))(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $2bf53bc833721b52$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $2bf53bc833721b52$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, (/*@__PURE__*/$parcel$interopDefault($jdWO4)))(()=>{
        const debouncedHandleResize = (0, (/*@__PURE__*/$parcel$interopDefault($9NXOO)))(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, (/*@__PURE__*/$parcel$interopDefault($4Rhws)))(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($jdWO4)))(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$2bf53bc833721b52$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $2bf53bc833721b52$export$2e2bcd8739ae039 = $2bf53bc833721b52$var$TextareaAutosize;














var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $587a42eced554844$export$ef57d5c8ca2278f6(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiInputBase', slot);
}
const $587a42eced554844$var$inputBaseClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $587a42eced554844$export$2e2bcd8739ae039 = $587a42eced554844$var$inputBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $810f5d6293d4467f$var$_InputGlobalStyles;
const $810f5d6293d4467f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $810f5d6293d4467f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $810f5d6293d4467f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $587a42eced554844$export$ef57d5c8ca2278f6), classes);
};
const $810f5d6293d4467f$export$298a043133d72a38 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $810f5d6293d4467f$export$965edad20a84fa75
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $587a42eced554844$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $810f5d6293d4467f$export$ee10465db6ff6017 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $810f5d6293d4467f$export$cf507b112810e72d
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $587a42eced554844$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $587a42eced554844$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $810f5d6293d4467f$var$InputGlobalStyles = (0, $76e91e24afb64923$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $810f5d6293d4467f$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($4Z6Nd)))(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $2bf53bc833721b52$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $810f5d6293d4467f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $810f5d6293d4467f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $810f5d6293d4467f$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $810f5d6293d4467f$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($810f5d6293d4467f$var$_InputGlobalStyles || ($810f5d6293d4467f$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($810f5d6293d4467f$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $31c91637cf4b438e$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $31c91637cf4b438e$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $810f5d6293d4467f$export$2e2bcd8739ae039 = $810f5d6293d4467f$var$InputBase;








var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");

function $4e32f80fb9096d1f$export$cdb270390122322b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiInput', slot);
}
const $4e32f80fb9096d1f$var$inputClasses = {
    ...(0, $587a42eced554844$export$2e2bcd8739ae039),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $4e32f80fb9096d1f$export$2e2bcd8739ae039 = $4e32f80fb9096d1f$var$inputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3745a2c6ea1264ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $4e32f80fb9096d1f$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $3745a2c6ea1264ac$var$InputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $810f5d6293d4467f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).disabled}, .${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $3745a2c6ea1264ac$var$InputInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})({});
const $3745a2c6ea1264ac$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $3745a2c6ea1264ac$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $3745a2c6ea1264ac$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $3745a2c6ea1264ac$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$3745a2c6ea1264ac$var$Input.muiName = 'Input';
var $3745a2c6ea1264ac$export$2e2bcd8739ae039 = $3745a2c6ea1264ac$var$Input;




var $acw62 = parcelRequire("acw62");

var $bQ4jM = parcelRequire("bQ4jM");



var $3Hg1x = parcelRequire("3Hg1x");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");

function $5ba40350513245a8$export$3331e419f1a48437(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiFilledInput', slot);
}
const $5ba40350513245a8$var$filledInputClasses = {
    ...(0, $587a42eced554844$export$2e2bcd8739ae039),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $5ba40350513245a8$export$2e2bcd8739ae039 = $5ba40350513245a8$var$filledInputClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $215c05c02ba2f8f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $5ba40350513245a8$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $215c05c02ba2f8f4$var$FilledInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $810f5d6293d4467f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}, .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $215c05c02ba2f8f4$var$FilledInputInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $215c05c02ba2f8f4$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $215c05c02ba2f8f4$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $215c05c02ba2f8f4$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $215c05c02ba2f8f4$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$215c05c02ba2f8f4$var$FilledInput.muiName = 'Input';
var $215c05c02ba2f8f4$export$2e2bcd8739ae039 = $215c05c02ba2f8f4$var$FilledInput;



var $acw62 = parcelRequire("acw62");



var $3Hg1x = parcelRequire("3Hg1x");
parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $908e29d7221628c4$var$_span;
const $908e29d7221628c4$var$NotchedOutlineRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('fieldset', {
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $908e29d7221628c4$var$NotchedOutlineLegend = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('legend', {
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $908e29d7221628c4$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($908e29d7221628c4$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($908e29d7221628c4$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $908e29d7221628c4$var$_span || ($908e29d7221628c4$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}










var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");

function $64077992b1d8b572$export$89922944c7227687(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiOutlinedInput', slot);
}
const $64077992b1d8b572$var$outlinedInputClasses = {
    ...(0, $587a42eced554844$export$2e2bcd8739ae039),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $64077992b1d8b572$export$2e2bcd8739ae039 = $64077992b1d8b572$var$outlinedInputClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fe946640f9150f45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $64077992b1d8b572$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $fe946640f9150f45$var$OutlinedInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $810f5d6293d4467f$export$965edad20a84fa75)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).focused} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).focused} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).error} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).disabled} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $fe946640f9150f45$var$NotchedOutlineRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $908e29d7221628c4$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $fe946640f9150f45$var$OutlinedInputInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $fe946640f9150f45$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $fe946640f9150f45$var$useUtilityClasses(props);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $fe946640f9150f45$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $fe946640f9150f45$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $fe946640f9150f45$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$fe946640f9150f45$var$OutlinedInput.muiName = 'Input';
var $fe946640f9150f45$export$2e2bcd8739ae039 = $fe946640f9150f45$var$OutlinedInput;








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $13a94221f14f71e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $384af05952ac69db$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $13a94221f14f71e8$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) && prop !== 'variant'
};
const $13a94221f14f71e8$var$StyledInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3745a2c6ea1264ac$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$StyledOutlinedInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $fe946640f9150f45$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$StyledFilledInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $215c05c02ba2f8f4$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $ade182381ccbdcec$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $5218b8cdffce5874$export$2e2bcd8739ae039) : (0, $0dd118e425182cac$export$2e2bcd8739ae039);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $13a94221f14f71e8$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, (0, (/*@__PURE__*/$parcel$interopDefault($1e42b4067cc53dea$exports)))(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$13a94221f14f71e8$var$Select.muiName = 'Select';
var $13a94221f14f71e8$export$2e2bcd8739ae039 = $13a94221f14f71e8$var$Select;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $b390f03b616903a9$export$72aef224d6115253(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTab', slot);
}
const $b390f03b616903a9$var$tabClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $b390f03b616903a9$export$2e2bcd8739ae039 = $b390f03b616903a9$var$tabClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c1f657281bee3142$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $b390f03b616903a9$export$72aef224d6115253), classes);
};
const $c1f657281bee3142$var$TabRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: styles.icon
            }
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $c1f657281bee3142$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $c1f657281bee3142$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c1f657281bee3142$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $c1f657281bee3142$export$2e2bcd8739ae039 = $c1f657281bee3142$var$Tab;


var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $3Hg1x = parcelRequire("3Hg1x");

var $9uEev = parcelRequire("9uEev");





function $84c81c1996222460$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $84c81c1996222460$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $84c81c1996222460$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1dc918b66cbea078$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $1dc918b66cbea078$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $1dc918b66cbea078$var$styles,
        ...other,
        ref: nodeRef
    });
}



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $9uEev = parcelRequire("9uEev");

parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d997f00fcbb3883b$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d91db4839e2bc3bb$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');






var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $78e5777b5eeee81f$export$34861783d3c2eef8(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTabScrollButton', slot);
}
const $78e5777b5eeee81f$var$tabScrollButtonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $78e5777b5eeee81f$export$2e2bcd8739ae039 = $78e5777b5eeee81f$var$tabScrollButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dd89d34ceba12c96$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $78e5777b5eeee81f$export$34861783d3c2eef8), classes);
};
const $dd89d34ceba12c96$var$TabScrollButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $78e5777b5eeee81f$export$2e2bcd8739ae039).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $dd89d34ceba12c96$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $dd89d34ceba12c96$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $d997f00fcbb3883b$export$2e2bcd8739ae039);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $d91db4839e2bc3bb$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5dc628ec8311fc9a$exports)))({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5dc628ec8311fc9a$exports)))({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($dd89d34ceba12c96$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $dd89d34ceba12c96$export$2e2bcd8739ae039 = $dd89d34ceba12c96$var$TabScrollButton;




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $499ba0703d8ef45f$export$cdd93bd054dec359(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTabs', slot);
}
const $499ba0703d8ef45f$var$tabsClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $499ba0703d8ef45f$export$2e2bcd8739ae039 = $499ba0703d8ef45f$var$tabsClasses;






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ade8931e75b51e59$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $ade8931e75b51e59$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $ade8931e75b51e59$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $ade8931e75b51e59$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $499ba0703d8ef45f$export$cdd93bd054dec359), classes);
};
const $ade8931e75b51e59$var$TabsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $499ba0703d8ef45f$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $499ba0703d8ef45f$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $499ba0703d8ef45f$export$2e2bcd8739ae039).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $ade8931e75b51e59$var$TabsScroller = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $ade8931e75b51e59$var$List = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $ade8931e75b51e59$var$TabsIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $ade8931e75b51e59$var$TabsScrollbarSize = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $1dc918b66cbea078$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $ade8931e75b51e59$var$defaultIndicatorStyle = {};
let $ade8931e75b51e59$var$warnedOnceTabPresent = false;
const $ade8931e75b51e59$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = (0, $9uEev.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $ade8931e75b51e59$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5dc628ec8311fc9a$exports)))({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5dc628ec8311fc9a$exports)))({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($ade8931e75b51e59$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $52726edc538865d0$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $84c81c1996222460$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('scrollbar', {
        className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $ade8931e75b51e59$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('scrollButtons', {
        className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $dd89d34ceba12c96$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $52726edc538865d0$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $52726edc538865d0$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($ade8931e75b51e59$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('indicator', {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $ade8931e75b51e59$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, currentFocus, $ade8931e75b51e59$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, currentFocus, $ade8931e75b51e59$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, null, $ade8931e75b51e59$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, null, $ade8931e75b51e59$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $ade8931e75b51e59$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $ade8931e75b51e59$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('list', {
        ref: tabListRef,
        className: (0, $9QePP.default)(classes.list, classes.flexContainer),
        elementType: $ade8931e75b51e59$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $ade8931e75b51e59$export$2e2bcd8739ae039 = $ade8931e75b51e59$var$Tabs;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $hwliF = parcelRequire("hwliF");









var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $bdd2baf6568f6f86$export$a394fa61b1d583a9(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiFormHelperText', slot);
}
const $bdd2baf6568f6f86$var$formHelperTextClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $bdd2baf6568f6f86$export$2e2bcd8739ae039 = $bdd2baf6568f6f86$var$formHelperTextClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $937760e70ffc7914$var$_span;
const $937760e70ffc7914$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $bdd2baf6568f6f86$export$a394fa61b1d583a9), classes);
};
const $937760e70ffc7914$var$FormHelperTextRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $bdd2baf6568f6f86$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $bdd2baf6568f6f86$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $937760e70ffc7914$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $937760e70ffc7914$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($937760e70ffc7914$var$FormHelperTextRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $937760e70ffc7914$var$_span || ($937760e70ffc7914$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $937760e70ffc7914$export$2e2bcd8739ae039 = $937760e70ffc7914$var$FormHelperText;




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $e71b8b43f7b2f425$export$c1bdcbaf0596aeda(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTextField', slot);
}
const $e71b8b43f7b2f425$var$textFieldClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTextField', [
    'root'
]);
var $e71b8b43f7b2f425$export$2e2bcd8739ae039 = $e71b8b43f7b2f425$var$textFieldClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f480fb6201951027$var$variantComponent = {
    standard: (0, $3745a2c6ea1264ac$export$2e2bcd8739ae039),
    filled: (0, $215c05c02ba2f8f4$export$2e2bcd8739ae039),
    outlined: (0, $fe946640f9150f45$export$2e2bcd8739ae039)
};
const $f480fb6201951027$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $e71b8b43f7b2f425$export$c1bdcbaf0596aeda), classes);
};
const $f480fb6201951027$var$TextFieldRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $f480fb6201951027$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $f480fb6201951027$var$useUtilityClasses(ownerState);
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($hwliF)))(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $f480fb6201951027$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $f480fb6201951027$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $937760e70ffc7914$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('select', {
        elementType: (0, $13a94221f14f71e8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $f480fb6201951027$export$2e2bcd8739ae039 = $f480fb6201951027$var$TextField;



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $hwliF = parcelRequire("hwliF");





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $849b663ea7e799fa$export$2177af0aa15c34c2(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDialog', slot);
}
const $849b663ea7e799fa$var$dialogClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $849b663ea7e799fa$export$2e2bcd8739ae039 = $849b663ea7e799fa$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
'use client';
const $fde71ca8ed33ed16$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $fde71ca8ed33ed16$export$2e2bcd8739ae039 = $fde71ca8ed33ed16$var$DialogContext;








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $37762b86c13fe370$var$DialogBackdrop = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $37762b86c13fe370$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $849b663ea7e799fa$export$2177af0aa15c34c2), classes);
};
const $37762b86c13fe370$var$DialogRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $37762b86c13fe370$var$DialogContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $37762b86c13fe370$var$DialogPaper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $37762b86c13fe370$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $bca3355350079f94$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $37762b86c13fe370$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, (/*@__PURE__*/$parcel$interopDefault($hwliF)))(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $37762b86c13fe370$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('backdrop', {
        elementType: $37762b86c13fe370$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        elementType: $37762b86c13fe370$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('container', {
        elementType: $37762b86c13fe370$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fde71ca8ed33ed16$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $37762b86c13fe370$export$2e2bcd8739ae039 = $37762b86c13fe370$var$Dialog;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $26cda4b569d13e19$export$5e57a444791c63be(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDialogActions', slot);
}
const $26cda4b569d13e19$var$dialogActionsClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDialogActions', [
    'root',
    'spacing'
]);
var $26cda4b569d13e19$export$2e2bcd8739ae039 = $26cda4b569d13e19$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ce32ef3e14a19991$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $26cda4b569d13e19$export$5e57a444791c63be), classes);
};
const $ce32ef3e14a19991$var$DialogActionsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $ce32ef3e14a19991$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $ce32ef3e14a19991$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ce32ef3e14a19991$var$DialogActionsRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $ce32ef3e14a19991$export$2e2bcd8739ae039 = $ce32ef3e14a19991$var$DialogActions;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $ad2dd284aafca16e$export$61b0ee1f05fb344e(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDialogContent', slot);
}
const $ad2dd284aafca16e$var$dialogContentClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDialogContent', [
    'root',
    'dividers'
]);
var $ad2dd284aafca16e$export$2e2bcd8739ae039 = $ad2dd284aafca16e$var$dialogContentClasses;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDialogTitle', slot);
}
const $d28a3cfcf0fa99af$var$dialogTitleClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDialogTitle', [
    'root'
]);
var $d28a3cfcf0fa99af$export$2e2bcd8739ae039 = $d28a3cfcf0fa99af$var$dialogTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $17fd443c9302d537$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $ad2dd284aafca16e$export$61b0ee1f05fb344e), classes);
};
const $17fd443c9302d537$var$DialogContentRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $d28a3cfcf0fa99af$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $17fd443c9302d537$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $17fd443c9302d537$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($17fd443c9302d537$var$DialogContentRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $17fd443c9302d537$export$2e2bcd8739ae039 = $17fd443c9302d537$var$DialogContent;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $493ef287866e3611$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088), classes);
};
const $493ef287866e3611$var$DialogTitleRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $493ef287866e3611$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $493ef287866e3611$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $fde71ca8ed33ed16$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($493ef287866e3611$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $493ef287866e3611$export$2e2bcd8739ae039 = $493ef287866e3611$var$DialogTitle;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $bQ4jM = parcelRequire("bQ4jM");

var $b14cZ = parcelRequire("b14cZ");

var $3Hg1x = parcelRequire("3Hg1x");

var $8TaLX = parcelRequire("8TaLX");

var $bQ4jM = parcelRequire("bQ4jM");

var $4O6za = parcelRequire("4O6za");

var $3cLs1 = parcelRequire("3cLs1");

var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");

var $aFFCY = parcelRequire("aFFCY");
const $9a7e913a82f46e5c$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $9a7e913a82f46e5c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $9a7e913a82f46e5c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $9a7e913a82f46e5c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $9a7e913a82f46e5c$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$9a7e913a82f46e5c$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $9a7e913a82f46e5c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $9a7e913a82f46e5c$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $9a7e913a82f46e5c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9a7e913a82f46e5c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $8TaLX.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $9dZwz.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9a7e913a82f46e5c$var$defaultOverridesResolver($9a7e913a82f46e5c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $9a7e913a82f46e5c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9a7e913a82f46e5c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $8TaLX.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $9a7e913a82f46e5c$var$processStyle(props, style);
            };
            if ((0, $bQ4jM.isPlainObject)(style)) {
                const serialized = (0, $aFFCY.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $9a7e913a82f46e5c$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $9a7e913a82f46e5c$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $9a7e913a82f46e5c$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $9dZwz.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $9a7e913a82f46e5c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, (/*@__PURE__*/$parcel$interopDefault($4O6za)))(componentSlot || '')}`;
    return `Styled(${(0, (/*@__PURE__*/$parcel$interopDefault($3cLs1)))(tag)})`;
}
function $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $9a7e913a82f46e5c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9a7e913a82f46e5c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9a7e913a82f46e5c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}


const $9dc40fba00dc8e3b$var$styled = (0, $9a7e913a82f46e5c$export$2e2bcd8739ae039)();
var $9dc40fba00dc8e3b$export$2e2bcd8739ae039 = $9dc40fba00dc8e3b$var$styled;



var $7T9kw = parcelRequire("7T9kw");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7T9kw)))(theme.components[name].defaultProps, props);
}



var $eM1DJ = parcelRequire("eM1DJ");
'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $eM1DJ.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}




var $6o2lr = parcelRequire("6o2lr");

var $82aMg = parcelRequire("82aMg");

var $7kpn1 = parcelRequire("7kpn1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $82aMg.handleBreakpoints)({
            theme: theme
        }, (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $7kpn1.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $7kpn1.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $7kpn1.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, (/*@__PURE__*/$parcel$interopDefault($bQ4jM)))(styles, (0, $82aMg.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $82aMg.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (slot)=>(0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}




'use client';
const $045ee6ef181778c1$var$Stack = (0, $d70594339ba23534$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $1bc4906ad0338fb8$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $045ee6ef181778c1$export$2e2bcd8739ae039 = $045ee6ef181778c1$var$Stack;


const $0c4bba0f189150f2$var$AddEzvizCameraModal = ({ open: open, onClose: onClose, setNewCamera: setNewCamera })=>{
    const [accessToken, setAccessToken] = (0, $acw62.useState)('');
    const [deviceSerial, setDeviceSerial] = (0, $acw62.useState)('');
    const [code, setCode] = (0, $acw62.useState)('');
    const handleClose = ()=>{
        setAccessToken('');
        setDeviceSerial('');
        setCode('');
        onClose();
    };
    const handleSubmit = async ()=>{
        try {
            const params = new URLSearchParams({
                accessToken: accessToken,
                deviceSerial: deviceSerial,
                channelNo: '1',
                protocol: '2',
                code: code,
                expireTime: '62208000',
                type: '1',
                quality: '1'
            });
            const response = await fetch(`https://open.ezvizlife.com/api/lapp/live/address/get?${params.toString()}`, {
                method: 'POST'
            });
            const result = await response.json();
            if (result.code === '200' && result.data?.url) {
                setNewCamera((prev)=>({
                        ...prev,
                        stream_url: result.data.url
                    }));
                onClose();
            } else alert(`Error: ${result.msg || 'Failed to fetch camera URL'}`);
        } catch (err) {
            alert('Error: ' + err.message);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                children: "Link EZVIZ Camera"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $045ee6ef181778c1$export$2e2bcd8739ae039), {
                    spacing: 2,
                    mt: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Access Token",
                            fullWidth: true,
                            value: accessToken,
                            onChange: (e)=>setAccessToken(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Device Serial",
                            fullWidth: true,
                            value: deviceSerial,
                            onChange: (e)=>setDeviceSerial(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Code",
                            fullWidth: true,
                            value: code,
                            onChange: (e)=>setCode(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "contained",
                        onClick: handleSubmit,
                        children: "Link Camera"
                    })
                ]
            })
        ]
    });
};
var $0c4bba0f189150f2$export$2e2bcd8739ae039 = $0c4bba0f189150f2$var$AddEzvizCameraModal;



const $b1b44af3c77a62f9$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $103cafb5d5f4c571$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $103cafb5d5f4c571$export$14f2b6540d498ce extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $103cafb5d5f4c571$export$d08a45df86040161 extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $103cafb5d5f4c571$export$761f8c0e0fa4624f extends $103cafb5d5f4c571$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $103cafb5d5f4c571$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($103cafb5d5f4c571$export$9b19f1a5abf91e06 || ($103cafb5d5f4c571$export$9b19f1a5abf91e06 = {}));


var $6f9d627d4ebb0255$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $6f9d627d4ebb0255$export$1d0b400bf8a0fa55 {
    constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $103cafb5d5f4c571$export$9b19f1a5abf91e06).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $b1b44af3c77a62f9$export$98d92b1aa79f8cc7)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $6f9d627d4ebb0255$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $103cafb5d5f4c571$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $103cafb5d5f4c571$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $103cafb5d5f4c571$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
}


var $02d76e8b98cdd913$exports = {};
"use strict";
var $02d76e8b98cdd913$var$__importDefault = $02d76e8b98cdd913$exports && $02d76e8b98cdd913$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($02d76e8b98cdd913$exports, "__esModule", {
    value: true
});
$02d76e8b98cdd913$exports.PostgrestError = $02d76e8b98cdd913$exports.PostgrestBuilder = $02d76e8b98cdd913$exports.PostgrestTransformBuilder = $02d76e8b98cdd913$exports.PostgrestFilterBuilder = $02d76e8b98cdd913$exports.PostgrestQueryBuilder = $02d76e8b98cdd913$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
const $02d76e8b98cdd913$var$PostgrestClient_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("jreHA")));
$02d76e8b98cdd913$exports.PostgrestClient = $02d76e8b98cdd913$var$PostgrestClient_1.default;

const $02d76e8b98cdd913$var$PostgrestQueryBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("dBXeq")));
$02d76e8b98cdd913$exports.PostgrestQueryBuilder = $02d76e8b98cdd913$var$PostgrestQueryBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestFilterBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("dSHX3")));
$02d76e8b98cdd913$exports.PostgrestFilterBuilder = $02d76e8b98cdd913$var$PostgrestFilterBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestTransformBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("kkZ1b")));
$02d76e8b98cdd913$exports.PostgrestTransformBuilder = $02d76e8b98cdd913$var$PostgrestTransformBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestBuilder_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("9WNOL")));
$02d76e8b98cdd913$exports.PostgrestBuilder = $02d76e8b98cdd913$var$PostgrestBuilder_1.default;

const $02d76e8b98cdd913$var$PostgrestError_1 = $02d76e8b98cdd913$var$__importDefault((parcelRequire("iN95t")));
$02d76e8b98cdd913$exports.PostgrestError = $02d76e8b98cdd913$var$PostgrestError_1.default;
$02d76e8b98cdd913$exports.default = {
    PostgrestClient: $02d76e8b98cdd913$var$PostgrestClient_1.default,
    PostgrestQueryBuilder: $02d76e8b98cdd913$var$PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: $02d76e8b98cdd913$var$PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: $02d76e8b98cdd913$var$PostgrestTransformBuilder_1.default,
    PostgrestBuilder: $02d76e8b98cdd913$var$PostgrestBuilder_1.default,
    PostgrestError: $02d76e8b98cdd913$var$PostgrestError_1.default
};


const { PostgrestClient: $fa98774720195011$export$796f32e2ee984aaa, PostgrestQueryBuilder: $fa98774720195011$export$a81993b50ca081ad, PostgrestFilterBuilder: $fa98774720195011$export$3158317c13bdc93a, PostgrestTransformBuilder: $fa98774720195011$export$7b4361bb87e3030c, PostgrestBuilder: $fa98774720195011$export$3106e21688a06353, PostgrestError: $fa98774720195011$export$445b7e3a323f992f } = (0, (/*@__PURE__*/$parcel$interopDefault($02d76e8b98cdd913$exports)));
var // compatibility with CJS output
$fa98774720195011$export$2e2bcd8739ae039 = {
    PostgrestClient: $fa98774720195011$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $fa98774720195011$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $fa98774720195011$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $fa98774720195011$export$7b4361bb87e3030c,
    PostgrestBuilder: $fa98774720195011$export$3106e21688a06353,
    PostgrestError: $fa98774720195011$export$445b7e3a323f992f
};


// Node.js WebSocket entry point
let $b1520c36c4a743bc$var$WebSocketImpl;

if (typeof window === 'undefined') // Node.js environment
// eslint-disable-next-line @typescript-eslint/no-var-requires
$b1520c36c4a743bc$var$WebSocketImpl = (parcelRequire("fvaAM"));
else // Browser environment
$b1520c36c4a743bc$var$WebSocketImpl = window.WebSocket;
var $b1520c36c4a743bc$export$2e2bcd8739ae039 = $b1520c36c4a743bc$var$WebSocketImpl;


const $4cff20d240de2de4$export$83d89fbfd8236492 = '2.11.10';


const $3d531e63e1ea7f53$export$88a84136db6a4b64 = {
    'X-Client-Info': `realtime-js/${(0, $4cff20d240de2de4$export$83d89fbfd8236492)}`
};
const $3d531e63e1ea7f53$export$df3f558bb9a9c991 = '1.0.0';
const $3d531e63e1ea7f53$export$a4ad2735b021c132 = (0, $4cff20d240de2de4$export$83d89fbfd8236492);
const $3d531e63e1ea7f53$export$7bd623b29ec8e1eb = 10000;
const $3d531e63e1ea7f53$export$5e80cf62e56a877b = 1000;
var $3d531e63e1ea7f53$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($3d531e63e1ea7f53$export$a6d0320a1563d49e || ($3d531e63e1ea7f53$export$a6d0320a1563d49e = {}));
var $3d531e63e1ea7f53$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($3d531e63e1ea7f53$export$b83816118db74fe7 || ($3d531e63e1ea7f53$export$b83816118db74fe7 = {}));
var $3d531e63e1ea7f53$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($3d531e63e1ea7f53$export$8db7548e65d6ea55 || ($3d531e63e1ea7f53$export$8db7548e65d6ea55 = {}));
var $3d531e63e1ea7f53$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($3d531e63e1ea7f53$export$b2688bfb999f5751 || ($3d531e63e1ea7f53$export$b2688bfb999f5751 = {}));
var $3d531e63e1ea7f53$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($3d531e63e1ea7f53$export$deda39003d27273 || ($3d531e63e1ea7f53$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $6805f7080ae1d67f$export$2e2bcd8739ae039 {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $505c2b2d07197e20$export$2e2bcd8739ae039 {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $3f01feefa94fd48b$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($3f01feefa94fd48b$export$4d213a7d364021dc || ($3f01feefa94fd48b$export$4d213a7d364021dc = {}));
const $3f01feefa94fd48b$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $3f01feefa94fd48b$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $3f01feefa94fd48b$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $3f01feefa94fd48b$export$3df02a362b86a91(colType, value);
    return $3f01feefa94fd48b$var$noop(value);
};
const $3f01feefa94fd48b$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $3f01feefa94fd48b$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $3f01feefa94fd48b$export$4d213a7d364021dc.bool:
            return $3f01feefa94fd48b$export$3c2e6d1b7583eee6(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.float8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int2:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.numeric:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.oid:
            return $3f01feefa94fd48b$export$a0a81dc3380ce7d3(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.json:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.jsonb:
            return $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2(value);
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamp:
            return $3f01feefa94fd48b$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $3f01feefa94fd48b$export$4d213a7d364021dc.abstime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.date:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.daterange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int4range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.int8range:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.money:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.reltime:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.text:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.time:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timestamptz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.timetz:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tsrange:
        case $3f01feefa94fd48b$export$4d213a7d364021dc.tstzrange:
            return $3f01feefa94fd48b$var$noop(value);
        default:
            // Return the value for remaining types
            return $3f01feefa94fd48b$var$noop(value);
    }
};
const $3f01feefa94fd48b$var$noop = (value)=>{
    return value;
};
const $3f01feefa94fd48b$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $3f01feefa94fd48b$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $3f01feefa94fd48b$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $3f01feefa94fd48b$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$3f01feefa94fd48b$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $3f01feefa94fd48b$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $3f01feefa94fd48b$export$976fda7151b30cae = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};




class $9b541112b15eb31d$export$2e2bcd8739ae039 {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $3d531e63e1ea7f53$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $4c897aa496ab948f$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($4c897aa496ab948f$export$f1ce049df2794fb4 || ($4c897aa496ab948f$export$f1ce049df2794fb4 = {}));
class $4c897aa496ab948f$export$2e2bcd8739ae039 {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $4c897aa496ab948f$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}



var $0851918337283a61$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($0851918337283a61$export$bc171c571098b6c4 || ($0851918337283a61$export$bc171c571098b6c4 = {}));
var $0851918337283a61$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($0851918337283a61$export$9e3fe8e487ef792e || ($0851918337283a61$export$9e3fe8e487ef792e = {}));
var $0851918337283a61$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($0851918337283a61$export$a6885b926af646a2 || ($0851918337283a61$export$a6885b926af646a2 = {}));
const $0851918337283a61$export$154db638d9c0559e = (0, $3d531e63e1ea7f53$export$b83816118db74fe7);
class $0851918337283a61$export$2e2bcd8739ae039 {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $9b541112b15eb31d$export$2e2bcd8739ae039)(this, (0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $505c2b2d07197e20$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $4c897aa496ab948f$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $3f01feefa94fd48b$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($0851918337283a61$export$a6885b926af646a2.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes: postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
                            callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback($0851918337283a61$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).errored;
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($0851918337283a61$export$a6885b926af646a2.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event: event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).close, 'leave', this._joinRef());
        };
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $9b541112b15eb31d$export$2e2bcd8739ae039)(this, (0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /**
     * Teardown the channel.
     *
     * Destroys and stops related timers.
     */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.rejoinTimer && clearTimeout(this.rejoinTimer.timer);
        this.joinPush.destroy();
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $9b541112b15eb31d$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $3d531e63e1ea7f53$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $3d531e63e1ea7f53$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $0851918337283a61$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $3d531e63e1ea7f53$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $3f01feefa94fd48b$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $3f01feefa94fd48b$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
}


const $ae049384a7d1c7c8$var$noop = ()=>{};
const $ae049384a7d1c7c8$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;

class $ae049384a7d1c7c8$export$2e2bcd8739ae039 {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = new Array();
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $3d531e63e1ea7f53$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $3d531e63e1ea7f53$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 25000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.heartbeatCallback = $ae049384a7d1c7c8$var$noop;
        this.ref = 0;
        this.logger = $ae049384a7d1c7c8$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $6805f7080ae1d67f$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $3d531e63e1ea7f53$export$b2688bfb999f5751).websocket}`;
        this.httpEndpoint = (0, $3f01feefa94fd48b$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            this.params = Object.assign(Object.assign({}, this.params), {
                log_level: this.logLevel
            });
        }
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $505c2b2d07197e20$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (!this.transport) this.transport = (0, $b1520c36c4a743bc$export$2e2bcd8739ae039);
        if (this.transport) {
            // Detect if using the native browser WebSocket
            const isBrowser = typeof window !== 'undefined' && this.transport === window.WebSocket;
            if (isBrowser) this.conn = new this.transport(this.endpointURL());
            else this.conn = new this.transport(this.endpointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
            return;
        }
        this.conn = new $ae049384a7d1c7c8$var$WSWebSocketDummy(this.endpointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $3d531e63e1ea7f53$export$df3f558bb9a9c991)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
            this.channels.forEach((channel)=>channel.teardown());
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        this.channels = this.channels.filter((c)=>c._joinRef !== channel._joinRef);
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.channels = [];
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).connecting:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Connecting;
            case (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).open:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Open;
            case (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).closing:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Closing;
            default:
                return (0, $3d531e63e1ea7f53$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $3d531e63e1ea7f53$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $0851918337283a61$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                tokenToSend && channel.updateJoinPayload({
                    access_token: tokenToSend,
                    version: this.headers && this.headers['X-Client-Info']
                });
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) {
            this.heartbeatCallback('disconnected');
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            this.heartbeatCallback('timeout');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $3d531e63e1ea7f53$export$5e80cf62e56a877b), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.heartbeatCallback('sent');
        await this.setAuth();
    }
    onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (topic === 'phoenix' && event === 'phx_reply') this.heartbeatCallback(msg.payload.status == 'ok' ? 'ok' : 'error');
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            Array.from(this.channels).filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this.sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $3d531e63e1ea7f53$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $ae049384a7d1c7c8$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}
class $ae049384a7d1c7c8$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $3d531e63e1ea7f53$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $abe02471d8456f7f$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function $abe02471d8456f7f$export$5a322e77e5eb0561(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class $abe02471d8456f7f$export$ca9ecfd959b3871c extends $abe02471d8456f7f$export$697502632950e9d3 {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class $abe02471d8456f7f$export$29127ca2e1a271d extends $abe02471d8456f7f$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}



var $b8abd4fb4763e533$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $b8abd4fb4763e533$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $b8abd4fb4763e533$export$ace1d6afc438cf26 = ()=>$b8abd4fb4763e533$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield Promise.resolve((parcelRequire("979Ct")))).Response;
        return Response;
    });
const $b8abd4fb4763e533$export$69d519e35e6fc3d4 = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$b8abd4fb4763e533$export$69d519e35e6fc3d4(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = $b8abd4fb4763e533$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $2ad35efa1b333042$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2ad35efa1b333042$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $2ad35efa1b333042$var$handleError = (error, reject, options)=>$2ad35efa1b333042$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $b8abd4fb4763e533$export$ace1d6afc438cf26)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, $abe02471d8456f7f$export$ca9ecfd959b3871c)($2ad35efa1b333042$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $abe02471d8456f7f$export$29127ca2e1a271d)($2ad35efa1b333042$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $abe02471d8456f7f$export$29127ca2e1a271d)($2ad35efa1b333042$var$_getErrorMessage(error), error));
    });
const $2ad35efa1b333042$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $2ad35efa1b333042$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $2ad35efa1b333042$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$2ad35efa1b333042$var$handleError(error, reject, options));
        });
    });
}
function $2ad35efa1b333042$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function $2ad35efa1b333042$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function $2ad35efa1b333042$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function $2ad35efa1b333042$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function $2ad35efa1b333042$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $2ad35efa1b333042$var$__awaiter(this, void 0, void 0, function*() {
        return $2ad35efa1b333042$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $21597b612ea06b11$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $21597b612ea06b11$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $21597b612ea06b11$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const $21597b612ea06b11$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class $21597b612ea06b11$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $b8abd4fb4763e533$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $21597b612ea06b11$var$DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $21597b612ea06b11$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, $abe02471d8456f7f$export$697502632950e9d3)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, $b8abd4fb4763e533$export$69d519e35e6fc3d4)(data),
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, $2ad35efa1b333042$export$5fd5031fecdacec3)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error) && error instanceof (0, $abe02471d8456f7f$export$29127ca2e1a271d)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error: error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $21597b612ea06b11$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $21597b612ea06b11$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $21597b612ea06b11$require$Buffer !== 'undefined') return $21597b612ea06b11$require$Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}


// generated by genversion
const $a02d8046733ee147$export$83d89fbfd8236492 = '2.7.1';


const $f4c4e1deae4025ef$export$88a84136db6a4b64 = {
    'X-Client-Info': `storage-js/${(0, $a02d8046733ee147$export$83d89fbfd8236492)}`
};





var $316874d7d88ac643$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $316874d7d88ac643$export$2e2bcd8739ae039 {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $f4c4e1deae4025ef$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $b8abd4fb4763e533$export$98d92b1aa79f8cc7)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $316874d7d88ac643$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $2ad35efa1b333042$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $abe02471d8456f7f$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
}


class $3ac213f23af4773a$export$6c85f5032e75eff9 extends (0, $316874d7d88ac643$export$2e2bcd8739ae039) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $21597b612ea06b11$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
}


const $7ab8bdf3e5c9b693$export$83d89fbfd8236492 = '2.49.10';


let $c0fdce55fc03ad18$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $c0fdce55fc03ad18$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $c0fdce55fc03ad18$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $c0fdce55fc03ad18$var$JS_ENV = 'react-native';
else $c0fdce55fc03ad18$var$JS_ENV = 'node';
const $c0fdce55fc03ad18$export$88a84136db6a4b64 = {
    'X-Client-Info': `supabase-js-${$c0fdce55fc03ad18$var$JS_ENV}/${(0, $7ab8bdf3e5c9b693$export$83d89fbfd8236492)}`
};
const $c0fdce55fc03ad18$export$b63a5c3a2e5becd2 = {
    headers: $c0fdce55fc03ad18$export$88a84136db6a4b64
};
const $c0fdce55fc03ad18$export$b31378ae815bea6b = {
    schema: 'public'
};
const $c0fdce55fc03ad18$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const $c0fdce55fc03ad18$export$59685507ca0a3912 = {};



var $979Ct = parcelRequire("979Ct");
var $7846a7cc5c362d25$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7846a7cc5c362d25$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $979Ct.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $7846a7cc5c362d25$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === 'undefined') return 0, $979Ct.Headers;
    return Headers;
};
const $7846a7cc5c362d25$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $7846a7cc5c362d25$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $7846a7cc5c362d25$export$3d2cf54f85b7fc8a();
    return (input, init)=>$7846a7cc5c362d25$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


var $0c30a5a89f4b6341$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $0c30a5a89f4b6341$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $0c30a5a89f4b6341$export$a896b865588a414b(url) {
    return url.endsWith('/') ? url : url + '/';
}
const $0c30a5a89f4b6341$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined';
function $0c30a5a89f4b6341$export$da186dc3f8eace71(options, defaults) {
    var _a, _b;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions), {
            headers: Object.assign(Object.assign({}, (_a = DEFAULT_GLOBAL_OPTIONS === null || DEFAULT_GLOBAL_OPTIONS === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS.headers) !== null && _a !== void 0 ? _a : {}), (_b = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _b !== void 0 ? _b : {})
        }),
        accessToken: ()=>$0c30a5a89f4b6341$var$__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}


const $da0e74438356dc28$export$83d89fbfd8236492 = '2.69.1';


const $2f82a590c21cea7a$export$a4558fee79d6c8ae = 30000;
const $2f82a590c21cea7a$export$f20a97df8f5fe223 = 3;
const $2f82a590c21cea7a$export$a36ad0026e55ac00 = $2f82a590c21cea7a$export$f20a97df8f5fe223 * $2f82a590c21cea7a$export$a4558fee79d6c8ae;
const $2f82a590c21cea7a$export$7fedf552187f0c3d = 'http://localhost:9999';
const $2f82a590c21cea7a$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $2f82a590c21cea7a$export$2f9161bad044dacb = '';
const $2f82a590c21cea7a$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $da0e74438356dc28$export$83d89fbfd8236492)}`
};
const $2f82a590c21cea7a$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $2f82a590c21cea7a$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $2f82a590c21cea7a$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $2f82a590c21cea7a$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $2f82a590c21cea7a$export$5bd768495200f133 = 600000; // 10 minutes



class $b92ec9013174409a$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $b92ec9013174409a$export$45fde0b55b14f37b extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $b92ec9013174409a$export$4fe744aeb810d543(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $b92ec9013174409a$export$f7559805d4a50078 extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $b92ec9013174409a$export$823c745ae0673c5e extends $b92ec9013174409a$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $b92ec9013174409a$export$403b3fc0d3ad5f0c extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $b92ec9013174409a$export$3e849aa4db565c1d(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $b92ec9013174409a$export$7e277b620449c1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $b92ec9013174409a$export$9ef583f0381b4cc extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $b92ec9013174409a$export$bf5df8e043856ef5 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function $b92ec9013174409a$export$45edea3999507afd(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $b92ec9013174409a$export$39583657eb2a7027 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class $b92ec9013174409a$export$2423b763f68be1b4 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $b92ec9013174409a$export$a77af358da5fb874(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $b92ec9013174409a$export$b034076aa04913a6 extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function $b92ec9013174409a$export$dac36143fd8a46ef(error) {
    return $b92ec9013174409a$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $b92ec9013174409a$export$d04cb18528f2043e extends $b92ec9013174409a$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}


/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $dbf67752838ebc66$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $dbf67752838ebc66$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $dbf67752838ebc66$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $dbf67752838ebc66$var$IGNORE_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $dbf67752838ebc66$var$TO_BASE64URL.length; i += 1)charMap[$dbf67752838ebc66$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $dbf67752838ebc66$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($dbf67752838ebc66$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $dbf67752838ebc66$export$403e86c86002a137(charCode, state, emit) {
    const bits = $dbf67752838ebc66$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $dbf67752838ebc66$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>{
        $dbf67752838ebc66$export$744f452403189a3e(byte, state, emitter);
    });
    $dbf67752838ebc66$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $dbf67752838ebc66$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $dbf67752838ebc66$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $dbf67752838ebc66$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $dbf67752838ebc66$export$d203cd9136753332(codepoint, emit);
    }
}
function $dbf67752838ebc66$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $dbf67752838ebc66$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$dbf67752838ebc66$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $dbf67752838ebc66$export$a098e7b533f96db3(str) {
    const result = [];
    $dbf67752838ebc66$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}


function $6a62ca85cf697dd5$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $6a62ca85cf697dd5$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $6a62ca85cf697dd5$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $6a62ca85cf697dd5$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $6a62ca85cf697dd5$export$9ec034ee80211814 = ()=>{
    if (!$6a62ca85cf697dd5$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($6a62ca85cf697dd5$var$localStorageWriteTests.tested) return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $6a62ca85cf697dd5$var$localStorageWriteTests.tested = true;
        $6a62ca85cf697dd5$var$localStorageWriteTests.writable = false;
    }
    return $6a62ca85cf697dd5$var$localStorageWriteTests.writable;
};
function $6a62ca85cf697dd5$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $6a62ca85cf697dd5$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>Promise.resolve((parcelRequire("979Ct"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $6a62ca85cf697dd5$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $6a62ca85cf697dd5$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $6a62ca85cf697dd5$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $6a62ca85cf697dd5$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $6a62ca85cf697dd5$export$85f6557964517f1a {
    constructor(){
        this.promise = new $6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$6a62ca85cf697dd5$export$85f6557964517f1a.promiseConstructor = Promise;
function $6a62ca85cf697dd5$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $2f82a590c21cea7a$export$7a68c9e70b9d3911).test(parts[i])) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $dbf67752838ebc66$export$bd5d476f823ea024)(parts[0])),
        payload: JSON.parse((0, $dbf67752838ebc66$export$bd5d476f823ea024)(parts[1])),
        signature: (0, $dbf67752838ebc66$export$9cae2cd6076b8fb6)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $6a62ca85cf697dd5$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $6a62ca85cf697dd5$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $6a62ca85cf697dd5$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $6a62ca85cf697dd5$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $6a62ca85cf697dd5$var$dec2hex).join('');
}
async function $6a62ca85cf697dd5$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $6a62ca85cf697dd5$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $6a62ca85cf697dd5$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $6a62ca85cf697dd5$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = $6a62ca85cf697dd5$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await $6a62ca85cf697dd5$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await $6a62ca85cf697dd5$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $6a62ca85cf697dd5$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $6a62ca85cf697dd5$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $2f82a590c21cea7a$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($6a62ca85cf697dd5$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}
function $6a62ca85cf697dd5$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $6a62ca85cf697dd5$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}



var $9c1b37c8edd4ca2b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9c1b37c8edd4ca2b$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $6a62ca85cf697dd5$export$e8ad6599be1036a7)(error)) throw new (0, $b92ec9013174409a$export$2423b763f68be1b4)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), 0);
    if ($9c1b37c8edd4ca2b$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $b92ec9013174409a$export$2423b763f68be1b4)($9c1b37c8edd4ca2b$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $b92ec9013174409a$export$f7559805d4a50078)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, $6a62ca85cf697dd5$export$5f69ecf1c14d56fd)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $2f82a590c21cea7a$export$1f9a66038489bdeb)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $b92ec9013174409a$export$b034076aa04913a6)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $b92ec9013174409a$export$b034076aa04913a6)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
    throw new (0, $b92ec9013174409a$export$45fde0b55b14f37b)($9c1b37c8edd4ca2b$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $9c1b37c8edd4ca2b$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $2f82a590c21cea7a$export$e4f5507f88977535]) headers[0, $2f82a590c21cea7a$export$e4f5507f88977535] = (0, $2f82a590c21cea7a$export$1f9a66038489bdeb)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $9c1b37c8edd4ca2b$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $9c1b37c8edd4ca2b$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $b92ec9013174409a$export$2423b763f68be1b4)($9c1b37c8edd4ca2b$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $9c1b37c8edd4ca2b$export$d3da1ecaf1206c58(e);
    }
}
function $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($9c1b37c8edd4ca2b$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $6a62ca85cf697dd5$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$db83aade1c2922c7(data) {
    const response = $9c1b37c8edd4ca2b$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $9c1b37c8edd4ca2b$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $9c1b37c8edd4ca2b$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $9c1b37c8edd4ca2b$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $9c1b37c8edd4ca2b$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $b042d08e69f8c3c9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $b042d08e69f8c3c9$export$2e2bcd8739ae039 {
    constructor({ url: url = '', headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $6a62ca85cf697dd5$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $b042d08e69f8c3c9$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $9c1b37c8edd4ca2b$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}








const $75e7b709645121aa$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $6a62ca85cf697dd5$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $6a62ca85cf697dd5$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $6a62ca85cf697dd5$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $75e7b709645121aa$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $68327ffe4e2befb5$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $031357f45f79c67e$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $6a62ca85cf697dd5$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $031357f45f79c67e$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $031357f45f79c67e$export$4aa56776043a4631 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
class $031357f45f79c67e$export$4b982ee840d3d915 extends $031357f45f79c67e$export$23e9464cc010dff9 {
}
async function $031357f45f79c67e$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $031357f45f79c67e$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($031357f45f79c67e$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const $031357f45f79c67e$var$PROCESS_LOCKS = {};
async function $031357f45f79c67e$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $031357f45f79c67e$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new $031357f45f79c67e$export$4b982ee840d3d915(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    $031357f45f79c67e$var$PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}



(0, $68327ffe4e2befb5$export$ad067ce270531206)(); // Make "globalThis" available
const $8025f0dcbc879582$var$DEFAULT_OPTIONS = {
    url: (0, $2f82a590c21cea7a$export$7fedf552187f0c3d),
    storageKey: (0, $2f82a590c21cea7a$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $2f82a590c21cea7a$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
async function $8025f0dcbc879582$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $8025f0dcbc879582$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $8025f0dcbc879582$export$2e2bcd8739ae039.nextInstanceID;
        $8025f0dcbc879582$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, $8025f0dcbc879582$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $b042d08e69f8c3c9$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $6a62ca85cf697dd5$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $8025f0dcbc879582$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $031357f45f79c67e$export$f4ff21938fb7af3c);
        else this.lock = $8025f0dcbc879582$var$lockNoOp;
        this.jwks = {
            keys: []
        };
        this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $6a62ca85cf697dd5$export$9ec034ee80211814)()) this.storage = (0, $75e7b709645121aa$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $75e7b709645121aa$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $75e7b709645121aa$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $da0e74438356dc28$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, $6a62ca85cf697dd5$export$7a29392fb778224c)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $b92ec9013174409a$export$45edea3999507afd)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $b92ec9013174409a$export$f7559805d4a50078)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
                });
            } else throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$db83aade1c2922c7)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $9c1b37c8edd4ca2b$export$db83aade1c2922c7)
                });
            } else throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $b92ec9013174409a$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $9c1b37c8edd4ca2b$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $b92ec9013174409a$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $2f82a590c21cea7a$export$a36ad0026e55ac00) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)()
                };
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) {
                if ((0, $b92ec9013174409a$export$3e849aa4db565c1d)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error: error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
                const { data: data, error: userError } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $9c1b37c8edd4ca2b$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $6a62ca85cf697dd5$export$9a62e6c0a30e00bc)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)()) throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $b92ec9013174409a$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $b92ec9013174409a$export$39583657eb2a7027)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $b92ec9013174409a$export$bf5df8e043856ef5)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $b92ec9013174409a$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error: error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $6a62ca85cf697dd5$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $6a62ca85cf697dd5$export$9e1b8e833f44ff21)(async (attempt)=>{
                if (attempt > 0) await (0, $6a62ca85cf697dd5$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $9c1b37c8edd4ca2b$export$273fe4673a018c2e)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $b92ec9013174409a$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $6a62ca85cf697dd5$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) * 1000 - Date.now() < (0, $2f82a590c21cea7a$export$a36ad0026e55ac00);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $2f82a590c21cea7a$export$a36ad0026e55ac00)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $b92ec9013174409a$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $6a62ca85cf697dd5$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $b92ec9013174409a$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $b92ec9013174409a$export$a77af358da5fb874)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, $6a62ca85cf697dd5$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, $6a62ca85cf697dd5$export$d35c645d585317ec)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $2f82a590c21cea7a$export$a4558fee79d6c8ae));
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $2f82a590c21cea7a$export$a4558fee79d6c8ae)}ms, refresh threshold is ${(0, $2f82a590c21cea7a$export$f20a97df8f5fe223)} ticks`);
                            if (expiresInTicks <= (0, $2f82a590c21cea7a$export$f20a97df8f5fe223)) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $031357f45f79c67e$export$23e9464cc010dff9)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $6a62ca85cf697dd5$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, $6a62ca85cf697dd5$export$81b177cadfcf873c)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp: totp,
                phone: phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const { payload: payload } = (0, $6a62ca85cf697dd5$export$9a62e6c0a30e00bc)(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $2f82a590c21cea7a$export$5bd768495200f133) > Date.now()) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $9c1b37c8edd4ca2b$export$8969b3850ca2cdfd)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('JWKS is empty');
        this.jwks = data;
        this.jwks_cached_at = Date.now();
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('No matching signing key found in JWKS');
        return jwk;
    }
    /**
     * @experimental This method may change in future versions.
     * @description Gets the claims from a JWT. If the JWT is symmetric JWTs, it will call getUser() to verify against the server. If the JWT is asymmetric, it will be verified against the JWKS using the WebCrypto API.
     */ async getClaims(jwt, jwks = {
        keys: []
    }) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return {
                    data: null,
                    error: error
                };
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $6a62ca85cf697dd5$export$9a62e6c0a30e00bc)(token);
            // Reject expired JWTs
            (0, $6a62ca85cf697dd5$export$a5850868adeb9253)(payload.exp);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!header.kid || header.alg === 'HS256' || !('crypto' in globalThis && 'subtle' in globalThis.crypto)) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $6a62ca85cf697dd5$export$fa59f625ab60cb91)(header.alg);
            const signingKey = await this.fetchJwk(header.kid, jwks);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $dbf67752838ebc66$export$a098e7b533f96db3)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $b92ec9013174409a$export$d04cb18528f2043e)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $b92ec9013174409a$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}
$8025f0dcbc879582$export$2e2bcd8739ae039.nextInstanceID = 0;



const $b5e8a3473c3df521$var$AuthAdminApi = (0, $b042d08e69f8c3c9$export$2e2bcd8739ae039);
var $b5e8a3473c3df521$export$2e2bcd8739ae039 = $b5e8a3473c3df521$var$AuthAdminApi;



const $7b62653534e595bb$var$AuthClient = (0, $8025f0dcbc879582$export$2e2bcd8739ae039);
var $7b62653534e595bb$export$2e2bcd8739ae039 = $7b62653534e595bb$var$AuthClient;








class $b6000684d7c6c56c$export$8199a418bb09bd56 extends (0, $7b62653534e595bb$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $adb6551412d48394$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $adb6551412d48394$export$2e2bcd8739ae039 {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, $0c30a5a89f4b6341$export$a896b865588a414b)(supabaseUrl);
        const baseUrl = new URL(_supabaseUrl);
        this.realtimeUrl = new URL('realtime/v1', baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace('http', 'ws');
        this.authUrl = new URL('auth/v1', baseUrl);
        this.storageUrl = new URL('storage/v1', baseUrl);
        this.functionsUrl = new URL('functions/v1', baseUrl);
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${baseUrl.hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $c0fdce55fc03ad18$export$b31378ae815bea6b),
            realtime: (0, $c0fdce55fc03ad18$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $c0fdce55fc03ad18$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $c0fdce55fc03ad18$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $0c30a5a89f4b6341$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, $7846a7cc5c362d25$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $fa98774720195011$export$796f32e2ee984aaa)(new URL('rest/v1', baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $6f9d627d4ebb0255$export$1d0b400bf8a0fa55)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $3ac213f23af4773a$export$6c85f5032e75eff9)(this.storageUrl.href, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $adb6551412d48394$var$__awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $b6000684d7c6c56c$export$8199a418bb09bd56)({
            url: this.authUrl.href,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            fetch: fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: 'Authorization' in this.headers
        });
    }
    _initRealtimeClient(options) {
        return new (0, $ae049384a7d1c7c8$export$2e2bcd8739ae039)(this.realtimeUrl.href, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}






const $99dc17f4947b5a7e$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $adb6551412d48394$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


const $6a5394f247e70ce7$var$supabaseUrl = "https://xqdwpfytjayobvmxvhwj.supabase.co";
const $6a5394f247e70ce7$var$supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhxZHdwZnl0amF5b2J2bXh2aHdqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkxMTI3MzIsImV4cCI6MjA2NDY4ODczMn0.Vmn-0ovCuMnNVRsSd1uS_71Js0D__ASLcoObCPIi32A";
const $6a5394f247e70ce7$export$a0b632a28672d3c0 = (0, $99dc17f4947b5a7e$export$5d730b7aed1a3eb0)($6a5394f247e70ce7$var$supabaseUrl, $6a5394f247e70ce7$var$supabaseAnonKey, {
    auth: {
        persistSession: true
    }
});


// Camera name sorter
const $28770b279d7ab5b1$var$collator = new Intl.Collator([
    'en',
    'zh',
    'jp',
    'ko'
], {
    numeric: true,
    sensitivity: 'base'
});
const $28770b279d7ab5b1$export$7932064324870761 = (item)=>item.sort((a, b)=>$28770b279d7ab5b1$var$collator.compare(a.name, b.name));



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $607c3485b4f38191$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $607c3485b4f38191$export$2e2bcd8739ae039 = $607c3485b4f38191$var$TableContext;






var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $64c9c67b6531c050$export$315cb19215f77ce0(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTable', slot);
}
const $64c9c67b6531c050$var$tableClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTable', [
    'root',
    'stickyHeader'
]);
var $64c9c67b6531c050$export$2e2bcd8739ae039 = $64c9c67b6531c050$var$tableClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f087e22488590525$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $64c9c67b6531c050$export$315cb19215f77ce0), classes);
};
const $f087e22488590525$var$TableRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $f087e22488590525$var$defaultComponent = 'table';
const $f087e22488590525$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $f087e22488590525$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $f087e22488590525$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $607c3485b4f38191$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f087e22488590525$var$TableRoot, {
            as: component,
            role: component === $f087e22488590525$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $f087e22488590525$export$2e2bcd8739ae039 = $f087e22488590525$var$Table;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $59c9ddddb511cdd6$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $59c9ddddb511cdd6$export$2e2bcd8739ae039 = $59c9ddddb511cdd6$var$Tablelvl2Context;





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $43d98f398793ab7d$export$98bd2a9b566ec665(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTableBody', slot);
}
const $43d98f398793ab7d$var$tableBodyClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTableBody', [
    'root'
]);
var $43d98f398793ab7d$export$2e2bcd8739ae039 = $43d98f398793ab7d$var$tableBodyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $791aa0d72f2174bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $43d98f398793ab7d$export$98bd2a9b566ec665), classes);
};
const $791aa0d72f2174bf$var$TableBodyRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $791aa0d72f2174bf$var$tablelvl2 = {
    variant: 'body'
};
const $791aa0d72f2174bf$var$defaultComponent = 'tbody';
const $791aa0d72f2174bf$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $791aa0d72f2174bf$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $791aa0d72f2174bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039).Provider, {
        value: $791aa0d72f2174bf$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($791aa0d72f2174bf$var$TableBodyRoot, {
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $791aa0d72f2174bf$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $791aa0d72f2174bf$export$2e2bcd8739ae039 = $791aa0d72f2174bf$var$TableBody;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $0f3b8fb4e961edd5$export$33a0f07a16a10b1b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTableCell', slot);
}
const $0f3b8fb4e961edd5$var$tableCellClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $0f3b8fb4e961edd5$export$2e2bcd8739ae039 = $0f3b8fb4e961edd5$var$tableCellClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c63602040c542751$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(align)}`,
            padding !== 'normal' && `padding${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(padding)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $0f3b8fb4e961edd5$export$33a0f07a16a10b1b), classes);
};
const $c63602040c542751$var$TableCellRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $h61zw.lighten)((0, $h61zw.alpha)(theme.palette.divider, 1), 0.88) : (0, $h61zw.darken)((0, $h61zw.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $0f3b8fb4e961edd5$export$2e2bcd8739ae039).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $c63602040c542751$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $acw62.useContext((0, $607c3485b4f38191$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $c63602040c542751$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c63602040c542751$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $c63602040c542751$export$2e2bcd8739ae039 = $c63602040c542751$var$TableCell;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $73e1f9234e51787e$export$eed427986a7abdf9(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTableContainer', slot);
}
const $73e1f9234e51787e$var$tableContainerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTableContainer', [
    'root'
]);
var $73e1f9234e51787e$export$2e2bcd8739ae039 = $73e1f9234e51787e$var$tableContainerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d8d66642fc2c080$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $73e1f9234e51787e$export$eed427986a7abdf9), classes);
};
const $0d8d66642fc2c080$var$TableContainerRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $0d8d66642fc2c080$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $0d8d66642fc2c080$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0d8d66642fc2c080$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $0d8d66642fc2c080$export$2e2bcd8739ae039 = $0d8d66642fc2c080$var$TableContainer;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $42315241ec1b66a7$export$2e731cea2d1c2392(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTableHead', slot);
}
const $42315241ec1b66a7$var$tableHeadClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTableHead', [
    'root'
]);
var $42315241ec1b66a7$export$2e2bcd8739ae039 = $42315241ec1b66a7$var$tableHeadClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9fd7c480e10ebc69$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $42315241ec1b66a7$export$2e731cea2d1c2392), classes);
};
const $9fd7c480e10ebc69$var$TableHeadRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const $9fd7c480e10ebc69$var$tablelvl2 = {
    variant: 'head'
};
const $9fd7c480e10ebc69$var$defaultComponent = 'thead';
const $9fd7c480e10ebc69$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $9fd7c480e10ebc69$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $9fd7c480e10ebc69$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039).Provider, {
        value: $9fd7c480e10ebc69$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9fd7c480e10ebc69$var$TableHeadRoot, {
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $9fd7c480e10ebc69$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $9fd7c480e10ebc69$export$2e2bcd8739ae039 = $9fd7c480e10ebc69$var$TableHead;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $3Hg1x = parcelRequire("3Hg1x");








var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $11a5c049f91ec9c6$export$b12cb262231eef32(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiToolbar', slot);
}
const $11a5c049f91ec9c6$var$toolbarClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $11a5c049f91ec9c6$export$2e2bcd8739ae039 = $11a5c049f91ec9c6$var$toolbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e223a49097a073d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $11a5c049f91ec9c6$export$b12cb262231eef32), classes);
};
const $e223a49097a073d9$var$ToolbarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $e223a49097a073d9$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $e223a49097a073d9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e223a49097a073d9$var$ToolbarRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $e223a49097a073d9$export$2e2bcd8739ae039 = $e223a49097a073d9$var$Toolbar;



var $acw62 = parcelRequire("acw62");


var $9uEev = parcelRequire("9uEev");

var $3Hg1x = parcelRequire("3Hg1x");

var $9QePP = parcelRequire("9QePP");





var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");









var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $51a63158336e7c66$export$5e8702d71474f093(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiIconButton', slot);
}
const $51a63158336e7c66$var$iconButtonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $51a63158336e7c66$export$2e2bcd8739ae039 = $51a63158336e7c66$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $05a469b554e6dcda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $51a63158336e7c66$export$5e8702d71474f093), classes);
};
const $05a469b554e6dcda$var$IconButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $51a63158336e7c66$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $51a63158336e7c66$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $05a469b554e6dcda$var$IconButtonLoadingIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $05a469b554e6dcda$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $05a469b554e6dcda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($05a469b554e6dcda$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($05a469b554e6dcda$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $05a469b554e6dcda$export$2e2bcd8739ae039 = $05a469b554e6dcda$var$IconButton;


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d071034c982194cf$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a65fb2f9fd7a7465$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $cb9999951d5d2ac3$export$e7e9b1c332bb0588(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTablePaginationActions', slot);
}
const $cb9999951d5d2ac3$var$tablePaginationActionsClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTablePaginationActions', [
    'root'
]);
var $cb9999951d5d2ac3$export$2e2bcd8739ae039 = $cb9999951d5d2ac3$var$tablePaginationActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $274989d83c1a4bae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $cb9999951d5d2ac3$export$e7e9b1c332bb0588), classes);
};
const $274989d83c1a4bae$var$TablePaginationActionsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTablePaginationActions',
    slot: 'Root'
})({});
const $274989d83c1a4bae$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTablePaginationActions'
    });
    const { backIconButtonProps: backIconButtonProps, className: className, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $9uEev.useRtl)();
    const ownerState = props;
    const classes = $274989d83c1a4bae$var$useUtilityClasses(ownerState);
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const LastButton = slots.lastButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const NextButton = slots.nextButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const PreviousButton = slots.previousButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const FirstButtonIcon = slots.firstButtonIcon ?? (0, $a65fb2f9fd7a7465$export$2e2bcd8739ae039);
    const LastButtonIcon = slots.lastButtonIcon ?? (0, $d071034c982194cf$export$2e2bcd8739ae039);
    const NextButtonIcon = slots.nextButtonIcon ?? (0, $d91db4839e2bc3bb$export$2e2bcd8739ae039);
    const PreviousButtonIcon = slots.previousButtonIcon ?? (0, $d997f00fcbb3883b$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($274989d83c1a4bae$var$TablePaginationActionsRoot, {
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
var $274989d83c1a4bae$export$2e2bcd8739ae039 = $274989d83c1a4bae$var$TablePaginationActions;




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $f6b9903d0b727400$export$909e637b22246f4c(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTablePagination', slot);
}
const $f6b9903d0b727400$var$tablePaginationClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $f6b9903d0b727400$export$2e2bcd8739ae039 = $f6b9903d0b727400$var$tablePaginationClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e88806fdab3fc1ac$var$_InputBase;
const $e88806fdab3fc1ac$var$TablePaginationRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $c63602040c542751$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $e88806fdab3fc1ac$var$TablePaginationToolbar = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $e88806fdab3fc1ac$var$TablePaginationSpacer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer'
})({
    flex: '1 1 100%'
});
const $e88806fdab3fc1ac$var$TablePaginationSelectLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $e88806fdab3fc1ac$var$TablePaginationSelect = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $e88806fdab3fc1ac$var$TablePaginationMenuItem = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem'
})({});
const $e88806fdab3fc1ac$var$TablePaginationDisplayedRows = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $e88806fdab3fc1ac$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $e88806fdab3fc1ac$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $e88806fdab3fc1ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $f6b9903d0b727400$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $e88806fdab3fc1ac$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $274989d83c1a4bae$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = (0, $c63602040c542751$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $e88806fdab3fc1ac$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $e88806fdab3fc1ac$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $e88806fdab3fc1ac$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $e88806fdab3fc1ac$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $c63602040c542751$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: classes.root,
        elementType: $e88806fdab3fc1ac$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('toolbar', {
        className: classes.toolbar,
        elementType: $e88806fdab3fc1ac$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('spacer', {
        className: classes.spacer,
        elementType: $e88806fdab3fc1ac$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('selectLabel', {
        className: classes.selectLabel,
        elementType: $e88806fdab3fc1ac$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('select', {
        className: classes.select,
        elementType: $e88806fdab3fc1ac$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('displayedRows', {
        className: classes.displayedRows,
        elementType: $e88806fdab3fc1ac$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $e88806fdab3fc1ac$var$_InputBase || ($e88806fdab3fc1ac$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $9QePP.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $9QePP.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $9QePP.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
var $e88806fdab3fc1ac$export$2e2bcd8739ae039 = $e88806fdab3fc1ac$var$TablePagination;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $dc6dc2b9872aeb3e$export$ba0a6d6c28940107(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiTableRow', slot);
}
const $dc6dc2b9872aeb3e$var$tableRowClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $dc6dc2b9872aeb3e$export$2e2bcd8739ae039 = $dc6dc2b9872aeb3e$var$tableRowClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7e1593b31b92bf3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $dc6dc2b9872aeb3e$export$ba0a6d6c28940107), classes);
};
const $7e1593b31b92bf3c$var$TableRowRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $dc6dc2b9872aeb3e$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $dc6dc2b9872aeb3e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    })));
const $7e1593b31b92bf3c$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $7e1593b31b92bf3c$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $7e1593b31b92bf3c$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $acw62.useContext((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $7e1593b31b92bf3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7e1593b31b92bf3c$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $7e1593b31b92bf3c$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $7e1593b31b92bf3c$export$2e2bcd8739ae039 = $7e1593b31b92bf3c$var$TableRow;



var $acw62 = parcelRequire("acw62");
function $a1a2c8e96421375c$export$2e2bcd8739ae039({ cameras: cameras, deleteCamera: deleteCamera, loading: loading }) {
    const [page, setPage] = (0, $acw62.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(10);
    const handlePageChange = (event, newPage)=>{
        setPage(newPage);
    };
    const handleRowsPerPageChange = (event)=>{
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const pagedEntries = cameras.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d8d66642fc2c080$export$2e2bcd8739ae039), {
                sx: {
                    maxHeight: 600
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Stream URL"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        align: "right",
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: pagedEntries.map((camera)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: camera.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            sx: {
                                                maxWidth: 400,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: camera.stream_url
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            align: "right",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                                onClick: ()=>deleteCamera(camera.id),
                                                loading: loading.deleteCamera.get(camera.id) || false,
                                                children: "Delete"
                                            })
                                        })
                                    ]
                                }, camera.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e88806fdab3fc1ac$export$2e2bcd8739ae039), {
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                component: "div",
                count: cameras.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handlePageChange,
                onRowsPerPageChange: handleRowsPerPageChange
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ab8dae130526a9ed$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $40358248c3742ffd$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreHoriz');


var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $95f6704f80233608$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $ab9f026bf6924669$export$d9c6dc45f75b0e4f(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDialogContentText', slot);
}
const $ab9f026bf6924669$var$dialogContentTextClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDialogContentText', [
    'root'
]);
var $ab9f026bf6924669$export$2e2bcd8739ae039 = $ab9f026bf6924669$var$dialogContentTextClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6b3200515d476ef1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $ab9f026bf6924669$export$d9c6dc45f75b0e4f), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $6b3200515d476ef1$var$DialogContentTextRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $6b3200515d476ef1$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $6b3200515d476ef1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6b3200515d476ef1$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $6b3200515d476ef1$export$2e2bcd8739ae039 = $6b3200515d476ef1$var$DialogContentText;



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $689927f0df05e8fa$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');




var $acw62 = parcelRequire("acw62");
function $ca86126f38100538$export$2e2bcd8739ae039({ user: user, open: open, handleClose: handleClose, onConfirm: onConfirm, loading: loading }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
            open: open,
            onClose: handleClose,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                    children: "Delete User"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6b3200515d476ef1$export$2e2bcd8739ae039), {
                        children: [
                            "You are about to delete ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: user.email
                            }),
                            ". Are you sure?"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "contained",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {}),
                            color: "error",
                            loading: loading,
                            onClick: onConfirm,
                            children: "Delete"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "contained",
                            onClick: handleClose,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

function $b05ae290979893f0$export$2e2bcd8739ae039({ editingUser: editingUser, cameras: cameras, loadingUpdateUser: loadingUpdateUser, setEditingUser: setEditingUser, updateUser: updateUser, open: open, handleClose: handleClose }) {
    if (!editingUser) return null;
    const handleSubmit = (event)=>{
        event.preventDefault();
        updateUser(editingUser);
        handleClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                    children: "Editing User..."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                    dividers: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Email",
                            value: editingUser.email,
                            onChange: (e)=>setEditingUser({
                                    ...editingUser,
                                    email: e.target.value
                                }),
                            fullWidth: true,
                            margin: "normal",
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Password",
                            type: "password",
                            value: editingUser.password || '',
                            onChange: (e)=>setEditingUser({
                                    ...editingUser,
                                    password: e.target.value
                                }),
                            fullWidth: true,
                            margin: "normal"
                        }),
                        editingUser.role === 'customer' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            margin: "normal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                                    children: "Camera"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                    multiple: true,
                                    label: "Camera",
                                    value: editingUser.camera_ids || [],
                                    onChange: (e)=>setEditingUser({
                                            ...editingUser,
                                            camera_ids: e.target.value
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                            value: "",
                                            children: "None"
                                        }),
                                        cameras.map((camera)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: camera.id,
                                                children: camera.name
                                            }, camera.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Notes",
                            value: editingUser.notes,
                            onChange: (e)=>setEditingUser({
                                    ...editingUser,
                                    notes: e.target.value
                                }),
                            fullWidth: true,
                            margin: "normal",
                            multiline: true,
                            rows: 4
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            type: "submit",
                            variant: "contained",
                            disabled: loadingUpdateUser,
                            children: "Update"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            onClick: handleClose,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
}


function $b76cd4f860a20711$export$2e2bcd8739ae039({ users: users, cameras: cameras, updateUser: updateUser, deleteUser: deleteUser, loading: loading }) {
    const [page, setPage] = (0, $acw62.useState)(0);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(10);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const handlePageChange = (event, newPage)=>{
        setPage(newPage);
    };
    const handleRowsPerPageChange = (event)=>{
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleSearchChange = (event)=>{
        setSearchTerm(event.target.value);
        setPage(0);
    };
    const filteredCameraId = (0, $acw62.useMemo)(()=>{
        const term = searchTerm.trim().toLowerCase();
        if (!term) return new Set();
        return new Set(cameras.filter((cam)=>cam.name.toLowerCase().includes(term)).map((cam)=>cam.id));
    }, [
        cameras,
        searchTerm
    ]);
    const filteredEntries = (0, $acw62.useMemo)(()=>{
        const term = searchTerm.trim().toLowerCase();
        if (!term) return users;
        return users.filter((user)=>{
            const emailMatches = user.email.toLowerCase().includes(term);
            const notesMatches = user.notes?.toLowerCase().includes(term) ?? false;
            const cameraMatches = user.camera_ids && user.camera_ids.some((id)=>filteredCameraId.has(id));
            return emailMatches || notesMatches || cameraMatches;
        });
    }, [
        users,
        filteredCameraId,
        searchTerm
    ]);
    const pagedEntries = filteredEntries.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    // notes overflow check
    const noteRefs = (0, $acw62.useRef)({});
    const [overflowNotes, setOverflowNotes] = (0, $acw62.useState)(new Set());
    (0, $acw62.useEffect)(()=>{
        const newSet = new Set();
        pagedEntries.forEach((user)=>{
            const element = noteRefs.current[user.id];
            if (element && element.scrollHeight > element.clientHeight) newSet.add(user.id);
        });
        setOverflowNotes(newSet);
    }, [
        searchTerm,
        page,
        rowsPerPage,
        users,
        cameras
    ]);
    // notes expand modal
    const [openNote, setOpenNote] = (0, $acw62.useState)(false);
    const [currentNote, setCurrentNote] = (0, $acw62.useState)('');
    const [currentEmail, setCurrentEmail] = (0, $acw62.useState)('');
    const handleOpenNote = (note, email)=>{
        setCurrentEmail(email);
        setCurrentNote(note);
        setOpenNote(true);
    };
    const handleCloseNote = ()=>setOpenNote(false);
    // User edit Modal
    const [userToEdit, setUserToEdit] = (0, $acw62.useState)(null);
    const [userEditDialogOpen, setuserEditDialogOpen] = (0, $acw62.useState)(false);
    const handleEditClick = (user)=>{
        setUserToEdit(user);
        setuserEditDialogOpen(true);
    };
    const handleEditDialogClose = ()=>{
        setuserEditDialogOpen(false);
        setUserToEdit(null);
    };
    // edit confirm in UserEditModal.tsx
    // User delete Modal
    const [userToDelete, setUserToDelete] = (0, $acw62.useState)(null);
    const [userDeleteDialogOpen, setuserDeleteDialogOpen] = (0, $acw62.useState)(false);
    const handleDeleteClick = (user)=>{
        setUserToDelete(user);
        setuserDeleteDialogOpen(true);
    };
    const handleDeleteDialogClose = ()=>{
        setuserDeleteDialogOpen(false);
        setUserToDelete(null);
    };
    const handleDeleteConfirm = ()=>{
        if (!userToDelete || typeof userToDelete.id !== 'string') return;
        deleteUser(userToDelete.id);
        handleDeleteDialogClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                slotProps: {
                    input: {
                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                            position: "start",
                            sx: {
                                color: 'inherit',
                                mr: 1
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {})
                        })
                    }
                },
                fullWidth: true,
                sx: {
                    maxWidth: '95%',
                    display: 'flex',
                    mx: 'auto'
                },
                variant: "outlined",
                label: "Search...",
                value: searchTerm,
                onChange: handleSearchChange,
                margin: "normal"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d8d66642fc2c080$export$2e2bcd8739ae039), {
                sx: {
                    maxHeight: 600
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Camera"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Notes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        align: "right",
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: [
                                pagedEntries.map((user)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: user.email
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: user.role
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: user.role === 'admin' ? 'All Cameras' : user.camera_ids && user.camera_ids.length > 0 ? user.camera_ids.map((id)=>cameras.find((item)=>item.id === id)?.name || id).join(', ') : 'None'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                sx: {
                                                    width: '40%'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                            ref: (element)=>{
                                                                noteRefs.current[user.id] = element;
                                                            },
                                                            sx: {
                                                                flex: 1,
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: 'vertical',
                                                                overflow: 'hidden'
                                                            },
                                                            children: user.notes || '-'
                                                        }),
                                                        overflowNotes.has(user.id) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                            "aria-label": "expand note",
                                                            onClick: ()=>handleOpenNote(user.notes || '', user.email),
                                                            sx: {
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: 'inherit',
                                                                ml: 1
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40358248c3742ffd$export$2e2bcd8739ae039), {})
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                                        onClick: ()=>handleEditClick(user),
                                                        children: "Edit"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                                        onClick: ()=>handleDeleteClick(user),
                                                        disabled: users.length <= 1,
                                                        children: "Delete"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, user.id);
                                }),
                                pagedEntries.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        colSpan: 4,
                                        align: "center",
                                        children: "No users found."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e88806fdab3fc1ac$export$2e2bcd8739ae039), {
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                component: "div",
                count: filteredEntries.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handlePageChange,
                onRowsPerPageChange: handleRowsPerPageChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
                open: openNote,
                onClose: handleCloseNote,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "h6",
                                component: "div",
                                sx: {
                                    display: 'flex'
                                },
                                children: [
                                    "Note: ",
                                    currentEmail
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                "aria-label": "close dialog",
                                onClick: handleCloseNote,
                                sx: {
                                    color: 'inherit'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab8dae130526a9ed$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b3200515d476ef1$export$2e2bcd8739ae039), {
                            whiteSpace: "pre-wrap",
                            children: currentNote
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b05ae290979893f0$export$2e2bcd8739ae039), {
                open: userEditDialogOpen,
                handleClose: handleEditDialogClose,
                editingUser: userToEdit,
                cameras: cameras,
                loadingUpdateUser: loading.updateUser,
                setEditingUser: setUserToEdit,
                updateUser: updateUser
            }),
            userToDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca86126f38100538$export$2e2bcd8739ae039), {
                open: userDeleteDialogOpen,
                user: userToDelete,
                loading: loading.deleteUser.get(userToDelete.id) || false,
                handleClose: handleDeleteDialogClose,
                onConfirm: handleDeleteConfirm
            })
        ]
    });
}


function $5e4133e18ff83f85$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `admin-tabpanel-${index}`,
        "aria-labelledby": `admin-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                p: 3
            },
            children: children
        })
    });
}
function $5e4133e18ff83f85$export$2e2bcd8739ae039() {
    // State for tabs (0: Manage Users, 1: Manage Cameras, 2: Manage Brand)
    const [tab, setTab] = (0, $acw62.useState)(0);
    const [users, setUsers] = (0, $acw62.useState)([]);
    const [cameras, setCameras] = (0, $acw62.useState)([]);
    const [newUser, setNewUser] = (0, $acw62.useState)({
        email: '',
        password: '',
        role: 'customer',
        camera_ids: [],
        layout: null,
        columns: null,
        notes: null
    });
    const [newCamera, setNewCamera] = (0, $acw62.useState)({
        id: '',
        name: '',
        stream_url: ''
    });
    const [brand, setBrand] = (0, $acw62.useState)(null);
    const [brandColor, setBrandColor] = (0, $acw62.useState)('');
    const [logoFile, setLogoFile] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)({
        addUser: false,
        deleteUser: new Map(),
        updateUser: false,
        addCamera: false,
        deleteCamera: new Map(),
        updateBrand: false
    });
    const [ezvizModalOpen, setEzvizModalOpen] = (0, $acw62.useState)(false);
    const supabaseAPI = `${"https://xqdwpfytjayobvmxvhwj.supabase.co"}/functions/v1`;
    // Handlers for tab switching.
    const handleTabChange = (event, newValue)=>{
        setTab(newValue);
    };
    (0, $acw62.useEffect)(()=>{
        fetchUsers();
        fetchCameras();
        fetchBrand();
    }, []);
    async function fetchUsers() {
        const { data: session } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.getSession();
        console.log('JWT claims:', session?.session?.access_token ? JSON.parse(atob(session.session.access_token.split('.')[1])) : 'No session');
        const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users').select('id, email, role, users_cameras (camera_id), layout, notes');
        if (error) {
            console.error('Fetch users error:', error);
            return;
        }
        const usersWithCameraIds = data.map((user)=>({
                ...user,
                camera_ids: user.users_cameras.map((item)=>item.camera_id),
                users_cameras: undefined
            }));
        console.log('Users fetched:', data);
        setUsers(usersWithCameraIds);
    }
    async function fetchCameras() {
        const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('cameras').select('*');
        if (error) {
            console.error('Fetch cameras error:', error);
            return;
        }
        const sortedCameras = (0, $28770b279d7ab5b1$export$7932064324870761)(data);
        console.log('Cameras fetched:', sortedCameras);
        setCameras(sortedCameras);
    }
    async function fetchBrand() {
        const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('brand').select('*').limit(1).single();
        if (error) {
            console.error('Fetch brand error:', error);
            return;
        }
        console.log('Brand fetched:', data);
        setBrand(data);
        setBrandColor(data?.color.replace('#', '') || '');
    }
    async function getUserAccessToken() {
        const { data: { session: session } } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.getSession();
        return session?.access_token;
    }
    async function createUser(e) {
        e.preventDefault();
        setLoading((prev)=>({
                ...prev,
                addUser: true
            }));
        try {
            const accessToken = await getUserAccessToken();
            if (!accessToken) {
                console.error('No user session found');
                return;
            }
            const response = await fetch(`${supabaseAPI}/createUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    email: newUser.email,
                    password: newUser.password,
                    role: newUser.role
                })
            });
            const result = await response.json();
            if (result.error) {
                console.error('Create user error:', result.error);
                return;
            }
            setNewUser({
                email: '',
                password: '',
                role: 'customer',
                camera_ids: [],
                layout: null,
                columns: null,
                notes: null
            });
            fetchUsers();
        } catch (error) {
            console.error('Error creating user:', error);
        } finally{
            setLoading((prev)=>({
                    ...prev,
                    addUser: false
                }));
        }
    }
    async function updateUser(user) {
        setLoading((prev)=>({
                ...prev,
                updateUser: true
            }));
        try {
            const accessToken = await getUserAccessToken();
            if (!accessToken) {
                console.error('No user session found');
                return;
            }
            console.log('Updating user with data:', {
                id: user.id,
                email: user.email,
                role: user.role,
                notes: user.notes
            });
            // Update user in the users table
            const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users').update({
                email: user.email,
                role: user.role,
                notes: user.notes
            }).eq('id', user.id).select().single();
            if (error) {
                console.error('Error updating user:', error);
                return;
            }
            console.log('User updated:', data);
            // Update camera associations for customers
            if (user.role === 'customer') {
                // Delete existing camera associations
                const { error: deleteError } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users_cameras').delete().eq('user_id', user.id);
                if (deleteError) {
                    console.error('Error removing old camera associations:', deleteError);
                    return;
                }
                // Insert new camera associations
                if (user.camera_ids && user.camera_ids.length > 0) {
                    const cameraInserts = user.camera_ids.map((camera_id)=>({
                            user_id: user.id,
                            camera_id: camera_id
                        }));
                    const { error: insertError } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users_cameras').insert(cameraInserts);
                    if (insertError) {
                        console.error('Error assigning cameras:', insertError);
                        return;
                    }
                }
            }
            // If password is provided, update it via server-side endpoint
            if (user.password) {
                const response = await fetch(`${supabaseAPI}/updateUser`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({
                        id: user.id,
                        password: user.password
                    })
                });
                const result = await response.json();
                if (result.error) {
                    console.error('Error updating password:', result.error);
                    return;
                }
                console.log('Password updated successfully');
            }
            fetchUsers();
            // sign out for changing own password
            const currentUser = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.getUser();
            if (currentUser.data.user?.id === user.id) await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.signOut();
        } catch (error) {
            console.error('Error updating user:', error);
        } finally{
            setLoading((prev)=>({
                    ...prev,
                    updateUser: false
                }));
        }
    }
    async function deleteUser(id) {
        setLoading((prev)=>({
                ...prev,
                deleteUser: new Map(prev.deleteUser).set(id, true)
            }));
        try {
            const accessToken = await getUserAccessToken();
            if (!accessToken) {
                console.error('No user session found');
                return;
            }
            const response = await fetch(`${supabaseAPI}/deleteUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    id: id
                })
            });
            const result = await response.json();
            if (result.error) {
                console.error('Error deleting user:', result.error);
                return;
            }
            fetchUsers();
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally{
            setLoading((prev)=>{
                const newDeleteUser = new Map(prev.deleteUser);
                newDeleteUser.delete(id);
                return {
                    ...prev,
                    deleteUser: newDeleteUser
                };
            });
        }
    }
    async function createCamera(e) {
        e.preventDefault();
        setLoading((prev)=>({
                ...prev,
                addCamera: true
            }));
        try {
            const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('cameras').insert({
                name: newCamera.name,
                stream_url: newCamera.stream_url
            }).select().single();
            if (error) {
                console.error('Error creating camera:', error);
                return;
            }
            console.log('Camera created:', data);
            setNewCamera({
                id: '',
                name: '',
                stream_url: ''
            });
            fetchCameras();
        } catch (error) {
            console.error('Error creating camera:', error);
        } finally{
            setLoading((prev)=>({
                    ...prev,
                    addCamera: false
                }));
        }
    }
    async function deleteCamera(id) {
        setLoading((prev)=>({
                ...prev,
                deleteCamera: new Map(prev.deleteCamera).set(id, true)
            }));
        try {
            const accessToken = await getUserAccessToken();
            if (!accessToken) {
                console.error('No user session found');
                return;
            }
            // removing camera from public:cameras should cascade to the users_cameras table,
            // but do it here again in case it fails
            const { error: deleteAssocError } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users_cameras').delete().eq('camera_id', id);
            if (deleteAssocError) {
                console.error('deleteCamera: Error removing association: ', deleteAssocError);
                return;
            }
            // Proceed with deletion
            const { error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('cameras').delete().eq('id', id);
            if (error) {
                console.error('Error deleting camera:', error);
                return;
            }
            console.log('Camera deleted:', id);
            fetchCameras();
        } catch (error) {
            console.error('Error deleting camera:', error);
        } finally{
            setLoading((prev)=>{
                const newDeleteCamera = new Map(prev.deleteCamera);
                newDeleteCamera.delete(id);
                return {
                    ...prev,
                    deleteCamera: newDeleteCamera
                };
            });
        }
    }
    async function updateBrand(e) {
        e.preventDefault();
        setLoading((prev)=>({
                ...prev,
                updateBrand: true
            }));
        try {
            // Handle logo upload with fixed filename
            if (logoFile) {
                let fileExt = logoFile.name.split('.').pop();
                if (fileExt) fileExt = fileExt.toLowerCase();
                const fileName = `brand_logo.${fileExt}`; // Fixed filename
                const { error: uploadError } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).storage.from('image').upload(fileName, logoFile, {
                    upsert: true
                });
                if (uploadError) {
                    console.error('Error uploading logo:', uploadError);
                    return;
                }
            }
            // Upsert brand record (no logo_path)
            const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('brand').upsert({
                id: brand?.id || '00000000-0000-0000-0000-000000000001',
                color: `#${brandColor}`
            }).select().single();
            if (error) {
                console.error('Error updating brand:', error);
                return;
            }
            console.log('Brand updated:', data);
            setBrand(data);
            setLogoFile(null);
            fetchBrand();
        } catch (error) {
            console.error('Error updating brand:', error);
        } finally{
            setLoading((prev)=>({
                    ...prev,
                    updateBrand: false
                }));
        }
    }
    // Handle file input change
    const handleLogoChange = (e)=>{
        if (e.target.files && e.target.files[0]) setLogoFile(e.target.files[0]);
    };
    // Get public URL for logo
    const getLogoUrl = ()=>{
        const { data: data } = (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).storage.from('image').getPublicUrl('brand_logo.png');
        return data.publicUrl;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ade8931e75b51e59$export$2e2bcd8739ae039), {
                value: tab,
                onChange: handleTabChange,
                "aria-label": "admin panel tabs",
                sx: {
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                        label: "Manage Users"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                        label: "Manage Cameras"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                        label: "Manage Brand"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($5e4133e18ff83f85$var$TabPanel, {
                value: tab,
                index: 0,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: "Manage Users"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        component: "form",
                        onSubmit: createUser,
                        sx: {
                            my: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: "Email",
                                value: newUser.email,
                                onChange: (e)=>setNewUser({
                                        ...newUser,
                                        email: e.target.value
                                    }),
                                sx: {
                                    mr: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: "Password",
                                type: "password",
                                value: newUser.password,
                                onChange: (e)=>setNewUser({
                                        ...newUser,
                                        password: e.target.value
                                    }),
                                sx: {
                                    mr: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                                sx: {
                                    mr: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                                        children: "Role"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                        value: newUser.role,
                                        label: "Role",
                                        onChange: (e)=>setNewUser({
                                                ...newUser,
                                                role: e.target.value
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: "customer",
                                                children: "Customer"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: "admin",
                                                children: "Admin"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "contained",
                                loading: loading.addUser,
                                children: "Add User"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b76cd4f860a20711$export$2e2bcd8739ae039), {
                        users: users,
                        cameras: cameras,
                        deleteUser: deleteUser,
                        loading: loading,
                        updateUser: updateUser
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($5e4133e18ff83f85$var$TabPanel, {
                value: tab,
                index: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: "Manage Cameras"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        component: "form",
                        onSubmit: createCamera,
                        sx: {
                            my: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: "Camera Name",
                                value: newCamera.name,
                                onChange: (e)=>setNewCamera({
                                        ...newCamera,
                                        name: e.target.value
                                    }),
                                sx: {
                                    mr: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: "Stream URL",
                                value: newCamera.stream_url,
                                onChange: (e)=>setNewCamera({
                                        ...newCamera,
                                        stream_url: e.target.value
                                    }),
                                sx: {
                                    mr: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "contained",
                                loading: loading.addCamera,
                                children: "Add Camera"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                type: "button",
                                variant: "contained",
                                color: "warning",
                                sx: {
                                    ml: 2
                                },
                                onClick: ()=>setEzvizModalOpen(true),
                                children: "EZVIZ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1a2c8e96421375c$export$2e2bcd8739ae039), {
                        cameras: cameras,
                        deleteCamera: deleteCamera,
                        loading: {
                            deleteCamera: loading.deleteCamera
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c4bba0f189150f2$export$2e2bcd8739ae039), {
                        open: ezvizModalOpen,
                        onClose: ()=>setEzvizModalOpen(false),
                        setNewCamera: setNewCamera
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($5e4133e18ff83f85$var$TabPanel, {
                value: tab,
                index: 2,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: "Manage Brand"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        component: "form",
                        onSubmit: updateBrand,
                        sx: {
                            my: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: "Brand Color (Hex)",
                                value: brandColor,
                                onChange: (e)=>setBrandColor(e.target.value),
                                placeholder: "FF5733",
                                sx: {
                                    mr: 2
                                },
                                slotProps: {
                                    input: {
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                                            position: "start",
                                            children: "#"
                                        }),
                                        inputProps: {
                                            maxLength: 6
                                        }
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    mr: 2,
                                    display: 'inline-flex',
                                    alignItems: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        component: "label",
                                        variant: "outlined",
                                        children: [
                                            "Upload Logo",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "file",
                                                accept: "image/*",
                                                hidden: true,
                                                onChange: handleLogoChange
                                            })
                                        ]
                                    }),
                                    logoFile && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        sx: {
                                            ml: 1
                                        },
                                        children: logoFile.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "contained",
                                loading: loading.updateBrand,
                                loadingIndicator: "Updating\u2026",
                                children: "Update Brand"
                            })
                        ]
                    }),
                    brand && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: "Current Brand Settings:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    "Color: ",
                                    brand.color
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: "Logo:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: getLogoUrl() || '',
                                        alt: "Brand Logo",
                                        style: {
                                            maxWidth: '200px',
                                            maxHeight: '100px',
                                            marginTop: '8px'
                                        },
                                        onError: (e)=>e.currentTarget.style.display = 'none'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");

var $acw62 = parcelRequire("acw62");



var $3Hg1x = parcelRequire("3Hg1x");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $082f01778759dbca$export$baa0faa0c7ad8085(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('PrivateSwitchBase', slot);
}
const $082f01778759dbca$var$switchBaseClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $082f01778759dbca$export$2e2bcd8739ae039 = $082f01778759dbca$var$switchBaseClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dadefa050dca578a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $082f01778759dbca$export$baa0faa0c7ad8085), classes);
};
const $dadefa050dca578a$var$SwitchBaseRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039))({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $dadefa050dca578a$var$SwitchBaseInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $dadefa050dca578a$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $dadefa050dca578a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $dadefa050dca578a$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $dadefa050dca578a$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $dadefa050dca578a$export$2e2bcd8739ae039 = $dadefa050dca578a$var$SwitchBase;


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $915769b4d8e5eccb$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $13bd0137e91b5d2a$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $41df310c6674b6f6$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');





var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $6538b097db044083$export$6c57c6e16b4063b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiCheckbox', slot);
}
const $6538b097db044083$var$checkboxClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6538b097db044083$export$2e2bcd8739ae039 = $6538b097db044083$var$checkboxClasses;









var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e3ef6305be93c7af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $6538b097db044083$export$6c57c6e16b4063b), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $e3ef6305be93c7af$var$CheckboxRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $dadefa050dca578a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $h61zw.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $6538b097db044083$export$2e2bcd8739ae039).checked}, &.${(0, $6538b097db044083$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $6538b097db044083$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $e3ef6305be93c7af$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13bd0137e91b5d2a$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $915769b4d8e5eccb$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41df310c6674b6f6$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $e3ef6305be93c7af$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $e3ef6305be93c7af$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $e3ef6305be93c7af$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $e3ef6305be93c7af$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $e3ef6305be93c7af$var$CheckboxRoot,
        className: (0, $9QePP.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $b748e9827e4898eb$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $e3ef6305be93c7af$export$2e2bcd8739ae039 = $e3ef6305be93c7af$var$Checkbox;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $3Hg1x = parcelRequire("3Hg1x");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $4ae0c5c6bd551796$export$717666c39ec07e12(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiFormControlLabel', slot);
}
const $4ae0c5c6bd551796$var$formControlLabelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $4ae0c5c6bd551796$export$2e2bcd8739ae039 = $4ae0c5c6bd551796$var$formControlLabelClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e29860be68ec3320$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $4ae0c5c6bd551796$export$717666c39ec07e12), classes);
};
const $e29860be68ec3320$export$1b479270917a5676 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $e29860be68ec3320$var$AsteriskComponent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $e29860be68ec3320$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $e29860be68ec3320$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $9QePP.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e29860be68ec3320$export$1b479270917a5676, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($e29860be68ec3320$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $e29860be68ec3320$export$2e2bcd8739ae039 = $e29860be68ec3320$var$FormControlLabel;



function $57722e66549ea09a$export$2e2bcd8739ae039() {
    const [email, setEmail] = (0, $acw62.useState)('');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [rememberMe, setRememberMe] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const [logoUrl, setLogoUrl] = (0, $acw62.useState)('');
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        const fetchLogoUrl = async ()=>{
            const { data: data } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).storage.from('image').getPublicUrl('brand_logo.png');
            setLogoUrl(data.publicUrl);
        };
        fetchLogoUrl();
    }, []);
    async function handleSignIn(e) {
        e.preventDefault();
        const { error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.signInWithPassword({
            email: email,
            password: password
        });
        if (error) setError(error.message);
        else navigate('/camera');
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
            sx: {
                maxWidth: 400,
                mx: 'auto',
                mt: 4,
                p: 2
            },
            square: false,
            elevation: 4,
            children: [
                logoUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: logoUrl,
                    alt: "Logo",
                    style: {
                        width: '100%',
                        height: 'auto',
                        marginBottom: '16px'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h5",
                    children: "Login"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSignIn,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Email",
                            fullWidth: true,
                            margin: "normal",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            label: "Password",
                            type: "password",
                            fullWidth: true,
                            margin: "normal",
                            value: password,
                            onChange: (e)=>setPassword(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
                                checked: rememberMe,
                                onChange: (e)=>setRememberMe(e.target.checked)
                            }),
                            label: "Remember Me"
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            color: "error",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            type: "submit",
                            variant: "contained",
                            fullWidth: true,
                            sx: {
                                mt: 2
                            },
                            children: "Sign In"
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $bf2dbd940d8d1ee7$exports(r) || $efa3fde0b6100532$exports(r, e) || $51f08ebed50a2438$exports(r, e) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $602e4de33c4d0183$exports = {};
"use strict";
Object.defineProperty($602e4de33c4d0183$exports, "__esModule", {
    value: true
});
$602e4de33c4d0183$exports.bindAll = $602e4de33c4d0183$exports.bind = void 0;
var $c5bbcbe38ba49ef4$exports = {};
"use strict";
Object.defineProperty($c5bbcbe38ba49ef4$exports, "__esModule", {
    value: true
});
$c5bbcbe38ba49ef4$exports.bind = void 0;
function $c5bbcbe38ba49ef4$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$c5bbcbe38ba49ef4$exports.bind = $c5bbcbe38ba49ef4$var$bind;


Object.defineProperty($602e4de33c4d0183$exports, "bind", {
    enumerable: true,
    get: function() {
        return $c5bbcbe38ba49ef4$exports.bind;
    }
});
var $c74f78a9926000a3$exports = {};
"use strict";
var $c74f78a9926000a3$var$__assign = $c74f78a9926000a3$exports && $c74f78a9926000a3$exports.__assign || function() {
    $c74f78a9926000a3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c74f78a9926000a3$var$__assign.apply(this, arguments);
};
Object.defineProperty($c74f78a9926000a3$exports, "__esModule", {
    value: true
});
$c74f78a9926000a3$exports.bindAll = void 0;

function $c74f78a9926000a3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $c74f78a9926000a3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c74f78a9926000a3$var$__assign($c74f78a9926000a3$var$__assign({}, original), {
        options: $c74f78a9926000a3$var$__assign($c74f78a9926000a3$var$__assign({}, $c74f78a9926000a3$var$toOptions(sharedOptions)), $c74f78a9926000a3$var$toOptions(original.options))
    });
    return binding;
}
function $c74f78a9926000a3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c74f78a9926000a3$var$getBinding(original, sharedOptions);
        return (0, $c5bbcbe38ba49ef4$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$c74f78a9926000a3$exports.bindAll = $c74f78a9926000a3$var$bindAll;


Object.defineProperty($602e4de33c4d0183$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $c74f78a9926000a3$exports.bindAll;
    }
});



// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $5af51a2135a003ac$export$6eafea55f7947469 = 'data-pdnd-honey-pot';


function $283a5152aff51e26$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $5af51a2135a003ac$export$6eafea55f7947469));
}


function $ecbad2b94d3ba5d7$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $283a5152aff51e26$export$821bdcd739a2706b)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}


var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;
var $b77c8068776c2a21$exports = {};

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $010f4e0e13c82e16$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $97e4f199c1b7193b$export$7d0a15ee70427305 = 2147483647;



function $4fc58260d57fd988$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fc58260d57fd988$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fc58260d57fd988$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fc58260d57fd988$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4fc58260d57fd988$var$honeyPotSize = 2;
var $4fc58260d57fd988$var$halfHoneyPotSize = $4fc58260d57fd988$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $4fc58260d57fd988$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $4fc58260d57fd988$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $4fc58260d57fd988$var$halfHoneyPotSize,
        y: point.y - $4fc58260d57fd988$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4fc58260d57fd988$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $4fc58260d57fd988$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $4fc58260d57fd988$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $4fc58260d57fd988$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $4fc58260d57fd988$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $4fc58260d57fd988$var$preventGoingForwardsOffScreen($4fc58260d57fd988$var$preventGoingBackwardsOffScreen($4fc58260d57fd988$var$pullBackByHalfHoneyPotSize($4fc58260d57fd988$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $4fc58260d57fd988$var$honeyPotSize,
        height: $4fc58260d57fd988$var$honeyPotSize
    });
}
function $4fc58260d57fd988$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $4fc58260d57fd988$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $4fc58260d57fd988$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $5af51a2135a003ac$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $4fc58260d57fd988$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $4fc58260d57fd988$var$_objectSpread($4fc58260d57fd988$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $4fc58260d57fd988$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $97e4f199c1b7193b$export$7d0a15ee70427305)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $602e4de33c4d0183$exports.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $4fc58260d57fd988$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $4fc58260d57fd988$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($4fc58260d57fd988$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $602e4de33c4d0183$exports.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $4fc58260d57fd988$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $602e4de33c4d0183$exports.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $4fc58260d57fd988$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};

function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1e0ecff44bad0ea1$exports(r);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;



var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $41f5c206613f56c9$exports(r) || $cce79e023a3a67e7$exports(r) || $51f08ebed50a2438$exports(r) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;





/** Provide a function that you only ever want to be called a single time */ function $9a3003d7f2341560$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}


var $48965b868d61cb9c$export$b7d78993b74f766d = (0, $9a3003d7f2341560$export$d2de3aaeafa91619)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});



var $dcc663c8d046b643$export$95df08bae54cb4df = (0, $9a3003d7f2341560$export$d2de3aaeafa91619)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});




/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $b60692aace78371d$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $b60692aace78371d$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $dcc663c8d046b643$export$95df08bae54cb4df)()) return false;
    return dragEnter.hasOwnProperty($b60692aace78371d$var$symbols.isEnteringWindow);
}
function $b60692aace78371d$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $dcc663c8d046b643$export$95df08bae54cb4df)()) return false;
    return dragLeave.hasOwnProperty($b60692aace78371d$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $dcc663c8d046b643$export$95df08bae54cb4df)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $602e4de33c4d0183$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$b60692aace78371d$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$b60692aace78371d$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();


/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $f3d3f50eeb4a63d6$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $f3d3f50eeb4a63d6$export$e46810fef53b5b0e(eventTarget) {
    return $f3d3f50eeb4a63d6$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}


function $76be943fd292ee18$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $dcc663c8d046b643$export$95df08bae54cb4df)()) return (0, $b60692aace78371d$export$f21837c338005454)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $48965b868d61cb9c$export$b7d78993b74f766d)()) return (0, $f3d3f50eeb4a63d6$export$e46810fef53b5b0e)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}


function $c02b3882c40dbd96$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}


function $45ca3dcf5eb7145b$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}


var $8f52a5054f09a665$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8f52a5054f09a665$export$2e2bcd8739ae039 = $8f52a5054f09a665$var$rafSchd;


var $a2b2d2813eb5c722$var$scheduleOnDrag = (0, $8f52a5054f09a665$export$2e2bcd8739ae039)(function(fn) {
    return fn();
});
var $a2b2d2813eb5c722$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $a2b2d2813eb5c722$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $a2b2d2813eb5c722$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $a2b2d2813eb5c722$var$dragStart.flush();
            $a2b2d2813eb5c722$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $a2b2d2813eb5c722$var$scheduleOnDrag(function() {
                $a2b2d2813eb5c722$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $a2b2d2813eb5c722$var$dragStart.flush();
            $a2b2d2813eb5c722$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}


var $8b23a668efba0488$var$globalState = {
    isActive: false
};
function $8b23a668efba0488$var$canStart() {
    return !$8b23a668efba0488$var$globalState.isActive;
}
function $8b23a668efba0488$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $8b23a668efba0488$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $8b23a668efba0488$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$8b23a668efba0488$var$canStart()) return;
    var initial = $8b23a668efba0488$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $8b23a668efba0488$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $8b23a668efba0488$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $a2b2d2813eb5c722$export$9f13ecc44e83d682)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $8b23a668efba0488$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $45ca3dcf5eb7145b$export$7c112ceec8941e67)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $283a5152aff51e26$export$821bdcd739a2706b)(event.target) ? (0, $ecbad2b94d3ba5d7$export$81d0353f25f5dd)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $8b23a668efba0488$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $8b23a668efba0488$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $602e4de33c4d0183$exports.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $76be943fd292ee18$export$57d220c74e84a273)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $45ca3dcf5eb7145b$export$7c112ceec8941e67)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $8b23a668efba0488$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $45ca3dcf5eb7145b$export$7c112ceec8941e67)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))((0, $c02b3882c40dbd96$export$ac5e5b0daf997b2)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $8b23a668efba0488$var$getNativeSetDragImage(event)
    });
}
function $8b23a668efba0488$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $8b23a668efba0488$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $45ca3dcf5eb7145b$export$7c112ceec8941e67)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $8b23a668efba0488$export$3efdceeb8ca25c51 = {
    canStart: $8b23a668efba0488$var$canStart,
    start: $8b23a668efba0488$var$start
};


// Extending `Map` to allow us to link Key and Values together
var $e04aa3a457000d64$var$ledger = new Map();
function $e04aa3a457000d64$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $e04aa3a457000d64$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $e04aa3a457000d64$var$ledger.set(typeKey, initial);
    return initial;
}
function $e04aa3a457000d64$export$6503ec6e8aabbaf(args) {
    var entry = $e04aa3a457000d64$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $e04aa3a457000d64$var$ledger.delete(args.typeKey);
    };
}




/** Create a new combined function that will call all the provided functions */ function $d453ec773833617e$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}



function $7ab53996d2b59441$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}


function $1b8292b88c4a57a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8292b88c4a57a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8292b88c4a57a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8292b88c4a57a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8292b88c4a57a8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1b8292b88c4a57a8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1b8292b88c4a57a8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1b8292b88c4a57a8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1b8292b88c4a57a8$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $1b8292b88c4a57a8$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $d453ec773833617e$export$1be1fc439b849fdf)((0, $7ab53996d2b59441$export$5dcb5c23b6ba980a)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $9a3003d7f2341560$export$d2de3aaeafa91619)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $1b8292b88c4a57a8$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $1b8292b88c4a57a8$var$copyReverse(current);
        var actualCaptureOrdered = $1b8292b88c4a57a8$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($1b8292b88c4a57a8$var$_objectSpread($1b8292b88c4a57a8$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $1b8292b88c4a57a8$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}




function $d1e0ea191414d51e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $d1e0ea191414d51e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $d1e0ea191414d51e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $d1e0ea191414d51e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $d1e0ea191414d51e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $d1e0ea191414d51e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $d1e0ea191414d51e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1e0ea191414d51e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1e0ea191414d51e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1e0ea191414d51e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1e0ea191414d51e$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $d1e0ea191414d51e$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $9a3003d7f2341560$export$d2de3aaeafa91619)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $d1e0ea191414d51e$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}


function $50e9e5adc7c613fd$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $d1e0ea191414d51e$export$5dd4ed888d5b12ca)();
    var dropTargetAPI = (0, $1b8292b88c4a57a8$export$47d10e7bd9c81890)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $8b23a668efba0488$export$3efdceeb8ca25c51).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $8b23a668efba0488$export$3efdceeb8ca25c51).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $e04aa3a457000d64$export$6503ec6e8aabbaf)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}






var $4ccbd8c1d4cf98a2$export$a11b0059900ceec8 = (0, $9a3003d7f2341560$export$d2de3aaeafa91619)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $4ccbd8c1d4cf98a2$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';



// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $0565a3c110eeed03$export$fd3d00026297c0ad = 'text/plain';


// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $d192c1f59100e50e$export$4c44a460f123106 = 'text/uri-list';


/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $eff2cf0ca066f9dd$export$c9c4cc54e73b125d = 'application/vnd.pdnd';


var $6ba4b1aafdc6c74e$var$draggableRegistry = new WeakMap();
function $6ba4b1aafdc6c74e$var$addToRegistry(args) {
    $6ba4b1aafdc6c74e$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $6ba4b1aafdc6c74e$var$draggableRegistry.delete(args.element);
    };
}
var $6ba4b1aafdc6c74e$var$honeyPotFix = (0, $4fc58260d57fd988$export$8ecad27c959e89e0)();
var $6ba4b1aafdc6c74e$var$adapter = (0, $50e9e5adc7c613fd$export$2aa3a33160990d96)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $d453ec773833617e$export$1be1fc439b849fdf)($6ba4b1aafdc6c74e$var$honeyPotFix.bindEvents(), (0, $602e4de33c4d0183$exports.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $6ba4b1aafdc6c74e$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $45ca3dcf5eb7145b$export$7c112ceec8941e67)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $ecbad2b94d3ba5d7$export$81d0353f25f5dd)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $4ccbd8c1d4cf98a2$export$a11b0059900ceec8)() && !event.dataTransfer.types.includes((0, $0565a3c110eeed03$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $d192c1f59100e50e$export$4c44a460f123106))) event.dataTransfer.setData((0, $0565a3c110eeed03$export$fd3d00026297c0ad), (0, $4ccbd8c1d4cf98a2$export$aceb3ed8b7f7bd2c));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $eff2cf0ca066f9dd$export$c9c4cc54e73b125d), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $6ba4b1aafdc6c74e$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $6ba4b1aafdc6c74e$var$honeyPotFix.getOnPostDispatch()
});
var $6ba4b1aafdc6c74e$export$e7140b68045b5036 = $6ba4b1aafdc6c74e$var$adapter.dropTarget;
var $6ba4b1aafdc6c74e$export$59a074bac4c54f54 = $6ba4b1aafdc6c74e$var$adapter.monitor;
function $6ba4b1aafdc6c74e$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $d453ec773833617e$export$1be1fc439b849fdf)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $6ba4b1aafdc6c74e$var$adapter.registerUsage(), $6ba4b1aafdc6c74e$var$addToRegistry(args), (0, $7ab53996d2b59441$export$5dcb5c23b6ba980a)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $9a3003d7f2341560$export$d2de3aaeafa91619)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 


 // Payload for the draggable being dragged




var $acw62 = parcelRequire("acw62");

/** @jsxImportSource @emotion/react */ 
var $ayMG0 = parcelRequire("ayMG0");

var $eP9YU = parcelRequire("eP9YU");
parcelRequire("acw62");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
parcelRequire("8ajhZ");
parcelRequire("8rteH");
parcelRequire("2lACw");
var $67eb8f8e9d5e3981$export$ffb0004e005737fa = $ayMG0.Fragment;
var $67eb8f8e9d5e3981$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $eP9YU.h).call(props, 'css')) return $ayMG0.jsx(type, props, key);
    return $ayMG0.jsx((0, $eP9YU.E), (0, $eP9YU.c)(type, props), key);
};
var $67eb8f8e9d5e3981$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $eP9YU.h).call(props, 'css')) return $ayMG0.jsxs(type, props, key);
    return $ayMG0.jsxs((0, $eP9YU.E), (0, $eP9YU.c)(type, props), key);
};


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $d145bd79772829f1$export$368bacef0dacbe05 = 25;
var $d145bd79772829f1$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $d145bd79772829f1$export$30fa1a2e62ae150c = {
    none: $d145bd79772829f1$export$38b928a7167ce124.none,
    small: $d145bd79772829f1$export$38b928a7167ce124.small * $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER,
    medium: $d145bd79772829f1$export$38b928a7167ce124.medium * $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER,
    large: $d145bd79772829f1$export$38b928a7167ce124.large * $d145bd79772829f1$var$EXITING_MOTION_MULTIPLIER
};

var $e9ca40ca2325ac8e$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $e9ca40ca2325ac8e$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $e9ca40ca2325ac8e$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $e9ca40ca2325ac8e$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';








/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e39d81369b0c277ebeac5d0b02ae5cb>>
 * @codegenCommand yarn build tokens
 */ var $0e229c6308825451$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body'
};
var $0e229c6308825451$export$2e2bcd8739ae039 = $0e229c6308825451$var$tokens;


var $8eae9f6324a7c469$export$4ef52930e33717cd = 'data-theme';
var $8eae9f6324a7c469$export$a00eac3f8684bcd0 = 'data-color-mode';
var $8eae9f6324a7c469$export$2112803007239c61 = 'data-contrast-mode';
var $8eae9f6324a7c469$export$352e418ed5b6193a = 'data-custom-theme';
var $8eae9f6324a7c469$export$6f0c6fb8c80fcc92 = 'ds';
var $8eae9f6324a7c469$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $8eae9f6324a7c469$export$dddac1532e822863 = "--".concat($8eae9f6324a7c469$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8eae9f6324a7c469$export$9d7b58831ae93caa = "--".concat($8eae9f6324a7c469$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $533ab0667c222708$var$token(path, fallback) {
    var token = (0, $0e229c6308825451$export$2e2bcd8739ae039)[path];
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $8eae9f6324a7c469$export$dddac1532e822863);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $533ab0667c222708$export$2e2bcd8739ae039 = $533ab0667c222708$var$token;



var $jjlaj = parcelRequire("jjlaj");

// https://caniuse.com/mdn-javascript_builtins_number_isfinite
const $99a156a15cd35eb3$var$isFiniteNumber = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
const $99a156a15cd35eb3$var$isSafeInteger = Number.isSafeInteger || function(value) {
    return typeof value === 'number' && Math.abs(value) <= $99a156a15cd35eb3$var$MAX_SAFE_INTEGER;
};
const $99a156a15cd35eb3$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
let $99a156a15cd35eb3$export$43a750ddd9f2303e = /*#__PURE__*/ function(ErrorTypes) {
    // Identifier for a network error (loading error / timeout ...)
    ErrorTypes["NETWORK_ERROR"] = "networkError";
    // Identifier for a media Error (video/parsing/mediasource error)
    ErrorTypes["MEDIA_ERROR"] = "mediaError";
    // EME (encrypted media extensions) errors
    ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
    // Identifier for a mux Error (demuxing/remuxing)
    ErrorTypes["MUX_ERROR"] = "muxError";
    // Identifier for all other errors
    ErrorTypes["OTHER_ERROR"] = "otherError";
    return ErrorTypes;
}({});
let $99a156a15cd35eb3$export$d053ec805ce391aa = /*#__PURE__*/ function(ErrorDetails) {
    ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
    ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
    ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
    ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
    ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
    ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
    ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
    ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
    ErrorDetails["KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR"] = "keySystemDestroyMediaKeysError";
    ErrorDetails["KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR"] = "keySystemDestroyCloseSessionError";
    ErrorDetails["KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR"] = "keySystemDestroyRemoveSessionError";
    // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
    // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
    // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
    ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
    // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
    ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
    // Identifier for a level which contains no fragments - data: { url: faulty URL, reason: "no fragments found in level", level: index of the bad level }
    ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
    // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
    // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
    // Identifier for a level parse error - data: { url : faulty URL, error: Error, reason: error message }
    ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
    // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
    ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
    // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
    // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
    // Identifier for a subtitle track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
    // Identifier for a subtitle track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
    // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
    // Identifier for fragment load timeout error - data: { frag : fragment object}
    ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
    // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
    ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
    // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
    // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
    ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
    // Identifier for a fragment or part load skipped because of a GAP tag or attribute
    ErrorDetails["FRAG_GAP"] = "fragGap";
    // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
    ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
    // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
    // Identifier for decrypt key load timeout error - data: { frag : fragment object}
    ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
    // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : { error : exception , mimeType : mimeType }
    ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
    // Triggered when source buffer(s) could not be created using level (manifest CODECS attribute), parsed media, or best guess codec(s) - data: { reason : error reason }
    ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
    // Identifier for a buffer append error - data: append error description
    ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
    // Identifier for a buffer appending error event - data: appending error description
    ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
    // Identifier for a buffer stalled error event
    ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
    // Identifier for a buffer full event
    ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
    // Identifier for a buffer seek over hole event
    ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
    // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
    ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
    // Identifier for a Interstitial Asset List load error - data: { url: faulty URL, response: { code: error code, text: error text } }
    ErrorDetails["ASSET_LIST_LOAD_ERROR"] = "assetListLoadError";
    // Identifier for a Interstitial Asset List load timeout - data: { url: faulty URL, response: { code: error code, text: error text } }
    ErrorDetails["ASSET_LIST_LOAD_TIMEOUT"] = "assetListLoadTimeout";
    // Identifier for a Interstitial Asset List parsing error - data: { url : faulty URL, reason : error reason, response : { code: error code, text: error text }}
    ErrorDetails["ASSET_LIST_PARSING_ERROR"] = "assetListParsingError";
    // Identifier for a Interstitial Asset List parsing error - data: { url : faulty URL, reason : error reason, response : { code: error code, text: error text }}
    ErrorDetails["INTERSTITIAL_ASSET_ITEM_ERROR"] = "interstitialAssetItemError";
    // Identifier for an internal exception happening inside hls.js while handling an event
    ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
    // Identifier for an internal call to abort a loader
    ErrorDetails["INTERNAL_ABORTED"] = "aborted";
    // Triggered when attachMedia fails
    ErrorDetails["ATTACH_MEDIA_ERROR"] = "attachMediaError";
    // Uncategorized error
    ErrorDetails["UNKNOWN"] = "unknown";
    return ErrorDetails;
}({});
let $99a156a15cd35eb3$export$ada873a34909da65 = /*#__PURE__*/ function(Events) {
    // Fired before MediaSource is attaching to media element
    Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
    // Fired when MediaSource has been successfully attached to media element
    Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
    // Fired before detaching MediaSource from media element
    Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
    // Fired when MediaSource has been detached from media element
    Events["MEDIA_DETACHED"] = "hlsMediaDetached";
    // Fired when HTMLMediaElement dispatches "ended" event, or stalls at end of VOD program
    Events["MEDIA_ENDED"] = "hlsMediaEnded";
    // Fired after playback stall is resolved with playing, seeked, or ended event following BUFFER_STALLED_ERROR
    Events["STALL_RESOLVED"] = "hlsStallResolved";
    // Fired when the buffer is going to be reset
    Events["BUFFER_RESET"] = "hlsBufferReset";
    // Fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
    Events["BUFFER_CODECS"] = "hlsBufferCodecs";
    // fired when sourcebuffers have been created - data: { tracks : tracks }
    Events["BUFFER_CREATED"] = "hlsBufferCreated";
    // fired when we append a segment to the buffer - data: { segment: segment object }
    Events["BUFFER_APPENDING"] = "hlsBufferAppending";
    // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
    Events["BUFFER_APPENDED"] = "hlsBufferAppended";
    // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
    Events["BUFFER_EOS"] = "hlsBufferEos";
    // fired when all buffers are full to the end of the program, after calling MediaSource.endOfStream() (unless restricted)
    Events["BUFFERED_TO_END"] = "hlsBufferedToEnd";
    // fired when the media buffer should be flushed - data { startOffset, endOffset }
    Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
    // fired when the media buffer has been flushed - data: { }
    Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
    // fired to signal that a manifest loading starts - data: { url : manifestURL}
    Events["MANIFEST_LOADING"] = "hlsManifestLoading";
    // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks ], url : manifestURL, stats : LoaderStats }
    Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
    // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
    Events["MANIFEST_PARSED"] = "hlsManifestParsed";
    // fired when a level switch is requested - data: { level : id of new level }
    Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
    // fired when a level switch is effective - data: { level : id of new level }
    Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
    // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
    Events["LEVEL_LOADING"] = "hlsLevelLoading";
    // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : LoaderStats }
    Events["LEVEL_LOADED"] = "hlsLevelLoaded";
    // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
    Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
    // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
    Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
    // fired to notify that levels have changed after removing a level - data: { levels : [available quality levels] }
    Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
    // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
    Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
    // fired when an audio track switching is requested - data: { id : audio track id }
    Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
    // fired when an audio track switch actually occurs - data: { id : audio track id }
    Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
    // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
    Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
    // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : LoaderStats }
    Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
    // fired when an audio tracks's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, id : track id }
    Events["AUDIO_TRACK_UPDATED"] = "hlsAudioTrackUpdated";
    // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
    Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
    // fired to notify that subtitle tracks were cleared as a result of stopping the media
    Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
    // fired when an subtitle track switch occurs - data: { id : subtitle track id }
    Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
    // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
    Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
    // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : LoaderStats }
    Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
    // fired when a subtitle  racks's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, id : track id }
    Events["SUBTITLE_TRACK_UPDATED"] = "hlsSubtitleTrackUpdated";
    // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
    Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
    // fired when a set of VTTCues to be managed externally has been parsed - data: { type: string, track: string, cues: [ VTTCue ] }
    Events["CUES_PARSED"] = "hlsCuesParsed";
    // fired when a text track to be managed externally is found - data: { tracks: [ { label: string, kind: string, default: boolean } ] }
    Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
    // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, timescale: timescale, frag : fragment object }
    Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
    // fired when a fragment loading starts - data: { frag : fragment object }
    Events["FRAG_LOADING"] = "hlsFragLoading";
    // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
    // FRAG_LOAD_PROGRESS = 'hlsFragLoadProgress',
    // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
    Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
    // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : LoaderStats }
    Events["FRAG_LOADED"] = "hlsFragLoaded";
    // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
    Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
    // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
    Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
    // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
    Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
    // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
    Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
    // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
    // FRAG_PARSING_DATA = 'hlsFragParsingData',
    // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
    Events["FRAG_PARSED"] = "hlsFragParsed";
    // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : LoaderStats }
    Events["FRAG_BUFFERED"] = "hlsFragBuffered";
    // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
    Events["FRAG_CHANGED"] = "hlsFragChanged";
    // Identifier for a FPS drop event - data: { currentDropped, currentDecoded, totalDroppedFrames }
    Events["FPS_DROP"] = "hlsFpsDrop";
    // triggered when FPS drop triggers auto level capping - data: { level, droppedLevel }
    Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
    // triggered when maxAutoLevel changes - data { autoLevelCapping, levels, maxAutoLevel, minAutoLevel, maxHdcpLevel }
    Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
    // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
    Events["ERROR"] = "hlsError";
    // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
    Events["DESTROYING"] = "hlsDestroying";
    // fired when a decrypt key loading starts - data: { frag : fragment object }
    Events["KEY_LOADING"] = "hlsKeyLoading";
    // fired when a decrypt key loading is completed - data: { frag : fragment object, keyInfo : KeyLoaderInfo }
    Events["KEY_LOADED"] = "hlsKeyLoaded";
    // deprecated; please use BACK_BUFFER_REACHED - data : { bufferEnd: number }
    Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
    // fired when the back buffer is reached as defined by the backBufferLength config option - data : { bufferEnd: number }
    Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
    // fired after steering manifest has been loaded - data: { steeringManifest: SteeringManifest object, url: steering manifest URL }
    Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
    // fired when asset list has begun loading
    Events["ASSET_LIST_LOADING"] = "hlsAssetListLoading";
    // fired when a valid asset list is loaded
    Events["ASSET_LIST_LOADED"] = "hlsAssetListLoaded";
    // fired when the list of Interstitial Events and Interstitial Schedule is updated
    Events["INTERSTITIALS_UPDATED"] = "hlsInterstitialsUpdated";
    // fired when the buffer reaches an Interstitial Schedule boundary (both Primary segments and Interstitial Assets)
    Events["INTERSTITIALS_BUFFERED_TO_BOUNDARY"] = "hlsInterstitialsBufferedToBoundary";
    // fired when a player instance for an Interstitial Asset has been created
    Events["INTERSTITIAL_ASSET_PLAYER_CREATED"] = "hlsInterstitialAssetPlayerCreated";
    // Interstitial playback started
    Events["INTERSTITIAL_STARTED"] = "hlsInterstitialStarted";
    // InterstitialAsset playback started
    Events["INTERSTITIAL_ASSET_STARTED"] = "hlsInterstitialAssetStarted";
    // InterstitialAsset playback ended
    Events["INTERSTITIAL_ASSET_ENDED"] = "hlsInterstitialAssetEnded";
    // InterstitialAsset playback errored
    Events["INTERSTITIAL_ASSET_ERROR"] = "hlsInterstitialAssetError";
    // Interstitial playback ended
    Events["INTERSTITIAL_ENDED"] = "hlsInterstitialEnded";
    // Interstitial schedule resumed primary playback
    Events["INTERSTITIALS_PRIMARY_RESUMED"] = "hlsInterstitialsPrimaryResumed";
    // Interstitial players dispatch this event when playout limit is reached
    Events["PLAYOUT_LIMIT_REACHED"] = "hlsPlayoutLimitReached";
    // Event DateRange cue "enter" event dispatched
    Events["EVENT_CUE_ENTER"] = "hlsEventCueEnter";
    return Events;
}({});
/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */ var $99a156a15cd35eb3$var$PlaylistContextType = {
    MANIFEST: "manifest",
    LEVEL: "level",
    AUDIO_TRACK: "audioTrack",
    SUBTITLE_TRACK: "subtitleTrack"
};
var $99a156a15cd35eb3$export$e15fb1a9320a1882 = {
    MAIN: "main",
    AUDIO: "audio",
    SUBTITLE: "subtitle"
};
/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */ class $99a156a15cd35eb3$var$EWMA {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    constructor(halfLife, estimate = 0, weight = 0){
        this.halfLife = void 0;
        this.alpha_ = void 0;
        this.estimate_ = void 0;
        this.totalWeight_ = void 0;
        this.halfLife = halfLife;
        // Larger values of alpha expire historical data more slowly.
        this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
        this.estimate_ = estimate;
        this.totalWeight_ = weight;
    }
    sample(weight, value) {
        const adjAlpha = Math.pow(this.alpha_, weight);
        this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
        this.totalWeight_ += weight;
    }
    getTotalWeight() {
        return this.totalWeight_;
    }
    getEstimate() {
        if (this.alpha_) {
            const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
            if (zeroFactor) return this.estimate_ / zeroFactor;
        }
        return this.estimate_;
    }
}
/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */ class $99a156a15cd35eb3$var$EwmaBandWidthEstimator {
    constructor(slow, fast, defaultEstimate, defaultTTFB = 100){
        this.defaultEstimate_ = void 0;
        this.minWeight_ = void 0;
        this.minDelayMs_ = void 0;
        this.slow_ = void 0;
        this.fast_ = void 0;
        this.defaultTTFB_ = void 0;
        this.ttfb_ = void 0;
        this.defaultEstimate_ = defaultEstimate;
        this.minWeight_ = 0.001;
        this.minDelayMs_ = 50;
        this.slow_ = new $99a156a15cd35eb3$var$EWMA(slow);
        this.fast_ = new $99a156a15cd35eb3$var$EWMA(fast);
        this.defaultTTFB_ = defaultTTFB;
        this.ttfb_ = new $99a156a15cd35eb3$var$EWMA(slow);
    }
    update(slow, fast) {
        const { slow_: slow_, fast_: fast_, ttfb_: ttfb_ } = this;
        if (slow_.halfLife !== slow) this.slow_ = new $99a156a15cd35eb3$var$EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
        if (fast_.halfLife !== fast) this.fast_ = new $99a156a15cd35eb3$var$EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
        if (ttfb_.halfLife !== slow) this.ttfb_ = new $99a156a15cd35eb3$var$EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
    sample(durationMs, numBytes) {
        durationMs = Math.max(durationMs, this.minDelayMs_);
        const numBits = 8 * numBytes;
        // weight is duration in seconds
        const durationS = durationMs / 1000;
        // value is bandwidth in bits/s
        const bandwidthInBps = numBits / durationS;
        this.fast_.sample(durationS, bandwidthInBps);
        this.slow_.sample(durationS, bandwidthInBps);
    }
    sampleTTFB(ttfb) {
        // weight is frequency curve applied to TTFB in seconds
        // (longer times have less weight with expected input under 1 second)
        const seconds = ttfb / 1000;
        const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
        this.ttfb_.sample(weight, Math.max(ttfb, 5));
    }
    canEstimate() {
        return this.fast_.getTotalWeight() >= this.minWeight_;
    }
    getEstimate() {
        if (this.canEstimate()) // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
        else return this.defaultEstimate_;
    }
    getEstimateTTFB() {
        if (this.ttfb_.getTotalWeight() >= this.minWeight_) return this.ttfb_.getEstimate();
        else return this.defaultTTFB_;
    }
    get defaultEstimate() {
        return this.defaultEstimate_;
    }
    destroy() {}
}
function $99a156a15cd35eb3$var$_defineProperty(e, r, t) {
    return (r = $99a156a15cd35eb3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $99a156a15cd35eb3$var$_extends() {
    return $99a156a15cd35eb3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $99a156a15cd35eb3$var$_extends.apply(null, arguments);
}
function $99a156a15cd35eb3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99a156a15cd35eb3$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99a156a15cd35eb3$var$ownKeys(Object(t), true).forEach(function(r) {
            $99a156a15cd35eb3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99a156a15cd35eb3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $99a156a15cd35eb3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $99a156a15cd35eb3$var$_toPropertyKey(t) {
    var i = $99a156a15cd35eb3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
class $99a156a15cd35eb3$var$Logger {
    constructor(label, logger){
        this.trace = void 0;
        this.debug = void 0;
        this.log = void 0;
        this.warn = void 0;
        this.info = void 0;
        this.error = void 0;
        const lb = `[${label}]:`;
        this.trace = $99a156a15cd35eb3$var$noop;
        this.debug = logger.debug.bind(null, lb);
        this.log = logger.log.bind(null, lb);
        this.warn = logger.warn.bind(null, lb);
        this.info = logger.info.bind(null, lb);
        this.error = logger.error.bind(null, lb);
    }
}
const $99a156a15cd35eb3$var$noop = function noop() {};
const $99a156a15cd35eb3$var$fakeLogger = {
    trace: $99a156a15cd35eb3$var$noop,
    debug: $99a156a15cd35eb3$var$noop,
    log: $99a156a15cd35eb3$var$noop,
    warn: $99a156a15cd35eb3$var$noop,
    info: $99a156a15cd35eb3$var$noop,
    error: $99a156a15cd35eb3$var$noop
};
function $99a156a15cd35eb3$var$createLogger() {
    return $99a156a15cd35eb3$var$_extends({}, $99a156a15cd35eb3$var$fakeLogger);
}
// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function $99a156a15cd35eb3$var$consolePrintFn(type, id) {
    const func = self.console[type];
    return func ? func.bind(self.console, `${id ? '[' + id + '] ' : ''}[${type}] >`) : $99a156a15cd35eb3$var$noop;
}
function $99a156a15cd35eb3$var$getLoggerFn(key, debugConfig, id) {
    return debugConfig[key] ? debugConfig[key].bind(debugConfig) : $99a156a15cd35eb3$var$consolePrintFn(key, id);
}
const $99a156a15cd35eb3$var$exportedLogger = $99a156a15cd35eb3$var$createLogger();
function $99a156a15cd35eb3$var$enableLogs(debugConfig, context, id) {
    // check that console is available
    const newLogger = $99a156a15cd35eb3$var$createLogger();
    if (typeof console === 'object' && debugConfig === true || typeof debugConfig === 'object') {
        const keys = [
            // Remove out from list here to hard-disable a log-level
            // 'trace',
            'debug',
            'log',
            'info',
            'warn',
            'error'
        ];
        keys.forEach((key)=>{
            newLogger[key] = $99a156a15cd35eb3$var$getLoggerFn(key, debugConfig, id);
        });
        // Some browsers don't allow to use bind on console object anyway
        // fallback to default if needed
        try {
            newLogger.log(`Debug logs enabled for "${context}" in hls.js version ${"1.6.5"}`);
        } catch (e) {
            /* log fn threw an exception. All logger methods are no-ops. */ return $99a156a15cd35eb3$var$createLogger();
        }
        // global exported logger uses the same functions as new logger without `id`
        keys.forEach((key)=>{
            $99a156a15cd35eb3$var$exportedLogger[key] = $99a156a15cd35eb3$var$getLoggerFn(key, debugConfig);
        });
    } else // Reset global exported logger
    $99a156a15cd35eb3$var$_extends($99a156a15cd35eb3$var$exportedLogger, newLogger);
    return newLogger;
}
const $99a156a15cd35eb3$var$logger = $99a156a15cd35eb3$var$exportedLogger;
function $99a156a15cd35eb3$export$a92854129bc50f89(preferManagedMediaSource = true) {
    if (typeof self === 'undefined') return undefined;
    const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
    return mms || self.MediaSource || self.WebKitMediaSource;
}
function $99a156a15cd35eb3$var$isManagedMediaSource(source) {
    return typeof self !== 'undefined' && source === self.ManagedMediaSource;
}
function $99a156a15cd35eb3$var$isCompatibleTrackChange(currentTracks, requiredTracks) {
    const trackNames = Object.keys(currentTracks);
    const requiredTrackNames = Object.keys(requiredTracks);
    const trackCount = trackNames.length;
    const requiredTrackCount = requiredTrackNames.length;
    return !trackCount || !requiredTrackCount || trackCount === requiredTrackCount && !trackNames.some((name)=>requiredTrackNames.indexOf(name) === -1);
}
// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */ /**
 * Converts a UTF-8 array to a string.
 *
 * @param array - The UTF-8 array to convert
 *
 * @returns The string
 *
 * @group Utils
 *
 * @beta
 */ function $99a156a15cd35eb3$var$utf8ArrayToStr(array, exitOnNull = false) {
    if (typeof TextDecoder !== 'undefined') {
        const decoder = new TextDecoder('utf-8');
        const decoded = decoder.decode(array);
        if (exitOnNull) {
            // grab up to the first null
            const idx = decoded.indexOf('\0');
            return idx !== -1 ? decoded.substring(0, idx) : decoded;
        }
        // remove any null characters
        return decoded.replace(/\0/g, '');
    }
    const len = array.length;
    let c;
    let char2;
    let char3;
    let out = '';
    let i = 0;
    while(i < len){
        c = array[i++];
        if (c === 0x00 && exitOnNull) return out;
        else if (c === 0x00 || c === 0x03) continue;
        switch(c >> 4){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += String.fromCharCode(c);
                break;
            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                char2 = array[i++];
                out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
                break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
                break;
        }
    }
    return out;
}
/**
 *  hex dump helper class
 */ const $99a156a15cd35eb3$var$Hex = {
    hexDump: function(array) {
        let str = '';
        for(let i = 0; i < array.length; i++){
            let h = array[i].toString(16);
            if (h.length < 2) h = '0' + h;
            str += h;
        }
        return str;
    }
};
function $99a156a15cd35eb3$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $99a156a15cd35eb3$var$urlToolkit = {
    exports: {}
};
var $99a156a15cd35eb3$var$hasRequiredUrlToolkit;
function $99a156a15cd35eb3$var$requireUrlToolkit() {
    if ($99a156a15cd35eb3$var$hasRequiredUrlToolkit) return $99a156a15cd35eb3$var$urlToolkit.exports;
    $99a156a15cd35eb3$var$hasRequiredUrlToolkit = 1;
    (function(module, exports) {
        // see https://tools.ietf.org/html/rfc1808
        (function(root) {
            var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
            var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
            var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
            var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
            var URLToolkit = {
                // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                // E.g
                // With opts.alwaysNormalize = false (default, spec compliant)
                // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                // With opts.alwaysNormalize = true (not spec compliant)
                // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                buildAbsoluteURL: function(baseURL, relativeURL, opts) {
                    opts = opts || {};
                    // remove any remaining space and CRLF
                    baseURL = baseURL.trim();
                    relativeURL = relativeURL.trim();
                    if (!relativeURL) {
                        // 2a) If the embedded URL is entirely empty, it inherits the
                        // entire base URL (i.e., is set equal to the base URL)
                        // and we are done.
                        if (!opts.alwaysNormalize) return baseURL;
                        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                        if (!basePartsForNormalise) throw new Error('Error trying to parse base URL.');
                        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                        return URLToolkit.buildURLFromParts(basePartsForNormalise);
                    }
                    var relativeParts = URLToolkit.parseURL(relativeURL);
                    if (!relativeParts) throw new Error('Error trying to parse relative URL.');
                    if (relativeParts.scheme) {
                        // 2b) If the embedded URL starts with a scheme name, it is
                        // interpreted as an absolute URL and we are done.
                        if (!opts.alwaysNormalize) return relativeURL;
                        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                        return URLToolkit.buildURLFromParts(relativeParts);
                    }
                    var baseParts = URLToolkit.parseURL(baseURL);
                    if (!baseParts) throw new Error('Error trying to parse base URL.');
                    if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
                        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                        baseParts.netLoc = pathParts[1];
                        baseParts.path = pathParts[2];
                    }
                    if (baseParts.netLoc && !baseParts.path) baseParts.path = '/';
                    var builtParts = {
                        // 2c) Otherwise, the embedded URL inherits the scheme of
                        // the base URL.
                        scheme: baseParts.scheme,
                        netLoc: relativeParts.netLoc,
                        path: null,
                        params: relativeParts.params,
                        query: relativeParts.query,
                        fragment: relativeParts.fragment
                    };
                    if (!relativeParts.netLoc) {
                        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                        // (if any) of the base URL.
                        builtParts.netLoc = baseParts.netLoc;
                        // 4) If the embedded URL path is preceded by a slash "/", the
                        // path is not relative and we skip to Step 7.
                        if (relativeParts.path[0] !== '/') {
                            if (!relativeParts.path) {
                                // 5) If the embedded URL path is empty (and not preceded by a
                                // slash), then the embedded URL inherits the base URL path
                                builtParts.path = baseParts.path;
                                // 5a) if the embedded URL's <params> is non-empty, we skip to
                                // step 7; otherwise, it inherits the <params> of the base
                                // URL (if any) and
                                if (!relativeParts.params) {
                                    builtParts.params = baseParts.params;
                                    // 5b) if the embedded URL's <query> is non-empty, we skip to
                                    // step 7; otherwise, it inherits the <query> of the base
                                    // URL (if any) and we skip to step 7.
                                    if (!relativeParts.query) builtParts.query = baseParts.query;
                                }
                            } else {
                                // 6) The last segment of the base URL's path (anything
                                // following the rightmost slash "/", or the entire path if no
                                // slash is present) is removed and the embedded URL's path is
                                // appended in its place.
                                var baseURLPath = baseParts.path;
                                var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
                                builtParts.path = URLToolkit.normalizePath(newPath);
                            }
                        }
                    }
                    if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
                    return URLToolkit.buildURLFromParts(builtParts);
                },
                parseURL: function(url) {
                    var parts = URL_REGEX.exec(url);
                    if (!parts) return null;
                    return {
                        scheme: parts[1] || '',
                        netLoc: parts[2] || '',
                        path: parts[3] || '',
                        params: parts[4] || '',
                        query: parts[5] || '',
                        fragment: parts[6] || ''
                    };
                },
                normalizePath: function(path) {
                    // The following operations are
                    // then applied, in order, to the new path:
                    // 6a) All occurrences of "./", where "." is a complete path
                    // segment, are removed.
                    // 6b) If the path ends with "." as a complete path segment,
                    // that "." is removed.
                    path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
                    // 6c) All occurrences of "<segment>/../", where <segment> is a
                    // complete path segment not equal to "..", are removed.
                    // Removal of these path segments is performed iteratively,
                    // removing the leftmost matching pattern on each iteration,
                    // until no matching pattern remains.
                    // 6d) If the path ends with "<segment>/..", where <segment> is a
                    // complete path segment not equal to "..", that
                    // "<segment>/.." is removed.
                    while(path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length);
                    return path.split('').reverse().join('');
                },
                buildURLFromParts: function(parts) {
                    return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
                }
            };
            module.exports = URLToolkit;
        })();
    })($99a156a15cd35eb3$var$urlToolkit);
    return $99a156a15cd35eb3$var$urlToolkit.exports;
}
var $99a156a15cd35eb3$var$urlToolkitExports = $99a156a15cd35eb3$var$requireUrlToolkit();
class $99a156a15cd35eb3$export$792da06d301cf8fe {
    constructor(){
        this.aborted = false;
        this.loaded = 0;
        this.retry = 0;
        this.total = 0;
        this.chunkCount = 0;
        this.bwEstimate = 0;
        this.loading = {
            start: 0,
            first: 0,
            end: 0
        };
        this.parsing = {
            start: 0,
            end: 0
        };
        this.buffering = {
            start: 0,
            first: 0,
            end: 0
        };
    }
}
var $99a156a15cd35eb3$var$ElementaryStreamTypes = {
    AUDIO: "audio",
    VIDEO: "video",
    AUDIOVIDEO: "audiovideo"
};
class $99a156a15cd35eb3$export$dbfafecac5663ca {
    constructor(base){
        this._byteRange = null;
        this._url = null;
        this._stats = null;
        this._streams = null;
        // baseurl is the URL to the playlist
        this.base = void 0;
        // relurl is the portion of the URL that comes from inside the playlist.
        this.relurl = void 0;
        if (typeof base === 'string') base = {
            url: base
        };
        this.base = base;
        $99a156a15cd35eb3$var$makeEnumerable(this, 'stats');
    }
    // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
    setByteRange(value, previous) {
        const params = value.split('@', 2);
        let start;
        if (params.length === 1) start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
        else start = parseInt(params[1]);
        this._byteRange = [
            start,
            parseInt(params[0]) + start
        ];
    }
    get baseurl() {
        return this.base.url;
    }
    get byteRange() {
        if (this._byteRange === null) return [];
        return this._byteRange;
    }
    get byteRangeStartOffset() {
        return this.byteRange[0];
    }
    get byteRangeEndOffset() {
        return this.byteRange[1];
    }
    get elementaryStreams() {
        if (this._streams === null) this._streams = {
            [$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO]: null,
            [$99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO]: null,
            [$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIOVIDEO]: null
        };
        return this._streams;
    }
    set elementaryStreams(value) {
        this._streams = value;
    }
    get hasStats() {
        return this._stats !== null;
    }
    get hasStreams() {
        return this._streams !== null;
    }
    get stats() {
        if (this._stats === null) this._stats = new $99a156a15cd35eb3$export$792da06d301cf8fe();
        return this._stats;
    }
    set stats(value) {
        this._stats = value;
    }
    get url() {
        if (!this._url && this.baseurl && this.relurl) this._url = $99a156a15cd35eb3$var$urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
            alwaysNormalize: true
        });
        return this._url || '';
    }
    set url(value) {
        this._url = value;
    }
    clearElementaryStreamInfo() {
        const { elementaryStreams: elementaryStreams } = this;
        elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO] = null;
        elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO] = null;
        elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIOVIDEO] = null;
    }
}
function $99a156a15cd35eb3$var$isMediaFragment(frag) {
    return frag.sn !== 'initSegment';
}
/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */ class $99a156a15cd35eb3$export$ffb0004e005737fa extends $99a156a15cd35eb3$export$dbfafecac5663ca {
    constructor(type, base){
        super(base);
        this._decryptdata = null;
        this._programDateTime = null;
        this._ref = null;
        // Approximate bit rate of the fragment expressed in bits per second (bps) as indicated by the last EXT-X-BITRATE (kbps) tag
        this._bitrate = void 0;
        this.rawProgramDateTime = null;
        this.tagList = [];
        // EXTINF has to be present for a m3u8 to be considered valid
        this.duration = 0;
        // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
        this.sn = 0;
        // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
        // core difference from the private field _decryptdata is the lack of the initialized IV
        // _decryptdata will set the IV for this segment based on the segment number in the fragment
        this.levelkeys = void 0;
        // A string representing the fragment type
        this.type = void 0;
        // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
        this.loader = null;
        // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
        this.keyLoader = null;
        // The level/track index to which the fragment belongs
        this.level = -1;
        // The continuity counter of the fragment
        this.cc = 0;
        // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
        this.startPTS = void 0;
        // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
        this.endPTS = void 0;
        // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
        this.startDTS = void 0;
        // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
        this.endDTS = void 0;
        // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
        this.start = 0;
        // The offset time (seconds) of the fragment from the start of the Playlist
        this.playlistOffset = 0;
        // Set by `updateFragPTSDTS` in level-helper
        this.deltaPTS = void 0;
        // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
        this.maxStartPTS = void 0;
        // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
        this.minEndPTS = void 0;
        // Init Segment bytes (unset for media segments)
        this.data = void 0;
        // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
        this.bitrateTest = false;
        // #EXTINF  segment title
        this.title = null;
        // The Media Initialization Section for this segment
        this.initSegment = null;
        // Fragment is the last fragment in the media playlist
        this.endList = void 0;
        // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
        this.gap = void 0;
        // Deprecated
        this.urlId = 0;
        this.type = type;
    }
    get byteLength() {
        if (this.hasStats) {
            const total = this.stats.total;
            if (total) return total;
        }
        if (this.byteRange) {
            const start = this.byteRange[0];
            const end = this.byteRange[1];
            if ($99a156a15cd35eb3$var$isFiniteNumber(start) && $99a156a15cd35eb3$var$isFiniteNumber(end)) return end - start;
        }
        return null;
    }
    get bitrate() {
        if (this.byteLength) return this.byteLength * 8 / this.duration;
        if (this._bitrate) return this._bitrate;
        return null;
    }
    set bitrate(value) {
        this._bitrate = value;
    }
    get decryptdata() {
        const { levelkeys: levelkeys } = this;
        if (!levelkeys && !this._decryptdata) return null;
        if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
            const key = this.levelkeys.identity;
            if (key) this._decryptdata = key.getDecryptData(this.sn);
            else {
                const keyFormats = Object.keys(this.levelkeys);
                if (keyFormats.length === 1) return this._decryptdata = this.levelkeys[keyFormats[0]].getDecryptData(this.sn);
            }
        }
        return this._decryptdata;
    }
    get end() {
        return this.start + this.duration;
    }
    get endProgramDateTime() {
        if (this.programDateTime === null) return null;
        const duration = !$99a156a15cd35eb3$var$isFiniteNumber(this.duration) ? 0 : this.duration;
        return this.programDateTime + duration * 1000;
    }
    get encrypted() {
        var _this$_decryptdata;
        // At the m3u8-parser level we need to add support for manifest signalled keyformats
        // when we want the fragment to start reporting that it is encrypted.
        // Currently, keyFormat will only be set for identity keys
        if ((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.encrypted) return true;
        else if (this.levelkeys) {
            const keyFormats = Object.keys(this.levelkeys);
            const len = keyFormats.length;
            if (len > 1 || len === 1 && this.levelkeys[keyFormats[0]].encrypted) return true;
        }
        return false;
    }
    get programDateTime() {
        if (this._programDateTime === null && this.rawProgramDateTime) this.programDateTime = Date.parse(this.rawProgramDateTime);
        return this._programDateTime;
    }
    set programDateTime(value) {
        if (!$99a156a15cd35eb3$var$isFiniteNumber(value)) {
            this._programDateTime = this.rawProgramDateTime = null;
            return;
        }
        this._programDateTime = value;
    }
    get ref() {
        if (!$99a156a15cd35eb3$var$isMediaFragment(this)) return null;
        if (!this._ref) this._ref = {
            base: this.base,
            start: this.start,
            duration: this.duration,
            sn: this.sn,
            programDateTime: this.programDateTime
        };
        return this._ref;
    }
    addStart(value) {
        this.setStart(this.start + value);
    }
    setStart(value) {
        this.start = value;
        if (this._ref) this._ref.start = value;
    }
    setDuration(value) {
        this.duration = value;
        if (this._ref) this._ref.duration = value;
    }
    setKeyFormat(keyFormat) {
        if (this.levelkeys) {
            const key = this.levelkeys[keyFormat];
            if (key && !this._decryptdata) this._decryptdata = key.getDecryptData(this.sn);
        }
    }
    abortRequests() {
        var _this$loader, _this$keyLoader;
        (_this$loader = this.loader) == null || _this$loader.abort();
        (_this$keyLoader = this.keyLoader) == null || _this$keyLoader.abort();
    }
    setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
        const { elementaryStreams: elementaryStreams } = this;
        const info = elementaryStreams[type];
        if (!info) {
            elementaryStreams[type] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS,
                partial: partial
            };
            return;
        }
        info.startPTS = Math.min(info.startPTS, startPTS);
        info.endPTS = Math.max(info.endPTS, endPTS);
        info.startDTS = Math.min(info.startDTS, startDTS);
        info.endDTS = Math.max(info.endDTS, endDTS);
    }
}
/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */ class $99a156a15cd35eb3$export$7b5bf7981d51054e extends $99a156a15cd35eb3$export$dbfafecac5663ca {
    constructor(partAttrs, frag, base, index, previous){
        super(base);
        this.fragOffset = 0;
        this.duration = 0;
        this.gap = false;
        this.independent = false;
        this.relurl = void 0;
        this.fragment = void 0;
        this.index = void 0;
        this.duration = partAttrs.decimalFloatingPoint('DURATION');
        this.gap = partAttrs.bool('GAP');
        this.independent = partAttrs.bool('INDEPENDENT');
        this.relurl = partAttrs.enumeratedString('URI');
        this.fragment = frag;
        this.index = index;
        const byteRange = partAttrs.enumeratedString('BYTERANGE');
        if (byteRange) this.setByteRange(byteRange, previous);
        if (previous) this.fragOffset = previous.fragOffset + previous.duration;
    }
    get start() {
        return this.fragment.start + this.fragOffset;
    }
    get end() {
        return this.start + this.duration;
    }
    get loaded() {
        const { elementaryStreams: elementaryStreams } = this;
        return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
    }
}
function $99a156a15cd35eb3$var$getOwnPropertyDescriptorFromPrototypeChain(object, property) {
    const prototype = Object.getPrototypeOf(object);
    if (prototype) {
        const propertyDescriptor = Object.getOwnPropertyDescriptor(prototype, property);
        if (propertyDescriptor) return propertyDescriptor;
        return $99a156a15cd35eb3$var$getOwnPropertyDescriptorFromPrototypeChain(prototype, property);
    }
}
function $99a156a15cd35eb3$var$makeEnumerable(object, property) {
    const d = $99a156a15cd35eb3$var$getOwnPropertyDescriptorFromPrototypeChain(object, property);
    if (d) {
        d.enumerable = true;
        Object.defineProperty(object, property, d);
    }
}
const $99a156a15cd35eb3$var$UINT32_MAX$1 = Math.pow(2, 32) - 1;
const $99a156a15cd35eb3$var$push = [].push;
// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const $99a156a15cd35eb3$var$RemuxerTrackIdConfig = {
    video: 1,
    audio: 2,
    id3: 3,
    text: 4
};
function $99a156a15cd35eb3$var$bin2str(data) {
    return String.fromCharCode.apply(null, data);
}
function $99a156a15cd35eb3$var$readUint16(buffer, offset) {
    const val = buffer[offset] << 8 | buffer[offset + 1];
    return val < 0 ? 65536 + val : val;
}
function $99a156a15cd35eb3$var$readUint32(buffer, offset) {
    const val = $99a156a15cd35eb3$var$readSint32(buffer, offset);
    return val < 0 ? 4294967296 + val : val;
}
function $99a156a15cd35eb3$var$readUint64(buffer, offset) {
    let result = $99a156a15cd35eb3$var$readUint32(buffer, offset);
    result *= Math.pow(2, 32);
    result += $99a156a15cd35eb3$var$readUint32(buffer, offset + 4);
    return result;
}
function $99a156a15cd35eb3$var$readSint32(buffer, offset) {
    return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
function $99a156a15cd35eb3$var$writeUint32(buffer, offset, value) {
    buffer[offset] = value >> 24;
    buffer[offset + 1] = value >> 16 & 0xff;
    buffer[offset + 2] = value >> 8 & 0xff;
    buffer[offset + 3] = value & 0xff;
}
// Find "moof" box
function $99a156a15cd35eb3$var$hasMoofData(data) {
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = $99a156a15cd35eb3$var$readUint32(data, i);
        if (size > 8 && data[i + 4] === 0x6d && data[i + 5] === 0x6f && data[i + 6] === 0x6f && data[i + 7] === 0x66) return true;
        i = size > 1 ? i + size : end;
    }
    return false;
}
// Find the data for a box specified by its path
function $99a156a15cd35eb3$var$findBox(data, path) {
    const results = [];
    if (!path.length) // short-circuit the search for empty paths
    return results;
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = $99a156a15cd35eb3$var$readUint32(data, i);
        const type = $99a156a15cd35eb3$var$bin2str(data.subarray(i + 4, i + 8));
        const endbox = size > 1 ? i + size : end;
        if (type === path[0]) {
            if (path.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data.subarray(i + 8, endbox));
            else {
                // recursively search for the next box along the path
                const subresults = $99a156a15cd35eb3$var$findBox(data.subarray(i + 8, endbox), path.slice(1));
                if (subresults.length) $99a156a15cd35eb3$var$push.apply(results, subresults);
            }
        }
        i = endbox;
    }
    // we've finished searching all of data
    return results;
}
function $99a156a15cd35eb3$var$parseSegmentIndex(sidx) {
    const references = [];
    const version = sidx[0];
    // set initial offset, we skip the reference ID (not needed)
    let index = 8;
    const timescale = $99a156a15cd35eb3$var$readUint32(sidx, index);
    index += 4;
    let earliestPresentationTime = 0;
    let firstOffset = 0;
    if (version === 0) {
        earliestPresentationTime = $99a156a15cd35eb3$var$readUint32(sidx, index);
        firstOffset = $99a156a15cd35eb3$var$readUint32(sidx, index + 4);
        index += 8;
    } else {
        earliestPresentationTime = $99a156a15cd35eb3$var$readUint64(sidx, index);
        firstOffset = $99a156a15cd35eb3$var$readUint64(sidx, index + 8);
        index += 16;
    }
    // skip reserved
    index += 2;
    let startByte = sidx.length + firstOffset;
    const referencesCount = $99a156a15cd35eb3$var$readUint16(sidx, index);
    index += 2;
    for(let i = 0; i < referencesCount; i++){
        let referenceIndex = index;
        const referenceInfo = $99a156a15cd35eb3$var$readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        const referenceSize = referenceInfo & 0x7fffffff;
        const referenceType = (referenceInfo & 0x80000000) >>> 31;
        if (referenceType === 1) {
            $99a156a15cd35eb3$var$logger.warn('SIDX has hierarchical references (not supported)');
            return null;
        }
        const subsegmentDuration = $99a156a15cd35eb3$var$readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        references.push({
            referenceSize: referenceSize,
            subsegmentDuration: subsegmentDuration,
            // unscaled
            info: {
                duration: subsegmentDuration / timescale,
                start: startByte,
                end: startByte + referenceSize - 1
            }
        });
        startByte += referenceSize;
        // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
        // for |sapDelta|.
        referenceIndex += 4;
        // skip to next ref
        index = referenceIndex;
    }
    return {
        earliestPresentationTime: earliestPresentationTime,
        timescale: timescale,
        version: version,
        referencesCount: referencesCount,
        references: references
    };
}
/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */ function $99a156a15cd35eb3$var$parseInitSegment(initSegment) {
    const result = [];
    const traks = $99a156a15cd35eb3$var$findBox(initSegment, [
        'moov',
        'trak'
    ]);
    for(let i = 0; i < traks.length; i++){
        const trak = traks[i];
        const tkhd = $99a156a15cd35eb3$var$findBox(trak, [
            'tkhd'
        ])[0];
        if (tkhd) {
            let version = tkhd[0];
            const trackId = $99a156a15cd35eb3$var$readUint32(tkhd, version === 0 ? 12 : 20);
            const mdhd = $99a156a15cd35eb3$var$findBox(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) {
                version = mdhd[0];
                const timescale = $99a156a15cd35eb3$var$readUint32(mdhd, version === 0 ? 12 : 20);
                const hdlr = $99a156a15cd35eb3$var$findBox(trak, [
                    'mdia',
                    'hdlr'
                ])[0];
                if (hdlr) {
                    const hdlrType = $99a156a15cd35eb3$var$bin2str(hdlr.subarray(8, 12));
                    const type = {
                        soun: $99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO,
                        vide: $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO
                    }[hdlrType];
                    // Parse codec details
                    const stsdBox = $99a156a15cd35eb3$var$findBox(trak, [
                        'mdia',
                        'minf',
                        'stbl',
                        'stsd'
                    ])[0];
                    const stsd = $99a156a15cd35eb3$var$parseStsd(stsdBox);
                    if (type) {
                        // Add 'audio', 'video', and 'audiovideo' track records that will map to SourceBuffers
                        result[trackId] = {
                            timescale: timescale,
                            type: type,
                            stsd: stsd
                        };
                        result[type] = $99a156a15cd35eb3$var$_objectSpread2({
                            timescale: timescale,
                            id: trackId
                        }, stsd);
                    } else // Add 'meta' and other track records required by `offsetStartDTS`
                    result[trackId] = {
                        timescale: timescale,
                        type: hdlrType,
                        stsd: stsd
                    };
                }
            }
        }
    }
    const trex = $99a156a15cd35eb3$var$findBox(initSegment, [
        'moov',
        'mvex',
        'trex'
    ]);
    trex.forEach((trex)=>{
        const trackId = $99a156a15cd35eb3$var$readUint32(trex, 4);
        const track = result[trackId];
        if (track) track.default = {
            duration: $99a156a15cd35eb3$var$readUint32(trex, 12),
            flags: $99a156a15cd35eb3$var$readUint32(trex, 20)
        };
    });
    return result;
}
function $99a156a15cd35eb3$var$parseStsd(stsd) {
    const sampleEntries = stsd.subarray(8);
    const sampleEntriesEnd = sampleEntries.subarray(86);
    const fourCC = $99a156a15cd35eb3$var$bin2str(sampleEntries.subarray(4, 8));
    let codec = fourCC;
    let supplemental;
    const encrypted = fourCC === 'enca' || fourCC === 'encv';
    if (encrypted) {
        const encBox = $99a156a15cd35eb3$var$findBox(sampleEntries, [
            fourCC
        ])[0];
        const encBoxChildren = encBox.subarray(fourCC === 'enca' ? 28 : 78);
        const sinfs = $99a156a15cd35eb3$var$findBox(encBoxChildren, [
            'sinf'
        ]);
        sinfs.forEach((sinf)=>{
            const schm = $99a156a15cd35eb3$var$findBox(sinf, [
                'schm'
            ])[0];
            if (schm) {
                const scheme = $99a156a15cd35eb3$var$bin2str(schm.subarray(4, 8));
                if (scheme === 'cbcs' || scheme === 'cenc') {
                    const frma = $99a156a15cd35eb3$var$findBox(sinf, [
                        'frma'
                    ])[0];
                    if (frma) // for encrypted content codec fourCC will be in frma
                    codec = $99a156a15cd35eb3$var$bin2str(frma);
                }
            }
        });
    }
    const codecFourCC = codec;
    switch(codec){
        case 'avc1':
        case 'avc2':
        case 'avc3':
        case 'avc4':
            {
                // extract profile + compatibility + level out of avcC box
                const avcCBox = $99a156a15cd35eb3$var$findBox(sampleEntriesEnd, [
                    'avcC'
                ])[0];
                if (avcCBox && avcCBox.length > 3) {
                    codec += '.' + $99a156a15cd35eb3$var$toHex(avcCBox[1]) + $99a156a15cd35eb3$var$toHex(avcCBox[2]) + $99a156a15cd35eb3$var$toHex(avcCBox[3]);
                    supplemental = $99a156a15cd35eb3$var$parseSupplementalDoViCodec(codecFourCC === 'avc1' ? 'dva1' : 'dvav', sampleEntriesEnd);
                }
                break;
            }
        case 'mp4a':
            {
                const codecBox = $99a156a15cd35eb3$var$findBox(sampleEntries, [
                    fourCC
                ])[0];
                const esdsBox = $99a156a15cd35eb3$var$findBox(codecBox.subarray(28), [
                    'esds'
                ])[0];
                if (esdsBox && esdsBox.length > 7) {
                    let i = 4;
                    // ES Descriptor tag
                    if (esdsBox[i++] !== 0x03) break;
                    i = $99a156a15cd35eb3$var$skipBERInteger(esdsBox, i);
                    i += 2; // skip es_id;
                    const flags = esdsBox[i++];
                    if (flags & 0x80) i += 2; // skip dependency es_id
                    if (flags & 0x40) i += esdsBox[i++]; // skip URL
                    // Decoder config descriptor
                    if (esdsBox[i++] !== 0x04) break;
                    i = $99a156a15cd35eb3$var$skipBERInteger(esdsBox, i);
                    const objectType = esdsBox[i++];
                    if (objectType === 0x40) codec += '.' + $99a156a15cd35eb3$var$toHex(objectType);
                    else break;
                    i += 12;
                    // Decoder specific info
                    if (esdsBox[i++] !== 0x05) break;
                    i = $99a156a15cd35eb3$var$skipBERInteger(esdsBox, i);
                    const firstByte = esdsBox[i++];
                    let audioObjectType = (firstByte & 0xf8) >> 3;
                    if (audioObjectType === 31) audioObjectType += 1 + ((firstByte & 0x7) << 3) + ((esdsBox[i] & 0xe0) >> 5);
                    codec += '.' + audioObjectType;
                }
                break;
            }
        case 'hvc1':
        case 'hev1':
            {
                const hvcCBox = $99a156a15cd35eb3$var$findBox(sampleEntriesEnd, [
                    'hvcC'
                ])[0];
                if (hvcCBox && hvcCBox.length > 12) {
                    const profileByte = hvcCBox[1];
                    const profileSpace = [
                        '',
                        'A',
                        'B',
                        'C'
                    ][profileByte >> 6];
                    const generalProfileIdc = profileByte & 0x1f;
                    const profileCompat = $99a156a15cd35eb3$var$readUint32(hvcCBox, 2);
                    const tierFlag = (profileByte & 0x20) >> 5 ? 'H' : 'L';
                    const levelIDC = hvcCBox[12];
                    const constraintIndicator = hvcCBox.subarray(6, 12);
                    codec += '.' + profileSpace + generalProfileIdc;
                    codec += '.' + $99a156a15cd35eb3$var$reverse32BitInt(profileCompat).toString(16).toUpperCase();
                    codec += '.' + tierFlag + levelIDC;
                    let constraintString = '';
                    for(let i = constraintIndicator.length; i--;){
                        const byte = constraintIndicator[i];
                        if (byte || constraintString) {
                            const encodedByte = byte.toString(16).toUpperCase();
                            constraintString = '.' + encodedByte + constraintString;
                        }
                    }
                    codec += constraintString;
                }
                supplemental = $99a156a15cd35eb3$var$parseSupplementalDoViCodec(codecFourCC == 'hev1' ? 'dvhe' : 'dvh1', sampleEntriesEnd);
                break;
            }
        case 'dvh1':
        case 'dvhe':
        case 'dvav':
        case 'dva1':
        case 'dav1':
            codec = $99a156a15cd35eb3$var$parseSupplementalDoViCodec(codec, sampleEntriesEnd) || codec;
            break;
        case 'vp09':
            {
                const vpcCBox = $99a156a15cd35eb3$var$findBox(sampleEntriesEnd, [
                    'vpcC'
                ])[0];
                if (vpcCBox && vpcCBox.length > 6) {
                    const profile = vpcCBox[4];
                    const level = vpcCBox[5];
                    const bitDepth = vpcCBox[6] >> 4 & 0x0f;
                    codec += '.' + $99a156a15cd35eb3$var$addLeadingZero(profile) + '.' + $99a156a15cd35eb3$var$addLeadingZero(level) + '.' + $99a156a15cd35eb3$var$addLeadingZero(bitDepth);
                }
                break;
            }
        case 'av01':
            {
                const av1CBox = $99a156a15cd35eb3$var$findBox(sampleEntriesEnd, [
                    'av1C'
                ])[0];
                if (av1CBox && av1CBox.length > 2) {
                    const profile = av1CBox[1] >>> 5;
                    const level = av1CBox[1] & 0x1f;
                    const tierFlag = av1CBox[2] >>> 7 ? 'H' : 'M';
                    const highBitDepth = (av1CBox[2] & 0x40) >> 6;
                    const twelveBit = (av1CBox[2] & 0x20) >> 5;
                    const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
                    const monochrome = (av1CBox[2] & 0x10) >> 4;
                    const chromaSubsamplingX = (av1CBox[2] & 0x08) >> 3;
                    const chromaSubsamplingY = (av1CBox[2] & 0x04) >> 2;
                    const chromaSamplePosition = av1CBox[2] & 0x03;
                    // TODO: parse color_description_present_flag
                    // default it to BT.709/limited range for now
                    // more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
                    const colorPrimaries = 1;
                    const transferCharacteristics = 1;
                    const matrixCoefficients = 1;
                    const videoFullRangeFlag = 0;
                    codec += '.' + profile + '.' + $99a156a15cd35eb3$var$addLeadingZero(level) + tierFlag + '.' + $99a156a15cd35eb3$var$addLeadingZero(bitDepth) + '.' + monochrome + '.' + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + '.' + $99a156a15cd35eb3$var$addLeadingZero(colorPrimaries) + '.' + $99a156a15cd35eb3$var$addLeadingZero(transferCharacteristics) + '.' + $99a156a15cd35eb3$var$addLeadingZero(matrixCoefficients) + '.' + videoFullRangeFlag;
                    supplemental = $99a156a15cd35eb3$var$parseSupplementalDoViCodec('dav1', sampleEntriesEnd);
                }
                break;
            }
    }
    return {
        codec: codec,
        encrypted: encrypted,
        supplemental: supplemental
    };
}
function $99a156a15cd35eb3$var$parseSupplementalDoViCodec(fourCC, sampleEntriesEnd) {
    const dvvCResult = $99a156a15cd35eb3$var$findBox(sampleEntriesEnd, [
        'dvvC'
    ]); // used by DoVi Profile 8 to 10
    const dvXCBox = dvvCResult.length ? dvvCResult[0] : $99a156a15cd35eb3$var$findBox(sampleEntriesEnd, [
        'dvcC'
    ])[0]; // used by DoVi Profiles up to 7 and 20
    if (dvXCBox) {
        const doViProfile = dvXCBox[2] >> 1 & 0x7f;
        const doViLevel = dvXCBox[2] << 5 & 0x20 | dvXCBox[3] >> 3 & 0x1f;
        return fourCC + '.' + $99a156a15cd35eb3$var$addLeadingZero(doViProfile) + '.' + $99a156a15cd35eb3$var$addLeadingZero(doViLevel);
    }
}
function $99a156a15cd35eb3$var$reverse32BitInt(val) {
    let result = 0;
    for(let i = 0; i < 32; i++)result |= (val >> i & 1) << 31 - i;
    return result >>> 0;
}
function $99a156a15cd35eb3$var$skipBERInteger(bytes, i) {
    const limit = i + 5;
    while(bytes[i++] & 0x80 && i < limit);
    return i;
}
function $99a156a15cd35eb3$var$toHex(x) {
    return ('0' + x.toString(16).toUpperCase()).slice(-2);
}
function $99a156a15cd35eb3$var$addLeadingZero(num) {
    return (num < 10 ? '0' : '') + num;
}
function $99a156a15cd35eb3$var$patchEncyptionData(initSegment, decryptdata) {
    if (!initSegment || !decryptdata) return initSegment;
    const keyId = decryptdata.keyId;
    if (keyId && decryptdata.isCommonEncryption) {
        const traks = $99a156a15cd35eb3$var$findBox(initSegment, [
            'moov',
            'trak'
        ]);
        traks.forEach((trak)=>{
            const stsd = $99a156a15cd35eb3$var$findBox(trak, [
                'mdia',
                'minf',
                'stbl',
                'stsd'
            ])[0];
            // skip the sample entry count
            const sampleEntries = stsd.subarray(8);
            let encBoxes = $99a156a15cd35eb3$var$findBox(sampleEntries, [
                'enca'
            ]);
            const isAudio = encBoxes.length > 0;
            if (!isAudio) encBoxes = $99a156a15cd35eb3$var$findBox(sampleEntries, [
                'encv'
            ]);
            encBoxes.forEach((enc)=>{
                const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
                const sinfBoxes = $99a156a15cd35eb3$var$findBox(encBoxChildren, [
                    'sinf'
                ]);
                sinfBoxes.forEach((sinf)=>{
                    const tenc = $99a156a15cd35eb3$var$parseSinf(sinf);
                    if (tenc) {
                        // Look for default key id (keyID offset is always 8 within the tenc box):
                        const tencKeyId = tenc.subarray(8, 24);
                        if (!tencKeyId.some((b)=>b !== 0)) {
                            $99a156a15cd35eb3$var$logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${$99a156a15cd35eb3$var$Hex.hexDump(tencKeyId)} -> ${$99a156a15cd35eb3$var$Hex.hexDump(keyId)}`);
                            tenc.set(keyId, 8);
                        }
                    }
                });
            });
        });
    }
    return initSegment;
}
function $99a156a15cd35eb3$var$parseSinf(sinf) {
    const schm = $99a156a15cd35eb3$var$findBox(sinf, [
        'schm'
    ])[0];
    if (schm) {
        const scheme = $99a156a15cd35eb3$var$bin2str(schm.subarray(4, 8));
        if (scheme === 'cbcs' || scheme === 'cenc') return $99a156a15cd35eb3$var$findBox(sinf, [
            'schi',
            'tenc'
        ])[0];
    }
    return null;
}
/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */ function $99a156a15cd35eb3$var$getSampleData(data, initData, logger) {
    const tracks = {};
    const trafs = $99a156a15cd35eb3$var$findBox(data, [
        'moof',
        'traf'
    ]);
    for(let i = 0; i < trafs.length; i++){
        const traf = trafs[i];
        // There is only one tfhd & trun per traf
        // This is true for CMAF style content, and we should perhaps check the ftyp
        // and only look for a single trun then, but for ISOBMFF we should check
        // for multiple track runs.
        const tfhd = $99a156a15cd35eb3$var$findBox(traf, [
            'tfhd'
        ])[0];
        // get the track id from the tfhd
        const id = $99a156a15cd35eb3$var$readUint32(tfhd, 4);
        const track = initData[id];
        if (!track) continue;
        const trackTimes = tracks[id] || (tracks[id] = {
            start: NaN,
            duration: 0,
            sampleCount: 0,
            timescale: track.timescale,
            type: track.type
        });
        // get start DTS
        const tfdt = $99a156a15cd35eb3$var$findBox(traf, [
            'tfdt'
        ])[0];
        if (tfdt) {
            const version = tfdt[0];
            let baseTime = $99a156a15cd35eb3$var$readUint32(tfdt, 4);
            if (version === 1) {
                // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
                // This prevents large values from being used for initPTS, which can cause playlist sync issues.
                // https://github.com/video-dev/hls.js/issues/5303
                if (baseTime === $99a156a15cd35eb3$var$UINT32_MAX$1) logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
                else {
                    baseTime *= $99a156a15cd35eb3$var$UINT32_MAX$1 + 1;
                    baseTime += $99a156a15cd35eb3$var$readUint32(tfdt, 8);
                }
            }
            if ($99a156a15cd35eb3$var$isFiniteNumber(baseTime) && (!$99a156a15cd35eb3$var$isFiniteNumber(trackTimes.start) || baseTime < trackTimes.start)) trackTimes.start = baseTime;
        }
        const trackDefault = track.default;
        const tfhdFlags = $99a156a15cd35eb3$var$readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
        let defaultSampleDuration = (trackDefault == null ? void 0 : trackDefault.duration) || 0;
        if (tfhdFlags & 0x000008) {
            // 0x000008 indicates the presence of the default_sample_duration field
            if (tfhdFlags & 0x000002) // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
            // If present, the default_sample_duration exists at byte offset 12
            defaultSampleDuration = $99a156a15cd35eb3$var$readUint32(tfhd, 12);
            else // Otherwise, the duration is at byte offset 8
            defaultSampleDuration = $99a156a15cd35eb3$var$readUint32(tfhd, 8);
        }
        const truns = $99a156a15cd35eb3$var$findBox(traf, [
            'trun'
        ]);
        let sampleDTS = trackTimes.start || 0;
        let rawDuration = 0;
        let sampleDuration = defaultSampleDuration;
        for(let j = 0; j < truns.length; j++){
            const trun = truns[j];
            const sampleCount = $99a156a15cd35eb3$var$readUint32(trun, 4);
            const sampleIndex = trackTimes.sampleCount;
            trackTimes.sampleCount += sampleCount;
            // Get duration from samples
            const dataOffsetPresent = trun[3] & 0x01;
            const firstSampleFlagsPresent = trun[3] & 0x04;
            const sampleDurationPresent = trun[2] & 0x01;
            const sampleSizePresent = trun[2] & 0x02;
            const sampleFlagsPresent = trun[2] & 0x04;
            const sampleCompositionTimeOffsetPresent = trun[2] & 0x08;
            let offset = 8;
            let remaining = sampleCount;
            if (dataOffsetPresent) offset += 4;
            if (firstSampleFlagsPresent && sampleCount) {
                const isNonSyncSample = trun[offset + 1] & 0x01;
                if (!isNonSyncSample && trackTimes.keyFrameIndex === undefined) trackTimes.keyFrameIndex = sampleIndex;
                offset += 4;
                if (sampleDurationPresent) {
                    sampleDuration = $99a156a15cd35eb3$var$readUint32(trun, offset);
                    offset += 4;
                } else sampleDuration = defaultSampleDuration;
                if (sampleSizePresent) offset += 4;
                if (sampleCompositionTimeOffsetPresent) offset += 4;
                sampleDTS += sampleDuration;
                rawDuration += sampleDuration;
                remaining--;
            }
            while(remaining--){
                if (sampleDurationPresent) {
                    sampleDuration = $99a156a15cd35eb3$var$readUint32(trun, offset);
                    offset += 4;
                } else sampleDuration = defaultSampleDuration;
                if (sampleSizePresent) offset += 4;
                if (sampleFlagsPresent) {
                    const isNonSyncSample = trun[offset + 1] & 0x01;
                    if (!isNonSyncSample) {
                        if (trackTimes.keyFrameIndex === undefined) {
                            trackTimes.keyFrameIndex = trackTimes.sampleCount - (remaining + 1);
                            trackTimes.keyFrameStart = sampleDTS;
                        }
                    }
                    offset += 4;
                }
                if (sampleCompositionTimeOffsetPresent) offset += 4;
                sampleDTS += sampleDuration;
                rawDuration += sampleDuration;
            }
            if (!rawDuration && defaultSampleDuration) rawDuration += defaultSampleDuration * sampleCount;
        }
        trackTimes.duration += rawDuration;
    }
    if (!Object.keys(tracks).some((trackId)=>tracks[trackId].duration)) {
        // If duration samples are not available in the traf use sidx subsegment_duration
        let sidxMinStart = Infinity;
        let sidxMaxEnd = 0;
        const sidxs = $99a156a15cd35eb3$var$findBox(data, [
            'sidx'
        ]);
        for(let i = 0; i < sidxs.length; i++){
            const sidx = $99a156a15cd35eb3$var$parseSegmentIndex(sidxs[i]);
            if (sidx != null && sidx.references) {
                sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
                const subSegmentDuration = sidx.references.reduce((dur, ref)=>dur + ref.info.duration || 0, 0);
                sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
            }
        }
        if (sidxMaxEnd && $99a156a15cd35eb3$var$isFiniteNumber(sidxMaxEnd)) Object.keys(tracks).forEach((trackId)=>{
            if (!tracks[trackId].duration) tracks[trackId].duration = sidxMaxEnd * tracks[trackId].timescale - tracks[trackId].start;
        });
    }
    return tracks;
}
// TODO: Remove `offsetStartDTS` in favor of using `timestampOffset` (issue #5715)
function $99a156a15cd35eb3$var$offsetStartDTS(initData, fmp4, timeOffset) {
    $99a156a15cd35eb3$var$findBox(fmp4, [
        'moof',
        'traf'
    ]).forEach((traf)=>{
        $99a156a15cd35eb3$var$findBox(traf, [
            'tfhd'
        ]).forEach((tfhd)=>{
            // get the track id from the tfhd
            const id = $99a156a15cd35eb3$var$readUint32(tfhd, 4);
            const track = initData[id];
            if (!track) return;
            // assume a 90kHz clock if no timescale was specified
            const timescale = track.timescale || 90e3;
            // get the base media decode time from the tfdt
            $99a156a15cd35eb3$var$findBox(traf, [
                'tfdt'
            ]).forEach((tfdt)=>{
                const version = tfdt[0];
                const offset = timeOffset * timescale;
                if (offset) {
                    let baseMediaDecodeTime = $99a156a15cd35eb3$var$readUint32(tfdt, 4);
                    if (version === 0) {
                        baseMediaDecodeTime -= offset;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        $99a156a15cd35eb3$var$writeUint32(tfdt, 4, baseMediaDecodeTime);
                    } else {
                        baseMediaDecodeTime *= Math.pow(2, 32);
                        baseMediaDecodeTime += $99a156a15cd35eb3$var$readUint32(tfdt, 8);
                        baseMediaDecodeTime -= offset;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        const upper = Math.floor(baseMediaDecodeTime / ($99a156a15cd35eb3$var$UINT32_MAX$1 + 1));
                        const lower = Math.floor(baseMediaDecodeTime % ($99a156a15cd35eb3$var$UINT32_MAX$1 + 1));
                        $99a156a15cd35eb3$var$writeUint32(tfdt, 4, upper);
                        $99a156a15cd35eb3$var$writeUint32(tfdt, 8, lower);
                    }
                }
            });
        });
    });
}
// TODO: Check if the last moof+mdat pair is part of the valid range
function $99a156a15cd35eb3$var$segmentValidRange(data) {
    const segmentedRange = {
        valid: null,
        remainder: null
    };
    const moofs = $99a156a15cd35eb3$var$findBox(data, [
        'moof'
    ]);
    if (moofs.length < 2) {
        segmentedRange.remainder = data;
        return segmentedRange;
    }
    const last = moofs[moofs.length - 1];
    // Offset by 8 bytes; findBox offsets the start by as much
    segmentedRange.valid = data.slice(0, last.byteOffset - 8);
    segmentedRange.remainder = data.slice(last.byteOffset - 8);
    return segmentedRange;
}
function $99a156a15cd35eb3$var$appendUint8Array(data1, data2) {
    const temp = new Uint8Array(data1.length + data2.length);
    temp.set(data1);
    temp.set(data2, data1.length);
    return temp;
}
function $99a156a15cd35eb3$var$parseSamples(timeOffset, track) {
    const seiSamples = [];
    const videoData = track.samples;
    const timescale = track.timescale;
    const trackId = track.id;
    let isHEVCFlavor = false;
    const moofs = $99a156a15cd35eb3$var$findBox(videoData, [
        'moof'
    ]);
    moofs.map((moof)=>{
        const moofOffset = moof.byteOffset - 8;
        const trafs = $99a156a15cd35eb3$var$findBox(moof, [
            'traf'
        ]);
        trafs.map((traf)=>{
            // get the base media decode time from the tfdt
            const baseTime = $99a156a15cd35eb3$var$findBox(traf, [
                'tfdt'
            ]).map((tfdt)=>{
                const version = tfdt[0];
                let result = $99a156a15cd35eb3$var$readUint32(tfdt, 4);
                if (version === 1) {
                    result *= Math.pow(2, 32);
                    result += $99a156a15cd35eb3$var$readUint32(tfdt, 8);
                }
                return result / timescale;
            })[0];
            if (baseTime !== undefined) timeOffset = baseTime;
            return $99a156a15cd35eb3$var$findBox(traf, [
                'tfhd'
            ]).map((tfhd)=>{
                const id = $99a156a15cd35eb3$var$readUint32(tfhd, 4);
                const tfhdFlags = $99a156a15cd35eb3$var$readUint32(tfhd, 0) & 0xffffff;
                const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
                const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
                const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
                let defaultSampleDuration = 0;
                const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
                let defaultSampleSize = 0;
                const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
                let tfhdOffset = 8;
                if (id === trackId) {
                    if (baseDataOffsetPresent) tfhdOffset += 8;
                    if (sampleDescriptionIndexPresent) tfhdOffset += 4;
                    if (defaultSampleDurationPresent) {
                        defaultSampleDuration = $99a156a15cd35eb3$var$readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleSizePresent) {
                        defaultSampleSize = $99a156a15cd35eb3$var$readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleFlagsPresent) tfhdOffset += 4;
                    if (track.type === 'video') isHEVCFlavor = $99a156a15cd35eb3$var$isHEVC(track.codec);
                    $99a156a15cd35eb3$var$findBox(traf, [
                        'trun'
                    ]).map((trun)=>{
                        const version = trun[0];
                        const flags = $99a156a15cd35eb3$var$readUint32(trun, 0) & 0xffffff;
                        const dataOffsetPresent = (flags & 0x000001) !== 0;
                        let dataOffset = 0;
                        const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
                        const sampleDurationPresent = (flags & 0x000100) !== 0;
                        let sampleDuration = 0;
                        const sampleSizePresent = (flags & 0x000200) !== 0;
                        let sampleSize = 0;
                        const sampleFlagsPresent = (flags & 0x000400) !== 0;
                        const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
                        let compositionOffset = 0;
                        const sampleCount = $99a156a15cd35eb3$var$readUint32(trun, 4);
                        let trunOffset = 8; // past version, flags, and sample count
                        if (dataOffsetPresent) {
                            dataOffset = $99a156a15cd35eb3$var$readUint32(trun, trunOffset);
                            trunOffset += 4;
                        }
                        if (firstSampleFlagsPresent) trunOffset += 4;
                        let sampleOffset = dataOffset + moofOffset;
                        for(let ix = 0; ix < sampleCount; ix++){
                            if (sampleDurationPresent) {
                                sampleDuration = $99a156a15cd35eb3$var$readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleDuration = defaultSampleDuration;
                            if (sampleSizePresent) {
                                sampleSize = $99a156a15cd35eb3$var$readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleSize = defaultSampleSize;
                            if (sampleFlagsPresent) trunOffset += 4;
                            if (sampleCompositionOffsetsPresent) {
                                if (version === 0) compositionOffset = $99a156a15cd35eb3$var$readUint32(trun, trunOffset);
                                else compositionOffset = $99a156a15cd35eb3$var$readSint32(trun, trunOffset);
                                trunOffset += 4;
                            }
                            if (track.type === $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO) {
                                let naluTotalSize = 0;
                                while(naluTotalSize < sampleSize){
                                    const naluSize = $99a156a15cd35eb3$var$readUint32(videoData, sampleOffset);
                                    sampleOffset += 4;
                                    if ($99a156a15cd35eb3$var$isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                                        const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                                        $99a156a15cd35eb3$var$parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                                    }
                                    sampleOffset += naluSize;
                                    naluTotalSize += naluSize + 4;
                                }
                            }
                            timeOffset += sampleDuration / timescale;
                        }
                    });
                }
            });
        });
    });
    return seiSamples;
}
function $99a156a15cd35eb3$var$isHEVC(codec) {
    if (!codec) return false;
    const baseCodec = codec.substring(0, 4);
    return baseCodec === 'hvc1' || baseCodec === 'hev1' || // Dolby Vision
    baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function $99a156a15cd35eb3$var$isSEIMessage(isHEVCFlavor, naluHeader) {
    if (isHEVCFlavor) {
        const naluType = naluHeader >> 1 & 0x3f;
        return naluType === 39 || naluType === 40;
    } else {
        const naluType = naluHeader & 0x1f;
        return naluType === 6;
    }
}
function $99a156a15cd35eb3$var$parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
    const data = $99a156a15cd35eb3$var$discardEPB(unescapedData);
    let seiPtr = 0;
    // skip nal header
    seiPtr += headerSize;
    let payloadType = 0;
    let payloadSize = 0;
    let b = 0;
    while(seiPtr < data.length){
        payloadType = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadType += b;
        }while (b === 0xff);
        // Parse payload size.
        payloadSize = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadSize += b;
        }while (b === 0xff);
        const leftOver = data.length - seiPtr;
        // Create a variable to process the payload
        let payPtr = seiPtr;
        // Increment the seiPtr to the end of the payload
        if (payloadSize < leftOver) seiPtr += payloadSize;
        else if (payloadSize > leftOver) {
            // Some type of corruption has happened?
            $99a156a15cd35eb3$var$logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
            break;
        }
        if (payloadType === 4) {
            const countryCode = data[payPtr++];
            if (countryCode === 181) {
                const providerCode = $99a156a15cd35eb3$var$readUint16(data, payPtr);
                payPtr += 2;
                if (providerCode === 49) {
                    const userStructure = $99a156a15cd35eb3$var$readUint32(data, payPtr);
                    payPtr += 4;
                    if (userStructure === 0x47413934) {
                        const userDataType = data[payPtr++];
                        // Raw CEA-608 bytes wrapped in CEA-708 packet
                        if (userDataType === 3) {
                            const firstByte = data[payPtr++];
                            const totalCCs = 0x1f & firstByte;
                            const enabled = 0x40 & firstByte;
                            const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
                            const byteArray = new Uint8Array(totalBytes);
                            if (enabled) {
                                byteArray[0] = firstByte;
                                for(let i = 1; i < totalBytes; i++)byteArray[i] = data[payPtr++];
                            }
                            samples.push({
                                type: userDataType,
                                payloadType: payloadType,
                                pts: pts,
                                bytes: byteArray
                            });
                        }
                    }
                }
            }
        } else if (payloadType === 5) {
            if (payloadSize > 16) {
                const uuidStrArray = [];
                for(let i = 0; i < 16; i++){
                    const _b = data[payPtr++].toString(16);
                    uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
                    if (i === 3 || i === 5 || i === 7 || i === 9) uuidStrArray.push('-');
                }
                const length = payloadSize - 16;
                const userDataBytes = new Uint8Array(length);
                for(let i = 0; i < length; i++)userDataBytes[i] = data[payPtr++];
                samples.push({
                    payloadType: payloadType,
                    pts: pts,
                    uuid: uuidStrArray.join(''),
                    userData: $99a156a15cd35eb3$var$utf8ArrayToStr(userDataBytes),
                    userDataBytes: userDataBytes
                });
            }
        }
    }
}
/**
 * remove Emulation Prevention bytes from a RBSP
 */ function $99a156a15cd35eb3$var$discardEPB(data) {
    const length = data.byteLength;
    const EPBPositions = [];
    let i = 1;
    // Find all `Emulation Prevention Bytes`
    while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
        EPBPositions.push(i + 2);
        i += 2;
    } else i++;
    // If no Emulation Prevention Bytes were found just return the original
    // array
    if (EPBPositions.length === 0) return data;
    // Create a new array to hold the NAL unit data
    const newLength = length - EPBPositions.length;
    const newData = new Uint8Array(newLength);
    let sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === EPBPositions[0]) {
            // Skip this byte
            sourceIndex++;
            // Remove this position index
            EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
    }
    return newData;
}
function $99a156a15cd35eb3$var$parseEmsg(data) {
    const version = data[0];
    let schemeIdUri = '';
    let value = '';
    let timeScale = 0;
    let presentationTimeDelta = 0;
    let presentationTime = 0;
    let eventDuration = 0;
    let id = 0;
    let offset = 0;
    if (version === 0) {
        while($99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            schemeIdUri += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while($99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            value += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        timeScale = $99a156a15cd35eb3$var$readUint32(data, 12);
        presentationTimeDelta = $99a156a15cd35eb3$var$readUint32(data, 16);
        eventDuration = $99a156a15cd35eb3$var$readUint32(data, 20);
        id = $99a156a15cd35eb3$var$readUint32(data, 24);
        offset = 28;
    } else if (version === 1) {
        offset += 4;
        timeScale = $99a156a15cd35eb3$var$readUint32(data, offset);
        offset += 4;
        const leftPresentationTime = $99a156a15cd35eb3$var$readUint32(data, offset);
        offset += 4;
        const rightPresentationTime = $99a156a15cd35eb3$var$readUint32(data, offset);
        offset += 4;
        presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
        if (!$99a156a15cd35eb3$var$isSafeInteger(presentationTime)) {
            presentationTime = Number.MAX_SAFE_INTEGER;
            $99a156a15cd35eb3$var$logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
        }
        eventDuration = $99a156a15cd35eb3$var$readUint32(data, offset);
        offset += 4;
        id = $99a156a15cd35eb3$var$readUint32(data, offset);
        offset += 4;
        while($99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            schemeIdUri += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while($99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            value += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += $99a156a15cd35eb3$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
    }
    const payload = data.subarray(offset, data.byteLength);
    return {
        schemeIdUri: schemeIdUri,
        value: value,
        timeScale: timeScale,
        presentationTime: presentationTime,
        presentationTimeDelta: presentationTimeDelta,
        eventDuration: eventDuration,
        id: id,
        payload: payload
    };
}
function $99a156a15cd35eb3$var$mp4Box(type, ...payload) {
    const len = payload.length;
    let size = 8;
    let i = len;
    while(i--)size += payload[i].byteLength;
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    for(i = 0, size = 8; i < len; i++){
        result.set(payload[i], size);
        size += payload[i].byteLength;
    }
    return result;
}
function $99a156a15cd35eb3$var$mp4pssh(systemId, keyids, data) {
    if (systemId.byteLength !== 16) throw new RangeError('Invalid system id');
    let version;
    let kids;
    version = 0;
    kids = new Uint8Array();
    let kidCount;
    if (version > 0) {
        kidCount = new Uint8Array(4);
        if (keyids.length > 0) new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    } else kidCount = new Uint8Array();
    const dataSize = new Uint8Array(4);
    if (data && data.byteLength > 0) new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
    return $99a156a15cd35eb3$var$mp4Box([
        112,
        115,
        115,
        104
    ], new Uint8Array([
        version,
        0x00,
        0x00,
        0x00 // Flags
    ]), systemId, // 16 bytes
    kidCount, kids, dataSize, data || new Uint8Array());
}
function $99a156a15cd35eb3$var$parseMultiPssh(initData) {
    const results = [];
    if (initData instanceof ArrayBuffer) {
        const length = initData.byteLength;
        let offset = 0;
        while(offset + 32 < length){
            const view = new DataView(initData, offset);
            const pssh = $99a156a15cd35eb3$var$parsePssh(view);
            results.push(pssh);
            offset += pssh.size;
        }
    }
    return results;
}
function $99a156a15cd35eb3$var$parsePssh(view) {
    const size = view.getUint32(0);
    const offset = view.byteOffset;
    const length = view.byteLength;
    if (length < size) return {
        offset: offset,
        size: length
    };
    const type = view.getUint32(4);
    if (type !== 0x70737368) return {
        offset: offset,
        size: size
    };
    const version = view.getUint32(8) >>> 24;
    if (version !== 0 && version !== 1) return {
        offset: offset,
        size: size
    };
    const buffer = view.buffer;
    const systemId = $99a156a15cd35eb3$var$Hex.hexDump(new Uint8Array(buffer, offset + 12, 16));
    const dataSizeOrKidCount = view.getUint32(28);
    let kids = null;
    let data = null;
    if (version === 0) {
        if (size - 32 < dataSizeOrKidCount || dataSizeOrKidCount < 22) return {
            offset: offset,
            size: size
        };
        data = new Uint8Array(buffer, offset + 32, dataSizeOrKidCount);
    } else if (version === 1) {
        if (!dataSizeOrKidCount || length < offset + 32 + dataSizeOrKidCount * 16 + 16) return {
            offset: offset,
            size: size
        };
        kids = [];
        for(let i = 0; i < dataSizeOrKidCount; i++)kids.push(new Uint8Array(buffer, offset + 32 + i * 16, 16));
    }
    return {
        version: version,
        systemId: systemId,
        kids: kids,
        data: data,
        offset: offset,
        size: size
    };
}
const $99a156a15cd35eb3$var$userAgentHevcSupportIsInaccurate = ()=>{
    return /\(Windows.+Firefox\//i.test(navigator.userAgent);
};
// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
const $99a156a15cd35eb3$var$sampleEntryCodesISO = {
    audio: {
        a3ds: 1,
        'ac-3': 0.95,
        'ac-4': 1,
        alac: 0.9,
        alaw: 1,
        dra1: 1,
        'dts+': 1,
        'dts-': 1,
        dtsc: 1,
        dtse: 1,
        dtsh: 1,
        'ec-3': 0.9,
        enca: 1,
        fLaC: 0.9,
        // MP4-RA listed codec entry for FLAC
        flac: 0.9,
        // legacy browser codec name for FLAC
        FLAC: 0.9,
        // some manifests may list "FLAC" with Apple's tools
        g719: 1,
        g726: 1,
        m4ae: 1,
        mha1: 1,
        mha2: 1,
        mhm1: 1,
        mhm2: 1,
        mlpa: 1,
        mp4a: 1,
        'raw ': 1,
        Opus: 1,
        opus: 1,
        // browsers expect this to be lowercase despite MP4RA says 'Opus'
        samr: 1,
        sawb: 1,
        sawp: 1,
        sevc: 1,
        sqcp: 1,
        ssmv: 1,
        twos: 1,
        ulaw: 1
    },
    video: {
        avc1: 1,
        avc2: 1,
        avc3: 1,
        avc4: 1,
        avcp: 1,
        av01: 0.8,
        dav1: 0.8,
        drac: 1,
        dva1: 1,
        dvav: 1,
        dvh1: 0.7,
        dvhe: 0.7,
        encv: 1,
        hev1: 0.75,
        hvc1: 0.75,
        mjp2: 1,
        mp4v: 1,
        mvc1: 1,
        mvc2: 1,
        mvc3: 1,
        mvc4: 1,
        resv: 1,
        rv60: 1,
        s263: 1,
        svc1: 1,
        svc2: 1,
        'vc-1': 1,
        vp08: 1,
        vp09: 0.9
    },
    text: {
        stpp: 1,
        wvtt: 1
    }
};
function $99a156a15cd35eb3$var$isCodecType(codec, type) {
    const typeCodes = $99a156a15cd35eb3$var$sampleEntryCodesISO[type];
    return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function $99a156a15cd35eb3$var$areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
    return !codecs.split(',').some((codec)=>!$99a156a15cd35eb3$var$isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function $99a156a15cd35eb3$var$isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
    var _MediaSource$isTypeSu;
    const MediaSource = $99a156a15cd35eb3$export$a92854129bc50f89(preferManagedMediaSource);
    return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported($99a156a15cd35eb3$var$mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function $99a156a15cd35eb3$var$mimeTypeForCodec(codec, type) {
    return `${type}/mp4;codecs=${codec}`;
}
function $99a156a15cd35eb3$var$videoCodecPreferenceValue(videoCodec) {
    if (videoCodec) {
        const fourCC = videoCodec.substring(0, 4);
        return $99a156a15cd35eb3$var$sampleEntryCodesISO.video[fourCC];
    }
    return 2;
}
function $99a156a15cd35eb3$var$codecsSetSelectionPreferenceValue(codecSet) {
    const limitedHevcSupport = $99a156a15cd35eb3$var$userAgentHevcSupportIsInaccurate();
    return codecSet.split(',').reduce((num, fourCC)=>{
        const lowerPriority = limitedHevcSupport && $99a156a15cd35eb3$var$isHEVC(fourCC);
        const preferenceValue = lowerPriority ? 9 : $99a156a15cd35eb3$var$sampleEntryCodesISO.video[fourCC];
        if (preferenceValue) return (preferenceValue * 2 + num) / (num ? 3 : 2);
        return ($99a156a15cd35eb3$var$sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
    }, 0);
}
const $99a156a15cd35eb3$var$CODEC_COMPATIBLE_NAMES = {};
function $99a156a15cd35eb3$var$getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
    if ($99a156a15cd35eb3$var$CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) return $99a156a15cd35eb3$var$CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
    const codecsToCheck = {
        // Idealy fLaC and Opus would be first (spec-compliant) but
        // some browsers will report that fLaC is supported then fail.
        // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
        flac: [
            'flac',
            'fLaC',
            'FLAC'
        ],
        opus: [
            'opus',
            'Opus'
        ],
        // Replace audio codec info if browser does not support mp4a.40.34,
        // and demuxer can fallback to 'audio/mpeg' or 'audio/mp4;codecs="mp3"'
        'mp4a.40.34': [
            'mp3'
        ]
    }[lowerCaseCodec];
    for(let i = 0; i < codecsToCheck.length; i++){
        var _getMediaSource;
        if ($99a156a15cd35eb3$var$isCodecMediaSourceSupported(codecsToCheck[i], 'audio', preferManagedMediaSource)) {
            $99a156a15cd35eb3$var$CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
            return codecsToCheck[i];
        } else if (codecsToCheck[i] === 'mp3' && (_getMediaSource = $99a156a15cd35eb3$export$a92854129bc50f89(preferManagedMediaSource)) != null && _getMediaSource.isTypeSupported('audio/mpeg')) return '';
    }
    return lowerCaseCodec;
}
const $99a156a15cd35eb3$var$AUDIO_CODEC_REGEXP = /flac|opus|mp4a\.40\.34/i;
function $99a156a15cd35eb3$var$getCodecCompatibleName(codec, preferManagedMediaSource = true) {
    return codec.replace($99a156a15cd35eb3$var$AUDIO_CODEC_REGEXP, (m)=>$99a156a15cd35eb3$var$getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function $99a156a15cd35eb3$var$replaceVideoCodec(originalCodecs, newVideoCodec) {
    const codecs = [];
    if (originalCodecs) {
        const allCodecs = originalCodecs.split(',');
        for(let i = 0; i < allCodecs.length; i++)if (!$99a156a15cd35eb3$var$isCodecType(allCodecs[i], 'video')) codecs.push(allCodecs[i]);
    }
    if (newVideoCodec) codecs.push(newVideoCodec);
    return codecs.join(',');
}
function $99a156a15cd35eb3$var$pickMostCompleteCodecName(parsedCodec, levelCodec) {
    // Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
    // so use level codec is parsed codec is unavailable or incomplete
    if (parsedCodec && (parsedCodec.length > 4 || [
        'ac-3',
        'ec-3',
        'alac',
        'fLaC',
        'Opus'
    ].indexOf(parsedCodec) !== -1)) return parsedCodec;
    if (levelCodec) {
        const levelCodecs = levelCodec.split(',');
        if (levelCodecs.length > 1) {
            if (parsedCodec) for(let i = levelCodecs.length; i--;){
                if (levelCodecs[i].substring(0, 4) === parsedCodec.substring(0, 4)) return levelCodecs[i];
            }
            return levelCodecs[0];
        }
    }
    return levelCodec || parsedCodec;
}
function $99a156a15cd35eb3$var$convertAVC1ToAVCOTI(videoCodecs) {
    // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
    // Examples: avc1.66.30 to avc1.42001e and avc1.77.30,avc1.66.30 to avc1.4d001e,avc1.42001e.
    const codecs = videoCodecs.split(',');
    for(let i = 0; i < codecs.length; i++){
        const avcdata = codecs[i].split('.');
        // only convert codec strings starting with avc1 (Examples: avc1.64001f,dvh1.05.07)
        if (avcdata.length > 2 && avcdata[0] === 'avc1') codecs[i] = `avc1.${parseInt(avcdata[1]).toString(16)}${('000' + parseInt(avcdata[2]).toString(16)).slice(-4)}`;
    }
    return codecs.join(',');
}
function $99a156a15cd35eb3$var$fillInMissingAV01Params(videoCodec) {
    // Used to fill in incomplete AV1 playlist CODECS strings for mediaCapabilities.decodingInfo queries
    if (videoCodec.startsWith('av01.')) {
        const av1params = videoCodec.split('.');
        const placeholders = [
            '0',
            '111',
            '01',
            '01',
            '01',
            '0'
        ];
        for(let i = av1params.length; i > 4 && i < 10; i++)av1params[i] = placeholders[i - 4];
        return av1params.join('.');
    }
    return videoCodec;
}
function $99a156a15cd35eb3$var$getM2TSSupportedAudioTypes(preferManagedMediaSource) {
    const MediaSource = $99a156a15cd35eb3$export$a92854129bc50f89(preferManagedMediaSource) || {
        isTypeSupported: ()=>false
    };
    return {
        mpeg: MediaSource.isTypeSupported('audio/mpeg'),
        mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
        ac3: MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"')
    };
}
function $99a156a15cd35eb3$var$getCodecsForMimeType(mimeType) {
    return mimeType.replace(/^.+codecs=["']?([^"']+).*$/, '$1');
}
const $99a156a15cd35eb3$var$SUPPORTED_INFO_DEFAULT = {
    supported: true,
    configurations: [],
    decodingInfoResults: [
        {
            supported: true,
            powerEfficient: true,
            smooth: true
        }
    ]
};
function $99a156a15cd35eb3$var$getUnsupportedResult(error, configurations) {
    return {
        supported: false,
        configurations: configurations,
        decodingInfoResults: [
            {
                supported: false,
                smooth: false,
                powerEfficient: false
            }
        ],
        error: error
    };
}
const $99a156a15cd35eb3$var$SUPPORTED_INFO_CACHE = {};
function $99a156a15cd35eb3$var$requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
    // Only test support when configuration is exceeds minimum options
    const audioGroups = level.audioCodec ? level.audioGroups : null;
    const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
    const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
    const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
    let audioChannels = null;
    if (audioGroups != null && audioGroups.length) try {
        if (audioGroups.length === 1 && audioGroups[0]) audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
        else audioChannels = audioGroups.reduce((acc, groupId)=>{
            if (groupId) {
                const audioTrackGroup = audioTracksByGroup.groups[groupId];
                if (!audioTrackGroup) throw new Error(`Audio track group ${groupId} not found`);
                // Sum all channel key values
                Object.keys(audioTrackGroup.channels).forEach((key)=>{
                    acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
                });
            }
            return acc;
        }, {
            2: 0
        });
    } catch (error) {
        return true;
    }
    return level.videoCodec !== undefined && (level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== 'SDR' && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && $99a156a15cd35eb3$var$isFiniteNumber(maxChannels) && Object.keys(audioChannels).some((channels)=>parseInt(channels) > maxChannels);
}
function $99a156a15cd35eb3$var$getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities) {
    const videoCodecs = level.videoCodec;
    const audioCodecs = level.audioCodec;
    if (!videoCodecs && !audioCodecs || !mediaCapabilities) return Promise.resolve($99a156a15cd35eb3$var$SUPPORTED_INFO_DEFAULT);
    const configurations = [];
    if (videoCodecs) {
        const baseVideoConfiguration = {
            width: level.width,
            height: level.height,
            bitrate: Math.ceil(Math.max(level.bitrate * 0.9, level.averageBitrate)),
            // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
            framerate: level.frameRate || 30
        };
        const videoRange = level.videoRange;
        if (videoRange !== 'SDR') baseVideoConfiguration.transferFunction = videoRange.toLowerCase();
        const videoCodecsArray = videoCodecs.split(',');
        // Override Windows Firefox HEVC MediaCapabilities result (https://github.com/video-dev/hls.js/issues/7046)
        const ua = navigator.userAgent;
        if (videoCodecsArray.some((videoCodec)=>$99a156a15cd35eb3$var$isHEVC(videoCodec)) && $99a156a15cd35eb3$var$userAgentHevcSupportIsInaccurate()) return Promise.resolve($99a156a15cd35eb3$var$getUnsupportedResult(new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent sting: (${ua})`), configurations));
        configurations.push.apply(configurations, videoCodecsArray.map((videoCodec)=>({
                type: 'media-source',
                video: $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, baseVideoConfiguration), {}, {
                    contentType: $99a156a15cd35eb3$var$mimeTypeForCodec($99a156a15cd35eb3$var$fillInMissingAV01Params(videoCodec), 'video')
                })
            })));
    }
    if (audioCodecs && level.audioGroups) level.audioGroups.forEach((audioGroupId)=>{
        var _audioTracksByGroup$g;
        if (!audioGroupId) return;
        (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null || _audioTracksByGroup$g.tracks.forEach((audioTrack)=>{
            if (audioTrack.groupId === audioGroupId) {
                const channels = audioTrack.channels || '';
                const channelsNumber = parseFloat(channels);
                if ($99a156a15cd35eb3$var$isFiniteNumber(channelsNumber) && channelsNumber > 2) configurations.push.apply(configurations, audioCodecs.split(',').map((audioCodec)=>({
                        type: 'media-source',
                        audio: {
                            contentType: $99a156a15cd35eb3$var$mimeTypeForCodec(audioCodec, 'audio'),
                            channels: '' + channelsNumber
                        }
                    })));
            }
        });
    });
    return Promise.all(configurations.map((configuration)=>{
        // Cache MediaCapabilities promises
        const decodingInfoKey = $99a156a15cd35eb3$var$getMediaDecodingInfoKey(configuration);
        return $99a156a15cd35eb3$var$SUPPORTED_INFO_CACHE[decodingInfoKey] || ($99a156a15cd35eb3$var$SUPPORTED_INFO_CACHE[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
    })).then((decodingInfoResults)=>({
            supported: !decodingInfoResults.some((info)=>!info.supported),
            configurations: configurations,
            decodingInfoResults: decodingInfoResults
        })).catch((error)=>({
            supported: false,
            configurations: configurations,
            decodingInfoResults: [],
            error: error
        }));
}
function $99a156a15cd35eb3$var$getMediaDecodingInfoKey(config) {
    const { audio: audio, video: video } = config;
    const mediaConfig = video || audio;
    if (mediaConfig) {
        const codec = $99a156a15cd35eb3$var$getCodecsForMimeType(mediaConfig.contentType);
        if (video) return `r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || 'sd'}_${codec}_${Math.ceil(video.bitrate / 1e5)}`;
        if (audio) return `c${audio.channels}${audio.spatialRendering ? 's' : 'n'}_${codec}`;
    }
    return '';
}
const $99a156a15cd35eb3$var$HdcpLevels = [
    'NONE',
    'TYPE-0',
    'TYPE-1',
    null
];
function $99a156a15cd35eb3$var$isHdcpLevel(value) {
    return $99a156a15cd35eb3$var$HdcpLevels.indexOf(value) > -1;
}
const $99a156a15cd35eb3$var$VideoRangeValues = [
    'SDR',
    'PQ',
    'HLG'
];
function $99a156a15cd35eb3$var$isVideoRange(value) {
    return !!value && $99a156a15cd35eb3$var$VideoRangeValues.indexOf(value) > -1;
}
var $99a156a15cd35eb3$export$5d29c5ea940312ed = {
    No: "",
    Yes: "YES",
    v2: "v2"
};
function $99a156a15cd35eb3$var$getSkipValue(details) {
    const { canSkipUntil: canSkipUntil, canSkipDateRanges: canSkipDateRanges, age: age } = details;
    // A Client SHOULD NOT request a Playlist Delta Update unless it already
    // has a version of the Playlist that is no older than one-half of the Skip Boundary.
    // @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
    const playlistRecentEnough = age < canSkipUntil / 2;
    if (canSkipUntil && playlistRecentEnough) {
        if (canSkipDateRanges) return $99a156a15cd35eb3$export$5d29c5ea940312ed.v2;
        return $99a156a15cd35eb3$export$5d29c5ea940312ed.Yes;
    }
    return $99a156a15cd35eb3$export$5d29c5ea940312ed.No;
}
class $99a156a15cd35eb3$export$b1713430eaae90a7 {
    constructor(msn, part, skip){
        this.msn = void 0;
        this.part = void 0;
        this.skip = void 0;
        this.msn = msn;
        this.part = part;
        this.skip = skip;
    }
    addDirectives(uri) {
        const url = new self.URL(uri);
        if (this.msn !== undefined) url.searchParams.set('_HLS_msn', this.msn.toString());
        if (this.part !== undefined) url.searchParams.set('_HLS_part', this.part.toString());
        if (this.skip) url.searchParams.set('_HLS_skip', this.skip);
        return url.href;
    }
}
class $99a156a15cd35eb3$export$ca664994d1d54bff {
    constructor(data){
        this._attrs = void 0;
        this.audioCodec = void 0;
        this.bitrate = void 0;
        this.codecSet = void 0;
        this.url = void 0;
        this.frameRate = void 0;
        this.height = void 0;
        this.id = void 0;
        this.name = void 0;
        this.supplemental = void 0;
        this.videoCodec = void 0;
        this.width = void 0;
        this.details = void 0;
        this.fragmentError = 0;
        this.loadError = 0;
        this.loaded = void 0;
        this.realBitrate = 0;
        this.supportedPromise = void 0;
        this.supportedResult = void 0;
        this._avgBitrate = 0;
        this._audioGroups = void 0;
        this._subtitleGroups = void 0;
        // Deprecated (retained for backwards compatibility)
        this._urlId = 0;
        this.url = [
            data.url
        ];
        this._attrs = [
            data.attrs
        ];
        this.bitrate = data.bitrate;
        if (data.details) this.details = data.details;
        this.id = data.id || 0;
        this.name = data.name;
        this.width = data.width || 0;
        this.height = data.height || 0;
        this.frameRate = data.attrs.optionalFloat('FRAME-RATE', 0);
        this._avgBitrate = data.attrs.decimalInteger('AVERAGE-BANDWIDTH');
        this.audioCodec = data.audioCodec;
        this.videoCodec = data.videoCodec;
        this.codecSet = [
            data.videoCodec,
            data.audioCodec
        ].filter((c)=>!!c).map((s)=>s.substring(0, 4)).join(',');
        if ('supplemental' in data) {
            var _data$supplemental;
            this.supplemental = data.supplemental;
            const supplementalVideo = (_data$supplemental = data.supplemental) == null ? void 0 : _data$supplemental.videoCodec;
            if (supplementalVideo && supplementalVideo !== data.videoCodec) this.codecSet += `,${supplementalVideo.substring(0, 4)}`;
        }
        this.addGroupId('audio', data.attrs.AUDIO);
        this.addGroupId('text', data.attrs.SUBTITLES);
    }
    get maxBitrate() {
        return Math.max(this.realBitrate, this.bitrate);
    }
    get averageBitrate() {
        return this._avgBitrate || this.realBitrate || this.bitrate;
    }
    get attrs() {
        return this._attrs[0];
    }
    get codecs() {
        return this.attrs.CODECS || '';
    }
    get pathwayId() {
        return this.attrs['PATHWAY-ID'] || '.';
    }
    get videoRange() {
        return this.attrs['VIDEO-RANGE'] || 'SDR';
    }
    get score() {
        return this.attrs.optionalFloat('SCORE', 0);
    }
    get uri() {
        return this.url[0] || '';
    }
    hasAudioGroup(groupId) {
        return $99a156a15cd35eb3$var$hasGroup(this._audioGroups, groupId);
    }
    hasSubtitleGroup(groupId) {
        return $99a156a15cd35eb3$var$hasGroup(this._subtitleGroups, groupId);
    }
    get audioGroups() {
        return this._audioGroups;
    }
    get subtitleGroups() {
        return this._subtitleGroups;
    }
    addGroupId(type, groupId) {
        if (!groupId) return;
        if (type === 'audio') {
            let audioGroups = this._audioGroups;
            if (!audioGroups) audioGroups = this._audioGroups = [];
            if (audioGroups.indexOf(groupId) === -1) audioGroups.push(groupId);
        } else if (type === 'text') {
            let subtitleGroups = this._subtitleGroups;
            if (!subtitleGroups) subtitleGroups = this._subtitleGroups = [];
            if (subtitleGroups.indexOf(groupId) === -1) subtitleGroups.push(groupId);
        }
    }
    // Deprecated methods (retained for backwards compatibility)
    get urlId() {
        return 0;
    }
    set urlId(value) {}
    get audioGroupIds() {
        return this.audioGroups ? [
            this.audioGroupId
        ] : undefined;
    }
    get textGroupIds() {
        return this.subtitleGroups ? [
            this.textGroupId
        ] : undefined;
    }
    get audioGroupId() {
        var _this$audioGroups;
        return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
    }
    get textGroupId() {
        var _this$subtitleGroups;
        return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
    }
    addFallback() {}
}
function $99a156a15cd35eb3$var$hasGroup(groups, groupId) {
    if (!groupId || !groups) return false;
    return groups.indexOf(groupId) !== -1;
}
/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */ function $99a156a15cd35eb3$var$isHdrSupported() {
    if (typeof matchMedia === 'function') {
        const mediaQueryList = matchMedia('(dynamic-range: high)');
        const badQuery = matchMedia('bad query');
        if (mediaQueryList.media !== badQuery.media) return mediaQueryList.matches === true;
    }
    return false;
}
/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */ function $99a156a15cd35eb3$var$getVideoSelectionOptions(currentVideoRange, videoPreference) {
    let preferHDR = false;
    let allowedVideoRanges = [];
    if (currentVideoRange) {
        preferHDR = currentVideoRange !== 'SDR';
        allowedVideoRanges = [
            currentVideoRange
        ];
    }
    if (videoPreference) {
        allowedVideoRanges = videoPreference.allowedVideoRanges || $99a156a15cd35eb3$var$VideoRangeValues.slice(0);
        const allowAutoPreferHDR = allowedVideoRanges.join('') !== 'SDR' && !videoPreference.videoCodec;
        preferHDR = videoPreference.preferHDR !== undefined ? videoPreference.preferHDR : allowAutoPreferHDR && $99a156a15cd35eb3$var$isHdrSupported();
        if (!preferHDR) allowedVideoRanges = [
            'SDR'
        ];
    }
    return {
        preferHDR: preferHDR,
        allowedVideoRanges: allowedVideoRanges
    };
}
const $99a156a15cd35eb3$var$omitCircularRefsReplacer = (replacer)=>{
    const known = new WeakSet();
    return (_, value)=>{
        if (replacer) value = replacer(_, value);
        if (typeof value === 'object' && value !== null) {
            if (known.has(value)) return;
            known.add(value);
        }
        return value;
    };
};
const $99a156a15cd35eb3$var$stringify = (object, replacer)=>JSON.stringify(object, $99a156a15cd35eb3$var$omitCircularRefsReplacer(replacer));
function $99a156a15cd35eb3$var$getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
    const codecSets = Object.keys(codecTiers);
    const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
    const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
    const videoCodecPreference = videoPreference == null ? void 0 : videoPreference.videoCodec;
    const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
    // Use first level set to determine stereo, and minimum resolution and framerate
    let hasStereo = false;
    let hasCurrentVideoRange = false;
    let minHeight = Infinity;
    let minFramerate = Infinity;
    let minBitrate = Infinity;
    let minIndex = Infinity;
    let selectedScore = 0;
    let videoRanges = [];
    const { preferHDR: preferHDR, allowedVideoRanges: allowedVideoRanges } = $99a156a15cd35eb3$var$getVideoSelectionOptions(currentVideoRange, videoPreference);
    for(let i = codecSets.length; i--;){
        const tier = codecTiers[codecSets[i]];
        hasStereo || (hasStereo = tier.channels[2] > 0);
        minHeight = Math.min(minHeight, tier.minHeight);
        minFramerate = Math.min(minFramerate, tier.minFramerate);
        minBitrate = Math.min(minBitrate, tier.minBitrate);
        const matchingVideoRanges = allowedVideoRanges.filter((range)=>tier.videoRanges[range] > 0);
        if (matchingVideoRanges.length > 0) hasCurrentVideoRange = true;
    }
    minHeight = $99a156a15cd35eb3$var$isFiniteNumber(minHeight) ? minHeight : 0;
    minFramerate = $99a156a15cd35eb3$var$isFiniteNumber(minFramerate) ? minFramerate : 0;
    const maxHeight = Math.max(1080, minHeight);
    const maxFramerate = Math.max(30, minFramerate);
    minBitrate = $99a156a15cd35eb3$var$isFiniteNumber(minBitrate) ? minBitrate : currentBw;
    currentBw = Math.max(minBitrate, currentBw);
    // If there are no variants with matching preference, set currentVideoRange to undefined
    if (!hasCurrentVideoRange) currentVideoRange = undefined;
    const hasMultipleSets = codecSets.length > 1;
    const codecSet = codecSets.reduce((selected, candidate)=>{
        // Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
        const candidateTier = codecTiers[candidate];
        if (candidate === selected) return selected;
        videoRanges = hasCurrentVideoRange ? allowedVideoRanges.filter((range)=>candidateTier.videoRanges[range] > 0) : [];
        if (hasMultipleSets) {
            if (candidateTier.minBitrate > currentBw) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
                return selected;
            }
            if (!candidateTier.hasDefaultAudio) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
                return selected;
            }
            if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
                return selected;
            }
            if (channelsPreference && !preferStereo) {
                if (!candidateTier.channels[channelsPreference]) {
                    $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
                    return selected;
                }
            } else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels['2'] === 0) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
                return selected;
            }
            if (candidateTier.minHeight > maxHeight) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
                return selected;
            }
            if (candidateTier.minFramerate > maxFramerate) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
                return selected;
            }
            if (!videoRanges.some((range)=>candidateTier.videoRanges[range] > 0)) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${$99a156a15cd35eb3$var$stringify(videoRanges)} found`);
                return selected;
            }
            if (videoCodecPreference && candidate.indexOf(videoCodecPreference.substring(0, 4)) % 5 !== 0) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `video codec preference "${videoCodecPreference}" not found`);
                return selected;
            }
            if (candidateTier.maxScore < selectedScore) {
                $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
                return selected;
            }
        }
        // Remove candiates with less preferred codecs or more errors
        if (selected && ($99a156a15cd35eb3$var$codecsSetSelectionPreferenceValue(candidate) >= $99a156a15cd35eb3$var$codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) return selected;
        minIndex = candidateTier.minIndex;
        selectedScore = candidateTier.maxScore;
        return candidate;
    }, undefined);
    return {
        codecSet: codecSet,
        videoRanges: videoRanges,
        preferHDR: preferHDR,
        minFramerate: minFramerate,
        minBitrate: minBitrate,
        minIndex: minIndex
    };
}
function $99a156a15cd35eb3$var$logStartCodecCandidateIgnored(codeSet, reason) {
    $99a156a15cd35eb3$var$logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function $99a156a15cd35eb3$var$getAudioTracksByGroup(allAudioTracks) {
    return allAudioTracks.reduce((audioTracksByGroup, track)=>{
        let trackGroup = audioTracksByGroup.groups[track.groupId];
        if (!trackGroup) trackGroup = audioTracksByGroup.groups[track.groupId] = {
            tracks: [],
            channels: {
                2: 0
            },
            hasDefault: false,
            hasAutoSelect: false
        };
        trackGroup.tracks.push(track);
        const channelsKey = track.channels || '2';
        trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
        trackGroup.hasDefault = trackGroup.hasDefault || track.default;
        trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
        if (trackGroup.hasDefault) audioTracksByGroup.hasDefaultAudio = true;
        if (trackGroup.hasAutoSelect) audioTracksByGroup.hasAutoSelectAudio = true;
        return audioTracksByGroup;
    }, {
        hasDefaultAudio: false,
        hasAutoSelectAudio: false,
        groups: {}
    });
}
function $99a156a15cd35eb3$var$getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
    return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level, index)=>{
        if (!level.codecSet) return tiers;
        const audioGroups = level.audioGroups;
        let tier = tiers[level.codecSet];
        if (!tier) tiers[level.codecSet] = tier = {
            minBitrate: Infinity,
            minHeight: Infinity,
            minFramerate: Infinity,
            minIndex: index,
            maxScore: 0,
            videoRanges: {
                SDR: 0
            },
            channels: {
                '2': 0
            },
            hasDefaultAudio: !audioGroups,
            fragmentError: 0
        };
        tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
        const lesserWidthOrHeight = Math.min(level.height, level.width);
        tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
        tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
        tier.minIndex = Math.min(tier.minIndex, index);
        tier.maxScore = Math.max(tier.maxScore, level.score);
        tier.fragmentError += level.fragmentError;
        tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
        if (audioGroups) audioGroups.forEach((audioGroupId)=>{
            if (!audioGroupId) return;
            const audioGroup = audioTracksByGroup.groups[audioGroupId];
            if (!audioGroup) return;
            // Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
            tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
            Object.keys(audioGroup.channels).forEach((channels)=>{
                tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
            });
        });
        return tiers;
    }, {});
}
function $99a156a15cd35eb3$var$getBasicSelectionOption(option) {
    if (!option) return option;
    const { lang: lang, assocLang: assocLang, characteristics: characteristics, channels: channels, audioCodec: audioCodec } = option;
    return {
        lang: lang,
        assocLang: assocLang,
        characteristics: characteristics,
        channels: channels,
        audioCodec: audioCodec
    };
}
function $99a156a15cd35eb3$var$findMatchingOption(option, tracks, matchPredicate) {
    if ('attrs' in option) {
        const index = tracks.indexOf(option);
        if (index !== -1) return index;
    }
    for(let i = 0; i < tracks.length; i++){
        const track = tracks[i];
        if ($99a156a15cd35eb3$var$matchesOption(option, track, matchPredicate)) return i;
    }
    return -1;
}
function $99a156a15cd35eb3$var$matchesOption(option, track, matchPredicate) {
    const { groupId: groupId, name: name, lang: lang, assocLang: assocLang, default: isDefault } = option;
    const forced = option.forced;
    return (groupId === undefined || track.groupId === groupId) && (name === undefined || track.name === name) && (lang === undefined || $99a156a15cd35eb3$var$languagesMatch(lang, track.lang)) && (lang === undefined || track.assocLang === assocLang) && (isDefault === undefined || track.default === isDefault) && (forced === undefined || track.forced === forced) && (!('characteristics' in option) || $99a156a15cd35eb3$var$characteristicsMatch(option.characteristics || '', track.characteristics)) && (matchPredicate === undefined || matchPredicate(option, track));
}
function $99a156a15cd35eb3$var$languagesMatch(languageA, languageB = '--') {
    if (languageA.length === languageB.length) return languageA === languageB;
    return languageA.startsWith(languageB) || languageB.startsWith(languageA);
}
function $99a156a15cd35eb3$var$characteristicsMatch(characteristicsA, characteristicsB = '') {
    const arrA = characteristicsA.split(',');
    const arrB = characteristicsB.split(',');
    // Expects each item to be unique:
    return arrA.length === arrB.length && !arrA.some((el)=>arrB.indexOf(el) === -1);
}
function $99a156a15cd35eb3$var$audioMatchPredicate(option, track) {
    const { audioCodec: audioCodec, channels: channels } = option;
    return (audioCodec === undefined || (track.audioCodec || '').substring(0, 4) === audioCodec.substring(0, 4)) && (channels === undefined || channels === (track.channels || '2'));
}
function $99a156a15cd35eb3$var$findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
    const currentLevel = levels[searchIndex];
    // Are there variants with same URI as current level?
    // If so, find a match that does not require any level URI change
    const variants = levels.reduce((variantMap, level, index)=>{
        const uri = level.uri;
        const renditions = variantMap[uri] || (variantMap[uri] = []);
        renditions.push(index);
        return variantMap;
    }, {});
    const renditions = variants[currentLevel.uri];
    if (renditions.length > 1) searchIndex = Math.max.apply(Math, renditions);
    // Find best match
    const currentVideoRange = currentLevel.videoRange;
    const currentFrameRate = currentLevel.frameRate;
    const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
    const matchingVideo = $99a156a15cd35eb3$var$searchDownAndUpList(levels, searchIndex, (level)=>{
        if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) return false;
        const audioGroups = level.audioGroups;
        const tracks = allAudioTracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
        return $99a156a15cd35eb3$var$findMatchingOption(option, tracks, matchPredicate) > -1;
    });
    if (matchingVideo > -1) return matchingVideo;
    return $99a156a15cd35eb3$var$searchDownAndUpList(levels, searchIndex, (level)=>{
        const audioGroups = level.audioGroups;
        const tracks = allAudioTracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
        return $99a156a15cd35eb3$var$findMatchingOption(option, tracks, matchPredicate) > -1;
    });
}
function $99a156a15cd35eb3$var$searchDownAndUpList(arr, searchIndex, predicate) {
    for(let i = searchIndex; i > -1; i--){
        if (predicate(arr[i])) return i;
    }
    for(let i = searchIndex + 1; i < arr.length; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}
function $99a156a15cd35eb3$var$useAlternateAudio(audioTrackUrl, hls) {
    var _hls$loadLevelObj;
    return !!audioTrackUrl && audioTrackUrl !== ((_hls$loadLevelObj = hls.loadLevelObj) == null ? void 0 : _hls$loadLevelObj.uri);
}
class $99a156a15cd35eb3$export$264ac4b6e832e14e extends $99a156a15cd35eb3$var$Logger {
    constructor(_hls){
        super('abr', _hls.logger);
        this.hls = void 0;
        this.lastLevelLoadSec = 0;
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        this._nextAutoLevel = -1;
        this.nextAutoLevelKey = '';
        this.audioTracksByGroup = null;
        this.codecTiers = null;
        this.timer = -1;
        this.fragCurrent = null;
        this.partCurrent = null;
        this.bitrateTestDelay = 0;
        this.rebufferNotice = -1;
        this.bwEstimator = void 0;
        /*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */ this._abandonRulesCheck = (levelLoaded)=>{
            var _ref;
            const { fragCurrent: frag, partCurrent: part, hls: hls } = this;
            const { autoLevelEnabled: autoLevelEnabled, media: media } = hls;
            if (!frag || !media) return;
            const now = performance.now();
            const stats = part ? part.stats : frag.stats;
            const duration = part ? part.duration : frag.duration;
            const timeLoading = now - stats.loading.start;
            const minAutoLevel = hls.minAutoLevel;
            const loadingFragForLevel = frag.level;
            const currentAutoLevel = this._nextAutoLevel;
            // If frag loading is aborted, complete, or from lowest level, stop timer and return
            if (stats.aborted || stats.loaded && stats.loaded === stats.total || loadingFragForLevel <= minAutoLevel) {
                this.clearTimer();
                // reset forced auto level value so that next level will be selected
                this._nextAutoLevel = -1;
                return;
            }
            // This check only runs if we're in ABR mode
            if (!autoLevelEnabled) return;
            // Must be loading/loaded a new level or be in a playing state
            const fragBlockingSwitch = currentAutoLevel > -1 && currentAutoLevel !== loadingFragForLevel;
            const levelChange = !!levelLoaded || fragBlockingSwitch;
            if (!levelChange && (media.paused || !media.playbackRate || !media.readyState)) return;
            const bufferInfo = hls.mainForwardBufferInfo;
            if (!levelChange && bufferInfo === null) return;
            const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
            const playbackRate = Math.abs(media.playbackRate);
            // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
            if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) return;
            // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
            const bufferStarvationDelay = bufferInfo ? bufferInfo.len / playbackRate : 0;
            const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
            const loadedFirstByte = stats.loaded && ttfb > -1;
            const bwEstimate = this.getBwEstimate();
            const levels = hls.levels;
            const level = levels[loadingFragForLevel];
            const expectedLen = Math.max(stats.loaded, Math.round(duration * (frag.bitrate || level.averageBitrate) / 8));
            let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
            if (timeStreaming < 1 && loadedFirstByte) timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
            const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
            // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
            const ttfbSeconds = ttfbEstimate / 1000;
            const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbSeconds;
            // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
            if (fragLoadedDelay <= bufferStarvationDelay) return;
            const bwe = loadRate ? loadRate * 8 : bwEstimate;
            const live = ((_ref = (levelLoaded == null ? void 0 : levelLoaded.details) || this.hls.latestLevelDetails) == null ? void 0 : _ref.live) === true;
            const abrBandWidthUpFactor = this.hls.config.abrBandWidthUpFactor;
            let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
            let nextLoadLevel;
            // Iterate through lower level and try to find the largest one that avoids rebuffering
            for(nextLoadLevel = loadingFragForLevel - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--){
                // compute time to load next fragment at lower level
                // 8 = bits per byte (bps/Bps)
                const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
                const requiresLevelLoad = !levels[nextLoadLevel].details || live;
                fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbSeconds, bwe, duration * levelNextBitrate, requiresLevelLoad);
                if (fragLevelNextLoadedDelay < Math.min(bufferStarvationDelay, duration + ttfbSeconds)) break;
            }
            // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
            // to load the current one
            if (fragLevelNextLoadedDelay >= fragLoadedDelay) return;
            // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
            if (fragLevelNextLoadedDelay > duration * 10) return;
            if (loadedFirstByte) // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
            this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
            else // If there has been no loading progress, sample TTFB
            this.bwEstimator.sampleTTFB(timeLoading);
            const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
            if (this.getBwEstimate() * abrBandWidthUpFactor > nextLoadLevelBitrate) this.resetEstimator(nextLoadLevelBitrate);
            const bestSwitchLevel = this.findBestLevel(nextLoadLevelBitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
            if (bestSwitchLevel > -1) nextLoadLevel = bestSwitchLevel;
            this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${loadingFragForLevel} is loading too slowly;
      Fragment duration: ${frag.duration.toFixed(3)}
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${$99a156a15cd35eb3$var$isFiniteNumber(bwEstimate) ? bwEstimate | 0 : 'Unknown'} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
            hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
            this.clearTimer();
            const abortAndSwitch = ()=>{
                // Are nextLoadLevel details available or is stream-controller still in "WAITING_LEVEL" state?
                this.clearTimer();
                if (this.fragCurrent === frag && this.hls.loadLevel === nextLoadLevel && nextLoadLevel > 0) {
                    const bufferStarvationDelay = this.getStarvationDelay();
                    this.warn(`Aborting inflight request ${nextLoadLevel > 0 ? 'and switching down' : ''}
      Fragment duration: ${frag.duration.toFixed(3)} s
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s`);
                    frag.abortRequests();
                    this.fragCurrent = this.partCurrent = null;
                    if (nextLoadLevel > minAutoLevel) {
                        let lowestSwitchLevel = this.findBestLevel(this.hls.levels[minAutoLevel].bitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
                        if (lowestSwitchLevel === -1) lowestSwitchLevel = minAutoLevel;
                        this.hls.nextLoadLevel = this.hls.nextAutoLevel = lowestSwitchLevel;
                        this.resetEstimator(this.hls.levels[lowestSwitchLevel].bitrate);
                    }
                }
            };
            if (fragBlockingSwitch || fragLoadedDelay > fragLevelNextLoadedDelay * 2) abortAndSwitch();
            else this.timer = self.setInterval(abortAndSwitch, fragLevelNextLoadedDelay * 1000);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOAD_EMERGENCY_ABORTED, {
                frag: frag,
                part: part,
                stats: stats
            });
        };
        this.hls = _hls;
        this.bwEstimator = this.initEstimator();
        this.registerListeners();
    }
    resetEstimator(abrEwmaDefaultEstimate) {
        if (abrEwmaDefaultEstimate) {
            this.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
            this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
        }
        this.firstSelection = -1;
        this.bwEstimator = this.initEstimator();
    }
    initEstimator() {
        const config = this.hls.config;
        return new $99a156a15cd35eb3$var$EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.clearTimer();
        // @ts-ignore
        this.hls = this._abandonRulesCheck = null;
        this.fragCurrent = this.partCurrent = null;
    }
    onManifestLoading(event, data) {
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        this.lastLevelLoadSec = 0;
        this.fragCurrent = this.partCurrent = null;
        this.onLevelsUpdated();
        this.clearTimer();
    }
    onLevelsUpdated() {
        if (this.lastLoadedFragLevel > -1 && this.fragCurrent) this.lastLoadedFragLevel = this.fragCurrent.level;
        this._nextAutoLevel = -1;
        this.onMaxAutoLevelUpdated();
        this.codecTiers = null;
        this.audioTracksByGroup = null;
    }
    onMaxAutoLevelUpdated() {
        this.firstSelection = -1;
        this.nextAutoLevelKey = '';
    }
    onFragLoading(event, data) {
        const frag = data.frag;
        if (this.ignoreFragment(frag)) return;
        if (!frag.bitrateTest) {
            var _data$part;
            this.fragCurrent = frag;
            this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
        }
        this.clearTimer();
        this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
    onLevelSwitching(event, data) {
        this.clearTimer();
    }
    onError(event, data) {
        if (data.fatal) return;
        switch(data.details){
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                // Reset last loaded level so that a new selection can be made after calling recoverMediaError
                this.lastLoadedFragLevel = -1;
                this.firstSelection = -1;
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
                {
                    const frag = data.frag;
                    const { fragCurrent: fragCurrent, partCurrent: part } = this;
                    if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
                        const now = performance.now();
                        const stats = part ? part.stats : frag.stats;
                        const timeLoading = now - stats.loading.start;
                        const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
                        const loadedFirstByte = stats.loaded && ttfb > -1;
                        if (loadedFirstByte) {
                            const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
                            this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
                        } else this.bwEstimator.sampleTTFB(timeLoading);
                    }
                    break;
                }
        }
    }
    getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
        const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
        const playlistLoadSec = isSwitch ? timeToFirstByteSec + this.lastLevelLoadSec : 0;
        return fragLoadSec + playlistLoadSec;
    }
    onLevelLoaded(event, data) {
        const config = this.hls.config;
        const { loading: loading } = data.stats;
        const timeLoadingMs = loading.end - loading.first;
        if ($99a156a15cd35eb3$var$isFiniteNumber(timeLoadingMs)) this.lastLevelLoadSec = timeLoadingMs / 1000;
        if (data.details.live) this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
        else this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
        if (this.timer > -1) this._abandonRulesCheck(data.levelInfo);
    }
    onFragLoaded(event, { frag: frag, part: part }) {
        const stats = part ? part.stats : frag.stats;
        if (frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN) this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
        if (this.ignoreFragment(frag)) return;
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        if (frag.level === this._nextAutoLevel) this._nextAutoLevel = -1;
        this.firstSelection = -1;
        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
            const duration = part ? part.duration : frag.duration;
            const level = this.hls.levels[frag.level];
            const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
            const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
            level.loaded = {
                bytes: loadedBytes,
                duration: loadedDuration
            };
            level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        if (frag.bitrateTest) {
            const fragBufferedData = {
                stats: stats,
                frag: frag,
                part: part,
                id: frag.type
            };
            this.onFragBuffered($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, fragBufferedData);
            frag.bitrateTest = false;
        } else // store level id after successful fragment load for playback
        this.lastLoadedFragLevel = frag.level;
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
        if (stats.aborted) return;
        if (this.ignoreFragment(frag)) return;
        // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
        // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
        // is used. If we used buffering in that case, our BW estimate sample will be very large.
        const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
        this.bwEstimator.sample(processingMs, stats.loaded);
        stats.bwEstimate = this.getBwEstimate();
        if (frag.bitrateTest) this.bitrateTestDelay = processingMs / 1000;
        else this.bitrateTestDelay = 0;
    }
    ignoreFragment(frag) {
        // Only count non-alt-audio frags which were actually buffered in our BW calculations
        return frag.type !== $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN || frag.sn === 'initSegment';
    }
    clearTimer() {
        if (this.timer > -1) {
            self.clearInterval(this.timer);
            this.timer = -1;
        }
    }
    get firstAutoLevel() {
        const { maxAutoLevel: maxAutoLevel, minAutoLevel: minAutoLevel } = this.hls;
        const bwEstimate = this.getBwEstimate();
        const maxStartDelay = this.hls.config.maxStarvationDelay;
        const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
        if (abrAutoLevel > -1) return abrAutoLevel;
        const firstLevel = this.hls.firstLevel;
        const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
        this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
        return clamped;
    }
    get forcedAutoLevel() {
        if (this.nextAutoLevelKey) return -1;
        return this._nextAutoLevel;
    }
    // return next auto level
    get nextAutoLevel() {
        const forcedAutoLevel = this.forcedAutoLevel;
        const bwEstimator = this.bwEstimator;
        const useEstimate = bwEstimator.canEstimate();
        const loadedFirstFrag = this.lastLoadedFragLevel > -1;
        // in case next auto level has been forced, and bw not available or not reliable, return forced value
        if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) return forcedAutoLevel;
        // compute next level using ABR logic
        const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;
        // use forced auto level while it hasn't errored more than ABR selection
        if (forcedAutoLevel !== -1) {
            const levels = this.hls.levels;
            if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) return forcedAutoLevel;
        }
        // save result until state has changed
        this._nextAutoLevel = nextABRAutoLevel;
        this.nextAutoLevelKey = this.getAutoLevelKey();
        return nextABRAutoLevel;
    }
    getAutoLevelKey() {
        return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
    }
    getNextABRAutoLevel() {
        const { fragCurrent: fragCurrent, partCurrent: partCurrent, hls: hls } = this;
        if (hls.levels.length <= 1) return hls.loadLevel;
        const { maxAutoLevel: maxAutoLevel, config: config, minAutoLevel: minAutoLevel } = hls;
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const avgbw = this.getBwEstimate();
        // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
        const bufferStarvationDelay = this.getStarvationDelay();
        let bwFactor = config.abrBandWidthFactor;
        let bwUpFactor = config.abrBandWidthUpFactor;
        // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
        if (bufferStarvationDelay) {
            const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
            if (_bestLevel >= 0) {
                this.rebufferNotice = -1;
                return _bestLevel;
            }
        }
        // not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
        let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
        if (!bufferStarvationDelay) {
            // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
            const bitrateTestDelay = this.bitrateTestDelay;
            if (bitrateTestDelay) {
                // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                // max video loading delay used in  automatic start level selection :
                // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                this.info(`bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
                // don't use conservative factor on bitrate test
                bwFactor = bwUpFactor = 1;
            }
        }
        const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
        if (this.rebufferNotice !== bestLevel) {
            this.rebufferNotice = bestLevel;
            this.info(`${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, optimal quality level ${bestLevel}`);
        }
        if (bestLevel > -1) return bestLevel;
        // If no matching level found, see if min auto level would be a better option
        const minLevel = hls.levels[minAutoLevel];
        const autoLevel = hls.loadLevelObj;
        if (autoLevel && (minLevel == null ? void 0 : minLevel.bitrate) < autoLevel.bitrate) return minAutoLevel;
        // or if bitrate is not lower, continue to use loadLevel
        return hls.loadLevel;
    }
    getStarvationDelay() {
        const hls = this.hls;
        const media = hls.media;
        if (!media) return Infinity;
        // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
        // if we're playing back at the normal rate.
        const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
        const bufferInfo = hls.mainForwardBufferInfo;
        return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
    }
    getBwEstimate() {
        return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
    }
    findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
        var _this$hls$latestLevel;
        const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
        const lastLoadedFragLevel = this.lastLoadedFragLevel;
        const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
        const { fragCurrent: fragCurrent, partCurrent: partCurrent } = this;
        const { levels: levels, allAudioTracks: allAudioTracks, loadLevel: loadLevel, config: config } = this.hls;
        if (levels.length === 1) return 0;
        const level = levels[selectionBaseLevel];
        const live = !!((_this$hls$latestLevel = this.hls.latestLevelDetails) != null && _this$hls$latestLevel.live);
        const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
        let currentCodecSet;
        let currentVideoRange = 'SDR';
        let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
        const { audioPreference: audioPreference, videoPreference: videoPreference } = config;
        const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = $99a156a15cd35eb3$var$getAudioTracksByGroup(allAudioTracks));
        let minStartIndex = -1;
        if (firstSelection) {
            if (this.firstSelection !== -1) return this.firstSelection;
            const codecTiers = this.codecTiers || (this.codecTiers = $99a156a15cd35eb3$var$getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel));
            const startTier = $99a156a15cd35eb3$var$getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference);
            const { codecSet: codecSet, videoRanges: videoRanges, minFramerate: minFramerate, minBitrate: minBitrate, minIndex: minIndex, preferHDR: preferHDR } = startTier;
            minStartIndex = minIndex;
            currentCodecSet = codecSet;
            currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
            currentFrameRate = minFramerate;
            currentBw = Math.max(currentBw, minBitrate);
            this.log(`picked start tier ${$99a156a15cd35eb3$var$stringify(startTier)}`);
        } else {
            currentCodecSet = level == null ? void 0 : level.codecSet;
            currentVideoRange = level == null ? void 0 : level.videoRange;
        }
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
        const levelsSkipped = [];
        for(let i = maxAutoLevel; i >= minAutoLevel; i--){
            var _levelInfo$supportedR;
            const levelInfo = levels[i];
            const upSwitch = i > selectionBaseLevel;
            if (!levelInfo) continue;
            if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
                const mediaCapabilities = navigator.mediaCapabilities;
                if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === 'function' && ($99a156a15cd35eb3$var$requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) || $99a156a15cd35eb3$var$isHEVC(levelInfo.videoCodec) // Force media capabilities check for HEVC to avoid failure on Windows
                )) {
                    levelInfo.supportedPromise = $99a156a15cd35eb3$var$getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities);
                    levelInfo.supportedPromise.then((decodingInfo)=>{
                        if (!this.hls) return;
                        levelInfo.supportedResult = decodingInfo;
                        const levels = this.hls.levels;
                        const index = levels.indexOf(levelInfo);
                        if (decodingInfo.error) this.warn(`MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${$99a156a15cd35eb3$var$stringify(decodingInfo)}`);
                        else if (!decodingInfo.supported) {
                            this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${index} ${$99a156a15cd35eb3$var$stringify(decodingInfo)}`);
                            if (index > -1 && levels.length > 1) {
                                this.log(`Removing unsupported level ${index}`);
                                this.hls.removeLevel(index);
                                if (this.hls.loadLevel === -1) this.hls.nextLoadLevel = 0;
                            }
                        }
                    });
                } else levelInfo.supportedResult = $99a156a15cd35eb3$var$SUPPORTED_INFO_DEFAULT;
            }
            // skip candidates which change codec-family or video-range,
            // and which decrease or increase frame-rate for up and down-switch respectfully
            if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || levelInfo.supportedResult && !((_levelInfo$supportedR = levelInfo.supportedResult.decodingInfoResults) != null && _levelInfo$supportedR[0].smooth)) {
                if (!firstSelection || i !== minStartIndex) {
                    levelsSkipped.push(i);
                    continue;
                }
            }
            const levelDetails = levelInfo.details;
            const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
            let adjustedbw;
            // follow algorithm captured from stagefright :
            // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
            // Pick the highest bandwidth stream below or equal to estimated bandwidth.
            // consider only 80% of the available bandwidth, but if we are switching up,
            // be even more conservative (70%) to avoid overestimating and immediately
            // switching back.
            if (!upSwitch) adjustedbw = bwFactor * currentBw;
            else adjustedbw = bwUpFactor * currentBw;
            // Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
            const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levelInfo.averageBitrate : levelInfo.maxBitrate;
            const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
            const canSwitchWithinTolerance = // if adjusted bw is greater than level bitrate AND
            adjustedbw >= bitrate && // no level change, or new level has no error history
            (i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
            // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
            // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
            (fetchDuration <= ttfbEstimateSec || !$99a156a15cd35eb3$var$isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration);
            if (canSwitchWithinTolerance) {
                const forcedAutoLevel = this.forcedAutoLevel;
                if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
                    if (levelsSkipped.length) this.trace(`Skipped level(s) ${levelsSkipped.join(',')} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${currentCodecSet}" ${currentVideoRange}`);
                    this.info(`switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${levelInfo.codecSet} videoRange:${levelInfo.videoRange} hls.loadLevel:${loadLevel}`);
                }
                if (firstSelection) this.firstSelection = i;
                // as we are looping from highest to lowest, this will return the best achievable quality level
                return i;
            }
        }
        // not enough time budget even with quality level 0 ... rebuffering might happen
        return -1;
    }
    set nextAutoLevel(nextLevel) {
        const value = this.deriveNextAutoLevel(nextLevel);
        if (this._nextAutoLevel !== value) {
            this.nextAutoLevelKey = '';
            this._nextAutoLevel = value;
        }
    }
    deriveNextAutoLevel(nextLevel) {
        const { maxAutoLevel: maxAutoLevel, minAutoLevel: minAutoLevel } = this.hls;
        return Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
    }
}
const $99a156a15cd35eb3$var$BinarySearch = {
    /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */ search: function(list, comparisonFn) {
        let minIndex = 0;
        let maxIndex = list.length - 1;
        let currentIndex = null;
        let currentElement = null;
        while(minIndex <= maxIndex){
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];
            const comparisonResult = comparisonFn(currentElement);
            if (comparisonResult > 0) minIndex = currentIndex + 1;
            else if (comparisonResult < 0) maxIndex = currentIndex - 1;
            else return currentElement;
        }
        return null;
    }
};
/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */ function $99a156a15cd35eb3$var$findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
    if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !$99a156a15cd35eb3$var$isFiniteNumber(PDTValue)) return null;
    // if less than start
    const startPDT = fragments[0].programDateTime;
    if (PDTValue < (startPDT || 0)) return null;
    const endPDT = fragments[fragments.length - 1].endProgramDateTime;
    if (PDTValue >= (endPDT || 0)) return null;
    for(let seg = 0; seg < fragments.length; ++seg){
        const frag = fragments[seg];
        if ($99a156a15cd35eb3$var$pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) return frag;
    }
    return null;
}
/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */ function $99a156a15cd35eb3$var$findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0, nextFragLookupTolerance = 0.005) {
    let fragNext = null;
    if (fragPrevious) {
        fragNext = fragments[1 + fragPrevious.sn - fragments[0].sn] || null;
        // check for buffer-end rounding error
        const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
        if (bufferEdgeError > 0 && bufferEdgeError < 0.0000015) bufferEnd += 0.0000015;
        if (fragNext && fragPrevious.level !== fragNext.level && fragNext.end <= fragPrevious.end) fragNext = fragments[2 + fragPrevious.sn - fragments[0].sn] || null;
    } else if (bufferEnd === 0 && fragments[0].start === 0) fragNext = fragments[0];
    // Prefer the next fragment if it's within tolerance
    if (fragNext && ((!fragPrevious || fragPrevious.level === fragNext.level) && $99a156a15cd35eb3$var$fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0 || $99a156a15cd35eb3$var$fragmentWithinFastStartSwitch(fragNext, fragPrevious, Math.min(nextFragLookupTolerance, maxFragLookUpTolerance)))) return fragNext;
    // We might be seeking past the tolerance so find the best match
    const foundFragment = $99a156a15cd35eb3$var$BinarySearch.search(fragments, $99a156a15cd35eb3$var$fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
    if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) return foundFragment;
    // If no match was found return the next fragment after fragPrevious, or null
    return fragNext;
}
function $99a156a15cd35eb3$var$fragmentWithinFastStartSwitch(fragNext, fragPrevious, nextFragLookupTolerance) {
    if (fragPrevious && fragPrevious.start === 0 && fragPrevious.level < fragNext.level && (fragPrevious.endPTS || 0) > 0) {
        const firstDuration = fragPrevious.tagList.reduce((duration, tag)=>{
            if (tag[0] === 'INF') duration += parseFloat(tag[1]);
            return duration;
        }, nextFragLookupTolerance);
        return fragNext.start <= firstDuration;
    }
    return false;
}
/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */ function $99a156a15cd35eb3$var$fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
    // eagerly accept an accurate match (no tolerance)
    if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) return 0;
    // offset should be within fragment boundary - config.maxFragLookUpTolerance
    // this is to cope with situations like
    // bufferEnd = 9.991
    // frag[Ø] : [0,10]
    // frag[1] : [10,20]
    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
    //              frag start               frag start+duration
    //                  |-----------------------------|
    //              <--->                         <--->
    //  ...--------><-----------------------------><---------....
    // previous frag         matching fragment         next frag
    //  return -1             return 0                 return 1
    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
    return 0;
}
/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */ function $99a156a15cd35eb3$var$pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;
    // endProgramDateTime can be null, default to zero
    const endProgramDateTime = candidate.endProgramDateTime || 0;
    return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function $99a156a15cd35eb3$var$findNearestWithCC(details, cc, pos) {
    if (details) {
        if (details.startCC <= cc && details.endCC >= cc) {
            let fragments = details.fragments;
            const { fragmentHint: fragmentHint } = details;
            if (fragmentHint) fragments = fragments.concat(fragmentHint);
            let closest;
            $99a156a15cd35eb3$var$BinarySearch.search(fragments, (candidate)=>{
                if (candidate.cc < cc) return 1;
                if (candidate.cc > cc) return -1;
                closest = candidate;
                if (candidate.end <= pos) return 1;
                if (candidate.start > pos) return -1;
                return 0;
            });
            return closest || null;
        }
    }
    return null;
}
function $99a156a15cd35eb3$var$isTimeoutError(error) {
    switch(error.details){
        case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
        case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
        case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT:
        case $99a156a15cd35eb3$export$d053ec805ce391aa.MANIFEST_LOAD_TIMEOUT:
            return true;
    }
    return false;
}
function $99a156a15cd35eb3$var$getRetryConfig(loadPolicy, error) {
    const isTimeout = $99a156a15cd35eb3$var$isTimeoutError(error);
    return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function $99a156a15cd35eb3$var$getRetryDelay(retryConfig, retryCount) {
    // exponential backoff capped to max retry delay
    const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
    return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function $99a156a15cd35eb3$var$getLoaderConfigWithoutReties(loderConfig) {
    return $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, loderConfig), {
        errorRetry: null,
        timeoutRetry: null
    });
}
function $99a156a15cd35eb3$var$shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
    if (!retryConfig) return false;
    const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
    const retry = retryCount < retryConfig.maxNumRetry && ($99a156a15cd35eb3$var$retryForHttpStatus(httpStatus) || !!isTimeout);
    return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function $99a156a15cd35eb3$var$retryForHttpStatus(httpStatus) {
    // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
    return httpStatus === 0 && navigator.onLine === false || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}
var $99a156a15cd35eb3$export$679390c50dd617e4 = {
    DoNothing: 0,
    SendEndCallback: 1,
    SendAlternateToPenaltyBox: 2,
    RemoveAlternatePermanently: 3,
    InsertDiscontinuity: 4,
    RetryRequest: 5
};
var $99a156a15cd35eb3$export$f377ad9144b2d7af = {
    None: 0,
    MoveAllAlternatesMatchingHost: 1,
    MoveAllAlternatesMatchingHDCP: 2,
    SwitchToSDR: 4
};
class $99a156a15cd35eb3$export$2f5b22783539ff2 extends $99a156a15cd35eb3$var$Logger {
    constructor(hls){
        super('error-controller', hls.logger);
        this.hls = void 0;
        this.playlistError = 0;
        this.penalizedRenditions = {};
        this.hls = hls;
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onErrorOut, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    destroy() {
        this.unregisterListeners();
        // @ts-ignore
        this.hls = null;
        this.penalizedRenditions = {};
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.playlistError = 0;
    }
    getVariantLevelIndex(frag) {
        return (frag == null ? void 0 : frag.type) === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN ? frag.level : this.hls.loadLevel;
    }
    onManifestLoading() {
        this.playlistError = 0;
        this.penalizedRenditions = {};
    }
    onLevelUpdated() {
        this.playlistError = 0;
    }
    onError(event, data) {
        var _data$frag;
        if (data.fatal) return;
        const hls = this.hls;
        const context = data.context;
        switch(data.details){
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR:
                // ignore empty segment errors marked as gap
                if ((_data$frag = data.frag) != null && _data$frag.gap) {
                    data.errorAction = $99a156a15cd35eb3$var$createDoNothingErrorAction();
                    return;
                }
            // falls through
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR:
                // Switch level if possible, otherwise allow retry count to reach max error retries
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                data.errorAction.action = $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox;
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_EMPTY_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_PARSING_ERROR:
                {
                    var _data$context, _data$context$levelDe;
                    // Only retry when empty and live
                    const levelIndex = data.parent === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN ? data.level : hls.loadLevel;
                    if (data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context$levelDe = _data$context.levelDetails) != null && _data$context$levelDe.live)) data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
                    else {
                        // Escalate to fatal if not retrying or switching
                        data.levelRetry = false;
                        data.errorAction = this.getLevelSwitchAction(data, levelIndex);
                    }
                }
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT:
                if (typeof (context == null ? void 0 : context.level) === 'number') data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_TIMEOUT:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.SUBTITLE_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.SUBTITLE_TRACK_LOAD_TIMEOUT:
                if (context) {
                    const level = hls.loadLevelObj;
                    if (level && (context.type === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
                        // Perform Pathway switch or Redundant failover if possible for fastest recovery
                        // otherwise allow playlist retry count to reach max error retries
                        data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
                        data.errorAction.action = $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox;
                        data.errorAction.flags = $99a156a15cd35eb3$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost;
                        return;
                    }
                }
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
                {
                    const level = hls.loadLevelObj;
                    const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
                    if (restrictedHdcpLevel) data.errorAction = {
                        action: $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox,
                        flags: $99a156a15cd35eb3$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHDCP,
                        hdcpLevel: restrictedHdcpLevel
                    };
                    else this.keySystemError(data);
                }
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.REMUX_ALLOC_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                // Buffer-controller can set errorAction when append errors can be ignored or resolved locally
                if (!data.errorAction) {
                    var _data$level;
                    data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
                }
                return;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_EXCEPTION:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPENDING_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_FULL_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_SWITCH_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_SEEK_OVER_HOLE:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_NUDGE_ON_STALL:
                data.errorAction = $99a156a15cd35eb3$var$createDoNothingErrorAction();
                return;
        }
        if (data.type === $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR) this.keySystemError(data);
    }
    keySystemError(data) {
        const levelIndex = this.getVariantLevelIndex(data.frag);
        // Do not retry level. Escalate to fatal if switching levels fails.
        data.levelRetry = false;
        data.errorAction = this.getLevelSwitchAction(data, levelIndex);
    }
    getPlaylistRetryOrSwitchAction(data, levelIndex) {
        const hls = this.hls;
        const retryConfig = $99a156a15cd35eb3$var$getRetryConfig(hls.config.playlistLoadPolicy, data);
        const retryCount = this.playlistError++;
        const retry = $99a156a15cd35eb3$var$shouldRetry(retryConfig, retryCount, $99a156a15cd35eb3$var$isTimeoutError(data), data.response);
        if (retry) return {
            action: $99a156a15cd35eb3$export$679390c50dd617e4.RetryRequest,
            flags: $99a156a15cd35eb3$export$f377ad9144b2d7af.None,
            retryConfig: retryConfig,
            retryCount: retryCount
        };
        const errorAction = this.getLevelSwitchAction(data, levelIndex);
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = retryCount;
        }
        return errorAction;
    }
    getFragRetryOrSwitchAction(data) {
        const hls = this.hls;
        // Share fragment error count accross media options (main, audio, subs)
        // This allows for level based rendition switching when media option assets fail
        const variantLevelIndex = this.getVariantLevelIndex(data.frag);
        const level = hls.levels[variantLevelIndex];
        const { fragLoadPolicy: fragLoadPolicy, keyLoadPolicy: keyLoadPolicy } = hls.config;
        const retryConfig = $99a156a15cd35eb3$var$getRetryConfig(data.details.startsWith('key') ? keyLoadPolicy : fragLoadPolicy, data);
        const fragmentErrors = hls.levels.reduce((acc, level)=>acc + level.fragmentError, 0);
        // Switch levels when out of retried or level index out of bounds
        if (level) {
            if (data.details !== $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP) level.fragmentError++;
            const retry = $99a156a15cd35eb3$var$shouldRetry(retryConfig, fragmentErrors, $99a156a15cd35eb3$var$isTimeoutError(data), data.response);
            if (retry) return {
                action: $99a156a15cd35eb3$export$679390c50dd617e4.RetryRequest,
                flags: $99a156a15cd35eb3$export$f377ad9144b2d7af.None,
                retryConfig: retryConfig,
                retryCount: fragmentErrors
            };
        }
        // Reach max retry count, or Missing level reference
        // Switch to valid index
        const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
        // Add retry details to allow skipping of FRAG_PARSING_ERROR
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = fragmentErrors;
        }
        return errorAction;
    }
    getLevelSwitchAction(data, levelIndex) {
        const hls = this.hls;
        if (levelIndex === null || levelIndex === undefined) levelIndex = hls.loadLevel;
        const level = this.hls.levels[levelIndex];
        if (level) {
            var _data$frag2, _data$context2;
            const errorDetails = data.details;
            level.loadError++;
            if (errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR) level.fragmentError++;
            // Search for next level to retry
            let nextLevel = -1;
            const { levels: levels, loadLevel: loadLevel, minAutoLevel: minAutoLevel, maxAutoLevel: maxAutoLevel } = hls;
            if (!hls.autoLevelEnabled && !hls.config.preserveManualLevelOnError) hls.loadLevel = -1;
            const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
            // Find alternate audio codec if available on audio codec error
            const isAudioCodecError = fragErrorType === $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO && errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR || data.sourceBufferName === 'audio' && (errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR || errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR);
            const findAudioCodecAlternate = isAudioCodecError && levels.some(({ audioCodec: audioCodec })=>level.audioCodec !== audioCodec);
            // Find alternate video codec if available on video codec error
            const isVideoCodecError = data.sourceBufferName === 'video' && (errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR || errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR);
            const findVideoCodecAlternate = isVideoCodecError && levels.some(({ codecSet: codecSet, audioCodec: audioCodec })=>level.codecSet !== codecSet && level.audioCodec === audioCodec);
            const { type: playlistErrorType, groupId: playlistErrorGroupId } = (_data$context2 = data.context) != null ? _data$context2 : {};
            for(let i = levels.length; i--;){
                const candidate = (i + loadLevel) % levels.length;
                if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
                    var _level$audioGroups, _level$subtitleGroups;
                    const levelCandidate = levels[candidate];
                    // Skip level switch if GAP tag is found in next level at same position
                    if (errorDetails === $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP && fragErrorType === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN && data.frag) {
                        const levelDetails = levels[candidate].details;
                        if (levelDetails) {
                            const fragCandidate = $99a156a15cd35eb3$var$findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
                            if (fragCandidate != null && fragCandidate.gap) continue;
                        }
                    } else if (playlistErrorType === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) continue;
                    else if (fragErrorType === $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some((groupId)=>levelCandidate.hasAudioGroup(groupId)) || fragErrorType === $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some((groupId)=>levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || !findAudioCodecAlternate && level.audioCodec !== levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet) continue;
                    nextLevel = candidate;
                    break;
                }
            }
            if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
                data.levelRetry = true;
                this.playlistError = 0;
                return {
                    action: $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox,
                    flags: $99a156a15cd35eb3$export$f377ad9144b2d7af.None,
                    nextAutoLevel: nextLevel
                };
            }
        }
        // No levels to switch / Manual level selection / Level not found
        // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
        return {
            action: $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox,
            flags: $99a156a15cd35eb3$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost
        };
    }
    onErrorOut(event, data) {
        var _data$errorAction;
        switch((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action){
            case $99a156a15cd35eb3$export$679390c50dd617e4.DoNothing:
                break;
            case $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox:
                this.sendAlternateToPenaltyBox(data);
                if (!data.errorAction.resolved && data.details !== $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP) data.fatal = true;
                else if (/MediaSource readyState: ended/.test(data.error.message)) {
                    this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
                    this.hls.recoverMediaError();
                }
                break;
            case $99a156a15cd35eb3$export$679390c50dd617e4.RetryRequest:
                break;
        }
        if (data.fatal) {
            this.hls.stopLoad();
            return;
        }
    }
    sendAlternateToPenaltyBox(data) {
        const hls = this.hls;
        const errorAction = data.errorAction;
        if (!errorAction) return;
        const { flags: flags, hdcpLevel: hdcpLevel, nextAutoLevel: nextAutoLevel } = errorAction;
        switch(flags){
            case $99a156a15cd35eb3$export$f377ad9144b2d7af.None:
                this.switchLevel(data, nextAutoLevel);
                break;
            case $99a156a15cd35eb3$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHDCP:
                if (hdcpLevel) {
                    hls.maxHdcpLevel = $99a156a15cd35eb3$var$HdcpLevels[$99a156a15cd35eb3$var$HdcpLevels.indexOf(hdcpLevel) - 1];
                    errorAction.resolved = true;
                }
                this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
                break;
        }
        // If not resolved by previous actions try to switch to next level
        if (!errorAction.resolved) this.switchLevel(data, nextAutoLevel);
    }
    switchLevel(data, levelIndex) {
        if (levelIndex !== undefined && data.errorAction) {
            this.warn(`switching to level ${levelIndex} after ${data.details}`);
            this.hls.nextAutoLevel = levelIndex;
            data.errorAction.resolved = true;
            // Stream controller is responsible for this but won't switch on false start
            this.hls.nextLoadLevel = this.hls.nextAutoLevel;
            if (data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR && data.mimeType && data.sourceBufferName !== 'audiovideo') {
                const codec = $99a156a15cd35eb3$var$getCodecsForMimeType(data.mimeType);
                const levels = this.hls.levels;
                for(let i = levels.length; i--;)if (levels[i][`${data.sourceBufferName}Codec`] === codec) this.hls.removeLevel(i);
            }
        }
    }
}
function $99a156a15cd35eb3$var$createDoNothingErrorAction(resolved) {
    const errorAction = {
        action: $99a156a15cd35eb3$export$679390c50dd617e4.DoNothing,
        flags: $99a156a15cd35eb3$export$f377ad9144b2d7af.None
    };
    if (resolved) errorAction.resolved = true;
    return errorAction;
}
var $99a156a15cd35eb3$var$FragmentState = {
    NOT_LOADED: "NOT_LOADED",
    APPENDING: "APPENDING",
    PARTIAL: "PARTIAL",
    OK: "OK"
};
class $99a156a15cd35eb3$var$FragmentTracker {
    constructor(hls){
        this.activePartLists = Object.create(null);
        this.endListFragments = Object.create(null);
        this.fragments = Object.create(null);
        this.timeRanges = Object.create(null);
        this.bufferPadding = 0.2;
        this.hls = void 0;
        this.hasGaps = false;
        this.hls = hls;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
    }
    destroy() {
        this._unregisterListeners();
        // @ts-ignore
        this.fragments = // @ts-ignore
        this.activePartLists = // @ts-ignore
        this.endListFragments = this.timeRanges = null;
    }
    /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */ getAppendedFrag(position, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (activeParts) for(let i = activeParts.length; i--;){
            const activePart = activeParts[i];
            if (!activePart) break;
            const appendedPTS = activePart.end;
            if (activePart.start <= position && appendedPTS !== null && position <= appendedPTS) return activePart;
        }
        return this.getBufferedFrag(position, levelType);
    }
    /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */ getBufferedFrag(position, levelType) {
        return this.getFragAtPos(position, levelType, true);
    }
    getFragAtPos(position, levelType, buffered) {
        const { fragments: fragments } = this;
        const keys = Object.keys(fragments);
        for(let i = keys.length; i--;){
            const fragmentEntity = fragments[keys[i]];
            if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && (!buffered || fragmentEntity.buffered)) {
                const frag = fragmentEntity.body;
                if (frag.start <= position && position <= frag.end) return frag;
            }
        }
        return null;
    }
    /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */ detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart, removeAppending) {
        if (this.timeRanges) this.timeRanges[elementaryStream] = timeRange;
        // Check if any flagged fragments have been unloaded
        // excluding anything newer than appendedPartSn
        const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            if (appendedPartSn >= fragmentEntity.body.sn) return;
            if (!fragmentEntity.buffered && (!fragmentEntity.loaded || removeAppending)) {
                if (fragmentEntity.body.type === playlistType) this.removeFragment(fragmentEntity.body);
                return;
            }
            const esData = fragmentEntity.range[elementaryStream];
            if (!esData) return;
            if (esData.time.length === 0) {
                this.removeFragment(fragmentEntity.body);
                return;
            }
            esData.time.some((time1)=>{
                const isNotBuffered = !this.isTimeBuffered(time1.startPTS, time1.endPTS, timeRange);
                if (isNotBuffered) // Unregister partial fragment as it needs to load again to be reused
                this.removeFragment(fragmentEntity.body);
                return isNotBuffered;
            });
        });
    }
    /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */ detectPartialFragments(data) {
        const timeRanges = this.timeRanges;
        if (!timeRanges || data.frag.sn === 'initSegment') return;
        const frag = data.frag;
        const fragKey = $99a156a15cd35eb3$var$getFragmentKey(frag);
        const fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity || fragmentEntity.buffered && frag.gap) return;
        const isFragHint = !frag.relurl;
        Object.keys(timeRanges).forEach((elementaryStream)=>{
            const streamInfo = frag.elementaryStreams[elementaryStream];
            if (!streamInfo) return;
            const timeRange = timeRanges[elementaryStream];
            const partial = isFragHint || streamInfo.partial === true;
            fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, data.part, partial, timeRange);
        });
        fragmentEntity.loaded = null;
        if (Object.keys(fragmentEntity.range).length) {
            fragmentEntity.buffered = true;
            const endList = fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList;
            if (endList) this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
            if (!$99a156a15cd35eb3$var$isPartial(fragmentEntity)) // Remove older fragment parts from lookup after frag is tracked as buffered
            this.removeParts(frag.sn - 1, frag.type);
        } else // remove fragment if nothing was appended
        this.removeFragment(fragmentEntity.body);
    }
    removeParts(snToKeep, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (!activeParts) return;
        this.activePartLists[levelType] = $99a156a15cd35eb3$var$filterParts(activeParts, (part)=>part.fragment.sn >= snToKeep);
    }
    fragBuffered(frag, force) {
        const fragKey = $99a156a15cd35eb3$var$getFragmentKey(frag);
        let fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity && force) {
            fragmentEntity = this.fragments[fragKey] = {
                body: frag,
                appendedPTS: null,
                loaded: null,
                buffered: false,
                range: Object.create(null)
            };
            if (frag.gap) this.hasGaps = true;
        }
        if (fragmentEntity) {
            fragmentEntity.loaded = null;
            fragmentEntity.buffered = true;
        }
    }
    getBufferedTimes(fragment, part, partial, timeRange) {
        const buffered = {
            time: [],
            partial: partial
        };
        const startPTS = fragment.start;
        const endPTS = fragment.end;
        const minEndPTS = fragment.minEndPTS || endPTS;
        const maxStartPTS = fragment.maxStartPTS || startPTS;
        for(let i = 0; i < timeRange.length; i++){
            const startTime = timeRange.start(i) - this.bufferPadding;
            const endTime = timeRange.end(i) + this.bufferPadding;
            if (maxStartPTS >= startTime && minEndPTS <= endTime) {
                // Fragment is entirely contained in buffer
                // No need to check the other timeRange times since it's completely playable
                buffered.time.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                break;
            } else if (startPTS < endTime && endPTS > startTime) {
                const start = Math.max(startPTS, timeRange.start(i));
                const end = Math.min(endPTS, timeRange.end(i));
                if (end > start) {
                    buffered.partial = true;
                    // Check for intersection with buffer
                    // Get playable sections of the fragment
                    buffered.time.push({
                        startPTS: start,
                        endPTS: end
                    });
                }
            } else if (endPTS <= startTime) break;
        }
        return buffered;
    }
    /**
   * Gets the partial fragment for a certain time
   */ getPartialFragment(time1) {
        let bestFragment = null;
        let timePadding;
        let startTime;
        let endTime;
        let bestOverlap = 0;
        const { bufferPadding: bufferPadding, fragments: fragments } = this;
        Object.keys(fragments).forEach((key)=>{
            const fragmentEntity = fragments[key];
            if (!fragmentEntity) return;
            if ($99a156a15cd35eb3$var$isPartial(fragmentEntity)) {
                startTime = fragmentEntity.body.start - bufferPadding;
                endTime = fragmentEntity.body.end + bufferPadding;
                if (time1 >= startTime && time1 <= endTime) {
                    // Use the fragment that has the most padding from start and end time
                    timePadding = Math.min(time1 - startTime, endTime - time1);
                    if (bestOverlap <= timePadding) {
                        bestFragment = fragmentEntity.body;
                        bestOverlap = timePadding;
                    }
                }
            }
        });
        return bestFragment;
    }
    isEndListAppended(type) {
        const lastFragmentEntity = this.endListFragments[type];
        return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || $99a156a15cd35eb3$var$isPartial(lastFragmentEntity));
    }
    getState(fragment) {
        const fragKey = $99a156a15cd35eb3$var$getFragmentKey(fragment);
        const fragmentEntity = this.fragments[fragKey];
        if (fragmentEntity) {
            if (!fragmentEntity.buffered) return $99a156a15cd35eb3$var$FragmentState.APPENDING;
            else if ($99a156a15cd35eb3$var$isPartial(fragmentEntity)) return $99a156a15cd35eb3$var$FragmentState.PARTIAL;
            else return $99a156a15cd35eb3$var$FragmentState.OK;
        }
        return $99a156a15cd35eb3$var$FragmentState.NOT_LOADED;
    }
    isTimeBuffered(startPTS, endPTS, timeRange) {
        let startTime;
        let endTime;
        for(let i = 0; i < timeRange.length; i++){
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) return true;
            if (endPTS <= startTime) // No need to check the rest of the timeRange as it is in order
            return false;
        }
        return false;
    }
    onManifestLoading() {
        this.removeAllFragments();
    }
    onFragLoaded(event, data) {
        // don't track initsegment (for which sn is not a number)
        // don't track frags used for bitrateTest, they're irrelevant.
        if (data.frag.sn === 'initSegment' || data.frag.bitrateTest) return;
        const frag = data.frag;
        // Fragment entity `loaded` FragLoadedData is null when loading parts
        const loaded = data.part ? null : data;
        const fragKey = $99a156a15cd35eb3$var$getFragmentKey(frag);
        this.fragments[fragKey] = {
            body: frag,
            appendedPTS: null,
            loaded: loaded,
            buffered: false,
            range: Object.create(null)
        };
    }
    onBufferAppended(event, data) {
        const { frag: frag, part: part, timeRanges: timeRanges, type: type } = data;
        if (frag.sn === 'initSegment') return;
        const playlistType = frag.type;
        if (part) {
            let activeParts = this.activePartLists[playlistType];
            if (!activeParts) this.activePartLists[playlistType] = activeParts = [];
            activeParts.push(part);
        }
        // Store the latest timeRanges loaded in the buffer
        this.timeRanges = timeRanges;
        const timeRange = timeRanges[type];
        this.detectEvictedFragments(type, timeRange, playlistType, part);
    }
    onFragBuffered(event, data) {
        this.detectPartialFragments(data);
    }
    hasFragment(fragment) {
        const fragKey = $99a156a15cd35eb3$var$getFragmentKey(fragment);
        return !!this.fragments[fragKey];
    }
    hasFragments(type) {
        const { fragments: fragments } = this;
        const keys = Object.keys(fragments);
        if (!type) return keys.length > 0;
        for(let i = keys.length; i--;){
            const fragmentEntity = fragments[keys[i]];
            if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === type) return true;
        }
        return false;
    }
    hasParts(type) {
        var _this$activePartLists;
        return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
    }
    removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
        if (withGapOnly && !this.hasGaps) return;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            const frag = fragmentEntity.body;
            if (frag.type !== playlistType || withGapOnly && !frag.gap) return;
            if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) this.removeFragment(frag);
        });
    }
    removeFragment(fragment) {
        const fragKey = $99a156a15cd35eb3$var$getFragmentKey(fragment);
        fragment.clearElementaryStreamInfo();
        const activeParts = this.activePartLists[fragment.type];
        if (activeParts) {
            const snToRemove = fragment.sn;
            this.activePartLists[fragment.type] = $99a156a15cd35eb3$var$filterParts(activeParts, (part)=>part.fragment.sn !== snToRemove);
        }
        delete this.fragments[fragKey];
        if (fragment.endList) delete this.endListFragments[fragment.type];
    }
    removeAllFragments() {
        var _this$hls, _this$hls$latestLevel;
        this.fragments = Object.create(null);
        this.endListFragments = Object.create(null);
        this.activePartLists = Object.create(null);
        this.hasGaps = false;
        const partlist = (_this$hls = this.hls) == null ? void 0 : (_this$hls$latestLevel = _this$hls.latestLevelDetails) == null ? void 0 : _this$hls$latestLevel.partList;
        if (partlist) partlist.forEach((part)=>part.clearElementaryStreamInfo());
    }
}
function $99a156a15cd35eb3$var$isPartial(fragmentEntity) {
    var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
    return fragmentEntity.buffered && (fragmentEntity.body.gap || ((_fragmentEntity$range = fragmentEntity.range.video) == null ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) == null ? void 0 : _fragmentEntity$range2.partial) || ((_fragmentEntity$range3 = fragmentEntity.range.audiovideo) == null ? void 0 : _fragmentEntity$range3.partial));
}
function $99a156a15cd35eb3$var$getFragmentKey(fragment) {
    return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}
function $99a156a15cd35eb3$var$filterParts(partList, predicate) {
    return partList.filter((part)=>{
        const keep = predicate(part);
        if (!keep) part.clearElementaryStreamInfo();
        return keep;
    });
}
var $99a156a15cd35eb3$var$DecrypterAesMode = {
    cbc: 0,
    ctr: 1
};
class $99a156a15cd35eb3$var$AESCrypto {
    constructor(subtle, iv, aesMode){
        this.subtle = void 0;
        this.aesIV = void 0;
        this.aesMode = void 0;
        this.subtle = subtle;
        this.aesIV = iv;
        this.aesMode = aesMode;
    }
    decrypt(data, key) {
        switch(this.aesMode){
            case $99a156a15cd35eb3$var$DecrypterAesMode.cbc:
                return this.subtle.decrypt({
                    name: 'AES-CBC',
                    iv: this.aesIV
                }, key, data);
            case $99a156a15cd35eb3$var$DecrypterAesMode.ctr:
                return this.subtle.decrypt({
                    name: 'AES-CTR',
                    counter: this.aesIV,
                    length: 64
                }, //64 : NIST SP800-38A standard suggests that the counter should occupy half of the counter block
                key, data);
            default:
                throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
        }
    }
}
// PKCS7
function $99a156a15cd35eb3$var$removePadding(array) {
    const outputBytes = array.byteLength;
    const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
    if (paddingBytes) return array.slice(0, outputBytes - paddingBytes);
    return array;
}
class $99a156a15cd35eb3$var$AESDecryptor {
    constructor(){
        this.rcon = [
            0x0,
            0x1,
            0x2,
            0x4,
            0x8,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        this.subMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.invSubMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.sBox = new Uint32Array(256);
        this.invSBox = new Uint32Array(256);
        this.key = new Uint32Array(0);
        this.ksRows = 0;
        this.keySize = 0;
        this.keySchedule = void 0;
        this.invKeySchedule = void 0;
        this.initTable();
    }
    // Using view.getUint32() also swaps the byte order.
    uint8ArrayToUint32Array_(arrayBuffer) {
        const view = new DataView(arrayBuffer);
        const newArray = new Uint32Array(4);
        for(let i = 0; i < 4; i++)newArray[i] = view.getUint32(i * 4);
        return newArray;
    }
    initTable() {
        const sBox = this.sBox;
        const invSBox = this.invSBox;
        const subMix = this.subMix;
        const subMix0 = subMix[0];
        const subMix1 = subMix[1];
        const subMix2 = subMix[2];
        const subMix3 = subMix[3];
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const d = new Uint32Array(256);
        let x = 0;
        let xi = 0;
        let i = 0;
        for(i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
        else d[i] = i << 1 ^ 0x11b;
        for(i = 0; i < 256; i++){
            let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            sBox[x] = sx;
            invSBox[sx] = x;
            // Compute multiplication
            const x2 = d[x];
            const x4 = d[x2];
            const x8 = d[x4];
            // Compute sub/invSub bytes, mix columns tables
            let t = d[sx] * 0x101 ^ sx * 0x1010100;
            subMix0[x] = t << 24 | t >>> 8;
            subMix1[x] = t << 16 | t >>> 16;
            subMix2[x] = t << 8 | t >>> 24;
            subMix3[x] = t;
            // Compute inv sub bytes, inv mix columns tables
            t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            invSubMix0[sx] = t << 24 | t >>> 8;
            invSubMix1[sx] = t << 16 | t >>> 16;
            invSubMix2[sx] = t << 8 | t >>> 24;
            invSubMix3[sx] = t;
            // Compute next counter
            if (!x) x = xi = 1;
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    }
    expandKey(keyBuffer) {
        // convert keyBuffer to Uint32Array
        const key = this.uint8ArrayToUint32Array_(keyBuffer);
        let sameKey = true;
        let offset = 0;
        while(offset < key.length && sameKey){
            sameKey = key[offset] === this.key[offset];
            offset++;
        }
        if (sameKey) return;
        this.key = key;
        const keySize = this.keySize = key.length;
        if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error('Invalid aes key size=' + keySize);
        const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
        let ksRow;
        let invKsRow;
        const keySchedule = this.keySchedule = new Uint32Array(ksRows);
        const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
        const sbox = this.sBox;
        const rcon = this.rcon;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        let prev;
        let t;
        for(ksRow = 0; ksRow < ksRows; ksRow++){
            if (ksRow < keySize) {
                prev = keySchedule[ksRow] = key[ksRow];
                continue;
            }
            t = prev;
            if (ksRow % keySize === 0) {
                // Rot word
                t = t << 8 | t >>> 24;
                // Sub word
                t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
                // Mix Rcon
                t ^= rcon[ksRow / keySize | 0] << 24;
            } else if (keySize > 6 && ksRow % keySize === 4) // Sub word
            t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
            keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
        }
        for(invKsRow = 0; invKsRow < ksRows; invKsRow++){
            ksRow = ksRows - invKsRow;
            if (invKsRow & 3) t = keySchedule[ksRow];
            else t = keySchedule[ksRow - 4];
            if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
            else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
            invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
        }
    }
    // Adding this as a method greatly improves performance.
    networkToHostOrderSwap(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    }
    decrypt(inputArrayBuffer, offset, aesIV) {
        const nRounds = this.keySize + 6;
        const invKeySchedule = this.invKeySchedule;
        const invSBOX = this.invSBox;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const initVector = this.uint8ArrayToUint32Array_(aesIV);
        let initVector0 = initVector[0];
        let initVector1 = initVector[1];
        let initVector2 = initVector[2];
        let initVector3 = initVector[3];
        const inputInt32 = new Int32Array(inputArrayBuffer);
        const outputInt32 = new Int32Array(inputInt32.length);
        let t0, t1, t2, t3;
        let s0, s1, s2, s3;
        let inputWords0, inputWords1, inputWords2, inputWords3;
        let ksRow, i;
        const swapWord = this.networkToHostOrderSwap;
        while(offset < inputInt32.length){
            inputWords0 = swapWord(inputInt32[offset]);
            inputWords1 = swapWord(inputInt32[offset + 1]);
            inputWords2 = swapWord(inputInt32[offset + 2]);
            inputWords3 = swapWord(inputInt32[offset + 3]);
            s0 = inputWords0 ^ invKeySchedule[0];
            s1 = inputWords3 ^ invKeySchedule[1];
            s2 = inputWords2 ^ invKeySchedule[2];
            s3 = inputWords1 ^ invKeySchedule[3];
            ksRow = 4;
            // Iterate through the rounds of decryption
            for(i = 1; i < nRounds; i++){
                t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
                ksRow = ksRow + 4;
            }
            // Shift rows, sub bytes, add round key
            t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
            t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
            t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
            t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
            // Write
            outputInt32[offset] = swapWord(t0 ^ initVector0);
            outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
            outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
            outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
            // reset initVector to last 4 unsigned int
            initVector0 = inputWords0;
            initVector1 = inputWords1;
            initVector2 = inputWords2;
            initVector3 = inputWords3;
            offset = offset + 4;
        }
        return outputInt32.buffer;
    }
}
class $99a156a15cd35eb3$var$FastAESKey {
    constructor(subtle, key, aesMode){
        this.subtle = void 0;
        this.key = void 0;
        this.aesMode = void 0;
        this.subtle = subtle;
        this.key = key;
        this.aesMode = aesMode;
    }
    expandKey() {
        const subtleAlgoName = $99a156a15cd35eb3$var$getSubtleAlgoName(this.aesMode);
        return this.subtle.importKey('raw', this.key, {
            name: subtleAlgoName
        }, false, [
            'encrypt',
            'decrypt'
        ]);
    }
}
function $99a156a15cd35eb3$var$getSubtleAlgoName(aesMode) {
    switch(aesMode){
        case $99a156a15cd35eb3$var$DecrypterAesMode.cbc:
            return 'AES-CBC';
        case $99a156a15cd35eb3$var$DecrypterAesMode.ctr:
            return 'AES-CTR';
        default:
            throw new Error(`[FastAESKey] invalid aes mode ${aesMode}`);
    }
}
const $99a156a15cd35eb3$var$CHUNK_SIZE = 16; // 16 bytes, 128 bits
class $99a156a15cd35eb3$var$Decrypter {
    constructor(config, { removePKCS7Padding: removePKCS7Padding = true } = {}){
        this.logEnabled = true;
        this.removePKCS7Padding = void 0;
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
        this.useSoftware = void 0;
        this.enableSoftwareAES = void 0;
        this.enableSoftwareAES = config.enableSoftwareAES;
        this.removePKCS7Padding = removePKCS7Padding;
        // built in decryptor expects PKCS7 padding
        if (removePKCS7Padding) try {
            const browserCrypto = self.crypto;
            if (browserCrypto) this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        } catch (e) {
        /* no-op */ }
        this.useSoftware = !this.subtle;
    }
    destroy() {
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
    }
    isSync() {
        return this.useSoftware;
    }
    flush() {
        const { currentResult: currentResult, remainderData: remainderData } = this;
        if (!currentResult || remainderData) {
            this.reset();
            return null;
        }
        const data = new Uint8Array(currentResult);
        this.reset();
        if (this.removePKCS7Padding) return $99a156a15cd35eb3$var$removePadding(data);
        return data;
    }
    reset() {
        this.currentResult = null;
        this.currentIV = null;
        this.remainderData = null;
        if (this.softwareDecrypter) this.softwareDecrypter = null;
    }
    decrypt(data, key, iv, aesMode) {
        if (this.useSoftware) return new Promise((resolve, reject)=>{
            const dataView = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
            this.softwareDecrypt(dataView, key, iv, aesMode);
            const decryptResult = this.flush();
            if (decryptResult) resolve(decryptResult.buffer);
            else reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        });
        return this.webCryptoDecrypt(new Uint8Array(data), key, iv, aesMode);
    }
    // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
    // data is handled in the flush() call
    softwareDecrypt(data, key, iv, aesMode) {
        const { currentIV: currentIV, currentResult: currentResult, remainderData: remainderData } = this;
        if (aesMode !== $99a156a15cd35eb3$var$DecrypterAesMode.cbc || key.byteLength !== 16) {
            $99a156a15cd35eb3$var$logger.warn('SoftwareDecrypt: can only handle AES-128-CBC');
            return null;
        }
        this.logOnce('JS AES decrypt');
        // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
        // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
        // the end on flush(), but by that time we have already received all bytes for the segment.
        // Progressive decryption does not work with WebCrypto
        if (remainderData) {
            data = $99a156a15cd35eb3$var$appendUint8Array(remainderData, data);
            this.remainderData = null;
        }
        // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
        const currentChunk = this.getValidChunk(data);
        if (!currentChunk.length) return null;
        if (currentIV) iv = currentIV;
        let softwareDecrypter = this.softwareDecrypter;
        if (!softwareDecrypter) softwareDecrypter = this.softwareDecrypter = new $99a156a15cd35eb3$var$AESDecryptor();
        softwareDecrypter.expandKey(key);
        const result = currentResult;
        this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
        this.currentIV = currentChunk.slice(-16).buffer;
        if (!result) return null;
        return result;
    }
    webCryptoDecrypt(data, key, iv, aesMode) {
        if (this.key !== key || !this.fastAesKey) {
            if (!this.subtle) return Promise.resolve(this.onWebCryptoError(data, key, iv, aesMode));
            this.key = key;
            this.fastAesKey = new $99a156a15cd35eb3$var$FastAESKey(this.subtle, key, aesMode);
        }
        return this.fastAesKey.expandKey().then((aesKey)=>{
            // decrypt using web crypto
            if (!this.subtle) return Promise.reject(new Error('web crypto not initialized'));
            this.logOnce('WebCrypto AES decrypt');
            const crypto1 = new $99a156a15cd35eb3$var$AESCrypto(this.subtle, new Uint8Array(iv), aesMode);
            return crypto1.decrypt(data.buffer, aesKey);
        }).catch((err)=>{
            $99a156a15cd35eb3$var$logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
            return this.onWebCryptoError(data, key, iv, aesMode);
        });
    }
    onWebCryptoError(data, key, iv, aesMode) {
        const enableSoftwareAES = this.enableSoftwareAES;
        if (enableSoftwareAES) {
            this.useSoftware = true;
            this.logEnabled = true;
            this.softwareDecrypt(data, key, iv, aesMode);
            const decryptResult = this.flush();
            if (decryptResult) return decryptResult.buffer;
        }
        throw new Error('WebCrypto' + (enableSoftwareAES ? ' and softwareDecrypt' : '') + ': failed to decrypt data');
    }
    getValidChunk(data) {
        let currentChunk = data;
        const splitPoint = data.length - data.length % $99a156a15cd35eb3$var$CHUNK_SIZE;
        if (splitPoint !== data.length) {
            currentChunk = data.slice(0, splitPoint);
            this.remainderData = data.slice(splitPoint);
        }
        return currentChunk;
    }
    logOnce(msg) {
        if (!this.logEnabled) return;
        $99a156a15cd35eb3$var$logger.log(`[decrypter]: ${msg}`);
        this.logEnabled = false;
    }
}
const $99a156a15cd35eb3$var$MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb
class $99a156a15cd35eb3$var$FragmentLoader {
    constructor(config){
        this.config = void 0;
        this.loader = null;
        this.partLoadTimeout = -1;
        this.config = config;
    }
    destroy() {
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
    }
    abort() {
        if (this.loader) // Abort the loader for current fragment. Only one may load at any given time
        this.loader.abort();
    }
    load(frag, onProgress) {
        const url = frag.url;
        if (!url) return Promise.reject(new $99a156a15cd35eb3$var$LoadError({
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_ERROR,
            fatal: false,
            frag: frag,
            error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
            networkDetails: null
        }));
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap) {
                if (frag.tagList.some((tags)=>tags[0] === 'GAP')) {
                    reject($99a156a15cd35eb3$var$createGapLoadError(frag));
                    return;
                } else // Reset temporary treatment as GAP tag
                frag.gap = false;
            }
            const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = $99a156a15cd35eb3$var$createLoaderContext(frag);
            frag.loader = loader;
            const loadPolicy = $99a156a15cd35eb3$var$getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: frag.sn === 'initSegment' ? Infinity : $99a156a15cd35eb3$var$MIN_CHUNK_SIZE
            };
            // Assign frag stats to the loader's stats reference
            frag.stats = loader.stats;
            const callbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    let payload = response.data;
                    if (context.resetIV && frag.decryptdata) {
                        frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
                        payload = payload.slice(16);
                    }
                    resolve({
                        frag: frag,
                        part: null,
                        payload: payload,
                        networkDetails: networkDetails
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new $99a156a15cd35eb3$var$LoadError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag: frag,
                        response: $99a156a15cd35eb3$var$_objectSpread2({
                            url: url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $99a156a15cd35eb3$var$LoadError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_ABORTED,
                        fatal: false,
                        frag: frag,
                        error: new Error('Aborted'),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $99a156a15cd35eb3$var$LoadError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag: frag,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                }
            };
            if (onProgress) callbacks.onProgress = (stats, context, data, networkDetails)=>onProgress({
                    frag: frag,
                    part: null,
                    payload: data,
                    networkDetails: networkDetails
                });
            loader.load(loaderContext, loaderConfig, callbacks);
        });
    }
    loadPart(frag, part, onProgress) {
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap || part.gap) {
                reject($99a156a15cd35eb3$var$createGapLoadError(frag, part));
                return;
            }
            const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = $99a156a15cd35eb3$var$createLoaderContext(frag, part);
            frag.loader = loader;
            // Should we define another load policy for parts?
            const loadPolicy = $99a156a15cd35eb3$var$getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: $99a156a15cd35eb3$var$MIN_CHUNK_SIZE
            };
            // Assign part stats to the loader's stats reference
            part.stats = loader.stats;
            loader.load(loaderContext, loaderConfig, {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    this.updateStatsFromPart(frag, part);
                    const partLoadedData = {
                        frag: frag,
                        part: part,
                        payload: response.data,
                        networkDetails: networkDetails
                    };
                    onProgress(partLoadedData);
                    resolve(partLoadedData);
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new $99a156a15cd35eb3$var$LoadError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag: frag,
                        part: part,
                        response: $99a156a15cd35eb3$var$_objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    frag.stats.aborted = part.stats.aborted;
                    this.resetLoader(frag, loader);
                    reject(new $99a156a15cd35eb3$var$LoadError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_ABORTED,
                        fatal: false,
                        frag: frag,
                        part: part,
                        error: new Error('Aborted'),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $99a156a15cd35eb3$var$LoadError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag: frag,
                        part: part,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                }
            });
        });
    }
    updateStatsFromPart(frag, part) {
        const fragStats = frag.stats;
        const partStats = part.stats;
        const partTotal = partStats.total;
        fragStats.loaded += partStats.loaded;
        if (partTotal) {
            const estTotalParts = Math.round(frag.duration / part.duration);
            const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
            const estRemainingParts = estTotalParts - estLoadedParts;
            const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
            fragStats.total = fragStats.loaded + estRemainingBytes;
        } else fragStats.total = Math.max(fragStats.loaded, fragStats.total);
        const fragLoading = fragStats.loading;
        const partLoading = partStats.loading;
        if (fragLoading.start) // add to fragment loader latency
        fragLoading.first += partLoading.first - partLoading.start;
        else {
            fragLoading.start = partLoading.start;
            fragLoading.first = partLoading.first;
        }
        fragLoading.end = partLoading.end;
    }
    resetLoader(frag, loader) {
        frag.loader = null;
        if (this.loader === loader) {
            self.clearTimeout(this.partLoadTimeout);
            this.loader = null;
        }
        loader.destroy();
    }
}
function $99a156a15cd35eb3$var$createLoaderContext(frag, part = null) {
    const segment = part || frag;
    const loaderContext = {
        frag: frag,
        part: part,
        responseType: 'arraybuffer',
        url: segment.url,
        headers: {},
        rangeStart: 0,
        rangeEnd: 0
    };
    const start = segment.byteRangeStartOffset;
    const end = segment.byteRangeEndOffset;
    if ($99a156a15cd35eb3$var$isFiniteNumber(start) && $99a156a15cd35eb3$var$isFiniteNumber(end)) {
        var _frag$decryptdata;
        let byteRangeStart = start;
        let byteRangeEnd = end;
        if (frag.sn === 'initSegment' && $99a156a15cd35eb3$var$isMethodFullSegmentAesCbc((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method)) {
            // MAP segment encrypted with method 'AES-128' or 'AES-256' (cbc), when served with HTTP Range,
            // has the unencrypted size specified in the range.
            // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
            const fragmentLen = end - start;
            if (fragmentLen % 16) byteRangeEnd = end + (16 - fragmentLen % 16);
            if (start !== 0) {
                loaderContext.resetIV = true;
                byteRangeStart = start - 16;
            }
        }
        loaderContext.rangeStart = byteRangeStart;
        loaderContext.rangeEnd = byteRangeEnd;
    }
    return loaderContext;
}
function $99a156a15cd35eb3$var$createGapLoadError(frag, part) {
    const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
    const errorData = {
        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP,
        fatal: false,
        frag: frag,
        error: error,
        networkDetails: null
    };
    if (part) errorData.part = part;
    (part ? part : frag).stats.aborted = true;
    return new $99a156a15cd35eb3$var$LoadError(errorData);
}
function $99a156a15cd35eb3$var$isMethodFullSegmentAesCbc(method) {
    return method === 'AES-128' || method === 'AES-256';
}
class $99a156a15cd35eb3$var$LoadError extends Error {
    constructor(data){
        super(data.error.message);
        this.data = void 0;
        this.data = data;
    }
}
/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */ class $99a156a15cd35eb3$var$TaskLoop extends $99a156a15cd35eb3$var$Logger {
    constructor(label, logger){
        super(label, logger);
        this._boundTick = void 0;
        this._tickTimer = null;
        this._tickInterval = null;
        this._tickCallCount = 0;
        this._boundTick = this.tick.bind(this);
    }
    destroy() {
        this.onHandlerDestroying();
        this.onHandlerDestroyed();
    }
    onHandlerDestroying() {
        // clear all timers before unregistering from event bus
        this.clearNextTick();
        this.clearInterval();
    }
    onHandlerDestroyed() {}
    hasInterval() {
        return !!this._tickInterval;
    }
    hasNextTick() {
        return !!this._tickTimer;
    }
    /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */ setInterval(millis) {
        if (!this._tickInterval) {
            this._tickCallCount = 0;
            this._tickInterval = self.setInterval(this._boundTick, millis);
            return true;
        }
        return false;
    }
    /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */ clearInterval() {
        if (this._tickInterval) {
            self.clearInterval(this._tickInterval);
            this._tickInterval = null;
            return true;
        }
        return false;
    }
    /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */ clearNextTick() {
        if (this._tickTimer) {
            self.clearTimeout(this._tickTimer);
            this._tickTimer = null;
            return true;
        }
        return false;
    }
    /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */ tick() {
        this._tickCallCount++;
        if (this._tickCallCount === 1) {
            this.doTick();
            // re-entrant call to tick from previous doTick call stack
            // -> schedule a call on the next main loop iteration to process this task processing request
            if (this._tickCallCount > 1) // make sure only one timer exists at any time at max
            this.tickImmediate();
            this._tickCallCount = 0;
        }
    }
    tickImmediate() {
        this.clearNextTick();
        this._tickTimer = self.setTimeout(this._boundTick, 0);
    }
    /**
   * For subclass to implement task logic
   * @abstract
   */ doTick() {}
}
class $99a156a15cd35eb3$export$ce0708ece532c9c {
    constructor(level, sn, id, size = 0, part = -1, partial = false){
        this.level = void 0;
        this.sn = void 0;
        this.part = void 0;
        this.id = void 0;
        this.size = void 0;
        this.partial = void 0;
        this.transmuxing = $99a156a15cd35eb3$var$getNewPerformanceTiming();
        this.buffering = {
            audio: $99a156a15cd35eb3$var$getNewPerformanceTiming(),
            video: $99a156a15cd35eb3$var$getNewPerformanceTiming(),
            audiovideo: $99a156a15cd35eb3$var$getNewPerformanceTiming()
        };
        this.level = level;
        this.sn = sn;
        this.id = id;
        this.size = size;
        this.part = part;
        this.partial = partial;
    }
}
function $99a156a15cd35eb3$var$getNewPerformanceTiming() {
    return {
        start: 0,
        executeStart: 0,
        executeEnd: 0,
        end: 0
    };
}
/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */ const $99a156a15cd35eb3$var$noopBuffered = {
    length: 0,
    start: ()=>0,
    end: ()=>0
};
class $99a156a15cd35eb3$var$BufferHelper {
    /**
   * Return true if `media`'s buffered include `position`
   */ static isBuffered(media, position) {
        if (media) {
            const buffered = $99a156a15cd35eb3$var$BufferHelper.getBuffered(media);
            for(let i = buffered.length; i--;){
                if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
            }
        }
        return false;
    }
    static bufferedRanges(media) {
        if (media) {
            const timeRanges = $99a156a15cd35eb3$var$BufferHelper.getBuffered(media);
            return $99a156a15cd35eb3$var$BufferHelper.timeRangesToArray(timeRanges);
        }
        return [];
    }
    static timeRangesToArray(timeRanges) {
        const buffered = [];
        for(let i = 0; i < timeRanges.length; i++)buffered.push({
            start: timeRanges.start(i),
            end: timeRanges.end(i)
        });
        return buffered;
    }
    static bufferInfo(media, pos, maxHoleDuration) {
        if (media) {
            const buffered = $99a156a15cd35eb3$var$BufferHelper.bufferedRanges(media);
            if (buffered.length) return $99a156a15cd35eb3$var$BufferHelper.bufferedInfo(buffered, pos, maxHoleDuration);
        }
        return {
            len: 0,
            start: pos,
            end: pos,
            bufferedIndex: -1
        };
    }
    static bufferedInfo(buffered, pos, maxHoleDuration) {
        pos = Math.max(0, pos);
        // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
        if (buffered.length > 1) buffered.sort((a, b)=>a.start - b.start || b.end - a.end);
        let bufferedIndex = -1;
        let buffered2 = [];
        if (maxHoleDuration) // there might be some small holes between buffer time range
        // consider that holes smaller than maxHoleDuration are irrelevant and build another
        // buffer time range representations that discards those holes
        for(let i = 0; i < buffered.length; i++){
            if (pos >= buffered[i].start && pos <= buffered[i].end) bufferedIndex = i;
            const buf2len = buffered2.length;
            if (buf2len) {
                const buf2end = buffered2[buf2len - 1].end;
                // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                if (buffered[i].start - buf2end < maxHoleDuration) // merge overlapping time ranges
                // update lastRange.end only if smaller than item.end
                // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                {
                    if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
                } else // big hole
                buffered2.push(buffered[i]);
            } else // first value
            buffered2.push(buffered[i]);
        }
        else buffered2 = buffered;
        let bufferLen = 0;
        let nextStart;
        // bufferStart and bufferEnd are buffer boundaries around current playback position (pos)
        let bufferStart = pos;
        let bufferEnd = pos;
        for(let i = 0; i < buffered2.length; i++){
            const start = buffered2[i].start;
            const end = buffered2[i].end;
            // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
            if (bufferedIndex === -1 && pos >= start && pos <= end) bufferedIndex = i;
            if (pos + maxHoleDuration >= start && pos < end) {
                // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                bufferStart = start;
                bufferEnd = end;
                bufferLen = bufferEnd - pos;
            } else if (pos + maxHoleDuration < start) {
                nextStart = start;
                break;
            }
        }
        return {
            len: bufferLen,
            start: bufferStart || 0,
            end: bufferEnd || 0,
            nextStart: nextStart,
            buffered: buffered,
            bufferedIndex: bufferedIndex
        };
    }
    /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */ static getBuffered(media) {
        try {
            return media.buffered || $99a156a15cd35eb3$var$noopBuffered;
        } catch (e) {
            $99a156a15cd35eb3$var$logger.log('failed to get media.buffered', e);
            return $99a156a15cd35eb3$var$noopBuffered;
        }
    }
}
const $99a156a15cd35eb3$var$VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function $99a156a15cd35eb3$var$hasVariableReferences(str) {
    return $99a156a15cd35eb3$var$VARIABLE_REPLACEMENT_REGEX.test(str);
}
function $99a156a15cd35eb3$var$substituteVariables(parsed, value) {
    if (parsed.variableList !== null || parsed.hasVariableRefs) {
        const variableList = parsed.variableList;
        return value.replace($99a156a15cd35eb3$var$VARIABLE_REPLACEMENT_REGEX, (variableReference)=>{
            const variableName = variableReference.substring(2, variableReference.length - 1);
            const variableValue = variableList == null ? void 0 : variableList[variableName];
            if (variableValue === undefined) {
                parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
                return variableReference;
            }
            return variableValue;
        });
    }
    return value;
}
function $99a156a15cd35eb3$var$addVariableDefinition(parsed, attr, parentUrl) {
    let variableList = parsed.variableList;
    if (!variableList) parsed.variableList = variableList = {};
    let NAME;
    let VALUE;
    if ('QUERYPARAM' in attr) {
        NAME = attr.QUERYPARAM;
        try {
            const searchParams = new self.URL(parentUrl).searchParams;
            if (searchParams.has(NAME)) VALUE = searchParams.get(NAME);
            else throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
        } catch (error) {
            parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
        }
    } else {
        NAME = attr.NAME;
        VALUE = attr.VALUE;
    }
    if (NAME in variableList) parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
    else variableList[NAME] = VALUE || '';
}
function $99a156a15cd35eb3$var$importVariableDefinition(parsed, attr, sourceVariableList) {
    const IMPORT = attr.IMPORT;
    if (sourceVariableList && IMPORT in sourceVariableList) {
        let variableList = parsed.variableList;
        if (!variableList) parsed.variableList = variableList = {};
        variableList[IMPORT] = sourceVariableList[IMPORT];
    } else parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
}
const $99a156a15cd35eb3$var$DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const $99a156a15cd35eb3$var$ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;
// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class $99a156a15cd35eb3$export$3b2a5864ee72b619 {
    constructor(attrs, parsed){
        if (typeof attrs === 'string') attrs = $99a156a15cd35eb3$export$3b2a5864ee72b619.parseAttrList(attrs, parsed);
        $99a156a15cd35eb3$var$_extends(this, attrs);
    }
    get clientAttrs() {
        return Object.keys(this).filter((attr)=>attr.substring(0, 2) === 'X-');
    }
    decimalInteger(attrName) {
        const intValue = parseInt(this[attrName], 10);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    hexadecimalInteger(attrName) {
        if (this[attrName]) {
            let stringValue = (this[attrName] || '0x').slice(2);
            stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
            const value = new Uint8Array(stringValue.length / 2);
            for(let i = 0; i < stringValue.length / 2; i++)value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
            return value;
        }
        return null;
    }
    hexadecimalIntegerAsNumber(attrName) {
        const intValue = parseInt(this[attrName], 16);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    decimalFloatingPoint(attrName) {
        return parseFloat(this[attrName]);
    }
    optionalFloat(attrName, defaultValue) {
        const value = this[attrName];
        return value ? parseFloat(value) : defaultValue;
    }
    enumeratedString(attrName) {
        return this[attrName];
    }
    enumeratedStringList(attrName, dict) {
        const attrValue = this[attrName];
        return (attrValue ? attrValue.split(/[ ,]+/) : []).reduce((result, identifier)=>{
            result[identifier.toLowerCase()] = true;
            return result;
        }, dict);
    }
    bool(attrName) {
        return this[attrName] === 'YES';
    }
    decimalResolution(attrName) {
        const res = $99a156a15cd35eb3$var$DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
        if (res === null) return undefined;
        return {
            width: parseInt(res[1], 10),
            height: parseInt(res[2], 10)
        };
    }
    static parseAttrList(input, parsed) {
        let match;
        const attrs = {};
        const quote = '"';
        $99a156a15cd35eb3$var$ATTR_LIST_REGEX.lastIndex = 0;
        while((match = $99a156a15cd35eb3$var$ATTR_LIST_REGEX.exec(input)) !== null){
            const name = match[1].trim();
            let value = match[2];
            const quotedString = value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1;
            let hexadecimalSequence = false;
            if (quotedString) value = value.slice(1, -1);
            else switch(name){
                case 'IV':
                case 'SCTE35-CMD':
                case 'SCTE35-IN':
                case 'SCTE35-OUT':
                    hexadecimalSequence = true;
            }
            if (parsed && (quotedString || hexadecimalSequence)) value = $99a156a15cd35eb3$var$substituteVariables(parsed, value);
            else if (!hexadecimalSequence && !quotedString) switch(name){
                case 'CLOSED-CAPTIONS':
                    if (value === 'NONE') break;
                // falls through
                case 'ALLOWED-CPC':
                case 'CLASS':
                case 'ASSOC-LANGUAGE':
                case 'AUDIO':
                case 'BYTERANGE':
                case 'CHANNELS':
                case 'CHARACTERISTICS':
                case 'CODECS':
                case 'DATA-ID':
                case 'END-DATE':
                case 'GROUP-ID':
                case 'ID':
                case 'IMPORT':
                case 'INSTREAM-ID':
                case 'KEYFORMAT':
                case 'KEYFORMATVERSIONS':
                case 'LANGUAGE':
                case 'NAME':
                case 'PATHWAY-ID':
                case 'QUERYPARAM':
                case 'RECENTLY-REMOVED-DATERANGES':
                case 'SERVER-URI':
                case 'STABLE-RENDITION-ID':
                case 'STABLE-VARIANT-ID':
                case 'START-DATE':
                case 'SUBTITLES':
                case 'SUPPLEMENTAL-CODECS':
                case 'URI':
                case 'VALUE':
                case 'VIDEO':
                case 'X-ASSET-LIST':
                case 'X-ASSET-URI':
                    // Since we are not checking tag:attribute combination, just warn rather than ignoring attribute
                    $99a156a15cd35eb3$var$logger.warn(`${input}: attribute ${name} is missing quotes`);
            }
            attrs[name] = value;
        }
        return attrs;
    }
}
// Avoid exporting const enum so that these values can be inlined
const $99a156a15cd35eb3$var$CLASS_INTERSTITIAL = 'com.apple.hls.interstitial';
function $99a156a15cd35eb3$var$isDateRangeCueAttribute(attrName) {
    return attrName !== "ID" && attrName !== "CLASS" && attrName !== "CUE" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function $99a156a15cd35eb3$var$isSCTE35Attribute(attrName) {
    return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN" || attrName === "SCTE35-CMD";
}
class $99a156a15cd35eb3$export$829bd850c745b6e {
    constructor(dateRangeAttr, dateRangeWithSameId, tagCount = 0){
        var _dateRangeWithSameId$;
        this.attr = void 0;
        this.tagAnchor = void 0;
        this.tagOrder = void 0;
        this._startDate = void 0;
        this._endDate = void 0;
        this._dateAtEnd = void 0;
        this._cue = void 0;
        this._badValueForSameId = void 0;
        this.tagAnchor = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagAnchor) || null;
        this.tagOrder = (_dateRangeWithSameId$ = dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagOrder) != null ? _dateRangeWithSameId$ : tagCount;
        if (dateRangeWithSameId) {
            const previousAttr = dateRangeWithSameId.attr;
            for(const key in previousAttr)if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
                $99a156a15cd35eb3$var$logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
                this._badValueForSameId = key;
                break;
            }
            // Merge DateRange tags with the same ID
            dateRangeAttr = $99a156a15cd35eb3$var$_extends(new $99a156a15cd35eb3$export$3b2a5864ee72b619({}), previousAttr, dateRangeAttr);
        }
        this.attr = dateRangeAttr;
        if (dateRangeWithSameId) {
            this._startDate = dateRangeWithSameId._startDate;
            this._cue = dateRangeWithSameId._cue;
            this._endDate = dateRangeWithSameId._endDate;
            this._dateAtEnd = dateRangeWithSameId._dateAtEnd;
        } else this._startDate = new Date(dateRangeAttr["START-DATE"]);
        if ("END-DATE" in this.attr) {
            const endDate = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.endDate) || new Date(this.attr["END-DATE"]);
            if ($99a156a15cd35eb3$var$isFiniteNumber(endDate.getTime())) this._endDate = endDate;
        }
    }
    get id() {
        return this.attr.ID;
    }
    get class() {
        return this.attr.CLASS;
    }
    get cue() {
        const _cue = this._cue;
        if (_cue === undefined) return this._cue = this.attr.enumeratedStringList(this.attr.CUE ? 'CUE' : 'X-CUE', {
            pre: false,
            post: false,
            once: false
        });
        return _cue;
    }
    get startTime() {
        const { tagAnchor: tagAnchor } = this;
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (tagAnchor === null || tagAnchor.programDateTime === null) {
            $99a156a15cd35eb3$var$logger.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${tagAnchor}`);
            return NaN;
        }
        return tagAnchor.start + (this.startDate.getTime() - tagAnchor.programDateTime) / 1000;
    }
    get startDate() {
        return this._startDate;
    }
    get endDate() {
        const dateAtEnd = this._endDate || this._dateAtEnd;
        if (dateAtEnd) return dateAtEnd;
        const duration = this.duration;
        if (duration !== null) return this._dateAtEnd = new Date(this._startDate.getTime() + duration * 1000);
        return null;
    }
    get duration() {
        if ("DURATION" in this.attr) {
            const duration = this.attr.decimalFloatingPoint("DURATION");
            if ($99a156a15cd35eb3$var$isFiniteNumber(duration)) return duration;
        } else if (this._endDate) return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
        return null;
    }
    get plannedDuration() {
        if ("PLANNED-DURATION" in this.attr) return this.attr.decimalFloatingPoint("PLANNED-DURATION");
        return null;
    }
    get endOnNext() {
        return this.attr.bool("END-ON-NEXT");
    }
    get isInterstitial() {
        return this.class === $99a156a15cd35eb3$var$CLASS_INTERSTITIAL;
    }
    get isValid() {
        return !!this.id && !this._badValueForSameId && $99a156a15cd35eb3$var$isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || 'X-ASSET-URI' in this.attr || 'X-ASSET-LIST' in this.attr);
    }
}
const $99a156a15cd35eb3$var$DEFAULT_TARGET_DURATION = 10;
/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */ class $99a156a15cd35eb3$export$9eda1d8aef4189e9 {
    constructor(baseUrl){
        this.PTSKnown = false;
        this.alignedSliding = false;
        this.averagetargetduration = void 0;
        this.endCC = 0;
        this.endSN = 0;
        this.fragments = void 0;
        this.fragmentHint = void 0;
        this.partList = null;
        this.dateRanges = void 0;
        this.dateRangeTagCount = 0;
        this.live = true;
        this.requestScheduled = -1;
        this.ageHeader = 0;
        this.advancedDateTime = void 0;
        this.updated = true;
        this.advanced = true;
        this.misses = 0;
        this.startCC = 0;
        this.startSN = 0;
        this.startTimeOffset = null;
        this.targetduration = 0;
        this.totalduration = 0;
        this.type = null;
        this.url = void 0;
        this.m3u8 = '';
        this.version = null;
        this.canBlockReload = false;
        this.canSkipUntil = 0;
        this.canSkipDateRanges = false;
        this.skippedSegments = 0;
        this.recentlyRemovedDateranges = void 0;
        this.partHoldBack = 0;
        this.holdBack = 0;
        this.partTarget = 0;
        this.preloadHint = void 0;
        this.renditionReports = void 0;
        this.tuneInGoal = 0;
        this.deltaUpdateFailed = void 0;
        this.driftStartTime = 0;
        this.driftEndTime = 0;
        this.driftStart = 0;
        this.driftEnd = 0;
        this.encryptedFragments = void 0;
        this.playlistParsingError = null;
        this.variableList = null;
        this.hasVariableRefs = false;
        this.appliedTimelineOffset = void 0;
        this.fragments = [];
        this.encryptedFragments = [];
        this.dateRanges = {};
        this.url = baseUrl;
    }
    reloaded(previous) {
        if (!previous) {
            this.advanced = true;
            this.updated = true;
            return;
        }
        const partSnDiff = this.lastPartSn - previous.lastPartSn;
        const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
        this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
        this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
        if (this.updated || this.advanced) this.misses = Math.floor(previous.misses * 0.6);
        else this.misses = previous.misses + 1;
    }
    get hasProgramDateTime() {
        if (this.fragments.length) return $99a156a15cd35eb3$var$isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
        return false;
    }
    get levelTargetDuration() {
        return this.averagetargetduration || this.targetduration || $99a156a15cd35eb3$var$DEFAULT_TARGET_DURATION;
    }
    get drift() {
        const runTime = this.driftEndTime - this.driftStartTime;
        if (runTime > 0) {
            const runDuration = this.driftEnd - this.driftStart;
            return runDuration * 1000 / runTime;
        }
        return 1;
    }
    get edge() {
        return this.partEnd || this.fragmentEnd;
    }
    get partEnd() {
        var _this$partList;
        if ((_this$partList = this.partList) != null && _this$partList.length) return this.partList[this.partList.length - 1].end;
        return this.fragmentEnd;
    }
    get fragmentEnd() {
        var _this$fragments;
        if ((_this$fragments = this.fragments) != null && _this$fragments.length) return this.fragments[this.fragments.length - 1].end;
        return 0;
    }
    get fragmentStart() {
        var _this$fragments2;
        if ((_this$fragments2 = this.fragments) != null && _this$fragments2.length) return this.fragments[0].start;
        return 0;
    }
    get age() {
        if (this.advancedDateTime) return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
        return 0;
    }
    get lastPartIndex() {
        var _this$partList2;
        if ((_this$partList2 = this.partList) != null && _this$partList2.length) return this.partList[this.partList.length - 1].index;
        return -1;
    }
    get maxPartIndex() {
        const partList = this.partList;
        if (partList) {
            const lastIndex = this.lastPartIndex;
            if (lastIndex !== -1) {
                for(let i = partList.length; i--;){
                    if (partList[i].index > lastIndex) return partList[i].index;
                }
                return lastIndex;
            }
        }
        return 0;
    }
    get lastPartSn() {
        var _this$partList3;
        if ((_this$partList3 = this.partList) != null && _this$partList3.length) return this.partList[this.partList.length - 1].fragment.sn;
        return this.endSN;
    }
    get expired() {
        if (this.live && this.age && this.misses < 3) {
            const playlistWindowDuration = this.partEnd - this.fragmentStart;
            return this.age > Math.max(playlistWindowDuration, this.totalduration) + this.levelTargetDuration;
        }
        return false;
    }
}
function $99a156a15cd35eb3$var$isFullSegmentEncryption(method) {
    return method === 'AES-128' || method === 'AES-256' || method === 'AES-256-CTR';
}
function $99a156a15cd35eb3$var$getAesModeFromFullSegmentMethod(method) {
    switch(method){
        case 'AES-128':
        case 'AES-256':
            return $99a156a15cd35eb3$var$DecrypterAesMode.cbc;
        case 'AES-256-CTR':
            return $99a156a15cd35eb3$var$DecrypterAesMode.ctr;
        default:
            throw new Error(`invalid full segment method ${method}`);
    }
}
function $99a156a15cd35eb3$var$base64Decode(base64encodedStr) {
    return Uint8Array.from(atob(base64encodedStr), (c)=>c.charCodeAt(0));
}
// breaking up those two types in order to clarify what is happening in the decoding path.
// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */ function $99a156a15cd35eb3$var$strToUtf8array(str) {
    return Uint8Array.from(unescape(encodeURIComponent(str)), (c)=>c.charCodeAt(0));
}
function $99a156a15cd35eb3$var$getKeyIdBytes(str) {
    const keyIdbytes = $99a156a15cd35eb3$var$strToUtf8array(str).subarray(0, 16);
    const paddedkeyIdbytes = new Uint8Array(16);
    paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
    return paddedkeyIdbytes;
}
function $99a156a15cd35eb3$var$changeEndianness(keyId) {
    const swap = function swap(array, from, to) {
        const cur = array[from];
        array[from] = array[to];
        array[to] = cur;
    };
    swap(keyId, 0, 3);
    swap(keyId, 1, 2);
    swap(keyId, 4, 5);
    swap(keyId, 6, 7);
}
function $99a156a15cd35eb3$var$convertDataUriToArrayBytes(uri) {
    // data:[<media type][;attribute=value][;base64],<data>
    const colonsplit = uri.split(':');
    let keydata = null;
    if (colonsplit[0] === 'data' && colonsplit.length === 2) {
        const semicolonsplit = colonsplit[1].split(';');
        const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
        if (commasplit.length === 2) {
            const isbase64 = commasplit[0] === 'base64';
            const data = commasplit[1];
            if (isbase64) {
                semicolonsplit.splice(-1, 1); // remove from processing
                keydata = $99a156a15cd35eb3$var$base64Decode(data);
            } else keydata = $99a156a15cd35eb3$var$getKeyIdBytes(data);
        }
    }
    return keydata;
}
/** returns `undefined` is `self` is missing, e.g. in node */ const $99a156a15cd35eb3$var$optionalSelf = typeof self !== 'undefined' ? self : undefined;
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */ var $99a156a15cd35eb3$export$1c7b21e05766136c = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.fps",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "com.widevine.alpha"
};
// Playlist #EXT-X-KEY KEYFORMAT values
var $99a156a15cd35eb3$export$adbe91680a33e4e2 = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.streamingkeydelivery",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function $99a156a15cd35eb3$var$keySystemFormatToKeySystemDomain(format) {
    switch(format){
        case $99a156a15cd35eb3$export$adbe91680a33e4e2.FAIRPLAY:
            return $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY;
        case $99a156a15cd35eb3$export$adbe91680a33e4e2.PLAYREADY:
            return $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY;
        case $99a156a15cd35eb3$export$adbe91680a33e4e2.WIDEVINE:
            return $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE;
        case $99a156a15cd35eb3$export$adbe91680a33e4e2.CLEARKEY:
            return $99a156a15cd35eb3$export$1c7b21e05766136c.CLEARKEY;
    }
}
// System IDs for which we can extract a key ID from "encrypted" event PSSH
var $99a156a15cd35eb3$var$KeySystemIds = {
    CENC: "1077efecc0b24d02ace33c1e52e2fb4b",
    CLEARKEY: "e2719d58a985b3c9781ab030af78d30e",
    PLAYREADY: "9a04f07998404286ab92e65be0885f95",
    WIDEVINE: "edef8ba979d64acea3c827dcd51d21ed"
};
function $99a156a15cd35eb3$var$keySystemIdToKeySystemDomain(systemId) {
    if (systemId === $99a156a15cd35eb3$var$KeySystemIds.WIDEVINE) return $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE;
    else if (systemId === $99a156a15cd35eb3$var$KeySystemIds.PLAYREADY) return $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY;
    else if (systemId === $99a156a15cd35eb3$var$KeySystemIds.CENC || systemId === $99a156a15cd35eb3$var$KeySystemIds.CLEARKEY) return $99a156a15cd35eb3$export$1c7b21e05766136c.CLEARKEY;
}
function $99a156a15cd35eb3$var$keySystemDomainToKeySystemFormat(keySystem) {
    switch(keySystem){
        case $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY:
            return $99a156a15cd35eb3$export$adbe91680a33e4e2.FAIRPLAY;
        case $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY:
            return $99a156a15cd35eb3$export$adbe91680a33e4e2.PLAYREADY;
        case $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE:
            return $99a156a15cd35eb3$export$adbe91680a33e4e2.WIDEVINE;
        case $99a156a15cd35eb3$export$1c7b21e05766136c.CLEARKEY:
            return $99a156a15cd35eb3$export$adbe91680a33e4e2.CLEARKEY;
    }
}
function $99a156a15cd35eb3$var$getKeySystemsForConfig(config) {
    const { drmSystems: drmSystems, widevineLicenseUrl: widevineLicenseUrl } = config;
    const keySystemsToAttempt = drmSystems ? [
        $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY,
        $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE,
        $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY,
        $99a156a15cd35eb3$export$1c7b21e05766136c.CLEARKEY
    ].filter((keySystem)=>!!drmSystems[keySystem]) : [];
    if (!keySystemsToAttempt[$99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE] && widevineLicenseUrl) keySystemsToAttempt.push($99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE);
    return keySystemsToAttempt;
}
const $99a156a15cd35eb3$export$fd6ce47fe824665a = function(_optionalSelf$navigat) {
    if ($99a156a15cd35eb3$var$optionalSelf != null && (_optionalSelf$navigat = $99a156a15cd35eb3$var$optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
    else return null;
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */ function $99a156a15cd35eb3$var$getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
    let initDataTypes;
    switch(keySystem){
        case $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY:
            initDataTypes = [
                'cenc',
                'sinf'
            ];
            break;
        case $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE:
        case $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY:
            initDataTypes = [
                'cenc'
            ];
            break;
        case $99a156a15cd35eb3$export$1c7b21e05766136c.CLEARKEY:
            initDataTypes = [
                'cenc',
                'keyids'
            ];
            break;
        default:
            throw new Error(`Unknown key-system: ${keySystem}`);
    }
    return $99a156a15cd35eb3$var$createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function $99a156a15cd35eb3$var$createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
    const baseConfig = {
        initDataTypes: initDataTypes,
        persistentState: drmSystemOptions.persistentState || 'optional',
        distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'optional',
        sessionTypes: drmSystemOptions.sessionTypes || [
            drmSystemOptions.sessionType || 'temporary'
        ],
        audioCapabilities: audioCodecs.map((codec)=>({
                contentType: `audio/mp4; codecs=${codec}`,
                robustness: drmSystemOptions.audioRobustness || '',
                encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
            })),
        videoCapabilities: videoCodecs.map((codec)=>({
                contentType: `video/mp4; codecs=${codec}`,
                robustness: drmSystemOptions.videoRobustness || '',
                encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
            }))
    };
    return [
        baseConfig
    ];
}
function $99a156a15cd35eb3$var$isPersistentSessionType(drmSystemOptions) {
    var _drmSystemOptions$ses;
    return drmSystemOptions.sessionType === 'persistent-license' || !!((_drmSystemOptions$ses = drmSystemOptions.sessionTypes) != null && _drmSystemOptions$ses.some((type)=>type === 'persistent-license'));
}
function $99a156a15cd35eb3$var$parsePlayReadyWRM(keyBytes) {
    const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
    const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));
    // Parse Playready WRMHeader XML
    const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
    const keyData = xmlDoc.getElementsByTagName('KID')[0];
    if (keyData) {
        const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
        if (keyId) {
            const keyIdArray = $99a156a15cd35eb3$var$base64Decode(keyId).subarray(0, 16);
            // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
            // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
            $99a156a15cd35eb3$var$changeEndianness(keyIdArray);
            return keyIdArray;
        }
    }
    return null;
}
let $99a156a15cd35eb3$var$keyUriToKeyIdMap = {};
class $99a156a15cd35eb3$export$ca24892a09b21f29 {
    static clearKeyUriToKeyIdMap() {
        $99a156a15cd35eb3$var$keyUriToKeyIdMap = {};
    }
    constructor(method, uri, format, formatversions = [
        1
    ], iv = null){
        this.uri = void 0;
        this.method = void 0;
        this.keyFormat = void 0;
        this.keyFormatVersions = void 0;
        this.encrypted = void 0;
        this.isCommonEncryption = void 0;
        this.iv = null;
        this.key = null;
        this.keyId = null;
        this.pssh = null;
        this.method = method;
        this.uri = uri;
        this.keyFormat = format;
        this.keyFormatVersions = formatversions;
        this.iv = iv;
        this.encrypted = method ? method !== 'NONE' : false;
        this.isCommonEncryption = this.encrypted && !$99a156a15cd35eb3$var$isFullSegmentEncryption(method);
    }
    isSupported() {
        // If it's Segment encryption or No encryption, just select that key system
        if (this.method) {
            if ($99a156a15cd35eb3$var$isFullSegmentEncryption(this.method) || this.method === 'NONE') return true;
            if (this.keyFormat === 'identity') // Maintain support for clear SAMPLE-AES with MPEG-3 TS
            return this.method === 'SAMPLE-AES';
            else switch(this.keyFormat){
                case $99a156a15cd35eb3$export$adbe91680a33e4e2.FAIRPLAY:
                case $99a156a15cd35eb3$export$adbe91680a33e4e2.WIDEVINE:
                case $99a156a15cd35eb3$export$adbe91680a33e4e2.PLAYREADY:
                case $99a156a15cd35eb3$export$adbe91680a33e4e2.CLEARKEY:
                    return [
                        'ISO-23001-7',
                        'SAMPLE-AES',
                        'SAMPLE-AES-CENC',
                        'SAMPLE-AES-CTR'
                    ].indexOf(this.method) !== -1;
            }
        }
        return false;
    }
    getDecryptData(sn) {
        if (!this.encrypted || !this.uri) return null;
        if ($99a156a15cd35eb3$var$isFullSegmentEncryption(this.method) && this.uri && !this.iv) {
            if (typeof sn !== 'number') {
                // We are fetching decryption data for a initialization segment
                // If the segment was encrypted with AES-128/256
                // It must have an IV defined. We cannot substitute the Segment Number in.
                $99a156a15cd35eb3$var$logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
                // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
                sn = 0;
            }
            const iv = $99a156a15cd35eb3$var$createInitializationVector(sn);
            const decryptdata = new $99a156a15cd35eb3$export$ca24892a09b21f29(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
            return decryptdata;
        }
        // Initialize keyId if possible
        const keyBytes = $99a156a15cd35eb3$var$convertDataUriToArrayBytes(this.uri);
        if (keyBytes) switch(this.keyFormat){
            case $99a156a15cd35eb3$export$adbe91680a33e4e2.WIDEVINE:
                // Setting `pssh` on this LevelKey/DecryptData allows HLS.js to generate a session using
                // the playlist-key before the "encrypted" event. (Comment out to only use "encrypted" path.)
                this.pssh = keyBytes;
                // In case of widevine keyID is embedded in PSSH box. Read Key ID.
                if (keyBytes.length >= 22) this.keyId = keyBytes.subarray(keyBytes.length - 22, keyBytes.length - 6);
                break;
            case $99a156a15cd35eb3$export$adbe91680a33e4e2.PLAYREADY:
                {
                    const PlayReadyKeySystemUUID = new Uint8Array([
                        0x9a,
                        0x04,
                        0xf0,
                        0x79,
                        0x98,
                        0x40,
                        0x42,
                        0x86,
                        0xab,
                        0x92,
                        0xe6,
                        0x5b,
                        0xe0,
                        0x88,
                        0x5f,
                        0x95
                    ]);
                    // Setting `pssh` on this LevelKey/DecryptData allows HLS.js to generate a session using
                    // the playlist-key before the "encrypted" event. (Comment out to only use "encrypted" path.)
                    this.pssh = $99a156a15cd35eb3$var$mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
                    this.keyId = $99a156a15cd35eb3$var$parsePlayReadyWRM(keyBytes);
                    break;
                }
            default:
                {
                    let keydata = keyBytes.subarray(0, 16);
                    if (keydata.length !== 16) {
                        const padded = new Uint8Array(16);
                        padded.set(keydata, 16 - keydata.length);
                        keydata = padded;
                    }
                    this.keyId = keydata;
                    break;
                }
        }
        // Default behavior: assign a new keyId for each uri
        if (!this.keyId || this.keyId.byteLength !== 16) {
            let keyId = $99a156a15cd35eb3$var$keyUriToKeyIdMap[this.uri];
            if (!keyId) {
                const val = Object.keys($99a156a15cd35eb3$var$keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
                keyId = new Uint8Array(16);
                const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
                dv.setUint32(0, val);
                $99a156a15cd35eb3$var$keyUriToKeyIdMap[this.uri] = keyId;
            }
            this.keyId = keyId;
        }
        return this;
    }
}
function $99a156a15cd35eb3$var$createInitializationVector(segmentNumber) {
    const uint8View = new Uint8Array(16);
    for(let i = 12; i < 16; i++)uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
    return uint8View;
}
const $99a156a15cd35eb3$var$MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const $99a156a15cd35eb3$var$MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const $99a156a15cd35eb3$var$IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)
const $99a156a15cd35eb3$var$LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
    // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
    /(?!#) *(\S[^\r\n]*)/.source,
    // segment URI, group 3 => the URI (note newline is not eaten)
    /#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const $99a156a15cd35eb3$var$LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([
    /#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,
    /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,
    /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source,
    /(#)([^:]*):(.*)/.source,
    /(#)(.*)(?:.*)\r?\n?/.source
].join('|'));
class $99a156a15cd35eb3$export$c1bd440a1b47590d {
    static findGroup(groups, mediaGroupId) {
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            if (group.id === mediaGroupId) return group;
        }
    }
    static resolve(url, baseUrl) {
        return $99a156a15cd35eb3$var$urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
            alwaysNormalize: true
        });
    }
    static isMediaPlaylist(str) {
        return $99a156a15cd35eb3$var$IS_MEDIA_PLAYLIST.test(str);
    }
    static parseMasterPlaylist(string, baseurl) {
        const hasVariableRefs = $99a156a15cd35eb3$var$hasVariableReferences(string);
        const parsed = {
            contentSteering: null,
            levels: [],
            playlistParsingError: null,
            sessionData: null,
            sessionKeys: null,
            startTimeOffset: null,
            variableList: null,
            hasVariableRefs: hasVariableRefs
        };
        const levelsWithKnownCodecs = [];
        $99a156a15cd35eb3$var$MASTER_PLAYLIST_REGEX.lastIndex = 0;
        let result;
        while((result = $99a156a15cd35eb3$var$MASTER_PLAYLIST_REGEX.exec(string)) != null){
            if (result[1]) {
                var _level$unknownCodecs;
                // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
                const attrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(result[1], parsed);
                const uri = $99a156a15cd35eb3$var$substituteVariables(parsed, result[2]);
                const level = {
                    attrs: attrs,
                    bitrate: attrs.decimalInteger('BANDWIDTH') || attrs.decimalInteger('AVERAGE-BANDWIDTH'),
                    name: attrs.NAME,
                    url: $99a156a15cd35eb3$export$c1bd440a1b47590d.resolve(uri, baseurl)
                };
                const resolution = attrs.decimalResolution('RESOLUTION');
                if (resolution) {
                    level.width = resolution.width;
                    level.height = resolution.height;
                }
                $99a156a15cd35eb3$var$setCodecs(attrs.CODECS, level);
                const supplementalCodecs = attrs['SUPPLEMENTAL-CODECS'];
                if (supplementalCodecs) {
                    level.supplemental = {};
                    $99a156a15cd35eb3$var$setCodecs(supplementalCodecs, level.supplemental);
                }
                if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) levelsWithKnownCodecs.push(level);
                parsed.levels.push(level);
            } else if (result[3]) {
                const tag = result[3];
                const attributes = result[4];
                switch(tag){
                    case 'SESSION-DATA':
                        {
                            // #EXT-X-SESSION-DATA
                            const sessionAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(attributes, parsed);
                            const dataId = sessionAttrs['DATA-ID'];
                            if (dataId) {
                                if (parsed.sessionData === null) parsed.sessionData = {};
                                parsed.sessionData[dataId] = sessionAttrs;
                            }
                            break;
                        }
                    case 'SESSION-KEY':
                        {
                            // #EXT-X-SESSION-KEY
                            const sessionKey = $99a156a15cd35eb3$var$parseKey(attributes, baseurl, parsed);
                            if (sessionKey.encrypted && sessionKey.isSupported()) {
                                if (parsed.sessionKeys === null) parsed.sessionKeys = [];
                                parsed.sessionKeys.push(sessionKey);
                            } else $99a156a15cd35eb3$var$logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
                            break;
                        }
                    case 'DEFINE':
                        // #EXT-X-DEFINE
                        {
                            const variableAttributes = new $99a156a15cd35eb3$export$3b2a5864ee72b619(attributes, parsed);
                            $99a156a15cd35eb3$var$addVariableDefinition(parsed, variableAttributes, baseurl);
                        }
                        break;
                    case 'CONTENT-STEERING':
                        {
                            // #EXT-X-CONTENT-STEERING
                            const contentSteeringAttributes = new $99a156a15cd35eb3$export$3b2a5864ee72b619(attributes, parsed);
                            parsed.contentSteering = {
                                uri: $99a156a15cd35eb3$export$c1bd440a1b47590d.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
                            };
                            break;
                        }
                    case 'START':
                        // #EXT-X-START
                        parsed.startTimeOffset = $99a156a15cd35eb3$var$parseStartTimeOffset(attributes);
                        break;
                }
            }
        }
        // Filter out levels with unknown codecs if it does not remove all levels
        const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
        parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
        if (parsed.levels.length === 0) parsed.playlistParsingError = new Error('no levels found in manifest');
        return parsed;
    }
    static parseMasterPlaylistMedia(string, baseurl, parsed) {
        let result;
        const results = {};
        const levels = parsed.levels;
        const groupsByType = {
            AUDIO: levels.map((level)=>({
                    id: level.attrs.AUDIO,
                    audioCodec: level.audioCodec
                })),
            SUBTITLES: levels.map((level)=>({
                    id: level.attrs.SUBTITLES,
                    textCodec: level.textCodec
                })),
            'CLOSED-CAPTIONS': []
        };
        let id = 0;
        $99a156a15cd35eb3$var$MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
        while((result = $99a156a15cd35eb3$var$MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null){
            const attrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(result[1], parsed);
            const type = attrs.TYPE;
            if (type) {
                const groups = groupsByType[type];
                const medias = results[type] || [];
                results[type] = medias;
                const lang = attrs.LANGUAGE;
                const assocLang = attrs['ASSOC-LANGUAGE'];
                const channels = attrs.CHANNELS;
                const characteristics = attrs.CHARACTERISTICS;
                const instreamId = attrs['INSTREAM-ID'];
                const media = {
                    attrs: attrs,
                    bitrate: 0,
                    id: id++,
                    groupId: attrs['GROUP-ID'] || '',
                    name: attrs.NAME || lang || '',
                    type: type,
                    default: attrs.bool('DEFAULT'),
                    autoselect: attrs.bool('AUTOSELECT'),
                    forced: attrs.bool('FORCED'),
                    lang: lang,
                    url: attrs.URI ? $99a156a15cd35eb3$export$c1bd440a1b47590d.resolve(attrs.URI, baseurl) : ''
                };
                if (assocLang) media.assocLang = assocLang;
                if (channels) media.channels = channels;
                if (characteristics) media.characteristics = characteristics;
                if (instreamId) media.instreamId = instreamId;
                if (groups != null && groups.length) {
                    // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
                    // If we don't find the track signalled, lets use the first audio groups codec we have
                    // Acting as a best guess
                    const groupCodec = $99a156a15cd35eb3$export$c1bd440a1b47590d.findGroup(groups, media.groupId) || groups[0];
                    $99a156a15cd35eb3$var$assignCodec(media, groupCodec, 'audioCodec');
                    $99a156a15cd35eb3$var$assignCodec(media, groupCodec, 'textCodec');
                }
                medias.push(media);
            }
        }
        return results;
    }
    static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
        var _LEVEL_PLAYLIST_REGEX;
        const base = {
            url: baseurl
        };
        const level = new $99a156a15cd35eb3$export$9eda1d8aef4189e9(baseurl);
        const fragments = level.fragments;
        const programDateTimes = [];
        // The most recent init segment seen (applies to all subsequent segments)
        let currentInitSegment = null;
        let currentSN = 0;
        let currentPart = 0;
        let totalduration = 0;
        let discontinuityCounter = 0;
        let currentBitrate = 0;
        let prevFrag = null;
        let frag = new $99a156a15cd35eb3$export$ffb0004e005737fa(type, base);
        let result;
        let i;
        let levelkeys;
        let firstPdtIndex = -1;
        let createNextFrag = false;
        let nextByteRange = null;
        let serverControlAttrs;
        $99a156a15cd35eb3$var$LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
        level.m3u8 = string;
        level.hasVariableRefs = $99a156a15cd35eb3$var$hasVariableReferences(string);
        if (((_LEVEL_PLAYLIST_REGEX = $99a156a15cd35eb3$var$LEVEL_PLAYLIST_REGEX_FAST.exec(string)) == null ? void 0 : _LEVEL_PLAYLIST_REGEX[0]) !== '#EXTM3U') {
            level.playlistParsingError = new Error('Missing format identifier #EXTM3U');
            return level;
        }
        while((result = $99a156a15cd35eb3$var$LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null){
            if (createNextFrag) {
                createNextFrag = false;
                frag = new $99a156a15cd35eb3$export$ffb0004e005737fa(type, base);
                // setup the next fragment for part loading
                frag.playlistOffset = totalduration;
                frag.start = totalduration;
                frag.sn = currentSN;
                frag.cc = discontinuityCounter;
                if (currentBitrate) frag.bitrate = currentBitrate;
                frag.level = id;
                if (currentInitSegment) {
                    frag.initSegment = currentInitSegment;
                    if (currentInitSegment.rawProgramDateTime) {
                        frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                        currentInitSegment.rawProgramDateTime = null;
                    }
                    if (nextByteRange) {
                        frag.setByteRange(nextByteRange);
                        nextByteRange = null;
                    }
                }
            }
            const duration = result[1];
            if (duration) {
                // INF
                frag.duration = parseFloat(duration);
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const title = (' ' + result[2]).slice(1);
                frag.title = title || null;
                frag.tagList.push(title ? [
                    'INF',
                    duration,
                    title
                ] : [
                    'INF',
                    duration
                ]);
            } else if (result[3]) // url
            {
                if ($99a156a15cd35eb3$var$isFiniteNumber(frag.duration)) {
                    frag.playlistOffset = totalduration;
                    frag.start = totalduration;
                    if (levelkeys) $99a156a15cd35eb3$var$setFragLevelKeys(frag, levelkeys, level);
                    frag.sn = currentSN;
                    frag.level = id;
                    frag.cc = discontinuityCounter;
                    fragments.push(frag);
                    // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                    const uri = (' ' + result[3]).slice(1);
                    frag.relurl = $99a156a15cd35eb3$var$substituteVariables(level, uri);
                    $99a156a15cd35eb3$var$assignProgramDateTime(frag, prevFrag, programDateTimes);
                    prevFrag = frag;
                    totalduration += frag.duration;
                    currentSN++;
                    currentPart = 0;
                    createNextFrag = true;
                }
            } else {
                result = result[0].match($99a156a15cd35eb3$var$LEVEL_PLAYLIST_REGEX_SLOW);
                if (!result) {
                    $99a156a15cd35eb3$var$logger.warn('No matches on slow regex match for level playlist!');
                    continue;
                }
                for(i = 1; i < result.length; i++){
                    if (result[i] !== undefined) break;
                }
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const tag = (' ' + result[i]).slice(1);
                const value1 = (' ' + result[i + 1]).slice(1);
                const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : null;
                switch(tag){
                    case 'BYTERANGE':
                        if (prevFrag) frag.setByteRange(value1, prevFrag);
                        else frag.setByteRange(value1);
                        break;
                    case 'PROGRAM-DATE-TIME':
                        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                        frag.rawProgramDateTime = value1;
                        frag.tagList.push([
                            'PROGRAM-DATE-TIME',
                            value1
                        ]);
                        if (firstPdtIndex === -1) firstPdtIndex = fragments.length;
                        break;
                    case 'PLAYLIST-TYPE':
                        if (level.type) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.type = value1.toUpperCase();
                        break;
                    case 'MEDIA-SEQUENCE':
                        if (level.startSN !== 0) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        else if (fragments.length > 0) $99a156a15cd35eb3$var$assignMustAppearBeforeSegmentsError(level, tag, result);
                        currentSN = level.startSN = parseInt(value1);
                        break;
                    case 'SKIP':
                        {
                            if (level.skippedSegments) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                            const skipAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
                            if ($99a156a15cd35eb3$var$isFiniteNumber(skippedSegments)) {
                                level.skippedSegments += skippedSegments;
                                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                                for(let _i = skippedSegments; _i--;)fragments.push(null);
                                currentSN += skippedSegments;
                            }
                            const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
                            if (recentlyRemovedDateranges) level.recentlyRemovedDateranges = (level.recentlyRemovedDateranges || []).concat(recentlyRemovedDateranges.split('\t'));
                            break;
                        }
                    case 'TARGETDURATION':
                        if (level.targetduration !== 0) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.targetduration = Math.max(parseInt(value1), 1);
                        break;
                    case 'VERSION':
                        if (level.version !== null) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.version = parseInt(value1);
                        break;
                    case 'INDEPENDENT-SEGMENTS':
                        break;
                    case 'ENDLIST':
                        if (!level.live) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.live = false;
                        break;
                    case '#':
                        if (value1 || value2) frag.tagList.push(value2 ? [
                            value1,
                            value2
                        ] : [
                            value1
                        ]);
                        break;
                    case 'DISCONTINUITY':
                        discontinuityCounter++;
                        frag.tagList.push([
                            'DIS'
                        ]);
                        break;
                    case 'GAP':
                        frag.gap = true;
                        frag.tagList.push([
                            tag
                        ]);
                        break;
                    case 'BITRATE':
                        frag.tagList.push([
                            tag,
                            value1
                        ]);
                        currentBitrate = parseInt(value1) * 1000;
                        if ($99a156a15cd35eb3$var$isFiniteNumber(currentBitrate)) frag.bitrate = currentBitrate;
                        else currentBitrate = 0;
                        break;
                    case 'DATERANGE':
                        {
                            const dateRangeAttr = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            const dateRange = new $99a156a15cd35eb3$export$829bd850c745b6e(dateRangeAttr, level.dateRanges[dateRangeAttr.ID], level.dateRangeTagCount);
                            level.dateRangeTagCount++;
                            if (dateRange.isValid || level.skippedSegments) level.dateRanges[dateRange.id] = dateRange;
                            else $99a156a15cd35eb3$var$logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
                            // Add to fragment tag list for backwards compatibility (< v1.2.0)
                            frag.tagList.push([
                                'EXT-X-DATERANGE',
                                value1
                            ]);
                            break;
                        }
                    case 'DEFINE':
                        {
                            const variableAttributes = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            if ('IMPORT' in variableAttributes) $99a156a15cd35eb3$var$importVariableDefinition(level, variableAttributes, multivariantVariableList);
                            else $99a156a15cd35eb3$var$addVariableDefinition(level, variableAttributes, baseurl);
                        }
                        break;
                    case 'DISCONTINUITY-SEQUENCE':
                        if (level.startCC !== 0) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        else if (fragments.length > 0) $99a156a15cd35eb3$var$assignMustAppearBeforeSegmentsError(level, tag, result);
                        level.startCC = discontinuityCounter = parseInt(value1);
                        break;
                    case 'KEY':
                        {
                            const levelKey = $99a156a15cd35eb3$var$parseKey(value1, baseurl, level);
                            if (levelKey.isSupported()) {
                                if (levelKey.method === 'NONE') {
                                    levelkeys = undefined;
                                    break;
                                }
                                if (!levelkeys) levelkeys = {};
                                if (levelkeys[levelKey.keyFormat]) levelkeys = $99a156a15cd35eb3$var$_extends({}, levelkeys);
                                levelkeys[levelKey.keyFormat] = levelKey;
                            } else $99a156a15cd35eb3$var$logger.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${value1}"`);
                            break;
                        }
                    case 'START':
                        level.startTimeOffset = $99a156a15cd35eb3$var$parseStartTimeOffset(value1);
                        break;
                    case 'MAP':
                        {
                            const mapAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            if (frag.duration) {
                                // Initial segment tag is after segment duration tag.
                                //   #EXTINF: 6.0
                                //   #EXT-X-MAP:URI="init.mp4
                                const init = new $99a156a15cd35eb3$export$ffb0004e005737fa(type, base);
                                $99a156a15cd35eb3$var$setInitSegment(init, mapAttrs, id, levelkeys);
                                currentInitSegment = init;
                                frag.initSegment = currentInitSegment;
                                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                            } else {
                                // Initial segment tag is before segment duration tag
                                // Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
                                const end = frag.byteRangeEndOffset;
                                if (end) {
                                    const start = frag.byteRangeStartOffset;
                                    nextByteRange = `${end - start}@${start}`;
                                } else nextByteRange = null;
                                $99a156a15cd35eb3$var$setInitSegment(frag, mapAttrs, id, levelkeys);
                                currentInitSegment = frag;
                                createNextFrag = true;
                            }
                            currentInitSegment.cc = discontinuityCounter;
                            break;
                        }
                    case 'SERVER-CONTROL':
                        if (serverControlAttrs) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        serverControlAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1);
                        level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
                        level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
                        level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
                        level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
                        level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
                        break;
                    case 'PART-INF':
                        {
                            if (level.partTarget) $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                            const partInfAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1);
                            level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
                            break;
                        }
                    case 'PART':
                        {
                            let partList = level.partList;
                            if (!partList) partList = level.partList = [];
                            const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
                            const index = currentPart++;
                            const partAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            const part = new $99a156a15cd35eb3$export$7b5bf7981d51054e(partAttrs, frag, base, index, previousFragmentPart);
                            partList.push(part);
                            frag.duration += part.duration;
                            break;
                        }
                    case 'PRELOAD-HINT':
                        {
                            const preloadHintAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            level.preloadHint = preloadHintAttrs;
                            break;
                        }
                    case 'RENDITION-REPORT':
                        {
                            const renditionReportAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(value1, level);
                            level.renditionReports = level.renditionReports || [];
                            level.renditionReports.push(renditionReportAttrs);
                            break;
                        }
                    default:
                        $99a156a15cd35eb3$var$logger.warn(`line parsed but not handled: ${result}`);
                        break;
                }
            }
        }
        if (prevFrag && !prevFrag.relurl) {
            fragments.pop();
            totalduration -= prevFrag.duration;
            if (level.partList) level.fragmentHint = prevFrag;
        } else if (level.partList) {
            $99a156a15cd35eb3$var$assignProgramDateTime(frag, prevFrag, programDateTimes);
            frag.cc = discontinuityCounter;
            level.fragmentHint = frag;
            if (levelkeys) $99a156a15cd35eb3$var$setFragLevelKeys(frag, levelkeys, level);
        }
        if (!level.targetduration) level.playlistParsingError = new Error(`#EXT-X-TARGETDURATION is required`);
        const fragmentLength = fragments.length;
        const firstFragment = fragments[0];
        const lastFragment = fragments[fragmentLength - 1];
        totalduration += level.skippedSegments * level.targetduration;
        if (totalduration > 0 && fragmentLength && lastFragment) {
            level.averagetargetduration = totalduration / fragmentLength;
            const lastSn = lastFragment.sn;
            level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
            if (!level.live) lastFragment.endList = true;
            if (firstFragment && level.startCC === undefined) level.startCC = firstFragment.cc;
            /**
       * Backfill any missing PDT values
       * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
       * one or more Media Segment URIs, the client SHOULD extrapolate
       * backward from that tag (using EXTINF durations and/or media
       * timestamps) to associate dates with those segments."
       * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
       * computed.
       */ if (firstPdtIndex > 0) {
                $99a156a15cd35eb3$var$backfillProgramDateTimes(fragments, firstPdtIndex);
                if (firstFragment) programDateTimes.unshift(firstFragment);
            }
        } else {
            level.endSN = 0;
            level.startCC = 0;
        }
        if (level.fragmentHint) totalduration += level.fragmentHint.duration;
        level.totalduration = totalduration;
        if (programDateTimes.length && level.dateRangeTagCount && firstFragment) $99a156a15cd35eb3$var$mapDateRanges(programDateTimes, level);
        level.endCC = discontinuityCounter;
        return level;
    }
}
function $99a156a15cd35eb3$var$mapDateRanges(programDateTimes, details) {
    // Make sure DateRanges are mapped to a ProgramDateTime tag that applies a date to a segment that overlaps with its start date
    const programDateTimeCount = programDateTimes.length;
    if (!programDateTimeCount) return;
    const lastProgramDateTime = programDateTimes[programDateTimeCount - 1];
    const playlistEnd = details.live ? Infinity : details.totalduration;
    const dateRangeIds = Object.keys(details.dateRanges);
    for(let i = dateRangeIds.length; i--;){
        const dateRange = details.dateRanges[dateRangeIds[i]];
        const startDateTime = dateRange.startDate.getTime();
        dateRange.tagAnchor = lastProgramDateTime.ref;
        for(let j = programDateTimeCount; j--;){
            const fragIndex = $99a156a15cd35eb3$var$findFragmentWithStartDate(details, startDateTime, programDateTimes, j, playlistEnd);
            if (fragIndex !== -1) {
                dateRange.tagAnchor = details.fragments[fragIndex].ref;
                break;
            }
        }
    }
}
function $99a156a15cd35eb3$var$findFragmentWithStartDate(details, startDateTime, programDateTimes, index, endTime) {
    const pdtFragment = programDateTimes[index];
    if (pdtFragment) {
        // find matching range between PDT tags
        const pdtStart = pdtFragment.programDateTime;
        if (startDateTime >= pdtStart || index === 0) {
            var _programDateTimes;
            const durationBetweenPdt = (((_programDateTimes = programDateTimes[index + 1]) == null ? void 0 : _programDateTimes.start) || endTime) - pdtFragment.start;
            if (startDateTime <= pdtStart + durationBetweenPdt * 1000) {
                // map to fragment with date-time range
                const startIndex = programDateTimes[index].sn - details.startSN;
                const fragments = details.fragments;
                if (fragments.length > programDateTimes.length) {
                    const endSegment = programDateTimes[index + 1] || fragments[fragments.length - 1];
                    const endIndex = endSegment.sn - details.startSN;
                    for(let i = endIndex; i > startIndex; i--){
                        const fragStartDateTime = fragments[i].programDateTime;
                        if (startDateTime >= fragStartDateTime && startDateTime < fragStartDateTime + fragments[i].duration * 1000) return i;
                    }
                }
                return startIndex;
            }
        }
    }
    return -1;
}
function $99a156a15cd35eb3$var$parseKey(keyTagAttributes, baseurl, parsed) {
    var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
    // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
    const keyAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(keyTagAttributes, parsed);
    const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
    const decrypturi = keyAttrs.URI;
    const decryptiv = keyAttrs.hexadecimalInteger('IV');
    const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
    // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
    const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
    if (decrypturi && keyAttrs.IV && !decryptiv) $99a156a15cd35eb3$var$logger.error(`Invalid IV: ${keyAttrs.IV}`);
    // If decrypturi is a URI with a scheme, then baseurl will be ignored
    // No uri is allowed when METHOD is NONE
    const resolvedUri = decrypturi ? $99a156a15cd35eb3$export$c1bd440a1b47590d.resolve(decrypturi, baseurl) : '';
    const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
    return new $99a156a15cd35eb3$export$ca24892a09b21f29(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv);
}
function $99a156a15cd35eb3$var$parseStartTimeOffset(startAttributes) {
    const startAttrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(startAttributes);
    const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
    if ($99a156a15cd35eb3$var$isFiniteNumber(startTimeOffset)) return startTimeOffset;
    return null;
}
function $99a156a15cd35eb3$var$setCodecs(codecsAttributeValue, level) {
    let codecs = (codecsAttributeValue || '').split(/[ ,]+/).filter((c)=>c);
    [
        'video',
        'audio',
        'text'
    ].forEach((type)=>{
        const filtered = codecs.filter((codec)=>$99a156a15cd35eb3$var$isCodecType(codec, type));
        if (filtered.length) {
            // Comma separated list of all codecs for type
            level[`${type}Codec`] = filtered.map((c)=>c.split('/')[0]).join(',');
            // Remove known codecs so that only unknownCodecs are left after iterating through each type
            codecs = codecs.filter((codec)=>filtered.indexOf(codec) === -1);
        }
    });
    level.unknownCodecs = codecs;
}
function $99a156a15cd35eb3$var$assignCodec(media, groupItem, codecProperty) {
    const codecValue = groupItem[codecProperty];
    if (codecValue) media[codecProperty] = codecValue;
}
function $99a156a15cd35eb3$var$backfillProgramDateTimes(fragments, firstPdtIndex) {
    let fragPrev = fragments[firstPdtIndex];
    for(let i = firstPdtIndex; i--;){
        const frag = fragments[i];
        // Exit on delta-playlist skipped segments
        if (!frag) return;
        frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
        fragPrev = frag;
    }
}
function $99a156a15cd35eb3$var$assignProgramDateTime(frag, prevFrag, programDateTimes) {
    if (frag.rawProgramDateTime) programDateTimes.push(frag);
    else if (prevFrag != null && prevFrag.programDateTime) frag.programDateTime = prevFrag.endProgramDateTime;
}
function $99a156a15cd35eb3$var$setInitSegment(frag, mapAttrs, id, levelkeys) {
    frag.relurl = mapAttrs.URI;
    if (mapAttrs.BYTERANGE) frag.setByteRange(mapAttrs.BYTERANGE);
    frag.level = id;
    frag.sn = 'initSegment';
    if (levelkeys) frag.levelkeys = levelkeys;
    frag.initSegment = null;
}
function $99a156a15cd35eb3$var$setFragLevelKeys(frag, levelkeys, level) {
    frag.levelkeys = levelkeys;
    const { encryptedFragments: encryptedFragments } = level;
    if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some((format)=>levelkeys[format].isCommonEncryption)) encryptedFragments.push(frag);
}
function $99a156a15cd35eb3$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result) {
    level.playlistParsingError = new Error(`#EXT-X-${tag} must not appear more than once (${result[0]})`);
}
function $99a156a15cd35eb3$var$assignMustAppearBeforeSegmentsError(level, tag, result) {
    level.playlistParsingError = new Error(`#EXT-X-${tag} must appear before the first Media Segment (${result[0]})`);
}
function $99a156a15cd35eb3$var$updateFromToPTS(fragFrom, fragTo) {
    const fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if ($99a156a15cd35eb3$var$isFiniteNumber(fragToPTS)) {
        // update fragment duration.
        // it helps to fix drifts between playlist reported duration and fragment real duration
        let duration = 0;
        let frag;
        if (fragTo.sn > fragFrom.sn) {
            duration = fragToPTS - fragFrom.start;
            frag = fragFrom;
        } else {
            duration = fragFrom.start - fragToPTS;
            frag = fragTo;
        }
        if (frag.duration !== duration) frag.setDuration(duration);
    // we dont know startPTS[toIdx]
    } else if (fragTo.sn > fragFrom.sn) {
        const contiguous = fragFrom.cc === fragTo.cc;
        // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
        if (contiguous && fragFrom.minEndPTS) fragTo.setStart(fragFrom.start + (fragFrom.minEndPTS - fragFrom.start));
        else fragTo.setStart(fragFrom.start + fragFrom.duration);
    } else fragTo.setStart(Math.max(fragFrom.start - fragTo.duration, 0));
}
function $99a156a15cd35eb3$var$updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    const parsedMediaDuration = endPTS - startPTS;
    if (parsedMediaDuration <= 0) {
        $99a156a15cd35eb3$var$logger.warn('Fragment should have a positive duration', frag);
        endPTS = startPTS + frag.duration;
        endDTS = startDTS + frag.duration;
    }
    let maxStartPTS = startPTS;
    let minEndPTS = endPTS;
    const fragStartPts = frag.startPTS;
    const fragEndPts = frag.endPTS;
    if ($99a156a15cd35eb3$var$isFiniteNumber(fragStartPts)) {
        // delta PTS between audio and video
        const deltaPTS = Math.abs(fragStartPts - startPTS);
        if (!$99a156a15cd35eb3$var$isFiniteNumber(frag.deltaPTS)) frag.deltaPTS = deltaPTS;
        else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
        maxStartPTS = Math.max(startPTS, fragStartPts);
        startPTS = Math.min(startPTS, fragStartPts);
        startDTS = Math.min(startDTS, frag.startDTS);
        minEndPTS = Math.min(endPTS, fragEndPts);
        endPTS = Math.max(endPTS, fragEndPts);
        endDTS = Math.max(endDTS, frag.endDTS);
    }
    const drift = startPTS - frag.start;
    if (frag.start !== 0) frag.setStart(startPTS);
    frag.setDuration(endPTS - frag.start);
    frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.startDTS = startDTS;
    frag.endPTS = endPTS;
    frag.minEndPTS = minEndPTS;
    frag.endDTS = endDTS;
    const sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) return 0;
    let i;
    const fragIdx = sn - details.startSN;
    const fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for(i = fragIdx; i > 0; i--)$99a156a15cd35eb3$var$updateFromToPTS(fragments[i], fragments[i - 1]);
    // adjust fragment PTS/duration from seqnum to last frag
    for(i = fragIdx; i < fragments.length - 1; i++)$99a156a15cd35eb3$var$updateFromToPTS(fragments[i], fragments[i + 1]);
    if (details.fragmentHint) $99a156a15cd35eb3$var$updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
    details.PTSKnown = details.alignedSliding = true;
    return drift;
}
function $99a156a15cd35eb3$var$mergeDetails(oldDetails, newDetails) {
    if (oldDetails === newDetails) return;
    // Track the last initSegment processed. Initialize it to the last one on the timeline.
    let currentInitSegment = null;
    const oldFragments = oldDetails.fragments;
    for(let i = oldFragments.length - 1; i >= 0; i--){
        const oldInit = oldFragments[i].initSegment;
        if (oldInit) {
            currentInitSegment = oldInit;
            break;
        }
    }
    if (oldDetails.fragmentHint) // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
    // check if old/new playlists have fragments in common
    // loop through overlapping SN and update startPTS, cc, and duration if any found
    let PTSFrag;
    $99a156a15cd35eb3$var$mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag, newFragIndex, newFragments)=>{
        if ((!newDetails.startCC || newDetails.skippedSegments) && newFrag.cc !== oldFrag.cc) {
            const ccOffset = oldFrag.cc - newFrag.cc;
            for(let i = newFragIndex; i < newFragments.length; i++)newFragments[i].cc += ccOffset;
            newDetails.endCC = newFragments[newFragments.length - 1].cc;
        }
        if ($99a156a15cd35eb3$var$isFiniteNumber(oldFrag.startPTS) && $99a156a15cd35eb3$var$isFiniteNumber(oldFrag.endPTS)) {
            newFrag.setStart(newFrag.startPTS = oldFrag.startPTS);
            newFrag.startDTS = oldFrag.startDTS;
            newFrag.maxStartPTS = oldFrag.maxStartPTS;
            newFrag.endPTS = oldFrag.endPTS;
            newFrag.endDTS = oldFrag.endDTS;
            newFrag.minEndPTS = oldFrag.minEndPTS;
            newFrag.setDuration(oldFrag.endPTS - oldFrag.startPTS);
            if (newFrag.duration) PTSFrag = newFrag;
            // PTS is known when any segment has startPTS and endPTS
            newDetails.PTSKnown = newDetails.alignedSliding = true;
        }
        if (oldFrag.hasStreams) newFrag.elementaryStreams = oldFrag.elementaryStreams;
        newFrag.loader = oldFrag.loader;
        if (oldFrag.hasStats) newFrag.stats = oldFrag.stats;
        if (oldFrag.initSegment) {
            newFrag.initSegment = oldFrag.initSegment;
            currentInitSegment = oldFrag.initSegment;
        }
    });
    const newFragments = newDetails.fragments;
    const fragmentsToCheck = newDetails.fragmentHint ? newFragments.concat(newDetails.fragmentHint) : newFragments;
    if (currentInitSegment) fragmentsToCheck.forEach((frag)=>{
        var _currentInitSegment;
        if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) frag.initSegment = currentInitSegment;
    });
    if (newDetails.skippedSegments) {
        newDetails.deltaUpdateFailed = newFragments.some((frag)=>!frag);
        if (newDetails.deltaUpdateFailed) {
            $99a156a15cd35eb3$var$logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
            for(let i = newDetails.skippedSegments; i--;)newFragments.shift();
            newDetails.startSN = newFragments[0].sn;
        } else {
            if (newDetails.canSkipDateRanges) newDetails.dateRanges = $99a156a15cd35eb3$var$mergeDateRanges(oldDetails.dateRanges, newDetails);
            const programDateTimes = oldDetails.fragments.filter((frag)=>frag.rawProgramDateTime);
            if (oldDetails.hasProgramDateTime && !newDetails.hasProgramDateTime) {
                for(let i = 1; i < fragmentsToCheck.length; i++)if (fragmentsToCheck[i].programDateTime === null) $99a156a15cd35eb3$var$assignProgramDateTime(fragmentsToCheck[i], fragmentsToCheck[i - 1], programDateTimes);
            }
            $99a156a15cd35eb3$var$mapDateRanges(programDateTimes, newDetails);
        }
        newDetails.endCC = newFragments[newFragments.length - 1].cc;
    }
    if (!newDetails.startCC) {
        var _fragPriorToNewStart$;
        const fragPriorToNewStart = $99a156a15cd35eb3$var$getFragmentWithSN(oldDetails, newDetails.startSN - 1);
        newDetails.startCC = (_fragPriorToNewStart$ = fragPriorToNewStart == null ? void 0 : fragPriorToNewStart.cc) != null ? _fragPriorToNewStart$ : newFragments[0].cc;
    }
    // Merge parts
    $99a156a15cd35eb3$var$mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart)=>{
        newPart.elementaryStreams = oldPart.elementaryStreams;
        newPart.stats = oldPart.stats;
    });
    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) $99a156a15cd35eb3$var$updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    else // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    $99a156a15cd35eb3$var$adjustSliding(oldDetails, newDetails);
    if (newFragments.length) newDetails.totalduration = newDetails.edge - newFragments[0].start;
    newDetails.driftStartTime = oldDetails.driftStartTime;
    newDetails.driftStart = oldDetails.driftStart;
    const advancedDateTime = newDetails.advancedDateTime;
    if (newDetails.advanced && advancedDateTime) {
        const edge = newDetails.edge;
        if (!newDetails.driftStart) {
            newDetails.driftStartTime = advancedDateTime;
            newDetails.driftStart = edge;
        }
        newDetails.driftEndTime = advancedDateTime;
        newDetails.driftEnd = edge;
    } else {
        newDetails.driftEndTime = oldDetails.driftEndTime;
        newDetails.driftEnd = oldDetails.driftEnd;
        newDetails.advancedDateTime = oldDetails.advancedDateTime;
    }
    if (newDetails.requestScheduled === -1) newDetails.requestScheduled = oldDetails.requestScheduled;
}
function $99a156a15cd35eb3$var$mergeDateRanges(oldDateRanges, newDetails) {
    const { dateRanges: deltaDateRanges, recentlyRemovedDateranges: recentlyRemovedDateranges } = newDetails;
    const dateRanges = $99a156a15cd35eb3$var$_extends({}, oldDateRanges);
    if (recentlyRemovedDateranges) recentlyRemovedDateranges.forEach((id)=>{
        delete dateRanges[id];
    });
    const mergeIds = Object.keys(dateRanges);
    const mergeCount = mergeIds.length;
    if (mergeCount) Object.keys(deltaDateRanges).forEach((id)=>{
        const mergedDateRange = dateRanges[id];
        const dateRange = new $99a156a15cd35eb3$export$829bd850c745b6e(deltaDateRanges[id].attr, mergedDateRange);
        if (dateRange.isValid) {
            dateRanges[id] = dateRange;
            if (!mergedDateRange) dateRange.tagOrder += mergeCount;
        } else $99a156a15cd35eb3$var$logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${$99a156a15cd35eb3$var$stringify(deltaDateRanges[id].attr)}"`);
    });
    return dateRanges;
}
function $99a156a15cd35eb3$var$mapPartIntersection(oldParts, newParts, intersectionFn) {
    if (oldParts && newParts) {
        let delta = 0;
        for(let i = 0, len = oldParts.length; i <= len; i++){
            const oldPart = oldParts[i];
            const newPart = newParts[i + delta];
            if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) intersectionFn(oldPart, newPart);
            else delta--;
        }
    }
}
function $99a156a15cd35eb3$var$mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
    const skippedSegments = newDetails.skippedSegments;
    const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
    const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
    const delta = newDetails.startSN - oldDetails.startSN;
    const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
    for(let i = start; i <= end; i++){
        const oldFrag = oldFrags[delta + i];
        let newFrag = newFrags[i];
        if (skippedSegments && !newFrag && oldFrag) // Fill in skipped segments in delta playlist
        newFrag = newDetails.fragments[i] = oldFrag;
        if (oldFrag && newFrag) {
            intersectionFn(oldFrag, newFrag, i, newFrags);
            if (oldFrag.url && oldFrag.url !== newFrag.url) {
                newDetails.playlistParsingError = $99a156a15cd35eb3$var$getSequenceError(`media sequence mismatch ${newFrag.sn}:`, oldDetails, newDetails, oldFrag, newFrag);
                return;
            } else if (oldFrag.cc !== newFrag.cc) {
                newDetails.playlistParsingError = $99a156a15cd35eb3$var$getSequenceError(`discontinuity sequence mismatch (${oldFrag.cc}!=${newFrag.cc})`, oldDetails, newDetails, oldFrag, newFrag);
                return;
            }
        }
    }
}
function $99a156a15cd35eb3$var$getSequenceError(message, oldDetails, newDetails, oldFrag, newFrag) {
    return new Error(`${message} ${newFrag.url}
Playlist starting @${oldDetails.startSN}
${oldDetails.m3u8}

Playlist starting @${newDetails.startSN}
${newDetails.m3u8}`);
}
function $99a156a15cd35eb3$var$adjustSliding(oldDetails, newDetails, matchingStableVariantOrRendition = true) {
    const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
    const oldFragments = oldDetails.fragments;
    const advancedOrStable = delta >= 0;
    let sliding = 0;
    if (advancedOrStable && delta < oldFragments.length) sliding = oldFragments[delta].start;
    else if (advancedOrStable && newDetails.startSN === oldDetails.endSN + 1) sliding = oldDetails.fragmentEnd;
    else if (advancedOrStable && matchingStableVariantOrRendition) // align with expected position (updated playlist start sequence is past end sequence of last update)
    sliding = oldDetails.fragmentStart + delta * newDetails.levelTargetDuration;
    else if (!newDetails.skippedSegments && newDetails.fragmentStart === 0) // align new start with old (playlist switch has a sequence with no overlap and should not be used for alignment)
    sliding = oldDetails.fragmentStart;
    else // new details already has a sliding offset or has skipped segments
    return;
    $99a156a15cd35eb3$var$addSliding(newDetails, sliding);
}
function $99a156a15cd35eb3$var$addSliding(details, sliding) {
    if (sliding) {
        const fragments = details.fragments;
        for(let i = details.skippedSegments; i < fragments.length; i++)fragments[i].addStart(sliding);
        if (details.fragmentHint) details.fragmentHint.addStart(sliding);
    }
}
function $99a156a15cd35eb3$var$computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
    let reloadInterval = 1000 * newDetails.targetduration;
    if (newDetails.updated) {
        // Use last segment duration when shorter than target duration and near live edge
        const fragments = newDetails.fragments;
        const liveEdgeMaxTargetDurations = 4;
        if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
            const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
            if (lastSegmentDuration < reloadInterval) reloadInterval = lastSegmentDuration;
        }
    } else // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
    return Math.round(reloadInterval);
}
function $99a156a15cd35eb3$var$getFragmentWithSN(details, sn, fragCurrent) {
    if (!details) return null;
    let fragment = details.fragments[sn - details.startSN];
    if (fragment) return fragment;
    fragment = details.fragmentHint;
    if (fragment && fragment.sn === sn) return fragment;
    if (sn < details.startSN && fragCurrent && fragCurrent.sn === sn) return fragCurrent;
    return null;
}
function $99a156a15cd35eb3$var$getPartWith(details, sn, partIndex) {
    if (!details) return null;
    return $99a156a15cd35eb3$var$findPart(details.partList, sn, partIndex);
}
function $99a156a15cd35eb3$var$findPart(partList, sn, partIndex) {
    if (partList) for(let i = partList.length; i--;){
        const part = partList[i];
        if (part.index === partIndex && part.fragment.sn === sn) return part;
    }
    return null;
}
function $99a156a15cd35eb3$var$reassignFragmentLevelIndexes(levels) {
    levels.forEach((level, index)=>{
        var _level$details;
        (_level$details = level.details) == null || _level$details.fragments.forEach((fragment)=>{
            fragment.level = index;
            if (fragment.initSegment) fragment.initSegment.level = index;
        });
    });
}
function $99a156a15cd35eb3$var$findFirstFragWithCC(fragments, cc) {
    for(let i = 0, len = fragments.length; i < len; i++){
        var _fragments$i;
        if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) return fragments[i];
    }
    return null;
}
function $99a156a15cd35eb3$var$shouldAlignOnDiscontinuities(refDetails, details) {
    if (refDetails) {
        if (details.startCC < refDetails.endCC && details.endCC > refDetails.startCC) return true;
    }
    return false;
}
function $99a156a15cd35eb3$var$adjustFragmentStart(frag, sliding) {
    if (frag) {
        const start = frag.start + sliding;
        frag.start = frag.startPTS = start;
        frag.endPTS = start + frag.duration;
    }
}
function $99a156a15cd35eb3$var$adjustSlidingStart(sliding, details) {
    // Update segments
    const fragments = details.fragments;
    for(let i = 0, len = fragments.length; i < len; i++)$99a156a15cd35eb3$var$adjustFragmentStart(fragments[i], sliding);
    // Update LL-HLS parts at the end of the playlist
    if (details.fragmentHint) $99a156a15cd35eb3$var$adjustFragmentStart(details.fragmentHint, sliding);
    details.alignedSliding = true;
}
/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastLevel
 * @param details
 */ function $99a156a15cd35eb3$var$alignStream(switchDetails, details) {
    if (!switchDetails) return;
    $99a156a15cd35eb3$var$alignDiscontinuities(details, switchDetails);
    if (!details.alignedSliding && switchDetails) // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    $99a156a15cd35eb3$var$alignMediaPlaylistByPDT(details, switchDetails);
    if (!details.alignedSliding && switchDetails && !details.skippedSegments) // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    $99a156a15cd35eb3$var$adjustSliding(switchDetails, details, false);
}
/**
 * Ajust the start of fragments in `details` by the difference in time between fragments of the latest
 * shared discontinuity sequence change.
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */ function $99a156a15cd35eb3$var$alignDiscontinuities(details, refDetails) {
    if (!$99a156a15cd35eb3$var$shouldAlignOnDiscontinuities(refDetails, details)) return;
    const targetCC = Math.min(refDetails.endCC, details.endCC);
    const refFrag = $99a156a15cd35eb3$var$findFirstFragWithCC(refDetails.fragments, targetCC);
    const frag = $99a156a15cd35eb3$var$findFirstFragWithCC(details.fragments, targetCC);
    if (!refFrag || !frag) return;
    $99a156a15cd35eb3$var$logger.log(`Aligning playlist at start of dicontinuity sequence ${targetCC}`);
    const delta = refFrag.start - frag.start;
    $99a156a15cd35eb3$var$adjustSlidingStart(delta, details);
}
/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */ function $99a156a15cd35eb3$var$alignMediaPlaylistByPDT(details, refDetails) {
    if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) return;
    const fragments = details.fragments;
    const refFragments = refDetails.fragments;
    if (!fragments.length || !refFragments.length) return;
    // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
    // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
    // If a fragment of the same discontinuity was not found use the middle fragment of both.
    let refFrag;
    let frag;
    const targetCC = Math.min(refDetails.endCC, details.endCC);
    if (refDetails.startCC < targetCC && details.startCC < targetCC) {
        refFrag = $99a156a15cd35eb3$var$findFirstFragWithCC(refFragments, targetCC);
        frag = $99a156a15cd35eb3$var$findFirstFragWithCC(fragments, targetCC);
    }
    if (!refFrag || !frag) {
        refFrag = refFragments[Math.floor(refFragments.length / 2)];
        frag = $99a156a15cd35eb3$var$findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
    }
    const refPDT = refFrag.programDateTime;
    const targetPDT = frag.programDateTime;
    if (!refPDT || !targetPDT) return;
    const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
    $99a156a15cd35eb3$var$adjustSlidingStart(delta, details);
}
/**
 *  TimeRanges to string helper
 */ const $99a156a15cd35eb3$var$TimeRanges = {
    toString: function(r) {
        let log = '';
        const len = r.length;
        for(let i = 0; i < len; i++)log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
        return log;
    }
};
const $99a156a15cd35eb3$var$State = {
    STOPPED: 'STOPPED',
    IDLE: 'IDLE',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_TRACK: 'WAITING_TRACK',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    ENDED: 'ENDED',
    ERROR: 'ERROR',
    WAITING_INIT_PTS: 'WAITING_INIT_PTS',
    WAITING_LEVEL: 'WAITING_LEVEL'
};
class $99a156a15cd35eb3$export$946cb951577581c9 extends $99a156a15cd35eb3$var$TaskLoop {
    constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType){
        super(logPrefix, hls.logger);
        this.hls = void 0;
        this.fragPrevious = null;
        this.fragCurrent = null;
        this.fragmentTracker = void 0;
        this.transmuxer = null;
        this._state = $99a156a15cd35eb3$var$State.STOPPED;
        this.playlistType = void 0;
        this.media = null;
        this.mediaBuffer = null;
        this.config = void 0;
        this.bitrateTest = false;
        this.lastCurrentTime = 0;
        this.nextLoadPosition = 0;
        this.startPosition = 0;
        this.startTimeOffset = null;
        this.retryDate = 0;
        this.levels = null;
        this.fragmentLoader = void 0;
        this.keyLoader = void 0;
        this.levelLastLoaded = null;
        this.startFragRequested = false;
        this.decrypter = void 0;
        this.initPTS = [];
        this.buffering = true;
        this.loadingParts = false;
        this.loopSn = void 0;
        this.onMediaSeeking = ()=>{
            const { config: config, fragCurrent: fragCurrent, media: media, mediaBuffer: mediaBuffer, state: state } = this;
            const currentTime = media ? media.currentTime : 0;
            const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
            this.log(`media seeking to ${$99a156a15cd35eb3$var$isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}`);
            if (this.state === $99a156a15cd35eb3$var$State.ENDED) this.resetLoadingState();
            else if (fragCurrent) {
                // Seeking while frag load is in progress
                const tolerance = config.maxFragLookUpTolerance;
                const fragStartOffset = fragCurrent.start - tolerance;
                const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
                // if seeking out of buffered range or into new one
                if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
                    const pastFragment = currentTime > fragEndOffset;
                    // if the seek position is outside the current fragment range
                    if (currentTime < fragStartOffset || pastFragment) {
                        if (pastFragment && fragCurrent.loader) {
                            this.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
                            fragCurrent.abortRequests();
                            this.resetLoadingState();
                        }
                        this.fragPrevious = null;
                    }
                }
            }
            if (media) {
                // Remove gap fragments
                this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
                // Don't set lastCurrentTime with backward seeks (allows for frag selection with strict tolerances)
                const lastCurrentTime = this.lastCurrentTime;
                if (currentTime > lastCurrentTime) this.lastCurrentTime = currentTime;
                if (!this.loadingParts) {
                    const bufferEnd = Math.max(bufferInfo.end, currentTime);
                    const shouldLoadParts = this.shouldLoadParts(this.getLevelDetails(), bufferEnd);
                    if (shouldLoadParts) {
                        this.log(`LL-Part loading ON after seeking to ${currentTime.toFixed(2)} with buffer @${bufferEnd.toFixed(2)}`);
                        this.loadingParts = shouldLoadParts;
                    }
                }
            }
            // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
            if (!this.hls.hasEnoughToStart && !bufferInfo.len) {
                this.log(`setting startPosition to ${currentTime} because of seek before start`);
                this.nextLoadPosition = this.startPosition = currentTime;
            }
            // Async tick to speed up processing
            this.tickImmediate();
        };
        this.onMediaEnded = ()=>{
            // reset startPosition and lastCurrentTime to restart playback @ stream beginning
            this.log(`setting startPosition to 0 because media ended`);
            this.startPosition = this.lastCurrentTime = 0;
        };
        this.playlistType = playlistType;
        this.hls = hls;
        this.fragmentLoader = new $99a156a15cd35eb3$var$FragmentLoader(hls.config);
        this.keyLoader = keyLoader;
        this.fragmentTracker = fragmentTracker;
        this.config = hls.config;
        this.decrypter = new $99a156a15cd35eb3$var$Decrypter(hls.config);
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    doTick() {
        this.onTickEnd();
    }
    onTickEnd() {}
    startLoad(startPosition) {}
    stopLoad() {
        if (this.state === $99a156a15cd35eb3$var$State.STOPPED) return;
        this.fragmentLoader.abort();
        this.keyLoader.abort(this.playlistType);
        const frag = this.fragCurrent;
        if (frag != null && frag.loader) {
            frag.abortRequests();
            this.fragmentTracker.removeFragment(frag);
        }
        this.resetTransmuxer();
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.clearInterval();
        this.clearNextTick();
        this.state = $99a156a15cd35eb3$var$State.STOPPED;
    }
    get startPositionValue() {
        const { nextLoadPosition: nextLoadPosition, startPosition: startPosition } = this;
        if (startPosition === -1 && nextLoadPosition) return nextLoadPosition;
        return startPosition;
    }
    get bufferingEnabled() {
        return this.buffering;
    }
    pauseBuffering() {
        this.buffering = false;
    }
    resumeBuffering() {
        this.buffering = true;
    }
    get inFlightFrag() {
        return {
            frag: this.fragCurrent,
            state: this.state
        };
    }
    _streamEnded(bufferInfo, levelDetails) {
        // Stream is never "ended" when playlist is live or media is detached
        if (levelDetails.live || !this.media) return false;
        // Stream is not "ended" when nothing is buffered past the start
        const bufferEnd = bufferInfo.end || 0;
        const timelineStart = this.config.timelineOffset || 0;
        if (bufferEnd <= timelineStart) return false;
        // Stream is not "ended" when there is a second buffered range starting before the end of the playlist
        const bufferedRanges = bufferInfo.buffered;
        if (this.config.maxBufferHole && bufferedRanges && bufferedRanges.length > 1) // make sure bufferInfo accounts for any gaps
        bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferedInfo(bufferedRanges, bufferInfo.start, 0);
        const nextStart = bufferInfo.nextStart;
        const hasSecondBufferedRange = nextStart && nextStart > timelineStart && nextStart < levelDetails.edge;
        if (hasSecondBufferedRange) return false;
        // Playhead is in unbuffered region. Marking EoS now could result in Safari failing to dispatch "ended" event following seek on start.
        if (this.media.currentTime < bufferInfo.start) return false;
        const partList = levelDetails.partList;
        // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
        // check instead if the last part is buffered.
        if (partList != null && partList.length) {
            const lastPart = partList[partList.length - 1];
            // Checking the midpoint of the part for potential margin of error and related issues.
            // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
            // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
            // part mismatches for independent audio and video playlists/segments.
            const lastPartBuffered = $99a156a15cd35eb3$var$BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
            return lastPartBuffered;
        }
        const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
        return this.fragmentTracker.isEndListAppended(playlistType);
    }
    getLevelDetails() {
        if (this.levels && this.levelLastLoaded !== null) {
            var _this$levelLastLoaded;
            return (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details;
        }
    }
    get timelineOffset() {
        const configuredTimelineOffset = this.config.timelineOffset;
        if (configuredTimelineOffset) {
            var _this$getLevelDetails;
            return ((_this$getLevelDetails = this.getLevelDetails()) == null ? void 0 : _this$getLevelDetails.appliedTimelineOffset) || configuredTimelineOffset;
        }
        return 0;
    }
    onMediaAttached(event, data) {
        const media = this.media = this.mediaBuffer = data.media;
        media.removeEventListener('seeking', this.onMediaSeeking);
        media.removeEventListener('ended', this.onMediaEnded);
        media.addEventListener('seeking', this.onMediaSeeking);
        media.addEventListener('ended', this.onMediaEnded);
        const config = this.config;
        if (this.levels && config.autoStartLoad && this.state === $99a156a15cd35eb3$var$State.STOPPED) this.startLoad(config.startPosition);
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        const media = this.media;
        if (media === null) return;
        if (media.ended) {
            this.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // remove video listeners
        media.removeEventListener('seeking', this.onMediaSeeking);
        media.removeEventListener('ended', this.onMediaEnded);
        if (this.keyLoader && !transferringMedia) this.keyLoader.detach();
        this.media = this.mediaBuffer = null;
        this.loopSn = undefined;
        if (transferringMedia) {
            this.resetLoadingState();
            this.resetTransmuxer();
            return;
        }
        this.loadingParts = false;
        this.fragmentTracker.removeAllFragments();
        this.stopLoad();
    }
    onManifestLoading() {
        this.initPTS = [];
        this.levels = this.levelLastLoaded = this.fragCurrent = null;
        this.lastCurrentTime = this.startPosition = 0;
        this.startFragRequested = false;
    }
    onError(event, data) {}
    onManifestLoaded(event, data) {
        this.startTimeOffset = data.startTimeOffset;
    }
    onHandlerDestroying() {
        this.stopLoad();
        if (this.transmuxer) {
            this.transmuxer.destroy();
            this.transmuxer = null;
        }
        super.onHandlerDestroying();
        // @ts-ignore
        this.hls = this.onMediaSeeking = this.onMediaEnded = null;
    }
    onHandlerDestroyed() {
        this.state = $99a156a15cd35eb3$var$State.STOPPED;
        if (this.fragmentLoader) this.fragmentLoader.destroy();
        if (this.keyLoader) this.keyLoader.destroy();
        if (this.decrypter) this.decrypter.destroy();
        this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
        super.onHandlerDestroyed();
    }
    loadFragment(frag, level, targetBufferTime) {
        this.startFragRequested = true;
        this._loadFragForPlayback(frag, level, targetBufferTime);
    }
    _loadFragForPlayback(fragment, level, targetBufferTime) {
        const progressCallback = (data)=>{
            const frag = data.frag;
            if (this.fragContextChanged(frag)) {
                this.warn(`${frag.type} sn: ${frag.sn}${data.part ? ' part: ' + data.part.index : ''} of ${this.fragInfo(frag, false, data.part)}) was dropped during download.`);
                this.fragmentTracker.removeFragment(frag);
                return;
            }
            frag.stats.chunkCount++;
            this._handleFragmentLoadProgress(data);
        };
        this._doFragLoad(fragment, level, targetBufferTime, progressCallback).then((data)=>{
            if (!data) // if we're here we probably needed to backtrack or are waiting for more parts
            return;
            const state = this.state;
            const frag = data.frag;
            if (this.fragContextChanged(frag)) {
                if (state === $99a156a15cd35eb3$var$State.FRAG_LOADING || !this.fragCurrent && state === $99a156a15cd35eb3$var$State.PARSING) {
                    this.fragmentTracker.removeFragment(frag);
                    this.state = $99a156a15cd35eb3$var$State.IDLE;
                }
                return;
            }
            if ('payload' in data) {
                this.log(`Loaded ${frag.type} sn: ${frag.sn} of ${this.playlistLabel()} ${frag.level}`);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, data);
            }
            // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
            this._handleFragmentLoadComplete(data);
        }).catch((reason)=>{
            if (this.state === $99a156a15cd35eb3$var$State.STOPPED || this.state === $99a156a15cd35eb3$var$State.ERROR) return;
            this.warn(`Frag error: ${(reason == null ? void 0 : reason.message) || reason}`);
            this.resetFragmentLoading(fragment);
        });
    }
    clearTrackerIfNeeded(frag) {
        var _this$mediaBuffer;
        const { fragmentTracker: fragmentTracker } = this;
        const fragState = fragmentTracker.getState(frag);
        if (fragState === $99a156a15cd35eb3$var$FragmentState.APPENDING) {
            // Lower the max buffer length and try again
            const playlistType = frag.type;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
            // If backtracking, always remove from the tracker without reducing max buffer length
            const backtrackFragment = this.backtrackFragment;
            const backtracked = backtrackFragment ? frag.sn - backtrackFragment.sn : 0;
            if (backtracked === 1 || this.reduceMaxBufferLength(minForwardBufferLength, frag.duration)) fragmentTracker.removeFragment(frag);
        } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) // Stop gap for bad tracker / buffer flush behavior
        fragmentTracker.removeAllFragments();
        else if (fragmentTracker.hasParts(frag.type)) {
            // In low latency mode, remove fragments for which only some parts were buffered
            fragmentTracker.detectPartialFragments({
                frag: frag,
                part: null,
                stats: frag.stats,
                id: frag.type
            });
            if (fragmentTracker.getState(frag) === $99a156a15cd35eb3$var$FragmentState.PARTIAL) fragmentTracker.removeFragment(frag);
        }
    }
    checkLiveUpdate(details) {
        if (details.updated && !details.live) {
            // Live stream ended, update fragment tracker
            const lastFragment = details.fragments[details.fragments.length - 1];
            this.fragmentTracker.detectPartialFragments({
                frag: lastFragment,
                part: null,
                stats: lastFragment.stats,
                id: lastFragment.type
            });
        }
        if (!details.fragments[0]) details.deltaUpdateFailed = true;
    }
    waitForLive(levelInfo) {
        const details = levelInfo.details;
        return (details == null ? void 0 : details.live) && details.type !== 'EVENT' && (this.levelLastLoaded !== levelInfo || details.expired);
    }
    flushMainBuffer(startOffset, endOffset, type = null) {
        if (!(startOffset - endOffset)) return;
        // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
        // passing a null type flushes both buffers
        const flushScope = {
            startOffset: startOffset,
            endOffset: endOffset,
            type: type
        };
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, flushScope);
    }
    _loadInitSegment(fragment, level) {
        this._doFragLoad(fragment, level).then((data)=>{
            const frag = data == null ? void 0 : data.frag;
            if (!frag || this.fragContextChanged(frag) || !this.levels) throw new Error('init load aborted');
            return data;
        }).then((data)=>{
            const { hls: hls } = this;
            const { frag: frag, payload: payload } = data;
            const decryptData = frag.decryptdata;
            // check to see if the payload needs to be decrypted
            if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && $99a156a15cd35eb3$var$isFullSegmentEncryption(decryptData.method)) {
                const startTime = self.performance.now();
                // decrypt init segment data
                return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, $99a156a15cd35eb3$var$getAesModeFromFullSegmentMethod(decryptData.method)).catch((err)=>{
                    hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR,
                        fatal: false,
                        error: err,
                        reason: err.message,
                        frag: frag
                    });
                    throw err;
                }).then((decryptedData)=>{
                    const endTime = self.performance.now();
                    hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_DECRYPTED, {
                        frag: frag,
                        payload: decryptedData,
                        stats: {
                            tstart: startTime,
                            tdecrypt: endTime
                        }
                    });
                    data.payload = decryptedData;
                    return this.completeInitSegmentLoad(data);
                });
            }
            return this.completeInitSegmentLoad(data);
        }).catch((reason)=>{
            if (this.state === $99a156a15cd35eb3$var$State.STOPPED || this.state === $99a156a15cd35eb3$var$State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(fragment);
        });
    }
    completeInitSegmentLoad(data) {
        const { levels: levels } = this;
        if (!levels) throw new Error('init load aborted, missing levels');
        const stats = data.frag.stats;
        if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.state = $99a156a15cd35eb3$var$State.IDLE;
        data.frag.data = new Uint8Array(data.payload);
        stats.parsing.start = stats.buffering.start = self.performance.now();
        stats.parsing.end = stats.buffering.end = self.performance.now();
        this.tick();
    }
    fragContextChanged(frag) {
        const { fragCurrent: fragCurrent } = this;
        return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
    }
    fragBufferedComplete(frag, part) {
        const media = this.mediaBuffer ? this.mediaBuffer : this.media;
        this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.fragInfo(frag, false, part)} > buffer:${media ? $99a156a15cd35eb3$var$TimeRanges.toString($99a156a15cd35eb3$var$BufferHelper.getBuffered(media)) : '(detached)'})`);
        if ($99a156a15cd35eb3$var$isMediaFragment(frag)) {
            var _this$levels;
            if (frag.type !== $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE) {
                const el = frag.elementaryStreams;
                if (!Object.keys(el).some((type)=>!!el[type])) {
                    // empty segment
                    this.state = $99a156a15cd35eb3$var$State.IDLE;
                    return;
                }
            }
            const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
            if (level != null && level.fragmentError) {
                this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
                level.fragmentError = 0;
            }
        }
        this.state = $99a156a15cd35eb3$var$State.IDLE;
    }
    _handleFragmentLoadComplete(fragLoadedEndData) {
        const { transmuxer: transmuxer } = this;
        if (!transmuxer) return;
        const { frag: frag, part: part, partsLoaded: partsLoaded } = fragLoadedEndData;
        // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
        const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some((fragLoaded)=>!fragLoaded);
        const chunkMeta = new $99a156a15cd35eb3$export$ce0708ece532c9c(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
        transmuxer.flush(chunkMeta);
    }
    _handleFragmentLoadProgress(frag) {}
    _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
        var _frag$decryptdata;
        this.fragCurrent = frag;
        const details = level == null ? void 0 : level.details;
        if (!this.levels || !details) throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
        let keyLoadingPromise = null;
        if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
            this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.playlistLabel()} ${frag.level}`);
            this.state = $99a156a15cd35eb3$var$State.KEY_LOADING;
            this.fragCurrent = frag;
            keyLoadingPromise = this.keyLoader.load(frag).then((keyLoadedData)=>{
                if (!this.fragContextChanged(keyLoadedData.frag)) {
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.KEY_LOADED, keyLoadedData);
                    if (this.state === $99a156a15cd35eb3$var$State.KEY_LOADING) this.state = $99a156a15cd35eb3$var$State.IDLE;
                    return keyLoadedData;
                }
            });
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.KEY_LOADING, {
                frag: frag
            });
            if (this.fragCurrent === null) keyLoadingPromise = Promise.reject(new Error(`frag load aborted, context changed in KEY_LOADING`));
        } else if (!frag.encrypted) {
            keyLoadingPromise = this.keyLoader.loadClear(frag, details.encryptedFragments);
            if (keyLoadingPromise) this.log(`[eme] blocking frag load until media-keys acquired`);
        }
        const fragPrevious = this.fragPrevious;
        if ($99a156a15cd35eb3$var$isMediaFragment(frag) && (!fragPrevious || frag.sn !== fragPrevious.sn)) {
            const shouldLoadParts = this.shouldLoadParts(level.details, frag.end);
            if (shouldLoadParts !== this.loadingParts) {
                this.log(`LL-Part loading ${shouldLoadParts ? 'ON' : 'OFF'} loading sn ${fragPrevious == null ? void 0 : fragPrevious.sn}->${frag.sn}`);
                this.loadingParts = shouldLoadParts;
            }
        }
        targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
        if (this.loadingParts && $99a156a15cd35eb3$var$isMediaFragment(frag)) {
            const partList = details.partList;
            if (partList && progressCallback) {
                if (targetBufferTime > frag.end && details.fragmentHint) frag = details.fragmentHint;
                const partIndex = this.getNextPart(partList, frag, targetBufferTime);
                if (partIndex > -1) {
                    const part = partList[partIndex];
                    frag = this.fragCurrent = part.fragment;
                    this.log(`Loading ${frag.type} sn: ${frag.sn} part: ${part.index} (${partIndex}/${partList.length - 1}) of ${this.fragInfo(frag, false, part)}) cc: ${frag.cc} [${details.startSN}-${details.endSN}], target: ${parseFloat(targetBufferTime.toFixed(3))}`);
                    this.nextLoadPosition = part.start + part.duration;
                    this.state = $99a156a15cd35eb3$var$State.FRAG_LOADING;
                    let _result;
                    if (keyLoadingPromise) _result = keyLoadingPromise.then((keyLoadedData)=>{
                        if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
                        return this.doFragPartsLoad(frag, part, level, progressCallback);
                    }).catch((error)=>this.handleFragLoadError(error));
                    else _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch((error)=>this.handleFragLoadError(error));
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, {
                        frag: frag,
                        part: part,
                        targetBufferTime: targetBufferTime
                    });
                    if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
                    return _result;
                } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) // Fragment hint has no parts
                return Promise.resolve(null);
            }
        }
        if ($99a156a15cd35eb3$var$isMediaFragment(frag) && this.loadingParts) {
            this.log(`LL-Part loading OFF after next part miss @${targetBufferTime.toFixed(2)}`);
            this.loadingParts = false;
        } else if (!frag.url) // Selected fragment hint for part but not loading parts
        return Promise.resolve(null);
        this.log(`Loading ${frag.type} sn: ${frag.sn} of ${this.fragInfo(frag, false)}) cc: ${frag.cc} ${details ? '[' + details.startSN + '-' + details.endSN + ']' : ''}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
        // Don't update nextLoadPosition for fragments which are not buffered
        if ($99a156a15cd35eb3$var$isFiniteNumber(frag.sn) && !this.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;
        this.state = $99a156a15cd35eb3$var$State.FRAG_LOADING;
        // Load key before streaming fragment data
        const dataOnProgress = this.config.progressive;
        let result;
        if (dataOnProgress && keyLoadingPromise) result = keyLoadingPromise.then((keyLoadedData)=>{
            if (!keyLoadedData || this.fragContextChanged(keyLoadedData == null ? void 0 : keyLoadedData.frag)) return null;
            return this.fragmentLoader.load(frag, progressCallback);
        }).catch((error)=>this.handleFragLoadError(error));
        else // load unencrypted fragment data with progress event,
        // or handle fragment result after key and fragment are finished loading
        result = Promise.all([
            this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined),
            keyLoadingPromise
        ]).then(([fragLoadedData])=>{
            if (!dataOnProgress && fragLoadedData && progressCallback) progressCallback(fragLoadedData);
            return fragLoadedData;
        }).catch((error)=>this.handleFragLoadError(error));
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, {
            frag: frag,
            targetBufferTime: targetBufferTime
        });
        if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
        return result;
    }
    doFragPartsLoad(frag, fromPart, level, progressCallback) {
        return new Promise((resolve, reject)=>{
            var _level$details;
            const partsLoaded = [];
            const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
            const loadPart = (part)=>{
                this.fragmentLoader.loadPart(frag, part, progressCallback).then((partLoadedData)=>{
                    partsLoaded[part.index] = partLoadedData;
                    const loadedPart = partLoadedData.part;
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, partLoadedData);
                    const nextPart = $99a156a15cd35eb3$var$getPartWith(level.details, frag.sn, part.index + 1) || $99a156a15cd35eb3$var$findPart(initialPartList, frag.sn, part.index + 1);
                    if (nextPart) loadPart(nextPart);
                    else return resolve({
                        frag: frag,
                        part: loadedPart,
                        partsLoaded: partsLoaded
                    });
                }).catch(reject);
            };
            loadPart(fromPart);
        });
    }
    handleFragLoadError(error) {
        if ('data' in error) {
            const data = error.data;
            if (error.data && data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_ABORTED) this.handleFragLoadAborted(data.frag, data.part);
            else this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, data);
        } else this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_EXCEPTION,
            err: error,
            error: error,
            fatal: true
        });
        return null;
    }
    _handleTransmuxerFlush(chunkMeta) {
        const context = this.getCurrentContext(chunkMeta);
        if (!context || this.state !== $99a156a15cd35eb3$var$State.PARSING) {
            if (!this.fragCurrent && this.state !== $99a156a15cd35eb3$var$State.STOPPED && this.state !== $99a156a15cd35eb3$var$State.ERROR) this.state = $99a156a15cd35eb3$var$State.IDLE;
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const now = self.performance.now();
        frag.stats.parsing.end = now;
        if (part) part.stats.parsing.end = now;
        // See if part loading should be disabled/enabled based on buffer and playback position.
        const levelDetails = this.getLevelDetails();
        const loadingPartsAtEdge = levelDetails && frag.sn > levelDetails.endSN;
        const shouldLoadParts = loadingPartsAtEdge || this.shouldLoadParts(levelDetails, frag.end);
        if (shouldLoadParts !== this.loadingParts) {
            this.log(`LL-Part loading ${shouldLoadParts ? 'ON' : 'OFF'} after parsing segment ending @${frag.end.toFixed(2)}`);
            this.loadingParts = shouldLoadParts;
        }
        this.updateLevelTiming(frag, part, level, chunkMeta.partial);
    }
    shouldLoadParts(details, bufferEnd) {
        if (this.config.lowLatencyMode) {
            if (!details) return this.loadingParts;
            if (details != null && details.partList) {
                var _details$fragmentHint;
                // Buffer must be ahead of first part + duration of parts after last segment
                // and playback must be at or past segment adjacent to part list
                const firstPart = details.partList[0];
                const safePartStart = firstPart.end + (((_details$fragmentHint = details.fragmentHint) == null ? void 0 : _details$fragmentHint.duration) || 0);
                if (bufferEnd >= safePartStart) {
                    var _this$media;
                    const playhead = this.hls.hasEnoughToStart ? ((_this$media = this.media) == null ? void 0 : _this$media.currentTime) || this.lastCurrentTime : this.getLoadPosition();
                    if (playhead > firstPart.start - firstPart.fragment.duration) return true;
                }
            }
        }
        return false;
    }
    getCurrentContext(chunkMeta) {
        const { levels: levels, fragCurrent: fragCurrent } = this;
        const { level: levelIndex, sn: sn, part: partIndex } = chunkMeta;
        if (!(levels != null && levels[levelIndex])) {
            this.warn(`Levels object was unset while buffering fragment ${sn} of ${this.playlistLabel()} ${levelIndex}. The current chunk will not be buffered.`);
            return null;
        }
        const level = levels[levelIndex];
        const levelDetails = level.details;
        const part = partIndex > -1 ? $99a156a15cd35eb3$var$getPartWith(levelDetails, sn, partIndex) : null;
        const frag = part ? part.fragment : $99a156a15cd35eb3$var$getFragmentWithSN(levelDetails, sn, fragCurrent);
        if (!frag) return null;
        if (fragCurrent && fragCurrent !== frag) frag.stats = fragCurrent.stats;
        return {
            frag: frag,
            part: part,
            level: level
        };
    }
    bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
        var _buffer;
        if (!data || this.state !== $99a156a15cd35eb3$var$State.PARSING) return;
        const { data1: data1, data2: data2 } = data;
        let buffer = data1;
        if (data1 && data2) // Combine the moof + mdat so that we buffer with a single append
        buffer = $99a156a15cd35eb3$var$appendUint8Array(data1, data2);
        if (!((_buffer = buffer) != null && _buffer.length)) return;
        const segment = {
            type: data.type,
            frag: frag,
            part: part,
            chunkMeta: chunkMeta,
            parent: frag.type,
            data: buffer
        };
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDING, segment);
        if (data.dropped && data.independent && !part) {
            if (noBacktracking) return;
            // Clear buffer so that we reload previous segments sequentially if required
            this.flushBufferGap(frag);
        }
    }
    flushBufferGap(frag) {
        const media = this.media;
        if (!media) return;
        // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
        if (!$99a156a15cd35eb3$var$BufferHelper.isBuffered(media, media.currentTime)) {
            this.flushMainBuffer(0, frag.start);
            return;
        }
        // Remove back-buffer without interrupting playback to allow back tracking
        const currentTime = media.currentTime;
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const fragDuration = frag.duration;
        const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
        const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
        if (frag.start - start > segmentFraction) this.flushMainBuffer(start, frag.start);
    }
    getFwdBufferInfo(bufferable, type) {
        var _this$media2;
        const pos = this.getLoadPosition();
        if (!$99a156a15cd35eb3$var$isFiniteNumber(pos)) return null;
        const backwardSeek = this.lastCurrentTime > pos;
        const maxBufferHole = backwardSeek || (_this$media2 = this.media) != null && _this$media2.paused ? 0 : this.config.maxBufferHole;
        return this.getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole);
    }
    getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole) {
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
        // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
        if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
            const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
            if (bufferedFragAtPos && (bufferInfo.nextStart <= bufferedFragAtPos.end || bufferedFragAtPos.gap)) {
                const gapDuration = Math.max(Math.min(bufferInfo.nextStart, bufferedFragAtPos.end) - pos, maxBufferHole);
                return $99a156a15cd35eb3$var$BufferHelper.bufferInfo(bufferable, pos, gapDuration);
            }
        }
        return bufferInfo;
    }
    getMaxBufferLength(levelBitrate) {
        const { config: config } = this;
        let maxBufLen;
        if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
        else maxBufLen = config.maxBufferLength;
        return Math.min(maxBufLen, config.maxMaxBufferLength);
    }
    reduceMaxBufferLength(threshold, fragDuration) {
        const config = this.config;
        const minLength = Math.max(Math.min(threshold - fragDuration, config.maxBufferLength), fragDuration);
        const reducedLength = Math.max(threshold - fragDuration * 3, config.maxMaxBufferLength / 2, minLength);
        if (reducedLength >= minLength) {
            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
            config.maxMaxBufferLength = reducedLength;
            this.warn(`Reduce max buffer length to ${reducedLength}s`);
            return true;
        }
        return false;
    }
    getAppendedFrag(position, playlistType = $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN) {
        var _this$fragmentTracker;
        const fragOrPart = (_this$fragmentTracker = this.fragmentTracker) == null ? void 0 : _this$fragmentTracker.getAppendedFrag(position, playlistType);
        if (fragOrPart && 'fragment' in fragOrPart) return fragOrPart.fragment;
        return fragOrPart;
    }
    getNextFragment(pos, levelDetails) {
        const fragments = levelDetails.fragments;
        const fragLen = fragments.length;
        if (!fragLen) return null;
        // find fragment index, contiguous with end of buffer position
        const { config: config } = this;
        const start = fragments[0].start;
        const canLoadParts = config.lowLatencyMode && !!levelDetails.partList;
        let frag = null;
        if (levelDetails.live) {
            const initialLiveManifestSize = config.initialLiveManifestSize;
            if (fragLen < initialLiveManifestSize) {
                this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
                return null;
            }
            // The real fragment start times for a live stream are only known after the PTS range for that level is known.
            // In order to discover the range, we load the best matching fragment for that level and demux it.
            // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
            // we get the fragment matching that start time
            if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < start) {
                var _frag;
                if (canLoadParts && !this.loadingParts) {
                    this.log(`LL-Part loading ON for initial live fragment`);
                    this.loadingParts = true;
                }
                frag = this.getInitialLiveFragment(levelDetails);
                const mainStart = this.hls.startPosition;
                const liveSyncPosition = this.hls.liveSyncPosition;
                const startPosition = frag ? (mainStart !== -1 && mainStart >= start ? mainStart : liveSyncPosition) || frag.start : pos;
                this.log(`Setting startPosition to ${startPosition} to match start frag at live edge. mainStart: ${mainStart} liveSyncPosition: ${liveSyncPosition} frag.start: ${(_frag = frag) == null ? void 0 : _frag.start}`);
                this.startPosition = this.nextLoadPosition = startPosition;
            }
        } else if (pos <= start) // VoD playlist: if loadPosition before start of playlist, load first fragment
        frag = fragments[0];
        // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
        if (!frag) {
            const end = this.loadingParts ? levelDetails.partEnd : levelDetails.fragmentEnd;
            frag = this.getFragmentAtPosition(pos, end, levelDetails);
        }
        let programFrag = this.filterReplacedPrimary(frag, levelDetails);
        if (!programFrag && frag) {
            const curSNIdx = frag.sn - levelDetails.startSN;
            programFrag = this.filterReplacedPrimary(fragments[curSNIdx + 1] || null, levelDetails);
        }
        return this.mapToInitFragWhenRequired(programFrag);
    }
    isLoopLoading(frag, targetBufferTime) {
        const trackerState = this.fragmentTracker.getState(frag);
        return (trackerState === $99a156a15cd35eb3$var$FragmentState.OK || trackerState === $99a156a15cd35eb3$var$FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
    }
    getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
        let nextFragment = null;
        if (frag.gap) {
            nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
            if (nextFragment && !nextFragment.gap && bufferInfo.nextStart) {
                // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
                const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType, 0);
                if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
                    // Returning here might result in not finding an audio and video candiate to skip to
                    const sn = nextFragment.sn;
                    if (this.loopSn !== sn) {
                        this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${sn}`);
                        this.loopSn = sn;
                    }
                    return null;
                }
            }
        }
        this.loopSn = undefined;
        return nextFragment;
    }
    get primaryPrefetch() {
        if ($99a156a15cd35eb3$var$interstitialsEnabled(this.hls.config)) {
            var _this$hls$interstitia, _this$hls$interstitia2;
            const playingInterstitial = (_this$hls$interstitia = this.hls.interstitialsManager) == null ? void 0 : (_this$hls$interstitia2 = _this$hls$interstitia.playingItem) == null ? void 0 : _this$hls$interstitia2.event;
            if (playingInterstitial) return true;
        }
        return false;
    }
    filterReplacedPrimary(frag, details) {
        if (!frag) return frag;
        if ($99a156a15cd35eb3$var$interstitialsEnabled(this.hls.config) && frag.type !== $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE) {
            // Do not load fragments outside the buffering schedule segment
            const interstitials = this.hls.interstitialsManager;
            const bufferingItem = interstitials == null ? void 0 : interstitials.bufferingItem;
            if (bufferingItem) {
                const bufferingInterstitial = bufferingItem.event;
                if (bufferingInterstitial) {
                    // Do not stream fragments while buffering Interstitial Events (except for overlap at the start)
                    if (bufferingInterstitial.appendInPlace || Math.abs(frag.start - bufferingItem.start) > 1 || bufferingItem.start === 0) return null;
                } else {
                    // Limit fragment loading to media in schedule item
                    if (frag.end <= bufferingItem.start && (details == null ? void 0 : details.live) === false) // fragment ends by schedule item start
                    // this.fragmentTracker.fragBuffered(frag, true);
                    return null;
                    if (frag.start > bufferingItem.end && bufferingItem.nextEvent) {
                        // fragment is past schedule item end
                        // allow some overflow when not appending in place to prevent stalls
                        if (bufferingItem.nextEvent.appendInPlace || frag.start - bufferingItem.end > 1) return null;
                    }
                }
            }
            // Skip loading of fragments that overlap completely with appendInPlace interstitials
            const playerQueue = interstitials == null ? void 0 : interstitials.playerQueue;
            if (playerQueue) for(let i = playerQueue.length; i--;){
                const interstitial = playerQueue[i].interstitial;
                if (interstitial.appendInPlace && frag.start >= interstitial.startTime && frag.end <= interstitial.resumeTime) return null;
            }
        }
        return frag;
    }
    mapToInitFragWhenRequired(frag) {
        // If an initSegment is present, it must be buffered first
        if (frag != null && frag.initSegment && !(frag != null && frag.initSegment.data) && !this.bitrateTest) return frag.initSegment;
        return frag;
    }
    getNextPart(partList, frag, targetBufferTime) {
        let nextPart = -1;
        let contiguous = false;
        let independentAttrOmitted = true;
        for(let i = 0, len = partList.length; i < len; i++){
            const part = partList[i];
            independentAttrOmitted = independentAttrOmitted && !part.independent;
            if (nextPart > -1 && targetBufferTime < part.start) break;
            const loaded = part.loaded;
            if (loaded) nextPart = -1;
            else if ((contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) nextPart = i;
            contiguous = loaded;
        }
        return nextPart;
    }
    loadedEndOfParts(partList, targetBufferTime) {
        const lastPart = partList[partList.length - 1];
        return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
    }
    /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */ getInitialLiveFragment(levelDetails) {
        const fragments = levelDetails.fragments;
        const fragPrevious = this.fragPrevious;
        let frag = null;
        if (fragPrevious) {
            if (levelDetails.hasProgramDateTime) {
                // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
                this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
                frag = $99a156a15cd35eb3$var$findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
            }
            if (!frag) {
                // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
                const targetSN = fragPrevious.sn + 1;
                if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                    const fragNext = fragments[targetSN - levelDetails.startSN];
                    // Ensure that we're staying within the continuity range, since PTS resets upon a new range
                    if (fragPrevious.cc === fragNext.cc) {
                        frag = fragNext;
                        this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
                    }
                }
                // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
                // will have the wrong start times
                if (!frag) {
                    frag = $99a156a15cd35eb3$var$findNearestWithCC(levelDetails, fragPrevious.cc, fragPrevious.end);
                    if (frag) this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
                }
            }
        } else {
            // Find a new start fragment when fragPrevious is null
            const liveStart = this.hls.liveSyncPosition;
            if (liveStart !== null) frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
        }
        return frag;
    }
    /*
  This method finds the best matching fragment given the provided position.
   */ getFragmentAtPosition(bufferEnd, end, levelDetails) {
        const { config: config } = this;
        let { fragPrevious: fragPrevious } = this;
        let { fragments: fragments, endSN: endSN } = levelDetails;
        const { fragmentHint: fragmentHint } = levelDetails;
        const { maxFragLookUpTolerance: maxFragLookUpTolerance } = config;
        const partList = levelDetails.partList;
        const loadingParts = !!(this.loadingParts && partList != null && partList.length && fragmentHint);
        if (loadingParts && fragmentHint && !this.bitrateTest && partList[partList.length - 1].fragment.sn === fragmentHint.sn) {
            // Include incomplete fragment with parts at end
            fragments = fragments.concat(fragmentHint);
            endSN = fragmentHint.sn;
        }
        let frag;
        if (bufferEnd < end) {
            var _this$media3;
            const backwardSeek = bufferEnd < this.lastCurrentTime;
            const lookupTolerance = backwardSeek || bufferEnd > end - maxFragLookUpTolerance || (_this$media3 = this.media) != null && _this$media3.paused || !this.startFragRequested ? 0 : maxFragLookUpTolerance;
            // Remove the tolerance if it would put the bufferEnd past the actual end of stream
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            frag = $99a156a15cd35eb3$var$findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
        } else // reach end of playlist
        frag = fragments[fragments.length - 1];
        if (frag) {
            const curSNIdx = frag.sn - levelDetails.startSN;
            // Move fragPrevious forward to support forcing the next fragment to load
            // when the buffer catches up to a previously buffered range.
            const fragState = this.fragmentTracker.getState(frag);
            if (fragState === $99a156a15cd35eb3$var$FragmentState.OK || fragState === $99a156a15cd35eb3$var$FragmentState.PARTIAL && frag.gap) fragPrevious = frag;
            if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn || !levelDetails.live && !loadingParts)) {
                // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
                // non-uniform fragment durations
                const sameLevel = fragPrevious && frag.level === fragPrevious.level;
                if (sameLevel) {
                    const nextFrag = fragments[curSNIdx + 1];
                    if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== $99a156a15cd35eb3$var$FragmentState.OK) frag = nextFrag;
                    else frag = null;
                }
            }
        }
        return frag;
    }
    alignPlaylists(details, previousDetails, switchDetails) {
        // TODO: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
        //  this could all go in level-helper mergeDetails()
        const length = details.fragments.length;
        if (!length) {
            this.warn(`No fragments in live playlist`);
            return 0;
        }
        const slidingStart = details.fragmentStart;
        const firstLevelLoad = !previousDetails;
        const aligned = details.alignedSliding && $99a156a15cd35eb3$var$isFiniteNumber(slidingStart);
        if (firstLevelLoad || !aligned && !slidingStart) {
            $99a156a15cd35eb3$var$alignStream(switchDetails, details);
            const alignedSlidingStart = details.fragmentStart;
            this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} fragments: ${length}`);
            return alignedSlidingStart;
        }
        return slidingStart;
    }
    waitForCdnTuneIn(details) {
        // Wait for Low-Latency CDN Tune-in to get an updated playlist
        const advancePartLimit = 3;
        return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
    }
    setStartPosition(details, sliding) {
        // compute start position if set to -1. use it straight away if value is defined
        let startPosition = this.startPosition;
        if (startPosition < sliding) startPosition = -1;
        const timelineOffset = this.timelineOffset;
        if (startPosition === -1) {
            // Use Playlist EXT-X-START:TIME-OFFSET when set
            // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
            const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
            const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
            if (startTimeOffset !== null && $99a156a15cd35eb3$var$isFiniteNumber(startTimeOffset)) {
                startPosition = sliding + startTimeOffset;
                if (startTimeOffset < 0) startPosition += details.edge;
                startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
                this.log(`Setting startPosition to ${startPosition} for start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist`);
                this.startPosition = startPosition;
            } else if (details.live) {
                // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
                // not been specified via the config or an as an argument to startLoad (#3736).
                startPosition = this.hls.liveSyncPosition || sliding;
                this.log(`Setting startPosition to -1 to start at live edge ${startPosition}`);
                this.startPosition = -1;
            } else {
                this.log(`setting startPosition to 0 by default`);
                this.startPosition = startPosition = 0;
            }
            this.lastCurrentTime = startPosition + timelineOffset;
        }
        this.nextLoadPosition = startPosition + timelineOffset;
    }
    getLoadPosition() {
        var _this$hls;
        const { media: media } = this;
        // if we have not yet loaded any fragment, start loading from start position
        let pos = 0;
        if ((_this$hls = this.hls) != null && _this$hls.hasEnoughToStart && media) pos = media.currentTime;
        else if (this.nextLoadPosition >= 0) pos = this.nextLoadPosition;
        return pos;
    }
    handleFragLoadAborted(frag, part) {
        if (this.transmuxer && frag.type === this.playlistType && $99a156a15cd35eb3$var$isMediaFragment(frag) && frag.stats.aborted) {
            this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of ${this.playlistLabel()} ${frag.level} was aborted`);
            this.resetFragmentLoading(frag);
        }
    }
    resetFragmentLoading(frag) {
        if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== $99a156a15cd35eb3$var$State.FRAG_LOADING_WAITING_RETRY) this.state = $99a156a15cd35eb3$var$State.IDLE;
    }
    onFragmentOrKeyLoadError(filterType, data) {
        if (data.chunkMeta && !data.frag) {
            const context = this.getCurrentContext(data.chunkMeta);
            if (context) data.frag = context.frag;
        }
        const frag = data.frag;
        // Handle frag error related to caller's filterType
        if (!frag || frag.type !== filterType || !this.levels) return;
        if (this.fragContextChanged(frag)) {
            var _this$fragCurrent;
            this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.url}`);
            return;
        }
        const gapTagEncountered = data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP;
        if (gapTagEncountered) this.fragmentTracker.fragBuffered(frag, true);
        // keep retrying until the limit will be reached
        const errorAction = data.errorAction;
        const { action: action, flags: flags, retryCount: retryCount = 0, retryConfig: retryConfig } = errorAction || {};
        const couldRetry = !!errorAction && !!retryConfig;
        const retry = couldRetry && action === $99a156a15cd35eb3$export$679390c50dd617e4.RetryRequest;
        const noAlternate = couldRetry && !errorAction.resolved && flags === $99a156a15cd35eb3$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost;
        if (!retry && noAlternate && $99a156a15cd35eb3$var$isMediaFragment(frag) && !frag.endList) {
            this.resetFragmentErrors(filterType);
            this.treatAsGap(frag);
            errorAction.resolved = true;
        } else if ((retry || noAlternate) && retryCount < retryConfig.maxNumRetry) {
            this.resetStartWhenNotLoaded(this.levelLastLoaded);
            const delay = $99a156a15cd35eb3$var$getRetryDelay(retryConfig, retryCount);
            this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
            errorAction.resolved = true;
            this.retryDate = self.performance.now() + delay;
            this.state = $99a156a15cd35eb3$var$State.FRAG_LOADING_WAITING_RETRY;
        } else if (retryConfig && errorAction) {
            this.resetFragmentErrors(filterType);
            if (retryCount < retryConfig.maxNumRetry) // Network retry is skipped when level switch is preferred
            {
                if (!gapTagEncountered && action !== $99a156a15cd35eb3$export$679390c50dd617e4.RemoveAlternatePermanently) errorAction.resolved = true;
            } else {
                this.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
                return;
            }
        } else if (action === $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox) this.state = $99a156a15cd35eb3$var$State.WAITING_LEVEL;
        else this.state = $99a156a15cd35eb3$var$State.ERROR;
        // Perform next async tick sooner to speed up error action resolution
        this.tickImmediate();
    }
    reduceLengthAndFlushBuffer(data) {
        // if in appending state
        if (this.state === $99a156a15cd35eb3$var$State.PARSING || this.state === $99a156a15cd35eb3$var$State.PARSED) {
            const frag = data.frag;
            const playlistType = data.parent;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
            // reduce max buf len if current position is buffered
            const buffered = bufferedInfo && bufferedInfo.len > 0.5;
            if (buffered) this.reduceMaxBufferLength(bufferedInfo.len, (frag == null ? void 0 : frag.duration) || 10);
            const flushBuffer = !buffered;
            if (flushBuffer) // current position is not buffered, but browser is still complaining about buffer full error
            // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
            // in that case flush the whole audio buffer to recover
            this.warn(`Buffer full error while media.currentTime is not buffered, flush ${playlistType} buffer`);
            if (frag) {
                this.fragmentTracker.removeFragment(frag);
                this.nextLoadPosition = frag.start;
            }
            this.resetLoadingState();
            return flushBuffer;
        }
        return false;
    }
    resetFragmentErrors(filterType) {
        if (filterType === $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO) // Reset current fragment since audio track audio is essential and may not have a fail-over track
        this.fragCurrent = null;
        // Fragment errors that result in a level switch or redundant fail-over
        // should reset the stream controller state to idle
        if (!this.hls.hasEnoughToStart) this.startFragRequested = false;
        if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.state = $99a156a15cd35eb3$var$State.IDLE;
    }
    afterBufferFlushed(media, bufferType, playlistType) {
        if (!media) return;
        // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
        // (so that we will check against video.buffered ranges in case of alt audio track)
        const bufferedTimeRanges = $99a156a15cd35eb3$var$BufferHelper.getBuffered(media);
        this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
        if (this.state === $99a156a15cd35eb3$var$State.ENDED) this.resetLoadingState();
    }
    resetLoadingState() {
        this.log('Reset loading state');
        this.fragCurrent = null;
        this.fragPrevious = null;
        if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.state = $99a156a15cd35eb3$var$State.IDLE;
    }
    resetStartWhenNotLoaded(level) {
        // if loadedmetadata is not set, it means that first frag request failed
        // in that case, reset startFragRequested flag
        if (!this.hls.hasEnoughToStart) {
            this.startFragRequested = false;
            const details = level ? level.details : null;
            if (details != null && details.live) {
                // Update the start position and return to IDLE to recover live start
                this.log(`resetting startPosition for live start`);
                this.startPosition = -1;
                this.setStartPosition(details, details.fragmentStart);
                this.resetLoadingState();
            } else this.nextLoadPosition = this.startPosition;
        }
    }
    resetWhenMissingContext(chunkMeta) {
        this.warn(`The loading context changed while buffering fragment ${chunkMeta.sn} of ${this.playlistLabel()} ${chunkMeta.level}. This chunk will not be buffered.`);
        this.removeUnbufferedFrags();
        this.resetStartWhenNotLoaded(this.levelLastLoaded);
        this.resetLoadingState();
    }
    removeUnbufferedFrags(start = 0) {
        this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
    }
    updateLevelTiming(frag, part, level, partial) {
        const details = level.details;
        if (!details) {
            this.warn('level.details undefined');
            return;
        }
        const parsed = Object.keys(frag.elementaryStreams).reduce((result, type)=>{
            const info = frag.elementaryStreams[type];
            if (info) {
                const parsedDuration = info.endPTS - info.startPTS;
                if (parsedDuration <= 0) {
                    // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
                    // The new transmuxer will be configured with a time offset matching the next fragment start,
                    // preventing the timeline from shifting.
                    this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
                    return result || false;
                }
                const drift = partial ? 0 : $99a156a15cd35eb3$var$updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_PTS_UPDATED, {
                    details: details,
                    level: level,
                    drift: drift,
                    type: type,
                    frag: frag,
                    start: info.startPTS,
                    end: info.endPTS
                });
                return true;
            }
            return result;
        }, false);
        if (!parsed) {
            var _this$transmuxer;
            if (level.fragmentError === 0) // Mark and track the odd empty segment as a gap to avoid reloading
            this.treatAsGap(frag, level);
            if (((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null) {
                const error = new Error(`Found no media in fragment ${frag.sn} of ${this.playlistLabel()} ${frag.level} resetting transmuxer to fallback to playlist timing`);
                this.warn(error.message);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
                    fatal: false,
                    error: error,
                    frag: frag,
                    reason: `Found no media in msn ${frag.sn} of ${this.playlistLabel()} "${level.url}"`
                });
                if (!this.hls) return;
                this.resetTransmuxer();
            }
        // For this error fallthrough. Marking parsed will allow advancing to next fragment.
        }
        this.state = $99a156a15cd35eb3$var$State.PARSED;
        this.log(`Parsed ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.fragInfo(frag, false, part)})`);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSED, {
            frag: frag,
            part: part
        });
    }
    playlistLabel() {
        return this.playlistType === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN ? 'level' : 'track';
    }
    fragInfo(frag, pts = true, part) {
        var _ref, _ref2;
        return `${this.playlistLabel()} ${frag.level} (${part ? 'part' : 'frag'}:[${((_ref = pts && !part ? frag.startPTS : (part || frag).start) != null ? _ref : NaN).toFixed(3)}-${((_ref2 = pts && !part ? frag.endPTS : (part || frag).end) != null ? _ref2 : NaN).toFixed(3)}]${part && frag.type === 'main' ? 'INDEPENDENT=' + (part.independent ? 'YES' : 'NO') : ''}`;
    }
    treatAsGap(frag, level) {
        if (level) level.fragmentError++;
        frag.gap = true;
        this.fragmentTracker.removeFragment(frag);
        this.fragmentTracker.fragBuffered(frag, true);
    }
    resetTransmuxer() {
        var _this$transmuxer2;
        (_this$transmuxer2 = this.transmuxer) == null || _this$transmuxer2.reset();
    }
    recoverWorkerError(data) {
        if (data.event === 'demuxerWorker') {
            this.fragmentTracker.removeAllFragments();
            if (this.transmuxer) {
                this.transmuxer.destroy();
                this.transmuxer = null;
            }
            this.resetStartWhenNotLoaded(this.levelLastLoaded);
            this.resetLoadingState();
        }
    }
    set state(nextState) {
        const previousState = this._state;
        if (previousState !== nextState) {
            this._state = nextState;
            this.log(`${previousState}->${nextState}`);
        }
    }
    get state() {
        return this._state;
    }
}
function $99a156a15cd35eb3$var$interstitialsEnabled(config) {
    return !!config.interstitialsController && config.enableInterstitialPlayback !== false;
}
class $99a156a15cd35eb3$var$ChunkCache {
    constructor(){
        this.chunks = [];
        this.dataLength = 0;
    }
    push(chunk) {
        this.chunks.push(chunk);
        this.dataLength += chunk.length;
    }
    flush() {
        const { chunks: chunks, dataLength: dataLength } = this;
        let result;
        if (!chunks.length) return new Uint8Array(0);
        else if (chunks.length === 1) result = chunks[0];
        else result = $99a156a15cd35eb3$var$concatUint8Arrays(chunks, dataLength);
        this.reset();
        return result;
    }
    reset() {
        this.chunks.length = 0;
        this.dataLength = 0;
    }
}
function $99a156a15cd35eb3$var$concatUint8Arrays(chunks, dataLength) {
    const result = new Uint8Array(dataLength);
    let offset = 0;
    for(let i = 0; i < chunks.length; i++){
        const chunk = chunks[i];
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result;
}
var $99a156a15cd35eb3$var$eventemitter3 = {
    exports: {}
};
var $99a156a15cd35eb3$var$hasRequiredEventemitter3;
function $99a156a15cd35eb3$var$requireEventemitter3() {
    if ($99a156a15cd35eb3$var$hasRequiredEventemitter3) return $99a156a15cd35eb3$var$eventemitter3.exports;
    $99a156a15cd35eb3$var$hasRequiredEventemitter3 = 1;
    (function(module) {
        var has = Object.prototype.hasOwnProperty, prefix = '~';
        /**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */ function Events() {}
        //
        // We try to not inherit from `Object.prototype`. In some engines creating an
        // instance in this way is faster than calling `Object.create(null)` directly.
        // If `Object.create(null)` is not supported we prefix the event names with a
        // character to make sure that the built-in object properties are not
        // overridden or used as an attack vector.
        //
        if (Object.create) {
            Events.prototype = Object.create(null);
            //
            // This hack is needed because the `__proto__` property is still inherited in
            // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
            //
            if (!new Events().__proto__) prefix = false;
        }
        /**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */ function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
        }
        /**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */ function addListener(emitter, event, fn, context, once) {
            if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
            else emitter._events[evt] = [
                emitter._events[evt],
                listener
            ];
            return emitter;
        }
        /**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */ function clearEvent(emitter, evt) {
            if (--emitter._eventsCount === 0) emitter._events = new Events();
            else delete emitter._events[evt];
        }
        /**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */ function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
        }
        /**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */ EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0) return names;
            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
            return names;
        };
        /**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */ EventEmitter.prototype.listeners = function listeners(event) {
            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
            if (!handlers) return [];
            if (handlers.fn) return [
                handlers.fn
            ];
            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
            return ee;
        };
        /**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
            if (!listeners) return 0;
            if (listeners.fn) return 1;
            return listeners.length;
        };
        /**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
                if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                switch(len){
                    case 1:
                        return listeners.fn.call(listeners.context), true;
                    case 2:
                        return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                        return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                }
                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                listeners.fn.apply(listeners.context, args);
            } else {
                var length = listeners.length, j;
                for(i = 0; i < length; i++){
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                    switch(len){
                        case 1:
                            listeners[i].fn.call(listeners[i].context);
                            break;
                        case 2:
                            listeners[i].fn.call(listeners[i].context, a1);
                            break;
                        case 3:
                            listeners[i].fn.call(listeners[i].context, a1, a2);
                            break;
                        case 4:
                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                            break;
                        default:
                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                            listeners[i].fn.apply(listeners[i].context, args);
                    }
                }
            }
            return true;
        };
        /**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.on = function on(event, fn, context) {
            return addListener(this, event, fn, context, false);
        };
        /**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.once = function once(event, fn, context) {
            return addListener(this, event, fn, context, true);
        };
        /**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return this;
            if (!fn) {
                clearEvent(this, evt);
                return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
            } else {
                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                //
                // Reset the array, or remove it completely if we have no more listeners.
                //
                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                else clearEvent(this, evt);
            }
            return this;
        };
        /**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
                evt = prefix ? prefix + event : event;
                if (this._events[evt]) clearEvent(this, evt);
            } else {
                this._events = new Events();
                this._eventsCount = 0;
            }
            return this;
        };
        //
        // Alias methods names because people roll like that.
        //
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.addListener = EventEmitter.prototype.on;
        //
        // Expose the prefix.
        //
        EventEmitter.prefixed = prefix;
        //
        // Allow `EventEmitter` to be imported as module namespace.
        //
        EventEmitter.EventEmitter = EventEmitter;
        module.exports = EventEmitter;
    })($99a156a15cd35eb3$var$eventemitter3);
    return $99a156a15cd35eb3$var$eventemitter3.exports;
}
var $99a156a15cd35eb3$var$eventemitter3Exports = $99a156a15cd35eb3$var$requireEventemitter3();
var $99a156a15cd35eb3$var$EventEmitter = /*@__PURE__*/ $99a156a15cd35eb3$var$getDefaultExportFromCjs($99a156a15cd35eb3$var$eventemitter3Exports);
const $99a156a15cd35eb3$var$version = "1.6.5";
// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
const $99a156a15cd35eb3$var$workerStore = {};
function $99a156a15cd35eb3$var$hasUMDWorker() {
    return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function $99a156a15cd35eb3$var$injectWorker() {
    const workerContext = $99a156a15cd35eb3$var$workerStore[$99a156a15cd35eb3$var$version];
    if (workerContext) {
        workerContext.clientCount++;
        return workerContext;
    }
    const blob = new self.Blob([
        `var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`
    ], {
        type: 'text/javascript'
    });
    const objectURL = self.URL.createObjectURL(blob);
    const worker = new self.Worker(objectURL);
    const result = {
        worker: worker,
        objectURL: objectURL,
        clientCount: 1
    };
    $99a156a15cd35eb3$var$workerStore[$99a156a15cd35eb3$var$version] = result;
    return result;
}
function $99a156a15cd35eb3$var$loadWorker(path) {
    const workerContext = $99a156a15cd35eb3$var$workerStore[path];
    if (workerContext) {
        workerContext.clientCount++;
        return workerContext;
    }
    const scriptURL = new self.URL(path, self.location.href).href;
    const worker = new self.Worker(scriptURL);
    const result = {
        worker: worker,
        scriptURL: scriptURL,
        clientCount: 1
    };
    $99a156a15cd35eb3$var$workerStore[path] = result;
    return result;
}
function $99a156a15cd35eb3$var$removeWorkerFromStore(path) {
    const workerContext = $99a156a15cd35eb3$var$workerStore[path || $99a156a15cd35eb3$var$version];
    if (workerContext) {
        const clientCount = workerContext.clientCount--;
        if (clientCount === 1) {
            const { worker: worker, objectURL: objectURL } = workerContext;
            delete $99a156a15cd35eb3$var$workerStore[path || $99a156a15cd35eb3$var$version];
            if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
            worker.terminate();
        }
    }
}
/**
 * Returns true if an ID3 footer can be found at offset in data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns `true` if an ID3 footer is found
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$isId3Footer(data, offset) {
    /*
   * The footer is a copy of the header, but with a different identifier
   */ if (offset + 10 <= data.length) {
        // look for '3DI' identifier
        if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
}
/**
 * Returns true if an ID3 header can be found at offset in data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns `true` if an ID3 header is found
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$isId3Header(data, offset) {
    /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */ if (offset + 10 <= data.length) {
        // look for 'ID3' identifier
        if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
}
/**
 * Read ID3 size
 *
 * @param data - The data to read from
 * @param offset - The offset at which to start reading
 *
 * @returns The size
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$readId3Size(data, offset) {
    let size = 0;
    size = (data[offset] & 0x7f) << 21;
    size |= (data[offset + 1] & 0x7f) << 14;
    size |= (data[offset + 2] & 0x7f) << 7;
    size |= data[offset + 3] & 0x7f;
    return size;
}
/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns The block of data containing any ID3 tags found
 * or `undefined` if no header is found at the starting offset
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$getId3Data(data, offset) {
    const front = offset;
    let length = 0;
    while($99a156a15cd35eb3$var$isId3Header(data, offset)){
        // ID3 header is 10 bytes
        length += 10;
        const size = $99a156a15cd35eb3$var$readId3Size(data, offset + 6);
        length += size;
        if ($99a156a15cd35eb3$var$isId3Footer(data, offset + 10)) // ID3 footer is 10 bytes
        length += 10;
        offset += length;
    }
    if (length > 0) return data.subarray(front, front + length);
    return undefined;
}
function $99a156a15cd35eb3$var$getAudioConfig(observer, data, offset, manifestCodec) {
    const adtsSamplingRates = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    const byte2 = data[offset + 2];
    const adtsSamplingIndex = byte2 >> 2 & 0xf;
    if (adtsSamplingIndex > 12) {
        const error = new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
        observer.emit($99a156a15cd35eb3$export$ada873a34909da65.ERROR, $99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
            fatal: true,
            error: error,
            reason: error.message
        });
        return;
    }
    // MPEG-4 Audio Object Type (profile_ObjectType+1)
    const adtsObjectType = (byte2 >> 6 & 0x3) + 1;
    const channelCount = data[offset + 3] >> 6 & 0x3 | (byte2 & 1) << 2;
    const codec = 'mp4a.40.' + adtsObjectType;
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO/IEC 14496-3 - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */ // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    const samplerate = adtsSamplingRates[adtsSamplingIndex];
    let aacSampleIndex = adtsSamplingIndex;
    if (adtsObjectType === 5 || adtsObjectType === 29) // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
    // there is a factor 2 between frame sample rate and output sample rate
    // multiply frequency by 2 (see table above, equivalent to substract 3)
    aacSampleIndex -= 3;
    const config = [
        adtsObjectType << 3 | (aacSampleIndex & 0x0e) >> 1,
        (aacSampleIndex & 0x01) << 7 | channelCount << 3
    ];
    $99a156a15cd35eb3$var$logger.log(`manifest codec:${manifestCodec}, parsed codec:${codec}, channels:${channelCount}, rate:${samplerate} (ADTS object type:${adtsObjectType} sampling index:${adtsSamplingIndex})`);
    return {
        config: config,
        samplerate: samplerate,
        channelCount: channelCount,
        codec: codec,
        parsedCodec: codec,
        manifestCodec: manifestCodec
    };
}
function $99a156a15cd35eb3$var$isHeaderPattern$1(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function $99a156a15cd35eb3$var$getHeaderLength(data, offset) {
    return data[offset + 1] & 0x01 ? 7 : 9;
}
function $99a156a15cd35eb3$var$getFullFrameLength(data, offset) {
    return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function $99a156a15cd35eb3$var$canGetFrameLength(data, offset) {
    return offset + 5 < data.length;
}
function $99a156a15cd35eb3$var$isHeader$1(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    return offset + 1 < data.length && $99a156a15cd35eb3$var$isHeaderPattern$1(data, offset);
}
function $99a156a15cd35eb3$var$canParse$1(data, offset) {
    return $99a156a15cd35eb3$var$canGetFrameLength(data, offset) && $99a156a15cd35eb3$var$isHeaderPattern$1(data, offset) && $99a156a15cd35eb3$var$getFullFrameLength(data, offset) <= data.length - offset;
}
function $99a156a15cd35eb3$var$probe$1(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if ($99a156a15cd35eb3$var$isHeader$1(data, offset)) {
        // ADTS header Length
        const headerLength = $99a156a15cd35eb3$var$getHeaderLength(data, offset);
        if (offset + headerLength >= data.length) return false;
        // ADTS frame Length
        const frameLength = $99a156a15cd35eb3$var$getFullFrameLength(data, offset);
        if (frameLength <= headerLength) return false;
        const newOffset = offset + frameLength;
        return newOffset === data.length || $99a156a15cd35eb3$var$isHeader$1(data, newOffset);
    }
    return false;
}
function $99a156a15cd35eb3$var$initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
        const config = $99a156a15cd35eb3$var$getAudioConfig(observer, data, offset, audioCodec);
        if (!config) return;
        $99a156a15cd35eb3$var$_extends(track, config);
    }
}
function $99a156a15cd35eb3$var$getFrameDuration(samplerate) {
    return 92160000 / samplerate;
}
function $99a156a15cd35eb3$var$parseFrameHeader(data, offset) {
    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    const headerLength = $99a156a15cd35eb3$var$getHeaderLength(data, offset);
    if (offset + headerLength <= data.length) {
        // retrieve frame size
        const frameLength = $99a156a15cd35eb3$var$getFullFrameLength(data, offset) - headerLength;
        if (frameLength > 0) // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
        return {
            headerLength: headerLength,
            frameLength: frameLength
        };
    }
}
function $99a156a15cd35eb3$var$appendFrame$2(track, data, offset, pts, frameIndex) {
    const frameDuration = $99a156a15cd35eb3$var$getFrameDuration(track.samplerate);
    const stamp = pts + frameIndex * frameDuration;
    const header = $99a156a15cd35eb3$var$parseFrameHeader(data, offset);
    let unit;
    if (header) {
        const { frameLength: frameLength, headerLength: headerLength } = header;
        const _length = headerLength + frameLength;
        const missing = Math.max(0, offset + _length - data.length);
        // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
        if (missing) {
            unit = new Uint8Array(_length - headerLength);
            unit.set(data.subarray(offset + headerLength, data.length), 0);
        } else unit = data.subarray(offset + headerLength, offset + _length);
        const _sample = {
            unit: unit,
            pts: stamp
        };
        if (!missing) track.samples.push(_sample);
        return {
            sample: _sample,
            length: _length,
            missing: missing
        };
    }
    // overflow incomplete header
    const length = data.length - offset;
    unit = new Uint8Array(length);
    unit.set(data.subarray(offset, data.length), 0);
    const sample = {
        unit: unit,
        pts: stamp
    };
    return {
        sample: sample,
        length: length,
        missing: -1
    };
}
/**
 * Checks if the given data contains an ID3 tag.
 *
 * @param data - The data to check
 * @param offset - The offset at which to start checking
 *
 * @returns `true` if an ID3 tag is found
 *
 * @group ID3
 *
 * @beta
 */ function $99a156a15cd35eb3$var$canParseId3(data, offset) {
    return $99a156a15cd35eb3$var$isId3Header(data, offset) && $99a156a15cd35eb3$var$readId3Size(data, offset + 6) + 10 <= data.length - offset;
}
function $99a156a15cd35eb3$var$toArrayBuffer(view) {
    if (view instanceof ArrayBuffer) return view;
    else {
        if (view.byteOffset == 0 && view.byteLength == view.buffer.byteLength) // This is a TypedArray over the whole buffer.
        return view.buffer;
        // This is a 'view' on the buffer.  Create a new buffer that only contains
        // the data.  Note that since this isn't an ArrayBuffer, the 'new' call
        // will allocate a new buffer to hold the copy.
        return new Uint8Array(view).buffer;
    }
}
function $99a156a15cd35eb3$var$toUint8(data, offset = 0, length = Infinity) {
    return $99a156a15cd35eb3$var$view(data, offset, length, Uint8Array);
}
function $99a156a15cd35eb3$var$view(data, offset, length, Type) {
    const buffer = $99a156a15cd35eb3$var$unsafeGetArrayBuffer(data);
    let bytesPerElement = 1;
    if ('BYTES_PER_ELEMENT' in Type) bytesPerElement = Type.BYTES_PER_ELEMENT;
    // Absolute end of the |data| view within |buffer|.
    const dataOffset = $99a156a15cd35eb3$var$isArrayBufferView(data) ? data.byteOffset : 0;
    const dataEnd = (dataOffset + data.byteLength) / bytesPerElement;
    // Absolute start of the result within |buffer|.
    const rawStart = (dataOffset + offset) / bytesPerElement;
    const start = Math.floor(Math.max(0, Math.min(rawStart, dataEnd)));
    // Absolute end of the result within |buffer|.
    const end = Math.floor(Math.min(start + Math.max(length, 0), dataEnd));
    return new Type(buffer, start, end - start);
}
function $99a156a15cd35eb3$var$unsafeGetArrayBuffer(view) {
    if (view instanceof ArrayBuffer) return view;
    else return view.buffer;
}
function $99a156a15cd35eb3$var$isArrayBufferView(obj) {
    return obj && obj.buffer instanceof ArrayBuffer && obj.byteLength !== undefined && obj.byteOffset !== undefined;
}
function $99a156a15cd35eb3$var$decodeId3ImageFrame(frame) {
    const metadataFrame = {
        key: frame.type,
        description: '',
        data: '',
        mimeType: null,
        pictureType: null
    };
    const utf8Encoding = 0x03;
    if (frame.size < 2) return undefined;
    if (frame.data[0] !== utf8Encoding) {
        console.log("Ignore frame with unrecognized character encoding");
        return undefined;
    }
    const mimeTypeEndIndex = frame.data.subarray(1).indexOf(0);
    if (mimeTypeEndIndex === -1) return undefined;
    const mimeType = $99a156a15cd35eb3$var$utf8ArrayToStr($99a156a15cd35eb3$var$toUint8(frame.data, 1, mimeTypeEndIndex));
    const pictureType = frame.data[2 + mimeTypeEndIndex];
    const descriptionEndIndex = frame.data.subarray(3 + mimeTypeEndIndex).indexOf(0);
    if (descriptionEndIndex === -1) return undefined;
    const description = $99a156a15cd35eb3$var$utf8ArrayToStr($99a156a15cd35eb3$var$toUint8(frame.data, 3 + mimeTypeEndIndex, descriptionEndIndex));
    let data;
    if (mimeType === '-->') data = $99a156a15cd35eb3$var$utf8ArrayToStr($99a156a15cd35eb3$var$toUint8(frame.data, 4 + mimeTypeEndIndex + descriptionEndIndex));
    else data = $99a156a15cd35eb3$var$toArrayBuffer(frame.data.subarray(4 + mimeTypeEndIndex + descriptionEndIndex));
    metadataFrame.mimeType = mimeType;
    metadataFrame.pictureType = pictureType;
    metadataFrame.description = description;
    metadataFrame.data = data;
    return metadataFrame;
}
/**
 * Decode an ID3 PRIV frame.
 *
 * @param frame - the ID3 PRIV frame
 *
 * @returns The decoded ID3 PRIV frame
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$decodeId3PrivFrame(frame) {
    /*
  Format: <text string>\0<binary data>
  */ if (frame.size < 2) return undefined;
    const owner = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data, true);
    const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
    return {
        key: frame.type,
        info: owner,
        data: privateData.buffer
    };
}
/**
 * Decodes an ID3 text frame
 *
 * @param frame - the ID3 text frame
 *
 * @returns The decoded ID3 text frame
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$decodeId3TextFrame(frame) {
    if (frame.size < 2) return undefined;
    if (frame.type === 'TXXX') {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */ let index = 1;
        const description = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */ const text = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data.subarray(1));
    return {
        key: frame.type,
        info: '',
        data: text
    };
}
/**
 * Decode a URL frame
 *
 * @param frame - the ID3 URL frame
 *
 * @returns The decoded ID3 URL frame
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$decodeId3UrlFrame(frame) {
    if (frame.type === 'WXXX') {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */ if (frame.size < 2) return undefined;
        let index = 1;
        const description = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0-?] = {URL}
  */ const url = $99a156a15cd35eb3$var$utf8ArrayToStr(frame.data);
    return {
        key: frame.type,
        info: '',
        data: url
    };
}
/**
 * Decode an ID3 frame.
 *
 * @param frame - the ID3 frame
 *
 * @returns The decoded ID3 frame
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$decodeId3Frame(frame) {
    if (frame.type === 'PRIV') return $99a156a15cd35eb3$var$decodeId3PrivFrame(frame);
    else if (frame.type[0] === 'W') return $99a156a15cd35eb3$var$decodeId3UrlFrame(frame);
    else if (frame.type === 'APIC') return $99a156a15cd35eb3$var$decodeId3ImageFrame(frame);
    return $99a156a15cd35eb3$var$decodeId3TextFrame(frame);
}
/**
 * Returns the data of an ID3 frame.
 *
 * @param data - The data to read from
 *
 * @returns The data of the ID3 frame
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$getId3FrameData(data) {
    /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */ const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
    const size = $99a156a15cd35eb3$var$readId3Size(data, 4);
    // skip frame id, size, and flags
    const offset = 10;
    return {
        type: type,
        size: size,
        data: data.subarray(offset, offset + size)
    };
}
const $99a156a15cd35eb3$var$HEADER_FOOTER_SIZE = 10;
const $99a156a15cd35eb3$var$FRAME_SIZE = 10;
/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 *
 * @param id3Data - The ID3 data containing one or more ID3 tags
 *
 * @returns Array of ID3 frame objects
 *
 * @group ID3
 *
 * @beta
 */ function $99a156a15cd35eb3$var$getId3Frames(id3Data) {
    let offset = 0;
    const frames = [];
    while($99a156a15cd35eb3$var$isId3Header(id3Data, offset)){
        const size = $99a156a15cd35eb3$var$readId3Size(id3Data, offset + 6);
        if (id3Data[offset + 5] >> 6 & 1) // skip extended header
        offset += $99a156a15cd35eb3$var$HEADER_FOOTER_SIZE;
        // skip past ID3 header
        offset += $99a156a15cd35eb3$var$HEADER_FOOTER_SIZE;
        const end = offset + size;
        // loop through frames in the ID3 tag
        while(offset + $99a156a15cd35eb3$var$FRAME_SIZE < end){
            const frameData = $99a156a15cd35eb3$var$getId3FrameData(id3Data.subarray(offset));
            const frame = $99a156a15cd35eb3$var$decodeId3Frame(frameData);
            if (frame) frames.push(frame);
            // skip frame header and frame data
            offset += frameData.size + $99a156a15cd35eb3$var$HEADER_FOOTER_SIZE;
        }
        if ($99a156a15cd35eb3$var$isId3Footer(id3Data, offset)) offset += $99a156a15cd35eb3$var$HEADER_FOOTER_SIZE;
    }
    return frames;
}
/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 *
 * @param frame - the ID3 frame
 *
 * @returns `true` if the ID3 frame is an Elementary Stream timestamp frame
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$isId3TimestampFrame(frame) {
    return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
}
/**
 * Read a 33 bit timestamp from an ID3 frame.
 *
 * @param timeStampFrame - the ID3 frame
 *
 * @returns The timestamp
 *
 * @internal
 *
 * @group ID3
 */ function $99a156a15cd35eb3$var$readId3Timestamp(timeStampFrame) {
    if (timeStampFrame.data.byteLength === 8) {
        const data = new Uint8Array(timeStampFrame.data);
        // timestamp is 33 bit expressed as a big-endian eight-octet number,
        // with the upper 31 bits set to zero.
        const pts33Bit = data[3] & 0x1;
        let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
        timestamp /= 45;
        if (pts33Bit) timestamp += 47721858.84;
         // 2^32 / 90
        return Math.round(timestamp);
    }
    return undefined;
}
/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 *
 * @param data - Block of data containing one or more ID3 tags
 *
 * @returns The timestamp
 *
 * @group ID3
 *
 * @beta
 */ function $99a156a15cd35eb3$var$getId3Timestamp(data) {
    const frames = $99a156a15cd35eb3$var$getId3Frames(data);
    for(let i = 0; i < frames.length; i++){
        const frame = frames[i];
        if ($99a156a15cd35eb3$var$isId3TimestampFrame(frame)) return $99a156a15cd35eb3$var$readId3Timestamp(frame);
    }
    return undefined;
}
let $99a156a15cd35eb3$export$3f0d1211c87abf7f = /*#__PURE__*/ function(MetadataSchema) {
    MetadataSchema["audioId3"] = "org.id3";
    MetadataSchema["dateRange"] = "com.apple.quicktime.HLS";
    MetadataSchema["emsg"] = "https://aomedia.org/emsg/ID3";
    MetadataSchema["misbklv"] = "urn:misb:KLV:bin:1910.1";
    return MetadataSchema;
}({});
function $99a156a15cd35eb3$var$dummyTrack(type = '', inputTimeScale = 90000) {
    return {
        type: type,
        id: -1,
        pid: -1,
        inputTimeScale: inputTimeScale,
        sequenceNumber: -1,
        samples: [],
        dropped: 0
    };
}
class $99a156a15cd35eb3$var$BaseAudioDemuxer {
    constructor(){
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this.frameIndex = 0;
        this.cachedData = null;
        this.basePTS = null;
        this.initPTS = null;
        this.lastPTS = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this._id3Track = {
            type: 'id3',
            id: 3,
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0
        };
    }
    resetTimeStamp(deaultTimestamp) {
        this.initPTS = deaultTimestamp;
        this.resetContiguity();
    }
    resetContiguity() {
        this.basePTS = null;
        this.lastPTS = null;
        this.frameIndex = 0;
    }
    canParse(data, offset) {
        return false;
    }
    appendFrame(track, data, offset) {}
    // feed incoming data to the front of the parsing pipeline
    demux(data, timeOffset) {
        if (this.cachedData) {
            data = $99a156a15cd35eb3$var$appendUint8Array(this.cachedData, data);
            this.cachedData = null;
        }
        let id3Data = $99a156a15cd35eb3$var$getId3Data(data, 0);
        let offset = id3Data ? id3Data.length : 0;
        let lastDataIndex;
        const track = this._audioTrack;
        const id3Track = this._id3Track;
        const timestamp = id3Data ? $99a156a15cd35eb3$var$getId3Timestamp(id3Data) : undefined;
        const length = data.length;
        if (this.basePTS === null || this.frameIndex === 0 && $99a156a15cd35eb3$var$isFiniteNumber(timestamp)) {
            this.basePTS = $99a156a15cd35eb3$var$initPTSFn(timestamp, timeOffset, this.initPTS);
            this.lastPTS = this.basePTS;
        }
        if (this.lastPTS === null) this.lastPTS = this.basePTS;
        // more expressive than alternative: id3Data?.length
        if (id3Data && id3Data.length > 0) id3Track.samples.push({
            pts: this.lastPTS,
            dts: this.lastPTS,
            data: id3Data,
            type: $99a156a15cd35eb3$export$3f0d1211c87abf7f.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        while(offset < length){
            if (this.canParse(data, offset)) {
                const frame = this.appendFrame(track, data, offset);
                if (frame) {
                    this.frameIndex++;
                    this.lastPTS = frame.sample.pts;
                    offset += frame.length;
                    lastDataIndex = offset;
                } else offset = length;
            } else if ($99a156a15cd35eb3$var$canParseId3(data, offset)) {
                // after a canParse, a call to getId3Data *should* always returns some data
                id3Data = $99a156a15cd35eb3$var$getId3Data(data, offset);
                id3Track.samples.push({
                    pts: this.lastPTS,
                    dts: this.lastPTS,
                    data: id3Data,
                    type: $99a156a15cd35eb3$export$3f0d1211c87abf7f.audioId3,
                    duration: Number.POSITIVE_INFINITY
                });
                offset += id3Data.length;
                lastDataIndex = offset;
            } else offset++;
            if (offset === length && lastDataIndex !== length) {
                const partialData = data.slice(lastDataIndex);
                if (this.cachedData) this.cachedData = $99a156a15cd35eb3$var$appendUint8Array(this.cachedData, partialData);
                else this.cachedData = partialData;
            }
        }
        return {
            audioTrack: track,
            videoTrack: $99a156a15cd35eb3$var$dummyTrack(),
            id3Track: id3Track,
            textTrack: $99a156a15cd35eb3$var$dummyTrack()
        };
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
    }
    flush(timeOffset) {
        // Parse cache in case of remaining frames.
        const cachedData = this.cachedData;
        if (cachedData) {
            this.cachedData = null;
            this.demux(cachedData, 0);
        }
        return {
            audioTrack: this._audioTrack,
            videoTrack: $99a156a15cd35eb3$var$dummyTrack(),
            id3Track: this._id3Track,
            textTrack: $99a156a15cd35eb3$var$dummyTrack()
        };
    }
    destroy() {
        this.cachedData = null;
        // @ts-ignore
        this._audioTrack = this._id3Track = undefined;
    }
}
/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */ const $99a156a15cd35eb3$var$initPTSFn = (timestamp, timeOffset, initPTS)=>{
    if ($99a156a15cd35eb3$var$isFiniteNumber(timestamp)) return timestamp * 90;
    const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
    return timeOffset * 90000 + init90kHz;
};
/**
 *  MPEG parser helper
 */ let $99a156a15cd35eb3$var$chromeVersion$1 = null;
const $99a156a15cd35eb3$var$BitratesMap = [
    32,
    64,
    96,
    128,
    160,
    192,
    224,
    256,
    288,
    320,
    352,
    384,
    416,
    448,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    384,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160,
    176,
    192,
    224,
    256,
    8,
    16,
    24,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160
];
const $99a156a15cd35eb3$var$SamplingRateMap = [
    44100,
    48000,
    32000,
    22050,
    24000,
    16000,
    11025,
    12000,
    8000
];
const $99a156a15cd35eb3$var$SamplesCoefficients = [
    // MPEG 2.5
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // Reserved
    [
        0,
        // Reserved
        0,
        // Layer3
        0,
        // Layer2
        0 // Layer1
    ],
    // MPEG 2
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // MPEG 1
    [
        0,
        // Reserved
        144,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ]
];
const $99a156a15cd35eb3$var$BytesInSlot = [
    0,
    // Reserved
    1,
    // Layer3
    1,
    // Layer2
    4 // Layer1
];
function $99a156a15cd35eb3$var$appendFrame$1(track, data, offset, pts, frameIndex) {
    // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
    if (offset + 24 > data.length) return;
    const header = $99a156a15cd35eb3$var$parseHeader(data, offset);
    if (header && offset + header.frameLength <= data.length) {
        const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
        const stamp = pts + frameIndex * frameDuration;
        const sample = {
            unit: data.subarray(offset, offset + header.frameLength),
            pts: stamp,
            dts: stamp
        };
        track.config = [];
        track.channelCount = header.channelCount;
        track.samplerate = header.sampleRate;
        track.samples.push(sample);
        return {
            sample: sample,
            length: header.frameLength,
            missing: 0
        };
    }
}
function $99a156a15cd35eb3$var$parseHeader(data, offset) {
    const mpegVersion = data[offset + 1] >> 3 & 3;
    const mpegLayer = data[offset + 1] >> 1 & 3;
    const bitRateIndex = data[offset + 2] >> 4 & 15;
    const sampleRateIndex = data[offset + 2] >> 2 & 3;
    if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
        const paddingBit = data[offset + 2] >> 1 & 1;
        const channelMode = data[offset + 3] >> 6;
        const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
        const bitRate = $99a156a15cd35eb3$var$BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
        const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
        const sampleRate = $99a156a15cd35eb3$var$SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
        const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
        const sampleCoefficient = $99a156a15cd35eb3$var$SamplesCoefficients[mpegVersion][mpegLayer];
        const bytesInSlot = $99a156a15cd35eb3$var$BytesInSlot[mpegLayer];
        const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
        const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
        if ($99a156a15cd35eb3$var$chromeVersion$1 === null) {
            const userAgent = navigator.userAgent || '';
            const result = userAgent.match(/Chrome\/(\d+)/i);
            $99a156a15cd35eb3$var$chromeVersion$1 = result ? parseInt(result[1]) : 0;
        }
        const needChromeFix = !!$99a156a15cd35eb3$var$chromeVersion$1 && $99a156a15cd35eb3$var$chromeVersion$1 <= 87;
        if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
        data[offset + 3] = data[offset + 3] | 0x80;
        return {
            sampleRate: sampleRate,
            channelCount: channelCount,
            frameLength: frameLength,
            samplesPerFrame: samplesPerFrame
        };
    }
}
function $99a156a15cd35eb3$var$isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function $99a156a15cd35eb3$var$isHeader(data, offset) {
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    return offset + 1 < data.length && $99a156a15cd35eb3$var$isHeaderPattern(data, offset);
}
function $99a156a15cd35eb3$var$canParse(data, offset) {
    const headerSize = 4;
    return $99a156a15cd35eb3$var$isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function $99a156a15cd35eb3$var$probe(data, offset) {
    // same as isHeader but we also check that MPEG frame follows last MPEG frame
    // or end of data is reached
    if (offset + 1 < data.length && $99a156a15cd35eb3$var$isHeaderPattern(data, offset)) {
        // MPEG header Length
        const headerLength = 4;
        // MPEG frame Length
        const header = $99a156a15cd35eb3$var$parseHeader(data, offset);
        let frameLength = headerLength;
        if (header != null && header.frameLength) frameLength = header.frameLength;
        const newOffset = offset + frameLength;
        return newOffset === data.length || $99a156a15cd35eb3$var$isHeader(data, newOffset);
    }
    return false;
}
/**
 * AAC demuxer
 */ class $99a156a15cd35eb3$var$AACDemuxer extends $99a156a15cd35eb3$var$BaseAudioDemuxer {
    constructor(observer, config){
        super();
        this.observer = void 0;
        this.config = void 0;
        this.observer = observer;
        this.config = config;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/adts',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'aac',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
    static probe(data, logger) {
        if (!data) return false;
        // Check for the ADTS sync word
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        const id3Data = $99a156a15cd35eb3$var$getId3Data(data, 0);
        let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
        if ($99a156a15cd35eb3$var$probe(data, offset)) return false;
        for(let length = data.length; offset < length; offset++)if ($99a156a15cd35eb3$var$probe$1(data, offset)) {
            logger.log('ADTS sync word found !');
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return $99a156a15cd35eb3$var$canParse$1(data, offset);
    }
    appendFrame(track, data, offset) {
        $99a156a15cd35eb3$var$initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
        const frame = $99a156a15cd35eb3$var$appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
        if (frame && frame.missing === 0) return frame;
    }
}
const $99a156a15cd35eb3$var$getAudioBSID = (data, offset)=>{
    // check the bsid to confirm ac-3 | ec-3
    let bsid = 0;
    let numBits = 5;
    offset += numBits;
    const temp = new Uint32Array(1); // unsigned 32 bit for temporary storage
    const mask = new Uint32Array(1); // unsigned 32 bit mask value
    const byte = new Uint8Array(1); // unsigned 8 bit for temporary storage
    while(numBits > 0){
        byte[0] = data[offset];
        // read remaining bits, upto 8 bits at a time
        const bits = Math.min(numBits, 8);
        const shift = 8 - bits;
        mask[0] = 0xff000000 >>> 24 + shift << shift;
        temp[0] = (byte[0] & mask[0]) >> shift;
        bsid = !bsid ? temp[0] : bsid << bits | temp[0];
        offset += 1;
        numBits -= bits;
    }
    return bsid;
};
class $99a156a15cd35eb3$var$AC3Demuxer extends $99a156a15cd35eb3$var$BaseAudioDemuxer {
    constructor(observer){
        super();
        this.observer = void 0;
        this.observer = observer;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/ac-3',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'ac3',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    canParse(data, offset) {
        return offset + 64 < data.length;
    }
    appendFrame(track, data, offset) {
        const frameLength = $99a156a15cd35eb3$var$appendFrame(track, data, offset, this.basePTS, this.frameIndex);
        if (frameLength !== -1) {
            const sample = track.samples[track.samples.length - 1];
            return {
                sample: sample,
                length: frameLength,
                missing: 0
            };
        }
    }
    static probe(data) {
        if (!data) return false;
        const id3Data = $99a156a15cd35eb3$var$getId3Data(data, 0);
        if (!id3Data) return false;
        // look for the ac-3 sync bytes
        const offset = id3Data.length;
        if (data[offset] === 0x0b && data[offset + 1] === 0x77 && $99a156a15cd35eb3$var$getId3Timestamp(id3Data) !== undefined && // check the bsid to confirm ac-3
        $99a156a15cd35eb3$var$getAudioBSID(data, offset) < 16) return true;
        return false;
    }
}
function $99a156a15cd35eb3$var$appendFrame(track, data, start, pts, frameIndex) {
    if (start + 8 > data.length) return -1; // not enough bytes left
    if (data[start] !== 0x0b || data[start + 1] !== 0x77) return -1; // invalid magic
    // get sample rate
    const samplingRateCode = data[start + 4] >> 6;
    if (samplingRateCode >= 3) return -1; // invalid sampling rate
    const samplingRateMap = [
        48000,
        44100,
        32000
    ];
    const sampleRate = samplingRateMap[samplingRateCode];
    // get frame size
    const frameSizeCode = data[start + 4] & 0x3f;
    const frameSizeMap = [
        64,
        69,
        96,
        64,
        70,
        96,
        80,
        87,
        120,
        80,
        88,
        120,
        96,
        104,
        144,
        96,
        105,
        144,
        112,
        121,
        168,
        112,
        122,
        168,
        128,
        139,
        192,
        128,
        140,
        192,
        160,
        174,
        240,
        160,
        175,
        240,
        192,
        208,
        288,
        192,
        209,
        288,
        224,
        243,
        336,
        224,
        244,
        336,
        256,
        278,
        384,
        256,
        279,
        384,
        320,
        348,
        480,
        320,
        349,
        480,
        384,
        417,
        576,
        384,
        418,
        576,
        448,
        487,
        672,
        448,
        488,
        672,
        512,
        557,
        768,
        512,
        558,
        768,
        640,
        696,
        960,
        640,
        697,
        960,
        768,
        835,
        1152,
        768,
        836,
        1152,
        896,
        975,
        1344,
        896,
        976,
        1344,
        1024,
        1114,
        1536,
        1024,
        1115,
        1536,
        1152,
        1253,
        1728,
        1152,
        1254,
        1728,
        1280,
        1393,
        1920,
        1280,
        1394,
        1920
    ];
    const frameLength = frameSizeMap[frameSizeCode * 3 + samplingRateCode] * 2;
    if (start + frameLength > data.length) return -1;
    // get channel count
    const channelMode = data[start + 6] >> 5;
    let skipCount = 0;
    if (channelMode === 2) skipCount += 2;
    else {
        if (channelMode & 1 && channelMode !== 1) skipCount += 2;
        if (channelMode & 4) skipCount += 2;
    }
    const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
    const channelsMap = [
        2,
        1,
        2,
        3,
        3,
        4,
        4,
        5
    ];
    const channelCount = channelsMap[channelMode] + lfeon;
    // build dac3 box
    const bsid = data[start + 5] >> 3;
    const bsmod = data[start + 5] & 7;
    const config = new Uint8Array([
        samplingRateCode << 6 | bsid << 1 | bsmod >> 2,
        (bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4,
        frameSizeCode << 4 & 0xe0
    ]);
    const frameDuration = 1536 / sampleRate * 90000;
    const stamp = pts + frameIndex * frameDuration;
    const unit = data.subarray(start, start + frameLength);
    track.config = config;
    track.channelCount = channelCount;
    track.samplerate = sampleRate;
    track.samples.push({
        unit: unit,
        pts: stamp
    });
    return frameLength;
}
/**
 * MP3 demuxer
 */ class $99a156a15cd35eb3$var$MP3Demuxer extends $99a156a15cd35eb3$var$BaseAudioDemuxer {
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/mpeg',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'mp3',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    static probe(data) {
        if (!data) return false;
        // check if data contains ID3 timestamp and MPEG sync word
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        const id3Data = $99a156a15cd35eb3$var$getId3Data(data, 0);
        let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
        // Check for ac-3|ec-3 sync bytes and return false if present
        if (id3Data && data[offset] === 0x0b && data[offset + 1] === 0x77 && $99a156a15cd35eb3$var$getId3Timestamp(id3Data) !== undefined && // check the bsid to confirm ac-3 or ec-3 (not mp3)
        $99a156a15cd35eb3$var$getAudioBSID(data, offset) <= 16) return false;
        for(let length = data.length; offset < length; offset++)if ($99a156a15cd35eb3$var$probe(data, offset)) {
            $99a156a15cd35eb3$var$logger.log('MPEG Audio sync word found !');
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return $99a156a15cd35eb3$var$canParse(data, offset);
    }
    appendFrame(track, data, offset) {
        if (this.basePTS === null) return;
        return $99a156a15cd35eb3$var$appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
    }
}
const $99a156a15cd35eb3$var$emsgSchemePattern = /\/emsg[-/]ID3/i;
class $99a156a15cd35eb3$var$MP4Demuxer {
    constructor(observer, config){
        this.remainderData = null;
        this.timeOffset = 0;
        this.config = void 0;
        this.videoTrack = void 0;
        this.audioTrack = void 0;
        this.id3Track = void 0;
        this.txtTrack = void 0;
        this.config = config;
    }
    resetTimeStamp() {}
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        const videoTrack = this.videoTrack = $99a156a15cd35eb3$var$dummyTrack('video', 1);
        const audioTrack = this.audioTrack = $99a156a15cd35eb3$var$dummyTrack('audio', 1);
        const captionTrack = this.txtTrack = $99a156a15cd35eb3$var$dummyTrack('text', 1);
        this.id3Track = $99a156a15cd35eb3$var$dummyTrack('id3', 1);
        this.timeOffset = 0;
        if (!(initSegment != null && initSegment.byteLength)) return;
        const initData = $99a156a15cd35eb3$var$parseInitSegment(initSegment);
        if (initData.video) {
            const { id: id, timescale: timescale, codec: codec, supplemental: supplemental } = initData.video;
            videoTrack.id = id;
            videoTrack.timescale = captionTrack.timescale = timescale;
            videoTrack.codec = codec;
            videoTrack.supplemental = supplemental;
        }
        if (initData.audio) {
            const { id: id, timescale: timescale, codec: codec } = initData.audio;
            audioTrack.id = id;
            audioTrack.timescale = timescale;
            audioTrack.codec = codec;
        }
        captionTrack.id = $99a156a15cd35eb3$var$RemuxerTrackIdConfig.text;
        videoTrack.sampleDuration = 0;
        videoTrack.duration = audioTrack.duration = trackDuration;
    }
    resetContiguity() {
        this.remainderData = null;
    }
    static probe(data) {
        return $99a156a15cd35eb3$var$hasMoofData(data);
    }
    demux(data, timeOffset) {
        this.timeOffset = timeOffset;
        // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
        let videoSamples = data;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        if (this.config.progressive) {
            // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
            // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
            // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
            if (this.remainderData) videoSamples = $99a156a15cd35eb3$var$appendUint8Array(this.remainderData, data);
            const segmentedData = $99a156a15cd35eb3$var$segmentValidRange(videoSamples);
            this.remainderData = segmentedData.remainder;
            videoTrack.samples = segmentedData.valid || new Uint8Array();
        } else videoTrack.samples = videoSamples;
        const id3Track = this.extractID3Track(videoTrack, timeOffset);
        textTrack.samples = $99a156a15cd35eb3$var$parseSamples(timeOffset, videoTrack);
        return {
            videoTrack: videoTrack,
            audioTrack: this.audioTrack,
            id3Track: id3Track,
            textTrack: this.txtTrack
        };
    }
    flush() {
        const timeOffset = this.timeOffset;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        videoTrack.samples = this.remainderData || new Uint8Array();
        this.remainderData = null;
        const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
        textTrack.samples = $99a156a15cd35eb3$var$parseSamples(timeOffset, videoTrack);
        return {
            videoTrack: videoTrack,
            audioTrack: $99a156a15cd35eb3$var$dummyTrack(),
            id3Track: id3Track,
            textTrack: $99a156a15cd35eb3$var$dummyTrack()
        };
    }
    extractID3Track(videoTrack, timeOffset) {
        const id3Track = this.id3Track;
        if (videoTrack.samples.length) {
            const emsgs = $99a156a15cd35eb3$var$findBox(videoTrack.samples, [
                'emsg'
            ]);
            if (emsgs) emsgs.forEach((data)=>{
                const emsgInfo = $99a156a15cd35eb3$var$parseEmsg(data);
                if ($99a156a15cd35eb3$var$emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
                    const pts = $99a156a15cd35eb3$var$getEmsgStartTime(emsgInfo, timeOffset);
                    let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
                    // Safari takes anything <= 0.001 seconds and maps it to Infinity
                    if (duration <= 0.001) duration = Number.POSITIVE_INFINITY;
                    const payload = emsgInfo.payload;
                    id3Track.samples.push({
                        data: payload,
                        len: payload.byteLength,
                        dts: pts,
                        pts: pts,
                        type: $99a156a15cd35eb3$export$3f0d1211c87abf7f.emsg,
                        duration: duration
                    });
                } else if (this.config.enableEmsgKLVMetadata && emsgInfo.schemeIdUri.startsWith('urn:misb:KLV:bin:1910.1')) {
                    const pts = $99a156a15cd35eb3$var$getEmsgStartTime(emsgInfo, timeOffset);
                    id3Track.samples.push({
                        data: emsgInfo.payload,
                        len: emsgInfo.payload.byteLength,
                        dts: pts,
                        pts: pts,
                        type: $99a156a15cd35eb3$export$3f0d1211c87abf7f.misbklv,
                        duration: Number.POSITIVE_INFINITY
                    });
                }
            });
        }
        return id3Track;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
    }
    destroy() {
        // @ts-ignore
        this.config = null;
        this.remainderData = null;
        this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = undefined;
    }
}
function $99a156a15cd35eb3$var$getEmsgStartTime(emsgInfo, timeOffset) {
    return $99a156a15cd35eb3$var$isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
}
/**
 * SAMPLE-AES decrypter
 */ class $99a156a15cd35eb3$var$SampleAesDecrypter {
    constructor(observer, config, keyData){
        this.keyData = void 0;
        this.decrypter = void 0;
        this.keyData = keyData;
        this.decrypter = new $99a156a15cd35eb3$var$Decrypter(config, {
            removePKCS7Padding: false
        });
    }
    decryptBuffer(encryptedData) {
        return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer, $99a156a15cd35eb3$var$DecrypterAesMode.cbc);
    }
    // AAC - encrypt all full 16 bytes blocks starting from offset 16
    decryptAacSample(samples, sampleIndex, callback) {
        const curUnit = samples[sampleIndex].unit;
        if (curUnit.length <= 16) // No encrypted portion in this sample (first 16 bytes is not
        // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
        return;
        const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
        const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
        this.decryptBuffer(encryptedBuffer).then((decryptedBuffer)=>{
            const decryptedData = new Uint8Array(decryptedBuffer);
            curUnit.set(decryptedData, 16);
            if (!this.decrypter.isSync()) this.decryptAacSamples(samples, sampleIndex + 1, callback);
        });
    }
    decryptAacSamples(samples, sampleIndex, callback) {
        for(;; sampleIndex++){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            if (samples[sampleIndex].unit.length < 32) continue;
            this.decryptAacSample(samples, sampleIndex, callback);
            if (!this.decrypter.isSync()) return;
        }
    }
    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
    getAvcEncryptedData(decodedData) {
        const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
        const encryptedData = new Int8Array(encryptedDataLen);
        let outputPos = 0;
        for(let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16)encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
        return encryptedData;
    }
    getAvcDecryptedUnit(decodedData, decryptedData) {
        const uint8DecryptedData = new Uint8Array(decryptedData);
        let inputPos = 0;
        for(let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16)decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
        return decodedData;
    }
    decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
        const decodedData = $99a156a15cd35eb3$var$discardEPB(curUnit.data);
        const encryptedData = this.getAvcEncryptedData(decodedData);
        this.decryptBuffer(encryptedData.buffer).then((decryptedBuffer)=>{
            curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
            if (!this.decrypter.isSync()) this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
        });
    }
    decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
        if (samples instanceof Uint8Array) throw new Error('Cannot decrypt samples of type Uint8Array');
        for(;; sampleIndex++, unitIndex = 0){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            const curUnits = samples[sampleIndex].units;
            for(;; unitIndex++){
                if (unitIndex >= curUnits.length) break;
                const curUnit = curUnits[unitIndex];
                if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;
                this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
                if (!this.decrypter.isSync()) return;
            }
        }
    }
}
class $99a156a15cd35eb3$var$BaseVideoParser {
    constructor(){
        this.VideoSample = null;
    }
    createVideoSample(key, pts, dts) {
        return {
            key: key,
            frame: false,
            pts: pts,
            dts: dts,
            units: [],
            length: 0
        };
    }
    getLastNalUnit(samples) {
        var _VideoSample;
        let VideoSample = this.VideoSample;
        let lastUnit;
        // try to fallback to previous sample if current one is empty
        if (!VideoSample || VideoSample.units.length === 0) VideoSample = samples[samples.length - 1];
        if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
            const units = VideoSample.units;
            lastUnit = units[units.length - 1];
        }
        return lastUnit;
    }
    pushAccessUnit(VideoSample, videoTrack) {
        if (VideoSample.units.length && VideoSample.frame) {
            // if sample does not have PTS/DTS, patch with last sample PTS/DTS
            if (VideoSample.pts === undefined) {
                const samples = videoTrack.samples;
                const nbSamples = samples.length;
                if (nbSamples) {
                    const lastSample = samples[nbSamples - 1];
                    VideoSample.pts = lastSample.pts;
                    VideoSample.dts = lastSample.dts;
                } else {
                    // dropping samples, no timestamp found
                    videoTrack.dropped++;
                    return;
                }
            }
            videoTrack.samples.push(VideoSample);
        }
    }
    parseNALu(track, array, endOfSegment) {
        const len = array.byteLength;
        let state = track.naluState || 0;
        const lastState = state;
        const units = [];
        let i = 0;
        let value;
        let overflow;
        let unitType;
        let lastUnitStart = -1;
        let lastUnitType = 0;
        // logger.log('PES:' + Hex.hexDump(array));
        if (state === -1) {
            // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
            lastUnitStart = 0;
            // NALu type is value read from offset 0
            lastUnitType = this.getNALuType(array, 0);
            state = 0;
            i = 1;
        }
        while(i < len){
            value = array[i++];
            // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
            if (!state) {
                state = value ? 0 : 1;
                continue;
            }
            if (state === 1) {
                state = value ? 0 : 2;
                continue;
            }
            // here we have state either equal to 2 or 3
            if (!value) state = 3;
            else if (value === 1) {
                overflow = i - state - 1;
                if (lastUnitStart >= 0) {
                    const unit = {
                        data: array.subarray(lastUnitStart, overflow),
                        type: lastUnitType
                    };
                    // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                    units.push(unit);
                } else {
                    // lastUnitStart is undefined => this is the first start code found in this PES packet
                    // first check if start code delimiter is overlapping between 2 PES packets,
                    // ie it started in last packet (lastState not zero)
                    // and ended at the beginning of this PES packet (i <= 4 - lastState)
                    const lastUnit = this.getLastNalUnit(track.samples);
                    if (lastUnit) {
                        if (lastState && i <= 4 - lastState) // start delimiter overlapping between PES packets
                        // strip start delimiter bytes from the end of last NAL unit
                        // check if lastUnit had a state different from zero
                        {
                            if (lastUnit.state) // strip last bytes
                            lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                        }
                        // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                        if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            lastUnit.data = $99a156a15cd35eb3$var$appendUint8Array(lastUnit.data, array.subarray(0, overflow));
                            lastUnit.state = 0;
                        }
                    }
                }
                // check if we can read unit type
                if (i < len) {
                    unitType = this.getNALuType(array, i);
                    // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                    lastUnitStart = i;
                    lastUnitType = unitType;
                    state = 0;
                } else // not enough byte to read unit type. let's read it on next PES parsing
                state = -1;
            } else state = 0;
        }
        if (lastUnitStart >= 0 && state >= 0) {
            const unit = {
                data: array.subarray(lastUnitStart, len),
                type: lastUnitType,
                state: state
            };
            units.push(unit);
        // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
        }
        // no NALu found
        if (units.length === 0) {
            // append pes.data to previous NAL unit
            const lastUnit = this.getLastNalUnit(track.samples);
            if (lastUnit) lastUnit.data = $99a156a15cd35eb3$var$appendUint8Array(lastUnit.data, array);
        }
        track.naluState = state;
        return units;
    }
}
/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */ class $99a156a15cd35eb3$var$ExpGolomb {
    constructor(data){
        this.data = void 0;
        this.bytesAvailable = void 0;
        this.word = void 0;
        this.bitsAvailable = void 0;
        this.data = data;
        // the number of bytes left to examine in this.data
        this.bytesAvailable = data.byteLength;
        // the current word being examined
        this.word = 0; // :uint
        // the number of bits left to examine in the current word
        this.bitsAvailable = 0; // :uint
    }
    // ():void
    loadWord() {
        const data = this.data;
        const bytesAvailable = this.bytesAvailable;
        const position = data.byteLength - bytesAvailable;
        const workingBytes = new Uint8Array(4);
        const availableBytes = Math.min(4, bytesAvailable);
        if (availableBytes === 0) throw new Error('no bytes available');
        workingBytes.set(data.subarray(position, position + availableBytes));
        this.word = new DataView(workingBytes.buffer).getUint32(0);
        // track the amount of this.data that has been processed
        this.bitsAvailable = availableBytes * 8;
        this.bytesAvailable -= availableBytes;
    }
    // (count:int):void
    skipBits(count) {
        let skipBytes; // :int
        count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
        if (this.bitsAvailable > count) {
            this.word <<= count;
            this.bitsAvailable -= count;
        } else {
            count -= this.bitsAvailable;
            skipBytes = count >> 3;
            count -= skipBytes << 3;
            this.bytesAvailable -= skipBytes;
            this.loadWord();
            this.word <<= count;
            this.bitsAvailable -= count;
        }
    }
    // (size:int):uint
    readBits(size) {
        let bits = Math.min(this.bitsAvailable, size); // :uint
        const valu = this.word >>> 32 - bits; // :uint
        if (size > 32) $99a156a15cd35eb3$var$logger.error('Cannot read more than 32 bits at a time');
        this.bitsAvailable -= bits;
        if (this.bitsAvailable > 0) this.word <<= bits;
        else if (this.bytesAvailable > 0) this.loadWord();
        else throw new Error('no bits available');
        bits = size - bits;
        if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);
        else return valu;
    }
    // ():uint
    skipLZ() {
        let leadingZeroCount; // :uint
        for(leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount)if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
            // the first bit of working word is 1
            this.word <<= leadingZeroCount;
            this.bitsAvailable -= leadingZeroCount;
            return leadingZeroCount;
        }
        // we exhausted word and still have not found a 1
        this.loadWord();
        return leadingZeroCount + this.skipLZ();
    }
    // ():void
    skipUEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():void
    skipEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():uint
    readUEG() {
        const clz = this.skipLZ(); // :uint
        return this.readBits(clz + 1) - 1;
    }
    // ():int
    readEG() {
        const valu = this.readUEG(); // :int
        if (0x01 & valu) // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
        else return -1 * (valu >>> 1); // divide by two then make it negative
    }
    // Some convenience functions
    // :Boolean
    readBoolean() {
        return this.readBits(1) === 1;
    }
    // ():int
    readUByte() {
        return this.readBits(8);
    }
    // ():int
    readUShort() {
        return this.readBits(16);
    }
    // ():int
    readUInt() {
        return this.readBits(32);
    }
}
class $99a156a15cd35eb3$var$AvcVideoParser extends $99a156a15cd35eb3$var$BaseVideoParser {
    parsePES(track, textTrack, pes, endOfSegment) {
        const units = this.parseNALu(track, pes.data, endOfSegment);
        let VideoSample = this.VideoSample;
        let push;
        let spsfound = false;
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (VideoSample && units.length && !track.audFound) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
        }
        units.forEach((unit)=>{
            var _VideoSample2, _VideoSample3;
            switch(unit.type){
                // NDR
                case 1:
                    {
                        let iskey = false;
                        push = true;
                        const data = unit.data;
                        // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                        if (spsfound && data.length > 4) {
                            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                            const sliceType = this.readSliceType(data);
                            // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                            // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                            // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                            // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                            // if (sliceType === 2 || sliceType === 7) {
                            if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) iskey = true;
                        }
                        if (iskey) {
                            var _VideoSample;
                            // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
                            if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                                this.pushAccessUnit(VideoSample, track);
                                VideoSample = this.VideoSample = null;
                            }
                        }
                        if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                        VideoSample.frame = true;
                        VideoSample.key = iskey;
                        break;
                    // IDR
                    }
                case 5:
                    push = true;
                    // handle PES not starting with AUD
                    // if we have frame data already, that cannot belong to the same frame, so force a push
                    if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = this.VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // SEI
                case 6:
                    push = true;
                    $99a156a15cd35eb3$var$parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
                    break;
                case 7:
                    {
                        var _track$pixelRatio, _track$pixelRatio2;
                        push = true;
                        spsfound = true;
                        const sps = unit.data;
                        const config = this.readSPS(sps);
                        if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
                            track.width = config.width;
                            track.height = config.height;
                            track.pixelRatio = config.pixelRatio;
                            track.sps = [
                                sps
                            ];
                            const codecarray = sps.subarray(1, 4);
                            let codecstring = 'avc1.';
                            for(let i = 0; i < 3; i++){
                                let h = codecarray[i].toString(16);
                                if (h.length < 2) h = '0' + h;
                                codecstring += h;
                            }
                            track.codec = codecstring;
                        }
                        break;
                    }
                // PPS
                case 8:
                    push = true;
                    track.pps = [
                        unit.data
                    ];
                    break;
                // AUD
                case 9:
                    push = true;
                    track.audFound = true;
                    if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
                    break;
                // Filler Data
                case 12:
                    push = true;
                    break;
                default:
                    push = false;
                    break;
            }
            if (VideoSample && push) {
                const units = VideoSample.units;
                units.push(unit);
            }
        });
        // if last PES packet, push samples
        if (endOfSegment && VideoSample) {
            this.pushAccessUnit(VideoSample, track);
            this.VideoSample = null;
        }
    }
    getNALuType(data, offset) {
        return data[offset] & 0x1f;
    }
    readSliceType(data) {
        const eg = new $99a156a15cd35eb3$var$ExpGolomb(data);
        // skip NALu type
        eg.readUByte();
        // discard first_mb_in_slice
        eg.readUEG();
        // return slice_type
        return eg.readUEG();
    }
    /**
   * The scaling list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */ skipScalingList(count, reader) {
        let lastScale = 8;
        let nextScale = 8;
        let deltaScale;
        for(let j = 0; j < count; j++){
            if (nextScale !== 0) {
                deltaScale = reader.readEG();
                nextScale = (lastScale + deltaScale + 256) % 256;
            }
            lastScale = nextScale === 0 ? lastScale : nextScale;
        }
    }
    /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */ readSPS(sps) {
        const eg = new $99a156a15cd35eb3$var$ExpGolomb(sps);
        let frameCropLeftOffset = 0;
        let frameCropRightOffset = 0;
        let frameCropTopOffset = 0;
        let frameCropBottomOffset = 0;
        let numRefFramesInPicOrderCntCycle;
        let scalingListCount;
        let i;
        const readUByte = eg.readUByte.bind(eg);
        const readBits = eg.readBits.bind(eg);
        const readUEG = eg.readUEG.bind(eg);
        const readBoolean = eg.readBoolean.bind(eg);
        const skipBits = eg.skipBits.bind(eg);
        const skipEG = eg.skipEG.bind(eg);
        const skipUEG = eg.skipUEG.bind(eg);
        const skipScalingList = this.skipScalingList.bind(this);
        readUByte();
        const profileIdc = readUByte(); // profile_idc
        readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
        skipBits(3); // reserved_zero_3bits u(3),
        readUByte(); // level_idc u(8)
        skipUEG(); // seq_parameter_set_id
        // some profiles have more optional data we don't need
        if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
            const chromaFormatIdc = readUEG();
            if (chromaFormatIdc === 3) skipBits(1);
             // separate_colour_plane_flag
            skipUEG(); // bit_depth_luma_minus8
            skipUEG(); // bit_depth_chroma_minus8
            skipBits(1); // qpprime_y_zero_transform_bypass_flag
            if (readBoolean()) {
                // seq_scaling_matrix_present_flag
                scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                for(i = 0; i < scalingListCount; i++)if (readBoolean()) {
                    // seq_scaling_list_present_flag[ i ]
                    if (i < 6) skipScalingList(16, eg);
                    else skipScalingList(64, eg);
                }
            }
        }
        skipUEG(); // log2_max_frame_num_minus4
        const picOrderCntType = readUEG();
        if (picOrderCntType === 0) readUEG(); // log2_max_pic_order_cnt_lsb_minus4
        else if (picOrderCntType === 1) {
            skipBits(1); // delta_pic_order_always_zero_flag
            skipEG(); // offset_for_non_ref_pic
            skipEG(); // offset_for_top_to_bottom_field
            numRefFramesInPicOrderCntCycle = readUEG();
            for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)skipEG();
             // offset_for_ref_frame[ i ]
        }
        skipUEG(); // max_num_ref_frames
        skipBits(1); // gaps_in_frame_num_value_allowed_flag
        const picWidthInMbsMinus1 = readUEG();
        const picHeightInMapUnitsMinus1 = readUEG();
        const frameMbsOnlyFlag = readBits(1);
        if (frameMbsOnlyFlag === 0) skipBits(1);
         // mb_adaptive_frame_field_flag
        skipBits(1); // direct_8x8_inference_flag
        if (readBoolean()) {
            // frame_cropping_flag
            frameCropLeftOffset = readUEG();
            frameCropRightOffset = readUEG();
            frameCropTopOffset = readUEG();
            frameCropBottomOffset = readUEG();
        }
        let pixelRatio = [
            1,
            1
        ];
        if (readBoolean()) // vui_parameters_present_flag
        {
            if (readBoolean()) {
                // aspect_ratio_info_present_flag
                const aspectRatioIdc = readUByte();
                switch(aspectRatioIdc){
                    case 1:
                        pixelRatio = [
                            1,
                            1
                        ];
                        break;
                    case 2:
                        pixelRatio = [
                            12,
                            11
                        ];
                        break;
                    case 3:
                        pixelRatio = [
                            10,
                            11
                        ];
                        break;
                    case 4:
                        pixelRatio = [
                            16,
                            11
                        ];
                        break;
                    case 5:
                        pixelRatio = [
                            40,
                            33
                        ];
                        break;
                    case 6:
                        pixelRatio = [
                            24,
                            11
                        ];
                        break;
                    case 7:
                        pixelRatio = [
                            20,
                            11
                        ];
                        break;
                    case 8:
                        pixelRatio = [
                            32,
                            11
                        ];
                        break;
                    case 9:
                        pixelRatio = [
                            80,
                            33
                        ];
                        break;
                    case 10:
                        pixelRatio = [
                            18,
                            11
                        ];
                        break;
                    case 11:
                        pixelRatio = [
                            15,
                            11
                        ];
                        break;
                    case 12:
                        pixelRatio = [
                            64,
                            33
                        ];
                        break;
                    case 13:
                        pixelRatio = [
                            160,
                            99
                        ];
                        break;
                    case 14:
                        pixelRatio = [
                            4,
                            3
                        ];
                        break;
                    case 15:
                        pixelRatio = [
                            3,
                            2
                        ];
                        break;
                    case 16:
                        pixelRatio = [
                            2,
                            1
                        ];
                        break;
                    case 255:
                        pixelRatio = [
                            readUByte() << 8 | readUByte(),
                            readUByte() << 8 | readUByte()
                        ];
                        break;
                }
            }
        }
        return {
            width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
            height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
            pixelRatio: pixelRatio
        };
    }
}
class $99a156a15cd35eb3$var$HevcVideoParser extends $99a156a15cd35eb3$var$BaseVideoParser {
    constructor(...args){
        super(...args);
        this.initVPS = null;
    }
    parsePES(track, textTrack, pes, endOfSegment) {
        const units = this.parseNALu(track, pes.data, endOfSegment);
        let VideoSample = this.VideoSample;
        let push;
        let spsfound = false;
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (VideoSample && units.length && !track.audFound) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
        }
        units.forEach((unit)=>{
            var _VideoSample2, _VideoSample3;
            switch(unit.type){
                // NON-IDR, NON RANDOM ACCESS SLICE
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
                    VideoSample.frame = true;
                    push = true;
                    break;
                // CRA, BLA (random access picture)
                case 16:
                case 17:
                case 18:
                case 21:
                    push = true;
                    if (spsfound) {
                        var _VideoSample;
                        // handle PES not starting with AUD
                        // if we have frame data already, that cannot belong to the same frame, so force a push
                        if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                            this.pushAccessUnit(VideoSample, track);
                            VideoSample = this.VideoSample = null;
                        }
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // IDR
                case 19:
                case 20:
                    push = true;
                    // handle PES not starting with AUD
                    // if we have frame data already, that cannot belong to the same frame, so force a push
                    if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = this.VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // SEI
                case 39:
                    push = true;
                    $99a156a15cd35eb3$var$parseSEIMessageFromNALu(unit.data, 2, // NALu header size
                    pes.pts, textTrack.samples);
                    break;
                // VPS
                case 32:
                    push = true;
                    if (!track.vps) {
                        if (typeof track.params !== 'object') track.params = {};
                        track.params = $99a156a15cd35eb3$var$_extends(track.params, this.readVPS(unit.data));
                        this.initVPS = unit.data;
                    }
                    track.vps = [
                        unit.data
                    ];
                    break;
                // SPS
                case 33:
                    push = true;
                    spsfound = true;
                    if (track.vps !== undefined && track.vps[0] !== this.initVPS && track.sps !== undefined && !this.matchSPS(track.sps[0], unit.data)) {
                        this.initVPS = track.vps[0];
                        track.sps = track.pps = undefined;
                    }
                    if (!track.sps) {
                        const config = this.readSPS(unit.data);
                        track.width = config.width;
                        track.height = config.height;
                        track.pixelRatio = config.pixelRatio;
                        track.codec = config.codecString;
                        track.sps = [];
                        if (typeof track.params !== 'object') track.params = {};
                        for(const prop in config.params)track.params[prop] = config.params[prop];
                    }
                    this.pushParameterSet(track.sps, unit.data, track.vps);
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    break;
                // PPS
                case 34:
                    push = true;
                    if (typeof track.params === 'object') {
                        if (!track.pps) {
                            track.pps = [];
                            const config = this.readPPS(unit.data);
                            for(const prop in config)track.params[prop] = config[prop];
                        }
                        this.pushParameterSet(track.pps, unit.data, track.vps);
                    }
                    break;
                // ACCESS UNIT DELIMITER
                case 35:
                    push = true;
                    track.audFound = true;
                    if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
                    break;
                default:
                    push = false;
                    break;
            }
            if (VideoSample && push) {
                const units = VideoSample.units;
                units.push(unit);
            }
        });
        // if last PES packet, push samples
        if (endOfSegment && VideoSample) {
            this.pushAccessUnit(VideoSample, track);
            this.VideoSample = null;
        }
    }
    pushParameterSet(parameterSets, data, vps) {
        if (vps && vps[0] === this.initVPS || !vps && !parameterSets.length) parameterSets.push(data);
    }
    getNALuType(data, offset) {
        return (data[offset] & 0x7e) >>> 1;
    }
    ebsp2rbsp(arr) {
        const dst = new Uint8Array(arr.byteLength);
        let dstIdx = 0;
        for(let i = 0; i < arr.byteLength; i++){
            if (i >= 2) {
                // Unescape: Skip 0x03 after 00 00
                if (arr[i] === 0x03 && arr[i - 1] === 0x00 && arr[i - 2] === 0x00) continue;
            }
            dst[dstIdx] = arr[i];
            dstIdx++;
        }
        return new Uint8Array(dst.buffer, 0, dstIdx);
    }
    pushAccessUnit(VideoSample, videoTrack) {
        super.pushAccessUnit(VideoSample, videoTrack);
        if (this.initVPS) this.initVPS = null; // null initVPS to prevent possible track's sps/pps growth until next VPS
    }
    readVPS(vps) {
        const eg = new $99a156a15cd35eb3$var$ExpGolomb(vps);
        // remove header
        eg.readUByte();
        eg.readUByte();
        eg.readBits(4); // video_parameter_set_id
        eg.skipBits(2);
        eg.readBits(6); // max_layers_minus1
        const max_sub_layers_minus1 = eg.readBits(3);
        const temporal_id_nesting_flag = eg.readBoolean();
        // ...vui fps can be here, but empty fps value is not critical for metadata
        return {
            numTemporalLayers: max_sub_layers_minus1 + 1,
            temporalIdNested: temporal_id_nesting_flag
        };
    }
    readSPS(sps) {
        const eg = new $99a156a15cd35eb3$var$ExpGolomb(this.ebsp2rbsp(sps));
        eg.readUByte();
        eg.readUByte();
        eg.readBits(4); //video_parameter_set_id
        const max_sub_layers_minus1 = eg.readBits(3);
        eg.readBoolean(); // temporal_id_nesting_flag
        // profile_tier_level
        const general_profile_space = eg.readBits(2);
        const general_tier_flag = eg.readBoolean();
        const general_profile_idc = eg.readBits(5);
        const general_profile_compatibility_flags_1 = eg.readUByte();
        const general_profile_compatibility_flags_2 = eg.readUByte();
        const general_profile_compatibility_flags_3 = eg.readUByte();
        const general_profile_compatibility_flags_4 = eg.readUByte();
        const general_constraint_indicator_flags_1 = eg.readUByte();
        const general_constraint_indicator_flags_2 = eg.readUByte();
        const general_constraint_indicator_flags_3 = eg.readUByte();
        const general_constraint_indicator_flags_4 = eg.readUByte();
        const general_constraint_indicator_flags_5 = eg.readUByte();
        const general_constraint_indicator_flags_6 = eg.readUByte();
        const general_level_idc = eg.readUByte();
        const sub_layer_profile_present_flags = [];
        const sub_layer_level_present_flags = [];
        for(let i = 0; i < max_sub_layers_minus1; i++){
            sub_layer_profile_present_flags.push(eg.readBoolean());
            sub_layer_level_present_flags.push(eg.readBoolean());
        }
        if (max_sub_layers_minus1 > 0) for(let i = max_sub_layers_minus1; i < 8; i++)eg.readBits(2);
        for(let i = 0; i < max_sub_layers_minus1; i++){
            if (sub_layer_profile_present_flags[i]) {
                eg.readUByte(); // sub_layer_profile_space, sub_layer_tier_flag, sub_layer_profile_idc
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte(); // sub_layer_profile_compatibility_flag
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
            }
            if (sub_layer_level_present_flags[i]) eg.readUByte();
        }
        eg.readUEG(); // seq_parameter_set_id
        const chroma_format_idc = eg.readUEG();
        if (chroma_format_idc == 3) eg.skipBits(1); //separate_colour_plane_flag
        const pic_width_in_luma_samples = eg.readUEG();
        const pic_height_in_luma_samples = eg.readUEG();
        const conformance_window_flag = eg.readBoolean();
        let pic_left_offset = 0, pic_right_offset = 0, pic_top_offset = 0, pic_bottom_offset = 0;
        if (conformance_window_flag) {
            pic_left_offset += eg.readUEG();
            pic_right_offset += eg.readUEG();
            pic_top_offset += eg.readUEG();
            pic_bottom_offset += eg.readUEG();
        }
        const bit_depth_luma_minus8 = eg.readUEG();
        const bit_depth_chroma_minus8 = eg.readUEG();
        const log2_max_pic_order_cnt_lsb_minus4 = eg.readUEG();
        const sub_layer_ordering_info_present_flag = eg.readBoolean();
        for(let i = sub_layer_ordering_info_present_flag ? 0 : max_sub_layers_minus1; i <= max_sub_layers_minus1; i++){
            eg.skipUEG(); // max_dec_pic_buffering_minus1[i]
            eg.skipUEG(); // max_num_reorder_pics[i]
            eg.skipUEG(); // max_latency_increase_plus1[i]
        }
        eg.skipUEG(); // log2_min_luma_coding_block_size_minus3
        eg.skipUEG(); // log2_diff_max_min_luma_coding_block_size
        eg.skipUEG(); // log2_min_transform_block_size_minus2
        eg.skipUEG(); // log2_diff_max_min_transform_block_size
        eg.skipUEG(); // max_transform_hierarchy_depth_inter
        eg.skipUEG(); // max_transform_hierarchy_depth_intra
        const scaling_list_enabled_flag = eg.readBoolean();
        if (scaling_list_enabled_flag) {
            const sps_scaling_list_data_present_flag = eg.readBoolean();
            if (sps_scaling_list_data_present_flag) {
                for(let sizeId = 0; sizeId < 4; sizeId++)for(let matrixId = 0; matrixId < (sizeId === 3 ? 2 : 6); matrixId++){
                    const scaling_list_pred_mode_flag = eg.readBoolean();
                    if (!scaling_list_pred_mode_flag) eg.readUEG(); // scaling_list_pred_matrix_id_delta
                    else {
                        const coefNum = Math.min(64, 1 << 4 + (sizeId << 1));
                        if (sizeId > 1) eg.readEG();
                        for(let i = 0; i < coefNum; i++)eg.readEG();
                    }
                }
            }
        }
        eg.readBoolean(); // amp_enabled_flag
        eg.readBoolean(); // sample_adaptive_offset_enabled_flag
        const pcm_enabled_flag = eg.readBoolean();
        if (pcm_enabled_flag) {
            eg.readUByte();
            eg.skipUEG();
            eg.skipUEG();
            eg.readBoolean();
        }
        const num_short_term_ref_pic_sets = eg.readUEG();
        let num_delta_pocs = 0;
        for(let i = 0; i < num_short_term_ref_pic_sets; i++){
            let inter_ref_pic_set_prediction_flag = false;
            if (i !== 0) inter_ref_pic_set_prediction_flag = eg.readBoolean();
            if (inter_ref_pic_set_prediction_flag) {
                if (i === num_short_term_ref_pic_sets) eg.readUEG();
                eg.readBoolean();
                eg.readUEG();
                let next_num_delta_pocs = 0;
                for(let j = 0; j <= num_delta_pocs; j++){
                    const used_by_curr_pic_flag = eg.readBoolean();
                    let use_delta_flag = false;
                    if (!used_by_curr_pic_flag) use_delta_flag = eg.readBoolean();
                    if (used_by_curr_pic_flag || use_delta_flag) next_num_delta_pocs++;
                }
                num_delta_pocs = next_num_delta_pocs;
            } else {
                const num_negative_pics = eg.readUEG();
                const num_positive_pics = eg.readUEG();
                num_delta_pocs = num_negative_pics + num_positive_pics;
                for(let j = 0; j < num_negative_pics; j++){
                    eg.readUEG();
                    eg.readBoolean();
                }
                for(let j = 0; j < num_positive_pics; j++){
                    eg.readUEG();
                    eg.readBoolean();
                }
            }
        }
        const long_term_ref_pics_present_flag = eg.readBoolean();
        if (long_term_ref_pics_present_flag) {
            const num_long_term_ref_pics_sps = eg.readUEG();
            for(let i = 0; i < num_long_term_ref_pics_sps; i++){
                for(let j = 0; j < log2_max_pic_order_cnt_lsb_minus4 + 4; j++)eg.readBits(1);
                eg.readBits(1);
            }
        }
        let min_spatial_segmentation_idc = 0;
        let sar_width = 1, sar_height = 1;
        let fps_fixed = true, fps_den = 1, fps_num = 0;
        eg.readBoolean(); // sps_temporal_mvp_enabled_flag
        eg.readBoolean(); // strong_intra_smoothing_enabled_flag
        let default_display_window_flag = false;
        const vui_parameters_present_flag = eg.readBoolean();
        if (vui_parameters_present_flag) {
            const aspect_ratio_info_present_flag = eg.readBoolean();
            if (aspect_ratio_info_present_flag) {
                const aspect_ratio_idc = eg.readUByte();
                const sar_width_table = [
                    1,
                    12,
                    10,
                    16,
                    40,
                    24,
                    20,
                    32,
                    80,
                    18,
                    15,
                    64,
                    160,
                    4,
                    3,
                    2
                ];
                const sar_height_table = [
                    1,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    33,
                    99,
                    3,
                    2,
                    1
                ];
                if (aspect_ratio_idc > 0 && aspect_ratio_idc < 16) {
                    sar_width = sar_width_table[aspect_ratio_idc - 1];
                    sar_height = sar_height_table[aspect_ratio_idc - 1];
                } else if (aspect_ratio_idc === 255) {
                    sar_width = eg.readBits(16);
                    sar_height = eg.readBits(16);
                }
            }
            const overscan_info_present_flag = eg.readBoolean();
            if (overscan_info_present_flag) eg.readBoolean();
            const video_signal_type_present_flag = eg.readBoolean();
            if (video_signal_type_present_flag) {
                eg.readBits(3);
                eg.readBoolean();
                const colour_description_present_flag = eg.readBoolean();
                if (colour_description_present_flag) {
                    eg.readUByte();
                    eg.readUByte();
                    eg.readUByte();
                }
            }
            const chroma_loc_info_present_flag = eg.readBoolean();
            if (chroma_loc_info_present_flag) {
                eg.readUEG();
                eg.readUEG();
            }
            eg.readBoolean(); // neutral_chroma_indication_flag
            eg.readBoolean(); // field_seq_flag
            eg.readBoolean(); // frame_field_info_present_flag
            default_display_window_flag = eg.readBoolean();
            if (default_display_window_flag) {
                pic_left_offset += eg.readUEG();
                pic_right_offset += eg.readUEG();
                pic_top_offset += eg.readUEG();
                pic_bottom_offset += eg.readUEG();
            }
            const vui_timing_info_present_flag = eg.readBoolean();
            if (vui_timing_info_present_flag) {
                fps_den = eg.readBits(32);
                fps_num = eg.readBits(32);
                const vui_poc_proportional_to_timing_flag = eg.readBoolean();
                if (vui_poc_proportional_to_timing_flag) eg.readUEG();
                const vui_hrd_parameters_present_flag = eg.readBoolean();
                if (vui_hrd_parameters_present_flag) {
                    //const commonInfPresentFlag = true;
                    //if (commonInfPresentFlag) {
                    const nal_hrd_parameters_present_flag = eg.readBoolean();
                    const vcl_hrd_parameters_present_flag = eg.readBoolean();
                    let sub_pic_hrd_params_present_flag = false;
                    if (nal_hrd_parameters_present_flag || vcl_hrd_parameters_present_flag) {
                        sub_pic_hrd_params_present_flag = eg.readBoolean();
                        if (sub_pic_hrd_params_present_flag) {
                            eg.readUByte();
                            eg.readBits(5);
                            eg.readBoolean();
                            eg.readBits(5);
                        }
                        eg.readBits(4); // bit_rate_scale
                        eg.readBits(4); // cpb_size_scale
                        if (sub_pic_hrd_params_present_flag) eg.readBits(4);
                        eg.readBits(5);
                        eg.readBits(5);
                        eg.readBits(5);
                    }
                    //}
                    for(let i = 0; i <= max_sub_layers_minus1; i++){
                        fps_fixed = eg.readBoolean(); // fixed_pic_rate_general_flag
                        const fixed_pic_rate_within_cvs_flag = fps_fixed || eg.readBoolean();
                        let low_delay_hrd_flag = false;
                        if (fixed_pic_rate_within_cvs_flag) eg.readEG();
                        else low_delay_hrd_flag = eg.readBoolean();
                        const cpb_cnt = low_delay_hrd_flag ? 1 : eg.readUEG() + 1;
                        if (nal_hrd_parameters_present_flag) for(let j = 0; j < cpb_cnt; j++){
                            eg.readUEG();
                            eg.readUEG();
                            if (sub_pic_hrd_params_present_flag) {
                                eg.readUEG();
                                eg.readUEG();
                            }
                            eg.skipBits(1);
                        }
                        if (vcl_hrd_parameters_present_flag) for(let j = 0; j < cpb_cnt; j++){
                            eg.readUEG();
                            eg.readUEG();
                            if (sub_pic_hrd_params_present_flag) {
                                eg.readUEG();
                                eg.readUEG();
                            }
                            eg.skipBits(1);
                        }
                    }
                }
            }
            const bitstream_restriction_flag = eg.readBoolean();
            if (bitstream_restriction_flag) {
                eg.readBoolean(); // tiles_fixed_structure_flag
                eg.readBoolean(); // motion_vectors_over_pic_boundaries_flag
                eg.readBoolean(); // restricted_ref_pic_lists_flag
                min_spatial_segmentation_idc = eg.readUEG();
            }
        }
        let width = pic_width_in_luma_samples, height = pic_height_in_luma_samples;
        if (conformance_window_flag || default_display_window_flag) {
            let chroma_scale_w = 1, chroma_scale_h = 1;
            if (chroma_format_idc === 1) // YUV 420
            chroma_scale_w = chroma_scale_h = 2;
            else if (chroma_format_idc == 2) // YUV 422
            chroma_scale_w = 2;
            width = pic_width_in_luma_samples - chroma_scale_w * pic_right_offset - chroma_scale_w * pic_left_offset;
            height = pic_height_in_luma_samples - chroma_scale_h * pic_bottom_offset - chroma_scale_h * pic_top_offset;
        }
        const profile_space_string = general_profile_space ? [
            'A',
            'B',
            'C'
        ][general_profile_space] : '';
        const profile_compatibility_buf = general_profile_compatibility_flags_1 << 24 | general_profile_compatibility_flags_2 << 16 | general_profile_compatibility_flags_3 << 8 | general_profile_compatibility_flags_4;
        let profile_compatibility_rev = 0;
        for(let i = 0; i < 32; i++)profile_compatibility_rev = (profile_compatibility_rev | (profile_compatibility_buf >> i & 1) << 31 - i) >>> 0; // reverse bit position (and cast as UInt32)
        let profile_compatibility_flags_string = profile_compatibility_rev.toString(16);
        if (general_profile_idc === 1 && profile_compatibility_flags_string === '2') profile_compatibility_flags_string = '6';
        const tier_flag_string = general_tier_flag ? 'H' : 'L';
        return {
            codecString: `hvc1.${profile_space_string}${general_profile_idc}.${profile_compatibility_flags_string}.${tier_flag_string}${general_level_idc}.B0`,
            params: {
                general_tier_flag: general_tier_flag,
                general_profile_idc: general_profile_idc,
                general_profile_space: general_profile_space,
                general_profile_compatibility_flags: [
                    general_profile_compatibility_flags_1,
                    general_profile_compatibility_flags_2,
                    general_profile_compatibility_flags_3,
                    general_profile_compatibility_flags_4
                ],
                general_constraint_indicator_flags: [
                    general_constraint_indicator_flags_1,
                    general_constraint_indicator_flags_2,
                    general_constraint_indicator_flags_3,
                    general_constraint_indicator_flags_4,
                    general_constraint_indicator_flags_5,
                    general_constraint_indicator_flags_6
                ],
                general_level_idc: general_level_idc,
                bit_depth: bit_depth_luma_minus8 + 8,
                bit_depth_luma_minus8: bit_depth_luma_minus8,
                bit_depth_chroma_minus8: bit_depth_chroma_minus8,
                min_spatial_segmentation_idc: min_spatial_segmentation_idc,
                chroma_format_idc: chroma_format_idc,
                frame_rate: {
                    fixed: fps_fixed,
                    fps: fps_num / fps_den
                }
            },
            width: width,
            height: height,
            pixelRatio: [
                sar_width,
                sar_height
            ]
        };
    }
    readPPS(pps) {
        const eg = new $99a156a15cd35eb3$var$ExpGolomb(this.ebsp2rbsp(pps));
        eg.readUByte();
        eg.readUByte();
        eg.skipUEG(); // pic_parameter_set_id
        eg.skipUEG(); // seq_parameter_set_id
        eg.skipBits(2); // dependent_slice_segments_enabled_flag, output_flag_present_flag
        eg.skipBits(3); // num_extra_slice_header_bits
        eg.skipBits(2); // sign_data_hiding_enabled_flag, cabac_init_present_flag
        eg.skipUEG();
        eg.skipUEG();
        eg.skipEG(); // init_qp_minus26
        eg.skipBits(2); // constrained_intra_pred_flag, transform_skip_enabled_flag
        const cu_qp_delta_enabled_flag = eg.readBoolean();
        if (cu_qp_delta_enabled_flag) eg.skipUEG();
        eg.skipEG(); // cb_qp_offset
        eg.skipEG(); // cr_qp_offset
        eg.skipBits(4); // pps_slice_chroma_qp_offsets_present_flag, weighted_pred_flag, weighted_bipred_flag, transquant_bypass_enabled_flag
        const tiles_enabled_flag = eg.readBoolean();
        const entropy_coding_sync_enabled_flag = eg.readBoolean();
        let parallelismType = 1; // slice-based parallel decoding
        if (entropy_coding_sync_enabled_flag && tiles_enabled_flag) parallelismType = 0; // mixed-type parallel decoding
        else if (entropy_coding_sync_enabled_flag) parallelismType = 3; // wavefront-based parallel decoding
        else if (tiles_enabled_flag) parallelismType = 2; // tile-based parallel decoding
        return {
            parallelismType: parallelismType
        };
    }
    matchSPS(sps1, sps2) {
        // compare without headers and VPS related params
        return String.fromCharCode.apply(null, sps1).substr(3) === String.fromCharCode.apply(null, sps2).substr(3);
    }
}
const $99a156a15cd35eb3$var$PACKET_LENGTH = 188;
class $99a156a15cd35eb3$var$TSDemuxer {
    constructor(observer, config, typeSupported, logger){
        this.logger = void 0;
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.sampleAes = null;
        this.pmtParsed = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this._pmtId = -1;
        this._videoTrack = void 0;
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this._txtTrack = void 0;
        this.aacOverFlow = null;
        this.remainderData = null;
        this.videoParser = void 0;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.logger = logger;
        this.videoParser = null;
    }
    static probe(data, logger) {
        const syncOffset = $99a156a15cd35eb3$var$TSDemuxer.syncOffset(data);
        if (syncOffset > 0) logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
        return syncOffset !== -1;
    }
    static syncOffset(data) {
        const length = data.length;
        let scanwindow = Math.min($99a156a15cd35eb3$var$PACKET_LENGTH * 5, length - $99a156a15cd35eb3$var$PACKET_LENGTH) + 1;
        let i = 0;
        while(i < scanwindow){
            // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
            let foundPat = false;
            let packetStart = -1;
            let tsPackets = 0;
            for(let j = i; j < length; j += $99a156a15cd35eb3$var$PACKET_LENGTH){
                if (data[j] === 0x47 && (length - j === $99a156a15cd35eb3$var$PACKET_LENGTH || data[j + $99a156a15cd35eb3$var$PACKET_LENGTH] === 0x47)) {
                    tsPackets++;
                    if (packetStart === -1) {
                        packetStart = j;
                        // First sync word found at offset, increase scan length (#5251)
                        if (packetStart !== 0) scanwindow = Math.min(packetStart + $99a156a15cd35eb3$var$PACKET_LENGTH * 99, data.length - $99a156a15cd35eb3$var$PACKET_LENGTH) + 1;
                    }
                    if (!foundPat) foundPat = $99a156a15cd35eb3$var$parsePID(data, j) === 0;
                    // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
                    if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + $99a156a15cd35eb3$var$PACKET_LENGTH > scanwindow)) return packetStart;
                } else if (tsPackets) // Exit if sync word found, but does not contain contiguous packets
                return -1;
                else break;
            }
            i++;
        }
        return -1;
    }
    /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */ static createTrack(type, duration) {
        return {
            container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
            type: type,
            id: $99a156a15cd35eb3$var$RemuxerTrackIdConfig[type],
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0,
            duration: type === 'audio' ? duration : undefined
        };
    }
    /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */ resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this.pmtParsed = false;
        this._pmtId = -1;
        this._videoTrack = $99a156a15cd35eb3$var$TSDemuxer.createTrack('video');
        this._videoTrack.duration = trackDuration;
        this._audioTrack = $99a156a15cd35eb3$var$TSDemuxer.createTrack('audio', trackDuration);
        this._id3Track = $99a156a15cd35eb3$var$TSDemuxer.createTrack('id3');
        this._txtTrack = $99a156a15cd35eb3$var$TSDemuxer.createTrack('text');
        this._audioTrack.segmentCodec = 'aac';
        // flush any partial content
        this.aacOverFlow = null;
        this.remainderData = null;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
    }
    resetTimeStamp() {}
    resetContiguity() {
        const { _audioTrack: _audioTrack, _videoTrack: _videoTrack, _id3Track: _id3Track } = this;
        if (_audioTrack) _audioTrack.pesData = null;
        if (_videoTrack) _videoTrack.pesData = null;
        if (_id3Track) _id3Track.pesData = null;
        this.aacOverFlow = null;
        this.remainderData = null;
    }
    demux(data, timeOffset, isSampleAes = false, flush = false) {
        if (!isSampleAes) this.sampleAes = null;
        let pes;
        const videoTrack = this._videoTrack;
        const audioTrack = this._audioTrack;
        const id3Track = this._id3Track;
        const textTrack = this._txtTrack;
        let videoPid = videoTrack.pid;
        let videoData = videoTrack.pesData;
        let audioPid = audioTrack.pid;
        let id3Pid = id3Track.pid;
        let audioData = audioTrack.pesData;
        let id3Data = id3Track.pesData;
        let unknownPID = null;
        let pmtParsed = this.pmtParsed;
        let pmtId = this._pmtId;
        let len = data.length;
        if (this.remainderData) {
            data = $99a156a15cd35eb3$var$appendUint8Array(this.remainderData, data);
            len = data.length;
            this.remainderData = null;
        }
        if (len < $99a156a15cd35eb3$var$PACKET_LENGTH && !flush) {
            this.remainderData = data;
            return {
                audioTrack: audioTrack,
                videoTrack: videoTrack,
                id3Track: id3Track,
                textTrack: textTrack
            };
        }
        const syncOffset = Math.max(0, $99a156a15cd35eb3$var$TSDemuxer.syncOffset(data));
        len -= (len - syncOffset) % $99a156a15cd35eb3$var$PACKET_LENGTH;
        if (len < data.byteLength && !flush) this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
        // loop through TS packets
        let tsPacketErrors = 0;
        for(let start = syncOffset; start < len; start += $99a156a15cd35eb3$var$PACKET_LENGTH)if (data[start] === 0x47) {
            const stt = !!(data[start + 1] & 0x40);
            const pid = $99a156a15cd35eb3$var$parsePID(data, start);
            const atf = (data[start + 3] & 0x30) >> 4;
            // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
            let offset;
            if (atf > 1) {
                offset = start + 5 + data[start + 4];
                // continue if there is only adaptation field
                if (offset === start + $99a156a15cd35eb3$var$PACKET_LENGTH) continue;
            } else offset = start + 4;
            switch(pid){
                case videoPid:
                    if (stt) {
                        if (videoData && (pes = $99a156a15cd35eb3$var$parsePES(videoData, this.logger))) {
                            if (this.videoParser === null) switch(videoTrack.segmentCodec){
                                case 'avc':
                                    this.videoParser = new $99a156a15cd35eb3$var$AvcVideoParser();
                                    break;
                                case 'hevc':
                                    this.videoParser = new $99a156a15cd35eb3$var$HevcVideoParser();
                                    break;
                            }
                            if (this.videoParser !== null) this.videoParser.parsePES(videoTrack, textTrack, pes, false);
                        }
                        videoData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (videoData) {
                        videoData.data.push(data.subarray(offset, start + $99a156a15cd35eb3$var$PACKET_LENGTH));
                        videoData.size += start + $99a156a15cd35eb3$var$PACKET_LENGTH - offset;
                    }
                    break;
                case audioPid:
                    if (stt) {
                        if (audioData && (pes = $99a156a15cd35eb3$var$parsePES(audioData, this.logger))) switch(audioTrack.segmentCodec){
                            case 'aac':
                                this.parseAACPES(audioTrack, pes);
                                break;
                            case 'mp3':
                                this.parseMPEGPES(audioTrack, pes);
                                break;
                            case 'ac3':
                                this.parseAC3PES(audioTrack, pes);
                                break;
                        }
                        audioData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (audioData) {
                        audioData.data.push(data.subarray(offset, start + $99a156a15cd35eb3$var$PACKET_LENGTH));
                        audioData.size += start + $99a156a15cd35eb3$var$PACKET_LENGTH - offset;
                    }
                    break;
                case id3Pid:
                    if (stt) {
                        if (id3Data && (pes = $99a156a15cd35eb3$var$parsePES(id3Data, this.logger))) this.parseID3PES(id3Track, pes);
                        id3Data = {
                            data: [],
                            size: 0
                        };
                    }
                    if (id3Data) {
                        id3Data.data.push(data.subarray(offset, start + $99a156a15cd35eb3$var$PACKET_LENGTH));
                        id3Data.size += start + $99a156a15cd35eb3$var$PACKET_LENGTH - offset;
                    }
                    break;
                case 0:
                    if (stt) offset += data[offset] + 1;
                    pmtId = this._pmtId = $99a156a15cd35eb3$var$parsePAT(data, offset);
                    break;
                case pmtId:
                    {
                        if (stt) offset += data[offset] + 1;
                        const parsedPIDs = $99a156a15cd35eb3$var$parsePMT(data, offset, this.typeSupported, isSampleAes, this.observer, this.logger);
                        // only update track id if track PID found while parsing PMT
                        // this is to avoid resetting the PID to -1 in case
                        // track PID transiently disappears from the stream
                        // this could happen in case of transient missing audio samples for example
                        // NOTE this is only the PID of the track as found in TS,
                        // but we are not using this for MP4 track IDs.
                        videoPid = parsedPIDs.videoPid;
                        if (videoPid > 0) {
                            videoTrack.pid = videoPid;
                            videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
                        }
                        audioPid = parsedPIDs.audioPid;
                        if (audioPid > 0) {
                            audioTrack.pid = audioPid;
                            audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
                        }
                        id3Pid = parsedPIDs.id3Pid;
                        if (id3Pid > 0) id3Track.pid = id3Pid;
                        if (unknownPID !== null && !pmtParsed) {
                            this.logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                            unknownPID = null;
                            // we set it to -188, the += 188 in the for loop will reset start to 0
                            start = syncOffset - 188;
                        }
                        pmtParsed = this.pmtParsed = true;
                        break;
                    }
                case 0x11:
                case 0x1fff:
                    break;
                default:
                    unknownPID = pid;
                    break;
            }
        } else tsPacketErrors++;
        if (tsPacketErrors > 0) $99a156a15cd35eb3$var$emitParsingError(this.observer, new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`), undefined, this.logger);
        videoTrack.pesData = videoData;
        audioTrack.pesData = audioData;
        id3Track.pesData = id3Data;
        const demuxResult = {
            audioTrack: audioTrack,
            videoTrack: videoTrack,
            id3Track: id3Track,
            textTrack: textTrack
        };
        if (flush) this.extractRemainingSamples(demuxResult);
        return demuxResult;
    }
    flush() {
        const { remainderData: remainderData } = this;
        this.remainderData = null;
        let result;
        if (remainderData) result = this.demux(remainderData, -1, false, true);
        else result = {
            videoTrack: this._videoTrack,
            audioTrack: this._audioTrack,
            id3Track: this._id3Track,
            textTrack: this._txtTrack
        };
        this.extractRemainingSamples(result);
        if (this.sampleAes) return this.decrypt(result, this.sampleAes);
        return result;
    }
    extractRemainingSamples(demuxResult) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = demuxResult;
        const videoData = videoTrack.pesData;
        const audioData = audioTrack.pesData;
        const id3Data = id3Track.pesData;
        // try to parse last PES packets
        let pes;
        if (videoData && (pes = $99a156a15cd35eb3$var$parsePES(videoData, this.logger))) {
            if (this.videoParser === null) switch(videoTrack.segmentCodec){
                case 'avc':
                    this.videoParser = new $99a156a15cd35eb3$var$AvcVideoParser();
                    break;
                case 'hevc':
                    this.videoParser = new $99a156a15cd35eb3$var$HevcVideoParser();
                    break;
            }
            if (this.videoParser !== null) {
                this.videoParser.parsePES(videoTrack, textTrack, pes, true);
                videoTrack.pesData = null;
            }
        } else // either avcData null or PES truncated, keep it for next frag parsing
        videoTrack.pesData = videoData;
        if (audioData && (pes = $99a156a15cd35eb3$var$parsePES(audioData, this.logger))) {
            switch(audioTrack.segmentCodec){
                case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                case 'ac3':
                    this.parseAC3PES(audioTrack, pes);
                    break;
            }
            audioTrack.pesData = null;
        } else {
            if (audioData != null && audioData.size) this.logger.log('last AAC PES packet truncated,might overlap between fragments');
            // either audioData null or PES truncated, keep it for next frag parsing
            audioTrack.pesData = audioData;
        }
        if (id3Data && (pes = $99a156a15cd35eb3$var$parsePES(id3Data, this.logger))) {
            this.parseID3PES(id3Track, pes);
            id3Track.pesData = null;
        } else // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
        const sampleAes = this.sampleAes = new $99a156a15cd35eb3$var$SampleAesDecrypter(this.observer, this.config, keyData);
        return this.decrypt(demuxResult, sampleAes);
    }
    decrypt(demuxResult, sampleAes) {
        return new Promise((resolve)=>{
            const { audioTrack: audioTrack, videoTrack: videoTrack } = demuxResult;
            if (audioTrack.samples && audioTrack.segmentCodec === 'aac') sampleAes.decryptAacSamples(audioTrack.samples, 0, ()=>{
                if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                    resolve(demuxResult);
                });
                else resolve(demuxResult);
            });
            else if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                resolve(demuxResult);
            });
        });
    }
    destroy() {
        if (this.observer) this.observer.removeAllListeners();
        // @ts-ignore
        this.config = this.logger = this.observer = null;
        this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null;
        this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = undefined;
    }
    parseAACPES(track, pes) {
        let startOffset = 0;
        const aacOverFlow = this.aacOverFlow;
        let data = pes.data;
        if (aacOverFlow) {
            this.aacOverFlow = null;
            const frameMissingBytes = aacOverFlow.missing;
            const sampleLength = aacOverFlow.sample.unit.byteLength;
            // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
            if (frameMissingBytes === -1) data = $99a156a15cd35eb3$var$appendUint8Array(aacOverFlow.sample.unit, data);
            else {
                const frameOverflowBytes = sampleLength - frameMissingBytes;
                aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
                track.samples.push(aacOverFlow.sample);
                startOffset = aacOverFlow.missing;
            }
        }
        // look for ADTS header (0xFFFx)
        let offset;
        let len;
        for(offset = startOffset, len = data.length; offset < len - 1; offset++){
            if ($99a156a15cd35eb3$var$isHeader$1(data, offset)) break;
        }
        // if ADTS header does not start straight from the beginning of the PES payload, raise an error
        if (offset !== startOffset) {
            let reason;
            const recoverable = offset < len - 1;
            if (recoverable) reason = `AAC PES did not start with ADTS header,offset:${offset}`;
            else reason = 'No ADTS header found in AAC PES';
            $99a156a15cd35eb3$var$emitParsingError(this.observer, new Error(reason), recoverable, this.logger);
            if (!recoverable) return;
        }
        $99a156a15cd35eb3$var$initTrackConfig(track, this.observer, data, offset, this.audioCodec);
        let pts;
        if (pes.pts !== undefined) pts = pes.pts;
        else if (aacOverFlow) {
            // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
            // first sample PTS should be equal to last sample PTS + frameDuration
            const frameDuration = $99a156a15cd35eb3$var$getFrameDuration(track.samplerate);
            pts = aacOverFlow.sample.pts + frameDuration;
        } else {
            this.logger.warn('[tsdemuxer]: AAC PES unknown PTS');
            return;
        }
        // scan for aac samples
        let frameIndex = 0;
        let frame;
        while(offset < len){
            frame = $99a156a15cd35eb3$var$appendFrame$2(track, data, offset, pts, frameIndex);
            offset += frame.length;
            if (!frame.missing) {
                frameIndex++;
                for(; offset < len - 1; offset++){
                    if ($99a156a15cd35eb3$var$isHeader$1(data, offset)) break;
                }
            } else {
                this.aacOverFlow = frame;
                break;
            }
        }
    }
    parseMPEGPES(track, pes) {
        const data = pes.data;
        const length = data.length;
        let frameIndex = 0;
        let offset = 0;
        const pts = pes.pts;
        if (pts === undefined) {
            this.logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
            return;
        }
        while(offset < length)if ($99a156a15cd35eb3$var$isHeader(data, offset)) {
            const frame = $99a156a15cd35eb3$var$appendFrame$1(track, data, offset, pts, frameIndex);
            if (frame) {
                offset += frame.length;
                frameIndex++;
            } else break;
        } else // nothing found, keep looking
        offset++;
    }
    parseAC3PES(track, pes) {
        {
            const data = pes.data;
            const pts = pes.pts;
            if (pts === undefined) {
                this.logger.warn('[tsdemuxer]: AC3 PES unknown PTS');
                return;
            }
            const length = data.length;
            let frameIndex = 0;
            let offset = 0;
            let parsed;
            while(offset < length && (parsed = $99a156a15cd35eb3$var$appendFrame(track, data, offset, pts, frameIndex++)) > 0)offset += parsed;
        }
    }
    parseID3PES(id3Track, pes) {
        if (pes.pts === undefined) {
            this.logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
            return;
        }
        const id3Sample = $99a156a15cd35eb3$var$_extends({}, pes, {
            type: this._videoTrack ? $99a156a15cd35eb3$export$3f0d1211c87abf7f.emsg : $99a156a15cd35eb3$export$3f0d1211c87abf7f.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        id3Track.samples.push(id3Sample);
    }
}
function $99a156a15cd35eb3$var$parsePID(data, offset) {
    // pid is a 13-bit field starting at the last bit of TS[1]
    return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function $99a156a15cd35eb3$var$parsePAT(data, offset) {
    // skip the PSI header and parse the first PMT entry
    return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function $99a156a15cd35eb3$var$parsePMT(data, offset, typeSupported, isSampleAes, observer, logger) {
    const result = {
        audioPid: -1,
        videoPid: -1,
        id3Pid: -1,
        segmentVideoCodec: 'avc',
        segmentAudioCodec: 'aac'
    };
    const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
    const tableEnd = offset + 3 + sectionLength - 4;
    // to determine where the table is, we have to figure out how
    // long the program info descriptors are
    const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
    // advance the offset to the first entry in the mapping table
    offset += 12 + programInfoLength;
    while(offset < tableEnd){
        const pid = $99a156a15cd35eb3$var$parsePID(data, offset);
        const esInfoLength = (data[offset + 3] & 0x0f) << 8 | data[offset + 4];
        switch(data[offset]){
            case 0xcf:
                // SAMPLE-AES AAC
                if (!isSampleAes) {
                    $99a156a15cd35eb3$var$logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC', logger);
                    break;
                }
            /* falls through */ case 0x0f:
                // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                // logger.log('AAC PID:'  + pid);
                if (result.audioPid === -1) result.audioPid = pid;
                break;
            // Packetized metadata (ID3)
            case 0x15:
                // logger.log('ID3 PID:'  + pid);
                if (result.id3Pid === -1) result.id3Pid = pid;
                break;
            case 0xdb:
                // SAMPLE-AES AVC
                if (!isSampleAes) {
                    $99a156a15cd35eb3$var$logEncryptedSamplesFoundInUnencryptedStream('H.264', logger);
                    break;
                }
            /* falls through */ case 0x1b:
                // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                // logger.log('AVC PID:'  + pid);
                if (result.videoPid === -1) result.videoPid = pid;
                break;
            // ISO/IEC 11172-3 (MPEG-1 audio)
            // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
            case 0x03:
            case 0x04:
                // logger.log('MPEG PID:'  + pid);
                if (!typeSupported.mpeg && !typeSupported.mp3) logger.log('MPEG audio found, not supported in this browser');
                else if (result.audioPid === -1) {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'mp3';
                }
                break;
            case 0xc1:
                // SAMPLE-AES AC3
                if (!isSampleAes) {
                    $99a156a15cd35eb3$var$logEncryptedSamplesFoundInUnencryptedStream('AC-3', logger);
                    break;
                }
            /* falls through */ case 0x81:
                if (!typeSupported.ac3) logger.log('AC-3 audio found, not supported in this browser');
                else if (result.audioPid === -1) {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'ac3';
                }
                break;
            case 0x06:
                // stream_type 6 can mean a lot of different things in case of DVB.
                // We need to look at the descriptors. Right now, we're only interested
                // in AC-3 audio, so we do the descriptor parsing only when we don't have
                // an audio PID yet.
                if (result.audioPid === -1 && esInfoLength > 0) {
                    let parsePos = offset + 5;
                    let remaining = esInfoLength;
                    while(remaining > 2){
                        const descriptorId = data[parsePos];
                        switch(descriptorId){
                            case 0x6a:
                                if (typeSupported.ac3 !== true) logger.log('AC-3 audio found, not supported in this browser for now');
                                else {
                                    result.audioPid = pid;
                                    result.segmentAudioCodec = 'ac3';
                                }
                                break;
                        }
                        const descriptorLen = data[parsePos + 1] + 2;
                        parsePos += descriptorLen;
                        remaining -= descriptorLen;
                    }
                }
                break;
            case 0xc2:
            /* falls through */ case 0x87:
                $99a156a15cd35eb3$var$emitParsingError(observer, new Error('Unsupported EC-3 in M2TS found'), undefined, logger);
                return result;
            case 0x24:
                if (result.videoPid === -1) {
                    result.videoPid = pid;
                    result.segmentVideoCodec = 'hevc';
                    logger.log('HEVC in M2TS found');
                }
                break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += esInfoLength + 5;
    }
    return result;
}
function $99a156a15cd35eb3$var$emitParsingError(observer, error, levelRetry, logger) {
    logger.warn(`parsing error: ${error.message}`);
    observer.emit($99a156a15cd35eb3$export$ada873a34909da65.ERROR, $99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
        details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
        fatal: false,
        levelRetry: levelRetry,
        error: error,
        reason: error.message
    });
}
function $99a156a15cd35eb3$var$logEncryptedSamplesFoundInUnencryptedStream(type, logger) {
    logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function $99a156a15cd35eb3$var$parsePES(stream, logger) {
    let i = 0;
    let frag;
    let pesLen;
    let pesHdrLen;
    let pesPts;
    let pesDts;
    const data = stream.data;
    // safety check
    if (!stream || stream.size === 0) return null;
    // we might need up to 19 bytes to read PES header
    // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
    // usually only one merge is needed (and this is rare ...)
    while(data[0].length < 19 && data.length > 1){
        data[0] = $99a156a15cd35eb3$var$appendUint8Array(data[0], data[1]);
        data.splice(1, 1);
    }
    // retrieve PTS/DTS from first fragment
    frag = data[0];
    const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
    if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) return null;
        const pesFlags = frag[7];
        if (pesFlags & 0xc0) {
            /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */ pesPts = (frag[9] & 0x0e) * 536870912 + // 1 << 29
            (frag[10] & 0xff) * 4194304 + // 1 << 22
            (frag[11] & 0xfe) * 16384 + // 1 << 14
            (frag[12] & 0xff) * 128 + // 1 << 7
            (frag[13] & 0xfe) / 2;
            if (pesFlags & 0x40) {
                pesDts = (frag[14] & 0x0e) * 536870912 + // 1 << 29
                (frag[15] & 0xff) * 4194304 + // 1 << 22
                (frag[16] & 0xfe) * 16384 + // 1 << 14
                (frag[17] & 0xff) * 128 + // 1 << 7
                (frag[18] & 0xfe) / 2;
                if (pesPts - pesDts > 5400000) {
                    logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
                    pesPts = pesDts;
                }
            } else pesDts = pesPts;
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        let payloadStartOffset = pesHdrLen + 9;
        if (stream.size <= payloadStartOffset) return null;
        stream.size -= payloadStartOffset;
        // reassemble PES packet
        const pesData = new Uint8Array(stream.size);
        for(let j = 0, dataLen = data.length; j < dataLen; j++){
            frag = data[j];
            let len = frag.byteLength;
            if (payloadStartOffset) {
                if (payloadStartOffset > len) {
                    // trim full frag if PES header bigger than frag
                    payloadStartOffset -= len;
                    continue;
                } else {
                    // trim partial frag if PES header smaller than frag
                    frag = frag.subarray(payloadStartOffset);
                    len -= payloadStartOffset;
                    payloadStartOffset = 0;
                }
            }
            pesData.set(frag, i);
            i += len;
        }
        if (pesLen) // payload size : remove PES header + PES extension
        pesLen -= pesHdrLen + 3;
        return {
            data: pesData,
            pts: pesPts,
            dts: pesDts,
            len: pesLen
        };
    }
    return null;
}
/**
 *  AAC helper
 */ class $99a156a15cd35eb3$var$AAC {
    static getSilentFrame(codec, channelCount) {
        switch(codec){
            case 'mp4a.40.2':
                if (channelCount === 1) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 2) return new Uint8Array([
                    0x21,
                    0x00,
                    0x49,
                    0x90,
                    0x02,
                    0x19,
                    0x00,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 3) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x8e
                ]);
                else if (channelCount === 4) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x80,
                    0x2c,
                    0x80,
                    0x08,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 5) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 6) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x00,
                    0xb2,
                    0x00,
                    0x20,
                    0x08,
                    0xe0
                ]);
                break;
            // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
            default:
                if (channelCount === 1) // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x4e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x1c,
                    0x6,
                    0xf1,
                    0xc1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 2) // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 3) // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                break;
        }
        return undefined;
    }
}
/**
 * Generate MP4 Box
 */ const $99a156a15cd35eb3$var$UINT32_MAX = Math.pow(2, 32) - 1;
class $99a156a15cd35eb3$var$MP4 {
    static init() {
        $99a156a15cd35eb3$var$MP4.types = {
            avc1: [],
            // codingname
            avcC: [],
            hvc1: [],
            hvcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            '.mp3': [],
            dac3: [],
            'ac-3': [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: [],
            smhd: []
        };
        let i;
        for(i in $99a156a15cd35eb3$var$MP4.types)if ($99a156a15cd35eb3$var$MP4.types.hasOwnProperty(i)) $99a156a15cd35eb3$var$MP4.types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        const videoHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        const audioHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        $99a156a15cd35eb3$var$MP4.HDLR_TYPES = {
            video: videoHdlr,
            audio: audioHdlr
        };
        const dref = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        const stco = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        $99a156a15cd35eb3$var$MP4.STTS = $99a156a15cd35eb3$var$MP4.STSC = $99a156a15cd35eb3$var$MP4.STCO = stco;
        $99a156a15cd35eb3$var$MP4.STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        $99a156a15cd35eb3$var$MP4.VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
        $99a156a15cd35eb3$var$MP4.SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance
            0x00,
            0x00 // reserved
        ]);
        $99a156a15cd35eb3$var$MP4.STSD = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01
        ]); // entry_count
        const majorBrand = new Uint8Array([
            105,
            115,
            111,
            109
        ]); // isom
        const avc1Brand = new Uint8Array([
            97,
            118,
            99,
            49
        ]); // avc1
        const minorVersion = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        $99a156a15cd35eb3$var$MP4.FTYP = $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
        $99a156a15cd35eb3$var$MP4.DINF = $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.dinf, $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.dref, dref));
    }
    static box(type, ...payload) {
        let size = 8;
        let i = payload.length;
        const len = i;
        // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        const result = new Uint8Array(size);
        result[0] = size >> 24 & 0xff;
        result[1] = size >> 16 & 0xff;
        result[2] = size >> 8 & 0xff;
        result[3] = size & 0xff;
        result.set(type, 4);
        // copy the payload into the result
        for(i = 0, size = 8; i < len; i++){
            // copy payload[i] array @ offset size
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    }
    static hdlr(type) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.hdlr, $99a156a15cd35eb3$var$MP4.HDLR_TYPES[type]);
    }
    static mdat(data) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.mdat, data);
    }
    static mdhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.mdhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]));
    }
    static mdia(track) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.mdia, $99a156a15cd35eb3$var$MP4.mdhd(track.timescale || 0, track.duration || 0), $99a156a15cd35eb3$var$MP4.hdlr(track.type), $99a156a15cd35eb3$var$MP4.minf(track));
    }
    static mfhd(sequenceNumber) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            sequenceNumber >> 24,
            sequenceNumber >> 16 & 0xff,
            sequenceNumber >> 8 & 0xff,
            sequenceNumber & 0xff // sequence_number
        ]));
    }
    static minf(track) {
        if (track.type === 'audio') return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.minf, $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.smhd, $99a156a15cd35eb3$var$MP4.SMHD), $99a156a15cd35eb3$var$MP4.DINF, $99a156a15cd35eb3$var$MP4.stbl(track));
        else return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.minf, $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.vmhd, $99a156a15cd35eb3$var$MP4.VMHD), $99a156a15cd35eb3$var$MP4.DINF, $99a156a15cd35eb3$var$MP4.stbl(track));
    }
    static moof(sn, baseMediaDecodeTime, track) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.moof, $99a156a15cd35eb3$var$MP4.mfhd(sn), $99a156a15cd35eb3$var$MP4.traf(track, baseMediaDecodeTime));
    }
    static moov(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = $99a156a15cd35eb3$var$MP4.trak(tracks[i]);
        return $99a156a15cd35eb3$var$MP4.box.apply(null, [
            $99a156a15cd35eb3$var$MP4.types.moov,
            $99a156a15cd35eb3$var$MP4.mvhd(tracks[0].timescale || 0, tracks[0].duration || 0)
        ].concat(boxes).concat($99a156a15cd35eb3$var$MP4.mvex(tracks)));
    }
    static mvex(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = $99a156a15cd35eb3$var$MP4.trex(tracks[i]);
        return $99a156a15cd35eb3$var$MP4.box.apply(null, [
            $99a156a15cd35eb3$var$MP4.types.mvex,
            ...boxes
        ]);
    }
    static mvhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        const bytes = new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.mvhd, bytes);
    }
    static sdtp(track) {
        const samples = track.samples || [];
        const bytes = new Uint8Array(4 + samples.length);
        let i;
        let flags;
        // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.sdtp, bytes);
    }
    static stbl(track) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stbl, $99a156a15cd35eb3$var$MP4.stsd(track), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stts, $99a156a15cd35eb3$var$MP4.STTS), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsc, $99a156a15cd35eb3$var$MP4.STSC), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsz, $99a156a15cd35eb3$var$MP4.STSZ), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stco, $99a156a15cd35eb3$var$MP4.STCO));
    }
    static avc1(track) {
        let sps = [];
        let pps = [];
        let i;
        let data;
        let len;
        // assemble the SPSs
        for(i = 0; i < track.sps.length; i++){
            data = track.sps[i];
            len = data.byteLength;
            sps.push(len >>> 8 & 0xff);
            sps.push(len & 0xff);
            // SPS
            sps = sps.concat(Array.prototype.slice.call(data));
        }
        // assemble the PPSs
        for(i = 0; i < track.pps.length; i++){
            data = track.pps[i];
            len = data.byteLength;
            pps.push(len >>> 8 & 0xff);
            pps.push(len & 0xff);
            pps = pps.concat(Array.prototype.slice.call(data));
        }
        const avcc = $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.avcC, new Uint8Array([
            0x01,
            // version
            sps[3],
            // profile
            sps[4],
            // profile compat
            sps[5],
            // level
            255,
            // lengthSizeMinusOne, hard-coded to 4 bytes
            0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
        ].concat(sps).concat([
            track.pps.length // numOfPictureParameterSets
        ]).concat(pps))); // "PPS"
        const width = track.width;
        const height = track.height;
        const hSpacing = track.pixelRatio[0];
        const vSpacing = track.pixelRatio[1];
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.avc1, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            // pre_defined
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            width >> 8 & 0xff,
            width & 0xff,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            // height
            0x00,
            0x48,
            0x00,
            0x00,
            // horizresolution
            0x00,
            0x48,
            0x00,
            0x00,
            // vertresolution
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // frame_count
            0x12,
            0x64,
            0x61,
            0x69,
            0x6c,
            // dailymotion/hls.js
            0x79,
            0x6d,
            0x6f,
            0x74,
            0x69,
            0x6f,
            0x6e,
            0x2f,
            0x68,
            0x6c,
            0x73,
            0x2e,
            0x6a,
            0x73,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // compressorname
            0x00,
            0x18,
            // depth = 24
            0x11,
            0x11
        ]), // pre_defined = -1
        avcc, $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.btrt, new Uint8Array([
            0x00,
            0x1c,
            0x9c,
            0x80,
            // bufferSizeDB
            0x00,
            0x2d,
            0xc6,
            0xc0,
            // maxBitrate
            0x00,
            0x2d,
            0xc6,
            0xc0
        ])), // avgBitrate
        $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.pasp, new Uint8Array([
            hSpacing >> 24,
            // hSpacing
            hSpacing >> 16 & 0xff,
            hSpacing >> 8 & 0xff,
            hSpacing & 0xff,
            vSpacing >> 24,
            // vSpacing
            vSpacing >> 16 & 0xff,
            vSpacing >> 8 & 0xff,
            vSpacing & 0xff
        ])));
    }
    static esds(track) {
        const config = track.config;
        return new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x03,
            // descriptor_type
            0x19,
            // length
            0x00,
            0x01,
            // es_id
            0x00,
            // stream_priority
            0x04,
            // descriptor_type
            0x11,
            // length
            0x40,
            // codec : mpeg4_audio
            0x15,
            // stream_type
            0x00,
            0x00,
            0x00,
            // buffer_size
            0x00,
            0x00,
            0x00,
            0x00,
            // maxBitrate
            0x00,
            0x00,
            0x00,
            0x00,
            // avgBitrate
            0x05,
            // descriptor_type
            0x02,
            // length
            ...config,
            0x06,
            0x01,
            0x02 // GASpecificConfig)); // length + audio config descriptor
        ]);
    }
    static audioStsd(track) {
        const samplerate = track.samplerate || 0;
        return new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            track.channelCount || 0,
            // channelcount
            0x00,
            0x10,
            // sampleSize:16bits
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved2
            samplerate >> 8 & 0xff,
            samplerate & 0xff,
            //
            0x00,
            0x00
        ]);
    }
    static mp4a(track) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.mp4a, $99a156a15cd35eb3$var$MP4.audioStsd(track), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.esds, $99a156a15cd35eb3$var$MP4.esds(track)));
    }
    static mp3(track) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types['.mp3'], $99a156a15cd35eb3$var$MP4.audioStsd(track));
    }
    static ac3(track) {
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types['ac-3'], $99a156a15cd35eb3$var$MP4.audioStsd(track), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.dac3, track.config));
    }
    static stsd(track) {
        const { segmentCodec: segmentCodec } = track;
        if (track.type === 'audio') {
            if (segmentCodec === 'aac') return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsd, $99a156a15cd35eb3$var$MP4.STSD, $99a156a15cd35eb3$var$MP4.mp4a(track));
            if (segmentCodec === 'ac3' && track.config) return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsd, $99a156a15cd35eb3$var$MP4.STSD, $99a156a15cd35eb3$var$MP4.ac3(track));
            if (segmentCodec === 'mp3' && track.codec === 'mp3') return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsd, $99a156a15cd35eb3$var$MP4.STSD, $99a156a15cd35eb3$var$MP4.mp3(track));
        } else {
            if (track.pps && track.sps) {
                if (segmentCodec === 'avc') return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsd, $99a156a15cd35eb3$var$MP4.STSD, $99a156a15cd35eb3$var$MP4.avc1(track));
                if (segmentCodec === 'hevc' && track.vps) return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.stsd, $99a156a15cd35eb3$var$MP4.STSD, $99a156a15cd35eb3$var$MP4.hvc1(track));
            } else throw new Error(`video track missing pps or sps`);
        }
        throw new Error(`unsupported ${track.type} segment codec (${segmentCodec}/${track.codec})`);
    }
    static tkhd(track) {
        const id = track.id;
        const duration = (track.duration || 0) * (track.timescale || 0);
        const width = track.width || 0;
        const height = track.height || 0;
        const upperWordDuration = Math.floor(duration / ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.tkhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            id >> 24 & 0xff,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x00,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            width >> 8 & 0xff,
            width & 0xff,
            0x00,
            0x00,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            0x00,
            0x00 // height
        ]));
    }
    static traf(track, baseMediaDecodeTime) {
        const sampleDependencyTable = $99a156a15cd35eb3$var$MP4.sdtp(track);
        const id = track.id;
        const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % ($99a156a15cd35eb3$var$UINT32_MAX + 1));
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.traf, $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff // track_ID
        ])), $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            upperWordBaseMediaDecodeTime >> 24,
            upperWordBaseMediaDecodeTime >> 16 & 0xff,
            upperWordBaseMediaDecodeTime >> 8 & 0xff,
            upperWordBaseMediaDecodeTime & 0xff,
            lowerWordBaseMediaDecodeTime >> 24,
            lowerWordBaseMediaDecodeTime >> 16 & 0xff,
            lowerWordBaseMediaDecodeTime >> 8 & 0xff,
            lowerWordBaseMediaDecodeTime & 0xff
        ])), $99a156a15cd35eb3$var$MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
        20 + // tfdt
        8 + // traf header
        16 + // mfhd
        8 + // moof header
        8), // mdat header
        sampleDependencyTable);
    }
    /**
   * Generate a track box.
   * @param track a track definition
   */ static trak(track) {
        track.duration = track.duration || 0xffffffff;
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.trak, $99a156a15cd35eb3$var$MP4.tkhd(track), $99a156a15cd35eb3$var$MP4.mdia(track));
    }
    static trex(track) {
        const id = track.id;
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.trex, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]));
    }
    static trun(track, offset) {
        const samples = track.samples || [];
        const len = samples.length;
        const arraylen = 12 + 16 * len;
        const array = new Uint8Array(arraylen);
        let i;
        let sample;
        let duration;
        let size;
        let flags;
        let cts;
        offset += 8 + arraylen;
        array.set([
            track.type === 'video' ? 0x01 : 0x00,
            // version 1 for video with signed-int sample_composition_time_offset
            0x00,
            0x0f,
            0x01,
            // flags
            len >>> 24 & 0xff,
            len >>> 16 & 0xff,
            len >>> 8 & 0xff,
            len & 0xff,
            // sample_count
            offset >>> 24 & 0xff,
            offset >>> 16 & 0xff,
            offset >>> 8 & 0xff,
            offset & 0xff // data_offset
        ], 0);
        for(i = 0; i < len; i++){
            sample = samples[i];
            duration = sample.duration;
            size = sample.size;
            flags = sample.flags;
            cts = sample.cts;
            array.set([
                duration >>> 24 & 0xff,
                duration >>> 16 & 0xff,
                duration >>> 8 & 0xff,
                duration & 0xff,
                // sample_duration
                size >>> 24 & 0xff,
                size >>> 16 & 0xff,
                size >>> 8 & 0xff,
                size & 0xff,
                // sample_size
                flags.isLeading << 2 | flags.dependsOn,
                flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync,
                flags.degradPrio & 61440,
                flags.degradPrio & 0x0f,
                // sample_flags
                cts >>> 24 & 0xff,
                cts >>> 16 & 0xff,
                cts >>> 8 & 0xff,
                cts & 0xff // sample_composition_time_offset
            ], 12 + 16 * i);
        }
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.trun, array);
    }
    static initSegment(tracks) {
        if (!$99a156a15cd35eb3$var$MP4.types) $99a156a15cd35eb3$var$MP4.init();
        const movie = $99a156a15cd35eb3$var$MP4.moov(tracks);
        const result = $99a156a15cd35eb3$var$appendUint8Array($99a156a15cd35eb3$var$MP4.FTYP, movie);
        return result;
    }
    static hvc1(track) {
        const ps = track.params;
        const units = [
            track.vps,
            track.sps,
            track.pps
        ];
        const NALuLengthSize = 4;
        const config = new Uint8Array([
            0x01,
            ps.general_profile_space << 6 | (ps.general_tier_flag ? 32 : 0) | ps.general_profile_idc,
            ps.general_profile_compatibility_flags[0],
            ps.general_profile_compatibility_flags[1],
            ps.general_profile_compatibility_flags[2],
            ps.general_profile_compatibility_flags[3],
            ps.general_constraint_indicator_flags[0],
            ps.general_constraint_indicator_flags[1],
            ps.general_constraint_indicator_flags[2],
            ps.general_constraint_indicator_flags[3],
            ps.general_constraint_indicator_flags[4],
            ps.general_constraint_indicator_flags[5],
            ps.general_level_idc,
            240 | ps.min_spatial_segmentation_idc >> 8,
            255 & ps.min_spatial_segmentation_idc,
            252 | ps.parallelismType,
            252 | ps.chroma_format_idc,
            248 | ps.bit_depth_luma_minus8,
            248 | ps.bit_depth_chroma_minus8,
            0x00,
            parseInt(ps.frame_rate.fps),
            NALuLengthSize - 1 | ps.temporal_id_nested << 2 | ps.num_temporal_layers << 3 | (ps.frame_rate.fixed ? 64 : 0),
            units.length
        ]);
        // compute hvcC size in bytes
        let length = config.length;
        for(let i = 0; i < units.length; i += 1){
            length += 3;
            for(let j = 0; j < units[i].length; j += 1)length += 2 + units[i][j].length;
        }
        const hvcC = new Uint8Array(length);
        hvcC.set(config, 0);
        length = config.length;
        // append parameter set units: one vps, one or more sps and pps
        const iMax = units.length - 1;
        for(let i = 0; i < units.length; i += 1){
            hvcC.set(new Uint8Array([
                32 + i | (i === iMax ? 128 : 0),
                0x00,
                units[i].length
            ]), length);
            length += 3;
            for(let j = 0; j < units[i].length; j += 1){
                hvcC.set(new Uint8Array([
                    units[i][j].length >> 8,
                    units[i][j].length & 255
                ]), length);
                length += 2;
                hvcC.set(units[i][j], length);
                length += units[i][j].length;
            }
        }
        const hvcc = $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.hvcC, hvcC);
        const width = track.width;
        const height = track.height;
        const hSpacing = track.pixelRatio[0];
        const vSpacing = track.pixelRatio[1];
        return $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.hvc1, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            // pre_defined
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            width >> 8 & 0xff,
            width & 0xff,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            // height
            0x00,
            0x48,
            0x00,
            0x00,
            // horizresolution
            0x00,
            0x48,
            0x00,
            0x00,
            // vertresolution
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // frame_count
            0x12,
            0x64,
            0x61,
            0x69,
            0x6c,
            // dailymotion/hls.js
            0x79,
            0x6d,
            0x6f,
            0x74,
            0x69,
            0x6f,
            0x6e,
            0x2f,
            0x68,
            0x6c,
            0x73,
            0x2e,
            0x6a,
            0x73,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // compressorname
            0x00,
            0x18,
            // depth = 24
            0x11,
            0x11
        ]), // pre_defined = -1
        hvcc, $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.btrt, new Uint8Array([
            0x00,
            0x1c,
            0x9c,
            0x80,
            // bufferSizeDB
            0x00,
            0x2d,
            0xc6,
            0xc0,
            // maxBitrate
            0x00,
            0x2d,
            0xc6,
            0xc0
        ])), // avgBitrate
        $99a156a15cd35eb3$var$MP4.box($99a156a15cd35eb3$var$MP4.types.pasp, new Uint8Array([
            hSpacing >> 24,
            // hSpacing
            hSpacing >> 16 & 0xff,
            hSpacing >> 8 & 0xff,
            hSpacing & 0xff,
            vSpacing >> 24,
            // vSpacing
            vSpacing >> 16 & 0xff,
            vSpacing >> 8 & 0xff,
            vSpacing & 0xff
        ])));
    }
}
$99a156a15cd35eb3$var$MP4.types = void 0;
$99a156a15cd35eb3$var$MP4.HDLR_TYPES = void 0;
$99a156a15cd35eb3$var$MP4.STTS = void 0;
$99a156a15cd35eb3$var$MP4.STSC = void 0;
$99a156a15cd35eb3$var$MP4.STCO = void 0;
$99a156a15cd35eb3$var$MP4.STSZ = void 0;
$99a156a15cd35eb3$var$MP4.VMHD = void 0;
$99a156a15cd35eb3$var$MP4.SMHD = void 0;
$99a156a15cd35eb3$var$MP4.STSD = void 0;
$99a156a15cd35eb3$var$MP4.FTYP = void 0;
$99a156a15cd35eb3$var$MP4.DINF = void 0;
const $99a156a15cd35eb3$var$MPEG_TS_CLOCK_FREQ_HZ = 90000;
function $99a156a15cd35eb3$var$toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
    const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
    return round ? Math.round(result) : result;
}
function $99a156a15cd35eb3$var$toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
    return $99a156a15cd35eb3$var$toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function $99a156a15cd35eb3$var$toMsFromMpegTsClock(baseTime, round = false) {
    return $99a156a15cd35eb3$var$toTimescaleFromBase(baseTime, 1000, 1 / $99a156a15cd35eb3$var$MPEG_TS_CLOCK_FREQ_HZ, round);
}
function $99a156a15cd35eb3$var$toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
    return $99a156a15cd35eb3$var$toTimescaleFromBase(baseTime, $99a156a15cd35eb3$var$MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}
const $99a156a15cd35eb3$var$MAX_SILENT_FRAME_DURATION = 10000; // 10 seconds
const $99a156a15cd35eb3$var$AAC_SAMPLES_PER_FRAME = 1024;
const $99a156a15cd35eb3$var$MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
const $99a156a15cd35eb3$var$AC3_SAMPLES_PER_FRAME = 1536;
let $99a156a15cd35eb3$var$chromeVersion = null;
let $99a156a15cd35eb3$var$safariWebkitVersion = null;
function $99a156a15cd35eb3$var$createMp4Sample(isKeyframe, duration, size, cts) {
    return {
        duration: duration,
        size: size,
        cts: cts,
        flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: isKeyframe ? 2 : 1,
            isNonSync: isKeyframe ? 0 : 1
        }
    };
}
class $99a156a15cd35eb3$var$MP4Remuxer {
    constructor(observer, config, typeSupported, logger){
        this.logger = void 0;
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.ISGenerated = false;
        this._initPTS = null;
        this._initDTS = null;
        this.nextAvcDts = null;
        this.nextAudioPts = null;
        this.videoSampleDuration = null;
        this.isAudioContiguous = false;
        this.isVideoContiguous = false;
        this.videoTrackConfig = void 0;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.logger = logger;
        this.ISGenerated = false;
        if ($99a156a15cd35eb3$var$chromeVersion === null) {
            const userAgent = navigator.userAgent || '';
            const result = userAgent.match(/Chrome\/(\d+)/i);
            $99a156a15cd35eb3$var$chromeVersion = result ? parseInt(result[1]) : 0;
        }
        if ($99a156a15cd35eb3$var$safariWebkitVersion === null) {
            const result = navigator.userAgent.match(/Safari\/(\d+)/i);
            $99a156a15cd35eb3$var$safariWebkitVersion = result ? parseInt(result[1]) : 0;
        }
    }
    destroy() {
        // @ts-ignore
        this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
    }
    resetTimeStamp(defaultTimeStamp) {
        this.logger.log('[mp4-remuxer]: initPTS & initDTS reset');
        this._initPTS = this._initDTS = defaultTimeStamp;
    }
    resetNextTimestamp() {
        this.logger.log('[mp4-remuxer]: reset next timestamp');
        this.isVideoContiguous = false;
        this.isAudioContiguous = false;
    }
    resetInitSegment() {
        this.logger.log('[mp4-remuxer]: ISGenerated flag reset');
        this.ISGenerated = false;
        this.videoTrackConfig = undefined;
    }
    getVideoStartPts(videoSamples) {
        // Get the minimum PTS value relative to the first sample's PTS, normalized for 33-bit wrapping
        let rolloverDetected = false;
        const firstPts = videoSamples[0].pts;
        const startPTS = videoSamples.reduce((minPTS, sample)=>{
            let pts = sample.pts;
            let delta = pts - minPTS;
            if (delta < -4294967296) {
                // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
                rolloverDetected = true;
                pts = $99a156a15cd35eb3$var$normalizePts(pts, firstPts);
                delta = pts - minPTS;
            }
            if (delta > 0) return minPTS;
            return pts;
        }, firstPts);
        if (rolloverDetected) this.logger.debug('PTS rollover detected');
        return startPTS;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
        let video;
        let audio;
        let initSegment;
        let text;
        let id3;
        let independent;
        let audioTimeOffset = timeOffset;
        let videoTimeOffset = timeOffset;
        // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
        // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
        // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
        // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
        // then we can remux one track without waiting for the other.
        const hasAudio = audioTrack.pid > -1;
        const hasVideo = videoTrack.pid > -1;
        const length = videoTrack.samples.length;
        const enoughAudioSamples = audioTrack.samples.length > 0;
        const enoughVideoSamples = flush && length > 0 || length > 1;
        const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
        if (canRemuxAvc) {
            if (this.ISGenerated) {
                var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
                const config = this.videoTrackConfig;
                if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1])) || !config && enoughVideoSamples || this.nextAudioPts === null && enoughAudioSamples) this.resetInitSegment();
            }
            if (!this.ISGenerated) initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            const isVideoContiguous = this.isVideoContiguous;
            let firstKeyFrameIndex = -1;
            let firstKeyFramePTS;
            if (enoughVideoSamples) {
                firstKeyFrameIndex = $99a156a15cd35eb3$var$findKeyframeIndex(videoTrack.samples);
                if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
                    independent = true;
                    if (firstKeyFrameIndex > 0) {
                        this.logger.warn(`[mp4-remuxer]: Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
                        const startPTS = this.getVideoStartPts(videoTrack.samples);
                        videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
                        videoTrack.dropped += firstKeyFrameIndex;
                        videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
                        firstKeyFramePTS = videoTimeOffset;
                    } else if (firstKeyFrameIndex === -1) {
                        this.logger.warn(`[mp4-remuxer]: No keyframe found out of ${length} video samples`);
                        independent = false;
                    }
                }
            }
            if (this.ISGenerated) {
                if (enoughAudioSamples && enoughVideoSamples) {
                    // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                    // if first audio DTS is not aligned with first video DTS then we need to take that into account
                    // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                    // drift between audio and video streams
                    const startPTS = this.getVideoStartPts(videoTrack.samples);
                    const tsDelta = $99a156a15cd35eb3$var$normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
                    const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
                    audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
                    videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
                }
                // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
                if (enoughAudioSamples) {
                    // if initSegment was generated without audio samples, regenerate it again
                    if (!audioTrack.samplerate) {
                        this.logger.warn('[mp4-remuxer]: regenerate InitSegment as audio detected');
                        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                    }
                    audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO ? videoTimeOffset : undefined);
                    if (enoughVideoSamples) {
                        const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
                        // if initSegment was generated without video samples, regenerate it again
                        if (!videoTrack.inputTimeScale) {
                            this.logger.warn('[mp4-remuxer]: regenerate InitSegment as video detected');
                            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                        }
                        video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
                    }
                } else if (enoughVideoSamples) video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
                if (video) {
                    video.firstKeyFrame = firstKeyFrameIndex;
                    video.independent = firstKeyFrameIndex !== -1;
                    video.firstKeyFramePTS = firstKeyFramePTS;
                }
            }
        }
        // Allow ID3 and text to remux, even if more audio/video samples are required
        if (this.ISGenerated && this._initPTS && this._initDTS) {
            if (id3Track.samples.length) id3 = $99a156a15cd35eb3$var$flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
            if (textTrack.samples.length) text = $99a156a15cd35eb3$var$flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
        }
        return {
            audio: audio,
            video: video,
            initSegment: initSegment,
            independent: independent,
            text: text,
            id3: id3
        };
    }
    generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
        const audioSamples = audioTrack.samples;
        const videoSamples = videoTrack.samples;
        const typeSupported = this.typeSupported;
        const tracks = {};
        const _initPTS = this._initPTS;
        let computePTSDTS = !_initPTS || accurateTimeOffset;
        let container = 'audio/mp4';
        let initPTS;
        let initDTS;
        let timescale;
        let trackId;
        if (computePTSDTS) initPTS = initDTS = Infinity;
        if (audioTrack.config && audioSamples.length) {
            // let's use audio sampling rate as MP4 time scale.
            // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
            // using audio sampling rate here helps having an integer MP4 frame duration
            // this avoids potential rounding issue and AV sync issue
            audioTrack.timescale = audioTrack.samplerate;
            switch(audioTrack.segmentCodec){
                case 'mp3':
                    if (typeSupported.mpeg) {
                        // Chrome and Safari
                        container = 'audio/mpeg';
                        audioTrack.codec = '';
                    } else if (typeSupported.mp3) // Firefox
                    audioTrack.codec = 'mp3';
                    break;
                case 'ac3':
                    audioTrack.codec = 'ac-3';
                    break;
            }
            tracks.audio = {
                id: 'audio',
                container: container,
                codec: audioTrack.codec,
                initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : $99a156a15cd35eb3$var$MP4.initSegment([
                    audioTrack
                ]),
                metadata: {
                    channelCount: audioTrack.channelCount
                }
            };
            if (computePTSDTS) {
                trackId = audioTrack.id;
                timescale = audioTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) // remember first PTS of this demuxing context. for audio, PTS = DTS
                initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
                else computePTSDTS = false;
            }
        }
        if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
            // let's use input time scale as MP4 video timescale
            // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
            videoTrack.timescale = videoTrack.inputTimeScale;
            tracks.video = {
                id: 'main',
                container: 'video/mp4',
                codec: videoTrack.codec,
                initSegment: $99a156a15cd35eb3$var$MP4.initSegment([
                    videoTrack
                ]),
                metadata: {
                    width: videoTrack.width,
                    height: videoTrack.height
                }
            };
            if (computePTSDTS) {
                trackId = videoTrack.id;
                timescale = videoTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) {
                    const startPTS = this.getVideoStartPts(videoSamples);
                    const startOffset = Math.round(timescale * timeOffset);
                    initDTS = Math.min(initDTS, $99a156a15cd35eb3$var$normalizePts(videoSamples[0].dts, startPTS) - startOffset);
                    initPTS = Math.min(initPTS, startPTS - startOffset);
                } else computePTSDTS = false;
            }
            this.videoTrackConfig = {
                width: videoTrack.width,
                height: videoTrack.height,
                pixelRatio: videoTrack.pixelRatio
            };
        }
        if (Object.keys(tracks).length) {
            this.ISGenerated = true;
            if (computePTSDTS) {
                this._initPTS = {
                    baseTime: initPTS,
                    timescale: timescale
                };
                this._initDTS = {
                    baseTime: initDTS,
                    timescale: timescale
                };
            } else initPTS = timescale = undefined;
            return {
                tracks: tracks,
                initPTS: initPTS,
                timescale: timescale,
                trackId: trackId
            };
        }
    }
    remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
        const timeScale = track.inputTimeScale;
        const inputSamples = track.samples;
        const outputSamples = [];
        const nbSamples = inputSamples.length;
        const initPTS = this._initPTS;
        let nextAvcDts = this.nextAvcDts;
        let offset = 8;
        let mp4SampleDuration = this.videoSampleDuration;
        let firstDTS;
        let lastDTS;
        let minPTS = Number.POSITIVE_INFINITY;
        let maxPTS = Number.NEGATIVE_INFINITY;
        let sortSamples = false;
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        if (!contiguous || nextAvcDts === null) {
            const pts = timeOffset * timeScale;
            const cts = inputSamples[0].pts - $99a156a15cd35eb3$var$normalizePts(inputSamples[0].dts, inputSamples[0].pts);
            if ($99a156a15cd35eb3$var$chromeVersion && nextAvcDts !== null && Math.abs(pts - cts - nextAvcDts) < 15000) // treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
            contiguous = true;
            else // if not contiguous, let's use target timeOffset
            nextAvcDts = pts - cts;
        }
        // PTS is coded on 33bits, and can loop from -2^32 to 2^32
        // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
        const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
        for(let i = 0; i < nbSamples; i++){
            const sample = inputSamples[i];
            sample.pts = $99a156a15cd35eb3$var$normalizePts(sample.pts - initTime, nextAvcDts);
            sample.dts = $99a156a15cd35eb3$var$normalizePts(sample.dts - initTime, nextAvcDts);
            if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) sortSamples = true;
        }
        // sort video samples by DTS then PTS then demux id order
        if (sortSamples) inputSamples.sort(function(a, b) {
            const deltadts = a.dts - b.dts;
            const deltapts = a.pts - b.pts;
            return deltadts || deltapts;
        });
        // Get first/last DTS
        firstDTS = inputSamples[0].dts;
        lastDTS = inputSamples[inputSamples.length - 1].dts;
        // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
        // set this constant duration as being the avg delta between consecutive DTS.
        const inputDuration = lastDTS - firstDTS;
        const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;
        // if fragment are contiguous, detect hole/overlapping between fragments
        if (contiguous) {
            // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
            const delta = firstDTS - nextAvcDts;
            const foundHole = delta > averageSampleDuration;
            const foundOverlap = delta < -1;
            if (foundHole || foundOverlap) {
                if (foundHole) this.logger.warn(`${(track.segmentCodec || '').toUpperCase()}: ${$99a156a15cd35eb3$var$toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
                else this.logger.warn(`${(track.segmentCodec || '').toUpperCase()}: ${$99a156a15cd35eb3$var$toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
                if (!foundOverlap || nextAvcDts >= inputSamples[0].pts || $99a156a15cd35eb3$var$chromeVersion) {
                    firstDTS = nextAvcDts;
                    const firstPTS = inputSamples[0].pts - delta;
                    if (foundHole) {
                        inputSamples[0].dts = firstDTS;
                        inputSamples[0].pts = firstPTS;
                    } else {
                        let isPTSOrderRetained = true;
                        for(let i = 0; i < inputSamples.length; i++){
                            if (inputSamples[i].dts > firstPTS && isPTSOrderRetained) break;
                            const prevPTS = inputSamples[i].pts;
                            inputSamples[i].dts -= delta;
                            inputSamples[i].pts -= delta;
                            // check to see if this sample's PTS order has changed
                            // relative to the next one
                            if (i < inputSamples.length - 1) {
                                const nextSamplePTS = inputSamples[i + 1].pts;
                                const currentSamplePTS = inputSamples[i].pts;
                                const currentOrder = nextSamplePTS <= currentSamplePTS;
                                const prevOrder = nextSamplePTS <= prevPTS;
                                isPTSOrderRetained = currentOrder == prevOrder;
                            }
                        }
                    }
                    this.logger.log(`Video: Initial PTS/DTS adjusted: ${$99a156a15cd35eb3$var$toMsFromMpegTsClock(firstPTS, true)}/${$99a156a15cd35eb3$var$toMsFromMpegTsClock(firstDTS, true)}, delta: ${$99a156a15cd35eb3$var$toMsFromMpegTsClock(delta, true)} ms`);
                }
            }
        }
        firstDTS = Math.max(0, firstDTS);
        let nbNalu = 0;
        let naluLen = 0;
        let dtsStep = firstDTS;
        for(let i = 0; i < nbSamples; i++){
            // compute total/avc sample length and nb of NAL units
            const sample = inputSamples[i];
            const units = sample.units;
            const nbUnits = units.length;
            let sampleLen = 0;
            for(let j = 0; j < nbUnits; j++)sampleLen += units[j].data.length;
            naluLen += sampleLen;
            nbNalu += nbUnits;
            sample.length = sampleLen;
            // ensure sample monotonic DTS
            if (sample.dts < dtsStep) {
                sample.dts = dtsStep;
                dtsStep += averageSampleDuration / 4 | 0 || 1;
            } else dtsStep = sample.dts;
            minPTS = Math.min(sample.pts, minPTS);
            maxPTS = Math.max(sample.pts, maxPTS);
        }
        lastDTS = inputSamples[nbSamples - 1].dts;
        /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */ const mdatSize = naluLen + 4 * nbNalu + 8;
        let mdat;
        try {
            mdat = new Uint8Array(mdatSize);
        } catch (err) {
            this.observer.emit($99a156a15cd35eb3$export$ada873a34909da65.ERROR, $99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MUX_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.REMUX_ALLOC_ERROR,
                fatal: false,
                error: err,
                bytes: mdatSize,
                reason: `fail allocating video mdat ${mdatSize}`
            });
            return;
        }
        const view = new DataView(mdat.buffer);
        view.setUint32(0, mdatSize);
        mdat.set($99a156a15cd35eb3$var$MP4.types.mdat, 4);
        let stretchedLastFrame = false;
        let minDtsDelta = Number.POSITIVE_INFINITY;
        let minPtsDelta = Number.POSITIVE_INFINITY;
        let maxDtsDelta = Number.NEGATIVE_INFINITY;
        let maxPtsDelta = Number.NEGATIVE_INFINITY;
        for(let i = 0; i < nbSamples; i++){
            const VideoSample = inputSamples[i];
            const VideoSampleUnits = VideoSample.units;
            let mp4SampleLength = 0;
            // convert NALU bitstream to MP4 format (prepend NALU with size field)
            for(let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++){
                const unit = VideoSampleUnits[j];
                const unitData = unit.data;
                const unitDataLen = unit.data.byteLength;
                view.setUint32(offset, unitDataLen);
                offset += 4;
                mdat.set(unitData, offset);
                offset += unitDataLen;
                mp4SampleLength += 4 + unitDataLen;
            }
            // expected sample duration is the Decoding Timestamp diff of consecutive samples
            let ptsDelta;
            if (i < nbSamples - 1) {
                mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
                ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
            } else {
                const config = this.config;
                const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
                ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
                if (config.stretchShortVideoTrack && this.nextAudioPts !== null) {
                    // In some cases, a segment's audio track duration may exceed the video track duration.
                    // Since we've already remuxed audio, and we know how long the audio track is, we look to
                    // see if the delta to the next segment is longer than maxBufferHole.
                    // If so, playback would potentially get stuck, so we artificially inflate
                    // the duration of the last frame to minimize any potential gap between segments.
                    const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
                    const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioPts) - VideoSample.pts;
                    if (deltaToFrameEnd > gapTolerance) {
                        // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                        // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                        mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                        if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;
                        else stretchedLastFrame = true;
                        this.logger.log(`[mp4-remuxer]: It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
                    } else mp4SampleDuration = lastFrameDuration;
                } else mp4SampleDuration = lastFrameDuration;
            }
            const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
            minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
            maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
            minPtsDelta = Math.min(minPtsDelta, ptsDelta);
            maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
            outputSamples.push($99a156a15cd35eb3$var$createMp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
        }
        if (outputSamples.length) {
            if ($99a156a15cd35eb3$var$chromeVersion) {
                if ($99a156a15cd35eb3$var$chromeVersion < 70) {
                    // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
                    // https://code.google.com/p/chromium/issues/detail?id=229412
                    const flags = outputSamples[0].flags;
                    flags.dependsOn = 2;
                    flags.isNonSync = 0;
                }
            } else if ($99a156a15cd35eb3$var$safariWebkitVersion) // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
            // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
            {
                if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
                    this.logger.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
                    let dts = firstDTS;
                    for(let i = 0, len = outputSamples.length; i < len; i++){
                        const nextDts = dts + outputSamples[i].duration;
                        const pts = dts + outputSamples[i].cts;
                        if (i < len - 1) {
                            const nextPts = nextDts + outputSamples[i + 1].cts;
                            outputSamples[i].duration = nextPts - pts;
                        } else outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
                        outputSamples[i].cts = 0;
                        dts = nextDts;
                    }
                }
            }
        }
        // next AVC/HEVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
        mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
        this.nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
        this.videoSampleDuration = mp4SampleDuration;
        this.isVideoContiguous = true;
        const moof = $99a156a15cd35eb3$var$MP4.moof(track.sequenceNumber++, firstDTS, $99a156a15cd35eb3$var$_extends(track, {
            samples: outputSamples
        }));
        const type = 'video';
        const data = {
            data1: moof,
            data2: mdat,
            startPTS: minPTS / timeScale,
            endPTS: (maxPTS + mp4SampleDuration) / timeScale,
            startDTS: firstDTS / timeScale,
            endDTS: nextAvcDts / timeScale,
            type: type,
            hasAudio: false,
            hasVideo: true,
            nb: outputSamples.length,
            dropped: track.dropped
        };
        track.samples = [];
        track.dropped = 0;
        return data;
    }
    getSamplesPerFrame(track) {
        switch(track.segmentCodec){
            case 'mp3':
                return $99a156a15cd35eb3$var$MPEG_AUDIO_SAMPLE_PER_FRAME;
            case 'ac3':
                return $99a156a15cd35eb3$var$AC3_SAMPLES_PER_FRAME;
            default:
                return $99a156a15cd35eb3$var$AAC_SAMPLES_PER_FRAME;
        }
    }
    remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
        const inputTimeScale = track.inputTimeScale;
        const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
        const scaleFactor = inputTimeScale / mp4timeScale;
        const mp4SampleDuration = this.getSamplesPerFrame(track);
        const inputSampleDuration = mp4SampleDuration * scaleFactor;
        const initPTS = this._initPTS;
        const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
        const outputSamples = [];
        const alignedWithVideo = videoTimeOffset !== undefined;
        let inputSamples = track.samples;
        let offset = rawMPEG ? 0 : 8;
        let nextAudioPts = this.nextAudioPts || -1;
        // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);
        // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 20 audio frames distance
        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
        // this helps ensuring audio continuity
        // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
        const timeOffsetMpegTS = timeOffset * inputTimeScale;
        const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
        this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs($99a156a15cd35eb3$var$normalizePts(inputSamples[0].pts - initTime, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);
        // compute normalized PTS
        inputSamples.forEach(function(sample) {
            sample.pts = $99a156a15cd35eb3$var$normalizePts(sample.pts - initTime, timeOffsetMpegTS);
        });
        if (!contiguous || nextAudioPts < 0) {
            // filter out sample with negative PTS that are not playable anyway
            // if we don't remove these negative samples, they will shift all audio samples forward.
            // leading to audio overlap between current / next fragment
            inputSamples = inputSamples.filter((sample)=>sample.pts >= 0);
            // in case all samples have negative PTS, and have been filtered out, return now
            if (!inputSamples.length) return;
            if (videoTimeOffset === 0) // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
            nextAudioPts = 0;
            else if (accurateTimeOffset && !alignedWithVideo) // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
            nextAudioPts = Math.max(0, timeOffsetMpegTS);
            else // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
            nextAudioPts = inputSamples[0].pts;
        }
        // If the audio track is missing samples, the frames seem to get "left-shifted" within the
        // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
        // In an effort to prevent this from happening, we inject frames here where there are gaps.
        // When possible, we inject a silent frame; when that's not possible, we duplicate the last
        // frame.
        if (track.segmentCodec === 'aac') {
            const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
            for(let i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++){
                // First, let's see how far off this frame is from where we expect it to be
                const sample = inputSamples[i];
                const pts = sample.pts;
                const delta = pts - nextPts;
                const duration = Math.abs(1000 * delta / inputTimeScale);
                // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
                if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
                    if (i === 0) {
                        this.logger.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
                        this.nextAudioPts = nextAudioPts = nextPts = pts;
                    }
                } else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < $99a156a15cd35eb3$var$MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
                    let missing = Math.round(delta / inputSampleDuration);
                    // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
                    // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
                    nextPts = pts - missing * inputSampleDuration;
                    if (nextPts < 0) {
                        missing--;
                        nextPts += inputSampleDuration;
                    }
                    if (i === 0) this.nextAudioPts = nextAudioPts = nextPts;
                    this.logger.warn(`[mp4-remuxer]: Injecting ${missing} audio frame @ ${(nextPts / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
                    for(let j = 0; j < missing; j++){
                        const newStamp = Math.max(nextPts, 0);
                        let fillFrame = $99a156a15cd35eb3$var$AAC.getSilentFrame(track.parsedCodec || track.manifestCodec || track.codec, track.channelCount);
                        if (!fillFrame) {
                            this.logger.log('[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.');
                            fillFrame = sample.unit.subarray();
                        }
                        inputSamples.splice(i, 0, {
                            unit: fillFrame,
                            pts: newStamp
                        });
                        nextPts += inputSampleDuration;
                        i++;
                    }
                }
                sample.pts = nextPts;
                nextPts += inputSampleDuration;
            }
        }
        let firstPTS = null;
        let lastPTS = null;
        let mdat;
        let mdatSize = 0;
        let sampleLength = inputSamples.length;
        while(sampleLength--)mdatSize += inputSamples[sampleLength].unit.byteLength;
        for(let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++){
            const audioSample = inputSamples[j];
            const unit = audioSample.unit;
            let pts = audioSample.pts;
            if (lastPTS !== null) {
                // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
                // the previous sample
                const prevSample = outputSamples[j - 1];
                prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
            } else {
                if (contiguous && track.segmentCodec === 'aac') // set PTS/DTS to expected PTS/DTS
                pts = nextAudioPts;
                // remember first PTS of our audioSamples
                firstPTS = pts;
                if (mdatSize > 0) {
                    /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */ mdatSize += offset;
                    try {
                        mdat = new Uint8Array(mdatSize);
                    } catch (err) {
                        this.observer.emit($99a156a15cd35eb3$export$ada873a34909da65.ERROR, $99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MUX_ERROR,
                            details: $99a156a15cd35eb3$export$d053ec805ce391aa.REMUX_ALLOC_ERROR,
                            fatal: false,
                            error: err,
                            bytes: mdatSize,
                            reason: `fail allocating audio mdat ${mdatSize}`
                        });
                        return;
                    }
                    if (!rawMPEG) {
                        const view = new DataView(mdat.buffer);
                        view.setUint32(0, mdatSize);
                        mdat.set($99a156a15cd35eb3$var$MP4.types.mdat, 4);
                    }
                } else // no audio samples
                return;
            }
            mdat.set(unit, offset);
            const unitLen = unit.byteLength;
            offset += unitLen;
            // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
            // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
            // becomes the PTS diff with the previous sample
            outputSamples.push($99a156a15cd35eb3$var$createMp4Sample(true, mp4SampleDuration, unitLen, 0));
            lastPTS = pts;
        }
        // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
        const nbSamples = outputSamples.length;
        if (!nbSamples) return;
        // The next audio sample PTS should be equal to last sample PTS + duration
        const lastSample = outputSamples[outputSamples.length - 1];
        this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;
        // Set the track samples from inputSamples to outputSamples before remuxing
        const moof = rawMPEG ? new Uint8Array(0) : $99a156a15cd35eb3$var$MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, $99a156a15cd35eb3$var$_extends({}, track, {
            samples: outputSamples
        }));
        // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
        track.samples = [];
        const start = firstPTS / inputTimeScale;
        const end = nextAudioPts / inputTimeScale;
        const type = 'audio';
        const audioData = {
            data1: moof,
            data2: mdat,
            startPTS: start,
            endPTS: end,
            startDTS: start,
            endDTS: end,
            type: type,
            hasAudio: true,
            hasVideo: false,
            nb: nbSamples
        };
        this.isAudioContiguous = true;
        return audioData;
    }
}
function $99a156a15cd35eb3$var$normalizePts(value, reference) {
    let offset;
    if (reference === null) return value;
    if (reference < value) // - 2^33
    offset = -8589934592;
    else // + 2^33
    offset = 8589934592;
    /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */ while(Math.abs(value - reference) > 4294967296)value += offset;
    return value;
}
function $99a156a15cd35eb3$var$findKeyframeIndex(samples) {
    for(let i = 0; i < samples.length; i++){
        if (samples[i].key) return i;
    }
    return -1;
}
function $99a156a15cd35eb3$var$flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting id3 pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = $99a156a15cd35eb3$var$normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
        sample.dts = $99a156a15cd35eb3$var$normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    const samples = track.samples;
    track.samples = [];
    return {
        samples: samples
    };
}
function $99a156a15cd35eb3$var$flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting text pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = $99a156a15cd35eb3$var$normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    track.samples.sort((a, b)=>a.pts - b.pts);
    const samples = track.samples;
    track.samples = [];
    return {
        samples: samples
    };
}
class $99a156a15cd35eb3$var$PassThroughRemuxer {
    constructor(observer, config, typeSupported, logger){
        this.logger = void 0;
        this.emitInitSegment = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initData = void 0;
        this.initPTS = null;
        this.initTracks = void 0;
        this.lastEndTime = null;
        this.isVideoContiguous = false;
        this.logger = logger;
    }
    destroy() {}
    resetTimeStamp(defaultInitPTS) {
        this.initPTS = defaultInitPTS;
        this.lastEndTime = null;
    }
    resetNextTimestamp() {
        this.isVideoContiguous = false;
        this.lastEndTime = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.generateInitSegment($99a156a15cd35eb3$var$patchEncyptionData(initSegment, decryptdata));
        this.emitInitSegment = true;
    }
    generateInitSegment(initSegment) {
        let { audioCodec: audioCodec, videoCodec: videoCodec } = this;
        if (!(initSegment != null && initSegment.byteLength)) {
            this.initTracks = undefined;
            this.initData = undefined;
            return;
        }
        const initData = this.initData = $99a156a15cd35eb3$var$parseInitSegment(initSegment);
        // Get codec from initSegment
        if (initData.audio) audioCodec = $99a156a15cd35eb3$var$getParsedTrackCodec(initData.audio, $99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO, this.logger);
        if (initData.video) videoCodec = $99a156a15cd35eb3$var$getParsedTrackCodec(initData.video, $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO, this.logger);
        const tracks = {};
        if (initData.audio && initData.video) tracks.audiovideo = {
            container: 'video/mp4',
            codec: audioCodec + ',' + videoCodec,
            supplemental: initData.video.supplemental,
            initSegment: initSegment,
            id: 'main'
        };
        else if (initData.audio) tracks.audio = {
            container: 'audio/mp4',
            codec: audioCodec,
            initSegment: initSegment,
            id: 'audio'
        };
        else if (initData.video) tracks.video = {
            container: 'video/mp4',
            codec: videoCodec,
            supplemental: initData.video.supplemental,
            initSegment: initSegment,
            id: 'main'
        };
        else this.logger.warn('[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.');
        this.initTracks = tracks;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
        var _initData, _initData2;
        let { initPTS: initPTS, lastEndTime: lastEndTime } = this;
        const result = {
            audio: undefined,
            video: undefined,
            text: textTrack,
            id3: id3Track,
            initSegment: undefined
        };
        // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
        // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
        // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
        if (!$99a156a15cd35eb3$var$isFiniteNumber(lastEndTime)) lastEndTime = this.lastEndTime = timeOffset || 0;
        // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
        // audio or video (or both); adding it to video was an arbitrary choice.
        const data = videoTrack.samples;
        if (!(data != null && data.length)) return result;
        const initSegment = {
            initPTS: undefined,
            timescale: undefined,
            trackId: undefined
        };
        let initData = this.initData;
        if (!((_initData = initData) != null && _initData.length)) {
            this.generateInitSegment(data);
            initData = this.initData;
        }
        if (!((_initData2 = initData) != null && _initData2.length)) {
            // We can't remux if the initSegment could not be generated
            this.logger.warn('[passthrough-remuxer.ts]: Failed to generate initSegment.');
            return result;
        }
        if (this.emitInitSegment) {
            initSegment.tracks = this.initTracks;
            this.emitInitSegment = false;
        }
        const trackSampleData = $99a156a15cd35eb3$var$getSampleData(data, initData, this.logger);
        const audioSampleTimestamps = initData.audio ? trackSampleData[initData.audio.id] : null;
        const videoSampleTimestamps = initData.video ? trackSampleData[initData.video.id] : null;
        const videoStartTime = $99a156a15cd35eb3$var$toStartEndOrDefault(videoSampleTimestamps, Infinity);
        const audioStartTime = $99a156a15cd35eb3$var$toStartEndOrDefault(audioSampleTimestamps, Infinity);
        const videoEndTime = $99a156a15cd35eb3$var$toStartEndOrDefault(videoSampleTimestamps, 0, true);
        const audioEndTime = $99a156a15cd35eb3$var$toStartEndOrDefault(audioSampleTimestamps, 0, true);
        let baseOffsetSamples;
        let decodeTime = timeOffset;
        let duration = 0;
        if (audioSampleTimestamps && (!videoSampleTimestamps || !initPTS && audioStartTime < videoStartTime || initPTS && initPTS.trackId === initData.audio.id)) {
            initSegment.trackId = initData.audio.id;
            baseOffsetSamples = audioSampleTimestamps;
            duration = audioEndTime - audioStartTime;
        } else if (videoSampleTimestamps) {
            initSegment.trackId = initData.video.id;
            baseOffsetSamples = videoSampleTimestamps;
            duration = videoEndTime - videoStartTime;
        }
        if (baseOffsetSamples) {
            const timescale = baseOffsetSamples.timescale;
            decodeTime = baseOffsetSamples.start / timescale;
            initSegment.timescale = timescale;
            if (!initPTS) {
                initSegment.initPTS = baseOffsetSamples.start - timeOffset * timescale;
                this.initPTS = initPTS = {
                    baseTime: initSegment.initPTS,
                    timescale: timescale,
                    trackId: initSegment.trackId
                };
            }
        }
        if ((accurateTimeOffset || !initPTS) && ($99a156a15cd35eb3$var$isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || initSegment.timescale !== initPTS.timescale)) {
            initSegment.initPTS = decodeTime - timeOffset;
            if (initPTS && initPTS.timescale === 1) this.logger.warn(`Adjusting initPTS @${timeOffset} from ${initPTS.baseTime / initPTS.timescale} to ${initSegment.initPTS}`);
            this.initPTS = initPTS = {
                baseTime: initSegment.initPTS,
                timescale: 1
            };
        }
        const startTime = audioTrack ? decodeTime - initPTS.baseTime / initPTS.timescale : lastEndTime;
        $99a156a15cd35eb3$var$offsetStartDTS(initData, data, initPTS.baseTime / initPTS.timescale);
        const endTime = startTime + duration;
        if (duration > 0) this.lastEndTime = endTime;
        else {
            this.logger.warn('Duration parsed from mp4 should be greater than zero');
            this.resetNextTimestamp();
        }
        const hasAudio = !!initData.audio;
        const hasVideo = !!initData.video;
        let type = '';
        if (hasAudio) type += 'audio';
        if (hasVideo) type += 'video';
        const track = {
            data1: data,
            startPTS: startTime,
            startDTS: startTime,
            endPTS: endTime,
            endDTS: endTime,
            type: type,
            hasAudio: hasAudio,
            hasVideo: hasVideo,
            nb: 1,
            dropped: 0
        };
        result.audio = hasAudio && !hasVideo ? track : undefined;
        result.video = hasVideo ? track : undefined;
        const videoSampleCount = videoSampleTimestamps == null ? void 0 : videoSampleTimestamps.sampleCount;
        if (videoSampleCount) {
            const firstKeyFrame = videoSampleTimestamps.keyFrameIndex;
            const independent = firstKeyFrame !== -1;
            track.nb = videoSampleCount;
            track.dropped = firstKeyFrame === 0 || this.isVideoContiguous ? 0 : independent ? firstKeyFrame : videoSampleCount;
            track.independent = independent;
            track.firstKeyFrame = firstKeyFrame;
            if (independent && videoSampleTimestamps.keyFrameStart) track.firstKeyFramePTS = videoSampleTimestamps.keyFrameStart - initPTS.baseTime / initPTS.timescale;
            if (!this.isVideoContiguous) result.independent = independent;
            this.isVideoContiguous || (this.isVideoContiguous = independent);
            if (track.dropped) this.logger.warn(`fmp4 does not start with IDR: firstIDR ${firstKeyFrame}/${videoSampleCount} dropped: ${track.dropped} pts: ${track.firstKeyFramePTS || 'NA'}`);
        }
        result.initSegment = initSegment;
        result.id3 = $99a156a15cd35eb3$var$flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
        if (textTrack.samples.length) result.text = $99a156a15cd35eb3$var$flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
        return result;
    }
}
function $99a156a15cd35eb3$var$toStartEndOrDefault(trackTimes, defaultValue, end = false) {
    return (trackTimes == null ? void 0 : trackTimes.start) !== undefined ? (trackTimes.start + (end ? trackTimes.duration : 0)) / trackTimes.timescale : defaultValue;
}
function $99a156a15cd35eb3$var$isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
    if (initPTS === null) return true;
    // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
    const minDuration = Math.max(duration, 1);
    const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
    return Math.abs(startTime - timeOffset) > minDuration;
}
function $99a156a15cd35eb3$var$getParsedTrackCodec(track, type, logger) {
    const parsedCodec = track == null ? void 0 : track.codec;
    if (parsedCodec && parsedCodec.length > 4) return parsedCodec;
    if (type === $99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO) {
        if (parsedCodec === 'ec-3' || parsedCodec === 'ac-3' || parsedCodec === 'alac') return parsedCodec;
        if (parsedCodec === 'fLaC' || parsedCodec === 'Opus') {
            // Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
            const preferManagedMediaSource = false;
            return $99a156a15cd35eb3$var$getCodecCompatibleName(parsedCodec, preferManagedMediaSource);
        }
        logger.warn(`Unhandled audio codec "${parsedCodec}" in mp4 MAP`);
        return parsedCodec || 'mp4a';
    }
    // Provide defaults based on codec type
    // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
    logger.warn(`Unhandled video codec "${parsedCodec}" in mp4 MAP`);
    return parsedCodec || 'avc1';
}
let $99a156a15cd35eb3$var$now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
    $99a156a15cd35eb3$var$now = self.performance.now.bind(self.performance);
} catch (err) {
    $99a156a15cd35eb3$var$now = Date.now;
}
const $99a156a15cd35eb3$var$muxConfig = [
    {
        demux: $99a156a15cd35eb3$var$MP4Demuxer,
        remux: $99a156a15cd35eb3$var$PassThroughRemuxer
    },
    {
        demux: $99a156a15cd35eb3$var$TSDemuxer,
        remux: $99a156a15cd35eb3$var$MP4Remuxer
    },
    {
        demux: $99a156a15cd35eb3$var$AACDemuxer,
        remux: $99a156a15cd35eb3$var$MP4Remuxer
    },
    {
        demux: $99a156a15cd35eb3$var$MP3Demuxer,
        remux: $99a156a15cd35eb3$var$MP4Remuxer
    }
];
$99a156a15cd35eb3$var$muxConfig.splice(2, 0, {
    demux: $99a156a15cd35eb3$var$AC3Demuxer,
    remux: $99a156a15cd35eb3$var$MP4Remuxer
});
class $99a156a15cd35eb3$var$Transmuxer {
    constructor(observer, typeSupported, config, vendor, id, logger){
        this.asyncResult = false;
        this.logger = void 0;
        this.observer = void 0;
        this.typeSupported = void 0;
        this.config = void 0;
        this.id = void 0;
        this.demuxer = void 0;
        this.remuxer = void 0;
        this.decrypter = void 0;
        this.probe = void 0;
        this.decryptionPromise = null;
        this.transmuxConfig = void 0;
        this.currentTransmuxState = void 0;
        this.observer = observer;
        this.typeSupported = typeSupported;
        this.config = config;
        this.id = id;
        this.logger = logger;
    }
    configure(transmuxConfig) {
        this.transmuxConfig = transmuxConfig;
        if (this.decrypter) this.decrypter.reset();
    }
    push(data, decryptdata, chunkMeta, state) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = $99a156a15cd35eb3$var$now();
        let uintData = new Uint8Array(data);
        const { currentTransmuxState: currentTransmuxState, transmuxConfig: transmuxConfig } = this;
        if (state) this.currentTransmuxState = state;
        const { contiguous: contiguous, discontinuity: discontinuity, trackSwitch: trackSwitch, accurateTimeOffset: accurateTimeOffset, timeOffset: timeOffset, initSegmentChange: initSegmentChange } = state || currentTransmuxState;
        const { audioCodec: audioCodec, videoCodec: videoCodec, defaultInitPts: defaultInitPts, duration: duration, initSegmentData: initSegmentData } = transmuxConfig;
        const keyData = $99a156a15cd35eb3$var$getEncryptionType(uintData, decryptdata);
        if (keyData && $99a156a15cd35eb3$var$isFullSegmentEncryption(keyData.method)) {
            const decrypter = this.getDecrypter();
            const aesMode = $99a156a15cd35eb3$var$getAesModeFromFullSegmentMethod(keyData.method);
            // Software decryption is synchronous; webCrypto is not
            if (decrypter.isSync()) {
                // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
                // data is handled in the flush() call
                let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode);
                // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
                const loadingParts = chunkMeta.part > -1;
                if (loadingParts) {
                    const _data = decrypter.flush();
                    decryptedData = _data ? _data.buffer : _data;
                }
                if (!decryptedData) {
                    stats.executeEnd = $99a156a15cd35eb3$var$now();
                    return $99a156a15cd35eb3$var$emptyResult(chunkMeta);
                }
                uintData = new Uint8Array(decryptedData);
            } else {
                this.asyncResult = true;
                this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode).then((decryptedData)=>{
                    // Calling push here is important; if flush() is called while this is still resolving, this ensures that
                    // the decrypted data has been transmuxed
                    const result = this.push(decryptedData, null, chunkMeta);
                    this.decryptionPromise = null;
                    return result;
                });
                return this.decryptionPromise;
            }
        }
        const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
        if (resetMuxers) {
            const error = this.configureTransmuxer(uintData);
            if (error) {
                this.logger.warn(`[transmuxer] ${error.message}`);
                this.observer.emit($99a156a15cd35eb3$export$ada873a34909da65.ERROR, $99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
                    fatal: false,
                    error: error,
                    reason: error.message
                });
                stats.executeEnd = $99a156a15cd35eb3$var$now();
                return $99a156a15cd35eb3$var$emptyResult(chunkMeta);
            }
        }
        if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
        if (discontinuity || initSegmentChange || resetMuxers) this.resetInitialTimestamp(defaultInitPts);
        if (!contiguous) this.resetContiguity();
        const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        this.asyncResult = $99a156a15cd35eb3$var$isPromise(result);
        const currentState = this.currentTransmuxState;
        currentState.contiguous = true;
        currentState.discontinuity = false;
        currentState.trackSwitch = false;
        stats.executeEnd = $99a156a15cd35eb3$var$now();
        return result;
    }
    // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
    flush(chunkMeta) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = $99a156a15cd35eb3$var$now();
        const { decrypter: decrypter, currentTransmuxState: currentTransmuxState, decryptionPromise: decryptionPromise } = this;
        if (decryptionPromise) {
            this.asyncResult = true;
            // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
            // only flushing is required for async decryption
            return decryptionPromise.then(()=>{
                return this.flush(chunkMeta);
            });
        }
        const transmuxResults = [];
        const { timeOffset: timeOffset } = currentTransmuxState;
        if (decrypter) {
            // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
            // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
            // or for progressive downloads with small segments)
            const decryptedData = decrypter.flush();
            if (decryptedData) // Push always returns a TransmuxerResult if decryptdata is null
            transmuxResults.push(this.push(decryptedData.buffer, null, chunkMeta));
        }
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) {
            // If probing failed, then Hls.js has been given content its not able to handle
            stats.executeEnd = $99a156a15cd35eb3$var$now();
            const emptyResults = [
                $99a156a15cd35eb3$var$emptyResult(chunkMeta)
            ];
            if (this.asyncResult) return Promise.resolve(emptyResults);
            return emptyResults;
        }
        const demuxResultOrPromise = demuxer.flush(timeOffset);
        if ($99a156a15cd35eb3$var$isPromise(demuxResultOrPromise)) {
            this.asyncResult = true;
            // Decrypt final SAMPLE-AES samples
            return demuxResultOrPromise.then((demuxResult)=>{
                this.flushRemux(transmuxResults, demuxResult, chunkMeta);
                return transmuxResults;
            });
        }
        this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
        if (this.asyncResult) return Promise.resolve(transmuxResults);
        return transmuxResults;
    }
    flushRemux(transmuxResults, demuxResult, chunkMeta) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = demuxResult;
        const { accurateTimeOffset: accurateTimeOffset, timeOffset: timeOffset } = this.currentTransmuxState;
        this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? ' part: ' + chunkMeta.part : ''} of ${this.id === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN ? 'level' : 'track'} ${chunkMeta.level}`);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
        transmuxResults.push({
            remuxResult: remuxResult,
            chunkMeta: chunkMeta
        });
        chunkMeta.transmuxing.executeEnd = $99a156a15cd35eb3$var$now();
    }
    resetInitialTimestamp(defaultInitPts) {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetTimeStamp(defaultInitPts);
        remuxer.resetTimeStamp(defaultInitPts);
    }
    resetContiguity() {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetContiguity();
        remuxer.resetNextTimestamp();
    }
    resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
        remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
    }
    destroy() {
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = undefined;
        }
        if (this.remuxer) {
            this.remuxer.destroy();
            this.remuxer = undefined;
        }
    }
    transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
        let result;
        if (keyData && keyData.method === 'SAMPLE-AES') result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        else result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
        return result;
    }
    transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
        return {
            remuxResult: remuxResult,
            chunkMeta: chunkMeta
        };
    }
    transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
        return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then((demuxResult)=>{
            const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
            return {
                remuxResult: remuxResult,
                chunkMeta: chunkMeta
            };
        });
    }
    configureTransmuxer(data) {
        const { config: config, observer: observer, typeSupported: typeSupported } = this;
        // probe for content type
        let mux;
        for(let i = 0, len = $99a156a15cd35eb3$var$muxConfig.length; i < len; i++){
            var _muxConfig$i$demux;
            if ((_muxConfig$i$demux = $99a156a15cd35eb3$var$muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data, this.logger)) {
                mux = $99a156a15cd35eb3$var$muxConfig[i];
                break;
            }
        }
        if (!mux) return new Error('Failed to find demuxer by probing fragment data');
        // so let's check that current remuxer and demuxer are still valid
        const demuxer = this.demuxer;
        const remuxer = this.remuxer;
        const Remuxer = mux.remux;
        const Demuxer = mux.demux;
        if (!remuxer || !(remuxer instanceof Remuxer)) this.remuxer = new Remuxer(observer, config, typeSupported, this.logger);
        if (!demuxer || !(demuxer instanceof Demuxer)) {
            this.demuxer = new Demuxer(observer, config, typeSupported, this.logger);
            this.probe = Demuxer.probe;
        }
    }
    needsProbing(discontinuity, trackSwitch) {
        // in case of continuity change, or track switch
        // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
        return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
    }
    getDecrypter() {
        let decrypter = this.decrypter;
        if (!decrypter) decrypter = this.decrypter = new $99a156a15cd35eb3$var$Decrypter(this.config);
        return decrypter;
    }
}
function $99a156a15cd35eb3$var$getEncryptionType(data, decryptData) {
    let encryptionType = null;
    if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) encryptionType = decryptData;
    return encryptionType;
}
const $99a156a15cd35eb3$var$emptyResult = (chunkMeta)=>({
        remuxResult: {},
        chunkMeta: chunkMeta
    });
function $99a156a15cd35eb3$var$isPromise(p) {
    return 'then' in p && p.then instanceof Function;
}
class $99a156a15cd35eb3$var$TransmuxConfig {
    constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts){
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initSegmentData = void 0;
        this.duration = void 0;
        this.defaultInitPts = void 0;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.initSegmentData = initSegmentData;
        this.duration = duration;
        this.defaultInitPts = defaultInitPts || null;
    }
}
class $99a156a15cd35eb3$var$TransmuxState {
    constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange){
        this.discontinuity = void 0;
        this.contiguous = void 0;
        this.accurateTimeOffset = void 0;
        this.trackSwitch = void 0;
        this.timeOffset = void 0;
        this.initSegmentChange = void 0;
        this.discontinuity = discontinuity;
        this.contiguous = contiguous;
        this.accurateTimeOffset = accurateTimeOffset;
        this.trackSwitch = trackSwitch;
        this.timeOffset = timeOffset;
        this.initSegmentChange = initSegmentChange;
    }
}
let $99a156a15cd35eb3$var$transmuxerInstanceCount = 0;
class $99a156a15cd35eb3$var$TransmuxerInterface {
    constructor(_hls, id, onTransmuxComplete, onFlush){
        this.error = null;
        this.hls = void 0;
        this.id = void 0;
        this.instanceNo = $99a156a15cd35eb3$var$transmuxerInstanceCount++;
        this.observer = void 0;
        this.frag = null;
        this.part = null;
        this.useWorker = void 0;
        this.workerContext = null;
        this.transmuxer = null;
        this.onTransmuxComplete = void 0;
        this.onFlush = void 0;
        this.onWorkerMessage = (event)=>{
            const data = event.data;
            const hls = this.hls;
            if (!hls || !(data != null && data.event) || data.instanceNo !== this.instanceNo) return;
            switch(data.event){
                case 'init':
                    {
                        var _this$workerContext;
                        const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
                        if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
                        self.URL.revokeObjectURL(objectURL);
                        break;
                    }
                case 'transmuxComplete':
                    this.handleTransmuxComplete(data.data);
                    break;
                case 'flush':
                    this.onFlush(data.data);
                    break;
                // pass logs from the worker thread to the main logger
                case 'workerLog':
                    if (hls.logger[data.data.logType]) hls.logger[data.data.logType](data.data.message);
                    break;
                default:
                    data.data = data.data || {};
                    data.data.frag = this.frag;
                    data.data.part = this.part;
                    data.data.id = this.id;
                    hls.trigger(data.event, data.data);
                    break;
            }
        };
        this.onWorkerError = (event)=>{
            if (!this.hls) return;
            const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
            this.hls.config.enableWorker = false;
            this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`);
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_EXCEPTION,
                fatal: false,
                event: 'demuxerWorker',
                error: error
            });
        };
        const config = _hls.config;
        this.hls = _hls;
        this.id = id;
        this.useWorker = !!config.enableWorker;
        this.onTransmuxComplete = onTransmuxComplete;
        this.onFlush = onFlush;
        const forwardMessage = (ev, data)=>{
            data = data || {};
            data.frag = this.frag || undefined;
            if (ev === $99a156a15cd35eb3$export$ada873a34909da65.ERROR) {
                data;
                data.parent = this.id;
                data.part = this.part;
                this.error = data.error;
            }
            this.hls.trigger(ev, data);
        };
        // forward events to main thread
        this.observer = new $99a156a15cd35eb3$var$EventEmitter();
        this.observer.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_DECRYPTED, forwardMessage);
        this.observer.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, forwardMessage);
        const m2tsTypeSupported = $99a156a15cd35eb3$var$getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
        if (this.useWorker && typeof Worker !== 'undefined') {
            const logger = this.hls.logger;
            const canCreateWorker = config.workerPath || $99a156a15cd35eb3$var$hasUMDWorker();
            if (canCreateWorker) {
                try {
                    if (config.workerPath) {
                        logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
                        this.workerContext = $99a156a15cd35eb3$var$loadWorker(config.workerPath);
                    } else {
                        logger.log(`injecting Web Worker for "${id}"`);
                        this.workerContext = $99a156a15cd35eb3$var$injectWorker();
                    }
                    const { worker: worker } = this.workerContext;
                    worker.addEventListener('message', this.onWorkerMessage);
                    worker.addEventListener('error', this.onWorkerError);
                    worker.postMessage({
                        instanceNo: this.instanceNo,
                        cmd: 'init',
                        typeSupported: m2tsTypeSupported,
                        id: id,
                        config: $99a156a15cd35eb3$var$stringify(config)
                    });
                } catch (err) {
                    logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
                    this.terminateWorker();
                    this.error = null;
                    this.transmuxer = new $99a156a15cd35eb3$var$Transmuxer(this.observer, m2tsTypeSupported, config, '', id, _hls.logger);
                }
                return;
            }
        }
        this.transmuxer = new $99a156a15cd35eb3$var$Transmuxer(this.observer, m2tsTypeSupported, config, '', id, _hls.logger);
    }
    reset() {
        this.frag = null;
        this.part = null;
        if (this.workerContext) {
            const instanceNo = this.instanceNo;
            this.instanceNo = $99a156a15cd35eb3$var$transmuxerInstanceCount++;
            const config = this.hls.config;
            const m2tsTypeSupported = $99a156a15cd35eb3$var$getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
            this.workerContext.worker.postMessage({
                instanceNo: this.instanceNo,
                cmd: 'reset',
                resetNo: instanceNo,
                typeSupported: m2tsTypeSupported,
                id: this.id,
                config: $99a156a15cd35eb3$var$stringify(config)
            });
        }
    }
    terminateWorker() {
        if (this.workerContext) {
            const { worker: worker } = this.workerContext;
            this.workerContext = null;
            worker.removeEventListener('message', this.onWorkerMessage);
            worker.removeEventListener('error', this.onWorkerError);
            $99a156a15cd35eb3$var$removeWorkerFromStore(this.hls.config.workerPath);
        }
    }
    destroy() {
        if (this.workerContext) {
            this.terminateWorker();
            // @ts-ignore
            this.onWorkerMessage = this.onWorkerError = null;
        } else {
            const transmuxer = this.transmuxer;
            if (transmuxer) {
                transmuxer.destroy();
                this.transmuxer = null;
            }
        }
        const observer = this.observer;
        if (observer) observer.removeAllListeners();
        this.frag = null;
        this.part = null;
        // @ts-ignore
        this.observer = null;
        // @ts-ignore
        this.hls = null;
    }
    push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
        var _frag$initSegment, _lastFrag$initSegment;
        chunkMeta.transmuxing.start = self.performance.now();
        const { instanceNo: instanceNo, transmuxer: transmuxer } = this;
        const timeOffset = part ? part.start : frag.start;
        // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
        const decryptdata = frag.decryptdata;
        const lastFrag = this.frag;
        const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
        const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
        const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
        const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
        const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
        const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
        const now = self.performance.now();
        if (trackSwitch || snDiff || frag.stats.parsing.start === 0) frag.stats.parsing.start = now;
        if (part && (partDiff || !contiguous)) part.stats.parsing.start = now;
        const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
        const state = new $99a156a15cd35eb3$var$TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
        if (!contiguous || discontinuity || initSegmentChange) {
            this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${frag.type} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? ' part: ' + chunkMeta.part : ''} ${this.id === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN ? 'level' : 'track'}: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
            const config = new $99a156a15cd35eb3$var$TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
            this.configureTransmuxer(config);
        }
        this.frag = frag;
        this.part = part;
        // Frags with sn of 'initSegment' are not transmuxed
        if (this.workerContext) // post fragment payload as transferable objects for ArrayBuffer (no copy)
        this.workerContext.worker.postMessage({
            instanceNo: instanceNo,
            cmd: 'demux',
            data: data,
            decryptdata: decryptdata,
            chunkMeta: chunkMeta,
            state: state
        }, data instanceof ArrayBuffer ? [
            data
        ] : []);
        else if (transmuxer) {
            const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
            if ($99a156a15cd35eb3$var$isPromise(transmuxResult)) transmuxResult.then((data)=>{
                this.handleTransmuxComplete(data);
            }).catch((error)=>{
                this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
            });
            else this.handleTransmuxComplete(transmuxResult);
        }
    }
    flush(chunkMeta) {
        chunkMeta.transmuxing.start = self.performance.now();
        const { instanceNo: instanceNo, transmuxer: transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            instanceNo: instanceNo,
            cmd: 'flush',
            chunkMeta: chunkMeta
        });
        else if (transmuxer) {
            const transmuxResult = transmuxer.flush(chunkMeta);
            if ($99a156a15cd35eb3$var$isPromise(transmuxResult)) transmuxResult.then((data)=>{
                this.handleFlushResult(data, chunkMeta);
            }).catch((error)=>{
                this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
            });
            else this.handleFlushResult(transmuxResult, chunkMeta);
        }
    }
    transmuxerError(error, chunkMeta, reason) {
        if (!this.hls) return;
        this.error = error;
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
            chunkMeta: chunkMeta,
            frag: this.frag || undefined,
            part: this.part || undefined,
            fatal: false,
            error: error,
            err: error,
            reason: reason
        });
    }
    handleFlushResult(results, chunkMeta) {
        results.forEach((result)=>{
            this.handleTransmuxComplete(result);
        });
        this.onFlush(chunkMeta);
    }
    configureTransmuxer(config) {
        const { instanceNo: instanceNo, transmuxer: transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            instanceNo: instanceNo,
            cmd: 'configure',
            config: config
        });
        else if (transmuxer) transmuxer.configure(config);
    }
    handleTransmuxComplete(result) {
        result.chunkMeta.transmuxing.end = self.performance.now();
        this.onTransmuxComplete(result);
    }
}
const $99a156a15cd35eb3$var$TICK_INTERVAL$3 = 100; // how often to tick in ms
class $99a156a15cd35eb3$export$352c47a33fc91a8b extends $99a156a15cd35eb3$export$946cb951577581c9 {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, 'audio-stream-controller', $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO);
        this.mainAnchor = null;
        this.mainFragLoading = null;
        this.audioOnly = false;
        this.bufferedTrack = null;
        this.switchingTrack = null;
        this.trackId = -1;
        this.waitingData = null;
        this.mainDetails = null;
        this.flushing = false;
        this.bufferFlushed = false;
        this.cachedTrackLoadedData = null;
        this.registerListeners();
    }
    onHandlerDestroying() {
        this.unregisterListeners();
        super.onHandlerDestroying();
        this.resetItem();
    }
    resetItem() {
        this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
    }
    registerListeners() {
        super.registerListeners();
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        super.unregisterListeners();
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
    onInitPtsFound(event, { frag: frag, id: id, initPTS: initPTS, timescale: timescale }) {
        // Always update the new INIT PTS
        // Can change due level switch
        if (id === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN) {
            const cc = frag.cc;
            const inFlightFrag = this.fragCurrent;
            this.initPTS[cc] = {
                baseTime: initPTS,
                timescale: timescale
            };
            this.log(`InitPTS for cc: ${cc} found from main: ${initPTS}/${timescale}`);
            this.mainAnchor = frag;
            // If we are waiting, tick immediately to unblock audio fragment transmuxing
            if (this.state === $99a156a15cd35eb3$var$State.WAITING_INIT_PTS) {
                const waitingData = this.waitingData;
                if (!waitingData && !this.loadingParts || waitingData && waitingData.frag.cc !== cc) this.syncWithAnchor(frag, waitingData == null ? void 0 : waitingData.frag);
            } else if (!this.hls.hasEnoughToStart && inFlightFrag && inFlightFrag.cc !== cc) {
                inFlightFrag.abortRequests();
                this.syncWithAnchor(frag, inFlightFrag);
            } else if (this.state === $99a156a15cd35eb3$var$State.IDLE) this.tick();
        }
    }
    getLoadPosition() {
        if (!this.startFragRequested && this.nextLoadPosition >= 0) return this.nextLoadPosition;
        return super.getLoadPosition();
    }
    syncWithAnchor(mainAnchor, waitingToAppend) {
        var _this$mainFragLoading;
        // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
        const mainFragLoading = ((_this$mainFragLoading = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading.frag) || null;
        if (waitingToAppend) {
            if ((mainFragLoading == null ? void 0 : mainFragLoading.cc) === waitingToAppend.cc) // Wait for loading frag to complete and INIT_PTS_FOUND
            return;
        }
        const targetDiscontinuity = (mainFragLoading || mainAnchor).cc;
        const trackDetails = this.getLevelDetails();
        const pos = this.getLoadPosition();
        const syncFrag = $99a156a15cd35eb3$var$findNearestWithCC(trackDetails, targetDiscontinuity, pos);
        // Only stop waiting for audioFrag.cc if an audio segment of the same discontinuity domain (cc) is found
        if (syncFrag) {
            this.log(`Waiting fragment cc (${waitingToAppend == null ? void 0 : waitingToAppend.cc}) cancelled because video is at cc ${mainAnchor.cc}`);
            this.startFragRequested = false;
            this.nextLoadPosition = syncFrag.start;
            this.resetLoadingState();
            if (this.state === $99a156a15cd35eb3$var$State.IDLE) this.doTickIdle();
        }
    }
    startLoad(startPosition, skipSeekToStartPosition) {
        if (!this.levels) {
            this.startPosition = startPosition;
            this.state = $99a156a15cd35eb3$var$State.STOPPED;
            return;
        }
        const lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        this.setInterval($99a156a15cd35eb3$var$TICK_INTERVAL$3);
        if (lastCurrentTime > 0 && startPosition === -1) {
            this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
            startPosition = lastCurrentTime;
            this.state = $99a156a15cd35eb3$var$State.IDLE;
        } else this.state = $99a156a15cd35eb3$var$State.WAITING_TRACK;
        this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
        this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
        this.tick();
    }
    doTick() {
        switch(this.state){
            case $99a156a15cd35eb3$var$State.IDLE:
                this.doTickIdle();
                break;
            case $99a156a15cd35eb3$var$State.WAITING_TRACK:
                {
                    const { levels: levels, trackId: trackId } = this;
                    const currenTrack = levels == null ? void 0 : levels[trackId];
                    const details = currenTrack == null ? void 0 : currenTrack.details;
                    if (details && !this.waitForLive(currenTrack)) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = $99a156a15cd35eb3$var$State.WAITING_INIT_PTS;
                    }
                    break;
                }
            case $99a156a15cd35eb3$var$State.FRAG_LOADING_WAITING_RETRY:
                {
                    var _this$media;
                    const now = performance.now();
                    const retryDate = this.retryDate;
                    // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                    if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
                        const { levels: levels, trackId: trackId } = this;
                        this.log('RetryDate reached, switch back to IDLE state');
                        this.resetStartWhenNotLoaded((levels == null ? void 0 : levels[trackId]) || null);
                        this.state = $99a156a15cd35eb3$var$State.IDLE;
                    }
                    break;
                }
            case $99a156a15cd35eb3$var$State.WAITING_INIT_PTS:
                {
                    // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                    const waitingData = this.waitingData;
                    if (waitingData) {
                        const { frag: frag, part: part, cache: cache, complete: complete } = waitingData;
                        const mainAnchor = this.mainAnchor;
                        if (this.initPTS[frag.cc] !== undefined) {
                            this.waitingData = null;
                            this.state = $99a156a15cd35eb3$var$State.FRAG_LOADING;
                            const payload = cache.flush().buffer;
                            const data = {
                                frag: frag,
                                part: part,
                                payload: payload,
                                networkDetails: null
                            };
                            this._handleFragmentLoadProgress(data);
                            if (complete) super._handleFragmentLoadComplete(data);
                        } else if (mainAnchor && mainAnchor.cc !== waitingData.frag.cc) this.syncWithAnchor(mainAnchor, waitingData.frag);
                    } else this.state = $99a156a15cd35eb3$var$State.IDLE;
                }
        }
        this.onTickEnd();
    }
    resetLoadingState() {
        const waitingData = this.waitingData;
        if (waitingData) {
            this.fragmentTracker.removeFragment(waitingData.frag);
            this.waitingData = null;
        }
        super.resetLoadingState();
    }
    onTickEnd() {
        const { media: media } = this;
        if (!(media != null && media.readyState)) // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
        return;
        this.lastCurrentTime = media.currentTime;
    }
    doTickIdle() {
        var _this$mainFragLoading2;
        const { hls: hls, levels: levels, media: media, trackId: trackId } = this;
        const config = hls.config;
        // 1. if buffering is suspended
        // 2. if video not attached AND
        //    start fragment already requested OR start frag prefetch not enabled
        // 3. if tracks or track not loaded and selected
        // then exit loop
        // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
        if (!this.buffering || !media && !this.primaryPrefetch && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) return;
        const levelInfo = levels[trackId];
        const trackDetails = levelInfo.details;
        if (!trackDetails || this.waitForLive(levelInfo) || this.waitForCdnTuneIn(trackDetails)) {
            this.state = $99a156a15cd35eb3$var$State.WAITING_TRACK;
            this.startFragRequested = false;
            return;
        }
        const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
        if (this.bufferFlushed && bufferable) {
            this.bufferFlushed = false;
            this.afterBufferFlushed(bufferable, $99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO, $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO);
        }
        const bufferInfo = this.getFwdBufferInfo(bufferable, $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO);
        if (bufferInfo === null) return;
        if (!this.switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_EOS, {
                type: 'audio'
            });
            this.state = $99a156a15cd35eb3$var$State.ENDED;
            return;
        }
        const bufferLen = bufferInfo.len;
        const maxBufLen = hls.maxBufferLength;
        const fragments = trackDetails.fragments;
        const start = fragments[0].start;
        const loadPosition = this.getLoadPosition();
        const targetBufferTime = this.flushing ? loadPosition : bufferInfo.end;
        if (this.switchingTrack && media) {
            const pos = loadPosition;
            // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
            if (trackDetails.PTSKnown && pos < start) // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
            {
                if (bufferInfo.end > start || bufferInfo.nextStart) {
                    this.log('Alt audio track ahead of main track, seek to start of alt audio track');
                    media.currentTime = start + 0.05;
                }
            }
        }
        // if buffer length is less than maxBufLen, or near the end, find a fragment to load
        if (bufferLen >= maxBufLen && !this.switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) return;
        let frag = this.getNextFragment(targetBufferTime, trackDetails);
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN, maxBufLen);
        if (!frag) {
            this.bufferFlushed = true;
            return;
        }
        // Request audio segments up to one fragment ahead of main stream-controller
        let mainFragLoading = ((_this$mainFragLoading2 = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading2.frag) || null;
        if (!this.audioOnly && this.startFragRequested && mainFragLoading && $99a156a15cd35eb3$var$isMediaFragment(frag) && !frag.endList && (!trackDetails.live || !this.loadingParts && targetBufferTime < this.hls.liveSyncPosition)) {
            if (this.fragmentTracker.getState(mainFragLoading) === $99a156a15cd35eb3$var$FragmentState.OK) this.mainFragLoading = mainFragLoading = null;
            if (mainFragLoading && $99a156a15cd35eb3$var$isMediaFragment(mainFragLoading)) {
                if (frag.start > mainFragLoading.end) {
                    // Get buffered frag at target position from tracker (loaded out of sequence)
                    const mainFragAtPos = this.fragmentTracker.getFragAtPos(targetBufferTime, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
                    if (mainFragAtPos && mainFragAtPos.end > mainFragLoading.end) {
                        mainFragLoading = mainFragAtPos;
                        this.mainFragLoading = {
                            frag: mainFragAtPos,
                            targetBufferTime: null
                        };
                    }
                }
                const atBufferSyncLimit = frag.start > mainFragLoading.end;
                if (atBufferSyncLimit) return;
            }
        }
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    onMediaDetaching(event, data) {
        this.bufferFlushed = this.flushing = false;
        super.onMediaDetaching(event, data);
    }
    onAudioTracksUpdated(event, { audioTracks: audioTracks }) {
        // Reset tranxmuxer is essential for large context switches (Content Steering)
        this.resetTransmuxer();
        this.levels = audioTracks.map((mediaPlaylist)=>new $99a156a15cd35eb3$export$ca664994d1d54bff(mediaPlaylist));
    }
    onAudioTrackSwitching(event, data) {
        // if any URL found on new audio track, it is an alternate audio track
        const altAudio = !!data.url;
        this.trackId = data.id;
        const { fragCurrent: fragCurrent } = this;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.removeUnbufferedFrags(fragCurrent.start);
        }
        this.resetLoadingState();
        // should we switch tracks ?
        if (altAudio) {
            this.switchingTrack = data;
            // main audio track are handled by stream-controller, just do something if switching to alt audio track
            this.flushAudioIfNeeded(data);
            if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) {
                // switching to audio track, start timer if not already started
                this.setInterval($99a156a15cd35eb3$var$TICK_INTERVAL$3);
                this.state = $99a156a15cd35eb3$var$State.IDLE;
                this.tick();
            }
        } else {
            // destroy useless transmuxer when switching audio to main
            this.resetTransmuxer();
            this.switchingTrack = null;
            this.bufferedTrack = data;
            this.clearInterval();
        }
    }
    onManifestLoading() {
        super.onManifestLoading();
        this.bufferFlushed = this.flushing = this.audioOnly = false;
        this.resetItem();
        this.trackId = -1;
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
        const cachedTrackLoadedData = this.cachedTrackLoadedData;
        if (cachedTrackLoadedData) {
            this.cachedTrackLoadedData = null;
            this.onAudioTrackLoaded($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, cachedTrackLoadedData);
        }
    }
    onAudioTrackLoaded(event, data) {
        var _trackLevel$details;
        const { levels: levels } = this;
        const { details: newDetails, id: trackId, groupId: groupId, track: track } = data;
        if (!levels) {
            this.warn(`Audio tracks reset while loading track ${trackId} "${track.name}" of "${groupId}"`);
            return;
        }
        const mainDetails = this.mainDetails;
        if (!mainDetails || newDetails.endCC > mainDetails.endCC || mainDetails.expired) {
            this.cachedTrackLoadedData = data;
            if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.state = $99a156a15cd35eb3$var$State.WAITING_TRACK;
            return;
        }
        this.cachedTrackLoadedData = null;
        this.log(`Audio track ${trackId} "${track.name}" of "${groupId}" loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
        const trackLevel = levels[trackId];
        let sliding = 0;
        if (newDetails.live || (_trackLevel$details = trackLevel.details) != null && _trackLevel$details.live) {
            this.checkLiveUpdate(newDetails);
            if (newDetails.deltaUpdateFailed) return;
            if (trackLevel.details) {
                var _this$levelLastLoaded;
                sliding = this.alignPlaylists(newDetails, trackLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
            }
            if (!newDetails.alignedSliding) {
                // Align audio rendition with the "main" playlist on discontinuity change
                // or program-date-time (PDT)
                $99a156a15cd35eb3$var$alignDiscontinuities(newDetails, mainDetails);
                if (!newDetails.alignedSliding) $99a156a15cd35eb3$var$alignMediaPlaylistByPDT(newDetails, mainDetails);
                sliding = newDetails.fragmentStart;
            }
        }
        trackLevel.details = newDetails;
        this.levelLastLoaded = trackLevel;
        // compute start position if we are aligned with the main playlist
        if (!this.startFragRequested) this.setStartPosition(mainDetails, sliding);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_UPDATED, {
            details: newDetails,
            id: trackId,
            groupId: data.groupId
        });
        // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
        if (this.state === $99a156a15cd35eb3$var$State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) this.state = $99a156a15cd35eb3$var$State.IDLE;
        // trigger handler right now
        this.tick();
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const frag = data.frag;
        const { part: part, payload: payload } = data;
        const { config: config, trackId: trackId, levels: levels } = this;
        if (!levels) {
            this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const track = levels[trackId];
        if (!track) {
            this.warn('Audio track is undefined on fragment load progress');
            return;
        }
        const details = track.details;
        if (!details) {
            this.warn('Audio track details undefined on fragment load progress');
            this.removeUnbufferedFrags(frag.start);
            return;
        }
        const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
        let transmuxer = this.transmuxer;
        if (!transmuxer) transmuxer = this.transmuxer = new $99a156a15cd35eb3$var$TransmuxerInterface(this.hls, $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        // Check if we have video initPTS
        // If not we need to wait for it
        const initPTS = this.initPTS[frag.cc];
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        if (initPTS !== undefined) {
            // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            const accurateTimeOffset = false; // details.PTSKnown || !details.live;
            const partIndex = part ? part.index : -1;
            const partial = partIndex !== -1;
            const chunkMeta = new $99a156a15cd35eb3$export$ce0708ece532c9c(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
            transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
        } else {
            this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            const { cache: cache } = this.waitingData = this.waitingData || {
                frag: frag,
                part: part,
                cache: new $99a156a15cd35eb3$var$ChunkCache(),
                complete: false
            };
            cache.push(new Uint8Array(payload));
            if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.state = $99a156a15cd35eb3$var$State.WAITING_INIT_PTS;
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        if (this.waitingData) {
            this.waitingData.complete = true;
            return;
        }
        super._handleFragmentLoadComplete(fragLoadedData);
    }
    onBufferReset() {
        // reset reference to sourcebuffers
        this.mediaBuffer = null;
    }
    onBufferCreated(event, data) {
        this.bufferFlushed = this.flushing = false;
        const audioTrack = data.tracks.audio;
        if (audioTrack) this.mediaBuffer = audioTrack.buffer || null;
    }
    onFragLoading(event, data) {
        if (!this.audioOnly && data.frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN && $99a156a15cd35eb3$var$isMediaFragment(data.frag)) {
            this.mainFragLoading = data;
            if (this.state === $99a156a15cd35eb3$var$State.IDLE) this.tick();
        }
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        if (frag.type !== $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO) {
            if (!this.audioOnly && frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN && !frag.elementaryStreams.video && !frag.elementaryStreams.audiovideo) {
                this.audioOnly = true;
                this.mainFragLoading = null;
            }
            return;
        }
        if (this.fragContextChanged(frag)) {
            // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
            // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
            this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
            return;
        }
        if ($99a156a15cd35eb3$var$isMediaFragment(frag)) {
            this.fragPrevious = frag;
            const track = this.switchingTrack;
            if (track) {
                this.bufferedTrack = track;
                this.switchingTrack = null;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, $99a156a15cd35eb3$var$_objectSpread2({}, track));
            }
        }
        this.fragBufferedComplete(frag, part);
        if (this.media) this.tick();
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = $99a156a15cd35eb3$var$State.ERROR;
            return;
        }
        switch(data.details){
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError($99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO, data);
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_TIMEOUT:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
                if (!data.levelRetry && this.state === $99a156a15cd35eb3$var$State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK) this.state = $99a156a15cd35eb3$var$State.IDLE;
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                if (data.parent !== 'audio') return;
                this.resetLoadingState();
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_FULL_ERROR:
                if (data.parent !== 'audio') return;
                if (this.reduceLengthAndFlushBuffer(data)) {
                    this.bufferedTrack = null;
                    super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
                }
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    onBufferFlushing(event, { type: type }) {
        if (type !== $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO) this.flushing = true;
    }
    onBufferFlushed(event, { type: type }) {
        if (type !== $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO) {
            this.flushing = false;
            this.bufferFlushed = true;
            if (this.state === $99a156a15cd35eb3$var$State.ENDED) this.state = $99a156a15cd35eb3$var$State.IDLE;
            const mediaBuffer = this.mediaBuffer || this.media;
            if (mediaBuffer) {
                this.afterBufferFlushed(mediaBuffer, type, $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO);
                this.tick();
            }
        }
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = 'audio';
        const { hls: hls } = this;
        const { remuxResult: remuxResult, chunkMeta: chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const { details: details } = level;
        const { audio: audio, text: text, id3: id3, initSegment: initSegment } = remuxResult;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag) || !details) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = $99a156a15cd35eb3$var$State.PARSING;
        if (this.switchingTrack && audio) this.completeAudioSwitch(this.switchingTrack);
        if (initSegment != null && initSegment.tracks) {
            const mapFragment = frag.initSegment || frag;
            this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_INIT_SEGMENT, {
                frag: mapFragment,
                id: id,
                tracks: initSegment.tracks
            });
        // Only flush audio from old audio tracks when PTS is known on new audio track
        }
        if (audio) {
            const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = audio;
            if (part) part.elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS
            };
            frag.setElementaryStreamInfo($99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = $99a156a15cd35eb3$var$_extends({
                id: id,
                frag: frag,
                details: details
            }, id3);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_METADATA, emittedID3);
        }
        if (text) {
            const emittedText = $99a156a15cd35eb3$var$_extends({
                id: id,
                frag: frag,
                details: details
            }, text);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== $99a156a15cd35eb3$var$State.PARSING) return;
        // delete any video track found on audio transmuxer
        if (tracks.video) delete tracks.video;
        if (tracks.audiovideo) delete tracks.audiovideo;
        // include levelCodec in audio and video tracks
        if (!tracks.audio) return;
        const track = tracks.audio;
        track.id = $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO;
        const variantAudioCodecs = currentLevel.audioCodec;
        this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
        // SourceBuffer will use track.levelCodec if defined
        if (variantAudioCodecs && variantAudioCodecs.split(',').length === 1) track.levelCodec = variantAudioCodecs;
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, tracks);
        const initSegment = track.initSegment;
        if (initSegment != null && initSegment.byteLength) {
            const segment = {
                type: 'audio',
                frag: frag,
                part: null,
                chunkMeta: chunkMeta,
                parent: frag.type,
                data: initSegment
            };
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDING, segment);
        }
        // trigger handler right now
        this.tickImmediate();
    }
    loadFragment(frag, track, targetBufferTime) {
        // only load if fragment is not loaded or if in audio switch
        const fragState = this.fragmentTracker.getState(frag);
        // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
        if (this.switchingTrack || fragState === $99a156a15cd35eb3$var$FragmentState.NOT_LOADED || fragState === $99a156a15cd35eb3$var$FragmentState.PARTIAL) {
            var _track$details;
            if (!$99a156a15cd35eb3$var$isMediaFragment(frag)) this._loadInitSegment(frag, track);
            else if ((_track$details = track.details) != null && _track$details.live && !this.initPTS[frag.cc]) {
                this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
                this.state = $99a156a15cd35eb3$var$State.WAITING_INIT_PTS;
                const mainDetails = this.mainDetails;
                if (mainDetails && mainDetails.fragmentStart !== track.details.fragmentStart) $99a156a15cd35eb3$var$alignMediaPlaylistByPDT(track.details, mainDetails);
            } else super.loadFragment(frag, track, targetBufferTime);
        } else this.clearTrackerIfNeeded(frag);
    }
    flushAudioIfNeeded(switchingTrack) {
        if (this.media && this.bufferedTrack) {
            const { name: name, lang: lang, assocLang: assocLang, characteristics: characteristics, audioCodec: audioCodec, channels: channels } = this.bufferedTrack;
            if (!$99a156a15cd35eb3$var$matchesOption({
                name: name,
                lang: lang,
                assocLang: assocLang,
                characteristics: characteristics,
                audioCodec: audioCodec,
                channels: channels
            }, switchingTrack, $99a156a15cd35eb3$var$audioMatchPredicate)) {
                if ($99a156a15cd35eb3$var$useAlternateAudio(switchingTrack.url, this.hls)) {
                    this.log('Switching audio track : flushing all audio');
                    super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
                    this.bufferedTrack = null;
                } else // Main is being buffered. Set bufferedTrack so that it is flushed when switching back to alt-audio
                this.bufferedTrack = switchingTrack;
            }
        }
    }
    completeAudioSwitch(switchingTrack) {
        const { hls: hls } = this;
        this.flushAudioIfNeeded(switchingTrack);
        this.bufferedTrack = switchingTrack;
        this.switchingTrack = null;
        hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, $99a156a15cd35eb3$var$_objectSpread2({}, switchingTrack));
    }
}
class $99a156a15cd35eb3$export$d94ec24774c8b986 extends $99a156a15cd35eb3$var$Logger {
    constructor(hls, logPrefix){
        super(logPrefix, hls.logger);
        this.hls = void 0;
        this.canLoad = false;
        this.timer = -1;
        this.hls = hls;
    }
    destroy() {
        this.clearTimer();
        // @ts-ignore
        this.hls = this.log = this.warn = null;
    }
    clearTimer() {
        if (this.timer !== -1) {
            self.clearTimeout(this.timer);
            this.timer = -1;
        }
    }
    startLoad() {
        this.canLoad = true;
        this.loadPlaylist();
    }
    stopLoad() {
        this.canLoad = false;
        this.clearTimer();
    }
    switchParams(playlistUri, previous, current) {
        const renditionReports = previous == null ? void 0 : previous.renditionReports;
        if (renditionReports) {
            let foundIndex = -1;
            for(let i = 0; i < renditionReports.length; i++){
                const attr = renditionReports[i];
                let uri;
                try {
                    uri = new self.URL(attr.URI, previous.url).href;
                } catch (error) {
                    this.warn(`Could not construct new URL for Rendition Report: ${error}`);
                    uri = attr.URI || '';
                }
                // Use exact match. Otherwise, the last partial match, if any, will be used
                // (Playlist URI includes a query string that the Rendition Report does not)
                if (uri === playlistUri) {
                    foundIndex = i;
                    break;
                } else if (uri === playlistUri.substring(0, uri.length)) foundIndex = i;
            }
            if (foundIndex !== -1) {
                const attr = renditionReports[foundIndex];
                const msn = parseInt(attr['LAST-MSN']) || (previous == null ? void 0 : previous.lastPartSn);
                let part = parseInt(attr['LAST-PART']) || (previous == null ? void 0 : previous.lastPartIndex);
                if (this.hls.config.lowLatencyMode) {
                    const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
                    if (part >= 0 && currentGoal > previous.partTarget) part += 1;
                }
                const skip = current && $99a156a15cd35eb3$var$getSkipValue(current);
                return new $99a156a15cd35eb3$export$b1713430eaae90a7(msn, part >= 0 ? part : undefined, skip);
            }
        }
    }
    loadPlaylist(hlsUrlParameters) {
        // Loading is handled by the subclasses
        this.clearTimer();
    }
    loadingPlaylist(playlist, hlsUrlParameters) {
        // Loading is handled by the subclasses
        this.clearTimer();
    }
    shouldLoadPlaylist(playlist) {
        return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
    }
    getUrlWithDirectives(uri, hlsUrlParameters) {
        if (hlsUrlParameters) try {
            return hlsUrlParameters.addDirectives(uri);
        } catch (error) {
            this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
        return uri;
    }
    playlistLoaded(index, data, previousDetails) {
        const { details: details, stats: stats } = data;
        // Set last updated date-time
        const now = self.performance.now();
        const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
        details.advancedDateTime = Date.now() - elapsed;
        // shift fragment starts with timelineOffset
        const timelineOffset = this.hls.config.timelineOffset;
        if (timelineOffset !== details.appliedTimelineOffset) {
            const offset = Math.max(timelineOffset || 0, 0);
            details.appliedTimelineOffset = offset;
            details.fragments.forEach((frag)=>{
                frag.start = frag.playlistOffset + offset;
            });
        }
        // if current playlist is a live playlist, arm a timer to reload it
        if (details.live || previousDetails != null && previousDetails.live) {
            const levelOrTrack = 'levelInfo' in data ? data.levelInfo : data.track;
            details.reloaded(previousDetails);
            // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
            if (previousDetails && details.fragments.length > 0) {
                $99a156a15cd35eb3$var$mergeDetails(previousDetails, details);
                const error = details.playlistParsingError;
                if (error) {
                    this.warn(error);
                    const hls = this.hls;
                    if (!hls.config.ignorePlaylistParsingErrors) {
                        var _details$fragments$;
                        const { networkDetails: networkDetails } = data;
                        hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                            details: $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_PARSING_ERROR,
                            fatal: false,
                            url: details.url,
                            error: error,
                            reason: error.message,
                            level: data.level || undefined,
                            parent: (_details$fragments$ = details.fragments[0]) == null ? void 0 : _details$fragments$.type,
                            networkDetails: networkDetails,
                            stats: stats
                        });
                        return;
                    }
                    details.playlistParsingError = null;
                }
            }
            if (details.requestScheduled === -1) details.requestScheduled = stats.loading.start;
            const bufferInfo = this.hls.mainForwardBufferInfo;
            const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
            const distanceToLiveEdgeMs = (details.edge - position) * 1000;
            const reloadInterval = $99a156a15cd35eb3$var$computeReloadInterval(details, distanceToLiveEdgeMs);
            if (details.requestScheduled + reloadInterval < now) details.requestScheduled = now;
            else details.requestScheduled += reloadInterval;
            this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : details.updated ? 'UPDATED' : 'MISSED'}`);
            if (!this.canLoad || !details.live) return;
            let deliveryDirectives;
            let msn = undefined;
            let part = undefined;
            if (details.canBlockReload && details.endSN && details.advanced) {
                // Load level with LL-HLS delivery directives
                const lowLatencyMode = this.hls.config.lowLatencyMode;
                const lastPartSn = details.lastPartSn;
                const endSn = details.endSN;
                const lastPartIndex = details.lastPartIndex;
                const hasParts = lastPartIndex !== -1;
                const atLastPartOfSegment = lastPartSn === endSn;
                if (hasParts) {
                    // When low latency mode is disabled, request the last part of the next segment
                    if (atLastPartOfSegment) {
                        msn = endSn + 1;
                        part = lowLatencyMode ? 0 : lastPartIndex;
                    } else {
                        msn = lastPartSn;
                        part = lowLatencyMode ? lastPartIndex + 1 : details.maxPartIndex;
                    }
                } else msn = endSn + 1;
                // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
                // Update directives to obtain the Playlist that has the estimated additional duration of media
                const lastAdvanced = details.age;
                const cdnAge = lastAdvanced + details.ageHeader;
                let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
                if (currentGoal > 0) {
                    if (cdnAge > details.targetduration * 3) {
                        // Omit segment and part directives when the last response was more than 3 target durations ago,
                        this.log(`Playlist last advanced ${lastAdvanced.toFixed(2)}s ago. Omitting segment and part directives.`);
                        msn = undefined;
                        part = undefined;
                    } else if (previousDetails != null && previousDetails.tuneInGoal && cdnAge - details.partTarget > previousDetails.tuneInGoal) {
                        // If we attempted to get the next or latest playlist update, but currentGoal increased,
                        // then we either can't catchup, or the "age" header cannot be trusted.
                        this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
                        currentGoal = 0;
                    } else {
                        const segments = Math.floor(currentGoal / details.targetduration);
                        msn += segments;
                        if (part !== undefined) {
                            const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
                            part += parts;
                        }
                        this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
                    }
                    details.tuneInGoal = currentGoal;
                }
                deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
                if (lowLatencyMode || !atLastPartOfSegment) {
                    details.requestScheduled = now;
                    this.loadingPlaylist(levelOrTrack, deliveryDirectives);
                    return;
                }
            } else if (details.canBlockReload || details.canSkipUntil) deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
            if (deliveryDirectives && msn !== undefined && details.canBlockReload) details.requestScheduled = stats.loading.first + Math.max(reloadInterval - elapsed * 2, reloadInterval / 2);
            this.scheduleLoading(levelOrTrack, deliveryDirectives, details);
        } else this.clearTimer();
    }
    scheduleLoading(levelOrTrack, deliveryDirectives, updatedDetails) {
        const details = updatedDetails || levelOrTrack.details;
        if (!details) {
            this.loadingPlaylist(levelOrTrack, deliveryDirectives);
            return;
        }
        const now = self.performance.now();
        const requestScheduled = details.requestScheduled;
        if (now >= requestScheduled) {
            this.loadingPlaylist(levelOrTrack, deliveryDirectives);
            return;
        }
        const estimatedTimeUntilUpdate = requestScheduled - now;
        this.log(`reload live playlist ${levelOrTrack.name || levelOrTrack.bitrate + 'bps'} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
        this.clearTimer();
        this.timer = self.setTimeout(()=>this.loadingPlaylist(levelOrTrack, deliveryDirectives), estimatedTimeUntilUpdate);
    }
    getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
        let skip = $99a156a15cd35eb3$var$getSkipValue(details);
        if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
            msn = previousDeliveryDirectives.msn;
            part = previousDeliveryDirectives.part;
            skip = $99a156a15cd35eb3$export$5d29c5ea940312ed.No;
        }
        return new $99a156a15cd35eb3$export$b1713430eaae90a7(msn, part, skip);
    }
    checkRetry(errorEvent) {
        const errorDetails = errorEvent.details;
        const isTimeout = $99a156a15cd35eb3$var$isTimeoutError(errorEvent);
        const errorAction = errorEvent.errorAction;
        const { action: action, retryCount: retryCount = 0, retryConfig: retryConfig } = errorAction || {};
        const retry = !!errorAction && !!retryConfig && (action === $99a156a15cd35eb3$export$679390c50dd617e4.RetryRequest || !errorAction.resolved && action === $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox);
        if (retry) {
            var _errorEvent$context;
            if (retryCount >= retryConfig.maxNumRetry) return false;
            if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
                // The LL-HLS request already timed out so retry immediately
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
                this.loadPlaylist();
            } else {
                const delay = $99a156a15cd35eb3$var$getRetryDelay(retryConfig, retryCount);
                // Schedule level/track reload
                this.clearTimer();
                this.timer = self.setTimeout(()=>this.loadPlaylist(), delay);
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
            }
            // `levelRetry = true` used to inform other controllers that a retry is happening
            errorEvent.levelRetry = true;
            errorAction.resolved = true;
        }
        return retry;
    }
}
function $99a156a15cd35eb3$var$subtitleOptionsIdentical(trackList1, trackList2) {
    if (trackList1.length !== trackList2.length) return false;
    for(let i = 0; i < trackList1.length; i++){
        if (!$99a156a15cd35eb3$var$mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) return false;
    }
    return true;
}
function $99a156a15cd35eb3$var$mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
    // Media options with the same rendition ID must be bit identical
    const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
    if (stableRenditionId && !customAttributes) return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
    // When rendition ID is not present, compare attributes
    return !(customAttributes || [
        'LANGUAGE',
        'NAME',
        'CHARACTERISTICS',
        'AUTOSELECT',
        'DEFAULT',
        'FORCED',
        'ASSOC-LANGUAGE'
    ]).some((subtitleAttribute)=>attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function $99a156a15cd35eb3$var$subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
    return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || '').toLowerCase());
}
class $99a156a15cd35eb3$export$befb88bd9e19246 extends $99a156a15cd35eb3$export$d94ec24774c8b986 {
    constructor(hls){
        super(hls, 'audio-track-controller');
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.registerListeners();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        super.destroy();
    }
    onManifestLoading() {
        this.tracks = [];
        this.tracksInGroup = [];
        this.groupIds = null;
        this.currentTrack = null;
        this.trackId = -1;
        this.selectDefaultTrack = true;
    }
    onManifestParsed(event, data) {
        this.tracks = data.audioTracks || [];
    }
    onAudioTrackLoaded(event, data) {
        const { id: id, groupId: groupId, details: details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!levelInfo) return;
        const audioGroups = levelInfo.audioGroups || null;
        const currentGroups = this.groupIds;
        let currentTrack = this.currentTrack;
        if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some((groupId)=>(currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
            this.groupIds = audioGroups;
            this.trackId = -1;
            this.currentTrack = null;
            const audioTracks = this.tracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
            if (audioTracks.length) {
                // Disable selectDefaultTrack if there are no default tracks
                if (this.selectDefaultTrack && !audioTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
                // track.id should match hls.audioTracks index
                audioTracks.forEach((track, i)=>{
                    track.id = i;
                });
            } else if (!currentTrack && !this.tracksInGroup.length) // Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
            return;
            this.tracksInGroup = audioTracks;
            // Find preferred track
            const audioPreference = this.hls.config.audioPreference;
            if (!currentTrack && audioPreference) {
                const groupIndex = $99a156a15cd35eb3$var$findMatchingOption(audioPreference, audioTracks, $99a156a15cd35eb3$var$audioMatchPredicate);
                if (groupIndex > -1) currentTrack = audioTracks[groupIndex];
                else {
                    const allIndex = $99a156a15cd35eb3$var$findMatchingOption(audioPreference, this.tracks);
                    currentTrack = this.tracks[allIndex];
                }
            }
            // Select initial track
            let trackId = this.findTrackId(currentTrack);
            if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
            // Dispatch events and load track if needed
            const audioTracksUpdated = {
                audioTracks: audioTracks
            };
            this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(',')}`);
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
            const selectedTrackId = this.trackId;
            if (trackId !== -1 && selectedTrackId === -1) this.setAudioTrack(trackId);
            else if (audioTracks.length && selectedTrackId === -1) {
                var _this$groupIds;
                const error = new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(',')} track count: ${audioTracks.length}`);
                this.warn(error.message);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR,
                    fatal: true,
                    error: error
                });
            }
        }
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
    }
    get allAudioTracks() {
        return this.tracks;
    }
    get audioTracks() {
        return this.tracksInGroup;
    }
    get audioTrack() {
        return this.trackId;
    }
    set audioTrack(newId) {
        // If audio track is selected from API then don't choose from the manifest default track
        this.selectDefaultTrack = false;
        this.setAudioTrack(newId);
    }
    setAudioOption(audioOption) {
        const hls = this.hls;
        hls.config.audioPreference = audioOption;
        if (audioOption) {
            const allAudioTracks = this.allAudioTracks;
            this.selectDefaultTrack = false;
            if (allAudioTracks.length) {
                // First see if current option matches (no switch op)
                const currentTrack = this.currentTrack;
                if (currentTrack && $99a156a15cd35eb3$var$matchesOption(audioOption, currentTrack, $99a156a15cd35eb3$var$audioMatchPredicate)) return currentTrack;
                // Find option in available tracks (tracksInGroup)
                const groupIndex = $99a156a15cd35eb3$var$findMatchingOption(audioOption, this.tracksInGroup, $99a156a15cd35eb3$var$audioMatchPredicate);
                if (groupIndex > -1) {
                    const track = this.tracksInGroup[groupIndex];
                    this.setAudioTrack(groupIndex);
                    return track;
                } else if (currentTrack) {
                    // Find option in nearest level audio group
                    let searchIndex = hls.loadLevel;
                    if (searchIndex === -1) searchIndex = hls.firstAutoLevel;
                    const switchIndex = $99a156a15cd35eb3$var$findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, $99a156a15cd35eb3$var$audioMatchPredicate);
                    if (switchIndex === -1) // could not find matching variant
                    return null;
                    // and switch level to acheive the audio group switch
                    hls.nextLoadLevel = switchIndex;
                }
                if (audioOption.channels || audioOption.audioCodec) {
                    // Could not find a match with codec / channels predicate
                    // Find a match without channels or codec
                    const withoutCodecAndChannelsMatch = $99a156a15cd35eb3$var$findMatchingOption(audioOption, allAudioTracks);
                    if (withoutCodecAndChannelsMatch > -1) return allAudioTracks[withoutCodecAndChannelsMatch];
                }
            }
        }
        return null;
    }
    setAudioTrack(newId) {
        const tracks = this.tracksInGroup;
        // check if level idx is valid
        if (newId < 0 || newId >= tracks.length) {
            this.warn(`Invalid audio track id: ${newId}`);
            return;
        }
        this.selectDefaultTrack = false;
        const lastTrack = this.currentTrack;
        const track = tracks[newId];
        const trackLoaded = track.details && !track.details.live;
        if (newId === this.trackId && track === lastTrack && trackLoaded) return;
        this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
        this.trackId = newId;
        this.currentTrack = track;
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, $99a156a15cd35eb3$var$_objectSpread2({}, track));
        // Do not reload track unless live
        if (trackLoaded) return;
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
        this.loadPlaylist(hlsUrlParameters);
    }
    findTrackId(currentTrack) {
        const audioTracks = this.tracksInGroup;
        for(let i = 0; i < audioTracks.length; i++){
            const track = audioTracks[i];
            if (this.selectDefaultTrack && !track.default) continue;
            if (!currentTrack || $99a156a15cd35eb3$var$matchesOption(currentTrack, track, $99a156a15cd35eb3$var$audioMatchPredicate)) return i;
        }
        if (currentTrack) {
            const { name: name, lang: lang, assocLang: assocLang, characteristics: characteristics, audioCodec: audioCodec, channels: channels } = currentTrack;
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if ($99a156a15cd35eb3$var$matchesOption({
                    name: name,
                    lang: lang,
                    assocLang: assocLang,
                    characteristics: characteristics,
                    audioCodec: audioCodec,
                    channels: channels
                }, track, $99a156a15cd35eb3$var$audioMatchPredicate)) return i;
            }
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if ($99a156a15cd35eb3$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'CHARACTERISTICS'
                ])) return i;
            }
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if ($99a156a15cd35eb3$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE'
                ])) return i;
            }
        }
        return -1;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const audioTrack = this.currentTrack;
        if (!this.shouldLoadPlaylist(audioTrack)) return;
        // Do not load audio rendition with URI matching main variant URI
        if ($99a156a15cd35eb3$var$useAlternateAudio(audioTrack.url, this.hls)) this.scheduleLoading(audioTrack, hlsUrlParameters);
    }
    loadingPlaylist(audioTrack, hlsUrlParameters) {
        super.loadingPlaylist(audioTrack, hlsUrlParameters);
        const id = audioTrack.id;
        const groupId = audioTrack.groupId;
        const url = this.getUrlWithDirectives(audioTrack.url, hlsUrlParameters);
        const details = audioTrack.details;
        const age = details == null ? void 0 : details.age;
        this.log(`Loading audio-track ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type : '') : ''} ${url}`);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADING, {
            url: url,
            id: id,
            groupId: groupId,
            deliveryDirectives: hlsUrlParameters || null,
            track: audioTrack
        });
    }
}
class $99a156a15cd35eb3$var$BufferOperationQueue {
    constructor(sourceBufferReference){
        this.tracks = void 0;
        this.queues = {
            video: [],
            audio: [],
            audiovideo: []
        };
        this.tracks = sourceBufferReference;
    }
    destroy() {
        this.tracks = this.queues = null;
    }
    append(operation, type, pending) {
        if (this.queues === null || this.tracks === null) return;
        const queue = this.queues[type];
        queue.push(operation);
        if (queue.length === 1 && !pending) this.executeNext(type);
    }
    appendBlocker(type) {
        return new Promise((resolve)=>{
            const operation = {
                label: 'async-blocker',
                execute: resolve,
                onStart: ()=>{},
                onComplete: ()=>{},
                onError: ()=>{}
            };
            this.append(operation, type);
        });
    }
    prependBlocker(type) {
        return new Promise((resolve)=>{
            if (this.queues) {
                const operation = {
                    label: 'async-blocker-prepend',
                    execute: resolve,
                    onStart: ()=>{},
                    onComplete: ()=>{},
                    onError: ()=>{}
                };
                this.queues[type].unshift(operation);
            }
        });
    }
    removeBlockers() {
        if (this.queues === null) return;
        [
            this.queues.video,
            this.queues.audio,
            this.queues.audiovideo
        ].forEach((queue)=>{
            var _queue$;
            const label = (_queue$ = queue[0]) == null ? void 0 : _queue$.label;
            if (label === 'async-blocker' || label === 'async-blocker-prepend') {
                queue[0].execute();
                queue.splice(0, 1);
            }
        });
    }
    unblockAudio(op) {
        if (this.queues === null) return;
        const queue = this.queues.audio;
        if (queue[0] === op) this.shiftAndExecuteNext('audio');
    }
    executeNext(type) {
        if (this.queues === null || this.tracks === null) return;
        const queue = this.queues[type];
        if (queue.length) {
            const operation = queue[0];
            try {
                // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
                // which do not end with this event must call _onSBUpdateEnd manually
                operation.execute();
            } catch (error) {
                var _this$tracks$type;
                operation.onError(error);
                if (this.queues === null || this.tracks === null) return;
                // Only shift the current operation off, otherwise the updateend handler will do this for us
                const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
                if (!(sb != null && sb.updating)) this.shiftAndExecuteNext(type);
            }
        }
    }
    shiftAndExecuteNext(type) {
        if (this.queues === null) return;
        this.queues[type].shift();
        this.executeNext(type);
    }
    current(type) {
        var _this$queues;
        return ((_this$queues = this.queues) == null ? void 0 : _this$queues[type][0]) || null;
    }
    toString() {
        const { queues: queues, tracks: tracks } = this;
        if (queues === null || tracks === null) return `<destroyed>`;
        return `
${this.list('video')}
${this.list('audio')}
${this.list('audiovideo')}}`;
    }
    list(type) {
        var _this$queues2, _this$tracks;
        return (_this$queues2 = this.queues) != null && _this$queues2[type] || (_this$tracks = this.tracks) != null && _this$tracks[type] ? `${type}: (${this.listSbInfo(type)}) ${this.listOps(type)}` : '';
    }
    listSbInfo(type) {
        var _this$tracks2;
        const track = (_this$tracks2 = this.tracks) == null ? void 0 : _this$tracks2[type];
        const sb = track == null ? void 0 : track.buffer;
        if (!sb) return 'none';
        return `SourceBuffer${sb.updating ? ' updating' : ''}${track.ended ? ' ended' : ''}${track.ending ? ' ending' : ''}`;
    }
    listOps(type) {
        var _this$queues3;
        return ((_this$queues3 = this.queues) == null ? void 0 : _this$queues3[type].map((op)=>op.label).join(', ')) || '';
    }
}
const $99a156a15cd35eb3$var$VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
const $99a156a15cd35eb3$var$TRACK_REMOVED_ERROR_NAME = 'HlsJsTrackRemovedError';
class $99a156a15cd35eb3$var$HlsJsTrackRemovedError extends Error {
    constructor(message){
        super(message);
        this.name = $99a156a15cd35eb3$var$TRACK_REMOVED_ERROR_NAME;
    }
}
class $99a156a15cd35eb3$export$2057e53fd83d2d77 extends $99a156a15cd35eb3$var$Logger {
    constructor(hls, fragmentTracker){
        super('buffer-controller', hls.logger);
        this.hls = void 0;
        this.fragmentTracker = void 0;
        // The level details used to determine duration, target-duration and live
        this.details = null;
        // cache the self generated object url to detect hijack of video tag
        this._objectUrl = null;
        // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
        this.operationQueue = null;
        // The total number track codecs expected before any sourceBuffers are created (2: audio and video or 1: audiovideo | audio | video)
        this.bufferCodecEventsTotal = 0;
        // A reference to the attached media element
        this.media = null;
        // A reference to the active media source
        this.mediaSource = null;
        // Last MP3 audio chunk appended
        this.lastMpegAudioChunk = null;
        // Audio fragment blocked from appending until corresponding video appends or context changes
        this.blockedAudioAppend = null;
        // Keep track of video append position for unblocking audio
        this.lastVideoAppendEnd = 0;
        // Whether or not to use ManagedMediaSource API and append source element to media element.
        this.appendSource = void 0;
        // Transferred MediaSource information used to detmerine if duration end endstream may be appended
        this.transferData = void 0;
        // Directives used to override default MediaSource handling
        this.overrides = void 0;
        // Error counters
        this.appendErrors = {
            audio: 0,
            video: 0,
            audiovideo: 0
        };
        // Record of required or created buffers by type. SourceBuffer is stored in Track.buffer once created.
        this.tracks = {};
        // Array of SourceBuffer type and SourceBuffer (or null). One entry per TrackSet in this.tracks.
        this.sourceBuffers = [
            [
                null,
                null
            ],
            [
                null,
                null
            ]
        ];
        this._onEndStreaming = (event)=>{
            var _this$mediaSource;
            if (!this.hls) return;
            if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) !== 'open') return;
            this.hls.pauseBuffering();
        };
        this._onStartStreaming = (event)=>{
            if (!this.hls) return;
            this.hls.resumeBuffering();
        };
        // Keep as arrow functions so that we can directly reference these functions directly as event listeners
        this._onMediaSourceOpen = (e)=>{
            const { media: media, mediaSource: mediaSource } = this;
            if (e) this.log('Media source opened');
            if (!media || !mediaSource) return;
            // once received, don't listen anymore to sourceopen event
            mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
            media.removeEventListener('emptied', this._onMediaEmptied);
            this.updateDuration();
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, {
                media: media,
                mediaSource: mediaSource
            });
            if (this.mediaSource !== null) this.checkPendingTracks();
        };
        this._onMediaSourceClose = ()=>{
            this.log('Media source closed');
        };
        this._onMediaSourceEnded = ()=>{
            this.log('Media source ended');
        };
        this._onMediaEmptied = ()=>{
            const { mediaSrc: mediaSrc, _objectUrl: _objectUrl } = this;
            if (mediaSrc !== _objectUrl) this.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
        };
        this.hls = hls;
        this.fragmentTracker = fragmentTracker;
        this.appendSource = $99a156a15cd35eb3$var$isManagedMediaSource($99a156a15cd35eb3$export$a92854129bc50f89(hls.config.preferManagedMediaSource));
        this.initTracks();
        this.registerListeners();
    }
    hasSourceTypes() {
        return Object.keys(this.tracks).length > 0;
    }
    destroy() {
        this.unregisterListeners();
        this.details = null;
        this.lastMpegAudioChunk = this.blockedAudioAppend = null;
        this.transferData = this.overrides = undefined;
        if (this.operationQueue) {
            this.operationQueue.destroy();
            this.operationQueue = null;
        }
        // @ts-ignore
        this.hls = this.fragmentTracker = null;
        // @ts-ignore
        this._onMediaSourceOpen = this._onMediaSourceClose = null;
        // @ts-ignore
        this._onMediaSourceEnded = null;
        // @ts-ignore
        this._onStartStreaming = this._onEndStreaming = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_EOS, this.onBufferEos, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSED, this.onFragParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_CHANGED, this.onFragChanged, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_EOS, this.onBufferEos, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSED, this.onFragParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_CHANGED, this.onFragChanged, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    transferMedia() {
        const { media: media, mediaSource: mediaSource } = this;
        if (!media) return null;
        const tracks = {};
        if (this.operationQueue) {
            const updating = this.isUpdating();
            if (!updating) this.operationQueue.removeBlockers();
            const queued = this.isQueued();
            if (updating || queued) this.warn(`Transfering MediaSource with${queued ? ' operations in queue' : ''}${updating ? ' updating SourceBuffer(s)' : ''} ${this.operationQueue}`);
            this.operationQueue.destroy();
        }
        const transferData = this.transferData;
        if (!this.sourceBufferCount && transferData && transferData.mediaSource === mediaSource) $99a156a15cd35eb3$var$_extends(tracks, transferData.tracks);
        else this.sourceBuffers.forEach((tuple)=>{
            const [type] = tuple;
            if (type) {
                tracks[type] = $99a156a15cd35eb3$var$_extends({}, this.tracks[type]);
                this.removeBuffer(type);
            }
            tuple[0] = tuple[1] = null;
        });
        return {
            media: media,
            mediaSource: mediaSource,
            tracks: tracks
        };
    }
    initTracks() {
        const tracks = {};
        this.sourceBuffers = [
            [
                null,
                null
            ],
            [
                null,
                null
            ]
        ];
        this.tracks = tracks;
        this.resetQueue();
        this.resetAppendErrors();
        this.lastMpegAudioChunk = this.blockedAudioAppend = null;
        this.lastVideoAppendEnd = 0;
    }
    onManifestLoading() {
        this.bufferCodecEventsTotal = 0;
        this.details = null;
    }
    onManifestParsed(event, data) {
        var _this$transferData;
        // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
        // sourcebuffers will be created all at once when the expected nb of tracks will be reached
        // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
        // it will contain the expected nb of source buffers, no need to compute it
        let codecEvents = 2;
        if (data.audio && !data.video || !data.altAudio) codecEvents = 1;
        this.bufferCodecEventsTotal = codecEvents;
        this.log(`${codecEvents} bufferCodec event(s) expected.`);
        if ((_this$transferData = this.transferData) != null && _this$transferData.mediaSource && this.sourceBufferCount && codecEvents) this.bufferCreated();
    }
    onMediaAttaching(event, data) {
        const media = this.media = data.media;
        const MediaSource = $99a156a15cd35eb3$export$a92854129bc50f89(this.appendSource);
        this.transferData = this.overrides = undefined;
        if (media && MediaSource) {
            const transferringMedia = !!data.mediaSource;
            if (transferringMedia || data.overrides) {
                this.transferData = data;
                this.overrides = data.overrides;
            }
            const ms = this.mediaSource = data.mediaSource || new MediaSource();
            this.assignMediaSource(ms);
            if (transferringMedia) {
                this._objectUrl = media.src;
                this.attachTransferred();
            } else {
                // cache the locally generated object url
                const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
                // link video and media Source
                if (this.appendSource) try {
                    media.removeAttribute('src');
                    // ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
                    const MMS = self.ManagedMediaSource;
                    media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
                    $99a156a15cd35eb3$var$removeSourceChildren(media);
                    $99a156a15cd35eb3$var$addSource(media, objectUrl);
                    media.load();
                } catch (error) {
                    media.src = objectUrl;
                }
                else media.src = objectUrl;
            }
            media.addEventListener('emptied', this._onMediaEmptied);
        }
    }
    assignMediaSource(ms) {
        var _this$transferData2, _ms$constructor;
        this.log(`${((_this$transferData2 = this.transferData) == null ? void 0 : _this$transferData2.mediaSource) === ms ? 'transferred' : 'created'} media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
        // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
        ms.addEventListener('sourceopen', this._onMediaSourceOpen);
        ms.addEventListener('sourceended', this._onMediaSourceEnded);
        ms.addEventListener('sourceclose', this._onMediaSourceClose);
        if (this.appendSource) {
            ms.addEventListener('startstreaming', this._onStartStreaming);
            ms.addEventListener('endstreaming', this._onEndStreaming);
        }
    }
    attachTransferred() {
        const media = this.media;
        const data = this.transferData;
        if (!data || !media) return;
        const requiredTracks = this.tracks;
        const transferredTracks = data.tracks;
        const trackNames = transferredTracks ? Object.keys(transferredTracks) : null;
        const trackCount = trackNames ? trackNames.length : 0;
        const mediaSourceOpenCallback = ()=>{
            if (this.media && this.mediaSourceOpenOrEnded) this._onMediaSourceOpen();
        };
        if (transferredTracks && trackNames && trackCount) {
            if (!this.tracksReady) {
                // Wait for CODECS event(s)
                this.hls.config.startFragPrefetch = true;
                this.log(`attachTransferred: waiting for SourceBuffer track info`);
                return;
            }
            this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${$99a156a15cd35eb3$var$stringify(requiredTracks, (key, value)=>key === 'initSegment' ? undefined : value)};
transfer tracks: ${$99a156a15cd35eb3$var$stringify(transferredTracks, (key, value)=>key === 'initSegment' ? undefined : value)}}`);
            if (!$99a156a15cd35eb3$var$isCompatibleTrackChange(transferredTracks, requiredTracks)) {
                // destroy attaching media source
                data.mediaSource = null;
                data.tracks = undefined;
                const currentTime = media.currentTime;
                const details = this.details;
                const startTime = Math.max(currentTime, (details == null ? void 0 : details.fragments[0].start) || 0);
                if (startTime - currentTime > 1) {
                    this.log(`attachTransferred: waiting for playback to reach new tracks start time ${currentTime} -> ${startTime}`);
                    return;
                }
                this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(transferredTracks)}"->"${Object.keys(requiredTracks)}") start time: ${startTime} currentTime: ${currentTime}`);
                this.onMediaDetaching($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, {});
                this.onMediaAttaching($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, data);
                media.currentTime = startTime;
                return;
            }
            this.transferData = undefined;
            trackNames.forEach((trackName)=>{
                const type = trackName;
                const track = transferredTracks[type];
                if (track) {
                    const sb = track.buffer;
                    if (sb) {
                        // Purge fragment tracker of ejected segments for existing buffer
                        const fragmentTracker = this.fragmentTracker;
                        const playlistType = track.id;
                        if (fragmentTracker.hasFragments(playlistType) || fragmentTracker.hasParts(playlistType)) {
                            const bufferedTimeRanges = $99a156a15cd35eb3$var$BufferHelper.getBuffered(sb);
                            fragmentTracker.detectEvictedFragments(type, bufferedTimeRanges, playlistType, null, true);
                        }
                        // Transfer SourceBuffer
                        const sbIndex = $99a156a15cd35eb3$var$sourceBufferNameToIndex(type);
                        const sbTuple = [
                            type,
                            sb
                        ];
                        this.sourceBuffers[sbIndex] = sbTuple;
                        if (sb.updating && this.operationQueue) this.operationQueue.prependBlocker(type);
                        this.trackSourceBuffer(type, track);
                    }
                }
            });
            mediaSourceOpenCallback();
            this.bufferCreated();
        } else {
            this.log(`attachTransferred: MediaSource w/o SourceBuffers`);
            mediaSourceOpenCallback();
        }
    }
    get mediaSourceOpenOrEnded() {
        var _this$mediaSource2;
        const readyState = (_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState;
        return readyState === 'open' || readyState === 'ended';
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        this.transferData = this.overrides = undefined;
        const { media: media, mediaSource: mediaSource, _objectUrl: _objectUrl } = this;
        if (mediaSource) {
            this.log(`media source ${transferringMedia ? 'transferring' : 'detaching'}`);
            if (transferringMedia) {
                // Detach SourceBuffers without removing from MediaSource
                // and leave `tracks` (required SourceBuffers configuration)
                this.sourceBuffers.forEach(([type])=>{
                    if (type) this.removeBuffer(type);
                });
                this.resetQueue();
            } else {
                if (this.mediaSourceOpenOrEnded) {
                    const open = mediaSource.readyState === 'open';
                    try {
                        const sourceBuffers = mediaSource.sourceBuffers;
                        for(let i = sourceBuffers.length; i--;){
                            if (open) sourceBuffers[i].abort();
                            mediaSource.removeSourceBuffer(sourceBuffers[i]);
                        }
                        if (open) // endOfStream could trigger exception if any sourcebuffer is in updating state
                        // we don't really care about checking sourcebuffer state here,
                        // as we are anyway detaching the MediaSource
                        // let's just avoid this exception to propagate
                        mediaSource.endOfStream();
                    } catch (err) {
                        this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
                    }
                }
                // Clean up the SourceBuffers by invoking onBufferReset
                if (this.sourceBufferCount) this.onBufferReset();
            }
            mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
            mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
            mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);
            if (this.appendSource) {
                mediaSource.removeEventListener('startstreaming', this._onStartStreaming);
                mediaSource.removeEventListener('endstreaming', this._onEndStreaming);
            }
            this.mediaSource = null;
            this._objectUrl = null;
        }
        // Detach properly the MediaSource from the HTMLMediaElement as
        // suggested in https://github.com/w3c/media-source/issues/53.
        if (media) {
            media.removeEventListener('emptied', this._onMediaEmptied);
            if (!transferringMedia) {
                if (_objectUrl) self.URL.revokeObjectURL(_objectUrl);
                // clean up video tag src only if it's our own url. some external libraries might
                // hijack the video tag and change its 'src' without destroying the Hls instance first
                if (this.mediaSrc === _objectUrl) {
                    media.removeAttribute('src');
                    if (this.appendSource) $99a156a15cd35eb3$var$removeSourceChildren(media);
                    media.load();
                } else this.warn('media|source.src was changed by a third party - skip cleanup');
            }
            this.media = null;
        }
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHED, data);
    }
    onBufferReset() {
        this.sourceBuffers.forEach(([type])=>{
            if (type) this.resetBuffer(type);
        });
        this.initTracks();
    }
    resetBuffer(type) {
        var _this$tracks$type;
        const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
        this.removeBuffer(type);
        if (sb) try {
            var _this$mediaSource3;
            if ((_this$mediaSource3 = this.mediaSource) != null && _this$mediaSource3.sourceBuffers.length) this.mediaSource.removeSourceBuffer(sb);
        } catch (err) {
            this.warn(`onBufferReset ${type}`, err);
        }
        delete this.tracks[type];
    }
    removeBuffer(type) {
        this.removeBufferListeners(type);
        this.sourceBuffers[$99a156a15cd35eb3$var$sourceBufferNameToIndex(type)] = [
            null,
            null
        ];
        const track = this.tracks[type];
        if (track) track.buffer = undefined;
    }
    resetQueue() {
        if (this.operationQueue) this.operationQueue.destroy();
        this.operationQueue = new $99a156a15cd35eb3$var$BufferOperationQueue(this.tracks);
    }
    onBufferCodecs(event, data) {
        const tracks = this.tracks;
        const trackNames = Object.keys(data);
        this.log(`BUFFER_CODECS: "${trackNames}" (current SB count ${this.sourceBufferCount})`);
        const unmuxedToMuxed = 'audiovideo' in data && (tracks.audio || tracks.video) || tracks.audiovideo && ('audio' in data || 'video' in data);
        const muxedToUnmuxed = !unmuxedToMuxed && this.sourceBufferCount && this.media && trackNames.some((sbName)=>!tracks[sbName]);
        if (unmuxedToMuxed || muxedToUnmuxed) {
            this.warn(`Unsupported transition between "${Object.keys(tracks)}" and "${trackNames}" SourceBuffers`);
            // Do not add incompatible track ('audiovideo' <-> 'video'/'audio').
            // Allow following onBufferAppending handle to trigger BUFFER_APPEND_ERROR.
            // This will either be resolved by level switch or could be handled with recoverMediaError().
            return;
        }
        trackNames.forEach((trackName)=>{
            var _this$transferData3, _this$transferData3$t, _trackCodec;
            const parsedTrack = data[trackName];
            const { id: id, codec: codec, levelCodec: levelCodec, container: container, metadata: metadata, supplemental: supplemental } = parsedTrack;
            let track = tracks[trackName];
            const transferredTrack = (_this$transferData3 = this.transferData) == null ? void 0 : (_this$transferData3$t = _this$transferData3.tracks) == null ? void 0 : _this$transferData3$t[trackName];
            const sbTrack = transferredTrack != null && transferredTrack.buffer ? transferredTrack : track;
            const sbCodec = (sbTrack == null ? void 0 : sbTrack.pendingCodec) || (sbTrack == null ? void 0 : sbTrack.codec);
            const trackLevelCodec = sbTrack == null ? void 0 : sbTrack.levelCodec;
            if (!track) track = tracks[trackName] = {
                buffer: undefined,
                listeners: [],
                codec: codec,
                supplemental: supplemental,
                container: container,
                levelCodec: levelCodec,
                metadata: metadata,
                id: id
            };
            // check if SourceBuffer codec needs to change
            const currentCodecFull = $99a156a15cd35eb3$var$pickMostCompleteCodecName(sbCodec, trackLevelCodec);
            const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace($99a156a15cd35eb3$var$VIDEO_CODEC_PROFILE_REPLACE, '$1');
            let trackCodec = $99a156a15cd35eb3$var$pickMostCompleteCodecName(codec, levelCodec);
            const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace($99a156a15cd35eb3$var$VIDEO_CODEC_PROFILE_REPLACE, '$1');
            if (trackCodec && currentCodecFull && currentCodec !== nextCodec) {
                if (trackName.slice(0, 5) === 'audio') trackCodec = $99a156a15cd35eb3$var$getCodecCompatibleName(trackCodec, this.appendSource);
                this.log(`switching codec ${sbCodec} to ${trackCodec}`);
                if (trackCodec !== (track.pendingCodec || track.codec)) track.pendingCodec = trackCodec;
                track.container = container;
                this.appendChangeType(trackName, container, trackCodec);
            }
        });
        if (this.tracksReady || this.sourceBufferCount) data.tracks = this.sourceBufferTracks;
        // if sourcebuffers already created, do nothing ...
        if (this.sourceBufferCount) return;
        if (this.mediaSourceOpenOrEnded) this.checkPendingTracks();
    }
    get sourceBufferTracks() {
        return Object.keys(this.tracks).reduce((baseTracks, type)=>{
            const track = this.tracks[type];
            baseTracks[type] = {
                id: track.id,
                container: track.container,
                codec: track.codec,
                levelCodec: track.levelCodec
            };
            return baseTracks;
        }, {});
    }
    appendChangeType(type, container, codec) {
        const mimeType = `${container};codecs=${codec}`;
        const operation = {
            label: `change-type=${mimeType}`,
            execute: ()=>{
                const track = this.tracks[type];
                if (track) {
                    const sb = track.buffer;
                    if (sb != null && sb.changeType) {
                        this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
                        sb.changeType(mimeType);
                        track.codec = codec;
                        track.container = container;
                    }
                }
                this.shiftAndExecuteNext(type);
            },
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: (error)=>{
                this.warn(`Failed to change ${type} SourceBuffer type`, error);
            }
        };
        this.append(operation, type, this.isPending(this.tracks[type]));
    }
    blockAudio(partOrFrag) {
        var _this$fragmentTracker;
        const pStart = partOrFrag.start;
        const pTime = pStart + partOrFrag.duration * 0.05;
        const atGap = ((_this$fragmentTracker = this.fragmentTracker.getAppendedFrag(pStart, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN)) == null ? void 0 : _this$fragmentTracker.gap) === true;
        if (atGap) return;
        const op = {
            label: 'block-audio',
            execute: ()=>{
                var _this$fragmentTracker2;
                const videoTrack = this.tracks.video;
                if (this.lastVideoAppendEnd > pTime || videoTrack != null && videoTrack.buffer && $99a156a15cd35eb3$var$BufferHelper.isBuffered(videoTrack.buffer, pTime) || ((_this$fragmentTracker2 = this.fragmentTracker.getAppendedFrag(pTime, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN)) == null ? void 0 : _this$fragmentTracker2.gap) === true) {
                    this.blockedAudioAppend = null;
                    this.shiftAndExecuteNext('audio');
                }
            },
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: (error)=>{
                this.warn('Error executing block-audio operation', error);
            }
        };
        this.blockedAudioAppend = {
            op: op,
            frag: partOrFrag
        };
        this.append(op, 'audio', true);
    }
    unblockAudio() {
        const { blockedAudioAppend: blockedAudioAppend, operationQueue: operationQueue } = this;
        if (blockedAudioAppend && operationQueue) {
            this.blockedAudioAppend = null;
            operationQueue.unblockAudio(blockedAudioAppend.op);
        }
    }
    onBufferAppending(event, eventData) {
        const { tracks: tracks } = this;
        const { data: data, type: type, parent: parent, frag: frag, part: part, chunkMeta: chunkMeta } = eventData;
        const chunkStats = chunkMeta.buffering[type];
        const sn = frag.sn;
        const bufferAppendingStart = self.performance.now();
        chunkStats.start = bufferAppendingStart;
        const fragBuffering = frag.stats.buffering;
        const partBuffering = part ? part.stats.buffering : null;
        if (fragBuffering.start === 0) fragBuffering.start = bufferAppendingStart;
        if (partBuffering && partBuffering.start === 0) partBuffering.start = bufferAppendingStart;
        // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
        // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
        // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
        // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
        // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
        const audioTrack = tracks.audio;
        let checkTimestampOffset = false;
        if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
            checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
            this.lastMpegAudioChunk = chunkMeta;
        }
        // Block audio append until overlapping video append
        const videoTrack = this.tracks.video;
        const videoSb = videoTrack == null ? void 0 : videoTrack.buffer;
        if (videoSb && sn !== 'initSegment') {
            const partOrFrag = part || frag;
            const blockedAudioAppend = this.blockedAudioAppend;
            if (type === 'audio' && parent !== 'main' && !this.blockedAudioAppend) {
                const pStart = partOrFrag.start;
                const pTime = pStart + partOrFrag.duration * 0.05;
                const vbuffered = videoSb.buffered;
                const vappending = this.currentOp('video');
                if (!vbuffered.length && !vappending) // wait for video before appending audio
                this.blockAudio(partOrFrag);
                else if (!vappending && !$99a156a15cd35eb3$var$BufferHelper.isBuffered(videoSb, pTime) && this.lastVideoAppendEnd < pTime) // audio is ahead of video
                this.blockAudio(partOrFrag);
            } else if (type === 'video') {
                const videoAppendEnd = partOrFrag.end;
                if (blockedAudioAppend) {
                    const audioStart = blockedAudioAppend.frag.start;
                    if (videoAppendEnd > audioStart || videoAppendEnd < this.lastVideoAppendEnd || $99a156a15cd35eb3$var$BufferHelper.isBuffered(videoSb, audioStart)) this.unblockAudio();
                }
                this.lastVideoAppendEnd = videoAppendEnd;
            }
        }
        const fragStart = (part || frag).start;
        const operation = {
            label: `append-${type}`,
            execute: ()=>{
                chunkStats.executeStart = self.performance.now();
                if (checkTimestampOffset) {
                    const track = this.tracks[type];
                    if (track) {
                        const sb = track.buffer;
                        if (sb) {
                            const delta = fragStart - sb.timestampOffset;
                            if (Math.abs(delta) >= 0.1) {
                                this.log(`Updating audio SourceBuffer timestampOffset to ${fragStart} (delta: ${delta}) sn: ${sn})`);
                                sb.timestampOffset = fragStart;
                            }
                        }
                    }
                }
                this.appendExecutor(data, type);
            },
            onStart: ()=>{
            // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
            },
            onComplete: ()=>{
                // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
                const end = self.performance.now();
                chunkStats.executeEnd = chunkStats.end = end;
                if (fragBuffering.first === 0) fragBuffering.first = end;
                if (partBuffering && partBuffering.first === 0) partBuffering.first = end;
                const timeRanges = {};
                this.sourceBuffers.forEach(([type, sb])=>{
                    if (type) timeRanges[type] = $99a156a15cd35eb3$var$BufferHelper.getBuffered(sb);
                });
                this.appendErrors[type] = 0;
                if (type === 'audio' || type === 'video') this.appendErrors.audiovideo = 0;
                else {
                    this.appendErrors.audio = 0;
                    this.appendErrors.video = 0;
                }
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, {
                    type: type,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    parent: frag.type,
                    timeRanges: timeRanges
                });
            },
            onError: (error)=>{
                var _this$media;
                // in case any error occured while appending, put back segment in segments table
                const event = {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                    parent: frag.type,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR,
                    sourceBufferName: type,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    error: error,
                    err: error,
                    fatal: false
                };
                const mediaError = (_this$media = this.media) == null ? void 0 : _this$media.error;
                if (error.code === DOMException.QUOTA_EXCEEDED_ERR) // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                event.details = $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_FULL_ERROR;
                else if (error.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !mediaError) // Allow retry for "Failed to execute 'appendBuffer' on 'SourceBuffer': This SourceBuffer is still processing" errors
                event.errorAction = $99a156a15cd35eb3$var$createDoNothingErrorAction(true);
                else if (error.name === $99a156a15cd35eb3$var$TRACK_REMOVED_ERROR_NAME && this.sourceBufferCount === 0) // Do nothing if sourceBuffers were removed (media is detached and append was not aborted)
                event.errorAction = $99a156a15cd35eb3$var$createDoNothingErrorAction(true);
                else {
                    const appendErrorCount = ++this.appendErrors[type];
                    /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */ this.warn(`Failed ${appendErrorCount}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer (${mediaError ? mediaError : 'no media error'})`);
                    if (appendErrorCount >= this.hls.config.appendErrorMaxRetry || !!mediaError) event.fatal = true;
                }
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, event);
            }
        };
        this.append(operation, type, this.isPending(this.tracks[type]));
    }
    getFlushOp(type, start, end) {
        this.log(`queuing "${type}" remove ${start}-${end}`);
        return {
            label: 'remove',
            execute: ()=>{
                this.removeExecutor(type, start, end);
            },
            onStart: ()=>{
            // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
            },
            onComplete: ()=>{
                // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, {
                    type: type
                });
            },
            onError: (error)=>{
                this.warn(`Failed to remove ${start}-${end} from "${type}" SourceBuffer`, error);
            }
        };
    }
    onBufferFlushing(event, data) {
        const { type: type, startOffset: startOffset, endOffset: endOffset } = data;
        if (type) this.append(this.getFlushOp(type, startOffset, endOffset), type);
        else this.sourceBuffers.forEach(([type])=>{
            if (type) this.append(this.getFlushOp(type, startOffset, endOffset), type);
        });
    }
    onFragParsed(event, data) {
        const { frag: frag, part: part } = data;
        const buffersAppendedTo = [];
        const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
        if (elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIOVIDEO]) buffersAppendedTo.push('audiovideo');
        else {
            if (elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO]) buffersAppendedTo.push('audio');
            if (elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO]) buffersAppendedTo.push('video');
        }
        const onUnblocked = ()=>{
            const now = self.performance.now();
            frag.stats.buffering.end = now;
            if (part) part.stats.buffering.end = now;
            const stats = part ? part.stats : frag.stats;
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, {
                frag: frag,
                part: part,
                stats: stats,
                id: frag.type
            });
        };
        if (buffersAppendedTo.length === 0) this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
        this.blockBuffers(onUnblocked, buffersAppendedTo).catch((error)=>{
            this.warn(`Fragment buffered callback ${error}`);
            this.stepOperationQueue(this.sourceBufferTypes);
        });
    }
    onFragChanged(event, data) {
        this.trimBuffers();
    }
    get bufferedToEnd() {
        return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type])=>{
            var _this$tracks$type2, _this$tracks$type3;
            return type && (!((_this$tracks$type2 = this.tracks[type]) != null && _this$tracks$type2.ended) || ((_this$tracks$type3 = this.tracks[type]) == null ? void 0 : _this$tracks$type3.ending));
        });
    }
    // on BUFFER_EOS mark matching sourcebuffer(s) as "ending" and "ended" and queue endOfStream after remaining operations(s)
    // an undefined data.type will mark all buffers as EOS.
    onBufferEos(event, data) {
        var _this$overrides;
        this.sourceBuffers.forEach(([type])=>{
            if (type) {
                const track = this.tracks[type];
                if (!data.type || data.type === type) {
                    track.ending = true;
                    if (!track.ended) {
                        track.ended = true;
                        this.log(`${type} buffer reached EOS`);
                    }
                }
            }
        });
        const allowEndOfStream = ((_this$overrides = this.overrides) == null ? void 0 : _this$overrides.endOfStream) !== false;
        const allTracksEnding = this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type])=>{
            var _this$tracks$type4;
            return type && !((_this$tracks$type4 = this.tracks[type]) != null && _this$tracks$type4.ended);
        });
        if (allTracksEnding) {
            if (allowEndOfStream) {
                this.log(`Queueing EOS`);
                this.blockUntilOpen(()=>{
                    this.tracksEnded();
                    const { mediaSource: mediaSource } = this;
                    if (!mediaSource || mediaSource.readyState !== 'open') {
                        if (mediaSource) this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
                        return;
                    }
                    this.log(`Calling mediaSource.endOfStream()`);
                    // Allow this to throw and be caught by the enqueueing function
                    mediaSource.endOfStream();
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFERED_TO_END, undefined);
                });
            } else {
                this.tracksEnded();
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFERED_TO_END, undefined);
            }
        }
    }
    tracksEnded() {
        this.sourceBuffers.forEach(([type])=>{
            if (type !== null) {
                const track = this.tracks[type];
                if (track) track.ending = false;
            }
        });
    }
    onLevelUpdated(event, { details: details }) {
        if (!details.fragments.length) return;
        this.details = details;
        this.updateDuration();
    }
    updateDuration() {
        const durationAndRange = this.getDurationAndRange();
        if (!durationAndRange) return;
        this.blockUntilOpen(()=>this.updateMediaSource(durationAndRange));
    }
    onError(event, data) {
        if (data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR && data.frag) {
            var _data$errorAction;
            const nextAutoLevel = (_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.nextAutoLevel;
            if ($99a156a15cd35eb3$var$isFiniteNumber(nextAutoLevel) && nextAutoLevel !== data.frag.level) this.resetAppendErrors();
        }
    }
    resetAppendErrors() {
        this.appendErrors = {
            audio: 0,
            video: 0,
            audiovideo: 0
        };
    }
    trimBuffers() {
        const { hls: hls, details: details, media: media } = this;
        if (!media || details === null) return;
        if (!this.sourceBufferCount) return;
        const config = hls.config;
        const currentTime = media.currentTime;
        const targetDuration = details.levelTargetDuration;
        // Support for deprecated liveBackBufferLength
        const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
        if ($99a156a15cd35eb3$var$isFiniteNumber(backBufferLength) && backBufferLength >= 0) {
            const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
            const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
            this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
        }
        if ($99a156a15cd35eb3$var$isFiniteNumber(config.frontBufferFlushThreshold) && config.frontBufferFlushThreshold > 0) {
            const frontBufferLength = Math.max(config.maxBufferLength, config.frontBufferFlushThreshold);
            const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
            const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
            this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
        }
    }
    flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
        this.sourceBuffers.forEach(([type, sb])=>{
            if (sb) {
                const buffered = $99a156a15cd35eb3$var$BufferHelper.getBuffered(sb);
                // when target buffer start exceeds actual buffer start
                if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                    var _this$details;
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    // Support for deprecated event:
                    const track = this.tracks[type];
                    if ((_this$details = this.details) != null && _this$details.live) this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LIVE_BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    else if (track != null && track.ended) {
                        this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
                        return;
                    }
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, {
                        startOffset: 0,
                        endOffset: targetBackBufferPosition,
                        type: type
                    });
                }
            }
        });
    }
    flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
        this.sourceBuffers.forEach(([type, sb])=>{
            if (sb) {
                const buffered = $99a156a15cd35eb3$var$BufferHelper.getBuffered(sb);
                const numBufferedRanges = buffered.length;
                // The buffer is either empty or contiguous
                if (numBufferedRanges < 2) return;
                const bufferStart = buffered.start(numBufferedRanges - 1);
                const bufferEnd = buffered.end(numBufferedRanges - 1);
                // No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
                if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) return;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, {
                    startOffset: bufferStart,
                    endOffset: Infinity,
                    type: type
                });
            }
        });
    }
    /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */ getDurationAndRange() {
        var _this$overrides2;
        const { details: details, mediaSource: mediaSource } = this;
        if (!details || !this.media || (mediaSource == null ? void 0 : mediaSource.readyState) !== 'open') return null;
        const playlistEnd = details.edge;
        if (details.live && this.hls.config.liveDurationInfinity) {
            const len = details.fragments.length;
            if (len && details.live && !!mediaSource.setLiveSeekableRange) {
                const start = Math.max(0, details.fragmentStart);
                const end = Math.max(start, playlistEnd);
                return {
                    duration: Infinity,
                    start: start,
                    end: end
                };
            }
            return {
                duration: Infinity
            };
        }
        const overrideDuration = (_this$overrides2 = this.overrides) == null ? void 0 : _this$overrides2.duration;
        if (overrideDuration) {
            if (!$99a156a15cd35eb3$var$isFiniteNumber(overrideDuration)) return null;
            return {
                duration: overrideDuration
            };
        }
        const mediaDuration = this.media.duration;
        const msDuration = $99a156a15cd35eb3$var$isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
        if (playlistEnd > msDuration && playlistEnd > mediaDuration || !$99a156a15cd35eb3$var$isFiniteNumber(mediaDuration)) return {
            duration: playlistEnd
        };
        return null;
    }
    updateMediaSource({ duration: duration, start: start, end: end }) {
        const mediaSource = this.mediaSource;
        if (!this.media || !mediaSource || mediaSource.readyState !== 'open') return;
        if (mediaSource.duration !== duration) {
            if ($99a156a15cd35eb3$var$isFiniteNumber(duration)) this.log(`Updating MediaSource duration to ${duration.toFixed(3)}`);
            mediaSource.duration = duration;
        }
        if (start !== undefined && end !== undefined) {
            this.log(`MediaSource duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
            mediaSource.setLiveSeekableRange(start, end);
        }
    }
    get tracksReady() {
        const pendingTrackCount = this.pendingTrackCount;
        return pendingTrackCount > 0 && (pendingTrackCount >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
    }
    checkPendingTracks() {
        const { bufferCodecEventsTotal: bufferCodecEventsTotal, pendingTrackCount: pendingTrackCount, tracks: tracks } = this;
        this.log(`checkPendingTracks (pending: ${pendingTrackCount} codec events expected: ${bufferCodecEventsTotal}) ${$99a156a15cd35eb3$var$stringify(tracks)}`);
        // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
        // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
        // data has been appended to existing ones.
        // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
        if (this.tracksReady) {
            var _this$transferData4;
            const transferredTracks = (_this$transferData4 = this.transferData) == null ? void 0 : _this$transferData4.tracks;
            if (transferredTracks && Object.keys(transferredTracks).length) this.attachTransferred();
            else // ok, let's create them now !
            this.createSourceBuffers();
        }
    }
    bufferCreated() {
        if (this.sourceBufferCount) {
            const tracks = {};
            this.sourceBuffers.forEach(([type, buffer])=>{
                if (type) {
                    const track = this.tracks[type];
                    tracks[type] = {
                        buffer: buffer,
                        container: track.container,
                        codec: track.codec,
                        supplemental: track.supplemental,
                        levelCodec: track.levelCodec,
                        id: track.id,
                        metadata: track.metadata
                    };
                }
            });
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, {
                tracks: tracks
            });
            this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`);
            this.sourceBuffers.forEach(([type])=>{
                this.executeNext(type);
            });
        } else {
            const error = new Error('could not create source buffer for media codec(s)');
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                fatal: true,
                error: error,
                reason: error.message
            });
        }
    }
    createSourceBuffers() {
        const { tracks: tracks, sourceBuffers: sourceBuffers, mediaSource: mediaSource } = this;
        if (!mediaSource) throw new Error('createSourceBuffers called when mediaSource was null');
        for(const trackName in tracks){
            const type = trackName;
            const track = tracks[type];
            if (this.isPending(track)) {
                const codec = this.getTrackCodec(track, type);
                const mimeType = `${track.container};codecs=${codec}`;
                track.codec = codec;
                this.log(`creating sourceBuffer(${mimeType})${this.currentOp(type) ? ' Queued' : ''} ${$99a156a15cd35eb3$var$stringify(track)}`);
                try {
                    const sb = mediaSource.addSourceBuffer(mimeType);
                    const sbIndex = $99a156a15cd35eb3$var$sourceBufferNameToIndex(type);
                    const sbTuple = [
                        type,
                        sb
                    ];
                    sourceBuffers[sbIndex] = sbTuple;
                    track.buffer = sb;
                } catch (error) {
                    var _this$operationQueue;
                    this.error(`error while trying to add sourceBuffer: ${error.message}`);
                    // remove init segment from queue and delete track info
                    this.shiftAndExecuteNext(type);
                    (_this$operationQueue = this.operationQueue) == null || _this$operationQueue.removeBlockers();
                    delete this.tracks[type];
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR,
                        fatal: false,
                        error: error,
                        sourceBufferName: type,
                        mimeType: mimeType,
                        parent: track.id
                    });
                    return;
                }
                this.trackSourceBuffer(type, track);
            }
        }
        this.bufferCreated();
    }
    getTrackCodec(track, trackName) {
        // Use supplemental video codec when supported when adding SourceBuffer (#5558)
        const supplementalCodec = track.supplemental;
        let trackCodec = track.codec;
        if (supplementalCodec && (trackName === 'video' || trackName === 'audiovideo') && $99a156a15cd35eb3$var$areCodecsMediaSourceSupported(supplementalCodec, 'video')) trackCodec = $99a156a15cd35eb3$var$replaceVideoCodec(trackCodec, supplementalCodec);
        const codec = $99a156a15cd35eb3$var$pickMostCompleteCodecName(trackCodec, track.levelCodec);
        if (codec) {
            if (trackName.slice(0, 5) === 'audio') return $99a156a15cd35eb3$var$getCodecCompatibleName(codec, this.appendSource);
            return codec;
        }
        return '';
    }
    trackSourceBuffer(type, track) {
        const buffer = track.buffer;
        if (!buffer) return;
        const codec = this.getTrackCodec(track, type);
        this.tracks[type] = {
            buffer: buffer,
            codec: codec,
            container: track.container,
            levelCodec: track.levelCodec,
            supplemental: track.supplemental,
            metadata: track.metadata,
            id: track.id,
            listeners: []
        };
        this.removeBufferListeners(type);
        this.addBufferListener(type, 'updatestart', this.onSBUpdateStart);
        this.addBufferListener(type, 'updateend', this.onSBUpdateEnd);
        this.addBufferListener(type, 'error', this.onSBUpdateError);
        // ManagedSourceBuffer bufferedchange event
        if (this.appendSource) this.addBufferListener(type, 'bufferedchange', (type, event)=>{
            // If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
            const removedRanges = event.removedRanges;
            if (removedRanges != null && removedRanges.length) this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, {
                type: type
            });
        });
    }
    get mediaSrc() {
        var _this$media2, _this$media2$querySel;
        const media = ((_this$media2 = this.media) == null ? void 0 : (_this$media2$querySel = _this$media2.querySelector) == null ? void 0 : _this$media2$querySel.call(_this$media2, 'source')) || this.media;
        return media == null ? void 0 : media.src;
    }
    onSBUpdateStart(type) {
        const operation = this.currentOp(type);
        if (!operation) return;
        operation.onStart();
    }
    onSBUpdateEnd(type) {
        var _this$mediaSource4;
        if (((_this$mediaSource4 = this.mediaSource) == null ? void 0 : _this$mediaSource4.readyState) === 'closed') {
            this.resetBuffer(type);
            return;
        }
        const operation = this.currentOp(type);
        if (!operation) return;
        operation.onComplete();
        this.shiftAndExecuteNext(type);
    }
    onSBUpdateError(type, event) {
        var _this$mediaSource5;
        const error = new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource5 = this.mediaSource) == null ? void 0 : _this$mediaSource5.readyState}`);
        this.error(`${error}`, event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPENDING_ERROR,
            sourceBufferName: type,
            error: error,
            fatal: false
        });
        // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
        const operation = this.currentOp(type);
        if (operation) operation.onError(error);
    }
    // This method must result in an updateend event; if remove is not called, onSBUpdateEnd must be called manually
    removeExecutor(type, startOffset, endOffset) {
        const { media: media, mediaSource: mediaSource } = this;
        const track = this.tracks[type];
        const sb = track == null ? void 0 : track.buffer;
        if (!media || !mediaSource || !sb) {
            this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
            this.shiftAndExecuteNext(type);
            return;
        }
        const mediaDuration = $99a156a15cd35eb3$var$isFiniteNumber(media.duration) ? media.duration : Infinity;
        const msDuration = $99a156a15cd35eb3$var$isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
        const removeStart = Math.max(0, startOffset);
        const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
        if (removeEnd > removeStart && (!track.ending || track.ended)) {
            track.ended = false;
            this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
            sb.remove(removeStart, removeEnd);
        } else // Cycle the queue
        this.shiftAndExecuteNext(type);
    }
    // This method must result in an updateend event; if append is not called, onSBUpdateEnd must be called manually
    appendExecutor(data, type) {
        const track = this.tracks[type];
        const sb = track == null ? void 0 : track.buffer;
        if (!sb) throw new $99a156a15cd35eb3$var$HlsJsTrackRemovedError(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
        track.ending = false;
        track.ended = false;
        sb.appendBuffer(data);
    }
    blockUntilOpen(callback) {
        if (this.isUpdating() || this.isQueued()) this.blockBuffers(callback).catch((error)=>{
            this.warn(`SourceBuffer blocked callback ${error}`);
            this.stepOperationQueue(this.sourceBufferTypes);
        });
        else try {
            callback();
        } catch (error) {
            this.warn(`Callback run without blocking ${this.operationQueue} ${error}`);
        }
    }
    isUpdating() {
        return this.sourceBuffers.some(([type, sb])=>type && sb.updating);
    }
    isQueued() {
        return this.sourceBuffers.some(([type])=>type && !!this.currentOp(type));
    }
    isPending(track) {
        return !!track && !track.buffer;
    }
    // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
    // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
    // upon completion, since we already do it here
    blockBuffers(onUnblocked, bufferNames = this.sourceBufferTypes) {
        if (!bufferNames.length) {
            this.log('Blocking operation requested, but no SourceBuffers exist');
            return Promise.resolve().then(onUnblocked);
        }
        const { operationQueue: operationQueue } = this;
        // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
        const blockingOperations = bufferNames.map((type)=>this.appendBlocker(type));
        const audioBlocked = bufferNames.length > 1 && !!this.blockedAudioAppend;
        if (audioBlocked) this.unblockAudio();
        return Promise.all(blockingOperations).then((result)=>{
            if (operationQueue !== this.operationQueue) return;
            // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
            onUnblocked();
            this.stepOperationQueue(this.sourceBufferTypes);
        });
    }
    stepOperationQueue(bufferNames) {
        bufferNames.forEach((type)=>{
            var _this$tracks$type5;
            const sb = (_this$tracks$type5 = this.tracks[type]) == null ? void 0 : _this$tracks$type5.buffer;
            // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
            // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
            // While this is a workaround, it's probably useful to have around
            if (!sb || sb.updating) return;
            this.shiftAndExecuteNext(type);
        });
    }
    append(operation, type, pending) {
        if (this.operationQueue) this.operationQueue.append(operation, type, pending);
    }
    appendBlocker(type) {
        if (this.operationQueue) return this.operationQueue.appendBlocker(type);
    }
    currentOp(type) {
        if (this.operationQueue) return this.operationQueue.current(type);
        return null;
    }
    executeNext(type) {
        if (type && this.operationQueue) this.operationQueue.executeNext(type);
    }
    shiftAndExecuteNext(type) {
        if (this.operationQueue) this.operationQueue.shiftAndExecuteNext(type);
    }
    get pendingTrackCount() {
        return Object.keys(this.tracks).reduce((acc, type)=>acc + (this.isPending(this.tracks[type]) ? 1 : 0), 0);
    }
    get sourceBufferCount() {
        return this.sourceBuffers.reduce((acc, [type])=>acc + (type ? 1 : 0), 0);
    }
    get sourceBufferTypes() {
        return this.sourceBuffers.map(([type])=>type).filter((type)=>!!type);
    }
    addBufferListener(type, event, fn) {
        const track = this.tracks[type];
        if (!track) return;
        const buffer = track.buffer;
        if (!buffer) return;
        const listener = fn.bind(this, type);
        track.listeners.push({
            event: event,
            listener: listener
        });
        buffer.addEventListener(event, listener);
    }
    removeBufferListeners(type) {
        const track = this.tracks[type];
        if (!track) return;
        const buffer = track.buffer;
        if (!buffer) return;
        track.listeners.forEach((l)=>{
            buffer.removeEventListener(l.event, l.listener);
        });
        track.listeners.length = 0;
    }
}
function $99a156a15cd35eb3$var$removeSourceChildren(node) {
    const sourceChildren = node.querySelectorAll('source');
    [].slice.call(sourceChildren).forEach((source)=>{
        node.removeChild(source);
    });
}
function $99a156a15cd35eb3$var$addSource(media, url) {
    const source = self.document.createElement('source');
    source.type = 'video/mp4';
    source.src = url;
    media.appendChild(source);
}
function $99a156a15cd35eb3$var$sourceBufferNameToIndex(type) {
    return type === 'audio' ? 1 : 0;
}
class $99a156a15cd35eb3$export$24bc69225d44061c {
    constructor(hls){
        this.hls = void 0;
        this.autoLevelCapping = void 0;
        this.firstLevel = void 0;
        this.media = void 0;
        this.restrictedLevels = void 0;
        this.timer = void 0;
        this.clientRect = void 0;
        this.streamController = void 0;
        this.hls = hls;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.firstLevel = -1;
        this.media = null;
        this.restrictedLevels = [];
        this.timer = undefined;
        this.clientRect = null;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    destroy() {
        if (this.hls) this.unregisterListener();
        if (this.timer) this.stopCapping();
        this.media = null;
        this.clientRect = null;
        // @ts-ignore
        this.hls = this.streamController = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    unregisterListener() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    onFpsDropLevelCapping(event, data) {
        // Don't add a restricted level more than once
        const level = this.hls.levels[data.droppedLevel];
        if (this.isLevelAllowed(level)) this.restrictedLevels.push({
            bitrate: level.bitrate,
            height: level.height,
            width: level.width
        });
    }
    onMediaAttaching(event, data) {
        this.media = data.media instanceof HTMLVideoElement ? data.media : null;
        this.clientRect = null;
        if (this.timer && this.hls.levels.length) this.detectPlayerSize();
    }
    onManifestParsed(event, data) {
        const hls = this.hls;
        this.restrictedLevels = [];
        this.firstLevel = data.firstLevel;
        if (hls.config.capLevelToPlayerSize && data.video) // Start capping immediately if the manifest has signaled video codecs
        this.startCapping();
    }
    onLevelsUpdated(event, data) {
        if (this.timer && $99a156a15cd35eb3$var$isFiniteNumber(this.autoLevelCapping)) this.detectPlayerSize();
    }
    // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
    // to the first level
    onBufferCodecs(event, data) {
        const hls = this.hls;
        if (hls.config.capLevelToPlayerSize && data.video) // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
        this.startCapping();
    }
    onMediaDetaching() {
        this.stopCapping();
        this.media = null;
    }
    detectPlayerSize() {
        if (this.media) {
            if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
                this.clientRect = null;
                return;
            }
            const levels = this.hls.levels;
            if (levels.length) {
                const hls = this.hls;
                const maxLevel = this.getMaxLevel(levels.length - 1);
                if (maxLevel !== this.autoLevelCapping) hls.logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
                hls.autoLevelCapping = maxLevel;
                if (hls.autoLevelEnabled && hls.autoLevelCapping > this.autoLevelCapping && this.streamController) // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                // usually happen when the user go to the fullscreen mode.
                this.streamController.nextLevelSwitch();
                this.autoLevelCapping = hls.autoLevelCapping;
            }
        }
    }
    /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */ getMaxLevel(capLevelIndex) {
        const levels = this.hls.levels;
        if (!levels.length) return -1;
        const validLevels = levels.filter((level, index)=>this.isLevelAllowed(level) && index <= capLevelIndex);
        this.clientRect = null;
        return $99a156a15cd35eb3$export$24bc69225d44061c.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    }
    startCapping() {
        if (this.timer) // Don't reset capping if started twice; this can happen if the manifest signals a video codec
        return;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        self.clearInterval(this.timer);
        this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
    }
    stopCapping() {
        this.restrictedLevels = [];
        this.firstLevel = -1;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
            self.clearInterval(this.timer);
            this.timer = undefined;
        }
    }
    getDimensions() {
        if (this.clientRect) return this.clientRect;
        const media = this.media;
        const boundsRect = {
            width: 0,
            height: 0
        };
        if (media) {
            const clientRect = media.getBoundingClientRect();
            boundsRect.width = clientRect.width;
            boundsRect.height = clientRect.height;
            if (!boundsRect.width && !boundsRect.height) {
                // When the media element has no width or height (equivalent to not being in the DOM),
                // then use its width and height attributes (media.width, media.height)
                boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
                boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
            }
        }
        this.clientRect = boundsRect;
        return boundsRect;
    }
    get mediaWidth() {
        return this.getDimensions().width * this.contentScaleFactor;
    }
    get mediaHeight() {
        return this.getDimensions().height * this.contentScaleFactor;
    }
    get contentScaleFactor() {
        let pixelRatio = 1;
        if (!this.hls.config.ignoreDevicePixelRatio) try {
            pixelRatio = self.devicePixelRatio;
        } catch (e) {
        /* no-op */ }
        return Math.min(pixelRatio, this.hls.config.maxDevicePixelRatio);
    }
    isLevelAllowed(level) {
        const restrictedLevels = this.restrictedLevels;
        return !restrictedLevels.some((restrictedLevel)=>{
            return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
        });
    }
    static getMaxLevelByMediaSize(levels, width, height) {
        if (!(levels != null && levels.length)) return -1;
        // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
        // to determine whether we've chosen the greatest bandwidth for the media's dimensions
        const atGreatestBandwidth = (curLevel, nextLevel)=>{
            if (!nextLevel) return true;
            return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
        };
        // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
        // the max level
        let maxLevelIndex = levels.length - 1;
        // Prevent changes in aspect-ratio from causing capping to toggle back and forth
        const squareSize = Math.max(width, height);
        for(let i = 0; i < levels.length; i += 1){
            const level = levels[i];
            if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
                maxLevelIndex = i;
                break;
            }
        }
        return maxLevelIndex;
    }
}
/**
 * Common Media Object Type
 *
 * @internal
 */ const $99a156a15cd35eb3$var$CmObjectType = {
    /**
   * text file, such as a manifest or playlist
   */ MANIFEST: 'm',
    /**
   * audio only
   */ AUDIO: 'a',
    /**
   * video only
   */ VIDEO: 'v',
    /**
   * muxed audio and video
   */ MUXED: 'av',
    /**
   * init segment
   */ INIT: 'i',
    /**
   * caption or subtitle
   */ CAPTION: 'c',
    /**
   * ISOBMFF timed text track
   */ TIMED_TEXT: 'tt',
    /**
   * cryptographic key, license or certificate.
   */ KEY: 'k',
    /**
   * other
   */ OTHER: 'o'
};
/**
 * Common Media Client Data Object Type
 *
 * @group CMCD
 *
 * @beta
 *
 * @enum
 */ const $99a156a15cd35eb3$var$CmcdObjectType = $99a156a15cd35eb3$var$CmObjectType;
/**
 * Common Media Streaming Format
 *
 * @internal
 */ const $99a156a15cd35eb3$var$CmStreamingFormat = {
    /**
   * HTTP Live Streaming (HLS)
   */ HLS: 'h'
};
/**
 * Common Media Client Data Streaming Format
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CmcdStreamingFormat = $99a156a15cd35eb3$var$CmStreamingFormat;
/**
 * CMCD object header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CMCD_OBJECT = 'CMCD-Object';
/**
 * CMCD request header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CMCD_REQUEST = 'CMCD-Request';
/**
 * CMCD session header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CMCD_SESSION = 'CMCD-Session';
/**
 * CMCD status header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CMCD_STATUS = 'CMCD-Status';
/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CmcdHeaderField = {
    /**
   * keys whose values vary with the object being requested.
   */ OBJECT: $99a156a15cd35eb3$var$CMCD_OBJECT,
    /**
   * keys whose values vary with each request.
   */ REQUEST: $99a156a15cd35eb3$var$CMCD_REQUEST,
    /**
   * keys whose values are expected to be invariant over the life of the session.
   */ SESSION: $99a156a15cd35eb3$var$CMCD_SESSION,
    /**
   * keys whose values do not vary with every request or object.
   */ STATUS: $99a156a15cd35eb3$var$CMCD_STATUS
};
/**
 * The map of CMCD header fields to official CMCD keys.
 *
 * @internal
 *
 * @group CMCD
 */ const $99a156a15cd35eb3$var$CmcdHeaderMap = {
    [$99a156a15cd35eb3$var$CmcdHeaderField.OBJECT]: [
        'br',
        'd',
        'ot',
        'tb'
    ],
    [$99a156a15cd35eb3$var$CmcdHeaderField.REQUEST]: [
        'bl',
        'dl',
        'mtp',
        'nor',
        'nrr',
        'su'
    ],
    [$99a156a15cd35eb3$var$CmcdHeaderField.SESSION]: [
        'cid',
        'pr',
        'sf',
        'sid',
        'st',
        'v'
    ],
    [$99a156a15cd35eb3$var$CmcdHeaderField.STATUS]: [
        'bs',
        'rtp'
    ]
};
/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */ class $99a156a15cd35eb3$var$SfItem {
    constructor(value, params){
        if (Array.isArray(value)) value = value.map((v)=>v instanceof $99a156a15cd35eb3$var$SfItem ? v : new $99a156a15cd35eb3$var$SfItem(v));
        this.value = value;
        this.params = params;
    }
}
const $99a156a15cd35eb3$var$DICT = 'Dict';
function $99a156a15cd35eb3$var$format(value) {
    if (Array.isArray(value)) return JSON.stringify(value);
    if (value instanceof Map) return 'Map{}';
    if (value instanceof Set) return 'Set{}';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}
function $99a156a15cd35eb3$var$throwError(action, src, type, cause) {
    return new Error(`failed to ${action} "${$99a156a15cd35eb3$var$format(src)}" as ${type}`, {
        cause: cause
    });
}
function $99a156a15cd35eb3$var$serializeError(src, type, cause) {
    return $99a156a15cd35eb3$var$throwError('serialize', src, type, cause);
}
/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */ class $99a156a15cd35eb3$var$SfToken {
    constructor(description){
        this.description = description;
    }
}
const $99a156a15cd35eb3$var$BARE_ITEM = 'Bare Item';
const $99a156a15cd35eb3$var$BOOLEAN = 'Boolean';
// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function $99a156a15cd35eb3$var$serializeBoolean(value) {
    if (typeof value !== 'boolean') throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$BOOLEAN);
    return value ? '?1' : '?0';
}
/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */ function $99a156a15cd35eb3$var$base64encode(binary) {
    return btoa(String.fromCharCode(...binary));
}
const $99a156a15cd35eb3$var$BYTES = 'Byte Sequence';
// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function $99a156a15cd35eb3$var$serializeByteSequence(value) {
    if (ArrayBuffer.isView(value) === false) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$BYTES);
    return `:${$99a156a15cd35eb3$var$base64encode(value)}:`;
}
const $99a156a15cd35eb3$var$INTEGER = 'Integer';
function $99a156a15cd35eb3$var$isInvalidInt(value) {
    return value < -999999999999999 || 999999999999999 < value;
}
// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function $99a156a15cd35eb3$var$serializeInteger(value) {
    if ($99a156a15cd35eb3$var$isInvalidInt(value)) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$INTEGER);
    return value.toString();
}
// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function $99a156a15cd35eb3$var$serializeDate(value) {
    return `@${$99a156a15cd35eb3$var$serializeInteger(value.getTime() / 1000)}`;
}
/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */ function $99a156a15cd35eb3$var$roundToEven(value, precision) {
    if (value < 0) return -$99a156a15cd35eb3$var$roundToEven(-value, precision);
    const decimalShift = Math.pow(10, precision);
    const isEquidistant = Math.abs(value * decimalShift % 1 - 0.5) < Number.EPSILON;
    if (isEquidistant) {
        // If the tail of the decimal place is 'equidistant' we round to the nearest even value
        const flooredValue = Math.floor(value * decimalShift);
        return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
    } else // Otherwise, proceed as normal
    return Math.round(value * decimalShift) / decimalShift;
}
const $99a156a15cd35eb3$var$DECIMAL = 'Decimal';
// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function $99a156a15cd35eb3$var$serializeDecimal(value) {
    const roundedValue = $99a156a15cd35eb3$var$roundToEven(value, 3); // round to 3 decimal places
    if (Math.floor(Math.abs(roundedValue)).toString().length > 12) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$DECIMAL);
    const stringValue = roundedValue.toString();
    return stringValue.includes('.') ? stringValue : `${stringValue}.0`;
}
const $99a156a15cd35eb3$var$STRING = 'String';
const $99a156a15cd35eb3$var$STRING_REGEX = /[\x00-\x1f\x7f]+/;
// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function $99a156a15cd35eb3$var$serializeString(value) {
    if ($99a156a15cd35eb3$var$STRING_REGEX.test(value)) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$STRING);
    return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}
/**
 * Converts a symbol to a string.
 *
 * @param symbol - The symbol to convert.
 *
 * @returns The string representation of the symbol.
 *
 * @internal
 */ function $99a156a15cd35eb3$var$symbolToStr(symbol) {
    return symbol.description || symbol.toString().slice(7, -1);
}
const $99a156a15cd35eb3$var$TOKEN = 'Token';
function $99a156a15cd35eb3$var$serializeToken(token) {
    const value = $99a156a15cd35eb3$var$symbolToStr(token);
    if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$TOKEN);
    return value;
}
// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function $99a156a15cd35eb3$var$serializeBareItem(value) {
    switch(typeof value){
        case 'number':
            if (!$99a156a15cd35eb3$var$isFiniteNumber(value)) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$BARE_ITEM);
            if (Number.isInteger(value)) return $99a156a15cd35eb3$var$serializeInteger(value);
            return $99a156a15cd35eb3$var$serializeDecimal(value);
        case 'string':
            return $99a156a15cd35eb3$var$serializeString(value);
        case 'symbol':
            return $99a156a15cd35eb3$var$serializeToken(value);
        case 'boolean':
            return $99a156a15cd35eb3$var$serializeBoolean(value);
        case 'object':
            if (value instanceof Date) return $99a156a15cd35eb3$var$serializeDate(value);
            if (value instanceof Uint8Array) return $99a156a15cd35eb3$var$serializeByteSequence(value);
            if (value instanceof $99a156a15cd35eb3$var$SfToken) return $99a156a15cd35eb3$var$serializeToken(value);
        default:
            // fail
            throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$BARE_ITEM);
    }
}
const $99a156a15cd35eb3$var$KEY = 'Key';
// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function $99a156a15cd35eb3$var$serializeKey(value) {
    if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) throw $99a156a15cd35eb3$var$serializeError(value, $99a156a15cd35eb3$var$KEY);
    return value;
}
// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function $99a156a15cd35eb3$var$serializeParams(params) {
    if (params == null) return '';
    return Object.entries(params).map(([key, value])=>{
        if (value === true) return `;${$99a156a15cd35eb3$var$serializeKey(key)}`; // omit true
        return `;${$99a156a15cd35eb3$var$serializeKey(key)}=${$99a156a15cd35eb3$var$serializeBareItem(value)}`;
    }).join('');
}
// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function $99a156a15cd35eb3$var$serializeItem(value) {
    if (value instanceof $99a156a15cd35eb3$var$SfItem) return `${$99a156a15cd35eb3$var$serializeBareItem(value.value)}${$99a156a15cd35eb3$var$serializeParams(value.params)}`;
    else return $99a156a15cd35eb3$var$serializeBareItem(value);
}
// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function $99a156a15cd35eb3$var$serializeInnerList(value) {
    return `(${value.value.map($99a156a15cd35eb3$var$serializeItem).join(' ')})${$99a156a15cd35eb3$var$serializeParams(value.params)}`;
}
// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function $99a156a15cd35eb3$var$serializeDict(dict, options = {
    whitespace: true
}) {
    if (typeof dict !== 'object') throw $99a156a15cd35eb3$var$serializeError(dict, $99a156a15cd35eb3$var$DICT);
    const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
    const optionalWhiteSpace = (options === null || options === void 0 ? void 0 : options.whitespace) ? ' ' : '';
    return Array.from(entries).map(([key, item])=>{
        if (item instanceof $99a156a15cd35eb3$var$SfItem === false) item = new $99a156a15cd35eb3$var$SfItem(item);
        let output = $99a156a15cd35eb3$var$serializeKey(key);
        if (item.value === true) output += $99a156a15cd35eb3$var$serializeParams(item.params);
        else {
            output += '=';
            if (Array.isArray(item.value)) output += $99a156a15cd35eb3$var$serializeInnerList(item);
            else output += $99a156a15cd35eb3$var$serializeItem(item);
        }
        return output;
    }).join(`,${optionalWhiteSpace}`);
}
/**
 * Encode an object into a structured field dictionary
 *
 * @param value - The structured field dictionary to encode
 * @param options - Encoding options
 *
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */ function $99a156a15cd35eb3$var$encodeSfDict(value, options) {
    return $99a156a15cd35eb3$var$serializeDict(value, options);
}
/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 */ function $99a156a15cd35eb3$var$isTokenField(key) {
    return key === 'ot' || key === 'sf' || key === 'st';
}
/**
 * Checks if the given value is valid
 *
 * @param value - The value to check.
 *
 * @returns `true` if the key is a value is valid.
 *
 * @internal
 */ function $99a156a15cd35eb3$var$isValid(value) {
    if (typeof value === 'number') return $99a156a15cd35eb3$var$isFiniteNumber(value);
    return value != null && value !== '' && value !== false;
}
/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */ function $99a156a15cd35eb3$var$urlToRelativePath(url, base) {
    const to = new URL(url);
    const from = new URL(base);
    if (to.origin !== from.origin) return url;
    const toPath = to.pathname.split('/').slice(1);
    const fromPath = from.pathname.split('/').slice(1, -1);
    // remove common parents
    while(toPath[0] === fromPath[0]){
        toPath.shift();
        fromPath.shift();
    }
    // add back paths
    while(fromPath.length){
        fromPath.shift();
        toPath.unshift('..');
    }
    return toPath.join('/');
}
const $99a156a15cd35eb3$var$toRounded = (value)=>Math.round(value);
const $99a156a15cd35eb3$var$toUrlSafe = (value, options)=>{
    if (options === null || options === void 0 ? void 0 : options.baseUrl) value = $99a156a15cd35eb3$var$urlToRelativePath(value, options.baseUrl);
    return encodeURIComponent(value);
};
const $99a156a15cd35eb3$var$toHundred = (value)=>$99a156a15cd35eb3$var$toRounded(value / 100) * 100;
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CmcdFormatters = {
    /**
   * Bitrate (kbps) rounded integer
   */ br: $99a156a15cd35eb3$var$toRounded,
    /**
   * Duration (milliseconds) rounded integer
   */ d: $99a156a15cd35eb3$var$toRounded,
    /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */ bl: $99a156a15cd35eb3$var$toHundred,
    /**
   * Deadline (milliseconds) rounded nearest 100ms
   */ dl: $99a156a15cd35eb3$var$toHundred,
    /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */ mtp: $99a156a15cd35eb3$var$toHundred,
    /**
   * Next Object Request URL encoded
   */ nor: $99a156a15cd35eb3$var$toUrlSafe,
    /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */ rtp: $99a156a15cd35eb3$var$toHundred,
    /**
   * Top Bitrate (kbps) rounded integer
   */ tb: $99a156a15cd35eb3$var$toRounded
};
/**
 * Internal CMCD processing function.
 *
 * @param obj - The CMCD object to process.
 * @param map - The mapping function to use.
 * @param options - Options for encoding.
 *
 * @internal
 *
 * @group CMCD
 */ function $99a156a15cd35eb3$var$processCmcd(obj, options) {
    const results = {};
    if (obj == null || typeof obj !== 'object') return results;
    const keys = Object.keys(obj).sort();
    const formatters = $99a156a15cd35eb3$var$_extends({}, $99a156a15cd35eb3$var$CmcdFormatters, options === null || options === void 0 ? void 0 : options.formatters);
    const filter = options === null || options === void 0 ? void 0 : options.filter;
    keys.forEach((key)=>{
        if (filter === null || filter === void 0 ? void 0 : filter(key)) return;
        let value = obj[key];
        const formatter = formatters[key];
        if (formatter) value = formatter(value, options);
        // Version should only be reported if not equal to 1.
        if (key === 'v' && value === 1) return;
        // Playback rate should only be sent if not equal to 1.
        if (key == 'pr' && value === 1) return;
        // ignore invalid values
        if (!$99a156a15cd35eb3$var$isValid(value)) return;
        if ($99a156a15cd35eb3$var$isTokenField(key) && typeof value === 'string') value = new $99a156a15cd35eb3$var$SfToken(value);
        results[key] = value;
    });
    return results;
}
/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 */ function $99a156a15cd35eb3$var$encodeCmcd(cmcd, options = {}) {
    if (!cmcd) return '';
    return $99a156a15cd35eb3$var$encodeSfDict($99a156a15cd35eb3$var$processCmcd(cmcd, options), $99a156a15cd35eb3$var$_extends({
        whitespace: false
    }, options));
}
/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */ function $99a156a15cd35eb3$var$toCmcdHeaders(cmcd, options = {}) {
    const result = {};
    if (!cmcd) return result;
    const entries = Object.entries(cmcd);
    const headerMap = Object.entries($99a156a15cd35eb3$var$CmcdHeaderMap).concat(Object.entries((options === null || options === void 0 ? void 0 : options.customHeaderMap) || {}));
    const shards = entries.reduce((acc, entry)=>{
        var _a, _b;
        const [key, value] = entry;
        const field = ((_a = headerMap.find((entry)=>entry[1].includes(key))) === null || _a === void 0 ? void 0 : _a[0]) || $99a156a15cd35eb3$var$CmcdHeaderField.REQUEST;
        (_b = acc[field]) !== null && _b !== void 0 ? _b : acc[field] = {};
        acc[field][key] = value;
        return acc;
    }, {});
    return Object.entries(shards).reduce((acc, [field, value])=>{
        acc[field] = $99a156a15cd35eb3$var$encodeCmcd(value, options);
        return acc;
    }, result);
}
/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Encode options.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 */ function $99a156a15cd35eb3$var$appendCmcdHeaders(headers, cmcd, options) {
    return $99a156a15cd35eb3$var$_extends(headers, $99a156a15cd35eb3$var$toCmcdHeaders(cmcd, options));
}
/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */ const $99a156a15cd35eb3$var$CMCD_PARAM = 'CMCD';
/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 */ function $99a156a15cd35eb3$var$toCmcdQuery(cmcd, options = {}) {
    if (!cmcd) return '';
    const params = $99a156a15cd35eb3$var$encodeCmcd(cmcd, options);
    return `${$99a156a15cd35eb3$var$CMCD_PARAM}=${encodeURIComponent(params)}`;
}
const $99a156a15cd35eb3$var$REGEX = /CMCD=[^&#]+/;
/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 */ function $99a156a15cd35eb3$var$appendCmcdQuery(url, cmcd, options) {
    // TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
    // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
    const query = $99a156a15cd35eb3$var$toCmcdQuery(cmcd, options);
    if (!query) return url;
    if ($99a156a15cd35eb3$var$REGEX.test(url)) return url.replace($99a156a15cd35eb3$var$REGEX, query);
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${query}`;
}
/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */ class $99a156a15cd35eb3$export$953f29a3a19a03d {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = void 0;
        this.sid = void 0;
        this.cid = void 0;
        this.useHeaders = false;
        this.includeKeys = void 0;
        this.initialized = false;
        this.starved = false;
        this.buffering = true;
        this.audioBuffer = void 0;
        this.videoBuffer = void 0;
        this.onWaiting = ()=>{
            if (this.initialized) this.starved = true;
            this.buffering = true;
        };
        this.onPlaying = ()=>{
            if (!this.initialized) this.initialized = true;
            this.buffering = false;
        };
        /**
     * Apply CMCD data to a manifest request.
     */ this.applyPlaylistData = (context)=>{
            try {
                this.apply(context, {
                    ot: $99a156a15cd35eb3$var$CmcdObjectType.MANIFEST,
                    su: !this.initialized
                });
            } catch (error) {
                this.hls.logger.warn('Could not generate manifest CMCD data.', error);
            }
        };
        /**
     * Apply CMCD data to a segment request
     */ this.applyFragmentData = (context)=>{
            try {
                const { frag: frag, part: part } = context;
                const level = this.hls.levels[frag.level];
                const ot = this.getObjectType(frag);
                const data = {
                    d: (part || frag).duration * 1000,
                    ot: ot
                };
                if (ot === $99a156a15cd35eb3$var$CmcdObjectType.VIDEO || ot === $99a156a15cd35eb3$var$CmcdObjectType.AUDIO || ot == $99a156a15cd35eb3$var$CmcdObjectType.MUXED) {
                    data.br = level.bitrate / 1000;
                    data.tb = this.getTopBandwidth(ot) / 1000;
                    data.bl = this.getBufferLength(ot);
                }
                const next = part ? this.getNextPart(part) : this.getNextFrag(frag);
                if (next != null && next.url && next.url !== frag.url) data.nor = next.url;
                this.apply(context, data);
            } catch (error) {
                this.hls.logger.warn('Could not generate segment CMCD data.', error);
            }
        };
        this.hls = hls;
        const config = this.config = hls.config;
        const { cmcd: cmcd } = config;
        if (cmcd != null) {
            config.pLoader = this.createPlaylistLoader();
            config.fLoader = this.createFragmentLoader();
            this.sid = cmcd.sessionId || hls.sessionId;
            this.cid = cmcd.contentId;
            this.useHeaders = cmcd.useHeaders === true;
            this.includeKeys = cmcd.includeKeys;
            this.registerListeners();
        }
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetached();
        // @ts-ignore
        this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
        // @ts-ignore
        this.onWaiting = this.onPlaying = this.media = null;
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener('waiting', this.onWaiting);
        this.media.addEventListener('playing', this.onPlaying);
    }
    onMediaDetached() {
        if (!this.media) return;
        this.media.removeEventListener('waiting', this.onWaiting);
        this.media.removeEventListener('playing', this.onPlaying);
        // @ts-ignore
        this.media = null;
    }
    onBufferCreated(event, data) {
        var _data$tracks$audio, _data$tracks$video;
        this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
        this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
    }
    /**
   * Create baseline CMCD data
   */ createData() {
        var _this$media;
        return {
            v: 1,
            sf: $99a156a15cd35eb3$var$CmcdStreamingFormat.HLS,
            sid: this.sid,
            cid: this.cid,
            pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
            mtp: this.hls.bandwidthEstimate / 1000
        };
    }
    /**
   * Apply CMCD data to a request.
   */ apply(context, data = {}) {
        // apply baseline data
        $99a156a15cd35eb3$var$_extends(data, this.createData());
        const isVideo = data.ot === $99a156a15cd35eb3$var$CmcdObjectType.INIT || data.ot === $99a156a15cd35eb3$var$CmcdObjectType.VIDEO || data.ot === $99a156a15cd35eb3$var$CmcdObjectType.MUXED;
        if (this.starved && isVideo) {
            data.bs = true;
            data.su = true;
            this.starved = false;
        }
        if (data.su == null) data.su = this.buffering;
        // TODO: Implement rtp, nrr, dl
        const { includeKeys: includeKeys } = this;
        if (includeKeys) data = Object.keys(data).reduce((acc, key)=>{
            includeKeys.includes(key) && (acc[key] = data[key]);
            return acc;
        }, {});
        const options = {
            baseUrl: context.url
        };
        if (this.useHeaders) {
            if (!context.headers) context.headers = {};
            $99a156a15cd35eb3$var$appendCmcdHeaders(context.headers, data, options);
        } else context.url = $99a156a15cd35eb3$var$appendCmcdQuery(context.url, data, options);
    }
    getNextFrag(fragment) {
        var _this$hls$levels$frag;
        const levelDetails = (_this$hls$levels$frag = this.hls.levels[fragment.level]) == null ? void 0 : _this$hls$levels$frag.details;
        if (levelDetails) {
            const index = fragment.sn - levelDetails.startSN;
            return levelDetails.fragments[index + 1];
        }
        return undefined;
    }
    getNextPart(part) {
        var _this$hls$levels$frag2, _this$hls$levels$frag3;
        const { index: index, fragment: fragment } = part;
        const partList = (_this$hls$levels$frag2 = this.hls.levels[fragment.level]) == null ? void 0 : (_this$hls$levels$frag3 = _this$hls$levels$frag2.details) == null ? void 0 : _this$hls$levels$frag3.partList;
        if (partList) {
            const { sn: sn } = fragment;
            for(let i = partList.length - 1; i >= 0; i--){
                const p = partList[i];
                if (p.index === index && p.fragment.sn === sn) return partList[i + 1];
            }
        }
        return undefined;
    }
    /**
   * The CMCD object type.
   */ getObjectType(fragment) {
        const { type: type } = fragment;
        if (type === 'subtitle') return $99a156a15cd35eb3$var$CmcdObjectType.TIMED_TEXT;
        if (fragment.sn === 'initSegment') return $99a156a15cd35eb3$var$CmcdObjectType.INIT;
        if (type === 'audio') return $99a156a15cd35eb3$var$CmcdObjectType.AUDIO;
        if (type === 'main') {
            if (!this.hls.audioTracks.length) return $99a156a15cd35eb3$var$CmcdObjectType.MUXED;
            return $99a156a15cd35eb3$var$CmcdObjectType.VIDEO;
        }
        return undefined;
    }
    /**
   * Get the highest bitrate.
   */ getTopBandwidth(type) {
        let bitrate = 0;
        let levels;
        const hls = this.hls;
        if (type === $99a156a15cd35eb3$var$CmcdObjectType.AUDIO) levels = hls.audioTracks;
        else {
            const max = hls.maxAutoLevel;
            const len = max > -1 ? max + 1 : hls.levels.length;
            levels = hls.levels.slice(0, len);
        }
        levels.forEach((level)=>{
            if (level.bitrate > bitrate) bitrate = level.bitrate;
        });
        return bitrate > 0 ? bitrate : NaN;
    }
    /**
   * Get the buffer length for a media type in milliseconds
   */ getBufferLength(type) {
        const media = this.media;
        const buffer = type === $99a156a15cd35eb3$var$CmcdObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
        if (!buffer || !media) return NaN;
        const info = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
        return info.len * 1000;
    }
    /**
   * Create a playlist loader
   */ createPlaylistLoader() {
        const { pLoader: pLoader } = this.config;
        const apply = this.applyPlaylistData;
        const Ctor = pLoader || this.config.loader;
        return class CmcdPlaylistLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
    /**
   * Create a playlist loader
   */ createFragmentLoader() {
        const { fLoader: fLoader } = this.config;
        const apply = this.applyFragmentData;
        const Ctor = fLoader || this.config.loader;
        return class CmcdFragmentLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
}
const $99a156a15cd35eb3$var$PATHWAY_PENALTY_DURATION_MS = 300000;
class $99a156a15cd35eb3$export$52a61818002372cb extends $99a156a15cd35eb3$var$Logger {
    constructor(hls){
        super('content-steering', hls.logger);
        this.hls = void 0;
        this.loader = null;
        this.uri = null;
        this.pathwayId = '.';
        this._pathwayPriority = null;
        this.timeToLoad = 300;
        this.reloadTimer = -1;
        this.updated = 0;
        this.started = false;
        this.enabled = true;
        this.levels = null;
        this.audioTracks = null;
        this.subtitleTracks = null;
        this.penalizedPathways = {};
        this.hls = hls;
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    pathways() {
        return (this.levels || []).reduce((pathways, level)=>{
            if (pathways.indexOf(level.pathwayId) === -1) pathways.push(level.pathwayId);
            return pathways;
        }, []);
    }
    get pathwayPriority() {
        return this._pathwayPriority;
    }
    set pathwayPriority(pathwayPriority) {
        this.updatePathwayPriority(pathwayPriority);
    }
    startLoad() {
        this.started = true;
        this.clearTimeout();
        if (this.enabled && this.uri) {
            if (this.updated) {
                const ttl = this.timeToLoad * 1000 - (performance.now() - this.updated);
                if (ttl > 0) {
                    this.scheduleRefresh(this.uri, ttl);
                    return;
                }
            }
            this.loadSteeringManifest(this.uri);
        }
    }
    stopLoad() {
        this.started = false;
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
        this.clearTimeout();
    }
    clearTimeout() {
        if (this.reloadTimer !== -1) {
            self.clearTimeout(this.reloadTimer);
            this.reloadTimer = -1;
        }
    }
    destroy() {
        this.unregisterListeners();
        this.stopLoad();
        // @ts-ignore
        this.hls = null;
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    removeLevel(levelToRemove) {
        const levels = this.levels;
        if (levels) this.levels = levels.filter((level)=>level !== levelToRemove);
    }
    onManifestLoading() {
        this.stopLoad();
        this.enabled = true;
        this.timeToLoad = 300;
        this.updated = 0;
        this.uri = null;
        this.pathwayId = '.';
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    onManifestLoaded(event, data) {
        const { contentSteering: contentSteering } = data;
        if (contentSteering === null) return;
        this.pathwayId = contentSteering.pathwayId;
        this.uri = contentSteering.uri;
        if (this.started) this.startLoad();
    }
    onManifestParsed(event, data) {
        this.audioTracks = data.audioTracks;
        this.subtitleTracks = data.subtitleTracks;
    }
    onError(event, data) {
        const { errorAction: errorAction } = data;
        if ((errorAction == null ? void 0 : errorAction.action) === $99a156a15cd35eb3$export$679390c50dd617e4.SendAlternateToPenaltyBox && errorAction.flags === $99a156a15cd35eb3$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost) {
            const levels = this.levels;
            let pathwayPriority = this._pathwayPriority;
            let errorPathway = this.pathwayId;
            if (data.context) {
                const { groupId: groupId, pathwayId: pathwayId, type: type } = data.context;
                if (groupId && levels) errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
                else if (pathwayId) errorPathway = pathwayId;
            }
            if (!(errorPathway in this.penalizedPathways)) this.penalizedPathways[errorPathway] = performance.now();
            if (!pathwayPriority && levels) // If PATHWAY-PRIORITY was not provided, list pathways for error handling
            pathwayPriority = this.pathways();
            if (pathwayPriority && pathwayPriority.length > 1) {
                this.updatePathwayPriority(pathwayPriority);
                errorAction.resolved = this.pathwayId !== errorPathway;
            }
            if (!errorAction.resolved) this.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${$99a156a15cd35eb3$var$stringify(pathwayPriority)} penalized: ${$99a156a15cd35eb3$var$stringify(this.penalizedPathways)}`);
        }
    }
    filterParsedLevels(levels) {
        // Filter levels to only include those that are in the initial pathway
        this.levels = levels;
        let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
        if (pathwayLevels.length === 0) {
            const pathwayId = levels[0].pathwayId;
            this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
            pathwayLevels = this.getLevelsForPathway(pathwayId);
            this.pathwayId = pathwayId;
        }
        if (pathwayLevels.length !== levels.length) this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
        return pathwayLevels;
    }
    getLevelsForPathway(pathwayId) {
        if (this.levels === null) return [];
        return this.levels.filter((level)=>pathwayId === level.pathwayId);
    }
    updatePathwayPriority(pathwayPriority) {
        this._pathwayPriority = pathwayPriority;
        let levels;
        // Evaluate if we should remove the pathway from the penalized list
        const penalizedPathways = this.penalizedPathways;
        const now = performance.now();
        Object.keys(penalizedPathways).forEach((pathwayId)=>{
            if (now - penalizedPathways[pathwayId] > $99a156a15cd35eb3$var$PATHWAY_PENALTY_DURATION_MS) delete penalizedPathways[pathwayId];
        });
        for(let i = 0; i < pathwayPriority.length; i++){
            const pathwayId = pathwayPriority[i];
            if (pathwayId in penalizedPathways) continue;
            if (pathwayId === this.pathwayId) return;
            const selectedIndex = this.hls.nextLoadLevel;
            const selectedLevel = this.hls.levels[selectedIndex];
            levels = this.getLevelsForPathway(pathwayId);
            if (levels.length > 0) {
                this.log(`Setting Pathway to "${pathwayId}"`);
                this.pathwayId = pathwayId;
                $99a156a15cd35eb3$var$reassignFragmentLevelIndexes(levels);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, {
                    levels: levels
                });
                // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
                const levelAfterChange = this.hls.levels[selectedIndex];
                if (selectedLevel && levelAfterChange && this.levels) {
                    if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
                    this.hls.nextLoadLevel = selectedIndex;
                }
                break;
            }
        }
    }
    getPathwayForGroupId(groupId, type, defaultPathway) {
        const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
        for(let i = 0; i < levels.length; i++){
            if (type === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) return levels[i].pathwayId;
        }
        return defaultPathway;
    }
    clonePathways(pathwayClones) {
        const levels = this.levels;
        if (!levels) return;
        const audioGroupCloneMap = {};
        const subtitleGroupCloneMap = {};
        pathwayClones.forEach((pathwayClone)=>{
            const { ID: cloneId, 'BASE-ID': baseId, 'URI-REPLACEMENT': uriReplacement } = pathwayClone;
            if (levels.some((level)=>level.pathwayId === cloneId)) return;
            const clonedVariants = this.getLevelsForPathway(baseId).map((baseLevel)=>{
                const attributes = new $99a156a15cd35eb3$export$3b2a5864ee72b619(baseLevel.attrs);
                attributes['PATHWAY-ID'] = cloneId;
                const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
                const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
                if (clonedAudioGroupId) {
                    audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
                    attributes.AUDIO = clonedAudioGroupId;
                }
                if (clonedSubtitleGroupId) {
                    subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
                    attributes.SUBTITLES = clonedSubtitleGroupId;
                }
                const url = $99a156a15cd35eb3$var$performUriReplacement(baseLevel.uri, attributes['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
                const clonedLevel = new $99a156a15cd35eb3$export$ca664994d1d54bff({
                    attrs: attributes,
                    audioCodec: baseLevel.audioCodec,
                    bitrate: baseLevel.bitrate,
                    height: baseLevel.height,
                    name: baseLevel.name,
                    url: url,
                    videoCodec: baseLevel.videoCodec,
                    width: baseLevel.width
                });
                if (baseLevel.audioGroups) for(let i = 1; i < baseLevel.audioGroups.length; i++)clonedLevel.addGroupId('audio', `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
                if (baseLevel.subtitleGroups) for(let i = 1; i < baseLevel.subtitleGroups.length; i++)clonedLevel.addGroupId('text', `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
                return clonedLevel;
            });
            levels.push(...clonedVariants);
            $99a156a15cd35eb3$var$cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
            $99a156a15cd35eb3$var$cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
        });
    }
    loadSteeringManifest(uri) {
        const config = this.hls.config;
        const Loader = config.loader;
        if (this.loader) this.loader.destroy();
        this.loader = new Loader(config);
        let url;
        try {
            url = new self.URL(uri);
        } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest URI: ${uri}`);
            return;
        }
        if (url.protocol !== 'data:') {
            const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
            url.searchParams.set('_HLS_pathway', this.pathwayId);
            url.searchParams.set('_HLS_throughput', '' + throughput);
        }
        const context = {
            responseType: 'json',
            url: url.href
        };
        const loadPolicy = config.steeringManifestLoadPolicy.default;
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const callbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                this.log(`Loaded steering manifest: "${url}"`);
                const steeringData = response.data;
                if ((steeringData == null ? void 0 : steeringData.VERSION) !== 1) {
                    this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
                    return;
                }
                this.updated = performance.now();
                this.timeToLoad = steeringData.TTL;
                const { 'RELOAD-URI': reloadUri, 'PATHWAY-CLONES': pathwayClones, 'PATHWAY-PRIORITY': pathwayPriority } = steeringData;
                if (reloadUri) try {
                    this.uri = new self.URL(reloadUri, url).href;
                } catch (error) {
                    this.enabled = false;
                    this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url);
                if (pathwayClones) this.clonePathways(pathwayClones);
                const loadedSteeringData = {
                    steeringManifest: steeringData,
                    url: url.toString()
                };
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.STEERING_MANIFEST_LOADED, loadedSteeringData);
                if (pathwayPriority) this.updatePathwayPriority(pathwayPriority);
            },
            onError: (error, context, networkDetails, stats)=>{
                this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
                this.stopLoad();
                if (error.code === 410) {
                    this.enabled = false;
                    this.log(`Steering manifest ${context.url} no longer available`);
                    return;
                }
                let ttl = this.timeToLoad * 1000;
                if (error.code === 429) {
                    const loader = this.loader;
                    if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
                        const retryAfter = loader.getResponseHeader('Retry-After');
                        if (retryAfter) ttl = parseFloat(retryAfter) * 1000;
                    }
                    this.log(`Steering manifest ${context.url} rate limited`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url, ttl);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.log(`Timeout loading steering manifest (${context.url})`);
                this.scheduleRefresh(this.uri || context.url);
            }
        };
        this.log(`Requesting steering manifest: ${url}`);
        this.loader.load(context, loaderConfig, callbacks);
    }
    scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
        this.clearTimeout();
        this.reloadTimer = self.setTimeout(()=>{
            var _this$hls;
            const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
            if (media && !media.ended) {
                this.loadSteeringManifest(uri);
                return;
            }
            this.scheduleRefresh(uri, this.timeToLoad * 1000);
        }, ttlMs);
    }
}
function $99a156a15cd35eb3$var$cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
    if (!tracks) return;
    Object.keys(groupCloneMap).forEach((audioGroupId)=>{
        const clonedTracks = tracks.filter((track)=>track.groupId === audioGroupId).map((track)=>{
            const clonedTrack = $99a156a15cd35eb3$var$_extends({}, track);
            clonedTrack.details = undefined;
            clonedTrack.attrs = new $99a156a15cd35eb3$export$3b2a5864ee72b619(clonedTrack.attrs);
            clonedTrack.url = clonedTrack.attrs.URI = $99a156a15cd35eb3$var$performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
            clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
            clonedTrack.attrs['PATHWAY-ID'] = cloneId;
            return clonedTrack;
        });
        tracks.push(...clonedTracks);
    });
}
function $99a156a15cd35eb3$var$performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
    const { HOST: host, PARAMS: params, [perOptionKey]: perOptionUris } = uriReplacement;
    let perVariantUri;
    if (stableId) {
        perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
        if (perVariantUri) uri = perVariantUri;
    }
    const url = new self.URL(uri);
    if (host && !perVariantUri) url.host = host;
    if (params) Object.keys(params).sort().forEach((key)=>{
        if (key) url.searchParams.set(key, params[key]);
    });
    return url.href;
}
function $99a156a15cd35eb3$var$addEventListener(el, type, listener) {
    $99a156a15cd35eb3$var$removeEventListener(el, type, listener);
    el.addEventListener(type, listener);
}
function $99a156a15cd35eb3$var$removeEventListener(el, type, listener) {
    el.removeEventListener(type, listener);
}
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */ class $99a156a15cd35eb3$export$bd16919f25cf2fc5 extends $99a156a15cd35eb3$var$Logger {
    constructor(hls){
        super('eme', hls.logger);
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.keyFormatPromise = null;
        this.keySystemAccessPromises = {};
        this._requestLicenseFailureCount = 0;
        this.mediaKeySessions = [];
        this.keyIdToKeySessionPromise = {};
        this.mediaKeys = null;
        this.setMediaKeysQueue = $99a156a15cd35eb3$export$bd16919f25cf2fc5.CDMCleanupPromise ? [
            $99a156a15cd35eb3$export$bd16919f25cf2fc5.CDMCleanupPromise
        ] : [];
        this.onMediaEncrypted = (event)=>{
            const { initDataType: initDataType, initData: initData } = event;
            const logMessage = `"${event.type}" event: init data type: "${initDataType}"`;
            this.debug(logMessage);
            // Ignore event when initData is null
            if (initData === null) return;
            if (!this.keyFormatPromise) {
                let keySystems = Object.keys(this.keySystemAccessPromises);
                if (!keySystems.length) keySystems = $99a156a15cd35eb3$var$getKeySystemsForConfig(this.config);
                const keyFormats = keySystems.map($99a156a15cd35eb3$var$keySystemDomainToKeySystemFormat).filter((k)=>!!k);
                this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
            }
            this.keyFormatPromise.then((keySystemFormat)=>{
                const keySystem = $99a156a15cd35eb3$var$keySystemFormatToKeySystemDomain(keySystemFormat);
                let keyId;
                let keySystemDomain;
                if (initDataType === 'sinf') {
                    if (keySystem !== $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY) {
                        this.warn(`Ignoring unexpected "${event.type}" event with init data type: "${initDataType}" for selected key-system ${keySystem}`);
                        return;
                    }
                    // Match sinf keyId to playlist skd://keyId=
                    const json = $99a156a15cd35eb3$var$bin2str(new Uint8Array(initData));
                    try {
                        const sinf = $99a156a15cd35eb3$var$base64Decode(JSON.parse(json).sinf);
                        const tenc = $99a156a15cd35eb3$var$parseSinf(sinf);
                        if (!tenc) throw new Error(`'schm' box missing or not cbcs/cenc with schi > tenc`);
                        keyId = new Uint8Array(tenc.subarray(8, 24));
                        keySystemDomain = $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY;
                    } catch (error) {
                        this.warn(`${logMessage} Failed to parse sinf: ${error}`);
                        return;
                    }
                } else {
                    if (keySystem !== $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE && keySystem !== $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY) {
                        this.warn(`Ignoring unexpected "${event.type}" event with init data type: "${initDataType}" for selected key-system ${keySystem}`);
                        return;
                    }
                    // Support Widevine/PlayReady clear-lead key-session creation (otherwise depend on playlist keys)
                    const psshResults = $99a156a15cd35eb3$var$parseMultiPssh(initData);
                    const psshInfos = psshResults.filter((pssh)=>!!pssh.systemId && $99a156a15cd35eb3$var$keySystemIdToKeySystemDomain(pssh.systemId) === keySystem);
                    if (psshInfos.length > 1) this.warn(`${logMessage} Using first of ${psshInfos.length} pssh found for selected key-system ${keySystem}`);
                    const psshInfo = psshInfos[0];
                    if (!psshInfo) {
                        if (psshResults.length === 0 || psshResults.some((pssh)=>!pssh.systemId)) this.warn(`${logMessage} contains incomplete or invalid pssh data`);
                        else this.log(`ignoring ${logMessage} for ${psshResults.map((pssh)=>$99a156a15cd35eb3$var$keySystemIdToKeySystemDomain(pssh.systemId)).join(',')} pssh data in favor of playlist keys`);
                        return;
                    }
                    keySystemDomain = $99a156a15cd35eb3$var$keySystemIdToKeySystemDomain(psshInfo.systemId);
                    if (psshInfo.version === 0 && psshInfo.data) {
                        if (keySystemDomain === $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE) {
                            const offset = psshInfo.data.length - 22;
                            keyId = new Uint8Array(psshInfo.data.subarray(offset, offset + 16));
                        } else if (keySystemDomain === $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY) keyId = $99a156a15cd35eb3$var$parsePlayReadyWRM(psshInfo.data);
                    }
                }
                if (!keySystemDomain || !keyId) return;
                const keyIdHex = $99a156a15cd35eb3$var$Hex.hexDump(keyId);
                const { keyIdToKeySessionPromise: keyIdToKeySessionPromise, mediaKeySessions: mediaKeySessions } = this;
                let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
                for(let i = 0; i < mediaKeySessions.length; i++){
                    // Match playlist key
                    const keyContext = mediaKeySessions[i];
                    const decryptdata = keyContext.decryptdata;
                    if (!decryptdata.keyId) continue;
                    const oldKeyIdHex = $99a156a15cd35eb3$var$Hex.hexDump(decryptdata.keyId);
                    if (keyIdHex === oldKeyIdHex || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
                        keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
                        if (decryptdata.pssh) break;
                        delete keyIdToKeySessionPromise[oldKeyIdHex];
                        decryptdata.pssh = new Uint8Array(initData);
                        decryptdata.keyId = keyId;
                        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(()=>{
                            return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
                        });
                        keySessionContextPromise.catch((error)=>this.handleError(error));
                        break;
                    }
                }
                if (!keySessionContextPromise) {
                    if (keySystemDomain !== keySystem) {
                        this.log(`Ignoring "${event.type}" event with ${keySystemDomain} init data for selected key-system ${keySystem}`);
                        return;
                    }
                    // "Clear-lead" (misc key not encountered in playlist)
                    keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = this.getKeySystemSelectionPromise([
                        keySystemDomain
                    ]).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
                        var _keySystemToKeySystem;
                        this.throwIfDestroyed();
                        const decryptdata = new $99a156a15cd35eb3$export$ca24892a09b21f29('ISO-23001-7', keyIdHex, (_keySystemToKeySystem = $99a156a15cd35eb3$var$keySystemDomainToKeySystemFormat(keySystem)) != null ? _keySystemToKeySystem : '');
                        decryptdata.pssh = new Uint8Array(initData);
                        decryptdata.keyId = keyId;
                        return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                            this.throwIfDestroyed();
                            const keySessionContext = this.createMediaKeySessionContext({
                                decryptdata: decryptdata,
                                keySystem: keySystem,
                                mediaKeys: mediaKeys
                            });
                            return this.generateRequestWithPreferredKeySession(keySessionContext, initDataType, initData, 'encrypted-event-no-match');
                        });
                    });
                    keySessionContextPromise.catch((error)=>this.handleError(error));
                }
            });
        };
        this.onWaitingForKey = (event)=>{
            this.log(`"${event.type}" event`);
        };
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    destroy() {
        this.onDestroying();
        this.onMediaDetached();
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.requestMediaKeySystemAccessFunc = null;
        config.licenseXhrSetup = config.licenseResponseCallback = undefined;
        config.drmSystems = config.drmSystemOptions = {};
        // @ts-ignore
        this.hls = this.config = this.keyIdToKeySessionPromise = null;
        // @ts-ignore
        this.onMediaEncrypted = this.onWaitingForKey = null;
    }
    registerListeners() {
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
    }
    unregisterListeners() {
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
    }
    getLicenseServerUrl(keySystem) {
        const { drmSystems: drmSystems, widevineLicenseUrl: widevineLicenseUrl } = this.config;
        const keySystemConfiguration = drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.licenseUrl;
        // For backward compatibility
        if (keySystem === $99a156a15cd35eb3$export$1c7b21e05766136c.WIDEVINE && widevineLicenseUrl) return widevineLicenseUrl;
    }
    getLicenseServerUrlOrThrow(keySystem) {
        const url = this.getLicenseServerUrl(keySystem);
        if (url === undefined) throw new Error(`no license server URL configured for key-system "${keySystem}"`);
        return url;
    }
    getServerCertificateUrl(keySystem) {
        const { drmSystems: drmSystems } = this.config;
        const keySystemConfiguration = drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.serverCertificateUrl;
        else this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
    attemptKeySystemAccess(keySystemsToAttempt) {
        const levels = this.hls.levels;
        const uniqueCodec = (value, i, a)=>!!value && a.indexOf(value) === i;
        const audioCodecs = levels.map((level)=>level.audioCodec).filter(uniqueCodec);
        const videoCodecs = levels.map((level)=>level.videoCodec).filter(uniqueCodec);
        if (audioCodecs.length + videoCodecs.length === 0) videoCodecs.push('avc1.42e01e');
        return new Promise((resolve, reject)=>{
            const attempt = (keySystems)=>{
                const keySystem = keySystems.shift();
                this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then((mediaKeys)=>resolve({
                        keySystem: keySystem,
                        mediaKeys: mediaKeys
                    })).catch((error)=>{
                    if (keySystems.length) attempt(keySystems);
                    else if (error instanceof $99a156a15cd35eb3$var$EMEKeyError) reject(error);
                    else reject(new $99a156a15cd35eb3$var$EMEKeyError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_NO_ACCESS,
                        error: error,
                        fatal: true
                    }, error.message));
                });
            };
            attempt(keySystemsToAttempt);
        });
    }
    requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
        const { requestMediaKeySystemAccessFunc: requestMediaKeySystemAccessFunc } = this.config;
        if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
            let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
            if ($99a156a15cd35eb3$export$fd6ce47fe824665a === null && self.location.protocol === 'http:') errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
            return Promise.reject(new Error(errMessage));
        }
        return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
    }
    getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
        // This can throw, but is caught in event handler callpath
        const mediaKeySystemConfigs = $99a156a15cd35eb3$var$getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions);
        const keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
        let keySystemAccess = keySystemAccessPromises == null ? void 0 : keySystemAccessPromises.keySystemAccess;
        if (!keySystemAccess) {
            this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${$99a156a15cd35eb3$var$stringify(mediaKeySystemConfigs)}`);
            keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
            const _keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
                keySystemAccess: keySystemAccess
            };
            keySystemAccess.catch((error)=>{
                this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
            });
            return keySystemAccess.then((mediaKeySystemAccess)=>{
                this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
                const certificateRequest = this.fetchServerCertificate(keySystem);
                this.log(`Create media-keys for "${keySystem}"`);
                _keySystemAccessPromises.mediaKeys = mediaKeySystemAccess.createMediaKeys().then((mediaKeys)=>{
                    this.log(`Media-keys created for "${keySystem}"`);
                    _keySystemAccessPromises.hasMediaKeys = true;
                    return certificateRequest.then((certificate)=>{
                        if (certificate) return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
                        return mediaKeys;
                    });
                });
                _keySystemAccessPromises.mediaKeys.catch((error)=>{
                    this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
                });
                return _keySystemAccessPromises.mediaKeys;
            });
        }
        return keySystemAccess.then(()=>keySystemAccessPromises.mediaKeys);
    }
    createMediaKeySessionContext({ decryptdata: decryptdata, keySystem: keySystem, mediaKeys: mediaKeys }) {
        this.log(`Creating key-system session "${keySystem}" keyId: ${$99a156a15cd35eb3$var$Hex.hexDump(decryptdata.keyId || [])}`);
        const mediaKeysSession = mediaKeys.createSession();
        const mediaKeySessionContext = {
            decryptdata: decryptdata,
            keySystem: keySystem,
            mediaKeys: mediaKeys,
            mediaKeysSession: mediaKeysSession,
            keyStatus: 'status-pending'
        };
        this.mediaKeySessions.push(mediaKeySessionContext);
        return mediaKeySessionContext;
    }
    renewKeySession(mediaKeySessionContext) {
        const decryptdata = mediaKeySessionContext.decryptdata;
        if (decryptdata.pssh) {
            const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
            const keyId = this.getKeyIdString(decryptdata);
            const scheme = 'cenc';
            this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh.buffer, 'expired');
        } else this.warn(`Could not renew expired session. Missing pssh initData.`);
        this.removeSession(mediaKeySessionContext);
    }
    getKeyIdString(decryptdata) {
        if (!decryptdata) throw new Error('Could not read keyId of undefined decryptdata');
        if (decryptdata.keyId === null) throw new Error('keyId is null');
        return $99a156a15cd35eb3$var$Hex.hexDump(decryptdata.keyId);
    }
    updateKeySession(mediaKeySessionContext, data) {
        var _mediaKeySessionConte;
        const keySession = mediaKeySessionContext.mediaKeysSession;
        this.log(`Updating key-session "${keySession.sessionId}" for keyID ${$99a156a15cd35eb3$var$Hex.hexDump(((_mediaKeySessionConte = mediaKeySessionContext.decryptdata) == null ? void 0 : _mediaKeySessionConte.keyId) || [])}
      } (data length: ${data ? data.byteLength : data})`);
        return keySession.update(data);
    }
    getSelectedKeySystemFormats() {
        return Object.keys(this.keySystemAccessPromises).map((keySystem)=>({
                keySystem: keySystem,
                hasMediaKeys: this.keySystemAccessPromises[keySystem].hasMediaKeys
            })).filter(({ hasMediaKeys: hasMediaKeys })=>!!hasMediaKeys).map(({ keySystem: keySystem })=>$99a156a15cd35eb3$var$keySystemDomainToKeySystemFormat(keySystem)).filter((keySystem)=>!!keySystem);
    }
    getKeySystemAccess(keySystemsToAttempt) {
        return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
            return this.attemptSetMediaKeys(keySystem, mediaKeys);
        });
    }
    selectKeySystem(keySystemsToAttempt) {
        return new Promise((resolve, reject)=>{
            return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem: keySystem })=>{
                const keySystemFormat = $99a156a15cd35eb3$var$keySystemDomainToKeySystemFormat(keySystem);
                if (keySystemFormat) resolve(keySystemFormat);
                else reject(new Error(`Unable to find format for key-system "${keySystem}"`));
            }).catch(reject);
        });
    }
    selectKeySystemFormat(frag) {
        const keyFormats = Object.keys(frag.levelkeys || {});
        if (!this.keyFormatPromise) {
            this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
        return this.keyFormatPromise;
    }
    getKeyFormatPromise(keyFormats) {
        const keySystemsInConfig = $99a156a15cd35eb3$var$getKeySystemsForConfig(this.config);
        const keySystemsToAttempt = keyFormats.map($99a156a15cd35eb3$var$keySystemFormatToKeySystemDomain).filter((value)=>!!value && keySystemsInConfig.indexOf(value) !== -1);
        return this.selectKeySystem(keySystemsToAttempt);
    }
    loadKey(data) {
        const decryptdata = data.keyInfo.decryptdata;
        const keyId = this.getKeyIdString(decryptdata);
        const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
        this.log(`Starting session for key ${keyDetails}`);
        let keyContextPromise = this.keyIdToKeySessionPromise[keyId];
        if (!keyContextPromise) {
            keyContextPromise = this.getKeySystemForKeyPromise(decryptdata).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
                this.throwIfDestroyed();
                this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
                return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                    this.throwIfDestroyed();
                    return this.createMediaKeySessionContext({
                        keySystem: keySystem,
                        mediaKeys: mediaKeys,
                        decryptdata: decryptdata
                    });
                });
            });
            const keySessionContextPromise = this.keyIdToKeySessionPromise[keyId] = keyContextPromise.then((keySessionContext)=>{
                const scheme = 'cenc';
                const initData = decryptdata.pssh ? decryptdata.pssh.buffer : null;
                return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, initData, 'playlist-key');
            });
            keySessionContextPromise.catch((error)=>this.handleError(error));
        }
        return keyContextPromise;
    }
    throwIfDestroyed(message = 'Invalid state') {
        if (!this.hls) throw new Error('invalid state');
    }
    handleError(error) {
        if (!this.hls) return;
        this.error(error.message);
        if (error instanceof $99a156a15cd35eb3$var$EMEKeyError) this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, error.data);
        else this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_NO_KEYS,
            error: error,
            fatal: true
        });
    }
    getKeySystemForKeyPromise(decryptdata) {
        const keyId = this.getKeyIdString(decryptdata);
        const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
        if (!mediaKeySessionContext) {
            const keySystem = $99a156a15cd35eb3$var$keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
            const keySystemsToAttempt = keySystem ? [
                keySystem
            ] : $99a156a15cd35eb3$var$getKeySystemsForConfig(this.config);
            return this.attemptKeySystemAccess(keySystemsToAttempt);
        }
        return mediaKeySessionContext;
    }
    getKeySystemSelectionPromise(keySystemsToAttempt) {
        if (!keySystemsToAttempt.length) keySystemsToAttempt = $99a156a15cd35eb3$var$getKeySystemsForConfig(this.config);
        if (keySystemsToAttempt.length === 0) throw new $99a156a15cd35eb3$var$EMEKeyError({
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
            fatal: true
        }, `Missing key-system license configuration options ${$99a156a15cd35eb3$var$stringify({
            drmSystems: this.config.drmSystems
        })}`);
        return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    attemptSetMediaKeys(keySystem, mediaKeys) {
        if (this.mediaKeys === mediaKeys) return Promise.resolve();
        const queue = this.setMediaKeysQueue.slice();
        this.log(`Setting media-keys for "${keySystem}"`);
        // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
        // can be queued for execution for multiple key sessions.
        const setMediaKeysPromise = Promise.all(queue).then(()=>{
            if (!this.media) {
                this.mediaKeys = null;
                throw new Error('Attempted to set mediaKeys without media element attached');
            }
            return this.media.setMediaKeys(mediaKeys);
        });
        this.mediaKeys = mediaKeys;
        this.setMediaKeysQueue.push(setMediaKeysPromise);
        return setMediaKeysPromise.then(()=>{
            this.log(`Media-keys set for "${keySystem}"`);
            queue.push(setMediaKeysPromise);
            this.setMediaKeysQueue = this.setMediaKeysQueue.filter((p)=>queue.indexOf(p) === -1);
        });
    }
    generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
        var _this$config$drmSyste, _this$config$drmSyste2;
        const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null ? void 0 : (_this$config$drmSyste2 = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste2.generateRequest;
        if (generateRequestFilter) try {
            const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
            if (!mappedInitData) throw new Error('Invalid response from configured generateRequest filter');
            initDataType = mappedInitData.initDataType;
            initData = mappedInitData.initData ? mappedInitData.initData : null;
            context.decryptdata.pssh = initData ? new Uint8Array(initData) : null;
        } catch (error) {
            var _this$hls;
            this.warn(error.message);
            if ((_this$hls = this.hls) != null && _this$hls.config.debug) throw error;
        }
        if (initData === null) {
            this.log(`Skipping key-session request for "${reason}" (no initData)`);
            return Promise.resolve(context);
        }
        const keyId = this.getKeyIdString(context.decryptdata);
        this.log(`Generating key-session request for "${reason}": ${keyId} (init data type: ${initDataType} length: ${initData ? initData.byteLength : null})`);
        const licenseStatus = new $99a156a15cd35eb3$var$EventEmitter();
        const onmessage = context._onmessage = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit('error', new Error('invalid state'));
                return;
            }
            const { messageType: messageType, message: message } = event;
            this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
            if (messageType === 'license-request' || messageType === 'license-renewal') this.renewLicense(context, message).catch((error)=>{
                if (licenseStatus.eventNames().length) licenseStatus.emit('error', error);
                else this.handleError(error);
            });
            else if (messageType === 'license-release') {
                if (context.keySystem === $99a156a15cd35eb3$export$1c7b21e05766136c.FAIRPLAY) {
                    this.updateKeySession(context, $99a156a15cd35eb3$var$strToUtf8array('acknowledged'));
                    this.removeSession(context);
                }
            } else this.warn(`unhandled media key message type "${messageType}"`);
        };
        const onkeystatuseschange = context._onkeystatuseschange = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit('error', new Error('invalid state'));
                return;
            }
            this.onKeyStatusChange(context);
            const keyStatus = context.keyStatus;
            licenseStatus.emit('keyStatus', keyStatus);
            if (keyStatus === 'expired') {
                this.warn(`${context.keySystem} expired for key ${keyId}`);
                this.renewKeySession(context);
            }
        };
        $99a156a15cd35eb3$var$addEventListener(context.mediaKeysSession, 'message', onmessage);
        $99a156a15cd35eb3$var$addEventListener(context.mediaKeysSession, 'keystatuseschange', onkeystatuseschange);
        const keyUsablePromise = new Promise((resolve, reject)=>{
            licenseStatus.on('error', reject);
            licenseStatus.on('keyStatus', (keyStatus)=>{
                if (keyStatus.startsWith('usable')) resolve();
                else if (keyStatus === 'output-restricted') reject(new $99a156a15cd35eb3$var$EMEKeyError({
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
                    fatal: false
                }, 'HDCP level output restricted'));
                else if (keyStatus === 'internal-error') reject(new $99a156a15cd35eb3$var$EMEKeyError({
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
                    fatal: true
                }, `key status changed to "${keyStatus}"`));
                else if (keyStatus === 'expired') reject(new Error('key expired while generating request'));
                else this.warn(`unhandled key status change "${keyStatus}"`);
            });
        });
        return context.mediaKeysSession.generateRequest(initDataType, initData).then(()=>{
            var _context$mediaKeysSes;
            this.log(`Request generated for key-session "${(_context$mediaKeysSes = context.mediaKeysSession) == null ? void 0 : _context$mediaKeysSes.sessionId}" keyId: ${keyId}`);
        }).catch((error)=>{
            throw new $99a156a15cd35eb3$var$EMEKeyError({
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_NO_SESSION,
                error: error,
                fatal: false
            }, `Error generating key-session request: ${error}`);
        }).then(()=>keyUsablePromise).catch((error)=>{
            licenseStatus.removeAllListeners();
            this.removeSession(context);
            throw error;
        }).then(()=>{
            licenseStatus.removeAllListeners();
            return context;
        });
    }
    onKeyStatusChange(mediaKeySessionContext) {
        mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status1, keyId)=>{
            // keyStatuses.forEach is not standard API so the callback value looks weird on xboxone
            // xboxone callback(keyId, status) so we need to exchange them
            if (typeof keyId === 'string' && typeof status1 === 'object') {
                const temp = keyId;
                keyId = status1;
                status1 = temp;
            }
            this.log(`key status change "${status1}" for keyStatuses keyId: ${$99a156a15cd35eb3$var$Hex.hexDump('buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId))} session keyId: ${$99a156a15cd35eb3$var$Hex.hexDump(new Uint8Array(mediaKeySessionContext.decryptdata.keyId || []))} uri: ${mediaKeySessionContext.decryptdata.uri}`);
            mediaKeySessionContext.keyStatus = status1;
        });
    }
    fetchServerCertificate(keySystem) {
        const config = this.config;
        const Loader = config.loader;
        const certLoader = new Loader(config);
        const url = this.getServerCertificateUrl(keySystem);
        if (!url) return Promise.resolve();
        this.log(`Fetching server certificate for "${keySystem}"`);
        return new Promise((resolve, reject)=>{
            const loaderContext = {
                responseType: 'arraybuffer',
                url: url
            };
            const loadPolicy = config.certLoadPolicy.default;
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    resolve(response.data);
                },
                onError: (response, contex, networkDetails, stats)=>{
                    reject(new $99a156a15cd35eb3$var$EMEKeyError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails: networkDetails,
                        response: $99a156a15cd35eb3$var$_objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response)
                    }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    reject(new $99a156a15cd35eb3$var$EMEKeyError({
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails: networkDetails,
                        response: {
                            url: loaderContext.url,
                            data: undefined
                        }
                    }, `"${keySystem}" certificate request timed out (${url})`));
                },
                onAbort: (stats, context, networkDetails)=>{
                    reject(new Error('aborted'));
                }
            };
            certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
        return new Promise((resolve, reject)=>{
            mediaKeys.setServerCertificate(cert).then((success)=>{
                this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert == null ? void 0 : cert.byteLength}) on "${keySystem}"`);
                resolve(mediaKeys);
            }).catch((error)=>{
                reject(new $99a156a15cd35eb3$var$EMEKeyError({
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
                    error: error,
                    fatal: true
                }, error.message));
            });
        });
    }
    renewLicense(context, keyMessage) {
        return this.requestLicense(context, new Uint8Array(keyMessage)).then((data)=>{
            return this.updateKeySession(context, new Uint8Array(data)).catch((error)=>{
                throw new $99a156a15cd35eb3$var$EMEKeyError({
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_SESSION_UPDATE_FAILED,
                    error: error,
                    fatal: true
                }, error.message);
            });
        });
    }
    unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
        // On Edge, the raw license message is UTF-16-encoded XML.  We need
        // to unpack the Challenge element (base64-encoded string containing the
        // actual license request) and any HttpHeader elements (sent as request
        // headers).
        // For PlayReady CDMs, we need to dig the Challenge out of the XML.
        const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
        if (!xmlString.includes('PlayReadyKeyMessage')) {
            // This does not appear to be a wrapped message as on Edge.  Some
            // clients do not need this unwrapping, so we will assume this is one of
            // them.  Note that "xml" at this point probably looks like random
            // garbage, since we interpreted UTF-8 as UTF-16.
            xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
            return licenseChallenge;
        }
        const keyMessageXml = new DOMParser().parseFromString(xmlString, 'application/xml');
        // Set request headers.
        const headers = keyMessageXml.querySelectorAll('HttpHeader');
        if (headers.length > 0) {
            let header;
            for(let i = 0, len = headers.length; i < len; i++){
                var _header$querySelector, _header$querySelector2;
                header = headers[i];
                const name = (_header$querySelector = header.querySelector('name')) == null ? void 0 : _header$querySelector.textContent;
                const value = (_header$querySelector2 = header.querySelector('value')) == null ? void 0 : _header$querySelector2.textContent;
                if (name && value) xhr.setRequestHeader(name, value);
            }
        }
        const challengeElement = keyMessageXml.querySelector('Challenge');
        const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
        if (!challengeText) throw new Error(`Cannot find <Challenge> in key message`);
        return $99a156a15cd35eb3$var$strToUtf8array(atob(challengeText));
    }
    setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
        const licenseXhrSetup = this.config.licenseXhrSetup;
        if (!licenseXhrSetup) {
            xhr.open('POST', url, true);
            return Promise.resolve({
                xhr: xhr,
                licenseChallenge: licenseChallenge
            });
        }
        return Promise.resolve().then(()=>{
            if (!keysListItem.decryptdata) throw new Error('Key removed');
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).catch((error)=>{
            if (!keysListItem.decryptdata) // Key session removed. Cancel license request.
            throw error;
            // let's try to open before running setup
            xhr.open('POST', url, true);
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).then((licenseXhrSetupResult)=>{
            // if licenseXhrSetup did not yet call open, let's do it now
            if (!xhr.readyState) xhr.open('POST', url, true);
            const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
            return {
                xhr: xhr,
                licenseChallenge: finalLicenseChallenge
            };
        });
    }
    requestLicense(keySessionContext, licenseChallenge) {
        const keyLoadPolicy = this.config.keyLoadPolicy.default;
        return new Promise((resolve, reject)=>{
            const url = this.getLicenseServerUrlOrThrow(keySessionContext.keySystem);
            this.log(`Sending license request to URL: ${url}`);
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.onreadystatechange = ()=>{
                if (!this.hls || !keySessionContext.mediaKeysSession) return reject(new Error('invalid state'));
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this._requestLicenseFailureCount = 0;
                        let data = xhr.response;
                        this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
                        const licenseResponseCallback = this.config.licenseResponseCallback;
                        if (licenseResponseCallback) try {
                            data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
                        } catch (error) {
                            this.error(error);
                        }
                        resolve(data);
                    } else {
                        const retryConfig = keyLoadPolicy.errorRetry;
                        const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
                        this._requestLicenseFailureCount++;
                        if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) reject(new $99a156a15cd35eb3$var$EMEKeyError({
                            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                            details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: true,
                            networkDetails: xhr,
                            response: {
                                url: url,
                                data: undefined,
                                code: xhr.status,
                                text: xhr.statusText
                            }
                        }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
                        else {
                            const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
                            this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
                            this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
                        }
                    }
                }
            };
            if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) keySessionContext.licenseXhr.abort();
            keySessionContext.licenseXhr = xhr;
            this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({ xhr: xhr, licenseChallenge: licenseChallenge })=>{
                if (keySessionContext.keySystem == $99a156a15cd35eb3$export$1c7b21e05766136c.PLAYREADY) licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
                xhr.send(licenseChallenge);
            });
        });
    }
    onDestroying() {
        this.unregisterListeners();
        this._clear();
    }
    onMediaAttached(event, data) {
        if (!this.config.emeEnabled) return;
        const media = data.media;
        // keep reference of media
        this.media = media;
        $99a156a15cd35eb3$var$addEventListener(media, 'encrypted', this.onMediaEncrypted);
        $99a156a15cd35eb3$var$addEventListener(media, 'waitingforkey', this.onWaitingForKey);
    }
    onMediaDetached() {
        const media = this.media;
        if (media) {
            $99a156a15cd35eb3$var$removeEventListener(media, 'encrypted', this.onMediaEncrypted);
            $99a156a15cd35eb3$var$removeEventListener(media, 'waitingforkey', this.onWaitingForKey);
            this.media = null;
            this.mediaKeys = null;
        }
    }
    _clear() {
        var _media$setMediaKeys;
        this._requestLicenseFailureCount = 0;
        this.keyIdToKeySessionPromise = {};
        if (!this.mediaKeys && !this.mediaKeySessions.length) return;
        const media = this.media;
        const mediaKeysList = this.mediaKeySessions.slice();
        this.mediaKeySessions = [];
        this.mediaKeys = null;
        $99a156a15cd35eb3$export$ca24892a09b21f29.clearKeyUriToKeyIdMap();
        // Close all sessions and remove media keys from the video element.
        const keySessionCount = mediaKeysList.length;
        $99a156a15cd35eb3$export$bd16919f25cf2fc5.CDMCleanupPromise = Promise.all(mediaKeysList.map((mediaKeySessionContext)=>this.removeSession(mediaKeySessionContext)).concat(media == null ? void 0 : (_media$setMediaKeys = media.setMediaKeys(null)) == null ? void 0 : _media$setMediaKeys.catch((error)=>{
            var _this$hls2;
            this.log(`Could not clear media keys: ${error}`);
            (_this$hls2 = this.hls) == null || _this$hls2.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
                fatal: false,
                error: new Error(`Could not clear media keys: ${error}`)
            });
        }))).catch((error)=>{
            var _this$hls3;
            this.log(`Could not close sessions and clear media keys: ${error}`);
            (_this$hls3 = this.hls) == null || _this$hls3.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
                fatal: false,
                error: new Error(`Could not close sessions and clear media keys: ${error}`)
            });
        }).then(()=>{
            if (keySessionCount) this.log('finished closing key sessions and clearing media keys');
        });
    }
    onManifestLoading() {
        this.keyFormatPromise = null;
    }
    onManifestLoaded(event, { sessionKeys: sessionKeys }) {
        if (!sessionKeys || !this.config.emeEnabled) return;
        if (!this.keyFormatPromise) {
            const keyFormats = sessionKeys.reduce((formats, sessionKey)=>{
                if (formats.indexOf(sessionKey.keyFormat) === -1) formats.push(sessionKey.keyFormat);
                return formats;
            }, []);
            this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
    }
    removeSession(mediaKeySessionContext) {
        const { mediaKeysSession: mediaKeysSession, licenseXhr: licenseXhr } = mediaKeySessionContext;
        if (mediaKeysSession) {
            this.log(`Remove licenses and keys and close session ${mediaKeysSession.sessionId}`);
            if (mediaKeySessionContext._onmessage) {
                mediaKeysSession.removeEventListener('message', mediaKeySessionContext._onmessage);
                mediaKeySessionContext._onmessage = undefined;
            }
            if (mediaKeySessionContext._onkeystatuseschange) {
                mediaKeysSession.removeEventListener('keystatuseschange', mediaKeySessionContext._onkeystatuseschange);
                mediaKeySessionContext._onkeystatuseschange = undefined;
            }
            if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) licenseXhr.abort();
            mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
            const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
            if (index > -1) this.mediaKeySessions.splice(index, 1);
            const { drmSystemOptions: drmSystemOptions } = this.config;
            const removePromise = $99a156a15cd35eb3$var$isPersistentSessionType(drmSystemOptions) ? new Promise((resolve, reject)=>{
                self.setTimeout(()=>reject(new Error(`MediaKeySession.remove() timeout`)), 8000);
                mediaKeysSession.remove().then(resolve);
            }) : Promise.resolve();
            return removePromise.catch((error)=>{
                var _this$hls4;
                this.log(`Could not remove session: ${error}`);
                (_this$hls4 = this.hls) == null || _this$hls4.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
                    fatal: false,
                    error: new Error(`Could not remove session: ${error}`)
                });
            }).then(()=>{
                return mediaKeysSession.close();
            }).catch((error)=>{
                var _this$hls5;
                this.log(`Could not close session: ${error}`);
                (_this$hls5 = this.hls) == null || _this$hls5.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
                    fatal: false,
                    error: new Error(`Could not close session: ${error}`)
                });
            });
        }
    }
}
$99a156a15cd35eb3$export$bd16919f25cf2fc5.CDMCleanupPromise = void 0;
class $99a156a15cd35eb3$var$EMEKeyError extends Error {
    constructor(data, message){
        super(message);
        this.data = void 0;
        data.error || (data.error = new Error(message));
        this.data = data;
        data.err = data.error;
    }
}
class $99a156a15cd35eb3$export$ca3da7ea73955a38 {
    constructor(hls){
        this.hls = void 0;
        this.isVideoPlaybackQualityAvailable = false;
        this.timer = void 0;
        this.media = null;
        this.lastTime = void 0;
        this.lastDroppedFrames = 0;
        this.lastDecodedFrames = 0;
        // stream controller must be provided as a dependency!
        this.streamController = void 0;
        this.hls = hls;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    registerListeners() {
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    unregisterListeners() {
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    destroy() {
        if (this.timer) clearInterval(this.timer);
        this.unregisterListeners();
        this.isVideoPlaybackQualityAvailable = false;
        this.media = null;
    }
    onMediaAttaching(event, data) {
        const config = this.hls.config;
        if (config.capLevelOnFPSDrop) {
            const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
            this.media = media;
            if (media && typeof media.getVideoPlaybackQuality === 'function') this.isVideoPlaybackQualityAvailable = true;
            self.clearInterval(this.timer);
            this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
        }
    }
    onMediaDetaching() {
        this.media = null;
    }
    checkFPS(video, decodedFrames, droppedFrames) {
        const currentTime = performance.now();
        if (decodedFrames) {
            if (this.lastTime) {
                const currentPeriod = currentTime - this.lastTime;
                const currentDropped = droppedFrames - this.lastDroppedFrames;
                const currentDecoded = decodedFrames - this.lastDecodedFrames;
                const droppedFPS = 1000 * currentDropped / currentPeriod;
                const hls = this.hls;
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FPS_DROP, {
                    currentDropped: currentDropped,
                    currentDecoded: currentDecoded,
                    totalDroppedFrames: droppedFrames
                });
                if (droppedFPS > 0) // hls.logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                {
                    if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                        let currentLevel = hls.currentLevel;
                        hls.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
                        if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FPS_DROP_LEVEL_CAPPING, {
                                level: currentLevel,
                                droppedLevel: hls.currentLevel
                            });
                            hls.autoLevelCapping = currentLevel;
                            this.streamController.nextLevelSwitch();
                        }
                    }
                }
            }
            this.lastTime = currentTime;
            this.lastDroppedFrames = droppedFrames;
            this.lastDecodedFrames = decodedFrames;
        }
    }
    checkFPSInterval() {
        const video = this.media;
        if (video) {
            if (this.isVideoPlaybackQualityAvailable) {
                const videoPlaybackQuality = video.getVideoPlaybackQuality();
                this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
            } else // HTMLVideoElement doesn't include the webkit types
            this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
    }
}
function $99a156a15cd35eb3$var$sendAddTrackEvent(track, videoEl) {
    let event;
    try {
        event = new Event('addtrack');
    } catch (err) {
        // for IE11
        event = document.createEvent('Event');
        event.initEvent('addtrack', false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
}
function $99a156a15cd35eb3$var$addCueToTrack(track, cue) {
    // Sometimes there are cue overlaps on segmented vtts so the same
    // cue can appear more than once in different vtt files.
    // This avoid showing duplicated cues with same timecode and text.
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues && !track.cues.getCueById(cue.id)) try {
        track.addCue(cue);
        if (!track.cues.getCueById(cue.id)) throw new Error(`addCue is failed for: ${cue}`);
    } catch (err) {
        $99a156a15cd35eb3$var$logger.debug(`[texttrack-utils]: ${err}`);
        try {
            const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
            textTrackCue.id = cue.id;
            track.addCue(textTrackCue);
        } catch (err2) {
            $99a156a15cd35eb3$var$logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
        }
    }
    if (mode === 'disabled') track.mode = mode;
}
function $99a156a15cd35eb3$var$clearCurrentCues(track, enterHandler) {
    // When track.mode is disabled, track.cues will be null.
    // To guarantee the removal of cues, we need to temporarily
    // change the mode to hidden
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues) for(let i = track.cues.length; i--;){
        if (enterHandler) track.cues[i].removeEventListener('enter', enterHandler);
        track.removeCue(track.cues[i]);
    }
    if (mode === 'disabled') track.mode = mode;
}
function $99a156a15cd35eb3$var$removeCuesInRange(track, start, end, predicate) {
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues && track.cues.length > 0) {
        const cues = $99a156a15cd35eb3$var$getCuesInRange(track.cues, start, end);
        for(let i = 0; i < cues.length; i++)if (!predicate || predicate(cues[i])) track.removeCue(cues[i]);
    }
    if (mode === 'disabled') track.mode = mode;
}
// Find first cue starting at or after given time.
// Modified version of binary search O(log(n)).
function $99a156a15cd35eb3$var$getFirstCueIndexFromTime(cues, time1) {
    // If first cue starts at or after time, start there
    if (time1 <= cues[0].startTime) return 0;
    // If the last cue ends before time there is no overlap
    const len = cues.length - 1;
    if (time1 > cues[len].endTime) return -1;
    let left = 0;
    let right = len;
    let mid;
    while(left <= right){
        mid = Math.floor((right + left) / 2);
        if (time1 < cues[mid].startTime) right = mid - 1;
        else if (time1 > cues[mid].startTime && left < len) left = mid + 1;
        else // If it's not lower or higher, it must be equal.
        return mid;
    }
    // At this point, left and right have swapped.
    // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
    return cues[left].startTime - time1 < time1 - cues[right].startTime ? left : right;
}
function $99a156a15cd35eb3$var$getCuesInRange(cues, start, end) {
    const cuesFound = [];
    const firstCueInRange = $99a156a15cd35eb3$var$getFirstCueIndexFromTime(cues, start);
    if (firstCueInRange > -1) for(let i = firstCueInRange, len = cues.length; i < len; i++){
        const cue = cues[i];
        if (cue.startTime >= start && cue.endTime <= end) cuesFound.push(cue);
        else if (cue.startTime > end) return cuesFound;
    }
    return cuesFound;
}
function $99a156a15cd35eb3$var$filterSubtitleTracks(textTrackList) {
    const tracks = [];
    for(let i = 0; i < textTrackList.length; i++){
        const track = textTrackList[i];
        // Edge adds a track without a label; we don't want to use it
        if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) tracks.push(textTrackList[i]);
    }
    return tracks;
}
class $99a156a15cd35eb3$export$e287517d6ed8b132 extends $99a156a15cd35eb3$export$d94ec24774c8b986 {
    constructor(hls){
        super(hls, 'subtitle-track-controller');
        this.media = null;
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.queuedDefaultTrack = -1;
        this.useTextTrackPolling = false;
        this.subtitlePollingInterval = -1;
        this._subtitleDisplay = true;
        this.asyncPollTrackChange = ()=>this.pollTrackChange(0);
        this.onTextTracksChanged = ()=>{
            if (!this.useTextTrackPolling) self.clearInterval(this.subtitlePollingInterval);
            // Media is undefined when switching streams via loadSource()
            if (!this.media || !this.hls.config.renderTextTracksNatively) return;
            let textTrack = null;
            const tracks = $99a156a15cd35eb3$var$filterSubtitleTracks(this.media.textTracks);
            for(let i = 0; i < tracks.length; i++){
                if (tracks[i].mode === 'hidden') // Do not break in case there is a following track with showing.
                textTrack = tracks[i];
                else if (tracks[i].mode === 'showing') {
                    textTrack = tracks[i];
                    break;
                }
            }
            // Find internal track index for TextTrack
            const trackId = this.findTrackForTextTrack(textTrack);
            if (this.subtitleTrack !== trackId) this.setSubtitleTrack(trackId);
        };
        this.registerListeners();
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        // @ts-ignore
        this.onTextTracksChanged = this.asyncPollTrackChange = null;
        super.destroy();
    }
    get subtitleDisplay() {
        return this._subtitleDisplay;
    }
    set subtitleDisplay(value) {
        this._subtitleDisplay = value;
        if (this.trackId > -1) this.toggleTrackModes();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    // Listen for subtitle track change, then extract the current track ID.
    onMediaAttached(event, data) {
        this.media = data.media;
        if (!this.media) return;
        if (this.queuedDefaultTrack > -1) {
            this.subtitleTrack = this.queuedDefaultTrack;
            this.queuedDefaultTrack = -1;
        }
        this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
        if (this.useTextTrackPolling) this.pollTrackChange(500);
        else this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
    pollTrackChange(timeout) {
        self.clearInterval(this.subtitlePollingInterval);
        this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
    }
    onMediaDetaching(event, data) {
        const media = this.media;
        if (!media) return;
        const transferringMedia = !!data.transferMedia;
        self.clearInterval(this.subtitlePollingInterval);
        if (!this.useTextTrackPolling) media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
        if (this.trackId > -1) this.queuedDefaultTrack = this.trackId;
        // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
        this.subtitleTrack = -1;
        this.media = null;
        if (transferringMedia) return;
        const textTracks = $99a156a15cd35eb3$var$filterSubtitleTracks(media.textTracks);
        // Clear loaded cues on media detachment from tracks
        textTracks.forEach((track)=>{
            $99a156a15cd35eb3$var$clearCurrentCues(track);
        });
    }
    onManifestLoading() {
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
    }
    // Fired whenever a new manifest is loaded.
    onManifestParsed(event, data) {
        this.tracks = data.subtitleTracks;
    }
    onSubtitleTrackLoaded(event, data) {
        const { id: id, groupId: groupId, details: details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!levelInfo) return;
        const subtitleGroups = levelInfo.subtitleGroups || null;
        const currentGroups = this.groupIds;
        let currentTrack = this.currentTrack;
        if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some((groupId)=>(currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
            this.groupIds = subtitleGroups;
            this.trackId = -1;
            this.currentTrack = null;
            const subtitleTracks = this.tracks.filter((track)=>!subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
            if (subtitleTracks.length) {
                // Disable selectDefaultTrack if there are no default tracks
                if (this.selectDefaultTrack && !subtitleTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
                // track.id should match hls.audioTracks index
                subtitleTracks.forEach((track, i)=>{
                    track.id = i;
                });
            } else if (!currentTrack && !this.tracksInGroup.length) // Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
            return;
            this.tracksInGroup = subtitleTracks;
            // Find preferred track
            const subtitlePreference = this.hls.config.subtitlePreference;
            if (!currentTrack && subtitlePreference) {
                this.selectDefaultTrack = false;
                const groupIndex = $99a156a15cd35eb3$var$findMatchingOption(subtitlePreference, subtitleTracks);
                if (groupIndex > -1) currentTrack = subtitleTracks[groupIndex];
                else {
                    const allIndex = $99a156a15cd35eb3$var$findMatchingOption(subtitlePreference, this.tracks);
                    currentTrack = this.tracks[allIndex];
                }
            }
            // Select initial track
            let trackId = this.findTrackId(currentTrack);
            if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
            // Dispatch events and load track if needed
            const subtitleTracksUpdated = {
                subtitleTracks: subtitleTracks
            };
            this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(',')}" group-id`);
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
            if (trackId !== -1 && this.trackId === -1) this.setSubtitleTrack(trackId);
        }
    }
    findTrackId(currentTrack) {
        const tracks = this.tracksInGroup;
        const selectDefault = this.selectDefaultTrack;
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            if (selectDefault && !track.default || !selectDefault && !currentTrack) continue;
            if (!currentTrack || $99a156a15cd35eb3$var$matchesOption(track, currentTrack)) return i;
        }
        if (currentTrack) {
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if ($99a156a15cd35eb3$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'CHARACTERISTICS'
                ])) return i;
            }
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if ($99a156a15cd35eb3$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE'
                ])) return i;
            }
        }
        return -1;
    }
    findTrackForTextTrack(textTrack) {
        if (textTrack) {
            const tracks = this.tracksInGroup;
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if ($99a156a15cd35eb3$var$subtitleTrackMatchesTextTrack(track, textTrack)) return i;
            }
        }
        return -1;
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
    }
    get allSubtitleTracks() {
        return this.tracks;
    }
    /** get alternate subtitle tracks list from playlist **/ get subtitleTracks() {
        return this.tracksInGroup;
    }
    /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/ get subtitleTrack() {
        return this.trackId;
    }
    set subtitleTrack(newId) {
        this.selectDefaultTrack = false;
        this.setSubtitleTrack(newId);
    }
    setSubtitleOption(subtitleOption) {
        this.hls.config.subtitlePreference = subtitleOption;
        if (subtitleOption) {
            if (subtitleOption.id === -1) {
                this.setSubtitleTrack(-1);
                return null;
            }
            const allSubtitleTracks = this.allSubtitleTracks;
            this.selectDefaultTrack = false;
            if (allSubtitleTracks.length) {
                // First see if current option matches (no switch op)
                const currentTrack = this.currentTrack;
                if (currentTrack && $99a156a15cd35eb3$var$matchesOption(subtitleOption, currentTrack)) return currentTrack;
                // Find option in current group
                const groupIndex = $99a156a15cd35eb3$var$findMatchingOption(subtitleOption, this.tracksInGroup);
                if (groupIndex > -1) {
                    const track = this.tracksInGroup[groupIndex];
                    this.setSubtitleTrack(groupIndex);
                    return track;
                } else if (currentTrack) // If this is not the initial selection return null
                // option should have matched one in active group
                return null;
                else {
                    // Find the option in all tracks for initial selection
                    const allIndex = $99a156a15cd35eb3$var$findMatchingOption(subtitleOption, allSubtitleTracks);
                    if (allIndex > -1) return allSubtitleTracks[allIndex];
                }
            }
        }
        return null;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        if (this.shouldLoadPlaylist(this.currentTrack)) this.scheduleLoading(this.currentTrack, hlsUrlParameters);
    }
    loadingPlaylist(currentTrack, hlsUrlParameters) {
        super.loadingPlaylist(currentTrack, hlsUrlParameters);
        const id = currentTrack.id;
        const groupId = currentTrack.groupId;
        const url = this.getUrlWithDirectives(currentTrack.url, hlsUrlParameters);
        const details = currentTrack.details;
        const age = details == null ? void 0 : details.age;
        this.log(`Loading subtitle ${id} "${currentTrack.name}" lang:${currentTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type : '') : ''} ${url}`);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADING, {
            url: url,
            id: id,
            groupId: groupId,
            deliveryDirectives: hlsUrlParameters || null,
            track: currentTrack
        });
    }
    /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */ toggleTrackModes() {
        const { media: media } = this;
        if (!media) return;
        const textTracks = $99a156a15cd35eb3$var$filterSubtitleTracks(media.textTracks);
        const currentTrack = this.currentTrack;
        let nextTrack;
        if (currentTrack) {
            nextTrack = textTracks.filter((textTrack)=>$99a156a15cd35eb3$var$subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
            if (!nextTrack) this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
        }
        [].slice.call(textTracks).forEach((track)=>{
            if (track.mode !== 'disabled' && track !== nextTrack) track.mode = 'disabled';
        });
        if (nextTrack) {
            const mode = this.subtitleDisplay ? 'showing' : 'hidden';
            if (nextTrack.mode !== mode) nextTrack.mode = mode;
        }
    }
    /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */ setSubtitleTrack(newId) {
        const tracks = this.tracksInGroup;
        // setting this.subtitleTrack will trigger internal logic
        // if media has not been attached yet, it will fail
        // we keep a reference to the default track id
        // and we'll set subtitleTrack when onMediaAttached is triggered
        if (!this.media) {
            this.queuedDefaultTrack = newId;
            return;
        }
        // exit if track id as already set or invalid
        if (newId < -1 || newId >= tracks.length || !$99a156a15cd35eb3$var$isFiniteNumber(newId)) {
            this.warn(`Invalid subtitle track id: ${newId}`);
            return;
        }
        this.selectDefaultTrack = false;
        const lastTrack = this.currentTrack;
        const track = tracks[newId] || null;
        this.trackId = newId;
        this.currentTrack = track;
        this.toggleTrackModes();
        if (!track) {
            // switch to -1
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, {
                id: newId
            });
            return;
        }
        const trackLoaded = !!track.details && !track.details.live;
        if (newId === this.trackId && track === lastTrack && trackLoaded) return;
        this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
        const { id: id, groupId: groupId = '', name: name, type: type, url: url } = track;
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, {
            id: id,
            groupId: groupId,
            name: name,
            type: type,
            url: url
        });
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
        this.loadPlaylist(hlsUrlParameters);
    }
}
/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */ function $99a156a15cd35eb3$var$uuid() {
    try {
        return crypto.randomUUID();
    } catch (error) {
        try {
            const url = URL.createObjectURL(new Blob());
            const uuid = url.toString();
            URL.revokeObjectURL(url);
            return uuid.slice(uuid.lastIndexOf('/') + 1);
        } catch (error) {
            let dt = new Date().getTime();
            const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
                const r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
            });
            return uuid;
        }
    }
}
// From https://github.com/darkskyapp/string-hash
function $99a156a15cd35eb3$var$hash(text) {
    let hash = 5381;
    let i = text.length;
    while(i)hash = hash * 33 ^ text.charCodeAt(--i);
    return (hash >>> 0).toString();
}
const $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS = 0.025;
let $99a156a15cd35eb3$var$TimelineOccupancy = /*#__PURE__*/ function(TimelineOccupancy) {
    TimelineOccupancy[TimelineOccupancy["Point"] = 0] = "Point";
    TimelineOccupancy[TimelineOccupancy["Range"] = 1] = "Range";
    return TimelineOccupancy;
}({});
function $99a156a15cd35eb3$var$generateAssetIdentifier(interstitial, uri, assetListIndex) {
    return `${interstitial.identifier}-${assetListIndex + 1}-${$99a156a15cd35eb3$var$hash(uri)}`;
}
class $99a156a15cd35eb3$var$InterstitialEvent {
    constructor(dateRange, base){
        this.base = void 0;
        this._duration = null;
        this._timelineStart = null;
        this.appendInPlaceDisabled = void 0;
        this.appendInPlaceStarted = void 0;
        this.dateRange = void 0;
        this.hasPlayed = false;
        this.cumulativeDuration = 0;
        this.resumeOffset = NaN;
        this.playoutLimit = NaN;
        this.restrictions = {
            skip: false,
            jump: false
        };
        this.snapOptions = {
            out: false,
            in: false
        };
        this.assetList = [];
        this.assetListLoader = void 0;
        this.assetListResponse = null;
        this.resumeAnchor = void 0;
        this.error = void 0;
        this.resetOnResume = void 0;
        this.base = base;
        this.dateRange = dateRange;
        this.setDateRange(dateRange);
    }
    setDateRange(dateRange) {
        this.dateRange = dateRange;
        this.resumeOffset = dateRange.attr.optionalFloat('X-RESUME-OFFSET', this.resumeOffset);
        this.playoutLimit = dateRange.attr.optionalFloat('X-PLAYOUT-LIMIT', this.playoutLimit);
        this.restrictions = dateRange.attr.enumeratedStringList('X-RESTRICT', this.restrictions);
        this.snapOptions = dateRange.attr.enumeratedStringList('X-SNAP', this.snapOptions);
    }
    reset() {
        var _this$assetListLoader;
        this.appendInPlaceStarted = false;
        (_this$assetListLoader = this.assetListLoader) == null || _this$assetListLoader.destroy();
        this.assetListLoader = undefined;
        if (!this.supplementsPrimary) {
            this.assetListResponse = null;
            this.assetList = [];
            this._duration = null;
        }
    // `error?` is reset when seeking back over interstitial `startOffset`
    //  using `schedule.resetErrorsInRange(start, end)`.
    }
    isAssetPastPlayoutLimit(assetIndex) {
        var _this$assetList$asset;
        if (assetIndex > 0 && assetIndex >= this.assetList.length) return true;
        const playoutLimit = this.playoutLimit;
        if (assetIndex <= 0 || isNaN(playoutLimit)) return false;
        if (playoutLimit === 0) return true;
        const assetOffset = ((_this$assetList$asset = this.assetList[assetIndex]) == null ? void 0 : _this$assetList$asset.startOffset) || 0;
        return assetOffset > playoutLimit;
    }
    findAssetIndex(asset) {
        const index = this.assetList.indexOf(asset);
        return index;
    }
    get identifier() {
        return this.dateRange.id;
    }
    get startDate() {
        return this.dateRange.startDate;
    }
    get startTime() {
        // Primary media timeline start time
        const startTime = this.dateRange.startTime;
        if (this.snapOptions.out) {
            const frag = this.dateRange.tagAnchor;
            if (frag) return $99a156a15cd35eb3$var$getSnapToFragmentTime(startTime, frag);
        }
        return startTime;
    }
    get startOffset() {
        return this.cue.pre ? 0 : this.startTime;
    }
    get startIsAligned() {
        if (this.startTime === 0 || this.snapOptions.out) return true;
        const frag = this.dateRange.tagAnchor;
        if (frag) {
            const startTime = this.dateRange.startTime;
            const snappedStart = $99a156a15cd35eb3$var$getSnapToFragmentTime(startTime, frag);
            return startTime - snappedStart < 0.1;
        }
        return false;
    }
    get resumptionOffset() {
        const resumeOffset = this.resumeOffset;
        const offset = $99a156a15cd35eb3$var$isFiniteNumber(resumeOffset) ? resumeOffset : this.duration;
        return this.cumulativeDuration + offset;
    }
    get resumeTime() {
        // Primary media timeline resumption time
        const resumeTime = this.startOffset + this.resumptionOffset;
        if (this.snapOptions.in) {
            const frag = this.resumeAnchor;
            if (frag) return $99a156a15cd35eb3$var$getSnapToFragmentTime(resumeTime, frag);
        }
        return resumeTime;
    }
    get appendInPlace() {
        if (this.appendInPlaceStarted) return true;
        if (this.appendInPlaceDisabled) return false;
        if (!this.cue.once && !this.cue.pre && // preroll starts at startPosition before startPosition is known (live)
        this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS)) return true;
        return false;
    }
    set appendInPlace(value) {
        if (this.appendInPlaceStarted) {
            this.resetOnResume = !value;
            return;
        }
        this.appendInPlaceDisabled = !value;
    }
    // Extended timeline start time
    get timelineStart() {
        if (this._timelineStart !== null) return this._timelineStart;
        return this.startTime;
    }
    set timelineStart(value) {
        this._timelineStart = value;
    }
    get duration() {
        const playoutLimit = this.playoutLimit;
        let duration;
        if (this._duration !== null) duration = this._duration;
        else if (this.dateRange.duration) duration = this.dateRange.duration;
        else duration = this.dateRange.plannedDuration || 0;
        if (!isNaN(playoutLimit) && playoutLimit < duration) duration = playoutLimit;
        return duration;
    }
    set duration(value) {
        this._duration = value;
    }
    get cue() {
        return this.dateRange.cue;
    }
    get timelineOccupancy() {
        if (this.dateRange.attr['X-TIMELINE-OCCUPIES'] === 'RANGE') return $99a156a15cd35eb3$var$TimelineOccupancy.Range;
        return $99a156a15cd35eb3$var$TimelineOccupancy.Point;
    }
    get supplementsPrimary() {
        return this.dateRange.attr['X-TIMELINE-STYLE'] === 'PRIMARY';
    }
    get contentMayVary() {
        return this.dateRange.attr['X-CONTENT-MAY-VARY'] !== 'NO';
    }
    get assetUrl() {
        return this.dateRange.attr['X-ASSET-URI'];
    }
    get assetListUrl() {
        return this.dateRange.attr['X-ASSET-LIST'];
    }
    get baseUrl() {
        return this.base.url;
    }
    get assetListLoaded() {
        return this.assetList.length > 0 || this.assetListResponse !== null;
    }
    toString() {
        return $99a156a15cd35eb3$var$eventToString(this);
    }
}
function $99a156a15cd35eb3$var$getSnapToFragmentTime(time1, frag) {
    return time1 - frag.start < frag.duration / 2 && !(Math.abs(time1 - (frag.start + frag.duration)) < $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS) ? frag.start : frag.start + frag.duration;
}
function $99a156a15cd35eb3$var$getInterstitialUrl(uri, sessionId, baseUrl) {
    const url = new self.URL(uri, baseUrl);
    if (url.protocol !== 'data:') url.searchParams.set('_HLS_primary_id', sessionId);
    return url;
}
function $99a156a15cd35eb3$var$getNextAssetIndex(interstitial, assetListIndex) {
    while((_interstitial$assetLi = interstitial.assetList[++assetListIndex]) != null && _interstitial$assetLi.error)var _interstitial$assetLi;
     /* no-op */ 
    return assetListIndex;
}
function $99a156a15cd35eb3$var$eventToString(interstitial) {
    return `["${interstitial.identifier}" ${interstitial.cue.pre ? '<pre>' : interstitial.cue.post ? '<post>' : ''}${interstitial.timelineStart.toFixed(2)}-${interstitial.resumeTime.toFixed(2)}]`;
}
function $99a156a15cd35eb3$var$eventAssetToString(asset) {
    const start = asset.timelineStart;
    const duration = asset.duration || 0;
    return `["${asset.identifier}" ${start.toFixed(2)}-${(start + duration).toFixed(2)}]`;
}
class $99a156a15cd35eb3$var$HlsAssetPlayer {
    constructor(HlsPlayerClass, userConfig, interstitial, assetItem){
        this.hls = void 0;
        this.interstitial = void 0;
        this.assetItem = void 0;
        this.tracks = null;
        this.hasDetails = false;
        this.mediaAttached = null;
        this._currentTime = void 0;
        this._bufferedEosTime = void 0;
        this.checkPlayout = ()=>{
            if (this.reachedPlayout(this.currentTime)) this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.PLAYOUT_LIMIT_REACHED, {});
        };
        const hls = this.hls = new HlsPlayerClass(userConfig);
        this.interstitial = interstitial;
        this.assetItem = assetItem;
        let uri = assetItem.uri;
        try {
            uri = $99a156a15cd35eb3$var$getInterstitialUrl(uri, userConfig.primarySessionId).href;
        } catch (error) {
        // Ignore error parsing ASSET_URI or adding _HLS_primary_id to it. The
        // issue should surface as an INTERSTITIAL_ASSET_ERROR loading the asset.
        }
        hls.loadSource(uri);
        const detailsLoaded = ()=>{
            this.hasDetails = true;
        };
        hls.once($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, detailsLoaded);
        hls.once($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, detailsLoaded);
        hls.once($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, detailsLoaded);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, (name, { media: media })=>{
            this.removeMediaListeners();
            this.mediaAttached = media;
            const event = this.interstitial;
            if (event.playoutLimit) {
                media.addEventListener('timeupdate', this.checkPlayout);
                if (this.appendInPlace) hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, ()=>{
                    const bufferedEnd = this.bufferedEnd;
                    if (this.reachedPlayout(bufferedEnd)) {
                        this._bufferedEosTime = bufferedEnd;
                        hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFERED_TO_END, undefined);
                    }
                });
            }
        });
    }
    get appendInPlace() {
        var _this$interstitial;
        return ((_this$interstitial = this.interstitial) == null ? void 0 : _this$interstitial.appendInPlace) || false;
    }
    bufferedInPlaceToEnd(media) {
        var _this$hls;
        if (!this.appendInPlace) return false;
        if ((_this$hls = this.hls) != null && _this$hls.bufferedToEnd) return true;
        if (!media || !this._bufferedEosTime) return false;
        const start = this.timelineOffset;
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, start, 0);
        const bufferedEnd = this.getAssetTime(bufferInfo.end);
        return bufferedEnd >= this._bufferedEosTime - 0.02;
    }
    reachedPlayout(time1) {
        const interstitial = this.interstitial;
        const playoutLimit = interstitial.playoutLimit;
        return this.startOffset + time1 >= playoutLimit;
    }
    get destroyed() {
        var _this$hls2;
        return !((_this$hls2 = this.hls) != null && _this$hls2.userConfig);
    }
    get assetId() {
        return this.assetItem.identifier;
    }
    get interstitialId() {
        return this.assetItem.parentIdentifier;
    }
    get media() {
        var _this$hls3;
        return ((_this$hls3 = this.hls) == null ? void 0 : _this$hls3.media) || null;
    }
    get bufferedEnd() {
        const media = this.media || this.mediaAttached;
        if (!media) {
            if (this._bufferedEosTime) return this._bufferedEosTime;
            return this.currentTime;
        }
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, media.currentTime, 0.001);
        return this.getAssetTime(bufferInfo.end);
    }
    get currentTime() {
        const media = this.media || this.mediaAttached;
        if (!media) return this._currentTime || 0;
        return this.getAssetTime(media.currentTime);
    }
    get duration() {
        const duration = this.assetItem.duration;
        if (!duration) return 0;
        return duration;
    }
    get remaining() {
        const duration = this.duration;
        if (!duration) return 0;
        return Math.max(0, duration - this.currentTime);
    }
    get startOffset() {
        return this.assetItem.startOffset;
    }
    get timelineOffset() {
        var _this$hls4;
        return ((_this$hls4 = this.hls) == null ? void 0 : _this$hls4.config.timelineOffset) || 0;
    }
    set timelineOffset(value) {
        const timelineOffset = this.timelineOffset;
        if (value !== timelineOffset) {
            const diff = value - timelineOffset;
            if (Math.abs(diff) > 1 / 90000) {
                if (this.hasDetails) throw new Error(`Cannot set timelineOffset after playlists are loaded`);
                this.hls.config.timelineOffset = value;
            }
        }
    }
    getAssetTime(time1) {
        const timelineOffset = this.timelineOffset;
        const duration = this.duration;
        return Math.min(Math.max(0, time1 - timelineOffset), duration);
    }
    removeMediaListeners() {
        const media = this.mediaAttached;
        if (media) {
            this._currentTime = media.currentTime;
            this.bufferSnapShot();
            media.removeEventListener('timeupdate', this.checkPlayout);
        }
    }
    bufferSnapShot() {
        if (this.mediaAttached) {
            var _this$hls5;
            if ((_this$hls5 = this.hls) != null && _this$hls5.bufferedToEnd) this._bufferedEosTime = this.bufferedEnd;
        }
    }
    destroy() {
        this.removeMediaListeners();
        this.hls.destroy();
        // @ts-ignore
        this.hls = this.interstitial = null;
        // @ts-ignore
        this.tracks = this.mediaAttached = this.checkPlayout = null;
    }
    attachMedia(data) {
        this.hls.attachMedia(data);
    }
    detachMedia() {
        this.removeMediaListeners();
        this.mediaAttached = null;
        this.hls.detachMedia();
    }
    resumeBuffering() {
        this.hls.resumeBuffering();
    }
    pauseBuffering() {
        this.hls.pauseBuffering();
    }
    transferMedia() {
        this.bufferSnapShot();
        return this.hls.transferMedia();
    }
    resetDetails() {
        const hls = this.hls;
        if (this.hasDetails) {
            hls.stopLoad();
            const deleteDetails = (obj)=>delete obj.details;
            hls.levels.forEach(deleteDetails);
            hls.allAudioTracks.forEach(deleteDetails);
            hls.allSubtitleTracks.forEach(deleteDetails);
            this.hasDetails = false;
        }
    }
    on(event, listener, context) {
        this.hls.on(event, listener);
    }
    once(event, listener, context) {
        this.hls.once(event, listener);
    }
    off(event, listener, context) {
        this.hls.off(event, listener);
    }
    toString() {
        var _this$hls6;
        return `HlsAssetPlayer: ${$99a156a15cd35eb3$var$eventAssetToString(this.assetItem)} ${(_this$hls6 = this.hls) == null ? void 0 : _this$hls6.sessionId} ${this.appendInPlace ? 'append-in-place' : ''}`;
    }
}
const $99a156a15cd35eb3$var$ABUTTING_THRESHOLD_SECONDS = 0.033;
class $99a156a15cd35eb3$var$InterstitialsSchedule extends $99a156a15cd35eb3$var$Logger {
    constructor(onScheduleUpdate, logger){
        super('interstitials-sched', logger);
        this.onScheduleUpdate = void 0;
        this.eventMap = {};
        this.events = null;
        this.items = null;
        this.durations = {
            primary: 0,
            playout: 0,
            integrated: 0
        };
        this.onScheduleUpdate = onScheduleUpdate;
    }
    destroy() {
        this.reset();
        // @ts-ignore
        this.onScheduleUpdate = null;
    }
    reset() {
        this.eventMap = {};
        this.setDurations(0, 0, 0);
        if (this.events) this.events.forEach((interstitial)=>interstitial.reset());
        this.events = this.items = null;
    }
    resetErrorsInRange(start, end) {
        if (this.events) return this.events.reduce((count, interstitial)=>{
            if (start <= interstitial.startOffset && end > interstitial.startOffset) {
                delete interstitial.error;
                return count + 1;
            }
            return count;
        }, 0);
        return 0;
    }
    get duration() {
        const items = this.items;
        return items ? items[items.length - 1].end : 0;
    }
    get length() {
        return this.items ? this.items.length : 0;
    }
    getEvent(identifier) {
        return identifier ? this.eventMap[identifier] || null : null;
    }
    hasEvent(identifier) {
        return identifier in this.eventMap;
    }
    findItemIndex(item, time1) {
        if (item.event) // Find Event Item
        return this.findEventIndex(item.event.identifier);
        // Find Primary Item
        let index = -1;
        if (item.nextEvent) index = this.findEventIndex(item.nextEvent.identifier) - 1;
        else if (item.previousEvent) index = this.findEventIndex(item.previousEvent.identifier) + 1;
        const items = this.items;
        if (items) {
            if (!items[index]) {
                if (time1 === undefined) time1 = item.start;
                index = this.findItemIndexAtTime(time1);
            }
            // Only return index of a Primary Item
            while(index >= 0 && (_items$index = items[index]) != null && _items$index.event){
                var _items$index;
                // If index found is an interstitial it is not a valid result as it should have been matched up top
                // decrement until result is negative (not found) or a primary segment
                index--;
            }
        }
        return index;
    }
    findItemIndexAtTime(timelinePos, timelineType) {
        const items = this.items;
        if (items) for(let i = 0; i < items.length; i++){
            let timeRange = items[i];
            if (timelineType && timelineType !== 'primary') timeRange = timeRange[timelineType];
            if (timelinePos === timeRange.start || timelinePos > timeRange.start && timelinePos < timeRange.end) return i;
        }
        return -1;
    }
    findJumpRestrictedIndex(startIndex, endIndex) {
        const items = this.items;
        if (items) for(let i = startIndex; i <= endIndex; i++){
            if (!items[i]) break;
            const event = items[i].event;
            if (event != null && event.restrictions.jump && !event.appendInPlace) return i;
        }
        return -1;
    }
    findEventIndex(identifier) {
        const items = this.items;
        if (items) for(let i = items.length; i--;){
            var _items$i$event;
            if (((_items$i$event = items[i].event) == null ? void 0 : _items$i$event.identifier) === identifier) return i;
        }
        return -1;
    }
    findAssetIndex(event, timelinePos) {
        const assetList = event.assetList;
        const length = assetList.length;
        if (length > 1) for(let i = 0; i < length; i++){
            const asset = assetList[i];
            if (!asset.error) {
                const timelineStart = asset.timelineStart;
                if (timelinePos === timelineStart || timelinePos > timelineStart && timelinePos < timelineStart + (asset.duration || 0)) return i;
            }
        }
        return 0;
    }
    get assetIdAtEnd() {
        var _this$items, _this$items2;
        const interstitialAtEnd = (_this$items = this.items) == null ? void 0 : (_this$items2 = _this$items[this.length - 1]) == null ? void 0 : _this$items2.event;
        if (interstitialAtEnd) {
            const assetList = interstitialAtEnd.assetList;
            const assetAtEnd = assetList[assetList.length - 1];
            if (assetAtEnd) return assetAtEnd.identifier;
        }
        return null;
    }
    parseInterstitialDateRanges(mediaSelection, enableAppendInPlace) {
        const details = mediaSelection.main.details;
        const { dateRanges: dateRanges } = details;
        const previousInterstitialEvents = this.events;
        const interstitialEvents = this.parseDateRanges(dateRanges, {
            url: details.url
        }, enableAppendInPlace);
        const ids = Object.keys(dateRanges);
        const removedInterstitials = previousInterstitialEvents ? previousInterstitialEvents.filter((event)=>!ids.includes(event.identifier)) : [];
        if (interstitialEvents.length) // pre-rolls, post-rolls, and events with the same start time are played in playlist tag order
        // all other events are ordered by start time
        interstitialEvents.sort((a, b)=>{
            const aPre = a.cue.pre;
            const aPost = a.cue.post;
            const bPre = b.cue.pre;
            const bPost = b.cue.post;
            if (aPre && !bPre) return -1;
            if (bPre && !aPre) return 1;
            if (aPost && !bPost) return 1;
            if (bPost && !aPost) return -1;
            if (!aPre && !bPre && !aPost && !bPost) {
                const startA = a.startTime;
                const startB = b.startTime;
                if (startA !== startB) return startA - startB;
            }
            return a.dateRange.tagOrder - b.dateRange.tagOrder;
        });
        this.events = interstitialEvents;
        // Clear removed DateRanges from buffered list (kills playback of active Interstitials)
        removedInterstitials.forEach((interstitial)=>{
            this.removeEvent(interstitial);
        });
        this.updateSchedule(mediaSelection, removedInterstitials);
    }
    updateSchedule(mediaSelection, removedInterstitials = []) {
        const events = this.events || [];
        if (events.length || removedInterstitials.length || this.length < 2) {
            const currentItems = this.items;
            const updatedItems = this.parseSchedule(events, mediaSelection);
            const updated = removedInterstitials.length || (currentItems == null ? void 0 : currentItems.length) !== updatedItems.length || updatedItems.some((item, i)=>{
                return Math.abs(item.playout.start - currentItems[i].playout.start) > 0.005 || Math.abs(item.playout.end - currentItems[i].playout.end) > 0.005;
            });
            if (updated) {
                this.items = updatedItems;
                // call interstitials-controller onScheduleUpdated()
                this.onScheduleUpdate(removedInterstitials, currentItems);
            }
        }
    }
    parseDateRanges(dateRanges, baseData, enableAppendInPlace) {
        const interstitialEvents = [];
        const ids = Object.keys(dateRanges);
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const dateRange = dateRanges[id];
            if (dateRange.isInterstitial) {
                let interstitial = this.eventMap[id];
                if (interstitial) // Update InterstitialEvent already parsed and mapped
                // This retains already loaded duration and loaded asset list info
                interstitial.setDateRange(dateRange);
                else {
                    interstitial = new $99a156a15cd35eb3$var$InterstitialEvent(dateRange, baseData);
                    this.eventMap[id] = interstitial;
                    if (enableAppendInPlace === false) interstitial.appendInPlace = enableAppendInPlace;
                }
                interstitialEvents.push(interstitial);
            }
        }
        return interstitialEvents;
    }
    parseSchedule(interstitialEvents, mediaSelection) {
        const schedule = [];
        const details = mediaSelection.main.details;
        const primaryDuration = details.live ? Infinity : details.edge;
        let playoutDuration = 0;
        // Filter events that have errored from the schedule (Primary fallback)
        interstitialEvents = interstitialEvents.filter((event)=>!event.error && !(event.cue.once && event.hasPlayed));
        if (interstitialEvents.length) {
            // Update Schedule
            this.resolveOffsets(interstitialEvents, mediaSelection);
            // Populate Schedule with Interstitial Event and Primary Segment Items
            let primaryPosition = 0;
            let integratedTime = 0;
            interstitialEvents.forEach((interstitial, i)=>{
                const preroll = interstitial.cue.pre;
                const postroll = interstitial.cue.post;
                const previousEvent = interstitialEvents[i - 1] || null;
                const appendInPlace = interstitial.appendInPlace;
                const eventStart = postroll ? primaryDuration : interstitial.startOffset;
                const interstitialDuration = interstitial.duration;
                const timelineDuration = interstitial.timelineOccupancy === $99a156a15cd35eb3$var$TimelineOccupancy.Range ? interstitialDuration : 0;
                const resumptionOffset = interstitial.resumptionOffset;
                const inSameStartTimeSequence = (previousEvent == null ? void 0 : previousEvent.startTime) === eventStart;
                const start = eventStart + interstitial.cumulativeDuration;
                let end = appendInPlace ? start + interstitialDuration : eventStart + resumptionOffset;
                if (preroll || !postroll && eventStart <= 0) {
                    // preroll or in-progress midroll
                    const integratedStart = integratedTime;
                    integratedTime += timelineDuration;
                    interstitial.timelineStart = start;
                    const playoutStart = playoutDuration;
                    playoutDuration += interstitialDuration;
                    schedule.push({
                        event: interstitial,
                        start: start,
                        end: end,
                        playout: {
                            start: playoutStart,
                            end: playoutDuration
                        },
                        integrated: {
                            start: integratedStart,
                            end: integratedTime
                        }
                    });
                } else if (eventStart <= primaryDuration) {
                    if (!inSameStartTimeSequence) {
                        const segmentDuration = eventStart - primaryPosition;
                        // Do not schedule a primary segment if interstitials are abutting by less than ABUTTING_THRESHOLD_SECONDS
                        if (segmentDuration > $99a156a15cd35eb3$var$ABUTTING_THRESHOLD_SECONDS) {
                            // primary segment
                            const timelineStart = primaryPosition;
                            const _integratedStart = integratedTime;
                            integratedTime += segmentDuration;
                            const _playoutStart = playoutDuration;
                            playoutDuration += segmentDuration;
                            const primarySegment = {
                                previousEvent: interstitialEvents[i - 1] || null,
                                nextEvent: interstitial,
                                start: timelineStart,
                                end: timelineStart + segmentDuration,
                                playout: {
                                    start: _playoutStart,
                                    end: playoutDuration
                                },
                                integrated: {
                                    start: _integratedStart,
                                    end: integratedTime
                                }
                            };
                            schedule.push(primarySegment);
                        } else if (segmentDuration > 0 && previousEvent) {
                            // Add previous event `resumeTime` (based on duration or resumeOffset) so that it ends aligned with this one
                            previousEvent.cumulativeDuration += segmentDuration;
                            schedule[schedule.length - 1].end = eventStart;
                        }
                    }
                    // midroll / postroll
                    if (postroll) end = start;
                    interstitial.timelineStart = start;
                    const integratedStart = integratedTime;
                    integratedTime += timelineDuration;
                    const playoutStart = playoutDuration;
                    playoutDuration += interstitialDuration;
                    schedule.push({
                        event: interstitial,
                        start: start,
                        end: end,
                        playout: {
                            start: playoutStart,
                            end: playoutDuration
                        },
                        integrated: {
                            start: integratedStart,
                            end: integratedTime
                        }
                    });
                } else // Interstitial starts after end of primary VOD - not included in schedule
                return;
                const resumeTime = interstitial.resumeTime;
                if (postroll || resumeTime > primaryDuration) primaryPosition = primaryDuration;
                else primaryPosition = resumeTime;
            });
            if (primaryPosition < primaryDuration) {
                var _schedule;
                // last primary segment
                const timelineStart = primaryPosition;
                const integratedStart = integratedTime;
                const segmentDuration = primaryDuration - primaryPosition;
                integratedTime += segmentDuration;
                const playoutStart = playoutDuration;
                playoutDuration += segmentDuration;
                schedule.push({
                    previousEvent: ((_schedule = schedule[schedule.length - 1]) == null ? void 0 : _schedule.event) || null,
                    nextEvent: null,
                    start: primaryPosition,
                    end: timelineStart + segmentDuration,
                    playout: {
                        start: playoutStart,
                        end: playoutDuration
                    },
                    integrated: {
                        start: integratedStart,
                        end: integratedTime
                    }
                });
            }
            this.setDurations(primaryDuration, playoutDuration, integratedTime);
        } else {
            // no interstials - schedule is one primary segment
            const start = 0;
            schedule.push({
                previousEvent: null,
                nextEvent: null,
                start: start,
                end: primaryDuration,
                playout: {
                    start: start,
                    end: primaryDuration
                },
                integrated: {
                    start: start,
                    end: primaryDuration
                }
            });
            this.setDurations(primaryDuration, primaryDuration, primaryDuration);
        }
        return schedule;
    }
    setDurations(primary, playout, integrated) {
        this.durations = {
            primary: primary,
            playout: playout,
            integrated: integrated
        };
    }
    resolveOffsets(interstitialEvents, mediaSelection) {
        const details = mediaSelection.main.details;
        const primaryDuration = details.live ? Infinity : details.edge;
        // First resolve cumulative resumption offsets for Interstitials that start at the same DateTime
        let cumulativeDuration = 0;
        let lastScheduledStart = -1;
        interstitialEvents.forEach((interstitial, i)=>{
            const preroll = interstitial.cue.pre;
            const postroll = interstitial.cue.post;
            const eventStart = preroll ? 0 : postroll ? primaryDuration : interstitial.startTime;
            this.updateAssetDurations(interstitial);
            // X-RESUME-OFFSET values of interstitials scheduled at the same time are cumulative
            const inSameStartTimeSequence = lastScheduledStart === eventStart;
            if (inSameStartTimeSequence) interstitial.cumulativeDuration = cumulativeDuration;
            else {
                cumulativeDuration = 0;
                lastScheduledStart = eventStart;
            }
            if (!postroll && interstitial.snapOptions.in) // FIXME: Include audio playlist in snapping
            interstitial.resumeAnchor = $99a156a15cd35eb3$var$findFragmentByPTS(null, details.fragments, interstitial.startOffset + interstitial.resumptionOffset, 0, 0) || undefined;
            // Check if primary fragments align with resumption offset and disable appendInPlace if they do not
            if (interstitial.appendInPlace && !interstitial.appendInPlaceStarted) {
                const alignedSegmentStart = this.primaryCanResumeInPlaceAt(interstitial, mediaSelection);
                if (!alignedSegmentStart) interstitial.appendInPlace = false;
            }
            if (!interstitial.appendInPlace && i + 1 < interstitialEvents.length) {
                // abutting Interstitials must use the same MediaSource strategy, this applies to all whether or not they are back to back:
                const timeBetween = interstitialEvents[i + 1].startTime - interstitialEvents[i].resumeTime;
                if (timeBetween < $99a156a15cd35eb3$var$ABUTTING_THRESHOLD_SECONDS) {
                    interstitialEvents[i + 1].appendInPlace = false;
                    if (interstitialEvents[i + 1].appendInPlace) this.warn(`Could not change append strategy for abutting event ${interstitial}`);
                }
            }
            // Update cumulativeDuration for next abutting interstitial with the same start date
            const resumeOffset = $99a156a15cd35eb3$var$isFiniteNumber(interstitial.resumeOffset) ? interstitial.resumeOffset : interstitial.duration;
            cumulativeDuration += resumeOffset;
        });
    }
    primaryCanResumeInPlaceAt(interstitial, mediaSelection) {
        const resumeTime = interstitial.resumeTime;
        const resumesInPlaceAt = interstitial.startTime + interstitial.resumptionOffset;
        if (Math.abs(resumeTime - resumesInPlaceAt) > $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS) {
            this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with estimated timeline end ${resumesInPlaceAt}`);
            return false;
        }
        if (!mediaSelection) {
            this.log(`"${interstitial.identifier}" resumption ${resumeTime} can not be aligned with media (none selected)`);
            return false;
        }
        const playlists = Object.keys(mediaSelection);
        return !playlists.some((playlistType)=>{
            const details = mediaSelection[playlistType].details;
            const playlistEnd = details.edge;
            if (resumeTime >= playlistEnd) {
                // Live playback - resumption segments are not yet available
                this.log(`"${interstitial.identifier}" resumption ${resumeTime} past ${playlistType} playlist end ${playlistEnd}`);
                // Assume alignment is possible (or reset can take place)
                return false;
            }
            const startFragment = $99a156a15cd35eb3$var$findFragmentByPTS(null, details.fragments, resumeTime);
            if (!startFragment) {
                this.log(`"${interstitial.identifier}" resumption ${resumeTime} does not align with any fragments in ${playlistType} playlist (${details.fragStart}-${details.fragmentEnd})`);
                return true;
            }
            const allowance = playlistType === 'audio' ? 0.175 : 0;
            const alignedWithSegment = Math.abs(startFragment.start - resumeTime) < $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS + allowance || Math.abs(startFragment.end - resumeTime) < $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS + allowance;
            if (!alignedWithSegment) {
                this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with ${playlistType} fragment bounds (${startFragment.start}-${startFragment.end} sn: ${startFragment.sn} cc: ${startFragment.cc})`);
                return true;
            }
            return false;
        });
    }
    updateAssetDurations(interstitial) {
        if (!interstitial.assetListLoaded) return;
        const eventStart = interstitial.timelineStart;
        let sumDuration = 0;
        let hasUnknownDuration = false;
        let hasErrors = false;
        interstitial.assetList.forEach((asset, i)=>{
            const timelineStart = eventStart + sumDuration;
            asset.startOffset = sumDuration;
            asset.timelineStart = timelineStart;
            hasUnknownDuration || (hasUnknownDuration = asset.duration === null);
            hasErrors || (hasErrors = !!asset.error);
            const duration = asset.error ? 0 : asset.duration || 0;
            sumDuration += duration;
        });
        // Use the sum of known durations when it is greater than the stated duration
        if (hasUnknownDuration && !hasErrors) interstitial.duration = Math.max(sumDuration, interstitial.duration);
        else interstitial.duration = sumDuration;
    }
    removeEvent(interstitial) {
        interstitial.reset();
        delete this.eventMap[interstitial.identifier];
    }
}
function $99a156a15cd35eb3$var$segmentToString(segment) {
    return `[${segment.event ? '"' + segment.event.identifier + '"' : 'primary'}: ${segment.start.toFixed(2)}-${segment.end.toFixed(2)}]`;
}
class $99a156a15cd35eb3$var$AssetListLoader {
    constructor(hls){
        this.hls = void 0;
        this.hls = hls;
    }
    destroy() {
        // @ts-ignore
        this.hls = null;
    }
    loadAssetList(interstitial, hlsStartOffset) {
        const assetListUrl = interstitial.assetListUrl;
        let url;
        try {
            url = $99a156a15cd35eb3$var$getInterstitialUrl(assetListUrl, this.hls.sessionId, interstitial.baseUrl);
        } catch (error) {
            const errorData = this.assignAssetListError(interstitial, $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_LOAD_ERROR, error, assetListUrl);
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, errorData);
            return;
        }
        if (hlsStartOffset && url.protocol !== 'data:') url.searchParams.set('_HLS_start_offset', '' + hlsStartOffset);
        const config = this.hls.config;
        const Loader = config.loader;
        const loader = new Loader(config);
        const context = {
            responseType: 'json',
            url: url.href
        };
        const loadPolicy = config.interstitialAssetListLoadPolicy.default;
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: 0,
            retryDelay: 0,
            maxRetryDelay: 0
        };
        const callbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                const assetListResponse = response.data;
                const assets = assetListResponse == null ? void 0 : assetListResponse.ASSETS;
                if (!Array.isArray(assets)) {
                    const errorData = this.assignAssetListError(interstitial, $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_PARSING_ERROR, new Error(`Invalid interstitial asset list`), context.url, stats, networkDetails);
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, errorData);
                    return;
                }
                interstitial.assetListResponse = assetListResponse;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ASSET_LIST_LOADED, {
                    event: interstitial,
                    assetListResponse: assetListResponse,
                    networkDetails: networkDetails
                });
            },
            onError: (error, context, networkDetails, stats)=>{
                const errorData = this.assignAssetListError(interstitial, $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_LOAD_ERROR, new Error(`Error loading X-ASSET-LIST: HTTP status ${error.code} ${error.text} (${context.url})`), context.url, stats, networkDetails);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, errorData);
            },
            onTimeout: (stats, context, networkDetails)=>{
                const errorData = this.assignAssetListError(interstitial, $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_LOAD_TIMEOUT, new Error(`Timeout loading X-ASSET-LIST (${context.url})`), context.url, stats, networkDetails);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, errorData);
            }
        };
        loader.load(context, loaderConfig, callbacks);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ASSET_LIST_LOADING, {
            event: interstitial
        });
        return loader;
    }
    assignAssetListError(interstitial, details, error, url, stats, networkDetails) {
        interstitial.error = error;
        return {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: details,
            fatal: false,
            interstitial: interstitial,
            url: url,
            error: error,
            networkDetails: networkDetails,
            stats: stats
        };
    }
}
function $99a156a15cd35eb3$var$playWithCatch(media) {
    media == null || media.play().catch(()=>{
    /* no-op */ });
}
class $99a156a15cd35eb3$var$InterstitialsController extends $99a156a15cd35eb3$var$Logger {
    constructor(hls, HlsPlayerClass){
        super('interstitials', hls.logger);
        this.HlsPlayerClass = void 0;
        this.hls = void 0;
        this.assetListLoader = void 0;
        // Last updated LevelDetails
        this.mediaSelection = null;
        this.altSelection = null;
        // Media and MediaSource/SourceBuffers
        this.media = null;
        this.detachedData = null;
        this.requiredTracks = null;
        // Public Interface for Interstitial playback state and control
        this.manager = null;
        // Interstitial Asset Players
        this.playerQueue = [];
        // Timeline position tracking
        this.bufferedPos = -1;
        this.timelinePos = -1;
        // Schedule
        this.schedule = void 0;
        // Schedule playback and buffering state
        this.playingItem = null;
        this.bufferingItem = null;
        this.waitingItem = null;
        this.endedItem = null;
        this.playingAsset = null;
        this.endedAsset = null;
        this.bufferingAsset = null;
        this.shouldPlay = false;
        this.onPlay = ()=>{
            this.shouldPlay = true;
        };
        this.onPause = ()=>{
            this.shouldPlay = false;
        };
        this.onSeeking = ()=>{
            const currentTime = this.currentTime;
            if (currentTime === undefined || this.playbackDisabled) return;
            const diff = currentTime - this.timelinePos;
            const roundingError = Math.abs(diff) < 1 / 705600000; // one flick
            if (roundingError) return;
            const backwardSeek = diff <= -0.01;
            this.timelinePos = currentTime;
            this.bufferedPos = currentTime;
            // Check if seeking out of an item
            const playingItem = this.playingItem;
            if (!playingItem) {
                this.checkBuffer();
                return;
            }
            if (backwardSeek) {
                const resetCount = this.schedule.resetErrorsInRange(currentTime, currentTime - diff);
                if (resetCount) this.updateSchedule();
            }
            this.checkBuffer();
            if (backwardSeek && currentTime < playingItem.start || currentTime >= playingItem.end) {
                var _this$media;
                const scheduleIndex = this.schedule.findItemIndexAtTime(this.timelinePos);
                if (!this.isInterstitial(playingItem) && (_this$media = this.media) != null && _this$media.paused) this.shouldPlay = false;
                if (!backwardSeek) {
                    // check if an Interstitial between the current item and target item has an X-RESTRICT JUMP restriction
                    const playingIndex = this.findItemIndex(playingItem);
                    if (scheduleIndex > playingIndex) {
                        const jumpIndex = this.schedule.findJumpRestrictedIndex(playingIndex + 1, scheduleIndex);
                        if (jumpIndex > playingIndex) {
                            this.setSchedulePosition(jumpIndex);
                            return;
                        }
                    }
                }
                this.setSchedulePosition(scheduleIndex);
                return;
            }
            // Check if seeking out of an asset (assumes same item following above check)
            const playingAsset = this.playingAsset;
            if (!playingAsset) {
                // restart Interstitial at end
                if (this.playingLastItem && this.isInterstitial(playingItem)) {
                    const restartAsset = playingItem.event.assetList[0];
                    if (restartAsset) {
                        this.endedItem = this.playingItem;
                        this.playingItem = null;
                        this.setScheduleToAssetAtTime(currentTime, restartAsset);
                    }
                }
                return;
            }
            const start = playingAsset.timelineStart;
            const duration = playingAsset.duration || 0;
            if (backwardSeek && currentTime < start || currentTime >= start + duration) this.setScheduleToAssetAtTime(currentTime, playingAsset);
        };
        this.onTimeupdate = ()=>{
            const currentTime = this.currentTime;
            if (currentTime === undefined || this.playbackDisabled) return;
            // Only allow timeupdate to advance primary position, seeking is used for jumping back
            // this prevents primaryPos from being reset to 0 after re-attach
            if (currentTime > this.timelinePos) {
                this.timelinePos = currentTime;
                if (currentTime > this.bufferedPos) this.checkBuffer();
            } else return;
            // Check if playback has entered the next item
            const playingItem = this.playingItem;
            if (!playingItem || this.playingLastItem) return;
            if (currentTime >= playingItem.end) {
                this.timelinePos = playingItem.end;
                const playingIndex = this.findItemIndex(playingItem);
                this.setSchedulePosition(playingIndex + 1);
            }
            // Check if playback has entered the next asset
            const playingAsset = this.playingAsset;
            if (!playingAsset) return;
            const end = playingAsset.timelineStart + (playingAsset.duration || 0);
            if (currentTime >= end) this.setScheduleToAssetAtTime(currentTime, playingAsset);
        };
        // Schedule update callback
        this.onScheduleUpdate = (removedInterstitials, previousItems)=>{
            const schedule = this.schedule;
            const playingItem = this.playingItem;
            const interstitialEvents = schedule.events || [];
            const scheduleItems = schedule.items || [];
            const durations = schedule.durations;
            const removedIds = removedInterstitials.map((interstitial)=>interstitial.identifier);
            const interstitialsUpdated = !!(interstitialEvents.length || removedIds.length);
            if (interstitialsUpdated || previousItems) this.log(`INTERSTITIALS_UPDATED (${interstitialEvents.length}): ${interstitialEvents}
Schedule: ${scheduleItems.map((seg)=>$99a156a15cd35eb3$var$segmentToString(seg))} pos: ${this.timelinePos}`);
            if (removedIds.length) this.log(`Removed events ${removedIds}`);
            this.playerQueue.forEach((player)=>{
                if (player.interstitial.appendInPlace) {
                    const timelineStart = player.assetItem.timelineStart;
                    const diff = player.timelineOffset - timelineStart;
                    if (diff) try {
                        player.timelineOffset = timelineStart;
                    } catch (e) {
                        if (Math.abs(diff) > $99a156a15cd35eb3$var$ALIGNED_END_THRESHOLD_SECONDS) this.warn(`${e} ("${player.assetId}" ${player.timelineOffset}->${timelineStart})`);
                    }
                }
            });
            // Update schedule item references
            // Do not replace Interstitial playingItem without a match - used for INTERSTITIAL_ASSET_ENDED and INTERSTITIAL_ENDED
            let trimInPlaceForPlayout = null;
            if (playingItem) {
                const updatedPlayingItem = this.updateItem(playingItem, this.timelinePos);
                if (this.itemsMatch(playingItem, updatedPlayingItem)) {
                    this.playingItem = updatedPlayingItem;
                    this.waitingItem = this.endedItem = null;
                    trimInPlaceForPlayout = ()=>this.trimInPlace(updatedPlayingItem, playingItem);
                }
            } else {
                // Clear waitingItem if it has been removed from the schedule
                this.waitingItem = this.updateItem(this.waitingItem);
                this.endedItem = this.updateItem(this.endedItem);
            }
            // Do not replace Interstitial bufferingItem without a match - used for transfering media element or source
            const bufferingItem = this.bufferingItem;
            if (bufferingItem) {
                const updatedBufferingItem = this.updateItem(bufferingItem, this.bufferedPos);
                if (this.itemsMatch(bufferingItem, updatedBufferingItem)) {
                    this.bufferingItem = updatedBufferingItem;
                    trimInPlaceForPlayout || (trimInPlaceForPlayout = ()=>this.trimInPlace(updatedBufferingItem, bufferingItem));
                } else if (bufferingItem.event) {
                    // Interstitial removed from schedule (Live -> VOD or other scenario where Start Date is outside the range of VOD Playlist)
                    this.bufferingItem = this.playingItem;
                    this.clearInterstitial(bufferingItem.event, null);
                }
            }
            removedInterstitials.forEach((interstitial)=>{
                interstitial.assetList.forEach((asset)=>{
                    this.clearAssetPlayer(asset.identifier, null);
                });
            });
            if (interstitialsUpdated || previousItems) {
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIALS_UPDATED, {
                    events: interstitialEvents.slice(0),
                    schedule: scheduleItems.slice(0),
                    durations: durations,
                    removedIds: removedIds
                });
                if (this.isInterstitial(playingItem) && removedIds.includes(playingItem.event.identifier)) {
                    this.warn(`Interstitial "${playingItem.event.identifier}" removed while playing`);
                    this.primaryFallback(playingItem.event);
                    return;
                }
                if (trimInPlaceForPlayout) trimInPlaceForPlayout();
                // Check is buffered to new Interstitial event boundary
                // (Live update publishes Interstitial with new segment)
                this.checkBuffer();
            }
        };
        this.hls = hls;
        this.HlsPlayerClass = HlsPlayerClass;
        this.assetListLoader = new $99a156a15cd35eb3$var$AssetListLoader(hls);
        this.schedule = new $99a156a15cd35eb3$var$InterstitialsSchedule(this.onScheduleUpdate, hls.logger);
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFERED_TO_END, this.onBufferedToEnd, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ENDED, this.onMediaEnded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFERED_TO_END, this.onBufferedToEnd, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ENDED, this.onMediaEnded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
    }
    startLoad() {
        // TODO: startLoad - check for waitingItem and retry by resetting schedule
        this.resumeBuffering();
    }
    stopLoad() {
        // TODO: stopLoad - stop all scheule.events[].assetListLoader?.abort() then delete the loaders
        this.pauseBuffering();
    }
    resumeBuffering() {
        var _this$getBufferingPla;
        (_this$getBufferingPla = this.getBufferingPlayer()) == null || _this$getBufferingPla.resumeBuffering();
    }
    pauseBuffering() {
        var _this$getBufferingPla2;
        (_this$getBufferingPla2 = this.getBufferingPlayer()) == null || _this$getBufferingPla2.pauseBuffering();
    }
    destroy() {
        this.unregisterListeners();
        this.stopLoad();
        if (this.assetListLoader) this.assetListLoader.destroy();
        this.emptyPlayerQueue();
        this.clearScheduleState();
        if (this.schedule) this.schedule.destroy();
        this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.manager = null;
        // @ts-ignore
        this.hls = this.HlsPlayerClass = this.schedule = this.log = null;
        // @ts-ignore
        this.assetListLoader = null;
        // @ts-ignore
        this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null;
        // @ts-ignore
        this.onScheduleUpdate = null;
    }
    onDestroying() {
        const media = this.primaryMedia || this.media;
        if (media) this.removeMediaListeners(media);
    }
    removeMediaListeners(media) {
        $99a156a15cd35eb3$var$removeEventListener(media, 'play', this.onPlay);
        $99a156a15cd35eb3$var$removeEventListener(media, 'pause', this.onPause);
        $99a156a15cd35eb3$var$removeEventListener(media, 'seeking', this.onSeeking);
        $99a156a15cd35eb3$var$removeEventListener(media, 'timeupdate', this.onTimeupdate);
    }
    onMediaAttaching(event, data) {
        const media = this.media = data.media;
        $99a156a15cd35eb3$var$addEventListener(media, 'seeking', this.onSeeking);
        $99a156a15cd35eb3$var$addEventListener(media, 'timeupdate', this.onTimeupdate);
        $99a156a15cd35eb3$var$addEventListener(media, 'play', this.onPlay);
        $99a156a15cd35eb3$var$addEventListener(media, 'pause', this.onPause);
    }
    onMediaAttached(event, data) {
        const playingItem = this.effectivePlayingItem;
        const detachedMedia = this.detachedData;
        this.detachedData = null;
        if (playingItem === null) this.checkStart();
        else if (!detachedMedia) {
            // Resume schedule after detached externally
            this.clearScheduleState();
            const playingIndex = this.findItemIndex(playingItem);
            this.setSchedulePosition(playingIndex);
        }
    }
    clearScheduleState() {
        this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        const media = this.media;
        this.media = null;
        if (transferringMedia) return;
        if (media) this.removeMediaListeners(media);
        // If detachMedia is called while in an Interstitial, detach the asset player as well and reset the schedule position
        if (this.detachedData) {
            const player = this.getBufferingPlayer();
            if (player) {
                this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null;
                player.detachMedia();
            }
            this.shouldPlay = false;
        }
    }
    get interstitialsManager() {
        if (!this.manager) {
            if (!this.hls) return null;
            const c = this;
            const effectiveBufferingItem = ()=>c.bufferingItem || c.waitingItem;
            const getAssetPlayer = (asset)=>asset ? c.getAssetPlayer(asset.identifier) : asset;
            const getMappedTime = (item, timelineType, asset, controllerField, assetPlayerField)=>{
                if (item) {
                    let time1 = item[timelineType].start;
                    const interstitial = item.event;
                    if (interstitial) {
                        if (timelineType === 'playout' || interstitial.timelineOccupancy !== $99a156a15cd35eb3$var$TimelineOccupancy.Point) {
                            const assetPlayer = getAssetPlayer(asset);
                            if ((assetPlayer == null ? void 0 : assetPlayer.interstitial) === interstitial) time1 += assetPlayer.assetItem.startOffset + assetPlayer[assetPlayerField];
                        }
                    } else {
                        const value = controllerField === 'bufferedPos' ? getBufferedEnd() : c[controllerField];
                        time1 += value - item.start;
                    }
                    return time1;
                }
                return 0;
            };
            const findMappedTime = (primaryTime, timelineType)=>{
                if (primaryTime !== 0 && timelineType !== 'primary' && c.schedule.length) {
                    var _c$schedule$items;
                    const index = c.schedule.findItemIndexAtTime(primaryTime);
                    const item = (_c$schedule$items = c.schedule.items) == null ? void 0 : _c$schedule$items[index];
                    if (item) {
                        const diff = item[timelineType].start - item.start;
                        return primaryTime + diff;
                    }
                }
                return primaryTime;
            };
            const getBufferedEnd = ()=>{
                const value = c.bufferedPos;
                if (value === Number.MAX_VALUE) return getMappedDuration('primary');
                return Math.max(value, 0);
            };
            const getMappedDuration = (timelineType)=>{
                var _c$primaryDetails;
                if ((_c$primaryDetails = c.primaryDetails) != null && _c$primaryDetails.live) // return end of last event item or playlist
                return c.primaryDetails.edge;
                return c.schedule.durations[timelineType];
            };
            const seekTo = (time1, timelineType)=>{
                var _item$event, _c$schedule$items2;
                const item = c.effectivePlayingItem;
                if (item != null && (_item$event = item.event) != null && _item$event.restrictions.skip) return;
                c.log(`seek to ${time1} "${timelineType}"`);
                const playingItem = c.effectivePlayingItem;
                const targetIndex = c.schedule.findItemIndexAtTime(time1, timelineType);
                const targetItem = (_c$schedule$items2 = c.schedule.items) == null ? void 0 : _c$schedule$items2[targetIndex];
                const bufferingPlayer = c.getBufferingPlayer();
                const bufferingInterstitial = bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial;
                const appendInPlace = bufferingInterstitial == null ? void 0 : bufferingInterstitial.appendInPlace;
                const seekInItem = playingItem && c.itemsMatch(playingItem, targetItem);
                if (playingItem && (appendInPlace || seekInItem)) {
                    // seek in asset player or primary media (appendInPlace)
                    const assetPlayer = getAssetPlayer(c.playingAsset);
                    const media = (assetPlayer == null ? void 0 : assetPlayer.media) || c.primaryMedia;
                    if (media) {
                        const currentTime = timelineType === 'primary' ? media.currentTime : getMappedTime(playingItem, timelineType, c.playingAsset, 'timelinePos', 'currentTime');
                        const diff = time1 - currentTime;
                        const seekToTime = (appendInPlace ? currentTime : media.currentTime) + diff;
                        if (seekToTime >= 0 && (!assetPlayer || appendInPlace || seekToTime <= assetPlayer.duration)) {
                            media.currentTime = seekToTime;
                            return;
                        }
                    }
                }
                // seek out of item or asset
                if (targetItem) {
                    let seekToTime = time1;
                    if (timelineType !== 'primary') {
                        const primarySegmentStart = targetItem[timelineType].start;
                        const diff = time1 - primarySegmentStart;
                        seekToTime = targetItem.start + diff;
                    }
                    const targetIsPrimary = !c.isInterstitial(targetItem);
                    if ((!c.isInterstitial(playingItem) || playingItem.event.appendInPlace) && (targetIsPrimary || targetItem.event.appendInPlace)) {
                        const media = c.media || (appendInPlace ? bufferingPlayer == null ? void 0 : bufferingPlayer.media : null);
                        if (media) media.currentTime = seekToTime;
                    } else if (playingItem) {
                        // check if an Interstitial between the current item and target item has an X-RESTRICT JUMP restriction
                        const playingIndex = c.findItemIndex(playingItem);
                        if (targetIndex > playingIndex) {
                            const jumpIndex = c.schedule.findJumpRestrictedIndex(playingIndex + 1, targetIndex);
                            if (jumpIndex > playingIndex) {
                                c.setSchedulePosition(jumpIndex);
                                return;
                            }
                        }
                        let assetIndex = 0;
                        if (targetIsPrimary) {
                            c.timelinePos = seekToTime;
                            c.checkBuffer();
                        } else {
                            var _targetItem$event;
                            const assetList = targetItem == null ? void 0 : (_targetItem$event = targetItem.event) == null ? void 0 : _targetItem$event.assetList;
                            if (assetList) {
                                const eventTime = time1 - (targetItem[timelineType] || targetItem).start;
                                for(let i = assetList.length; i--;){
                                    const asset = assetList[i];
                                    if (asset.duration && eventTime >= asset.startOffset && eventTime < asset.startOffset + asset.duration) {
                                        assetIndex = i;
                                        break;
                                    }
                                }
                            }
                        }
                        c.setSchedulePosition(targetIndex, assetIndex);
                    }
                }
            };
            const getActiveInterstitial = ()=>{
                const playingItem = c.effectivePlayingItem;
                if (c.isInterstitial(playingItem)) return playingItem;
                const bufferingItem = effectiveBufferingItem();
                if (c.isInterstitial(bufferingItem)) return bufferingItem;
                return null;
            };
            const interstitialPlayer = {
                get currentTime () {
                    const interstitialItem = getActiveInterstitial();
                    const playingItem = c.effectivePlayingItem;
                    if (playingItem && playingItem === interstitialItem) return getMappedTime(playingItem, 'playout', c.effectivePlayingAsset, 'timelinePos', 'currentTime') - playingItem.playout.start;
                    return 0;
                },
                set currentTime (time){
                    const interstitialItem = getActiveInterstitial();
                    const playingItem = c.effectivePlayingItem;
                    if (playingItem && playingItem === interstitialItem) seekTo(time + playingItem.playout.start, 'playout');
                },
                get duration () {
                    const interstitialItem = getActiveInterstitial();
                    if (interstitialItem) return interstitialItem.playout.end - interstitialItem.playout.start;
                    return 0;
                },
                get assetPlayers () {
                    var _getActiveInterstitia;
                    const assetList = (_getActiveInterstitia = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia.event.assetList;
                    if (assetList) return assetList.map((asset)=>c.getAssetPlayer(asset.identifier));
                    return [];
                },
                get playingIndex () {
                    var _getActiveInterstitia2;
                    const interstitial = (_getActiveInterstitia2 = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia2.event;
                    if (interstitial && c.effectivePlayingAsset) return interstitial.findAssetIndex(c.effectivePlayingAsset);
                    return -1;
                },
                get scheduleItem () {
                    return getActiveInterstitial();
                }
            };
            this.manager = {
                get events () {
                    var _c$schedule, _c$schedule$events;
                    return ((_c$schedule = c.schedule) == null ? void 0 : (_c$schedule$events = _c$schedule.events) == null ? void 0 : _c$schedule$events.slice(0)) || [];
                },
                get schedule () {
                    var _c$schedule2, _c$schedule2$items;
                    return ((_c$schedule2 = c.schedule) == null ? void 0 : (_c$schedule2$items = _c$schedule2.items) == null ? void 0 : _c$schedule2$items.slice(0)) || [];
                },
                get interstitialPlayer () {
                    if (getActiveInterstitial()) return interstitialPlayer;
                    return null;
                },
                get playerQueue () {
                    return c.playerQueue.slice(0);
                },
                get bufferingAsset () {
                    return c.bufferingAsset;
                },
                get bufferingItem () {
                    return effectiveBufferingItem();
                },
                get bufferingIndex () {
                    const item = effectiveBufferingItem();
                    return c.findItemIndex(item);
                },
                get playingAsset () {
                    return c.effectivePlayingAsset;
                },
                get playingItem () {
                    return c.effectivePlayingItem;
                },
                get playingIndex () {
                    const item = c.effectivePlayingItem;
                    return c.findItemIndex(item);
                },
                primary: {
                    get bufferedEnd () {
                        return getBufferedEnd();
                    },
                    get currentTime () {
                        const timelinePos = c.timelinePos;
                        return timelinePos > 0 ? timelinePos : 0;
                    },
                    set currentTime (time){
                        seekTo(time, 'primary');
                    },
                    get duration () {
                        return getMappedDuration('primary');
                    },
                    get seekableStart () {
                        var _c$primaryDetails2;
                        return ((_c$primaryDetails2 = c.primaryDetails) == null ? void 0 : _c$primaryDetails2.fragmentStart) || 0;
                    }
                },
                integrated: {
                    get bufferedEnd () {
                        return getMappedTime(effectiveBufferingItem(), 'integrated', c.bufferingAsset, 'bufferedPos', 'bufferedEnd');
                    },
                    get currentTime () {
                        return getMappedTime(c.effectivePlayingItem, 'integrated', c.effectivePlayingAsset, 'timelinePos', 'currentTime');
                    },
                    set currentTime (time){
                        seekTo(time, 'integrated');
                    },
                    get duration () {
                        return getMappedDuration('integrated');
                    },
                    get seekableStart () {
                        var _c$primaryDetails3;
                        return findMappedTime(((_c$primaryDetails3 = c.primaryDetails) == null ? void 0 : _c$primaryDetails3.fragmentStart) || 0, 'integrated');
                    }
                },
                skip: ()=>{
                    const item = c.effectivePlayingItem;
                    const event = item == null ? void 0 : item.event;
                    if (event && !event.restrictions.skip) {
                        const index = c.findItemIndex(item);
                        if (event.appendInPlace) {
                            const time1 = item.playout.start + item.event.duration;
                            seekTo(time1 + 0.001, 'playout');
                        } else c.advanceAfterAssetEnded(event, index, Infinity);
                    }
                }
            };
        }
        return this.manager;
    }
    // Schedule getters
    get effectivePlayingItem() {
        return this.waitingItem || this.playingItem || this.endedItem;
    }
    get effectivePlayingAsset() {
        return this.playingAsset || this.endedAsset;
    }
    get playingLastItem() {
        var _this$schedule;
        const playingItem = this.playingItem;
        const items = (_this$schedule = this.schedule) == null ? void 0 : _this$schedule.items;
        if (!this.playbackStarted || !playingItem || !items) return false;
        return this.findItemIndex(playingItem) === items.length - 1;
    }
    get playbackStarted() {
        return this.effectivePlayingItem !== null;
    }
    // Media getters and event callbacks
    get currentTime() {
        var _this$bufferingItem, _this$bufferingItem$e, _media;
        if (this.mediaSelection === null) // Do not advance before schedule is known
        return undefined;
        // Ignore currentTime when detached for Interstitial playback with source reset
        const queuedForPlayback = this.waitingItem || this.playingItem;
        if (this.isInterstitial(queuedForPlayback) && !queuedForPlayback.event.appendInPlace) return undefined;
        let media = this.media;
        if (!media && (_this$bufferingItem = this.bufferingItem) != null && (_this$bufferingItem$e = _this$bufferingItem.event) != null && _this$bufferingItem$e.appendInPlace) // Observe detached media currentTime when appending in place
        media = this.primaryMedia;
        const currentTime = (_media = media) == null ? void 0 : _media.currentTime;
        if (currentTime === undefined || !$99a156a15cd35eb3$var$isFiniteNumber(currentTime)) return undefined;
        return currentTime;
    }
    get primaryMedia() {
        var _this$detachedData;
        return this.media || ((_this$detachedData = this.detachedData) == null ? void 0 : _this$detachedData.media) || null;
    }
    isInterstitial(item) {
        return !!(item != null && item.event);
    }
    retreiveMediaSource(assetId, toSegment) {
        const player = this.getAssetPlayer(assetId);
        if (player) this.transferMediaFromPlayer(player, toSegment);
    }
    transferMediaFromPlayer(player, toSegment) {
        const appendInPlace = player.interstitial.appendInPlace;
        const playerMedia = player.media;
        if (appendInPlace && playerMedia === this.primaryMedia) {
            this.bufferingAsset = null;
            if (!toSegment || this.isInterstitial(toSegment) && !toSegment.event.appendInPlace) // MediaSource cannot be transfered back to an Interstitial that requires a source reset
            // no-op when toSegment is undefined
            {
                if (toSegment && playerMedia) {
                    this.detachedData = {
                        media: playerMedia
                    };
                    return;
                }
            }
            const attachMediaSourceData = player.transferMedia();
            this.log(`transfer MediaSource from ${player} ${$99a156a15cd35eb3$var$stringify(attachMediaSourceData)}`);
            this.detachedData = attachMediaSourceData;
        } else if (toSegment && playerMedia) this.shouldPlay || (this.shouldPlay = !playerMedia.paused);
    }
    transferMediaTo(player, media) {
        var _this$detachedData2, _attachMediaSourceDat;
        if (player.media === media) return;
        let attachMediaSourceData = null;
        const primaryPlayer = this.hls;
        const isAssetPlayer = player !== primaryPlayer;
        const appendInPlace = isAssetPlayer && player.interstitial.appendInPlace;
        const detachedMediaSource = (_this$detachedData2 = this.detachedData) == null ? void 0 : _this$detachedData2.mediaSource;
        let logFromSource;
        if (primaryPlayer.media) {
            if (appendInPlace) {
                attachMediaSourceData = primaryPlayer.transferMedia();
                this.detachedData = attachMediaSourceData;
            }
            logFromSource = `Primary`;
        } else if (detachedMediaSource) {
            const bufferingPlayer = this.getBufferingPlayer();
            if (bufferingPlayer) {
                attachMediaSourceData = bufferingPlayer.transferMedia();
                logFromSource = `${bufferingPlayer}`;
            } else logFromSource = `detached MediaSource`;
        } else logFromSource = `detached media`;
        if (!attachMediaSourceData) {
            if (detachedMediaSource) {
                attachMediaSourceData = this.detachedData;
                this.log(`using detachedData: MediaSource ${$99a156a15cd35eb3$var$stringify(attachMediaSourceData)}`);
            } else if (!this.detachedData || primaryPlayer.media === media) {
                // Keep interstitial media transition consistent
                const playerQueue = this.playerQueue;
                if (playerQueue.length > 1) playerQueue.forEach((queuedPlayer)=>{
                    if (isAssetPlayer && queuedPlayer.interstitial.appendInPlace !== appendInPlace) {
                        const interstitial = queuedPlayer.interstitial;
                        this.clearInterstitial(queuedPlayer.interstitial, null);
                        interstitial.appendInPlace = false;
                        if (interstitial.appendInPlace) this.warn(`Could not change append strategy for queued assets ${interstitial}`);
                    }
                });
                this.hls.detachMedia();
                this.detachedData = {
                    media: media
                };
            }
        }
        const transferring = attachMediaSourceData && 'mediaSource' in attachMediaSourceData && ((_attachMediaSourceDat = attachMediaSourceData.mediaSource) == null ? void 0 : _attachMediaSourceDat.readyState) !== 'closed';
        const dataToAttach = transferring && attachMediaSourceData ? attachMediaSourceData : media;
        this.log(`${transferring ? 'transfering MediaSource' : 'attaching media'} to ${isAssetPlayer ? player : 'Primary'} from ${logFromSource}`);
        if (dataToAttach === attachMediaSourceData) {
            const isAssetAtEndOfSchedule = isAssetPlayer && player.assetId === this.schedule.assetIdAtEnd;
            // Prevent asset players from marking EoS on transferred MediaSource
            dataToAttach.overrides = {
                duration: this.schedule.duration,
                endOfStream: !isAssetPlayer || isAssetAtEndOfSchedule,
                cueRemoval: !isAssetPlayer
            };
        }
        player.attachMedia(dataToAttach);
    }
    onInterstitialCueEnter() {
        this.onTimeupdate();
    }
    // Scheduling methods
    checkStart() {
        const schedule = this.schedule;
        const interstitialEvents = schedule.events;
        if (!interstitialEvents || this.playbackDisabled || !this.media) return;
        // Check buffered to pre-roll
        if (this.bufferedPos === -1) this.bufferedPos = 0;
        // Start stepping through schedule when playback begins for the first time and we have a pre-roll
        const timelinePos = this.timelinePos;
        const effectivePlayingItem = this.effectivePlayingItem;
        if (timelinePos === -1) {
            const startPosition = this.hls.startPosition;
            this.timelinePos = startPosition;
            if (interstitialEvents.length && interstitialEvents[0].cue.pre) {
                const index = schedule.findEventIndex(interstitialEvents[0].identifier);
                this.setSchedulePosition(index);
            } else if (startPosition >= 0 || !this.primaryLive) {
                const start = this.timelinePos = startPosition > 0 ? startPosition : 0;
                const index = schedule.findItemIndexAtTime(start);
                this.setSchedulePosition(index);
            }
        } else if (effectivePlayingItem && !this.playingItem) {
            const index = schedule.findItemIndex(effectivePlayingItem);
            this.setSchedulePosition(index);
        }
    }
    advanceAfterAssetEnded(interstitial, index, assetListIndex) {
        const nextAssetIndex = $99a156a15cd35eb3$var$getNextAssetIndex(interstitial, assetListIndex);
        if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) // Advance to next asset list item
        this.setSchedulePosition(index, nextAssetIndex);
        else {
            // Advance to next schedule segment
            // check if we've reached the end of the program
            const scheduleItems = this.schedule.items;
            if (scheduleItems) {
                const nextIndex = index + 1;
                const scheduleLength = scheduleItems.length;
                if (nextIndex >= scheduleLength) {
                    this.setSchedulePosition(-1);
                    return;
                }
                const resumptionTime = interstitial.resumeTime;
                if (this.timelinePos < resumptionTime) {
                    this.timelinePos = resumptionTime;
                    this.checkBuffer();
                }
                this.setSchedulePosition(nextIndex);
            }
        }
    }
    setScheduleToAssetAtTime(time1, playingAsset) {
        const schedule = this.schedule;
        const parentIdentifier = playingAsset.parentIdentifier;
        const interstitial = schedule.getEvent(parentIdentifier);
        if (interstitial) {
            const itemIndex = schedule.findEventIndex(parentIdentifier);
            const assetListIndex = schedule.findAssetIndex(interstitial, time1);
            this.advanceAfterAssetEnded(interstitial, itemIndex, assetListIndex - 1);
        }
    }
    setSchedulePosition(index, assetListIndex) {
        const scheduleItems = this.schedule.items;
        if (!scheduleItems || this.playbackDisabled) return;
        this.log(`setSchedulePosition ${index}, ${assetListIndex}`);
        const scheduledItem = index >= 0 ? scheduleItems[index] : null;
        // Cleanup current item / asset
        const currentItem = this.playingItem;
        const playingLastItem = this.playingLastItem;
        if (this.isInterstitial(currentItem)) {
            var _interstitial$assetLi;
            const interstitial = currentItem.event;
            const playingAsset = this.playingAsset;
            const assetId = playingAsset == null ? void 0 : playingAsset.identifier;
            const player = assetId ? this.getAssetPlayer(assetId) : null;
            if (player && assetId && (!this.eventItemsMatch(currentItem, scheduledItem) || assetListIndex !== undefined && assetId !== ((_interstitial$assetLi = interstitial.assetList) == null ? void 0 : _interstitial$assetLi[assetListIndex].identifier))) {
                var _this$detachedData3;
                const playingAssetListIndex = interstitial.findAssetIndex(playingAsset);
                this.log(`INTERSTITIAL_ASSET_ENDED ${playingAssetListIndex + 1}/${interstitial.assetList.length} ${$99a156a15cd35eb3$var$eventAssetToString(playingAsset)}`);
                this.endedAsset = playingAsset;
                this.playingAsset = null;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIAL_ASSET_ENDED, {
                    asset: playingAsset,
                    assetListIndex: playingAssetListIndex,
                    event: interstitial,
                    schedule: scheduleItems.slice(0),
                    scheduleIndex: index,
                    player: player
                });
                this.retreiveMediaSource(assetId, scheduledItem);
                if (player.media && !((_this$detachedData3 = this.detachedData) != null && _this$detachedData3.mediaSource)) player.detachMedia();
            }
            if (!this.eventItemsMatch(currentItem, scheduledItem)) {
                this.endedItem = currentItem;
                this.playingItem = null;
                this.log(`INTERSTITIAL_ENDED ${interstitial} ${$99a156a15cd35eb3$var$segmentToString(currentItem)}`);
                interstitial.hasPlayed = true;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIAL_ENDED, {
                    event: interstitial,
                    schedule: scheduleItems.slice(0),
                    scheduleIndex: index
                });
                // Exiting an Interstitial
                if (interstitial.cue.once) {
                    // Remove interstitial with CUE attribute value of ONCE after it has played
                    this.updateSchedule();
                    const items = this.schedule.items;
                    if (scheduledItem && items) {
                        const updatedIndex = this.schedule.findItemIndex(scheduledItem);
                        this.advanceSchedule(updatedIndex, items, assetListIndex, currentItem, playingLastItem);
                    }
                    return;
                }
            }
        }
        this.advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playingLastItem);
    }
    advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playedLastItem) {
        const scheduledItem = index >= 0 ? scheduleItems[index] : null;
        const media = this.primaryMedia;
        // Cleanup out of range Interstitials
        const playerQueue = this.playerQueue;
        if (playerQueue.length) playerQueue.forEach((player)=>{
            const interstitial = player.interstitial;
            const queuedIndex = this.schedule.findEventIndex(interstitial.identifier);
            if (queuedIndex < index || queuedIndex > index + 1) this.clearInterstitial(interstitial, scheduledItem);
        });
        // Setup scheduled item
        if (this.isInterstitial(scheduledItem)) {
            this.timelinePos = Math.min(Math.max(this.timelinePos, scheduledItem.start), scheduledItem.end);
            // Handle Interstitial
            const interstitial = scheduledItem.event;
            // find asset index
            if (assetListIndex === undefined) {
                assetListIndex = this.schedule.findAssetIndex(interstitial, this.timelinePos);
                const assetIndexCandidate = $99a156a15cd35eb3$var$getNextAssetIndex(interstitial, assetListIndex - 1);
                if (interstitial.isAssetPastPlayoutLimit(assetIndexCandidate)) {
                    this.advanceAfterAssetEnded(interstitial, index, assetListIndex);
                    return;
                }
                assetListIndex = assetIndexCandidate;
            }
            // Ensure Interstitial is enqueued
            const waitingItem = this.waitingItem;
            if (!this.assetsBuffered(scheduledItem, media)) this.setBufferingItem(scheduledItem);
            let player = this.preloadAssets(interstitial, assetListIndex);
            if (!this.eventItemsMatch(scheduledItem, waitingItem || currentItem)) {
                this.waitingItem = scheduledItem;
                this.log(`INTERSTITIAL_STARTED ${$99a156a15cd35eb3$var$segmentToString(scheduledItem)} ${interstitial.appendInPlace ? 'append in place' : ''}`);
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIAL_STARTED, {
                    event: interstitial,
                    schedule: scheduleItems.slice(0),
                    scheduleIndex: index
                });
            }
            if (!interstitial.assetListLoaded) {
                // Waiting at end of primary content segment
                // Expect setSchedulePosition to be called again once ASSET-LIST is loaded
                this.log(`Waiting for ASSET-LIST to complete loading ${interstitial}`);
                return;
            }
            if (interstitial.assetListLoader) {
                interstitial.assetListLoader.destroy();
                interstitial.assetListLoader = undefined;
            }
            if (!media) {
                this.log(`Waiting for attachMedia to start Interstitial ${interstitial}`);
                return;
            }
            // Update schedule and asset list position now that it can start
            this.waitingItem = this.endedItem = null;
            this.playingItem = scheduledItem;
            // If asset-list is empty or missing asset index, advance to next item
            const assetItem = interstitial.assetList[assetListIndex];
            if (!assetItem) {
                const nextItem = scheduleItems[index + 1];
                const _media2 = this.media;
                if (nextItem && _media2 && !this.isInterstitial(nextItem) && _media2.currentTime < nextItem.start) _media2.currentTime = this.timelinePos = nextItem.start;
                this.advanceAfterAssetEnded(interstitial, index, assetListIndex || 0);
                return;
            }
            // Start Interstitial Playback
            if (!player) player = this.getAssetPlayer(assetItem.identifier);
            if (player === null || player.destroyed) {
                const assetListLength = interstitial.assetList.length;
                this.warn(`asset ${assetListIndex + 1}/${assetListLength} player destroyed ${interstitial}`);
                player = this.createAssetPlayer(interstitial, assetItem, assetListIndex);
            }
            if (!this.eventItemsMatch(scheduledItem, this.bufferingItem)) {
                if (interstitial.appendInPlace && this.isAssetBuffered(assetItem)) return;
            }
            this.startAssetPlayer(player, assetListIndex, scheduleItems, index, media);
            if (this.shouldPlay) $99a156a15cd35eb3$var$playWithCatch(player.media);
        } else if (scheduledItem !== null) {
            this.resumePrimary(scheduledItem, index, currentItem);
            if (this.shouldPlay) $99a156a15cd35eb3$var$playWithCatch(this.hls.media);
        } else if (playedLastItem && this.isInterstitial(currentItem)) {
            // Maintain playingItem state at end of schedule (setSchedulePosition(-1) called to end program)
            // this allows onSeeking handler to update schedule position
            this.endedItem = null;
            this.playingItem = currentItem;
            if (!currentItem.event.appendInPlace) // Media must be re-attached to resume primary schedule if not sharing source
            this.attachPrimary(this.schedule.durations.primary, null);
        }
    }
    get playbackDisabled() {
        return this.hls.config.enableInterstitialPlayback === false;
    }
    get primaryDetails() {
        var _this$mediaSelection, _this$mediaSelection$;
        return (_this$mediaSelection = this.mediaSelection) == null ? void 0 : (_this$mediaSelection$ = _this$mediaSelection.main) == null ? void 0 : _this$mediaSelection$.details;
    }
    get primaryLive() {
        var _this$primaryDetails;
        return !!((_this$primaryDetails = this.primaryDetails) != null && _this$primaryDetails.live);
    }
    resumePrimary(scheduledItem, index, fromItem) {
        var _this$detachedData4;
        this.playingItem = scheduledItem;
        this.playingAsset = this.endedAsset = null;
        this.waitingItem = this.endedItem = null;
        this.bufferedToItem(scheduledItem);
        this.log(`resuming ${$99a156a15cd35eb3$var$segmentToString(scheduledItem)}`);
        if (!((_this$detachedData4 = this.detachedData) != null && _this$detachedData4.mediaSource)) {
            let timelinePos = this.timelinePos;
            if (timelinePos < scheduledItem.start || timelinePos >= scheduledItem.end) {
                timelinePos = this.getPrimaryResumption(scheduledItem, index);
                this.timelinePos = timelinePos;
            }
            this.attachPrimary(timelinePos, scheduledItem);
        }
        if (!fromItem) return;
        const scheduleItems = this.schedule.items;
        if (!scheduleItems) return;
        this.log(`INTERSTITIALS_PRIMARY_RESUMED ${$99a156a15cd35eb3$var$segmentToString(scheduledItem)}`);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIALS_PRIMARY_RESUMED, {
            schedule: scheduleItems.slice(0),
            scheduleIndex: index
        });
        this.checkBuffer();
    }
    getPrimaryResumption(scheduledItem, index) {
        const itemStart = scheduledItem.start;
        if (this.primaryLive) {
            const details = this.primaryDetails;
            if (index === 0) return this.hls.startPosition;
            else if (details && (itemStart < details.fragmentStart || itemStart > details.edge)) return this.hls.liveSyncPosition || -1;
        }
        return itemStart;
    }
    isAssetBuffered(asset) {
        const player = this.getAssetPlayer(asset.identifier);
        if (player != null && player.hls) return player.hls.bufferedToEnd;
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
        return bufferInfo.end + 1 >= asset.timelineStart + (asset.duration || 0);
    }
    attachPrimary(timelinePos, item, skipSeekToStartPosition) {
        if (item) this.setBufferingItem(item);
        else this.bufferingItem = this.playingItem;
        this.bufferingAsset = null;
        const media = this.primaryMedia;
        if (!media) return;
        const hls = this.hls;
        if (hls.media) this.checkBuffer();
        else {
            this.transferMediaTo(hls, media);
            if (skipSeekToStartPosition) this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
        }
        if (!skipSeekToStartPosition) {
            // Set primary position to resume time
            this.timelinePos = timelinePos;
            this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
        }
    }
    startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition) {
        var _hls$mainForwardBuffe;
        const hls = this.hls;
        if (!hls.loadingEnabled || !hls.media || Math.abs((((_hls$mainForwardBuffe = hls.mainForwardBufferInfo) == null ? void 0 : _hls$mainForwardBuffe.start) || hls.media.currentTime) - timelinePos) > 0.5) hls.startLoad(timelinePos, skipSeekToStartPosition);
        else if (!hls.bufferingEnabled) hls.resumeBuffering();
    }
    // HLS.js event callbacks
    onManifestLoading() {
        this.stopLoad();
        this.schedule.reset();
        this.emptyPlayerQueue();
        this.clearScheduleState();
        this.shouldPlay = false;
        this.bufferedPos = this.timelinePos = -1;
        this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null;
        // BUFFER_CODECS listener added here for buffer-controller to handle it first where it adds tracks
        this.hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        this.hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
    }
    onLevelUpdated(event, data) {
        if (data.level === -1) // level was removed
        return;
        const main = this.hls.levels[data.level];
        const currentSelection = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, this.mediaSelection || this.altSelection), {}, {
            main: main
        });
        this.mediaSelection = currentSelection;
        this.schedule.parseInterstitialDateRanges(currentSelection, this.hls.config.interstitialAppendInPlace);
        if (!this.effectivePlayingItem && this.schedule.items) this.checkStart();
    }
    onAudioTrackUpdated(event, data) {
        const audio = this.hls.audioTracks[data.id];
        const previousSelection = this.mediaSelection;
        if (!previousSelection) {
            this.altSelection = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, this.altSelection), {}, {
                audio: audio
            });
            return;
        }
        const currentSelection = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, previousSelection), {}, {
            audio: audio
        });
        this.mediaSelection = currentSelection;
    }
    onSubtitleTrackUpdated(event, data) {
        const subtitles = this.hls.subtitleTracks[data.id];
        const previousSelection = this.mediaSelection;
        if (!previousSelection) {
            this.altSelection = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, this.altSelection), {}, {
                subtitles: subtitles
            });
            return;
        }
        const currentSelection = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, previousSelection), {}, {
            subtitles: subtitles
        });
        this.mediaSelection = currentSelection;
    }
    onAudioTrackSwitching(event, data) {
        const audioOption = $99a156a15cd35eb3$var$getBasicSelectionOption(data);
        this.playerQueue.forEach((player)=>player.hls.setAudioOption(data) || player.hls.setAudioOption(audioOption));
    }
    onSubtitleTrackSwitch(event, data) {
        const subtitleOption = $99a156a15cd35eb3$var$getBasicSelectionOption(data);
        this.playerQueue.forEach((player)=>player.hls.setSubtitleOption(data) || data.id !== -1 && player.hls.setSubtitleOption(subtitleOption));
    }
    onBufferCodecs(event, data) {
        const requiredTracks = data.tracks;
        if (requiredTracks) this.requiredTracks = requiredTracks;
    }
    onBufferAppended(event, data) {
        this.checkBuffer();
    }
    onBufferFlushed(event, data) {
        const playingItem = this.playingItem;
        if (playingItem && !this.itemsMatch(playingItem, this.bufferingItem) && !this.isInterstitial(playingItem)) {
            const timelinePos = this.timelinePos;
            this.bufferedPos = timelinePos;
            this.checkBuffer();
        }
    }
    onBufferedToEnd(event) {
        // Buffered to post-roll
        const interstitialEvents = this.schedule.events;
        if (this.bufferedPos < Number.MAX_VALUE && interstitialEvents) {
            for(let i = 0; i < interstitialEvents.length; i++){
                const interstitial = interstitialEvents[i];
                if (interstitial.cue.post) {
                    var _this$schedule$items;
                    const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
                    const item = (_this$schedule$items = this.schedule.items) == null ? void 0 : _this$schedule$items[scheduleIndex];
                    if (this.isInterstitial(item) && this.eventItemsMatch(item, this.bufferingItem)) this.bufferedToItem(item, 0);
                    break;
                }
            }
            this.bufferedPos = Number.MAX_VALUE;
        }
    }
    onMediaEnded(event) {
        const playingItem = this.playingItem;
        if (!this.playingLastItem && playingItem) {
            const playingIndex = this.findItemIndex(playingItem);
            this.setSchedulePosition(playingIndex + 1);
        } else this.shouldPlay = false;
    }
    updateItem(previousItem, time1) {
        // find item in this.schedule.items;
        const items = this.schedule.items;
        if (previousItem && items) {
            const index = this.findItemIndex(previousItem, time1);
            return items[index] || null;
        }
        return null;
    }
    trimInPlace(updatedItem, itemBeforeUpdate) {
        if (this.isInterstitial(updatedItem) && updatedItem.event.appendInPlace && itemBeforeUpdate.end - updatedItem.end > 0.25) {
            updatedItem.event.assetList.forEach((asset, index)=>{
                if (updatedItem.event.isAssetPastPlayoutLimit(index)) this.clearAssetPlayer(asset.identifier, null);
            });
            const flushStart = updatedItem.end + 0.25;
            const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(this.primaryMedia, flushStart, 0);
            if (bufferInfo.end > flushStart || (bufferInfo.nextStart || 0) > flushStart) {
                this.attachPrimary(flushStart, null);
                this.flushFrontBuffer(flushStart);
            }
        }
    }
    itemsMatch(a, b) {
        return !!b && (a === b || a.event && b.event && this.eventItemsMatch(a, b) || !a.event && !b.event && this.findItemIndex(a) === this.findItemIndex(b));
    }
    eventItemsMatch(a, b) {
        var _b$event;
        return !!b && (a === b || a.event.identifier === ((_b$event = b.event) == null ? void 0 : _b$event.identifier));
    }
    findItemIndex(item, time1) {
        return item ? this.schedule.findItemIndex(item, time1) : -1;
    }
    updateSchedule() {
        const mediaSelection = this.mediaSelection;
        if (!mediaSelection) return;
        this.schedule.updateSchedule(mediaSelection, []);
    }
    // Schedule buffer control
    checkBuffer(starved) {
        const items = this.schedule.items;
        if (!items) return;
        // Find when combined forward buffer change reaches next schedule segment
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
        if (starved) this.bufferedPos = this.timelinePos;
        starved || (starved = bufferInfo.len < 1);
        this.updateBufferedPos(bufferInfo.end, items, starved);
    }
    updateBufferedPos(bufferEnd, items, bufferIsEmpty) {
        const schedule = this.schedule;
        const bufferingItem = this.bufferingItem;
        if (this.bufferedPos > bufferEnd) return;
        if (items.length === 1 && this.itemsMatch(items[0], bufferingItem)) {
            this.bufferedPos = bufferEnd;
            return;
        }
        const playingItem = this.playingItem;
        const playingIndex = this.findItemIndex(playingItem);
        let bufferEndIndex = schedule.findItemIndexAtTime(bufferEnd);
        if (this.bufferedPos < bufferEnd) {
            var _nextItemToBuffer$eve, _bufferingItem$event;
            const bufferingIndex = this.findItemIndex(bufferingItem);
            const nextToBufferIndex = Math.min(bufferingIndex + 1, items.length - 1);
            const nextItemToBuffer = items[nextToBufferIndex];
            if (bufferEndIndex === -1 && bufferingItem && bufferEnd >= bufferingItem.end || (_nextItemToBuffer$eve = nextItemToBuffer.event) != null && _nextItemToBuffer$eve.appendInPlace && bufferEnd + 0.01 >= nextItemToBuffer.start) bufferEndIndex = nextToBufferIndex;
            if (nextToBufferIndex - playingIndex > 1 && (bufferingItem == null ? void 0 : (_bufferingItem$event = bufferingItem.event) == null ? void 0 : _bufferingItem$event.appendInPlace) === false) // do not advance buffering item past Interstitial that requires source reset
            return;
            this.bufferedPos = bufferEnd;
            if (bufferEndIndex > bufferingIndex && bufferEndIndex > playingIndex) this.bufferedToItem(nextItemToBuffer);
            else {
                // allow more time than distance from edge for assets to load
                const details = this.primaryDetails;
                if (this.primaryLive && details && bufferEnd > details.edge - details.targetduration && nextItemToBuffer.start < details.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(nextItemToBuffer)) this.preloadAssets(nextItemToBuffer.event, 0);
            }
        } else if (bufferIsEmpty && playingItem && !this.itemsMatch(playingItem, bufferingItem)) {
            if (bufferEndIndex === playingIndex) this.bufferedToItem(playingItem);
            else if (bufferEndIndex === playingIndex + 1) this.bufferedToItem(items[bufferEndIndex]);
        }
    }
    assetsBuffered(item, media) {
        const assetList = item.event.assetList;
        if (assetList.length === 0) return false;
        return !item.event.assetList.some((asset)=>{
            const player = this.getAssetPlayer(asset.identifier);
            return !(player != null && player.bufferedInPlaceToEnd(media));
        });
    }
    setBufferingItem(item) {
        const bufferingLast = this.bufferingItem;
        const schedule = this.schedule;
        if (!this.itemsMatch(item, bufferingLast)) {
            const { items: items, events: events } = schedule;
            if (!items || !events) return bufferingLast;
            const isInterstitial = this.isInterstitial(item);
            const bufferingPlayer = this.getBufferingPlayer();
            this.bufferingItem = item;
            this.bufferedPos = Math.max(item.start, Math.min(item.end, this.timelinePos));
            const timeRemaining = bufferingPlayer ? bufferingPlayer.remaining : bufferingLast ? bufferingLast.end - this.timelinePos : 0;
            this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${$99a156a15cd35eb3$var$segmentToString(item)}` + (bufferingLast ? ` (${timeRemaining.toFixed(2)} remaining)` : ''));
            if (!this.playbackDisabled) {
                if (isInterstitial) // primary fragment loading will exit early in base-stream-controller while `bufferingItem` is set to an Interstitial block
                item.event.assetList.forEach((asset)=>{
                    const player = this.getAssetPlayer(asset.identifier);
                    if (player) player.resumeBuffering();
                });
                else {
                    this.hls.resumeBuffering();
                    this.playerQueue.forEach((player)=>player.pauseBuffering());
                }
            }
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
                events: events.slice(0),
                schedule: items.slice(0),
                bufferingIndex: this.findItemIndex(item),
                playingIndex: this.findItemIndex(this.playingItem)
            });
        } else if (this.bufferingItem !== item) this.bufferingItem = item;
        return bufferingLast;
    }
    bufferedToItem(item, assetListIndex = 0) {
        const bufferingLast = this.setBufferingItem(item);
        if (this.playbackDisabled) return;
        if (this.isInterstitial(item)) // Ensure asset list is loaded
        this.bufferedToEvent(item, assetListIndex);
        else if (bufferingLast !== null) {
            // If primary player is detached, it is also stopped, restart loading at primary position
            this.bufferingAsset = null;
            const detachedData = this.detachedData;
            if (detachedData) {
                if (detachedData.mediaSource) {
                    const skipSeekToStartPosition = true;
                    this.attachPrimary(item.start, item, skipSeekToStartPosition);
                } else this.preloadPrimary(item);
            } else // If not detached seek to resumption point
            this.preloadPrimary(item);
        }
    }
    preloadPrimary(item) {
        const index = this.findItemIndex(item);
        const timelinePos = this.getPrimaryResumption(item, index);
        this.startLoadingPrimaryAt(timelinePos);
    }
    bufferedToEvent(item, assetListIndex) {
        const interstitial = item.event;
        const neverLoaded = interstitial.assetList.length === 0 && !interstitial.assetListLoader;
        const playOnce = interstitial.cue.once;
        if (neverLoaded || !playOnce) {
            // Buffered to Interstitial boundary
            const player = this.preloadAssets(interstitial, assetListIndex);
            if (player != null && player.interstitial.appendInPlace) {
                // If we have a player and asset list info, start buffering
                const assetItem = interstitial.assetList[assetListIndex];
                const media = this.primaryMedia;
                if (assetItem && media) this.bufferAssetPlayer(player, media);
            }
        }
    }
    preloadAssets(interstitial, assetListIndex) {
        const uri = interstitial.assetUrl;
        const assetListLength = interstitial.assetList.length;
        const neverLoaded = assetListLength === 0 && !interstitial.assetListLoader;
        const playOnce = interstitial.cue.once;
        if (neverLoaded) {
            const timelineStart = interstitial.timelineStart;
            if (interstitial.appendInPlace) {
                var _playingItem$nextEven;
                const playingItem = this.playingItem;
                if (!this.isInterstitial(playingItem) && (playingItem == null ? void 0 : (_playingItem$nextEven = playingItem.nextEvent) == null ? void 0 : _playingItem$nextEven.identifier) === interstitial.identifier) this.flushFrontBuffer(timelineStart + 0.25);
            }
            let hlsStartOffset;
            let liveStartPosition = 0;
            if (!this.playingItem && this.primaryLive) {
                liveStartPosition = this.hls.startPosition;
                if (liveStartPosition === -1) liveStartPosition = this.hls.liveSyncPosition || 0;
            }
            if (liveStartPosition && !(interstitial.cue.pre || interstitial.cue.post)) {
                const startOffset = liveStartPosition - timelineStart;
                if (startOffset > 0) hlsStartOffset = Math.round(startOffset * 1000) / 1000;
            }
            this.log(`Load interstitial asset ${assetListIndex + 1}/${uri ? 1 : assetListLength} ${interstitial}${hlsStartOffset ? ` live-start: ${liveStartPosition} start-offset: ${hlsStartOffset}` : ''}`);
            if (uri) return this.createAsset(interstitial, 0, 0, timelineStart, interstitial.duration, uri);
            const assetListLoader = this.assetListLoader.loadAssetList(interstitial, hlsStartOffset);
            if (assetListLoader) interstitial.assetListLoader = assetListLoader;
        } else if (!playOnce && assetListLength) {
            // Re-buffered to Interstitial boundary, re-create asset player(s)
            for(let i = assetListIndex; i < assetListLength; i++){
                const asset = interstitial.assetList[i];
                const playerIndex = this.getAssetPlayerQueueIndex(asset.identifier);
                if ((playerIndex === -1 || this.playerQueue[playerIndex].destroyed) && !asset.error) this.createAssetPlayer(interstitial, asset, i);
            }
            return this.getAssetPlayer(interstitial.assetList[assetListIndex].identifier);
        }
        return null;
    }
    flushFrontBuffer(startOffset) {
        // Force queued flushing of all buffers
        const requiredTracks = this.requiredTracks;
        if (!requiredTracks) return;
        this.log(`Removing front buffer starting at ${startOffset}`);
        const sourceBufferNames = Object.keys(requiredTracks);
        sourceBufferNames.forEach((type)=>{
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, {
                startOffset: startOffset,
                endOffset: Infinity,
                type: type
            });
        });
    }
    // Interstitial Asset Player control
    getAssetPlayerQueueIndex(assetId) {
        const playerQueue = this.playerQueue;
        for(let i = 0; i < playerQueue.length; i++){
            if (assetId === playerQueue[i].assetId) return i;
        }
        return -1;
    }
    getAssetPlayer(assetId) {
        const index = this.getAssetPlayerQueueIndex(assetId);
        return this.playerQueue[index] || null;
    }
    getBufferingPlayer() {
        const { playerQueue: playerQueue, primaryMedia: primaryMedia } = this;
        if (primaryMedia) for(let i = 0; i < playerQueue.length; i++){
            if (playerQueue[i].media === primaryMedia) return playerQueue[i];
        }
        return null;
    }
    createAsset(interstitial, assetListIndex, startOffset, timelineStart, duration, uri) {
        const assetItem = {
            parentIdentifier: interstitial.identifier,
            identifier: $99a156a15cd35eb3$var$generateAssetIdentifier(interstitial, uri, assetListIndex),
            duration: duration,
            startOffset: startOffset,
            timelineStart: timelineStart,
            uri: uri
        };
        return this.createAssetPlayer(interstitial, assetItem, assetListIndex);
    }
    createAssetPlayer(interstitial, assetItem, assetListIndex) {
        const primary = this.hls;
        const userConfig = primary.userConfig;
        let videoPreference = userConfig.videoPreference;
        const currentLevel = primary.loadLevelObj || primary.levels[primary.currentLevel];
        if (videoPreference || currentLevel) {
            videoPreference = $99a156a15cd35eb3$var$_extends({}, videoPreference);
            if (currentLevel.videoCodec) videoPreference.videoCodec = currentLevel.videoCodec;
            if (currentLevel.videoRange) videoPreference.allowedVideoRanges = [
                currentLevel.videoRange
            ];
        }
        const selectedAudio = primary.audioTracks[primary.audioTrack];
        const selectedSubtitle = primary.subtitleTracks[primary.subtitleTrack];
        let startPosition = 0;
        if (this.primaryLive || interstitial.appendInPlace) {
            const timePastStart = this.timelinePos - assetItem.timelineStart;
            if (timePastStart > 1) {
                const duration = assetItem.duration;
                if (duration && timePastStart < duration) startPosition = timePastStart;
            }
        }
        const assetId = assetItem.identifier;
        const playerConfig = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, userConfig), {}, {
            autoStartLoad: true,
            startFragPrefetch: true,
            primarySessionId: primary.sessionId,
            assetPlayerId: assetId,
            abrEwmaDefaultEstimate: primary.bandwidthEstimate,
            interstitialsController: undefined,
            startPosition: startPosition,
            liveDurationInfinity: false,
            testBandwidth: false,
            videoPreference: videoPreference,
            audioPreference: selectedAudio || userConfig.audioPreference,
            subtitlePreference: selectedSubtitle || userConfig.subtitlePreference
        });
        if (interstitial.appendInPlace) {
            interstitial.appendInPlaceStarted = true;
            if (assetItem.timelineStart) playerConfig.timelineOffset = assetItem.timelineStart;
        }
        const cmcd = playerConfig.cmcd;
        if (cmcd != null && cmcd.sessionId && cmcd.contentId) playerConfig.cmcd = $99a156a15cd35eb3$var$_extends({}, cmcd, {
            contentId: $99a156a15cd35eb3$var$hash(assetItem.uri)
        });
        if (this.getAssetPlayer(assetId)) this.warn(`Duplicate date range identifier ${interstitial} and asset ${assetId}`);
        const player = new $99a156a15cd35eb3$var$HlsAssetPlayer(this.HlsPlayerClass, playerConfig, interstitial, assetItem);
        this.playerQueue.push(player);
        interstitial.assetList[assetListIndex] = assetItem;
        // Listen for LevelDetails and PTS change to update duration
        const updateAssetPlayerDetails = (details)=>{
            if (details.live) {
                const error = new Error(`Interstitials MUST be VOD assets ${interstitial}`);
                const errorData = {
                    fatal: true,
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERSTITIAL_ASSET_ITEM_ERROR,
                    error: error
                };
                this.handleAssetItemError(errorData, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, error.message);
                return;
            }
            // Get time at end of last fragment
            const duration = details.edge - details.fragmentStart;
            const currentAssetDuration = assetItem.duration;
            if (currentAssetDuration === null || duration > currentAssetDuration) {
                this.log(`Interstitial asset "${assetId}" duration change ${currentAssetDuration} > ${duration}`);
                assetItem.duration = duration;
                // Update schedule with new event and asset duration
                this.updateSchedule();
            }
        };
        player.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, (event, { details: details })=>updateAssetPlayerDetails(details));
        player.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_PTS_UPDATED, (event, { details: details })=>updateAssetPlayerDetails(details));
        const onBufferCodecs = (event, data)=>{
            const inQueuPlayer = this.getAssetPlayer(assetId);
            if (inQueuPlayer && data.tracks) {
                inQueuPlayer.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, onBufferCodecs);
                inQueuPlayer.tracks = data.tracks;
                const media = this.primaryMedia;
                if (this.bufferingAsset === inQueuPlayer.assetItem && media && !inQueuPlayer.media) this.bufferAssetPlayer(inQueuPlayer, media);
            }
        };
        player.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, onBufferCodecs);
        const bufferedToEnd = ()=>{
            var _this$schedule$items2;
            const inQueuPlayer = this.getAssetPlayer(assetId);
            this.log(`buffered to end of asset ${inQueuPlayer}`);
            if (!inQueuPlayer) return;
            // Preload at end of asset
            const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
            const item = (_this$schedule$items2 = this.schedule.items) == null ? void 0 : _this$schedule$items2[scheduleIndex];
            if (this.isInterstitial(item)) {
                const assetListIndex = interstitial.findAssetIndex(assetItem);
                const nextAssetIndex = $99a156a15cd35eb3$var$getNextAssetIndex(interstitial, assetListIndex);
                if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) this.bufferedToItem(item, nextAssetIndex);
                else {
                    var _this$schedule$items3;
                    const nextItem = (_this$schedule$items3 = this.schedule.items) == null ? void 0 : _this$schedule$items3[scheduleIndex + 1];
                    if (nextItem) this.bufferedToItem(nextItem);
                }
            }
        };
        player.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFERED_TO_END, bufferedToEnd);
        const endedWithAssetIndex = (assetIndex)=>{
            return ()=>{
                const inQueuPlayer = this.getAssetPlayer(assetId);
                if (!inQueuPlayer) return;
                this.shouldPlay = true;
                const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
                this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetIndex);
            };
        };
        player.once($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ENDED, endedWithAssetIndex(assetListIndex));
        player.once($99a156a15cd35eb3$export$ada873a34909da65.PLAYOUT_LIMIT_REACHED, endedWithAssetIndex(Infinity));
        player.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, (event, data)=>{
            const inQueuPlayer = this.getAssetPlayer(assetId);
            if (data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR) {
                if (inQueuPlayer != null && inQueuPlayer.media) {
                    const assetCurrentTime = inQueuPlayer.currentTime;
                    const distanceFromEnd = inQueuPlayer.duration - assetCurrentTime;
                    if (assetCurrentTime && interstitial.appendInPlace && distanceFromEnd / inQueuPlayer.media.playbackRate < 0.5) {
                        this.log(`Advancing buffer past end of asset ${assetId} ${interstitial} at ${inQueuPlayer.media.currentTime}`);
                        bufferedToEnd();
                    } else {
                        this.warn(`Stalled at ${assetCurrentTime} of ${assetCurrentTime + distanceFromEnd} in asset ${assetId} ${interstitial}`);
                        this.onTimeupdate();
                        this.checkBuffer(true);
                    }
                }
                return;
            }
            this.handleAssetItemError(data, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, `Asset player error ${data.error} ${interstitial}`);
        });
        player.on($99a156a15cd35eb3$export$ada873a34909da65.DESTROYING, ()=>{
            const inQueuPlayer = this.getAssetPlayer(assetId);
            if (!inQueuPlayer) return;
            const error = new Error(`Asset player destroyed unexpectedly ${assetId}`);
            const errorData = {
                fatal: true,
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERSTITIAL_ASSET_ITEM_ERROR,
                error: error
            };
            this.handleAssetItemError(errorData, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, error.message);
        });
        this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${$99a156a15cd35eb3$var$eventAssetToString(assetItem)}`);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIAL_ASSET_PLAYER_CREATED, {
            asset: assetItem,
            assetListIndex: assetListIndex,
            event: interstitial,
            player: player
        });
        return player;
    }
    clearInterstitial(interstitial, toSegment) {
        interstitial.assetList.forEach((asset)=>{
            this.clearAssetPlayer(asset.identifier, toSegment);
        });
        // Remove asset list and resolved duration
        interstitial.reset();
    }
    resetAssetPlayer(assetId) {
        // Reset asset player so that it's timeline can be adjusted without reloading the MVP
        const playerIndex = this.getAssetPlayerQueueIndex(assetId);
        if (playerIndex !== -1) {
            this.log(`reset asset player "${assetId}" after error`);
            const player = this.playerQueue[playerIndex];
            this.transferMediaFromPlayer(player, null);
            player.resetDetails();
        }
    }
    clearAssetPlayer(assetId, toSegment) {
        const playerIndex = this.getAssetPlayerQueueIndex(assetId);
        if (playerIndex !== -1) {
            this.log(`clear asset player "${assetId}" toSegment: ${toSegment ? $99a156a15cd35eb3$var$segmentToString(toSegment) : toSegment}`);
            const player = this.playerQueue[playerIndex];
            this.transferMediaFromPlayer(player, toSegment);
            this.playerQueue.splice(playerIndex, 1);
            player.destroy();
        }
    }
    emptyPlayerQueue() {
        let player;
        while(player = this.playerQueue.pop())player.destroy();
        this.playerQueue = [];
    }
    startAssetPlayer(player, assetListIndex, scheduleItems, scheduleIndex, media) {
        const { interstitial: interstitial, assetItem: assetItem, assetId: assetId } = player;
        const assetListLength = interstitial.assetList.length;
        const playingAsset = this.playingAsset;
        this.endedAsset = null;
        this.playingAsset = assetItem;
        if (!playingAsset || playingAsset.identifier !== assetId) {
            if (playingAsset) {
                // Exiting another Interstitial asset
                this.clearAssetPlayer(playingAsset.identifier, scheduleItems[scheduleIndex]);
                delete playingAsset.error;
            }
            this.log(`INTERSTITIAL_ASSET_STARTED ${assetListIndex + 1}/${assetListLength} ${$99a156a15cd35eb3$var$eventAssetToString(assetItem)}`);
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIAL_ASSET_STARTED, {
                asset: assetItem,
                assetListIndex: assetListIndex,
                event: interstitial,
                schedule: scheduleItems.slice(0),
                scheduleIndex: scheduleIndex,
                player: player
            });
        }
        // detach media and attach to interstitial player if it does not have another element attached
        this.bufferAssetPlayer(player, media);
    }
    bufferAssetPlayer(player, media) {
        var _this$schedule$items4, _this$detachedData5;
        const { interstitial: interstitial, assetItem: assetItem } = player;
        const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
        const item = (_this$schedule$items4 = this.schedule.items) == null ? void 0 : _this$schedule$items4[scheduleIndex];
        if (!item) return;
        this.setBufferingItem(item);
        this.bufferingAsset = assetItem;
        const bufferingPlayer = this.getBufferingPlayer();
        if (bufferingPlayer === player) return;
        const appendInPlaceNext = interstitial.appendInPlace;
        if (appendInPlaceNext && (bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial.appendInPlace) === false) // Media is detached and not available to append in place
        return;
        const activeTracks = (bufferingPlayer == null ? void 0 : bufferingPlayer.tracks) || ((_this$detachedData5 = this.detachedData) == null ? void 0 : _this$detachedData5.tracks) || this.requiredTracks;
        if (appendInPlaceNext && assetItem !== this.playingAsset) {
            // Do not buffer another item if tracks are unknown or incompatible
            if (!player.tracks) return;
            if (activeTracks && !$99a156a15cd35eb3$var$isCompatibleTrackChange(activeTracks, player.tracks)) {
                const error = new Error(`Asset ${$99a156a15cd35eb3$var$eventAssetToString(assetItem)} SourceBuffer tracks ('${Object.keys(player.tracks)}') are not compatible with primary content tracks ('${Object.keys(activeTracks)}')`);
                const errorData = {
                    fatal: true,
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERSTITIAL_ASSET_ITEM_ERROR,
                    error: error
                };
                const assetListIndex = interstitial.findAssetIndex(assetItem);
                this.handleAssetItemError(errorData, interstitial, scheduleIndex, assetListIndex, error.message);
                return;
            }
        }
        this.transferMediaTo(player, media);
    }
    handleAssetItemError(data, interstitial, scheduleIndex, assetListIndex, errorMessage) {
        if (data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR) return;
        const assetItem = interstitial.assetList[assetListIndex];
        this.warn(`INTERSTITIAL_ASSET_ERROR ${assetItem ? $99a156a15cd35eb3$var$eventAssetToString(assetItem) : assetItem} ${data.error}`);
        const assetId = assetItem == null ? void 0 : assetItem.identifier;
        const playerIndex = this.getAssetPlayerQueueIndex(assetId);
        const player = this.playerQueue[playerIndex] || null;
        const items = this.schedule.items;
        const interstitialAssetError = $99a156a15cd35eb3$var$_extends({}, data, {
            fatal: false,
            errorAction: $99a156a15cd35eb3$var$createDoNothingErrorAction(true),
            asset: assetItem,
            assetListIndex: assetListIndex,
            event: interstitial,
            schedule: items,
            scheduleIndex: scheduleIndex,
            player: player
        });
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INTERSTITIAL_ASSET_ERROR, interstitialAssetError);
        if (!data.fatal) return;
        const playingAsset = this.playingAsset;
        const error = new Error(errorMessage);
        if (assetItem) {
            this.clearAssetPlayer(assetId, null);
            assetItem.error = error;
        }
        // If all assets in interstitial fail, mark the interstitial with an error
        if (!interstitial.assetList.some((asset)=>!asset.error)) interstitial.error = error;
        else if (interstitial.appendInPlace) {
            // Reset level details and reload/parse media playlists to align with updated schedule
            for(let i = assetListIndex; i < interstitial.assetList.length; i++)this.resetAssetPlayer(interstitial.assetList[i].identifier);
            this.updateSchedule();
        }
        if (interstitial.error) this.primaryFallback(interstitial);
        else if (playingAsset && playingAsset.identifier === assetId) this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetListIndex);
    }
    primaryFallback(interstitial) {
        // Fallback to Primary by on current or future events by updating schedule to skip errored interstitials/assets
        const flushStart = interstitial.timelineStart;
        const playingItem = this.effectivePlayingItem;
        // Update schedule now that interstitial/assets are flagged with `error` for fallback
        this.updateSchedule();
        if (playingItem) {
            this.log(`Fallback to primary from event "${interstitial.identifier}" start: ${flushStart} pos: ${this.timelinePos} playing: ${playingItem ? $99a156a15cd35eb3$var$segmentToString(playingItem) : '<none>'} error: ${interstitial.error}`);
            let timelinePos = this.timelinePos;
            if (timelinePos === -1) timelinePos = this.hls.startPosition;
            const newPlayingItem = this.updateItem(playingItem, timelinePos);
            if (this.itemsMatch(playingItem, newPlayingItem)) this.clearInterstitial(interstitial, null);
            if (interstitial.appendInPlace) {
                this.attachPrimary(flushStart, null);
                this.flushFrontBuffer(flushStart);
            }
            const scheduleIndex = this.schedule.findItemIndexAtTime(timelinePos);
            this.setSchedulePosition(scheduleIndex);
        } else this.checkStart();
    }
    // Asset List loading
    onAssetListLoaded(event, data) {
        var _this$bufferingItem2;
        const interstitial = data.event;
        const interstitialId = interstitial.identifier;
        const assets = data.assetListResponse.ASSETS;
        if (!this.schedule.hasEvent(interstitialId)) // Interstitial with id was removed
        return;
        const eventStart = interstitial.timelineStart;
        const previousDuration = interstitial.duration;
        let sumDuration = 0;
        assets.forEach((asset, assetListIndex)=>{
            const duration = parseFloat(asset.DURATION);
            this.createAsset(interstitial, assetListIndex, sumDuration, eventStart + sumDuration, duration, asset.URI);
            sumDuration += duration;
        });
        interstitial.duration = sumDuration;
        this.log(`Loaded asset-list with duration: ${sumDuration} (was: ${previousDuration}) ${interstitial}`);
        const waitingItem = this.waitingItem;
        const waitingForItem = (waitingItem == null ? void 0 : waitingItem.event.identifier) === interstitialId;
        // Update schedule now that asset.DURATION(s) are parsed
        this.updateSchedule();
        const bufferingEvent = (_this$bufferingItem2 = this.bufferingItem) == null ? void 0 : _this$bufferingItem2.event;
        // If buffer reached Interstitial, start buffering first asset
        if (waitingForItem) {
            var _this$schedule$items5;
            // Advance schedule when waiting for asset list data to play
            const scheduleIndex = this.schedule.findEventIndex(interstitialId);
            const item = (_this$schedule$items5 = this.schedule.items) == null ? void 0 : _this$schedule$items5[scheduleIndex];
            if (item) {
                if (!this.playingItem && this.timelinePos > item.end) {
                    // Abandon if new duration is reduced enough to land playback in primary start
                    const index = this.schedule.findItemIndexAtTime(this.timelinePos);
                    if (index !== scheduleIndex) {
                        interstitial.error = new Error(`Interstitial no longer within playback range ${this.timelinePos} ${interstitial}`);
                        this.primaryFallback(interstitial);
                        return;
                    }
                }
                this.setBufferingItem(item);
            }
            this.setSchedulePosition(scheduleIndex);
        } else if ((bufferingEvent == null ? void 0 : bufferingEvent.identifier) === interstitialId && bufferingEvent.appendInPlace) {
            // If buffering (but not playback) has reached this item transfer media-source
            const assetItem = interstitial.assetList[0];
            const player = this.getAssetPlayer(assetItem.identifier);
            const media = this.primaryMedia;
            if (assetItem && player && media) this.bufferAssetPlayer(player, media);
        }
    }
    onError(event, data) {
        switch(data.details){
            case $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_PARSING_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.ASSET_LIST_LOAD_TIMEOUT:
                {
                    const interstitial = data.interstitial;
                    if (interstitial) this.primaryFallback(interstitial);
                    break;
                }
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR:
                this.onTimeupdate();
                this.checkBuffer(true);
                break;
        }
    }
}
const $99a156a15cd35eb3$var$TICK_INTERVAL$2 = 500; // how often to tick in ms
class $99a156a15cd35eb3$export$507c2c1b84e7d645 extends $99a156a15cd35eb3$export$946cb951577581c9 {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, 'subtitle-stream-controller', $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE);
        this.currentTrackId = -1;
        this.tracksBuffered = [];
        this.mainDetails = null;
        this.registerListeners();
    }
    onHandlerDestroying() {
        this.unregisterListeners();
        super.onHandlerDestroying();
        this.mainDetails = null;
    }
    registerListeners() {
        super.registerListeners();
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    unregisterListeners() {
        super.unregisterListeners();
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    startLoad(startPosition, skipSeekToStartPosition) {
        this.stopLoad();
        this.state = $99a156a15cd35eb3$var$State.IDLE;
        this.setInterval($99a156a15cd35eb3$var$TICK_INTERVAL$2);
        this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
        this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
        this.tick();
    }
    onManifestLoading() {
        super.onManifestLoading();
        this.mainDetails = null;
    }
    onMediaDetaching(event, data) {
        this.tracksBuffered = [];
        super.onMediaDetaching(event, data);
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
    }
    onSubtitleFragProcessed(event, data) {
        const { frag: frag, success: success } = data;
        if ($99a156a15cd35eb3$var$isMediaFragment(frag)) this.fragPrevious = frag;
        this.state = $99a156a15cd35eb3$var$State.IDLE;
        if (!success) return;
        const buffered = this.tracksBuffered[this.currentTrackId];
        if (!buffered) return;
        // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
        // so we can re-use the logic used to detect how much has been buffered
        let timeRange;
        const fragStart = frag.start;
        for(let i = 0; i < buffered.length; i++)if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
            timeRange = buffered[i];
            break;
        }
        const fragEnd = frag.start + frag.duration;
        if (timeRange) timeRange.end = fragEnd;
        else {
            timeRange = {
                start: fragStart,
                end: fragEnd
            };
            buffered.push(timeRange);
        }
        this.fragmentTracker.fragBuffered(frag);
        this.fragBufferedComplete(frag, null);
        if (this.media) this.tick();
    }
    onBufferFlushing(event, data) {
        const { startOffset: startOffset, endOffset: endOffset } = data;
        if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
            const endOffsetSubtitles = endOffset - 1;
            if (endOffsetSubtitles <= 0) return;
            data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
            this.tracksBuffered.forEach((buffered)=>{
                for(let i = 0; i < buffered.length;){
                    if (buffered[i].end <= endOffsetSubtitles) {
                        buffered.shift();
                        continue;
                    } else if (buffered[i].start < endOffsetSubtitles) buffered[i].start = endOffsetSubtitles;
                    else break;
                    i++;
                }
            });
            this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE);
        }
    }
    // If something goes wrong, proceed to next frag, if we were processing one.
    onError(event, data) {
        const frag = data.frag;
        if ((frag == null ? void 0 : frag.type) === $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE) {
            if (data.details === $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP) this.fragmentTracker.fragBuffered(frag, true);
            if (this.fragCurrent) this.fragCurrent.abortRequests();
            if (this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.state = $99a156a15cd35eb3$var$State.IDLE;
        }
    }
    // Got all new subtitle levels.
    onSubtitleTracksUpdated(event, { subtitleTracks: subtitleTracks }) {
        if (this.levels && $99a156a15cd35eb3$var$subtitleOptionsIdentical(this.levels, subtitleTracks)) {
            this.levels = subtitleTracks.map((mediaPlaylist)=>new $99a156a15cd35eb3$export$ca664994d1d54bff(mediaPlaylist));
            return;
        }
        this.tracksBuffered = [];
        this.levels = subtitleTracks.map((mediaPlaylist)=>{
            const level = new $99a156a15cd35eb3$export$ca664994d1d54bff(mediaPlaylist);
            this.tracksBuffered[level.id] = [];
            return level;
        });
        this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE);
        this.fragPrevious = null;
        this.mediaBuffer = null;
    }
    onSubtitleTrackSwitch(event, data) {
        var _this$levels;
        this.currentTrackId = data.id;
        if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
            this.clearInterval();
            return;
        }
        // Check if track has the necessary details to load fragments
        const currentTrack = this.levels[this.currentTrackId];
        if (currentTrack != null && currentTrack.details) this.mediaBuffer = this.mediaBufferTimeRanges;
        else this.mediaBuffer = null;
        if (currentTrack && this.state !== $99a156a15cd35eb3$var$State.STOPPED) this.setInterval($99a156a15cd35eb3$var$TICK_INTERVAL$2);
    }
    // Got a new set of subtitle fragments.
    onSubtitleTrackLoaded(event, data) {
        var _track$details;
        const { currentTrackId: currentTrackId, levels: levels } = this;
        const { details: newDetails, id: trackId } = data;
        if (!levels) {
            this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
            return;
        }
        const track = levels[trackId];
        if (trackId >= levels.length || !track) return;
        this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
        this.mediaBuffer = this.mediaBufferTimeRanges;
        let sliding = 0;
        if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
            const mainDetails = this.mainDetails;
            if (newDetails.deltaUpdateFailed || !mainDetails) return;
            const mainSlidingStartFragment = mainDetails.fragments[0];
            if (!track.details) {
                if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                    $99a156a15cd35eb3$var$alignMediaPlaylistByPDT(newDetails, mainDetails);
                    sliding = newDetails.fragmentStart;
                } else if (mainSlidingStartFragment) {
                    // line up live playlist with main so that fragments in range are loaded
                    sliding = mainSlidingStartFragment.start;
                    $99a156a15cd35eb3$var$addSliding(newDetails, sliding);
                }
            } else {
                var _this$levelLastLoaded;
                sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
                if (sliding === 0 && mainSlidingStartFragment) {
                    // realign with main when there is no overlap with last refresh
                    sliding = mainSlidingStartFragment.start;
                    $99a156a15cd35eb3$var$addSliding(newDetails, sliding);
                }
            }
        }
        track.details = newDetails;
        this.levelLastLoaded = track;
        if (trackId !== currentTrackId) return;
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_UPDATED, {
            details: newDetails,
            id: trackId,
            groupId: data.groupId
        });
        // trigger handler right now
        this.tick();
        // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
        if (newDetails.live && !this.fragCurrent && this.media && this.state === $99a156a15cd35eb3$var$State.IDLE) {
            const foundFrag = $99a156a15cd35eb3$var$findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
            if (!foundFrag) {
                this.warn('Subtitle playlist not aligned with playback');
                track.details = undefined;
            }
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        const { frag: frag, payload: payload } = fragLoadedData;
        const decryptData = frag.decryptdata;
        const hls = this.hls;
        if (this.fragContextChanged(frag)) return;
        // check to see if the payload needs to be decrypted
        if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && $99a156a15cd35eb3$var$isFullSegmentEncryption(decryptData.method)) {
            const startTime = performance.now();
            // decrypt the subtitles
            this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, $99a156a15cd35eb3$var$getAesModeFromFullSegmentMethod(decryptData.method)).catch((err)=>{
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR,
                    fatal: false,
                    error: err,
                    reason: err.message,
                    frag: frag
                });
                throw err;
            }).then((decryptedData)=>{
                const endTime = performance.now();
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_DECRYPTED, {
                    frag: frag,
                    payload: decryptedData,
                    stats: {
                        tstart: startTime,
                        tdecrypt: endTime
                    }
                });
            }).catch((err)=>{
                this.warn(`${err.name}: ${err.message}`);
                this.state = $99a156a15cd35eb3$var$State.IDLE;
            });
        }
    }
    doTick() {
        if (!this.media) {
            this.state = $99a156a15cd35eb3$var$State.IDLE;
            return;
        }
        if (this.state === $99a156a15cd35eb3$var$State.IDLE) {
            const { currentTrackId: currentTrackId, levels: levels } = this;
            const track = levels == null ? void 0 : levels[currentTrackId];
            if (!track || !levels.length || !track.details) return;
            if (this.waitForLive(track)) return;
            const { config: config } = this;
            const currentTime = this.getLoadPosition();
            const bufferedInfo = $99a156a15cd35eb3$var$BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
            const { end: targetBufferTime, len: bufferLen } = bufferedInfo;
            const trackDetails = track.details;
            const maxBufLen = this.hls.maxBufferLength + trackDetails.levelTargetDuration;
            if (bufferLen > maxBufLen) return;
            const fragments = trackDetails.fragments;
            const fragLen = fragments.length;
            const end = trackDetails.edge;
            let foundFrag = null;
            const fragPrevious = this.fragPrevious;
            if (targetBufferTime < end) {
                const tolerance = config.maxFragLookUpTolerance;
                const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
                foundFrag = $99a156a15cd35eb3$var$findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
                if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) foundFrag = fragments[0];
            } else foundFrag = fragments[fragLen - 1];
            foundFrag = this.filterReplacedPrimary(foundFrag, track.details);
            if (!foundFrag) return;
            // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
            const curSNIdx = foundFrag.sn - trackDetails.startSN;
            const prevFrag = fragments[curSNIdx - 1];
            if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === $99a156a15cd35eb3$var$FragmentState.NOT_LOADED) foundFrag = prevFrag;
            if (this.fragmentTracker.getState(foundFrag) === $99a156a15cd35eb3$var$FragmentState.NOT_LOADED) {
                // only load if fragment is not loaded
                const fragToLoad = this.mapToInitFragWhenRequired(foundFrag);
                if (fragToLoad) this.loadFragment(fragToLoad, track, targetBufferTime);
            }
        }
    }
    loadFragment(frag, level, targetBufferTime) {
        if (!$99a156a15cd35eb3$var$isMediaFragment(frag)) this._loadInitSegment(frag, level);
        else super.loadFragment(frag, level, targetBufferTime);
    }
    get mediaBufferTimeRanges() {
        return new $99a156a15cd35eb3$var$BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
    }
}
class $99a156a15cd35eb3$var$BufferableInstance {
    constructor(timeranges){
        this.buffered = void 0;
        const getRange = (name, index, length)=>{
            index = index >>> 0;
            if (index > length - 1) throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
            return timeranges[index][name];
        };
        this.buffered = {
            get length () {
                return timeranges.length;
            },
            end (index) {
                return getRange('end', index, timeranges.length);
            },
            start (index) {
                return getRange('start', index, timeranges.length);
            }
        };
    }
}
/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */ /**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */ const $99a156a15cd35eb3$var$specialCea608CharsCodes = {
    0x2a: 0xe1,
    // lowercase a, acute accent
    0x5c: 0xe9,
    // lowercase e, acute accent
    0x5e: 0xed,
    // lowercase i, acute accent
    0x5f: 0xf3,
    // lowercase o, acute accent
    0x60: 0xfa,
    // lowercase u, acute accent
    0x7b: 0xe7,
    // lowercase c with cedilla
    0x7c: 0xf7,
    // division symbol
    0x7d: 0xd1,
    // uppercase N tilde
    0x7e: 0xf1,
    // lowercase n tilde
    0x7f: 0x2588,
    // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    // Registered symbol (R)
    0x81: 0xb0,
    // degree sign
    0x82: 0xbd,
    // 1/2 symbol
    0x83: 0xbf,
    // Inverted (open) question mark
    0x84: 0x2122,
    // Trademark symbol (TM)
    0x85: 0xa2,
    // Cents symbol
    0x86: 0xa3,
    // Pounds sterling
    0x87: 0x266a,
    // Music 8'th note
    0x88: 0xe0,
    // lowercase a, grave accent
    0x89: 0x20,
    // transparent space (regular)
    0x8a: 0xe8,
    // lowercase e, grave accent
    0x8b: 0xe2,
    // lowercase a, circumflex accent
    0x8c: 0xea,
    // lowercase e, circumflex accent
    0x8d: 0xee,
    // lowercase i, circumflex accent
    0x8e: 0xf4,
    // lowercase o, circumflex accent
    0x8f: 0xfb,
    // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    // capital letter A with acute
    0x91: 0xc9,
    // capital letter E with acute
    0x92: 0xd3,
    // capital letter O with acute
    0x93: 0xda,
    // capital letter U with acute
    0x94: 0xdc,
    // capital letter U with diaresis
    0x95: 0xfc,
    // lowercase letter U with diaeresis
    0x96: 0x2018,
    // opening single quote
    0x97: 0xa1,
    // inverted exclamation mark
    0x98: 0x2a,
    // asterisk
    0x99: 0x2019,
    // closing single quote
    0x9a: 0x2501,
    // box drawings heavy horizontal
    0x9b: 0xa9,
    // copyright sign
    0x9c: 0x2120,
    // Service mark
    0x9d: 0x2022,
    // (round) bullet
    0x9e: 0x201c,
    // Left double quotation mark
    0x9f: 0x201d,
    // Right double quotation mark
    0xa0: 0xc0,
    // uppercase A, grave accent
    0xa1: 0xc2,
    // uppercase A, circumflex
    0xa2: 0xc7,
    // uppercase C with cedilla
    0xa3: 0xc8,
    // uppercase E, grave accent
    0xa4: 0xca,
    // uppercase E, circumflex
    0xa5: 0xcb,
    // capital letter E with diaresis
    0xa6: 0xeb,
    // lowercase letter e with diaresis
    0xa7: 0xce,
    // uppercase I, circumflex
    0xa8: 0xcf,
    // uppercase I, with diaresis
    0xa9: 0xef,
    // lowercase i, with diaresis
    0xaa: 0xd4,
    // uppercase O, circumflex
    0xab: 0xd9,
    // uppercase U, grave accent
    0xac: 0xf9,
    // lowercase u, grave accent
    0xad: 0xdb,
    // uppercase U, circumflex
    0xae: 0xab,
    // left-pointing double angle quotation mark
    0xaf: 0xbb,
    // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    // Uppercase A, tilde
    0xb1: 0xe3,
    // Lowercase a, tilde
    0xb2: 0xcd,
    // Uppercase I, acute accent
    0xb3: 0xcc,
    // Uppercase I, grave accent
    0xb4: 0xec,
    // Lowercase i, grave accent
    0xb5: 0xd2,
    // Uppercase O, grave accent
    0xb6: 0xf2,
    // Lowercase o, grave accent
    0xb7: 0xd5,
    // Uppercase O, tilde
    0xb8: 0xf5,
    // Lowercase o, tilde
    0xb9: 0x7b,
    // Open curly brace
    0xba: 0x7d,
    // Closing curly brace
    0xbb: 0x5c,
    // Backslash
    0xbc: 0x5e,
    // Caret
    0xbd: 0x5f,
    // Underscore
    0xbe: 0x7c,
    // Pipe (vertical line)
    0xbf: 0x223c,
    // Tilde operator
    0xc0: 0xc4,
    // Uppercase A, umlaut
    0xc1: 0xe4,
    // Lowercase A, umlaut
    0xc2: 0xd6,
    // Uppercase O, umlaut
    0xc3: 0xf6,
    // Lowercase o, umlaut
    0xc4: 0xdf,
    // Esszett (sharp S)
    0xc5: 0xa5,
    // Yen symbol
    0xc6: 0xa4,
    // Generic currency sign
    0xc7: 0x2503,
    // Box drawings heavy vertical
    0xc8: 0xc5,
    // Uppercase A, ring
    0xc9: 0xe5,
    // Lowercase A, ring
    0xca: 0xd8,
    // Uppercase O, stroke
    0xcb: 0xf8,
    // Lowercase o, strok
    0xcc: 0x250f,
    // Box drawings heavy down and right
    0xcd: 0x2513,
    // Box drawings heavy down and left
    0xce: 0x2517,
    // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
};
/**
 * Utils
 */ const $99a156a15cd35eb3$var$getCharForByte = (byte)=>String.fromCharCode($99a156a15cd35eb3$var$specialCea608CharsCodes[byte] || byte);
const $99a156a15cd35eb3$var$NR_ROWS = 15;
const $99a156a15cd35eb3$var$NR_COLS = 100;
// Tables to look up row from PAC data
const $99a156a15cd35eb3$var$rowsLowCh1 = {
    0x11: 1,
    0x12: 3,
    0x15: 5,
    0x16: 7,
    0x17: 9,
    0x10: 11,
    0x13: 12,
    0x14: 14
};
const $99a156a15cd35eb3$var$rowsHighCh1 = {
    0x11: 2,
    0x12: 4,
    0x15: 6,
    0x16: 8,
    0x17: 10,
    0x13: 13,
    0x14: 15
};
const $99a156a15cd35eb3$var$rowsLowCh2 = {
    0x19: 1,
    0x1a: 3,
    0x1d: 5,
    0x1e: 7,
    0x1f: 9,
    0x18: 11,
    0x1b: 12,
    0x1c: 14
};
const $99a156a15cd35eb3$var$rowsHighCh2 = {
    0x19: 2,
    0x1a: 4,
    0x1d: 6,
    0x1e: 8,
    0x1f: 10,
    0x1b: 13,
    0x1c: 15
};
const $99a156a15cd35eb3$var$backgroundColors = [
    'white',
    'green',
    'blue',
    'cyan',
    'red',
    'yellow',
    'magenta',
    'black',
    'transparent'
];
class $99a156a15cd35eb3$var$CaptionsLogger {
    constructor(){
        this.time = null;
        this.verboseLevel = 0;
    }
    log(severity, msg) {
        if (this.verboseLevel >= severity) {
            const m = typeof msg === 'function' ? msg() : msg;
            $99a156a15cd35eb3$var$logger.log(`${this.time} [${severity}] ${m}`);
        }
    }
}
const $99a156a15cd35eb3$var$numArrayToHexArray = function numArrayToHexArray(numArray) {
    const hexArray = [];
    for(let j = 0; j < numArray.length; j++)hexArray.push(numArray[j].toString(16));
    return hexArray;
};
class $99a156a15cd35eb3$var$PenState {
    constructor(){
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    }
    reset() {
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    }
    setStyles(styles) {
        const attribs = [
            'foreground',
            'underline',
            'italics',
            'background',
            'flash'
        ];
        for(let i = 0; i < attribs.length; i++){
            const style = attribs[i];
            if (styles.hasOwnProperty(style)) this[style] = styles[style];
        }
    }
    isDefault() {
        return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
    }
    equals(other) {
        return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
    }
    copy(newPenState) {
        this.foreground = newPenState.foreground;
        this.underline = newPenState.underline;
        this.italics = newPenState.italics;
        this.background = newPenState.background;
        this.flash = newPenState.flash;
    }
    toString() {
        return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
    }
}
/**
 * Unicode character with styling and background.
 * @constructor
 */ class $99a156a15cd35eb3$var$StyledUnicodeChar {
    constructor(){
        this.uchar = ' ';
        this.penState = new $99a156a15cd35eb3$var$PenState();
    }
    reset() {
        this.uchar = ' ';
        this.penState.reset();
    }
    setChar(uchar, newPenState) {
        this.uchar = uchar;
        this.penState.copy(newPenState);
    }
    setPenState(newPenState) {
        this.penState.copy(newPenState);
    }
    equals(other) {
        return this.uchar === other.uchar && this.penState.equals(other.penState);
    }
    copy(newChar) {
        this.uchar = newChar.uchar;
        this.penState.copy(newChar.penState);
    }
    isEmpty() {
        return this.uchar === ' ' && this.penState.isDefault();
    }
}
/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */ class $99a156a15cd35eb3$var$Row {
    constructor(logger){
        this.chars = [];
        this.pos = 0;
        this.currPenState = new $99a156a15cd35eb3$var$PenState();
        this.cueStartTime = null;
        this.logger = void 0;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_COLS; i++)this.chars.push(new $99a156a15cd35eb3$var$StyledUnicodeChar());
        this.logger = logger;
    }
    equals(other) {
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_COLS; i++){
            if (!this.chars[i].equals(other.chars[i])) return false;
        }
        return true;
    }
    copy(other) {
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_COLS; i++)this.chars[i].copy(other.chars[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_COLS; i++)if (!this.chars[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    /**
   *  Set the cursor to a valid column.
   */ setCursor(absPos) {
        if (this.pos !== absPos) this.pos = absPos;
        if (this.pos < 0) {
            this.logger.log(3, 'Negative cursor position ' + this.pos);
            this.pos = 0;
        } else if (this.pos > $99a156a15cd35eb3$var$NR_COLS) {
            this.logger.log(3, 'Too large cursor position ' + this.pos);
            this.pos = $99a156a15cd35eb3$var$NR_COLS;
        }
    }
    /**
   * Move the cursor relative to current position.
   */ moveCursor(relPos) {
        const newPos = this.pos + relPos;
        if (relPos > 1) for(let i = this.pos + 1; i < newPos + 1; i++)this.chars[i].setPenState(this.currPenState);
        this.setCursor(newPos);
    }
    /**
   * Backspace, move one step back and clear character.
   */ backSpace() {
        this.moveCursor(-1);
        this.chars[this.pos].setChar(' ', this.currPenState);
    }
    insertChar(byte) {
        if (byte >= 0x90) // Extended char
        this.backSpace();
        const char = $99a156a15cd35eb3$var$getCharForByte(byte);
        if (this.pos >= $99a156a15cd35eb3$var$NR_COLS) {
            this.logger.log(0, ()=>'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
            return;
        }
        this.chars[this.pos].setChar(char, this.currPenState);
        this.moveCursor(1);
    }
    clearFromPos(startPos) {
        let i;
        for(i = startPos; i < $99a156a15cd35eb3$var$NR_COLS; i++)this.chars[i].reset();
    }
    clear() {
        this.clearFromPos(0);
        this.pos = 0;
        this.currPenState.reset();
    }
    clearToEndOfRow() {
        this.clearFromPos(this.pos);
    }
    getTextString() {
        const chars = [];
        let empty = true;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_COLS; i++){
            const char = this.chars[i].uchar;
            if (char !== ' ') empty = false;
            chars.push(char);
        }
        if (empty) return '';
        else return chars.join('');
    }
    setPenStyles(styles) {
        this.currPenState.setStyles(styles);
        const currChar = this.chars[this.pos];
        currChar.setPenState(this.currPenState);
    }
}
/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */ class $99a156a15cd35eb3$var$CaptionScreen {
    constructor(logger){
        this.rows = [];
        this.currRow = $99a156a15cd35eb3$var$NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.lastOutputScreen = null;
        this.logger = void 0;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++)this.rows.push(new $99a156a15cd35eb3$var$Row(logger));
        this.logger = logger;
    }
    reset() {
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++)this.rows[i].clear();
        this.currRow = $99a156a15cd35eb3$var$NR_ROWS - 1;
    }
    equals(other) {
        let equal = true;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++)if (!this.rows[i].equals(other.rows[i])) {
            equal = false;
            break;
        }
        return equal;
    }
    copy(other) {
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++)this.rows[i].copy(other.rows[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++)if (!this.rows[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    backSpace() {
        const row = this.rows[this.currRow];
        row.backSpace();
    }
    clearToEndOfRow() {
        const row = this.rows[this.currRow];
        row.clearToEndOfRow();
    }
    /**
   * Insert a character (without styling) in the current row.
   */ insertChar(char) {
        const row = this.rows[this.currRow];
        row.insertChar(char);
    }
    setPen(styles) {
        const row = this.rows[this.currRow];
        row.setPenStyles(styles);
    }
    moveCursor(relPos) {
        const row = this.rows[this.currRow];
        row.moveCursor(relPos);
    }
    setCursor(absPos) {
        this.logger.log(2, 'setCursor: ' + absPos);
        const row = this.rows[this.currRow];
        row.setCursor(absPos);
    }
    setPAC(pacData) {
        this.logger.log(2, ()=>'pacData = ' + $99a156a15cd35eb3$var$stringify(pacData));
        let newRow = pacData.row - 1;
        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;
        // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
        if (this.nrRollUpRows && this.currRow !== newRow) {
            // clear all rows first
            for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++)this.rows[i].clear();
            // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
            // topRowIndex - the start of rows to copy (inclusive index)
            const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            // We only copy if the last position was already shown.
            // We use the cueStartTime value to check this.
            const lastOutputScreen = this.lastOutputScreen;
            if (lastOutputScreen) {
                const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                const time1 = this.logger.time;
                if (prevLineTime !== null && time1 !== null && prevLineTime < time1) for(let i = 0; i < this.nrRollUpRows; i++)this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
            }
        }
        this.currRow = newRow;
        const row = this.rows[this.currRow];
        if (pacData.indent !== null) {
            const indent = pacData.indent;
            const prevPos = Math.max(indent - 1, 0);
            row.setCursor(pacData.indent);
            pacData.color = row.chars[prevPos].penState.foreground;
        }
        const styles = {
            foreground: pacData.color,
            underline: pacData.underline,
            italics: pacData.italics,
            background: 'black',
            flash: false
        };
        this.setPen(styles);
    }
    /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */ setBkgData(bkgData) {
        this.logger.log(2, ()=>'bkgData = ' + $99a156a15cd35eb3$var$stringify(bkgData));
        this.backSpace();
        this.setPen(bkgData);
        this.insertChar(0x20); // Space
    }
    setRollUpRows(nrRows) {
        this.nrRollUpRows = nrRows;
    }
    rollUp() {
        if (this.nrRollUpRows === null) {
            this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
            return; // Not properly setup
        }
        this.logger.log(1, ()=>this.getDisplayText());
        const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        const topRow = this.rows.splice(topRowIndex, 1)[0];
        topRow.clear();
        this.rows.splice(this.currRow, 0, topRow);
        this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
    }
    /**
   * Get all non-empty rows with as unicode text.
   */ getDisplayText(asOneRow) {
        asOneRow = asOneRow || false;
        const displayText = [];
        let text = '';
        let rowNr = -1;
        for(let i = 0; i < $99a156a15cd35eb3$var$NR_ROWS; i++){
            const rowText = this.rows[i].getTextString();
            if (rowText) {
                rowNr = i + 1;
                if (asOneRow) displayText.push('Row ' + rowNr + ": '" + rowText + "'");
                else displayText.push(rowText.trim());
            }
        }
        if (displayText.length > 0) {
            if (asOneRow) text = '[' + displayText.join(' | ') + ']';
            else text = displayText.join('\n');
        }
        return text;
    }
    getTextAndFormat() {
        return this.rows;
    }
}
// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
class $99a156a15cd35eb3$var$Cea608Channel {
    constructor(channelNumber, outputFilter, logger){
        this.chNr = void 0;
        this.outputFilter = void 0;
        this.mode = void 0;
        this.verbose = void 0;
        this.displayedMemory = void 0;
        this.nonDisplayedMemory = void 0;
        this.lastOutputScreen = void 0;
        this.currRollUpRow = void 0;
        this.writeScreen = void 0;
        this.cueStartTime = void 0;
        this.logger = void 0;
        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new $99a156a15cd35eb3$var$CaptionScreen(logger);
        this.nonDisplayedMemory = new $99a156a15cd35eb3$var$CaptionScreen(logger);
        this.lastOutputScreen = new $99a156a15cd35eb3$var$CaptionScreen(logger);
        this.currRollUpRow = this.displayedMemory.rows[$99a156a15cd35eb3$var$NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
        this.logger = logger;
    }
    reset() {
        this.mode = null;
        this.displayedMemory.reset();
        this.nonDisplayedMemory.reset();
        this.lastOutputScreen.reset();
        this.outputFilter.reset();
        this.currRollUpRow = this.displayedMemory.rows[$99a156a15cd35eb3$var$NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null;
    }
    getHandler() {
        return this.outputFilter;
    }
    setHandler(newHandler) {
        this.outputFilter = newHandler;
    }
    setPAC(pacData) {
        this.writeScreen.setPAC(pacData);
    }
    setBkgData(bkgData) {
        this.writeScreen.setBkgData(bkgData);
    }
    setMode(newMode) {
        if (newMode === this.mode) return;
        this.mode = newMode;
        this.logger.log(2, ()=>'MODE=' + newMode);
        if (this.mode === 'MODE_POP-ON') this.writeScreen = this.nonDisplayedMemory;
        else {
            this.writeScreen = this.displayedMemory;
            this.writeScreen.reset();
        }
        if (this.mode !== 'MODE_ROLL-UP') {
            this.displayedMemory.nrRollUpRows = null;
            this.nonDisplayedMemory.nrRollUpRows = null;
        }
        this.mode = newMode;
    }
    insertChars(chars) {
        for(let i = 0; i < chars.length; i++)this.writeScreen.insertChar(chars[i]);
        const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
        this.logger.log(2, ()=>screen + ': ' + this.writeScreen.getDisplayText(true));
        if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
            this.logger.log(1, ()=>'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
            this.outputDataUpdate();
        }
    }
    ccRCL() {
        // Resume Caption Loading (switch mode to Pop On)
        this.logger.log(2, 'RCL - Resume Caption Loading');
        this.setMode('MODE_POP-ON');
    }
    ccBS() {
        // BackSpace
        this.logger.log(2, 'BS - BackSpace');
        if (this.mode === 'MODE_TEXT') return;
        this.writeScreen.backSpace();
        if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
    }
    ccAOF() {
    // Reserved (formerly Alarm Off)
    }
    ccAON() {
    // Reserved (formerly Alarm On)
    }
    ccDER() {
        // Delete to End of Row
        this.logger.log(2, 'DER- Delete to End of Row');
        this.writeScreen.clearToEndOfRow();
        this.outputDataUpdate();
    }
    ccRU(nrRows) {
        // Roll-Up Captions-2,3,or 4 Rows
        this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
        this.writeScreen = this.displayedMemory;
        this.setMode('MODE_ROLL-UP');
        this.writeScreen.setRollUpRows(nrRows);
    }
    ccFON() {
        // Flash On
        this.logger.log(2, 'FON - Flash On');
        this.writeScreen.setPen({
            flash: true
        });
    }
    ccRDC() {
        // Resume Direct Captioning (switch mode to PaintOn)
        this.logger.log(2, 'RDC - Resume Direct Captioning');
        this.setMode('MODE_PAINT-ON');
    }
    ccTR() {
        // Text Restart in text mode (not supported, however)
        this.logger.log(2, 'TR');
        this.setMode('MODE_TEXT');
    }
    ccRTD() {
        // Resume Text Display in Text mode (not supported, however)
        this.logger.log(2, 'RTD');
        this.setMode('MODE_TEXT');
    }
    ccEDM() {
        // Erase Displayed Memory
        this.logger.log(2, 'EDM - Erase Displayed Memory');
        this.displayedMemory.reset();
        this.outputDataUpdate(true);
    }
    ccCR() {
        // Carriage Return
        this.logger.log(2, 'CR - Carriage Return');
        this.writeScreen.rollUp();
        this.outputDataUpdate(true);
    }
    ccENM() {
        // Erase Non-Displayed Memory
        this.logger.log(2, 'ENM - Erase Non-displayed Memory');
        this.nonDisplayedMemory.reset();
    }
    ccEOC() {
        // End of Caption (Flip Memories)
        this.logger.log(2, 'EOC - End Of Caption');
        if (this.mode === 'MODE_POP-ON') {
            const tmp = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory;
            this.nonDisplayedMemory = tmp;
            this.writeScreen = this.nonDisplayedMemory;
            this.logger.log(1, ()=>'DISP: ' + this.displayedMemory.getDisplayText());
        }
        this.outputDataUpdate(true);
    }
    ccTO(nrCols) {
        // Tab Offset 1,2, or 3 columns
        this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
        this.writeScreen.moveCursor(nrCols);
    }
    ccMIDROW(secondByte) {
        // Parse MIDROW command
        const styles = {
            flash: false
        };
        styles.underline = secondByte % 2 === 1;
        styles.italics = secondByte >= 0x2e;
        if (!styles.italics) {
            const colorIndex = Math.floor(secondByte / 2) - 0x10;
            const colors = [
                'white',
                'green',
                'blue',
                'cyan',
                'red',
                'yellow',
                'magenta'
            ];
            styles.foreground = colors[colorIndex];
        } else styles.foreground = 'white';
        this.logger.log(2, 'MIDROW: ' + $99a156a15cd35eb3$var$stringify(styles));
        this.writeScreen.setPen(styles);
    }
    outputDataUpdate(dispatch = false) {
        const time1 = this.logger.time;
        if (time1 === null) return;
        if (this.outputFilter) {
            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) // Start of a new cue
            this.cueStartTime = time1;
            else if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                this.outputFilter.newCue(this.cueStartTime, time1, this.lastOutputScreen);
                if (dispatch && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
                this.cueStartTime = this.displayedMemory.isEmpty() ? null : time1;
            }
            this.lastOutputScreen.copy(this.displayedMemory);
        }
    }
    cueSplitAtTime(t) {
        if (this.outputFilter) {
            if (!this.displayedMemory.isEmpty()) {
                if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                this.cueStartTime = t;
            }
        }
    }
}
// Will be 1 or 2 when parsing captions
class $99a156a15cd35eb3$var$Cea608Parser {
    constructor(field, out1, out2){
        this.channels = void 0;
        this.currentChannel = 0;
        this.cmdHistory = $99a156a15cd35eb3$var$createCmdHistory();
        this.logger = void 0;
        const logger = this.logger = new $99a156a15cd35eb3$var$CaptionsLogger();
        this.channels = [
            null,
            new $99a156a15cd35eb3$var$Cea608Channel(field, out1, logger),
            new $99a156a15cd35eb3$var$Cea608Channel(field + 1, out2, logger)
        ];
    }
    getHandler(channel) {
        return this.channels[channel].getHandler();
    }
    setHandler(channel, newHandler) {
        this.channels[channel].setHandler(newHandler);
    }
    /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */ addData(time1, byteList) {
        this.logger.time = time1;
        for(let i = 0; i < byteList.length; i += 2){
            const a = byteList[i] & 0x7f;
            const b = byteList[i + 1] & 0x7f;
            let cmdFound = false;
            let charsFound = null;
            if (a === 0 && b === 0) continue;
            else this.logger.log(3, ()=>'[' + $99a156a15cd35eb3$var$numArrayToHexArray([
                    byteList[i],
                    byteList[i + 1]
                ]) + '] -> (' + $99a156a15cd35eb3$var$numArrayToHexArray([
                    a,
                    b
                ]) + ')');
            const cmdHistory = this.cmdHistory;
            const isControlCode = a >= 0x10 && a <= 0x1f;
            if (isControlCode) {
                // Skip redundant control codes
                if ($99a156a15cd35eb3$var$hasCmdRepeated(a, b, cmdHistory)) {
                    $99a156a15cd35eb3$var$setLastCmd(null, null, cmdHistory);
                    this.logger.log(3, ()=>'Repeated command (' + $99a156a15cd35eb3$var$numArrayToHexArray([
                            a,
                            b
                        ]) + ') is dropped');
                    continue;
                }
                $99a156a15cd35eb3$var$setLastCmd(a, b, this.cmdHistory);
                cmdFound = this.parseCmd(a, b);
                if (!cmdFound) cmdFound = this.parseMidrow(a, b);
                if (!cmdFound) cmdFound = this.parsePAC(a, b);
                if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);
            } else $99a156a15cd35eb3$var$setLastCmd(null, null, cmdHistory);
            if (!cmdFound) {
                charsFound = this.parseChars(a, b);
                if (charsFound) {
                    const currChNr = this.currentChannel;
                    if (currChNr && currChNr > 0) {
                        const channel = this.channels[currChNr];
                        channel.insertChars(charsFound);
                    } else this.logger.log(2, 'No channel found yet. TEXT-MODE?');
                }
            }
            if (!cmdFound && !charsFound) this.logger.log(2, ()=>"Couldn't parse cleaned data " + $99a156a15cd35eb3$var$numArrayToHexArray([
                    a,
                    b
                ]) + ' orig: ' + $99a156a15cd35eb3$var$numArrayToHexArray([
                    byteList[i],
                    byteList[i + 1]
                ]));
        }
    }
    /**
   * Parse Command.
   * @returns True if a command was found
   */ parseCmd(a, b) {
        const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
        const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
        if (!(cond1 || cond2)) return false;
        const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
            if (b === 0x20) channel.ccRCL();
            else if (b === 0x21) channel.ccBS();
            else if (b === 0x22) channel.ccAOF();
            else if (b === 0x23) channel.ccAON();
            else if (b === 0x24) channel.ccDER();
            else if (b === 0x25) channel.ccRU(2);
            else if (b === 0x26) channel.ccRU(3);
            else if (b === 0x27) channel.ccRU(4);
            else if (b === 0x28) channel.ccFON();
            else if (b === 0x29) channel.ccRDC();
            else if (b === 0x2a) channel.ccTR();
            else if (b === 0x2b) channel.ccRTD();
            else if (b === 0x2c) channel.ccEDM();
            else if (b === 0x2d) channel.ccCR();
            else if (b === 0x2e) channel.ccENM();
            else if (b === 0x2f) channel.ccEOC();
        } else // a == 0x17 || a == 0x1F
        channel.ccTO(b - 0x20);
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Parse midrow styling command
   */ parseMidrow(a, b) {
        let chNr = 0;
        if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
            if (a === 0x11) chNr = 1;
            else chNr = 2;
            if (chNr !== this.currentChannel) {
                this.logger.log(0, 'Mismatch channel in midrow parsing');
                return false;
            }
            const channel = this.channels[chNr];
            if (!channel) return false;
            channel.ccMIDROW(b);
            this.logger.log(3, ()=>'MIDROW (' + $99a156a15cd35eb3$var$numArrayToHexArray([
                    a,
                    b
                ]) + ')');
            return true;
        }
        return false;
    }
    /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */ parsePAC(a, b) {
        let row;
        const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
        const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
        if (!(case1 || case2)) return false;
        const chNr = a <= 0x17 ? 1 : 2;
        if (b >= 0x40 && b <= 0x5f) row = chNr === 1 ? $99a156a15cd35eb3$var$rowsLowCh1[a] : $99a156a15cd35eb3$var$rowsLowCh2[a];
        else // 0x60 <= b <= 0x7F
        row = chNr === 1 ? $99a156a15cd35eb3$var$rowsHighCh1[a] : $99a156a15cd35eb3$var$rowsHighCh2[a];
        const channel = this.channels[chNr];
        if (!channel) return false;
        channel.setPAC(this.interpretPAC(row, b));
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */ interpretPAC(row, byte) {
        let pacIndex;
        const pacData = {
            color: null,
            italics: false,
            indent: null,
            underline: false,
            row: row
        };
        if (byte > 0x5f) pacIndex = byte - 0x60;
        else pacIndex = byte - 0x40;
        pacData.underline = (pacIndex & 1) === 1;
        if (pacIndex <= 0xd) pacData.color = [
            'white',
            'green',
            'blue',
            'cyan',
            'red',
            'yellow',
            'magenta',
            'white'
        ][Math.floor(pacIndex / 2)];
        else if (pacIndex <= 0xf) {
            pacData.italics = true;
            pacData.color = 'white';
        } else pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
        return pacData; // Note that row has zero offset. The spec uses 1.
    }
    /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */ parseChars(a, b) {
        let channelNr;
        let charCodes = null;
        let charCode1 = null;
        if (a >= 0x19) {
            channelNr = 2;
            charCode1 = a - 8;
        } else {
            channelNr = 1;
            charCode1 = a;
        }
        if (charCode1 >= 0x11 && charCode1 <= 0x13) {
            // Special character
            let oneCode;
            if (charCode1 === 0x11) oneCode = b + 0x50;
            else if (charCode1 === 0x12) oneCode = b + 0x70;
            else oneCode = b + 0x90;
            this.logger.log(2, ()=>"Special char '" + $99a156a15cd35eb3$var$getCharForByte(oneCode) + "' in channel " + channelNr);
            charCodes = [
                oneCode
            ];
        } else if (a >= 0x20 && a <= 0x7f) charCodes = b === 0 ? [
            a
        ] : [
            a,
            b
        ];
        if (charCodes) this.logger.log(3, ()=>'Char codes =  ' + $99a156a15cd35eb3$var$numArrayToHexArray(charCodes).join(','));
        return charCodes;
    }
    /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */ parseBackgroundAttributes(a, b) {
        const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
        const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
        if (!(case1 || case2)) return false;
        let index;
        const bkgData = {};
        if (a === 0x10 || a === 0x18) {
            index = Math.floor((b - 0x20) / 2);
            bkgData.background = $99a156a15cd35eb3$var$backgroundColors[index];
            if (b % 2 === 1) bkgData.background = bkgData.background + '_semi';
        } else if (b === 0x2d) bkgData.background = 'transparent';
        else {
            bkgData.foreground = 'black';
            if (b === 0x2f) bkgData.underline = true;
        }
        const chNr = a <= 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        channel.setBkgData(bkgData);
        return true;
    }
    /**
   * Reset state of parser and its channels.
   */ reset() {
        for(let i = 0; i < Object.keys(this.channels).length; i++){
            const channel = this.channels[i];
            if (channel) channel.reset();
        }
        $99a156a15cd35eb3$var$setLastCmd(null, null, this.cmdHistory);
    }
    /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */ cueSplitAtTime(t) {
        for(let i = 0; i < this.channels.length; i++){
            const channel = this.channels[i];
            if (channel) channel.cueSplitAtTime(t);
        }
    }
}
function $99a156a15cd35eb3$var$setLastCmd(a, b, cmdHistory) {
    cmdHistory.a = a;
    cmdHistory.b = b;
}
function $99a156a15cd35eb3$var$hasCmdRepeated(a, b, cmdHistory) {
    return cmdHistory.a === a && cmdHistory.b === b;
}
function $99a156a15cd35eb3$var$createCmdHistory() {
    return {
        a: null,
        b: null
    };
}
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $99a156a15cd35eb3$var$VTTCue = function() {
    if ($99a156a15cd35eb3$var$optionalSelf != null && $99a156a15cd35eb3$var$optionalSelf.VTTCue) return self.VTTCue;
    const AllowedDirections = [
        '',
        'lr',
        'rl'
    ];
    const AllowedAlignments = [
        'start',
        'middle',
        'end',
        'left',
        'right'
    ];
    function isAllowedValue(allowed, value) {
        if (typeof value !== 'string') return false;
        // necessary for assuring the generic conforms to the Array interface
        if (!Array.isArray(allowed)) return false;
        // reset the type so that the next narrowing works well
        const lcValue = value.toLowerCase();
        // use the allow list to narrow the type to a specific subset of strings
        if (~allowed.indexOf(lcValue)) return lcValue;
        return false;
    }
    function findDirectionSetting(value) {
        return isAllowedValue(AllowedDirections, value);
    }
    function findAlignSetting(value) {
        return isAllowedValue(AllowedAlignments, value);
    }
    function extend(obj, ...rest) {
        let i = 1;
        for(; i < arguments.length; i++){
            const cobj = arguments[i];
            for(const p in cobj)obj[p] = cobj[p];
        }
        return obj;
    }
    function VTTCue(startTime, endTime, text) {
        const cue = this;
        const baseObj = {
            enumerable: true
        };
        /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */ // Lets us know when the VTTCue's data has changed in such a way that we need
        // to recompute its display state. This lets us compute its display state
        // lazily.
        cue.hasBeenReset = false;
        /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */ let _id = '';
        let _pauseOnExit = false;
        let _startTime = startTime;
        let _endTime = endTime;
        let _text = text;
        let _region = null;
        let _vertical = '';
        let _snapToLines = true;
        let _line = 'auto';
        let _lineAlign = 'start';
        let _position = 50;
        let _positionAlign = 'middle';
        let _size = 50;
        let _align = 'middle';
        Object.defineProperty(cue, 'id', extend({}, baseObj, {
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = '' + value;
            }
        }));
        Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        }));
        Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== 'number') throw new TypeError('Start time must be set to a number.');
                _startTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== 'number') throw new TypeError('End time must be set to a number.');
                _endTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'text', extend({}, baseObj, {
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = '' + value;
                this.hasBeenReset = true;
            }
        }));
        // todo: implement VTTRegion polyfill?
        Object.defineProperty(cue, 'region', extend({}, baseObj, {
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
            get: function() {
                return _vertical;
            },
            set: function(value) {
                const setting = findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError('An invalid or illegal string was specified.');
                _vertical = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'line', extend({}, baseObj, {
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== 'number' && value !== 'auto') throw new SyntaxError('An invalid number or illegal string was specified.');
                _line = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _lineAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'position', extend({}, baseObj, {
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error('Position must be between 0 and 100.');
                _position = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _positionAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'size', extend({}, baseObj, {
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error('Size must be between 0 and 100.');
                _size = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'align', extend({}, baseObj, {
            get: function() {
                return _align;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _align = setting;
                this.hasBeenReset = true;
            }
        }));
        /**
     * Other <track> spec defined properties
     */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
        cue.displayState = undefined;
    }
    /**
   * VTTCue methods
   */ VTTCue.prototype.getCueAsHTML = function() {
        // Assume WebVTT.convertCueToDOMTree is on the global.
        const WebVTT = self.WebVTT;
        return WebVTT.convertCueToDOMTree(self, this.text);
    };
    // this is a polyfill hack
    return VTTCue;
}();
/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */ class $99a156a15cd35eb3$var$StringDecoder {
    decode(data, options) {
        if (!data) return '';
        if (typeof data !== 'string') throw new Error('Error - expected string data.');
        return decodeURIComponent(encodeURIComponent(data));
    }
}
// Try to parse input as a time stamp.
function $99a156a15cd35eb3$var$parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
    }
    const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
    if (!m) return null;
    if (parseFloat(m[2]) > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
    // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class $99a156a15cd35eb3$var$Settings {
    constructor(){
        this.values = Object.create(null);
    }
    // Only accept the first assignment to any key.
    set(k, v) {
        if (!this.get(k) && v !== '') this.values[k] = v;
    }
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    }
    // Check whether we have a value for a key.
    has(k) {
        return k in this.values;
    }
    // Accept a setting if its one of the given alternatives.
    alt(k, v, a) {
        for(let n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    }
    // Accept a setting if its a valid (signed) integer.
    integer(k, v) {
        if (/^-?\d+$/.test(v)) // integer
        this.set(k, parseInt(v, 10));
    }
    // Accept a setting if its a valid percentage.
    percent(k, v) {
        if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
            const percent = parseFloat(v);
            if (percent >= 0 && percent <= 100) {
                this.set(k, percent);
                return true;
            }
        }
        return false;
    }
}
// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function $99a156a15cd35eb3$var$parseOptions(input, callback, keyValueDelim, groupDelim) {
    const groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(const i in groups){
        if (typeof groups[i] !== 'string') continue;
        const kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        const k = kv[0];
        const v = kv[1];
        callback(k, v);
    }
}
const $99a156a15cd35eb3$var$defaults = new $99a156a15cd35eb3$var$VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const $99a156a15cd35eb3$var$center = $99a156a15cd35eb3$var$defaults.align === 'middle' ? 'middle' : 'center';
function $99a156a15cd35eb3$var$parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    const oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        const ts = $99a156a15cd35eb3$var$parseTimeStamp(input);
        if (ts === null) throw new Error('Malformed timestamp: ' + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, '');
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        const settings = new $99a156a15cd35eb3$var$Settings();
        $99a156a15cd35eb3$var$parseOptions(input, function(k, v) {
            let vals;
            switch(k){
                case 'region':
                    // Find the last region we parsed with the same region id.
                    for(let i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case 'vertical':
                    settings.alt(k, v, [
                        'rl',
                        'lr'
                    ]);
                    break;
                case 'line':
                    vals = v.split(',');
                    settings.integer(k, vals[0]);
                    if (settings.percent(k, vals[0])) settings.set('snapToLines', false);
                    settings.alt(k, vals[0], [
                        'auto'
                    ]);
                    if (vals.length === 2) settings.alt('lineAlign', vals[1], [
                        'start',
                        $99a156a15cd35eb3$var$center,
                        'end'
                    ]);
                    break;
                case 'position':
                    vals = v.split(',');
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt('positionAlign', vals[1], [
                        'start',
                        $99a156a15cd35eb3$var$center,
                        'end',
                        'line-left',
                        'line-right',
                        'auto'
                    ]);
                    break;
                case 'size':
                    settings.percent(k, v);
                    break;
                case 'align':
                    settings.alt(k, v, [
                        'start',
                        $99a156a15cd35eb3$var$center,
                        'end',
                        'left',
                        'right'
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get('region', null);
        cue.vertical = settings.get('vertical', '');
        let line = settings.get('line', 'auto');
        if (line === 'auto' && $99a156a15cd35eb3$var$defaults.line === -1) // set numeric line number for Safari
        line = -1;
        cue.line = line;
        cue.lineAlign = settings.get('lineAlign', 'start');
        cue.snapToLines = settings.get('snapToLines', true);
        cue.size = settings.get('size', 100);
        cue.align = settings.get('align', $99a156a15cd35eb3$var$center);
        let position = settings.get('position', 'auto');
        if (position === 'auto' && $99a156a15cd35eb3$var$defaults.position === 50) // set numeric position for Safari
        position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
        cue.position = position;
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, '');
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.slice(0, 3) !== '-->') // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.slice(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
function $99a156a15cd35eb3$var$fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, '\n');
}
class $99a156a15cd35eb3$var$VTTParser {
    constructor(){
        this.state = 'INITIAL';
        this.buffer = '';
        this.decoder = new $99a156a15cd35eb3$var$StringDecoder();
        this.regionList = [];
        this.cue = null;
        this.oncue = void 0;
        this.onparsingerror = void 0;
        this.onflush = void 0;
    }
    parse(data) {
        const _this = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        _this.buffer += _this.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            let buffer = _this.buffer;
            let pos = 0;
            buffer = $99a156a15cd35eb3$var$fixLineBreaks(buffer);
            while(pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n')++pos;
            const line = buffer.slice(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') ++pos;
            if (buffer[pos] === '\n') ++pos;
            _this.buffer = buffer.slice(pos);
            return line;
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            $99a156a15cd35eb3$var$parseOptions(input, function(k, v) {
            // switch (k) {
            // case 'region':
            // 3.3 WebVTT region metadata header syntax
            // console.log('parse region', v);
            // parseRegion(v);
            // break;
            // }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            let line = '';
            if (_this.state === 'INITIAL') {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                line = collectNextLine();
                // strip of UTF-8 BOM if any
                // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!(m != null && m[0])) throw new Error('Malformed WebVTT signature.');
                _this.state = 'HEADER';
            }
            let alreadyCollectedLine = false;
            while(_this.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(_this.state){
                    case 'HEADER':
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        _this.state = 'ID';
                        continue;
                    case 'NOTE':
                        // Ignore NOTE blocks.
                        if (!line) _this.state = 'ID';
                        continue;
                    case 'ID':
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            _this.state = 'NOTE';
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        _this.cue = new $99a156a15cd35eb3$var$VTTCue(0, 0, '');
                        _this.state = 'CUE';
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf('-->') === -1) {
                            _this.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /* falls through */ case 'CUE':
                        // 40 - Collect cue timings and settings.
                        if (!_this.cue) {
                            _this.state = 'BADCUE';
                            continue;
                        }
                        try {
                            $99a156a15cd35eb3$var$parseCue(line, _this.cue, _this.regionList);
                        } catch (e) {
                            // In case of an error ignore rest of the cue.
                            _this.cue = null;
                            _this.state = 'BADCUE';
                            continue;
                        }
                        _this.state = 'CUETEXT';
                        continue;
                    case 'CUETEXT':
                        {
                            const hasSubstring = line.indexOf('-->') !== -1;
                            // 34 - If we have an empty line then report the cue.
                            // 35 - If we have the special substring '-->' then report the cue,
                            // but do not collect the line as we need to process the current
                            // one as a new cue.
                            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                                // We are done parsing self cue.
                                if (_this.oncue && _this.cue) _this.oncue(_this.cue);
                                _this.cue = null;
                                _this.state = 'ID';
                                continue;
                            }
                            if (_this.cue === null) continue;
                            if (_this.cue.text) _this.cue.text += '\n';
                            _this.cue.text += line;
                        }
                        continue;
                    case 'BADCUE':
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) _this.state = 'ID';
                }
            }
        } catch (e) {
            // If we are currently parsing a cue, report what we have.
            if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) _this.oncue(_this.cue);
            _this.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
        }
        return this;
    }
    flush() {
        const _this = this;
        try {
            // Finish decoding the stream.
            // _this.buffer += _this.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (_this.cue || _this.state === 'HEADER') {
                _this.buffer += '\n\n';
                _this.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') throw new Error('Malformed WebVTT signature.');
        } catch (e) {
            if (_this.onparsingerror) _this.onparsingerror(e);
        }
        if (_this.onflush) _this.onflush();
        return this;
    }
}
const $99a156a15cd35eb3$var$LINEBREAKS = /\r\n|\n\r|\n|\r/g;
// String.prototype.startsWith is not supported in IE11
const $99a156a15cd35eb3$var$startsWith = function startsWith(inputString, searchString, position = 0) {
    return inputString.slice(position, position + searchString.length) === searchString;
};
const $99a156a15cd35eb3$var$cueString2millis = function cueString2millis(timeString) {
    let ts = parseInt(timeString.slice(-3));
    const secs = parseInt(timeString.slice(-6, -4));
    const mins = parseInt(timeString.slice(-9, -7));
    const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
    if (!$99a156a15cd35eb3$var$isFiniteNumber(ts) || !$99a156a15cd35eb3$var$isFiniteNumber(secs) || !$99a156a15cd35eb3$var$isFiniteNumber(mins) || !$99a156a15cd35eb3$var$isFiniteNumber(hours)) throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
    ts += 1000 * secs;
    ts += 60000 * mins;
    ts += 3600000 * hours;
    return ts;
};
// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function $99a156a15cd35eb3$var$generateCueId(startTime, endTime, text) {
    return $99a156a15cd35eb3$var$hash(startTime.toString()) + $99a156a15cd35eb3$var$hash(endTime.toString()) + $99a156a15cd35eb3$var$hash(text);
}
const $99a156a15cd35eb3$var$calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    let currCC = vttCCs[cc];
    let prevCC = vttCCs[currCC.prevCC];
    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }
    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while((_prevCC = prevCC) != null && _prevCC.new){
        var _prevCC;
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }
    vttCCs.presentationOffset = presentationTime;
};
function $99a156a15cd35eb3$var$parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
    const parser = new $99a156a15cd35eb3$var$VTTParser();
    // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
    // Uint8Array.prototype.reduce is not implemented in IE11
    const vttLines = $99a156a15cd35eb3$var$utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace($99a156a15cd35eb3$var$LINEBREAKS, '\n').split('\n');
    const cues = [];
    const init90kHz = initPTS ? $99a156a15cd35eb3$var$toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
    let cueTime = '00:00.000';
    let timestampMapMPEGTS = 0;
    let timestampMapLOCAL = 0;
    let parsingError;
    let inHeader = true;
    parser.oncue = function(cue) {
        // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
        const currCC = vttCCs[cc];
        let cueOffset = vttCCs.ccOffset;
        // Calculate subtitle PTS offset
        const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;
        // Update offsets for new discontinuities
        if (currCC != null && currCC.new) {
            if (timestampMapLOCAL !== undefined) // When local time is provided, offset = discontinuity start time - local time
            cueOffset = vttCCs.ccOffset = currCC.start;
            else $99a156a15cd35eb3$var$calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
        }
        if (webVttMpegTsMapOffset) {
            if (!initPTS) {
                parsingError = new Error('Missing initPTS for VTT MPEGTS');
                return;
            }
            // If we have MPEGTS, offset = presentation time + discontinuity offset
            cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
        }
        const duration = cue.endTime - cue.startTime;
        const startTime = $99a156a15cd35eb3$var$normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
        cue.startTime = Math.max(startTime, 0);
        cue.endTime = Math.max(startTime + duration, 0);
        //trim trailing webvtt block whitespaces
        const text = cue.text.trim();
        // Fix encoding of special characters
        cue.text = decodeURIComponent(encodeURIComponent(text));
        // If the cue was not assigned an id from the VTT file (line above the content), create one.
        if (!cue.id) cue.id = $99a156a15cd35eb3$var$generateCueId(cue.startTime, cue.endTime, text);
        if (cue.endTime > 0) cues.push(cue);
    };
    parser.onparsingerror = function(error) {
        parsingError = error;
    };
    parser.onflush = function() {
        if (parsingError) {
            errorCallBack(parsingError);
            return;
        }
        callBack(cues);
    };
    // Go through contents line by line.
    vttLines.forEach((line)=>{
        if (inHeader) {
            // Look for X-TIMESTAMP-MAP in header.
            if ($99a156a15cd35eb3$var$startsWith(line, 'X-TIMESTAMP-MAP=')) {
                // Once found, no more are allowed anyway, so stop searching.
                inHeader = false;
                // Extract LOCAL and MPEGTS.
                line.slice(16).split(',').forEach((timestamp)=>{
                    if ($99a156a15cd35eb3$var$startsWith(timestamp, 'LOCAL:')) cueTime = timestamp.slice(6);
                    else if ($99a156a15cd35eb3$var$startsWith(timestamp, 'MPEGTS:')) timestampMapMPEGTS = parseInt(timestamp.slice(7));
                });
                try {
                    // Convert cue time to seconds
                    timestampMapLOCAL = $99a156a15cd35eb3$var$cueString2millis(cueTime) / 1000;
                } catch (error) {
                    parsingError = error;
                }
                // Return without parsing X-TIMESTAMP-MAP line.
                return;
            } else if (line === '') inHeader = false;
        }
        // Parse line by default.
        parser.parse(line + '\n');
    });
    parser.flush();
}
const $99a156a15cd35eb3$var$IMSC1_CODEC = 'stpp.ttml.im1t';
// Time format: h:m:s:frames(.subframes)
const $99a156a15cd35eb3$var$HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;
// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const $99a156a15cd35eb3$var$TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const $99a156a15cd35eb3$var$textAlignToLineAlign = {
    left: 'start',
    center: 'center',
    right: 'end',
    start: 'start',
    end: 'end'
};
function $99a156a15cd35eb3$var$parseIMSC1(payload, initPTS, callBack, errorCallBack) {
    const results = $99a156a15cd35eb3$var$findBox(new Uint8Array(payload), [
        'mdat'
    ]);
    if (results.length === 0) {
        errorCallBack(new Error('Could not parse IMSC1 mdat'));
        return;
    }
    const ttmlList = results.map((mdat)=>$99a156a15cd35eb3$var$utf8ArrayToStr(mdat));
    const syncTime = $99a156a15cd35eb3$var$toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
    try {
        ttmlList.forEach((ttml)=>callBack($99a156a15cd35eb3$var$parseTTML(ttml, syncTime)));
    } catch (error) {
        errorCallBack(error);
    }
}
function $99a156a15cd35eb3$var$parseTTML(ttml, syncTime) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(ttml, 'text/xml');
    const tt = xmlDoc.getElementsByTagName('tt')[0];
    if (!tt) throw new Error('Invalid ttml');
    const defaultRateInfo = {
        frameRate: 30,
        subFrameRate: 1,
        frameRateMultiplier: 0,
        tickRate: 0
    };
    const rateInfo = Object.keys(defaultRateInfo).reduce((result, key)=>{
        result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
        return result;
    }, {});
    const trim = tt.getAttribute('xml:space') !== 'preserve';
    const styleElements = $99a156a15cd35eb3$var$collectionToDictionary($99a156a15cd35eb3$var$getElementCollection(tt, 'styling', 'style'));
    const regionElements = $99a156a15cd35eb3$var$collectionToDictionary($99a156a15cd35eb3$var$getElementCollection(tt, 'layout', 'region'));
    const cueElements = $99a156a15cd35eb3$var$getElementCollection(tt, 'body', '[begin]');
    return [].map.call(cueElements, (cueElement)=>{
        const cueText = $99a156a15cd35eb3$var$getTextContent(cueElement, trim);
        if (!cueText || !cueElement.hasAttribute('begin')) return null;
        const startTime = $99a156a15cd35eb3$var$parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
        const duration = $99a156a15cd35eb3$var$parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
        let endTime = $99a156a15cd35eb3$var$parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
        if (startTime === null) throw $99a156a15cd35eb3$var$timestampParsingError(cueElement);
        if (endTime === null) {
            if (duration === null) throw $99a156a15cd35eb3$var$timestampParsingError(cueElement);
            endTime = startTime + duration;
        }
        const cue = new $99a156a15cd35eb3$var$VTTCue(startTime - syncTime, endTime - syncTime, cueText);
        cue.id = $99a156a15cd35eb3$var$generateCueId(cue.startTime, cue.endTime, cue.text);
        const region = regionElements[cueElement.getAttribute('region')];
        const style = styleElements[cueElement.getAttribute('style')];
        // Apply styles to cue
        const styles = $99a156a15cd35eb3$var$getTtmlStyles(region, style, styleElements);
        const { textAlign: textAlign } = styles;
        if (textAlign) {
            // cue.positionAlign not settable in FF~2016
            const lineAlign = $99a156a15cd35eb3$var$textAlignToLineAlign[textAlign];
            if (lineAlign) cue.lineAlign = lineAlign;
            cue.align = textAlign;
        }
        $99a156a15cd35eb3$var$_extends(cue, styles);
        return cue;
    }).filter((cue)=>cue !== null);
}
function $99a156a15cd35eb3$var$getElementCollection(fromElement, parentName, childName) {
    const parent = fromElement.getElementsByTagName(parentName)[0];
    if (parent) return [].slice.call(parent.querySelectorAll(childName));
    return [];
}
function $99a156a15cd35eb3$var$collectionToDictionary(elementsWithId) {
    return elementsWithId.reduce((dict, element)=>{
        const id = element.getAttribute('xml:id');
        if (id) dict[id] = element;
        return dict;
    }, {});
}
function $99a156a15cd35eb3$var$getTextContent(element, trim) {
    return [].slice.call(element.childNodes).reduce((str, node, i)=>{
        var _node$childNodes;
        if (node.nodeName === 'br' && i) return str + '\n';
        if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) return $99a156a15cd35eb3$var$getTextContent(node, trim);
        else if (trim) return str + node.textContent.trim().replace(/\s+/g, ' ');
        return str + node.textContent;
    }, '');
}
function $99a156a15cd35eb3$var$getTtmlStyles(region, style, styleElements) {
    const ttsNs = 'http://www.w3.org/ns/ttml#styling';
    let regionStyle = null;
    const styleAttributes = [
        'displayAlign',
        'textAlign',
        'color',
        'backgroundColor',
        'fontSize',
        'fontFamily'
    ];
    const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
    if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) regionStyle = styleElements[regionStyleName];
    return styleAttributes.reduce((styles, name)=>{
        const value = $99a156a15cd35eb3$var$getAttributeNS(style, ttsNs, name) || $99a156a15cd35eb3$var$getAttributeNS(region, ttsNs, name) || $99a156a15cd35eb3$var$getAttributeNS(regionStyle, ttsNs, name);
        if (value) styles[name] = value;
        return styles;
    }, {});
}
function $99a156a15cd35eb3$var$getAttributeNS(element, ns, name) {
    if (!element) return null;
    return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function $99a156a15cd35eb3$var$timestampParsingError(node) {
    return new Error(`Could not parse ttml timestamp ${node}`);
}
function $99a156a15cd35eb3$var$parseTtmlTime(timeAttributeValue, rateInfo) {
    if (!timeAttributeValue) return null;
    let seconds = $99a156a15cd35eb3$var$parseTimeStamp(timeAttributeValue);
    if (seconds === null) {
        if ($99a156a15cd35eb3$var$HMSF_REGEX.test(timeAttributeValue)) seconds = $99a156a15cd35eb3$var$parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
        else if ($99a156a15cd35eb3$var$TIME_UNIT_REGEX.test(timeAttributeValue)) seconds = $99a156a15cd35eb3$var$parseTimeUnits(timeAttributeValue, rateInfo);
    }
    return seconds;
}
function $99a156a15cd35eb3$var$parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
    const m = $99a156a15cd35eb3$var$HMSF_REGEX.exec(timeAttributeValue);
    const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
    return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function $99a156a15cd35eb3$var$parseTimeUnits(timeAttributeValue, rateInfo) {
    const m = $99a156a15cd35eb3$var$TIME_UNIT_REGEX.exec(timeAttributeValue);
    const value = Number(m[1]);
    const unit = m[2];
    switch(unit){
        case 'h':
            return value * 3600;
        case 'm':
            return value * 60;
        case 'ms':
            return value * 1000;
        case 'f':
            return value / rateInfo.frameRate;
        case 't':
            return value / rateInfo.tickRate;
    }
    return value;
}
class $99a156a15cd35eb3$var$OutputFilter {
    constructor(timelineController, trackName){
        this.timelineController = void 0;
        this.cueRanges = [];
        this.trackName = void 0;
        this.startTime = null;
        this.endTime = null;
        this.screen = null;
        this.timelineController = timelineController;
        this.trackName = trackName;
    }
    dispatchCue() {
        if (this.startTime === null) return;
        this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
        this.startTime = null;
    }
    newCue(startTime, endTime, screen) {
        if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;
        this.endTime = endTime;
        this.screen = screen;
        this.timelineController.createCaptionsTrack(this.trackName);
    }
    reset() {
        this.cueRanges = [];
        this.startTime = null;
    }
}
class $99a156a15cd35eb3$export$33d15e092164e5ef {
    constructor(hls){
        this.hls = void 0;
        this.media = null;
        this.config = void 0;
        this.enabled = true;
        this.Cues = void 0;
        this.textTracks = [];
        this.tracks = [];
        this.initPTS = [];
        this.unparsedVttFrags = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.cea608Parser1 = void 0;
        this.cea608Parser2 = void 0;
        this.lastCc = -1;
        // Last video (CEA-608) fragment CC
        this.lastSn = -1;
        // Last video (CEA-608) fragment MSN
        this.lastPartIndex = -1;
        // Last video (CEA-608) fragment Part Index
        this.prevCC = -1;
        // Last subtitle fragment CC
        this.vttCCs = $99a156a15cd35eb3$var$newVTTCCs();
        this.captionsProperties = void 0;
        this.hls = hls;
        this.config = hls.config;
        this.Cues = hls.config.cueHandler;
        this.captionsProperties = {
            textTrack1: {
                label: this.config.captionsTextTrack1Label,
                languageCode: this.config.captionsTextTrack1LanguageCode
            },
            textTrack2: {
                label: this.config.captionsTextTrack2Label,
                languageCode: this.config.captionsTextTrack2LanguageCode
            },
            textTrack3: {
                label: this.config.captionsTextTrack3Label,
                languageCode: this.config.captionsTextTrack3LanguageCode
            },
            textTrack4: {
                label: this.config.captionsTextTrack4Label,
                languageCode: this.config.captionsTextTrack4LanguageCode
            }
        };
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    destroy() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        // @ts-ignore
        this.hls = this.config = this.media = null;
        this.cea608Parser1 = this.cea608Parser2 = undefined;
    }
    initCea608Parsers() {
        const channel1 = new $99a156a15cd35eb3$var$OutputFilter(this, 'textTrack1');
        const channel2 = new $99a156a15cd35eb3$var$OutputFilter(this, 'textTrack2');
        const channel3 = new $99a156a15cd35eb3$var$OutputFilter(this, 'textTrack3');
        const channel4 = new $99a156a15cd35eb3$var$OutputFilter(this, 'textTrack4');
        this.cea608Parser1 = new $99a156a15cd35eb3$var$Cea608Parser(1, channel1, channel2);
        this.cea608Parser2 = new $99a156a15cd35eb3$var$Cea608Parser(3, channel3, channel4);
    }
    addCues(trackName, startTime, endTime, screen, cueRanges) {
        // skip cues which overlap more than 50% with previously parsed time ranges
        let merged = false;
        for(let i = cueRanges.length; i--;){
            const cueRange = cueRanges[i];
            const overlap = $99a156a15cd35eb3$var$intersection(cueRange[0], cueRange[1], startTime, endTime);
            if (overlap >= 0) {
                cueRange[0] = Math.min(cueRange[0], startTime);
                cueRange[1] = Math.max(cueRange[1], endTime);
                merged = true;
                if (overlap / (endTime - startTime) > 0.5) return;
            }
        }
        if (!merged) cueRanges.push([
            startTime,
            endTime
        ]);
        if (this.config.renderTextTracksNatively) {
            const track = this.captionsTracks[trackName];
            this.Cues.newCue(track, startTime, endTime, screen);
        } else {
            const cues = this.Cues.newCue(null, startTime, endTime, screen);
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.CUES_PARSED, {
                type: 'captions',
                cues: cues,
                track: trackName
            });
        }
    }
    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
    onInitPtsFound(event, { frag: frag, id: id, initPTS: initPTS, timescale: timescale }) {
        const { unparsedVttFrags: unparsedVttFrags } = this;
        if (id === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN) this.initPTS[frag.cc] = {
            baseTime: initPTS,
            timescale: timescale
        };
        // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
        // Parse any unparsed fragments upon receiving the initial PTS.
        if (unparsedVttFrags.length) {
            this.unparsedVttFrags = [];
            unparsedVttFrags.forEach((frag)=>{
                this.onFragLoaded($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, frag);
            });
        }
    }
    getExistingTrack(label, language) {
        const { media: media } = this;
        if (media) for(let i = 0; i < media.textTracks.length; i++){
            const textTrack = media.textTracks[i];
            if ($99a156a15cd35eb3$var$canReuseVttTextTrack(textTrack, {
                name: label,
                lang: language,
                characteristics: 'transcribes-spoken-dialog,describes-music-and-sound'
            })) return textTrack;
        }
        return null;
    }
    createCaptionsTrack(trackName) {
        if (this.config.renderTextTracksNatively) this.createNativeTrack(trackName);
        else this.createNonNativeTrack(trackName);
    }
    createNativeTrack(trackName) {
        if (this.captionsTracks[trackName]) return;
        const { captionsProperties: captionsProperties, captionsTracks: captionsTracks, media: media } = this;
        const { label: label, languageCode: languageCode } = captionsProperties[trackName];
        // Enable reuse of existing text track.
        const existingTrack = this.getExistingTrack(label, languageCode);
        if (!existingTrack) {
            const textTrack = this.createTextTrack('captions', label, languageCode);
            if (textTrack) {
                // Set a special property on the track so we know it's managed by Hls.js
                textTrack[trackName] = true;
                captionsTracks[trackName] = textTrack;
            }
        } else {
            captionsTracks[trackName] = existingTrack;
            $99a156a15cd35eb3$var$clearCurrentCues(captionsTracks[trackName]);
            $99a156a15cd35eb3$var$sendAddTrackEvent(captionsTracks[trackName], media);
        }
    }
    createNonNativeTrack(trackName) {
        if (this.nonNativeCaptionsTracks[trackName]) return;
        // Create a list of a single track for the provider to consume
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) return;
        const label = trackProperties.label;
        const track = {
            _id: trackName,
            label: label,
            kind: 'captions',
            default: trackProperties.media ? !!trackProperties.media.default : false,
            closedCaptions: trackProperties.media
        };
        this.nonNativeCaptionsTracks[trackName] = track;
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.NON_NATIVE_TEXT_TRACKS_FOUND, {
            tracks: [
                track
            ]
        });
    }
    createTextTrack(kind, label, lang) {
        const media = this.media;
        if (!media) return;
        return media.addTextTrack(kind, label, lang);
    }
    onMediaAttaching(event, data) {
        this.media = data.media;
        if (!data.mediaSource) this._cleanTracks();
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        this.media = null;
        if (transferringMedia) return;
        const { captionsTracks: captionsTracks } = this;
        Object.keys(captionsTracks).forEach((trackName)=>{
            $99a156a15cd35eb3$var$clearCurrentCues(captionsTracks[trackName]);
            delete captionsTracks[trackName];
        });
        this.nonNativeCaptionsTracks = {};
    }
    onManifestLoading() {
        // Detect discontinuity in video fragment (CEA-608) parsing
        this.lastCc = -1;
        this.lastSn = -1;
        this.lastPartIndex = -1;
        // Detect discontinuity in subtitle manifests
        this.prevCC = -1;
        this.vttCCs = $99a156a15cd35eb3$var$newVTTCCs();
        // Reset tracks
        this._cleanTracks();
        this.tracks = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.textTracks = [];
        this.unparsedVttFrags = [];
        this.initPTS = [];
        if (this.cea608Parser1 && this.cea608Parser2) {
            this.cea608Parser1.reset();
            this.cea608Parser2.reset();
        }
    }
    _cleanTracks() {
        // clear outdated subtitles
        const { media: media } = this;
        if (!media) return;
        const textTracks = media.textTracks;
        if (textTracks) for(let i = 0; i < textTracks.length; i++)$99a156a15cd35eb3$var$clearCurrentCues(textTracks[i]);
    }
    onSubtitleTracksUpdated(event, data) {
        const tracks = data.subtitleTracks || [];
        const hasIMSC1 = tracks.some((track)=>track.textCodec === $99a156a15cd35eb3$var$IMSC1_CODEC);
        if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
            const listIsIdentical = $99a156a15cd35eb3$var$subtitleOptionsIdentical(this.tracks, tracks);
            if (listIsIdentical) {
                this.tracks = tracks;
                return;
            }
            this.textTracks = [];
            this.tracks = tracks;
            if (this.config.renderTextTracksNatively) {
                const media = this.media;
                const inUseTracks = media ? $99a156a15cd35eb3$var$filterSubtitleTracks(media.textTracks) : null;
                this.tracks.forEach((track, index)=>{
                    // Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
                    let textTrack;
                    if (inUseTracks) {
                        let inUseTrack = null;
                        for(let i = 0; i < inUseTracks.length; i++)if (inUseTracks[i] && $99a156a15cd35eb3$var$canReuseVttTextTrack(inUseTracks[i], track)) {
                            inUseTrack = inUseTracks[i];
                            inUseTracks[i] = null;
                            break;
                        }
                        if (inUseTrack) textTrack = inUseTrack;
                    }
                    if (textTrack) $99a156a15cd35eb3$var$clearCurrentCues(textTrack);
                    else {
                        const textTrackKind = $99a156a15cd35eb3$var$captionsOrSubtitlesFromCharacteristics(track);
                        textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
                        if (textTrack) textTrack.mode = 'disabled';
                    }
                    if (textTrack) this.textTracks.push(textTrack);
                });
                // Warn when video element has captions or subtitle TextTracks carried over from another source
                if (inUseTracks != null && inUseTracks.length) {
                    const unusedTextTracks = inUseTracks.filter((t)=>t !== null).map((t)=>t.label);
                    if (unusedTextTracks.length) this.hls.logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(', ')}. Replace media element for each source to clear TextTracks and captions menu.`);
                }
            } else if (this.tracks.length) {
                // Create a list of tracks for the provider to consume
                const tracksList = this.tracks.map((track)=>{
                    return {
                        label: track.name,
                        kind: track.type.toLowerCase(),
                        default: track.default,
                        subtitleTrack: track
                    };
                });
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.NON_NATIVE_TEXT_TRACKS_FOUND, {
                    tracks: tracksList
                });
            }
        }
    }
    onManifestLoaded(event, data) {
        if (this.config.enableCEA708Captions && data.captions) data.captions.forEach((captionsTrack)=>{
            const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
            if (!instreamIdMatch) return;
            const trackName = `textTrack${instreamIdMatch[1]}`;
            const trackProperties = this.captionsProperties[trackName];
            if (!trackProperties) return;
            trackProperties.label = captionsTrack.name;
            if (captionsTrack.lang) // optional attribute
            trackProperties.languageCode = captionsTrack.lang;
            trackProperties.media = captionsTrack;
        });
    }
    closedCaptionsForLevel(frag) {
        const level = this.hls.levels[frag.level];
        return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
    }
    onFragLoading(event, data) {
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (this.enabled && data.frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN) {
            var _data$part$index, _data$part;
            const { cea608Parser1: cea608Parser1, cea608Parser2: cea608Parser2, lastSn: lastSn } = this;
            const { cc: cc, sn: sn } = data.frag;
            const partIndex = (_data$part$index = (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
            if (cea608Parser1 && cea608Parser2) {
                if (sn !== lastSn + 1 || sn === lastSn && partIndex !== this.lastPartIndex + 1 || cc !== this.lastCc) {
                    cea608Parser1.reset();
                    cea608Parser2.reset();
                }
            }
            this.lastCc = cc;
            this.lastSn = sn;
            this.lastPartIndex = partIndex;
        }
    }
    onFragLoaded(event, data) {
        const { frag: frag, payload: payload } = data;
        if (frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE) {
            // If fragment is subtitle type, parse as WebVTT.
            if (payload.byteLength) {
                const decryptData = frag.decryptdata;
                // fragment after decryption has a stats object
                const decrypted = 'stats' in data;
                // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                if (decryptData == null || !decryptData.encrypted || decrypted) {
                    const trackPlaylistMedia = this.tracks[frag.level];
                    const vttCCs = this.vttCCs;
                    if (!vttCCs[frag.cc]) {
                        vttCCs[frag.cc] = {
                            start: frag.start,
                            prevCC: this.prevCC,
                            new: true
                        };
                        this.prevCC = frag.cc;
                    }
                    if (trackPlaylistMedia && trackPlaylistMedia.textCodec === $99a156a15cd35eb3$var$IMSC1_CODEC) this._parseIMSC1(frag, payload);
                    else this._parseVTTs(data);
                }
            } else // In case there is no payload, finish unsuccessfully.
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: new Error('Empty subtitle payload')
            });
        }
    }
    _parseIMSC1(frag, payload) {
        const hls = this.hls;
        $99a156a15cd35eb3$var$parseIMSC1(payload, this.initPTS[frag.cc], (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            hls.logger.log(`Failed to parse IMSC1: ${error}`);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: error
            });
        });
    }
    _parseVTTs(data) {
        var _frag$initSegment;
        const { frag: frag, payload: payload } = data;
        // We need an initial synchronisation PTS. Store fragments as long as none has arrived
        const { initPTS: initPTS, unparsedVttFrags: unparsedVttFrags } = this;
        const maxAvCC = initPTS.length - 1;
        if (!initPTS[frag.cc] && maxAvCC === -1) {
            unparsedVttFrags.push(data);
            return;
        }
        const hls = this.hls;
        // Parse the WebVTT file contents.
        const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? $99a156a15cd35eb3$var$appendUint8Array(frag.initSegment.data, new Uint8Array(payload)).buffer : payload;
        $99a156a15cd35eb3$var$parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
            if (missingInitPTS) unparsedVttFrags.push(data);
            else this._fallbackToIMSC1(frag, payload);
            // Something went wrong while parsing. Trigger event with success false.
            hls.logger.log(`Failed to parse VTT cue: ${error}`);
            if (missingInitPTS && maxAvCC > frag.cc) return;
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: error
            });
        });
    }
    _fallbackToIMSC1(frag, payload) {
        // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
        const trackPlaylistMedia = this.tracks[frag.level];
        if (!trackPlaylistMedia.textCodec) $99a156a15cd35eb3$var$parseIMSC1(payload, this.initPTS[frag.cc], ()=>{
            trackPlaylistMedia.textCodec = $99a156a15cd35eb3$var$IMSC1_CODEC;
            this._parseIMSC1(frag, payload);
        }, ()=>{
            trackPlaylistMedia.textCodec = 'wvtt';
        });
    }
    _appendCues(cues, fragLevel) {
        const hls = this.hls;
        if (this.config.renderTextTracksNatively) {
            const textTrack = this.textTracks[fragLevel];
            // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
            // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
            // and trying to access getCueById method of cues will throw an exception
            // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
            if (!textTrack || textTrack.mode === 'disabled') return;
            cues.forEach((cue)=>$99a156a15cd35eb3$var$addCueToTrack(textTrack, cue));
        } else {
            const currentTrack = this.tracks[fragLevel];
            if (!currentTrack) return;
            const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.CUES_PARSED, {
                type: 'subtitles',
                cues: cues,
                track: track
            });
        }
    }
    onFragDecrypted(event, data) {
        const { frag: frag } = data;
        if (frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE) this.onFragLoaded($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, data);
    }
    onSubtitleTracksCleared() {
        this.tracks = [];
        this.captionsTracks = {};
    }
    onFragParsingUserdata(event, data) {
        if (!this.enabled || !this.config.enableCEA708Captions) return;
        const { frag: frag, samples: samples } = data;
        if (frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') return;
        // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
        // It will create the proper timestamps based on the PTS value
        for(let i = 0; i < samples.length; i++){
            const ccBytes = samples[i].bytes;
            if (ccBytes) {
                if (!this.cea608Parser1) this.initCea608Parsers();
                const ccdatas = this.extractCea608Data(ccBytes);
                this.cea608Parser1.addData(samples[i].pts, ccdatas[0]);
                this.cea608Parser2.addData(samples[i].pts, ccdatas[1]);
            }
        }
    }
    onBufferFlushing(event, { startOffset: startOffset, endOffset: endOffset, endOffsetSubtitles: endOffsetSubtitles, type: type }) {
        const { media: media } = this;
        if (!media || media.currentTime < endOffset) return;
        // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
        // Forward cues are never removed because we can loose streamed 608 content from recent fragments
        if (!type || type === 'video') {
            const { captionsTracks: captionsTracks } = this;
            Object.keys(captionsTracks).forEach((trackName)=>$99a156a15cd35eb3$var$removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
        }
        if (this.config.renderTextTracksNatively) // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
        {
            if (startOffset === 0 && endOffsetSubtitles !== undefined) {
                const { textTracks: textTracks } = this;
                Object.keys(textTracks).forEach((trackName)=>$99a156a15cd35eb3$var$removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
            }
        }
    }
    extractCea608Data(byteArray) {
        const actualCCBytes = [
            [],
            []
        ];
        const count = byteArray[0] & 0x1f;
        let position = 2;
        for(let j = 0; j < count; j++){
            const tmpByte = byteArray[position++];
            const ccbyte1 = 0x7f & byteArray[position++];
            const ccbyte2 = 0x7f & byteArray[position++];
            if (ccbyte1 === 0 && ccbyte2 === 0) continue;
            const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
            if (ccValid) {
                const ccType = 0x03 & tmpByte;
                if (0x00 /* CEA608 field1*/  === ccType || 0x01 /* CEA608 field2*/  === ccType) {
                    // Exclude CEA708 CC data.
                    actualCCBytes[ccType].push(ccbyte1);
                    actualCCBytes[ccType].push(ccbyte2);
                }
            }
        }
        return actualCCBytes;
    }
}
function $99a156a15cd35eb3$var$captionsOrSubtitlesFromCharacteristics(track) {
    if (track.characteristics) {
        if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) return 'captions';
    }
    return 'subtitles';
}
function $99a156a15cd35eb3$var$canReuseVttTextTrack(inUseTrack, manifestTrack) {
    return !!inUseTrack && inUseTrack.kind === $99a156a15cd35eb3$var$captionsOrSubtitlesFromCharacteristics(manifestTrack) && $99a156a15cd35eb3$var$subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function $99a156a15cd35eb3$var$intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
}
function $99a156a15cd35eb3$var$newVTTCCs() {
    return {
        ccOffset: 0,
        presentationOffset: 0,
        0: {
            start: 0,
            prevCC: -1,
            new: true
        }
    };
}
const $99a156a15cd35eb3$var$WHITESPACE_CHAR = /\s/;
const $99a156a15cd35eb3$export$ccfbd9d17c71f30b = {
    newCue (track, startTime, endTime, captionScreen) {
        const result = [];
        let row;
        // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
        let cue;
        let indenting;
        let indent;
        let text;
        const Cue = self.VTTCue || self.TextTrackCue;
        for(let r = 0; r < captionScreen.rows.length; r++){
            row = captionScreen.rows[r];
            indenting = true;
            indent = 0;
            text = '';
            if (!row.isEmpty()) {
                var _track$cues;
                for(let c = 0; c < row.chars.length; c++)if ($99a156a15cd35eb3$var$WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) indent++;
                else {
                    text += row.chars[c].uchar;
                    indenting = false;
                }
                // To be used for cleaning-up orphaned roll-up captions
                row.cueStartTime = startTime;
                // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                if (startTime === endTime) endTime += 0.0001;
                if (indent >= 16) indent--;
                else indent++;
                const cueText = $99a156a15cd35eb3$var$fixLineBreaks(text.trim());
                const id = $99a156a15cd35eb3$var$generateCueId(startTime, endTime, cueText);
                // If this cue already exists in the track do not push it
                if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
                    cue = new Cue(startTime, endTime, cueText);
                    cue.id = id;
                    cue.line = r + 1;
                    cue.align = 'left';
                    // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
                    // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                    // Firefox throws an exception and captions break with out of bounds 0-100 values
                    cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
                    result.push(cue);
                }
            }
        }
        if (track && result.length) {
            // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
            result.sort((cueA, cueB)=>{
                if (cueA.line === 'auto' || cueB.line === 'auto') return 0;
                if (cueA.line > 8 && cueB.line > 8) return cueB.line - cueA.line;
                return cueA.line - cueB.line;
            });
            result.forEach((cue)=>$99a156a15cd35eb3$var$addCueToTrack(track, cue));
        }
        return result;
    }
};
function $99a156a15cd35eb3$export$2ebccc4e6cb246d0() {
    if (// @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
        new self.ReadableStream({}); // eslint-disable-line no-new
        return true;
    } catch (e) {
    /* noop */ }
    return false;
}
const $99a156a15cd35eb3$var$BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class $99a156a15cd35eb3$export$199fdd2c96d97926 {
    constructor(config){
        this.fetchSetup = void 0;
        this.requestTimeout = void 0;
        this.request = null;
        this.response = null;
        this.controller = void 0;
        this.context = null;
        this.config = null;
        this.callbacks = null;
        this.stats = void 0;
        this.loader = null;
        this.fetchSetup = config.fetchSetup || $99a156a15cd35eb3$var$getRequest;
        this.controller = new self.AbortController();
        this.stats = new $99a156a15cd35eb3$export$792da06d301cf8fe();
    }
    destroy() {
        this.loader = this.callbacks = this.context = this.config = this.request = null;
        this.abortInternal();
        this.response = null;
        // @ts-ignore
        this.fetchSetup = this.controller = this.stats = null;
    }
    abortInternal() {
        if (this.controller && !this.stats.loading.end) {
            this.stats.aborted = true;
            this.controller.abort();
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.response);
    }
    load(context, config, callbacks) {
        const stats = this.stats;
        if (stats.loading.start) throw new Error('Loader can only be used once.');
        stats.loading.start = self.performance.now();
        const initParams = $99a156a15cd35eb3$var$getRequestParameters(context, this.controller.signal);
        const isArrayBuffer = context.responseType === 'arraybuffer';
        const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
        const { maxTimeToFirstByteMs: maxTimeToFirstByteMs, maxLoadTimeMs: maxLoadTimeMs } = config.loadPolicy;
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.request = this.fetchSetup(context, initParams);
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && $99a156a15cd35eb3$var$isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(()=>{
            if (this.callbacks) {
                this.abortInternal();
                this.callbacks.onTimeout(stats, context, this.response);
            }
        }, config.timeout);
        const fetchPromise = $99a156a15cd35eb3$var$isPromise(this.request) ? this.request.then(self.fetch) : self.fetch(this.request);
        fetchPromise.then((response)=>{
            var _this$callbacks2;
            this.response = this.loader = response;
            const first = Math.max(self.performance.now(), stats.loading.start);
            self.clearTimeout(this.requestTimeout);
            config.timeout = maxLoadTimeMs;
            this.requestTimeout = self.setTimeout(()=>{
                if (this.callbacks) {
                    this.abortInternal();
                    this.callbacks.onTimeout(stats, context, this.response);
                }
            }, maxLoadTimeMs - (first - stats.loading.start));
            if (!response.ok) {
                const { status: status1, statusText: statusText } = response;
                throw new $99a156a15cd35eb3$var$FetchError(statusText || 'fetch, bad network response', status1, response);
            }
            stats.loading.first = first;
            stats.total = $99a156a15cd35eb3$var$getContentLength(response.headers) || stats.total;
            const onProgress = (_this$callbacks2 = this.callbacks) == null ? void 0 : _this$callbacks2.onProgress;
            if (onProgress && $99a156a15cd35eb3$var$isFiniteNumber(config.highWaterMark)) return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
            if (isArrayBuffer) return response.arrayBuffer();
            if (context.responseType === 'json') return response.json();
            return response.text();
        }).then((responseData)=>{
            var _this$callbacks3, _this$callbacks4;
            const response = this.response;
            if (!response) throw new Error('loader destroyed');
            self.clearTimeout(this.requestTimeout);
            stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
            const total = responseData[LENGTH];
            if (total) stats.loaded = stats.total = total;
            const loaderResponse = {
                url: response.url,
                data: responseData,
                code: response.status
            };
            const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
            if (onProgress && !$99a156a15cd35eb3$var$isFiniteNumber(config.highWaterMark)) onProgress(stats, context, responseData, response);
            (_this$callbacks4 = this.callbacks) == null || _this$callbacks4.onSuccess(loaderResponse, stats, context, response);
        }).catch((error)=>{
            var _this$callbacks5;
            self.clearTimeout(this.requestTimeout);
            if (stats.aborted) return;
            // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
            // when destroying, 'error' itself can be undefined
            const code = !error ? 0 : error.code || 0;
            const text = !error ? null : error.message;
            (_this$callbacks5 = this.callbacks) == null || _this$callbacks5.onError({
                code: code,
                text: text
            }, context, error ? error.details : null, stats);
        });
    }
    getCacheAge() {
        let result = null;
        if (this.response) {
            const ageHeader = this.response.headers.get('age');
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        return this.response ? this.response.headers.get(name) : null;
    }
    loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
        const chunkCache = new $99a156a15cd35eb3$var$ChunkCache();
        const reader = response.body.getReader();
        const pump = ()=>{
            return reader.read().then((data)=>{
                if (data.done) {
                    if (chunkCache.dataLength) onProgress(stats, context, chunkCache.flush().buffer, response);
                    return Promise.resolve(new ArrayBuffer(0));
                }
                const chunk = data.value;
                const len = chunk.length;
                stats.loaded += len;
                if (len < highWaterMark || chunkCache.dataLength) {
                    // The current chunk is too small to to be emitted or the cache already has data
                    // Push it to the cache
                    chunkCache.push(chunk);
                    if (chunkCache.dataLength >= highWaterMark) // flush in order to join the typed arrays
                    onProgress(stats, context, chunkCache.flush().buffer, response);
                } else // If there's nothing cached already, and the chache is large enough
                // just emit the progress event
                onProgress(stats, context, chunk.buffer, response);
                return pump();
            }).catch(()=>{
                /* aborted */ return Promise.reject();
            });
        };
        return pump();
    }
}
function $99a156a15cd35eb3$var$getRequestParameters(context, signal) {
    const initParams = {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        signal: signal,
        headers: new self.Headers($99a156a15cd35eb3$var$_extends({}, context.headers))
    };
    if (context.rangeEnd) initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
    return initParams;
}
function $99a156a15cd35eb3$var$getByteRangeLength(byteRangeHeader) {
    const result = $99a156a15cd35eb3$var$BYTERANGE.exec(byteRangeHeader);
    if (result) return parseInt(result[2]) - parseInt(result[1]) + 1;
}
function $99a156a15cd35eb3$var$getContentLength(headers) {
    const contentRange = headers.get('Content-Range');
    if (contentRange) {
        const byteRangeLength = $99a156a15cd35eb3$var$getByteRangeLength(contentRange);
        if ($99a156a15cd35eb3$var$isFiniteNumber(byteRangeLength)) return byteRangeLength;
    }
    const contentLength = headers.get('Content-Length');
    if (contentLength) return parseInt(contentLength);
}
function $99a156a15cd35eb3$var$getRequest(context, initParams) {
    return new self.Request(context.url, initParams);
}
class $99a156a15cd35eb3$var$FetchError extends Error {
    constructor(message, code, details){
        super(message);
        this.code = void 0;
        this.details = void 0;
        this.code = code;
        this.details = details;
    }
}
const $99a156a15cd35eb3$var$AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class $99a156a15cd35eb3$export$82bde069796904e9 {
    constructor(config){
        this.xhrSetup = void 0;
        this.requestTimeout = void 0;
        this.retryTimeout = void 0;
        this.retryDelay = void 0;
        this.config = null;
        this.callbacks = null;
        this.context = null;
        this.loader = null;
        this.stats = void 0;
        this.xhrSetup = config ? config.xhrSetup || null : null;
        this.stats = new $99a156a15cd35eb3$export$792da06d301cf8fe();
        this.retryDelay = 0;
    }
    destroy() {
        this.callbacks = null;
        this.abortInternal();
        this.loader = null;
        this.config = null;
        this.context = null;
        this.xhrSetup = null;
    }
    abortInternal() {
        const loader = this.loader;
        self.clearTimeout(this.requestTimeout);
        self.clearTimeout(this.retryTimeout);
        if (loader) {
            loader.onreadystatechange = null;
            loader.onprogress = null;
            if (loader.readyState !== 4) {
                this.stats.aborted = true;
                loader.abort();
            }
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
    load(context, config, callbacks) {
        if (this.stats.loading.start) throw new Error('Loader can only be used once.');
        this.stats.loading.start = self.performance.now();
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.loadInternal();
    }
    loadInternal() {
        const { config: config, context: context } = this;
        if (!config || !context) return;
        const xhr = this.loader = new self.XMLHttpRequest();
        const stats = this.stats;
        stats.loading.first = 0;
        stats.loaded = 0;
        stats.aborted = false;
        const xhrSetup = this.xhrSetup;
        if (xhrSetup) Promise.resolve().then(()=>{
            if (this.loader !== xhr || this.stats.aborted) return;
            return xhrSetup(xhr, context.url);
        }).catch((error)=>{
            if (this.loader !== xhr || this.stats.aborted) return;
            xhr.open('GET', context.url, true);
            return xhrSetup(xhr, context.url);
        }).then(()=>{
            if (this.loader !== xhr || this.stats.aborted) return;
            this.openAndSendXhr(xhr, context, config);
        }).catch((error)=>{
            var _this$callbacks2;
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            (_this$callbacks2 = this.callbacks) == null || _this$callbacks2.onError({
                code: xhr.status,
                text: error.message
            }, context, xhr, stats);
            return;
        });
        else this.openAndSendXhr(xhr, context, config);
    }
    openAndSendXhr(xhr, context, config) {
        if (!xhr.readyState) xhr.open('GET', context.url, true);
        const headers = context.headers;
        const { maxTimeToFirstByteMs: maxTimeToFirstByteMs, maxLoadTimeMs: maxLoadTimeMs } = config.loadPolicy;
        if (headers) for(const header in headers)xhr.setRequestHeader(header, headers[header]);
        if (context.rangeEnd) xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
        xhr.onreadystatechange = this.readystatechange.bind(this);
        xhr.onprogress = this.loadprogress.bind(this);
        xhr.responseType = context.responseType;
        // setup timeout before we perform request
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && $99a156a15cd35eb3$var$isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
        xhr.send();
    }
    readystatechange() {
        const { context: context, loader: xhr, stats: stats } = this;
        if (!context || !xhr) return;
        const readyState = xhr.readyState;
        const config = this.config;
        // don't proceed if xhr has been aborted
        if (stats.aborted) return;
        // >= HEADERS_RECEIVED
        if (readyState >= 2) {
            if (stats.loading.first === 0) {
                stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
                // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
                    self.clearTimeout(this.requestTimeout);
                    config.timeout = config.loadPolicy.maxLoadTimeMs;
                    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
                }
            }
            if (readyState === 4) {
                self.clearTimeout(this.requestTimeout);
                xhr.onreadystatechange = null;
                xhr.onprogress = null;
                const status1 = xhr.status;
                // http status between 200 to 299 are all successful
                const useResponseText = xhr.responseType === 'text' ? xhr.responseText : null;
                if (status1 >= 200 && status1 < 300) {
                    const data = useResponseText != null ? useResponseText : xhr.response;
                    if (data != null) {
                        var _this$callbacks3, _this$callbacks4;
                        stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
                        const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
                        stats.loaded = stats.total = len;
                        stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
                        const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
                        if (onProgress) onProgress(stats, context, data, xhr);
                        const _response = {
                            url: xhr.responseURL,
                            data: data,
                            code: status1
                        };
                        (_this$callbacks4 = this.callbacks) == null || _this$callbacks4.onSuccess(_response, stats, context, xhr);
                        return;
                    }
                }
                // Handle bad status or nullish response
                const retryConfig = config.loadPolicy.errorRetry;
                const retryCount = stats.retry;
                // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                const response = {
                    url: context.url,
                    data: undefined,
                    code: status1
                };
                if ($99a156a15cd35eb3$var$shouldRetry(retryConfig, retryCount, false, response)) this.retry(retryConfig);
                else {
                    var _this$callbacks5;
                    $99a156a15cd35eb3$var$logger.error(`${status1} while loading ${context.url}`);
                    (_this$callbacks5 = this.callbacks) == null || _this$callbacks5.onError({
                        code: status1,
                        text: xhr.statusText
                    }, context, xhr, stats);
                }
            }
        }
    }
    loadtimeout() {
        if (!this.config) return;
        const retryConfig = this.config.loadPolicy.timeoutRetry;
        const retryCount = this.stats.retry;
        if ($99a156a15cd35eb3$var$shouldRetry(retryConfig, retryCount, true)) this.retry(retryConfig);
        else {
            var _this$context;
            $99a156a15cd35eb3$var$logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
            const callbacks = this.callbacks;
            if (callbacks) {
                this.abortInternal();
                callbacks.onTimeout(this.stats, this.context, this.loader);
            }
        }
    }
    retry(retryConfig) {
        const { context: context, stats: stats } = this;
        this.retryDelay = $99a156a15cd35eb3$var$getRetryDelay(retryConfig, stats.retry);
        stats.retry++;
        $99a156a15cd35eb3$var$logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
        // abort and reset internal state
        this.abortInternal();
        this.loader = null;
        // schedule retry
        self.clearTimeout(this.retryTimeout);
        this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
    }
    loadprogress(event) {
        const stats = this.stats;
        stats.loaded = event.loaded;
        if (event.lengthComputable) stats.total = event.total;
    }
    getCacheAge() {
        let result = null;
        if (this.loader && $99a156a15cd35eb3$var$AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
            const ageHeader = this.loader.getResponseHeader('age');
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) return this.loader.getResponseHeader(name);
        return null;
    }
}
/**
 * @deprecated use fragLoadPolicy.default
 */ /**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */ const $99a156a15cd35eb3$var$defaultLoadPolicy = {
    maxTimeToFirstByteMs: 8000,
    maxLoadTimeMs: 20000,
    timeoutRetry: null,
    errorRetry: null
};
/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */ const $99a156a15cd35eb3$var$hlsDefaultConfig = $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({
    autoStartLoad: true,
    // used by stream-controller
    startPosition: -1,
    // used by stream-controller
    defaultAudioCodec: undefined,
    // used by stream-controller
    debug: false,
    // used by logger
    capLevelOnFPSDrop: false,
    // used by fps-controller
    capLevelToPlayerSize: false,
    // used by cap-level-controller
    ignoreDevicePixelRatio: false,
    // used by cap-level-controller
    maxDevicePixelRatio: Number.POSITIVE_INFINITY,
    // used by cap-level-controller
    preferManagedMediaSource: true,
    initialLiveManifestSize: 1,
    // used by stream-controller
    maxBufferLength: 30,
    // used by stream-controller
    backBufferLength: Infinity,
    // used by buffer-controller
    frontBufferFlushThreshold: Infinity,
    startOnSegmentBoundary: false,
    // used by stream-controller
    maxBufferSize: 60000000,
    // used by stream-controller
    maxFragLookUpTolerance: 0.25,
    // used by stream-controller
    maxBufferHole: 0.1,
    // used by stream-controller and gap-controller
    detectStallWithCurrentTimeMs: 1250,
    // used by gap-controller
    highBufferWatchdogPeriod: 2,
    // used by gap-controller
    nudgeOffset: 0.1,
    // used by gap-controller
    nudgeMaxRetry: 3,
    // used by gap-controller
    nudgeOnVideoHole: true,
    // used by gap-controller
    liveSyncMode: 'edge',
    // used by stream-controller
    liveSyncDurationCount: 3,
    // used by latency-controller
    liveSyncOnStallIncrease: 1,
    // used by latency-controller
    liveMaxLatencyDurationCount: Infinity,
    // used by latency-controller
    liveSyncDuration: undefined,
    // used by latency-controller
    liveMaxLatencyDuration: undefined,
    // used by latency-controller
    maxLiveSyncPlaybackRate: 1,
    // used by latency-controller
    liveDurationInfinity: false,
    // used by buffer-controller
    /**
   * @deprecated use backBufferLength
   */ liveBackBufferLength: null,
    // used by buffer-controller
    maxMaxBufferLength: 600,
    // used by stream-controller
    enableWorker: true,
    // used by transmuxer
    workerPath: null,
    // used by transmuxer
    enableSoftwareAES: true,
    // used by decrypter
    startLevel: undefined,
    // used by level-controller
    startFragPrefetch: false,
    // used by stream-controller
    fpsDroppedMonitoringPeriod: 5000,
    // used by fps-controller
    fpsDroppedMonitoringThreshold: 0.2,
    // used by fps-controller
    appendErrorMaxRetry: 3,
    // used by buffer-controller
    ignorePlaylistParsingErrors: false,
    loader: $99a156a15cd35eb3$export$82bde069796904e9,
    // loader: FetchLoader,
    fLoader: undefined,
    // used by fragment-loader
    pLoader: undefined,
    // used by playlist-loader
    xhrSetup: undefined,
    // used by xhr-loader
    licenseXhrSetup: undefined,
    // used by eme-controller
    licenseResponseCallback: undefined,
    // used by eme-controller
    abrController: $99a156a15cd35eb3$export$264ac4b6e832e14e,
    bufferController: $99a156a15cd35eb3$export$2057e53fd83d2d77,
    capLevelController: $99a156a15cd35eb3$export$24bc69225d44061c,
    errorController: $99a156a15cd35eb3$export$2f5b22783539ff2,
    fpsController: $99a156a15cd35eb3$export$ca3da7ea73955a38,
    stretchShortVideoTrack: false,
    // used by mp4-remuxer
    maxAudioFramesDrift: 1,
    // used by mp4-remuxer
    forceKeyFrameOnDiscontinuity: true,
    // used by ts-demuxer
    abrEwmaFastLive: 3,
    // used by abr-controller
    abrEwmaSlowLive: 9,
    // used by abr-controller
    abrEwmaFastVoD: 3,
    // used by abr-controller
    abrEwmaSlowVoD: 9,
    // used by abr-controller
    abrEwmaDefaultEstimate: 5e5,
    // 500 kbps  // used by abr-controller
    abrEwmaDefaultEstimateMax: 5e6,
    // 5 mbps
    abrBandWidthFactor: 0.95,
    // used by abr-controller
    abrBandWidthUpFactor: 0.7,
    // used by abr-controller
    abrMaxWithRealBitrate: false,
    // used by abr-controller
    maxStarvationDelay: 4,
    // used by abr-controller
    maxLoadingDelay: 4,
    // used by abr-controller
    minAutoBitrate: 0,
    // used by hls
    emeEnabled: false,
    // used by eme-controller
    widevineLicenseUrl: undefined,
    // used by eme-controller
    drmSystems: {},
    // used by eme-controller
    drmSystemOptions: {},
    // used by eme-controller
    requestMediaKeySystemAccessFunc: $99a156a15cd35eb3$export$fd6ce47fe824665a,
    // used by eme-controller
    requireKeySystemAccessOnStart: false,
    // used by eme-controller
    testBandwidth: true,
    progressive: false,
    lowLatencyMode: true,
    cmcd: undefined,
    enableDateRangeMetadataCues: true,
    enableEmsgMetadataCues: true,
    enableEmsgKLVMetadata: false,
    enableID3MetadataCues: true,
    enableInterstitialPlayback: true,
    interstitialAppendInPlace: true,
    interstitialLiveLookAhead: 10,
    useMediaCapabilities: true,
    preserveManualLevelOnError: false,
    certLoadPolicy: {
        default: $99a156a15cd35eb3$var$defaultLoadPolicy
    },
    keyLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 8000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: 'linear'
            },
            errorRetry: {
                maxNumRetry: 8,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: 'linear'
            }
        }
    },
    manifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: Infinity,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    playlistLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 2,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    fragLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 120000,
            timeoutRetry: {
                maxNumRetry: 4,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 6,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    steeringManifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    interstitialAssetListLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 30000,
            timeoutRetry: {
                maxNumRetry: 0,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 0,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    // These default settings are deprecated in favor of the above policies
    // and are maintained for backwards compatibility
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 64000,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 64000,
    fragLoadingTimeOut: 20000,
    fragLoadingMaxRetry: 6,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 64000
}, $99a156a15cd35eb3$var$timelineConfig()), {}, {
    subtitleStreamController: $99a156a15cd35eb3$export$507c2c1b84e7d645,
    subtitleTrackController: $99a156a15cd35eb3$export$e287517d6ed8b132,
    timelineController: $99a156a15cd35eb3$export$33d15e092164e5ef,
    audioStreamController: $99a156a15cd35eb3$export$352c47a33fc91a8b,
    audioTrackController: $99a156a15cd35eb3$export$befb88bd9e19246,
    emeController: $99a156a15cd35eb3$export$bd16919f25cf2fc5,
    cmcdController: $99a156a15cd35eb3$export$953f29a3a19a03d,
    contentSteeringController: $99a156a15cd35eb3$export$52a61818002372cb,
    interstitialsController: $99a156a15cd35eb3$var$InterstitialsController
});
function $99a156a15cd35eb3$var$timelineConfig() {
    return {
        cueHandler: $99a156a15cd35eb3$export$ccfbd9d17c71f30b,
        // used by timeline-controller
        enableWebVTT: true,
        // used by timeline-controller
        enableIMSC1: true,
        // used by timeline-controller
        enableCEA708Captions: true,
        // used by timeline-controller
        captionsTextTrack1Label: 'English',
        // used by timeline-controller
        captionsTextTrack1LanguageCode: 'en',
        // used by timeline-controller
        captionsTextTrack2Label: 'Spanish',
        // used by timeline-controller
        captionsTextTrack2LanguageCode: 'es',
        // used by timeline-controller
        captionsTextTrack3Label: 'Unknown CC',
        // used by timeline-controller
        captionsTextTrack3LanguageCode: '',
        // used by timeline-controller
        captionsTextTrack4Label: 'Unknown CC',
        // used by timeline-controller
        captionsTextTrack4LanguageCode: '',
        // used by timeline-controller
        renderTextTracksNatively: true
    };
}
/**
 * @ignore
 */ function $99a156a15cd35eb3$var$mergeConfig(defaultConfig, userConfig, logger) {
    if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
    if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
    if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
    const defaultsCopy = $99a156a15cd35eb3$var$deepCpy(defaultConfig);
    // Backwards compatibility with deprecated config values
    const deprecatedSettingTypes = [
        'manifest',
        'level',
        'frag'
    ];
    const deprecatedSettings = [
        'TimeOut',
        'MaxRetry',
        'RetryDelay',
        'MaxRetryTimeout'
    ];
    deprecatedSettingTypes.forEach((type)=>{
        const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
        const policyNotSet = userConfig[policyName] === undefined;
        const report = [];
        deprecatedSettings.forEach((setting)=>{
            const deprecatedSetting = `${type}Loading${setting}`;
            const value = userConfig[deprecatedSetting];
            if (value !== undefined && policyNotSet) {
                report.push(deprecatedSetting);
                const settings = defaultsCopy[policyName].default;
                userConfig[policyName] = {
                    default: settings
                };
                switch(setting){
                    case 'TimeOut':
                        settings.maxLoadTimeMs = value;
                        settings.maxTimeToFirstByteMs = value;
                        break;
                    case 'MaxRetry':
                        settings.errorRetry.maxNumRetry = value;
                        settings.timeoutRetry.maxNumRetry = value;
                        break;
                    case 'RetryDelay':
                        settings.errorRetry.retryDelayMs = value;
                        settings.timeoutRetry.retryDelayMs = value;
                        break;
                    case 'MaxRetryTimeout':
                        settings.errorRetry.maxRetryDelayMs = value;
                        settings.timeoutRetry.maxRetryDelayMs = value;
                        break;
                }
            }
        });
        if (report.length) logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${$99a156a15cd35eb3$var$stringify(userConfig[policyName])}`);
    });
    return $99a156a15cd35eb3$var$_objectSpread2($99a156a15cd35eb3$var$_objectSpread2({}, defaultsCopy), userConfig);
}
function $99a156a15cd35eb3$var$deepCpy(obj) {
    if (obj && typeof obj === 'object') {
        if (Array.isArray(obj)) return obj.map($99a156a15cd35eb3$var$deepCpy);
        return Object.keys(obj).reduce((result, key)=>{
            result[key] = $99a156a15cd35eb3$var$deepCpy(obj[key]);
            return result;
        }, {});
    }
    return obj;
}
/**
 * @ignore
 */ function $99a156a15cd35eb3$var$enableStreamingMode(config, logger) {
    const currentLoader = config.loader;
    if (currentLoader !== $99a156a15cd35eb3$export$199fdd2c96d97926 && currentLoader !== $99a156a15cd35eb3$export$82bde069796904e9) {
        // If a developer has configured their own loader, respect that choice
        logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
        config.progressive = false;
    } else {
        const canStreamProgressively = $99a156a15cd35eb3$export$2ebccc4e6cb246d0();
        if (canStreamProgressively) {
            config.loader = $99a156a15cd35eb3$export$199fdd2c96d97926;
            config.progressive = true;
            config.enableSoftwareAES = true;
            logger.log('[config]: Progressive streaming enabled, using FetchLoader');
        }
    }
}
const $99a156a15cd35eb3$var$MAX_START_GAP_JUMP = 2.0;
const $99a156a15cd35eb3$var$SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const $99a156a15cd35eb3$var$SKIP_BUFFER_RANGE_START = 0.05;
const $99a156a15cd35eb3$var$TICK_INTERVAL$1 = 100;
class $99a156a15cd35eb3$var$GapController extends $99a156a15cd35eb3$var$TaskLoop {
    constructor(hls, fragmentTracker){
        super('gap-controller', hls.logger);
        this.hls = null;
        this.fragmentTracker = null;
        this.media = null;
        this.mediaSource = void 0;
        this.nudgeRetry = 0;
        this.stallReported = false;
        this.stalled = null;
        this.moved = false;
        this.seeking = false;
        this.buffered = {};
        this.lastCurrentTime = 0;
        this.ended = 0;
        this.waiting = 0;
        this.onMediaPlaying = ()=>{
            this.ended = 0;
            this.waiting = 0;
        };
        this.onMediaWaiting = ()=>{
            var _this$media;
            if ((_this$media = this.media) != null && _this$media.seeking) return;
            this.waiting = self.performance.now();
            this.tick();
        };
        this.onMediaEnded = ()=>{
            if (this.hls) {
                var _this$media2;
                // ended is set when triggering MEDIA_ENDED so that we do not trigger it again on stall or on tick with media.ended
                this.ended = ((_this$media2 = this.media) == null ? void 0 : _this$media2.currentTime) || 1;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ENDED, {
                    stalled: false
                });
            }
        };
        this.hls = hls;
        this.fragmentTracker = fragmentTracker;
        this.registerListeners();
    }
    registerListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        }
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        }
    }
    destroy() {
        super.destroy();
        this.unregisterListeners();
        this.media = this.hls = this.fragmentTracker = null;
        this.mediaSource = undefined;
    }
    onMediaAttached(event, data) {
        this.setInterval($99a156a15cd35eb3$var$TICK_INTERVAL$1);
        this.mediaSource = data.mediaSource;
        const media = this.media = data.media;
        $99a156a15cd35eb3$var$addEventListener(media, 'playing', this.onMediaPlaying);
        $99a156a15cd35eb3$var$addEventListener(media, 'waiting', this.onMediaWaiting);
        $99a156a15cd35eb3$var$addEventListener(media, 'ended', this.onMediaEnded);
    }
    onMediaDetaching(event, data) {
        this.clearInterval();
        const { media: media } = this;
        if (media) {
            $99a156a15cd35eb3$var$removeEventListener(media, 'playing', this.onMediaPlaying);
            $99a156a15cd35eb3$var$removeEventListener(media, 'waiting', this.onMediaWaiting);
            $99a156a15cd35eb3$var$removeEventListener(media, 'ended', this.onMediaEnded);
            this.media = null;
        }
        this.mediaSource = undefined;
    }
    onBufferAppended(event, data) {
        this.buffered = data.timeRanges;
    }
    get hasBuffered() {
        return Object.keys(this.buffered).length > 0;
    }
    tick() {
        var _this$media3;
        if (!((_this$media3 = this.media) != null && _this$media3.readyState) || !this.hasBuffered) return;
        const currentTime = this.media.currentTime;
        this.poll(currentTime, this.lastCurrentTime);
        this.lastCurrentTime = currentTime;
    }
    /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */ poll(currentTime, lastCurrentTime) {
        var _this$hls, _this$hls2;
        const config = (_this$hls = this.hls) == null ? void 0 : _this$hls.config;
        if (!config) return;
        const media = this.media;
        if (!media) return;
        const { seeking: seeking } = media;
        const seeked = this.seeking && !seeking;
        const beginSeek = !this.seeking && seeking;
        const pausedEndedOrHalted = media.paused && !seeking || media.ended || media.playbackRate === 0;
        this.seeking = seeking;
        // The playhead is moving, no-op
        if (currentTime !== lastCurrentTime) {
            if (lastCurrentTime) this.ended = 0;
            this.moved = true;
            if (!seeking) {
                this.nudgeRetry = 0;
                // When crossing between buffered video time ranges, but not audio, flush pipeline with seek (Chrome)
                if (config.nudgeOnVideoHole && !pausedEndedOrHalted && currentTime > lastCurrentTime) this.nudgeOnVideoHole(currentTime, lastCurrentTime);
            }
            if (this.waiting === 0) this.stallResolved(currentTime);
            return;
        }
        // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
        if (beginSeek || seeked) {
            if (seeked) this.stallResolved(currentTime);
            return;
        }
        // The playhead should not be moving
        if (pausedEndedOrHalted) {
            this.nudgeRetry = 0;
            this.stallResolved(currentTime);
            // Fire MEDIA_ENDED to workaround event not being dispatched by browser
            if (!this.ended && media.ended && this.hls) {
                this.ended = currentTime || 1;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ENDED, {
                    stalled: false
                });
            }
            return;
        }
        if (!$99a156a15cd35eb3$var$BufferHelper.getBuffered(media).length) {
            this.nudgeRetry = 0;
            return;
        }
        // Resolve stalls at buffer holes using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const nextStart = bufferInfo.nextStart || 0;
        const fragmentTracker = this.fragmentTracker;
        if (seeking && fragmentTracker && this.hls) {
            // Is there a fragment loading/parsing/appending before currentTime?
            const inFlightDependency = $99a156a15cd35eb3$var$getInFlightDependency(this.hls.inFlightFragments, currentTime);
            // Waiting for seeking in a buffered range to complete
            const hasEnoughBuffer = bufferInfo.len > $99a156a15cd35eb3$var$MAX_START_GAP_JUMP;
            // Next buffered range is too far ahead to jump to while still seeking
            const noBufferHole = !nextStart || inFlightDependency || nextStart - currentTime > $99a156a15cd35eb3$var$MAX_START_GAP_JUMP && !fragmentTracker.getPartialFragment(currentTime);
            if (hasEnoughBuffer || noBufferHole) return;
            // Reset moved state when seeking to a point in or before a gap/hole
            this.moved = false;
        }
        // Skip start gaps if we haven't played, but the last poll detected the start of a stall
        // The addition poll gives the browser a chance to jump the gap for us
        const levelDetails = (_this$hls2 = this.hls) == null ? void 0 : _this$hls2.latestLevelDetails;
        if (!this.moved && this.stalled !== null && fragmentTracker) {
            // There is no playable buffer (seeked, waiting for buffer)
            const isBuffered = bufferInfo.len > 0;
            if (!isBuffered && !nextStart) return;
            // Jump start gaps within jump threshold
            const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;
            // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
            // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
            // that begins over 1 target duration after the video start position.
            const isLive = !!(levelDetails != null && levelDetails.live);
            const maxStartGapJump = isLive ? levelDetails.targetduration * 2 : $99a156a15cd35eb3$var$MAX_START_GAP_JUMP;
            const partialOrGap = fragmentTracker.getPartialFragment(currentTime);
            if (startJump > 0 && (startJump <= maxStartGapJump || partialOrGap)) {
                if (!media.paused) this._trySkipBufferHole(partialOrGap);
                return;
            }
        }
        // Start tracking stall time
        const detectStallWithCurrentTimeMs = config.detectStallWithCurrentTimeMs;
        const tnow = self.performance.now();
        const tWaiting = this.waiting;
        let stalled = this.stalled;
        if (stalled === null) {
            // Use time of recent "waiting" event
            if (tWaiting > 0 && tnow - tWaiting < detectStallWithCurrentTimeMs) stalled = this.stalled = tWaiting;
            else {
                this.stalled = tnow;
                return;
            }
        }
        const stalledDuration = tnow - stalled;
        if (!seeking && (stalledDuration >= detectStallWithCurrentTimeMs || tWaiting) && this.hls) {
            var _this$mediaSource;
            // Dispatch MEDIA_ENDED when media.ended/ended event is not signalled at end of stream
            if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) === 'ended' && !(levelDetails != null && levelDetails.live) && Math.abs(currentTime - ((levelDetails == null ? void 0 : levelDetails.edge) || 0)) < 1) {
                if (this.ended) return;
                this.ended = currentTime || 1;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ENDED, {
                    stalled: true
                });
                return;
            }
            // Report stalling after trying to fix
            this._reportStall(bufferInfo);
            if (!this.media || !this.hls) return;
        }
        const bufferedWithHoles = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
        this._tryFixBufferStall(bufferedWithHoles, stalledDuration, currentTime);
    }
    stallResolved(currentTime) {
        const stalled = this.stalled;
        if (stalled && this.hls) {
            this.stalled = null;
            // The playhead is now moving, but was previously stalled
            if (this.stallReported) {
                const stalledDuration = self.performance.now() - stalled;
                this.log(`playback not stuck anymore @${currentTime}, after ${Math.round(stalledDuration)}ms`);
                this.stallReported = false;
                this.waiting = 0;
                this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.STALL_RESOLVED, {});
            }
        }
    }
    nudgeOnVideoHole(currentTime, lastCurrentTime) {
        var _this$buffered$audio;
        // Chrome will play one second past a hole in video buffered time ranges without rendering any video from the subsequent range and then stall as long as audio is buffered:
        // https://github.com/video-dev/hls.js/issues/5631
        // https://issues.chromium.org/issues/40280613#comment10
        // Detect the potential for this situation and proactively seek to flush the video pipeline once the playhead passes the start of the video hole.
        // When there are audio and video buffers and currentTime is past the end of the first video buffered range...
        const videoSourceBuffered = this.buffered.video;
        if (this.hls && this.media && this.fragmentTracker && (_this$buffered$audio = this.buffered.audio) != null && _this$buffered$audio.length && videoSourceBuffered && videoSourceBuffered.length > 1 && currentTime > videoSourceBuffered.end(0)) {
            // and audio is buffered at the playhead
            const audioBufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferedInfo($99a156a15cd35eb3$var$BufferHelper.timeRangesToArray(this.buffered.audio), currentTime, 0);
            if (audioBufferInfo.len > 1 && lastCurrentTime >= audioBufferInfo.start) {
                const videoTimes = $99a156a15cd35eb3$var$BufferHelper.timeRangesToArray(videoSourceBuffered);
                const lastBufferedIndex = $99a156a15cd35eb3$var$BufferHelper.bufferedInfo(videoTimes, lastCurrentTime, 0).bufferedIndex;
                // nudge when crossing into another video buffered range (hole).
                if (lastBufferedIndex > -1 && lastBufferedIndex < videoTimes.length - 1) {
                    const bufferedIndex = $99a156a15cd35eb3$var$BufferHelper.bufferedInfo(videoTimes, currentTime, 0).bufferedIndex;
                    const holeStart = videoTimes[lastBufferedIndex].end;
                    const holeEnd = videoTimes[lastBufferedIndex + 1].start;
                    if ((bufferedIndex === -1 || bufferedIndex > lastBufferedIndex) && holeEnd - holeStart < 1 && // `maxBufferHole` may be too small and setting it to 0 should not disable this feature
                    currentTime - holeStart < 2) {
                        const error = new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${currentTime} hole: ${holeStart} -> ${holeEnd} buffered index: ${bufferedIndex}`);
                        this.warn(error.message);
                        // Magic number to flush the pipeline without interuption to audio playback:
                        this.media.currentTime += 0.000001;
                        const frag = this.fragmentTracker.getPartialFragment(currentTime) || undefined;
                        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(this.media, currentTime, 0);
                        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                            details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_SEEK_OVER_HOLE,
                            fatal: false,
                            error: error,
                            reason: error.message,
                            frag: frag,
                            buffer: bufferInfo.len,
                            bufferInfo: bufferInfo
                        });
                    }
                }
            }
        }
    }
    /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */ _tryFixBufferStall(bufferInfo, stalledDurationMs, currentTime) {
        var _this$hls3, _this$hls4;
        const { fragmentTracker: fragmentTracker, media: media } = this;
        const config = (_this$hls3 = this.hls) == null ? void 0 : _this$hls3.config;
        if (!media || !fragmentTracker || !config) return;
        const levelDetails = (_this$hls4 = this.hls) == null ? void 0 : _this$hls4.latestLevelDetails;
        const partial = fragmentTracker.getPartialFragment(currentTime);
        if (partial || levelDetails != null && levelDetails.live && currentTime < levelDetails.fragmentStart) {
            // Try to skip over the buffer hole caused by a partial fragment
            // This method isn't limited by the size of the gap between buffered ranges
            const targetTime = this._trySkipBufferHole(partial);
            // we return here in this case, meaning
            // the branch below only executes when we haven't seeked to a new position
            if (targetTime || !this.media) return;
        }
        // if we haven't had to skip over a buffer hole of a partial fragment
        // we may just have to "nudge" the playlist as the browser decoding/rendering engine
        // needs to cross some sort of threshold covering all source-buffers content
        // to start playing properly.
        const bufferedRanges = bufferInfo.buffered;
        const adjacentTraversal = this.adjacentTraversal(bufferInfo, currentTime);
        if ((bufferedRanges && bufferedRanges.length > 1 && bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && (bufferInfo.nextStart - currentTime < config.maxBufferHole || adjacentTraversal)) && (stalledDurationMs > config.highBufferWatchdogPeriod * 1000 || this.waiting)) {
            this.warn('Trying to nudge playhead over buffer-hole');
            // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
            // We only try to jump the hole if it's under the configured size
            this._tryNudgeBuffer(bufferInfo);
        }
    }
    adjacentTraversal(bufferInfo, currentTime) {
        const fragmentTracker = this.fragmentTracker;
        const nextStart = bufferInfo.nextStart;
        if (fragmentTracker && nextStart) {
            const current = fragmentTracker.getFragAtPos(currentTime, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
            const next = fragmentTracker.getFragAtPos(nextStart, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
            if (current && next) return next.sn - current.sn < 2;
        }
        return false;
    }
    /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */ _reportStall(bufferInfo) {
        const { hls: hls, media: media, stallReported: stallReported, stalled: stalled } = this;
        if (!stallReported && stalled !== null && media && hls) {
            // Report stalled error once
            this.stallReported = true;
            const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${$99a156a15cd35eb3$var$stringify(bufferInfo)})`);
            this.warn(error.message);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR,
                fatal: false,
                error: error,
                buffer: bufferInfo.len,
                bufferInfo: bufferInfo,
                stalled: {
                    start: stalled
                }
            });
        }
    }
    /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param partial - The partial fragment found at the current time (where playback is stalling).
   * @private
   */ _trySkipBufferHole(partial) {
        var _this$hls5;
        const { fragmentTracker: fragmentTracker, media: media } = this;
        const config = (_this$hls5 = this.hls) == null ? void 0 : _this$hls5.config;
        if (!media || !fragmentTracker || !config) return 0;
        // Check if currentTime is between unbuffered regions of partial fragments
        const currentTime = media.currentTime;
        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
        if (startTime && this.hls) {
            const bufferStarved = bufferInfo.len <= config.maxBufferHole;
            const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
            const gapLength = startTime - currentTime;
            if (gapLength > 0 && (bufferStarved || waiting)) {
                // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
                if (gapLength > config.maxBufferHole) {
                    let startGap = false;
                    if (currentTime === 0) {
                        const startFrag = fragmentTracker.getAppendedFrag(0, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
                        if (startFrag && startTime < startFrag.end) startGap = true;
                    }
                    if (!startGap) {
                        const startProvisioned = partial || fragmentTracker.getAppendedFrag(currentTime, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
                        if (startProvisioned) {
                            var _this$hls$loadLevelOb;
                            // Do not seek when selected variant playlist is unloaded
                            if (!((_this$hls$loadLevelOb = this.hls.loadLevelObj) != null && _this$hls$loadLevelOb.details)) return 0;
                            // Do not seek when required fragments are inflight or appending
                            const inFlightDependency = $99a156a15cd35eb3$var$getInFlightDependency(this.hls.inFlightFragments, startTime);
                            if (inFlightDependency) return 0;
                            // Do not seek if we can't walk tracked fragments to end of gap
                            let moreToLoad = false;
                            let pos = startProvisioned.end;
                            while(pos < startTime){
                                const provisioned = fragmentTracker.getPartialFragment(pos);
                                if (provisioned) pos += provisioned.duration;
                                else {
                                    moreToLoad = true;
                                    break;
                                }
                            }
                            if (moreToLoad) return 0;
                        }
                    }
                }
                const targetTime = Math.max(startTime + $99a156a15cd35eb3$var$SKIP_BUFFER_RANGE_START, currentTime + $99a156a15cd35eb3$var$SKIP_BUFFER_HOLE_STEP_SECONDS);
                this.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
                this.moved = true;
                media.currentTime = targetTime;
                if (!(partial != null && partial.gap)) {
                    const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_SEEK_OVER_HOLE,
                        fatal: false,
                        error: error,
                        reason: error.message,
                        frag: partial || undefined,
                        buffer: bufferInfo.len,
                        bufferInfo: bufferInfo
                    });
                }
                return targetTime;
            }
        }
        return 0;
    }
    /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */ _tryNudgeBuffer(bufferInfo) {
        const { hls: hls, media: media, nudgeRetry: nudgeRetry } = this;
        const config = hls == null ? void 0 : hls.config;
        if (!media || !config) return 0;
        const currentTime = media.currentTime;
        this.nudgeRetry++;
        if (nudgeRetry < config.nudgeMaxRetry) {
            const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
            // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
            const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
            this.warn(error.message);
            media.currentTime = targetTime;
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_NUDGE_ON_STALL,
                error: error,
                fatal: false,
                buffer: bufferInfo.len,
                bufferInfo: bufferInfo
            });
        } else {
            const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
            this.error(error.message);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR,
                error: error,
                fatal: true,
                buffer: bufferInfo.len,
                bufferInfo: bufferInfo
            });
        }
    }
}
function $99a156a15cd35eb3$var$getInFlightDependency(inFlightFragments, currentTime) {
    const main = $99a156a15cd35eb3$var$inFlight(inFlightFragments.main);
    if (main && main.start <= currentTime) return main;
    const audio = $99a156a15cd35eb3$var$inFlight(inFlightFragments.audio);
    if (audio && audio.start <= currentTime) return audio;
    return null;
}
function $99a156a15cd35eb3$var$inFlight(inFlightData) {
    if (!inFlightData) return null;
    switch(inFlightData.state){
        case $99a156a15cd35eb3$var$State.IDLE:
        case $99a156a15cd35eb3$var$State.STOPPED:
        case $99a156a15cd35eb3$var$State.ENDED:
        case $99a156a15cd35eb3$var$State.ERROR:
            return null;
    }
    return inFlightData.frag;
}
const $99a156a15cd35eb3$var$MIN_CUE_DURATION = 0.25;
function $99a156a15cd35eb3$var$getCueClass() {
    if (typeof self === 'undefined') return undefined;
    return self.VTTCue || self.TextTrackCue;
}
function $99a156a15cd35eb3$var$createCueWithDataFields(Cue, startTime, endTime, data, type) {
    let cue = new Cue(startTime, endTime, '');
    try {
        cue.value = data;
        if (type) cue.type = type;
    } catch (e) {
        cue = new Cue(startTime, endTime, $99a156a15cd35eb3$var$stringify(type ? $99a156a15cd35eb3$var$_objectSpread2({
            type: type
        }, data) : data));
    }
    return cue;
}
// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const $99a156a15cd35eb3$var$MAX_CUE_ENDTIME = (()=>{
    const Cue = $99a156a15cd35eb3$var$getCueClass();
    try {
        Cue && new Cue(0, Number.POSITIVE_INFINITY, '');
    } catch (e) {
        return Number.MAX_VALUE;
    }
    return Number.POSITIVE_INFINITY;
})();
function $99a156a15cd35eb3$var$hexToArrayBuffer(str) {
    return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
class $99a156a15cd35eb3$var$ID3TrackController {
    constructor(hls){
        this.hls = void 0;
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        this.removeCues = true;
        this.onEventCueEnter = ()=>{
            if (!this.hls) return;
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.EVENT_CUE_ENTER, {});
        };
        this.hls = hls;
        this._registerListeners();
    }
    destroy() {
        this._unregisterListeners();
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        // @ts-ignore
        this.hls = this.onEventCueEnter = null;
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
    }
    // Add ID3 metatadata text track.
    onMediaAttaching(event, data) {
        var _data$overrides;
        this.media = data.media;
        if (((_data$overrides = data.overrides) == null ? void 0 : _data$overrides.cueRemoval) === false) this.removeCues = false;
    }
    onMediaAttached() {
        const details = this.hls.latestLevelDetails;
        if (details) this.updateDateRangeCues(details);
    }
    onMediaDetaching(event, data) {
        this.media = null;
        const transferringMedia = !!data.transferMedia;
        if (transferringMedia) return;
        if (this.id3Track) {
            if (this.removeCues) $99a156a15cd35eb3$var$clearCurrentCues(this.id3Track, this.onEventCueEnter);
            this.id3Track = null;
        }
        this.dateRangeCuesAppended = {};
    }
    onManifestLoading() {
        this.dateRangeCuesAppended = {};
    }
    createTrack(media) {
        const track = this.getID3Track(media.textTracks);
        track.mode = 'hidden';
        return track;
    }
    getID3Track(textTracks) {
        if (!this.media) return;
        for(let i = 0; i < textTracks.length; i++){
            const textTrack = textTracks[i];
            if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
                // send 'addtrack' when reusing the textTrack for metadata,
                // same as what we do for captions
                $99a156a15cd35eb3$var$sendAddTrackEvent(textTrack, this.media);
                return textTrack;
            }
        }
        return this.media.addTextTrack('metadata', 'id3');
    }
    onFragParsingMetadata(event, data) {
        if (!this.media) return;
        const { hls: { config: { enableEmsgMetadataCues: enableEmsgMetadataCues, enableID3MetadataCues: enableID3MetadataCues } } } = this;
        if (!enableEmsgMetadataCues && !enableID3MetadataCues) return;
        const { samples: samples } = data;
        // create track dynamically
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const Cue = $99a156a15cd35eb3$var$getCueClass();
        if (!Cue) return;
        for(let i = 0; i < samples.length; i++){
            const type = samples[i].type;
            if (type === $99a156a15cd35eb3$export$3f0d1211c87abf7f.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) continue;
            const frames = $99a156a15cd35eb3$var$getId3Frames(samples[i].data);
            if (frames) {
                const startTime = samples[i].pts;
                let endTime = startTime + samples[i].duration;
                if (endTime > $99a156a15cd35eb3$var$MAX_CUE_ENDTIME) endTime = $99a156a15cd35eb3$var$MAX_CUE_ENDTIME;
                const timeDiff = endTime - startTime;
                if (timeDiff <= 0) endTime = startTime + $99a156a15cd35eb3$var$MIN_CUE_DURATION;
                for(let j = 0; j < frames.length; j++){
                    const frame = frames[j];
                    // Safari doesn't put the timestamp frame in the TextTrack
                    if (!$99a156a15cd35eb3$var$isId3TimestampFrame(frame)) {
                        // add a bounds to any unbounded cues
                        this.updateId3CueEnds(startTime, type);
                        const cue = $99a156a15cd35eb3$var$createCueWithDataFields(Cue, startTime, endTime, frame, type);
                        if (cue) this.id3Track.addCue(cue);
                    }
                }
            }
        }
    }
    updateId3CueEnds(startTime, type) {
        var _this$id3Track;
        const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
        if (cues) for(let i = cues.length; i--;){
            const cue = cues[i];
            if (cue.type === type && cue.startTime < startTime && cue.endTime === $99a156a15cd35eb3$var$MAX_CUE_ENDTIME) cue.endTime = startTime;
        }
    }
    onBufferFlushing(event, { startOffset: startOffset, endOffset: endOffset, type: type }) {
        const { id3Track: id3Track, hls: hls } = this;
        if (!hls) return;
        const { config: { enableEmsgMetadataCues: enableEmsgMetadataCues, enableID3MetadataCues: enableID3MetadataCues } } = hls;
        if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
            let predicate;
            if (type === 'audio') predicate = (cue)=>cue.type === $99a156a15cd35eb3$export$3f0d1211c87abf7f.audioId3 && enableID3MetadataCues;
            else if (type === 'video') predicate = (cue)=>cue.type === $99a156a15cd35eb3$export$3f0d1211c87abf7f.emsg && enableEmsgMetadataCues;
            else predicate = (cue)=>cue.type === $99a156a15cd35eb3$export$3f0d1211c87abf7f.audioId3 && enableID3MetadataCues || cue.type === $99a156a15cd35eb3$export$3f0d1211c87abf7f.emsg && enableEmsgMetadataCues;
            $99a156a15cd35eb3$var$removeCuesInRange(id3Track, startOffset, endOffset, predicate);
        }
    }
    onLevelUpdated(event, { details: details }) {
        this.updateDateRangeCues(details, true);
    }
    onLevelPtsUpdated(event, data) {
        if (Math.abs(data.drift) > 0.01) this.updateDateRangeCues(data.details);
    }
    updateDateRangeCues(details, removeOldCues) {
        if (!this.media || !details.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues) return;
        const { id3Track: id3Track } = this;
        const { dateRanges: dateRanges } = details;
        const ids = Object.keys(dateRanges);
        let dateRangeCuesAppended = this.dateRangeCuesAppended;
        // Remove cues from track not found in details.dateRanges
        if (id3Track && removeOldCues) {
            var _id3Track$cues;
            if ((_id3Track$cues = id3Track.cues) != null && _id3Track$cues.length) {
                const idsToRemove = Object.keys(dateRangeCuesAppended).filter((id)=>!ids.includes(id));
                for(let i = idsToRemove.length; i--;){
                    const id = idsToRemove[i];
                    const cues = dateRangeCuesAppended[id].cues;
                    delete dateRangeCuesAppended[id];
                    Object.keys(cues).forEach((key)=>{
                        try {
                            const cue = cues[key];
                            cue.removeEventListener('enter', this.onEventCueEnter);
                            id3Track.removeCue(cue);
                        } catch (e) {
                        /* no-op */ }
                    });
                }
            } else dateRangeCuesAppended = this.dateRangeCuesAppended = {};
        }
        // Exit if the playlist does not have Date Ranges or does not have Program Date Time
        const lastFragment = details.fragments[details.fragments.length - 1];
        if (ids.length === 0 || !$99a156a15cd35eb3$var$isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) return;
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const Cue = $99a156a15cd35eb3$var$getCueClass();
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const dateRange = dateRanges[id];
            const startTime = dateRange.startTime;
            // Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
            const appendedDateRangeCues = dateRangeCuesAppended[id];
            const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
            let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
            let endTime = $99a156a15cd35eb3$var$MAX_CUE_ENDTIME;
            const { duration: duration, endDate: endDate } = dateRange;
            if (endDate && duration !== null) {
                endTime = startTime + duration;
                durationKnown = true;
            } else if (dateRange.endOnNext && !durationKnown) {
                const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id)=>{
                    if (id !== dateRange.id) {
                        const otherDateRange = dateRanges[id];
                        if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) return otherDateRange;
                    }
                    return candidateDateRange;
                }, null);
                if (nextDateRangeWithSameClass) {
                    endTime = nextDateRangeWithSameClass.startTime;
                    durationKnown = true;
                }
            }
            // Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
            // This is to emulate Safari HLS playback handling of DateRange tags
            const attributes = Object.keys(dateRange.attr);
            for(let j = 0; j < attributes.length; j++){
                const key = attributes[j];
                if (!$99a156a15cd35eb3$var$isDateRangeCueAttribute(key)) continue;
                const cue = cues[key];
                if (cue) {
                    if (durationKnown && !appendedDateRangeCues.durationKnown) cue.endTime = endTime;
                    else if (Math.abs(cue.startTime - startTime) > 0.01) {
                        cue.startTime = startTime;
                        cue.endTime = endTime;
                    }
                } else if (Cue) {
                    let data = dateRange.attr[key];
                    if ($99a156a15cd35eb3$var$isSCTE35Attribute(key)) data = $99a156a15cd35eb3$var$hexToArrayBuffer(data);
                    const payload = {
                        key: key,
                        data: data
                    };
                    const _cue = $99a156a15cd35eb3$var$createCueWithDataFields(Cue, startTime, endTime, payload, $99a156a15cd35eb3$export$3f0d1211c87abf7f.dateRange);
                    if (_cue) {
                        _cue.id = id;
                        this.id3Track.addCue(_cue);
                        cues[key] = _cue;
                        if (this.hls.config.interstitialsController) {
                            if (key === 'X-ASSET-LIST' || key === 'X-ASSET-URL') _cue.addEventListener('enter', this.onEventCueEnter);
                        }
                    }
                }
            }
            // Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
            dateRangeCuesAppended[id] = {
                cues: cues,
                dateRange: dateRange,
                durationKnown: durationKnown
            };
        }
    }
}
class $99a156a15cd35eb3$var$LatencyController {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.currentTime = 0;
        this.stallCount = 0;
        this._latency = null;
        this._targetLatencyUpdated = false;
        this.onTimeupdate = ()=>{
            const { media: media } = this;
            const levelDetails = this.levelDetails;
            if (!media || !levelDetails) return;
            this.currentTime = media.currentTime;
            const latency = this.computeLatency();
            if (latency === null) return;
            this._latency = latency;
            // Adapt playbackRate to meet target latency in low-latency mode
            const { lowLatencyMode: lowLatencyMode, maxLiveSyncPlaybackRate: maxLiveSyncPlaybackRate } = this.config;
            if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) return;
            const targetLatency = this.targetLatency;
            if (targetLatency === null) return;
            const distanceFromTarget = latency - targetLatency;
            // Only adjust playbackRate when within one target duration of targetLatency
            // and more than one second from under-buffering.
            // Playback further than one target duration from target can be considered DVR playback.
            const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
            const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
            if (inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
                const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
                const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
                const playbackRate = Math.min(max, Math.max(1, rate));
                this.changeMediaPlaybackRate(media, playbackRate);
            } else if (media.playbackRate !== 1 && media.playbackRate !== 0) this.changeMediaPlaybackRate(media, 1);
        };
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    get levelDetails() {
        var _this$hls;
        return ((_this$hls = this.hls) == null ? void 0 : _this$hls.latestLevelDetails) || null;
    }
    get latency() {
        return this._latency || 0;
    }
    get maxLatency() {
        const { config: config } = this;
        if (config.liveMaxLatencyDuration !== undefined) return config.liveMaxLatencyDuration;
        const levelDetails = this.levelDetails;
        return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
    }
    get targetLatency() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null || this.hls === null) return null;
        const { holdBack: holdBack, partHoldBack: partHoldBack, targetduration: targetduration } = levelDetails;
        const { liveSyncDuration: liveSyncDuration, liveSyncDurationCount: liveSyncDurationCount, lowLatencyMode: lowLatencyMode } = this.config;
        const userConfig = this.hls.userConfig;
        let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
        if (this._targetLatencyUpdated || userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
        const maxLiveSyncOnStallIncrease = targetduration;
        return targetLatency + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
    }
    set targetLatency(latency) {
        this.stallCount = 0;
        this.config.liveSyncDuration = latency;
        this._targetLatencyUpdated = true;
    }
    get liveSyncPosition() {
        const liveEdge = this.estimateLiveEdge();
        const targetLatency = this.targetLatency;
        if (liveEdge === null || targetLatency === null) return null;
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return null;
        const edge = levelDetails.edge;
        const syncPosition = liveEdge - targetLatency - this.edgeStalled;
        const min = edge - levelDetails.totalduration;
        const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
        return Math.min(Math.max(min, syncPosition), max);
    }
    get drift() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return 1;
        return levelDetails.drift;
    }
    get edgeStalled() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return 0;
        const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
        return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
    }
    get forwardBufferLength() {
        const { media: media } = this;
        const levelDetails = this.levelDetails;
        if (!media || !levelDetails) return 0;
        const bufferedRanges = media.buffered.length;
        return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetaching();
        this.hls = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener('timeupdate', this.onTimeupdate);
    }
    onMediaDetaching() {
        if (this.media) {
            this.media.removeEventListener('timeupdate', this.onTimeupdate);
            this.media = null;
        }
    }
    onManifestLoading() {
        this._latency = null;
        this.stallCount = 0;
    }
    onLevelUpdated(event, { details: details }) {
        if (details.advanced) this.onTimeupdate();
        if (!details.live && this.media) this.media.removeEventListener('timeupdate', this.onTimeupdate);
    }
    onError(event, data) {
        var _this$levelDetails;
        if (data.details !== $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_STALLED_ERROR) return;
        this.stallCount++;
        if (this.hls && (_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) this.hls.logger.warn('[latency-controller]: Stall detected, adjusting target latency');
    }
    changeMediaPlaybackRate(media, playbackRate) {
        var _this$hls2, _this$targetLatency;
        if (media.playbackRate === playbackRate) return;
        (_this$hls2 = this.hls) == null || _this$hls2.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(_this$targetLatency = this.targetLatency) == null ? void 0 : _this$targetLatency.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${media.playbackRate} to ${playbackRate}`);
        media.playbackRate = playbackRate;
    }
    estimateLiveEdge() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return null;
        return levelDetails.edge + levelDetails.age;
    }
    computeLatency() {
        const liveEdge = this.estimateLiveEdge();
        if (liveEdge === null) return null;
        return liveEdge - this.currentTime;
    }
}
class $99a156a15cd35eb3$var$LevelController extends $99a156a15cd35eb3$export$d94ec24774c8b986 {
    constructor(hls, contentSteeringController){
        super(hls, 'level-controller');
        this._levels = [];
        this._firstLevel = -1;
        this._maxAutoLevel = -1;
        this._startLevel = void 0;
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        this.manualLevelIndex = -1;
        this.steering = void 0;
        this.onParsedComplete = void 0;
        this.steering = contentSteeringController;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.ERROR, this.onError, this);
    }
    destroy() {
        this._unregisterListeners();
        this.steering = null;
        this.resetLevels();
        super.destroy();
    }
    stopLoad() {
        const levels = this._levels;
        // clean up live level details to force reload them, and reset load errors
        levels.forEach((level)=>{
            level.loadError = 0;
            level.fragmentError = 0;
        });
        super.stopLoad();
    }
    resetLevels() {
        this._startLevel = undefined;
        this.manualLevelIndex = -1;
        this.currentLevelIndex = -1;
        this.currentLevel = null;
        this._levels = [];
        this._maxAutoLevel = -1;
    }
    onManifestLoading(event, data) {
        this.resetLevels();
    }
    onManifestLoaded(event, data) {
        const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
        const levels = [];
        const redundantSet = {};
        const generatePathwaySet = {};
        let resolutionFound = false;
        let videoCodecFound = false;
        let audioCodecFound = false;
        data.levels.forEach((levelParsed)=>{
            const attributes = levelParsed.attrs;
            let { audioCodec: audioCodec, videoCodec: videoCodec } = levelParsed;
            if (audioCodec) // Returns empty and set to undefined for 'mp4a.40.34' with fallback to 'audio/mpeg' SourceBuffer
            levelParsed.audioCodec = audioCodec = $99a156a15cd35eb3$var$getCodecCompatibleName(audioCodec, preferManagedMediaSource) || undefined;
            if (videoCodec) videoCodec = levelParsed.videoCodec = $99a156a15cd35eb3$var$convertAVC1ToAVCOTI(videoCodec);
            // only keep levels with supported audio/video codecs
            const { width: width, height: height, unknownCodecs: unknownCodecs } = levelParsed;
            let unknownUnsupportedCodecCount = unknownCodecs ? unknownCodecs.length : 0;
            if (unknownCodecs) // Treat unknown codec as audio or video codec based on passing `isTypeSupported` check
            // (allows for playback of any supported codec even if not indexed in utils/codecs)
            for(let i = unknownUnsupportedCodecCount; i--;){
                const unknownCodec = unknownCodecs[i];
                if (this.isAudioSupported(unknownCodec)) {
                    levelParsed.audioCodec = audioCodec = audioCodec ? `${audioCodec},${unknownCodec}` : unknownCodec;
                    unknownUnsupportedCodecCount--;
                    $99a156a15cd35eb3$var$sampleEntryCodesISO.audio[audioCodec.substring(0, 4)] = 2;
                } else if (this.isVideoSupported(unknownCodec)) {
                    levelParsed.videoCodec = videoCodec = videoCodec ? `${videoCodec},${unknownCodec}` : unknownCodec;
                    unknownUnsupportedCodecCount--;
                    $99a156a15cd35eb3$var$sampleEntryCodesISO.video[videoCodec.substring(0, 4)] = 2;
                }
            }
            resolutionFound || (resolutionFound = !!(width && height));
            videoCodecFound || (videoCodecFound = !!videoCodec);
            audioCodecFound || (audioCodecFound = !!audioCodec);
            if (unknownUnsupportedCodecCount || audioCodec && !this.isAudioSupported(audioCodec) || videoCodec && !this.isVideoSupported(videoCodec)) {
                this.log(`Some or all CODECS not supported "${attributes.CODECS}"`);
                return;
            }
            const { CODECS: CODECS, 'FRAME-RATE': FRAMERATE, 'HDCP-LEVEL': HDCP, 'PATHWAY-ID': PATHWAY, RESOLUTION: RESOLUTION, 'VIDEO-RANGE': VIDEO_RANGE } = attributes;
            const contentSteeringPrefix = `${PATHWAY || '.'}-`;
            const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
            if (!redundantSet[levelKey]) {
                const level = this.createLevel(levelParsed);
                redundantSet[levelKey] = level;
                generatePathwaySet[levelKey] = 1;
                levels.push(level);
            } else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs['PATHWAY-ID']) {
                // Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
                // Content Steering controller to handles Pathway fallback on error
                const pathwayCount = generatePathwaySet[levelKey] += 1;
                levelParsed.attrs['PATHWAY-ID'] = new Array(pathwayCount + 1).join('.');
                const level = this.createLevel(levelParsed);
                redundantSet[levelKey] = level;
                levels.push(level);
            } else {
                redundantSet[levelKey].addGroupId('audio', attributes.AUDIO);
                redundantSet[levelKey].addGroupId('text', attributes.SUBTITLES);
            }
        });
        this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
    }
    createLevel(levelParsed) {
        const level = new $99a156a15cd35eb3$export$ca664994d1d54bff(levelParsed);
        const supplemental = levelParsed.supplemental;
        if (supplemental != null && supplemental.videoCodec && !this.isVideoSupported(supplemental.videoCodec)) {
            const error = new Error(`SUPPLEMENTAL-CODECS not supported "${supplemental.videoCodec}"`);
            this.log(error.message);
            level.supportedResult = $99a156a15cd35eb3$var$getUnsupportedResult(error, []);
        }
        return level;
    }
    isAudioSupported(codec) {
        return $99a156a15cd35eb3$var$areCodecsMediaSourceSupported(codec, 'audio', this.hls.config.preferManagedMediaSource);
    }
    isVideoSupported(codec) {
        return $99a156a15cd35eb3$var$areCodecsMediaSourceSupported(codec, 'video', this.hls.config.preferManagedMediaSource);
    }
    filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
        let audioTracks = [];
        let subtitleTracks = [];
        let levels = filteredLevels;
        // remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
        if ((resolutionFound || videoCodecFound) && audioCodecFound) levels = levels.filter(({ videoCodec: videoCodec, videoRange: videoRange, width: width, height: height })=>(!!videoCodec || !!(width && height)) && $99a156a15cd35eb3$var$isVideoRange(videoRange));
        if (levels.length === 0) {
            // Dispatch error after MANIFEST_LOADED is done propagating
            Promise.resolve().then(()=>{
                if (this.hls) {
                    let message = 'no level with compatible codecs found in manifest';
                    let reason = message;
                    if (data.levels.length) {
                        reason = `one or more CODECS in variant not supported: ${$99a156a15cd35eb3$var$stringify(data.levels.map((level)=>level.attrs.CODECS).filter((value, index, array)=>array.indexOf(value) === index))}`;
                        this.warn(reason);
                        message += ` (${reason})`;
                    }
                    const error = new Error(message);
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                        type: $99a156a15cd35eb3$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $99a156a15cd35eb3$export$d053ec805ce391aa.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                        fatal: true,
                        url: data.url,
                        error: error,
                        reason: reason
                    });
                }
            });
            return;
        }
        if (data.audioTracks) {
            audioTracks = data.audioTracks.filter((track)=>!track.audioCodec || this.isAudioSupported(track.audioCodec));
            // Assign ids after filtering as array indices by group-id
            $99a156a15cd35eb3$var$assignTrackIdsByGroup(audioTracks);
        }
        if (data.subtitles) {
            subtitleTracks = data.subtitles;
            $99a156a15cd35eb3$var$assignTrackIdsByGroup(subtitleTracks);
        }
        // start bitrate is the first bitrate of the manifest
        const unsortedLevels = levels.slice(0);
        // sort levels from lowest to highest
        levels.sort((a, b)=>{
            if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
            // sort on height before bitrate for cap-level-controller
            if (resolutionFound && a.height !== b.height) return a.height - b.height;
            if (a.frameRate !== b.frameRate) return a.frameRate - b.frameRate;
            if (a.videoRange !== b.videoRange) return $99a156a15cd35eb3$var$VideoRangeValues.indexOf(a.videoRange) - $99a156a15cd35eb3$var$VideoRangeValues.indexOf(b.videoRange);
            if (a.videoCodec !== b.videoCodec) {
                const valueA = $99a156a15cd35eb3$var$videoCodecPreferenceValue(a.videoCodec);
                const valueB = $99a156a15cd35eb3$var$videoCodecPreferenceValue(b.videoCodec);
                if (valueA !== valueB) return valueB - valueA;
            }
            if (a.uri === b.uri && a.codecSet !== b.codecSet) {
                const valueA = $99a156a15cd35eb3$var$codecsSetSelectionPreferenceValue(a.codecSet);
                const valueB = $99a156a15cd35eb3$var$codecsSetSelectionPreferenceValue(b.codecSet);
                if (valueA !== valueB) return valueB - valueA;
            }
            if (a.averageBitrate !== b.averageBitrate) return a.averageBitrate - b.averageBitrate;
            return 0;
        });
        let firstLevelInPlaylist = unsortedLevels[0];
        if (this.steering) {
            levels = this.steering.filterParsedLevels(levels);
            if (levels.length !== unsortedLevels.length) {
                for(let i = 0; i < unsortedLevels.length; i++)if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
                    firstLevelInPlaylist = unsortedLevels[i];
                    break;
                }
            }
        }
        this._levels = levels;
        // find index of first level in sorted levels
        for(let i = 0; i < levels.length; i++)if (levels[i] === firstLevelInPlaylist) {
            var _this$hls$userConfig;
            this._firstLevel = i;
            const firstLevelBitrate = firstLevelInPlaylist.bitrate;
            const bandwidthEstimate = this.hls.bandwidthEstimate;
            this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
            // Update default bwe to first variant bitrate as long it has not been configured or set
            if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === undefined) {
                const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
                if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === this.hls.abrEwmaDefaultEstimate) this.hls.bandwidthEstimate = startingBwEstimate;
            }
            break;
        }
        // Audio is only alternate if manifest include a URI along with the audio group tag,
        // and this is not an audio-only stream where levels contain audio-only
        const audioOnly = audioCodecFound && !videoCodecFound;
        const config = this.hls.config;
        const altAudioEnabled = !!(config.audioStreamController && config.audioTrackController);
        const edata = {
            levels: levels,
            audioTracks: audioTracks,
            subtitleTracks: subtitleTracks,
            sessionData: data.sessionData,
            sessionKeys: data.sessionKeys,
            firstLevel: this._firstLevel,
            stats: data.stats,
            audio: audioCodecFound,
            video: videoCodecFound,
            altAudio: altAudioEnabled && !audioOnly && audioTracks.some((t)=>!!t.url)
        };
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, edata);
    }
    get levels() {
        if (this._levels.length === 0) return null;
        return this._levels;
    }
    get loadLevelObj() {
        return this.currentLevel;
    }
    get level() {
        return this.currentLevelIndex;
    }
    set level(newLevel) {
        const levels = this._levels;
        if (levels.length === 0) return;
        // check if level idx is valid
        if (newLevel < 0 || newLevel >= levels.length) {
            // invalid level id given, trigger error
            const error = new Error('invalid level idx');
            const fatal = newLevel < 0;
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_SWITCH_ERROR,
                level: newLevel,
                fatal: fatal,
                error: error,
                reason: error.message
            });
            if (fatal) return;
            newLevel = Math.min(newLevel, levels.length - 1);
        }
        const lastLevelIndex = this.currentLevelIndex;
        const lastLevel = this.currentLevel;
        const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
        const level = levels[newLevel];
        const pathwayId = level.attrs['PATHWAY-ID'];
        this.currentLevelIndex = newLevel;
        this.currentLevel = level;
        if (lastLevelIndex === newLevel && lastLevel && lastPathwayId === pathwayId) return;
        this.log(`Switching to level ${newLevel} (${level.height ? level.height + 'p ' : ''}${level.videoRange ? level.videoRange + ' ' : ''}${level.codecSet ? level.codecSet + ' ' : ''}@${level.bitrate})${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
        const levelSwitchingData = {
            level: newLevel,
            attrs: level.attrs,
            details: level.details,
            bitrate: level.bitrate,
            averageBitrate: level.averageBitrate,
            maxBitrate: level.maxBitrate,
            realBitrate: level.realBitrate,
            width: level.width,
            height: level.height,
            codecSet: level.codecSet,
            audioCodec: level.audioCodec,
            videoCodec: level.videoCodec,
            audioGroups: level.audioGroups,
            subtitleGroups: level.subtitleGroups,
            loaded: level.loaded,
            loadError: level.loadError,
            fragmentError: level.fragmentError,
            name: level.name,
            id: level.id,
            uri: level.uri,
            url: level.url,
            urlId: 0,
            audioGroupIds: level.audioGroupIds,
            textGroupIds: level.textGroupIds
        };
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHING, levelSwitchingData);
        // check if we need to load playlist for this level
        const levelDetails = level.details;
        if (!levelDetails || levelDetails.live) {
            // level not retrieved yet, or live playlist we need to (re)load it
            const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
            this.loadPlaylist(hlsUrlParameters);
        }
    }
    get manualLevel() {
        return this.manualLevelIndex;
    }
    set manualLevel(newLevel) {
        this.manualLevelIndex = newLevel;
        if (this._startLevel === undefined) this._startLevel = newLevel;
        if (newLevel !== -1) this.level = newLevel;
    }
    get firstLevel() {
        return this._firstLevel;
    }
    set firstLevel(newLevel) {
        this._firstLevel = newLevel;
    }
    get startLevel() {
        // Setting hls.startLevel (this._startLevel) overrides config.startLevel
        if (this._startLevel === undefined) {
            const configStartLevel = this.hls.config.startLevel;
            if (configStartLevel !== undefined) return configStartLevel;
            return this.hls.firstAutoLevel;
        }
        return this._startLevel;
    }
    set startLevel(newLevel) {
        this._startLevel = newLevel;
    }
    get pathways() {
        if (this.steering) return this.steering.pathways();
        return [];
    }
    get pathwayPriority() {
        if (this.steering) return this.steering.pathwayPriority;
        return null;
    }
    set pathwayPriority(pathwayPriority) {
        if (this.steering) {
            const pathwaysList = this.steering.pathways();
            const filteredPathwayPriority = pathwayPriority.filter((pathwayId)=>{
                return pathwaysList.indexOf(pathwayId) !== -1;
            });
            if (pathwayPriority.length < 1) {
                this.warn(`pathwayPriority ${pathwayPriority} should contain at least one pathway from list: ${pathwaysList}`);
                return;
            }
            this.steering.pathwayPriority = filteredPathwayPriority;
        }
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $99a156a15cd35eb3$var$PlaylistContextType.LEVEL && data.context.level === this.level) this.checkRetry(data);
    }
    // reset errors on the successful load of a fragment
    onFragBuffered(event, { frag: frag }) {
        if (frag !== undefined && frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN) {
            const el = frag.elementaryStreams;
            if (!Object.keys(el).some((type)=>!!el[type])) return;
            const level = this._levels[frag.level];
            if (level != null && level.loadError) {
                this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
                level.loadError = 0;
            }
        }
    }
    onLevelLoaded(event, data) {
        var _data$deliveryDirecti2;
        const { level: level, details: details } = data;
        const curLevel = data.levelInfo;
        if (!curLevel) {
            var _data$deliveryDirecti;
            this.warn(`Invalid level index ${level}`);
            if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) details.deltaUpdateFailed = true;
            return;
        }
        // only process level loaded events matching with expected level or prior to switch when media playlist is loaded directly
        if (curLevel === this.currentLevel || data.withoutMultiVariant) {
            // reset level load error counter on successful level loaded only if there is no issues with fragments
            if (curLevel.fragmentError === 0) curLevel.loadError = 0;
            // Ignore matching details populated by loading a Media Playlist directly
            let previousDetails = curLevel.details;
            if (previousDetails === data.details && previousDetails.advanced) previousDetails = undefined;
            this.playlistLoaded(level, data, previousDetails);
        } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) // received a delta playlist update that cannot be merged
        details.deltaUpdateFailed = true;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        if (this.shouldLoadPlaylist(this.currentLevel)) this.scheduleLoading(this.currentLevel, hlsUrlParameters);
    }
    loadingPlaylist(currentLevel, hlsUrlParameters) {
        super.loadingPlaylist(currentLevel, hlsUrlParameters);
        const url = this.getUrlWithDirectives(currentLevel.uri, hlsUrlParameters);
        const currentLevelIndex = this.currentLevelIndex;
        const pathwayId = currentLevel.attrs['PATHWAY-ID'];
        const details = currentLevel.details;
        const age = details == null ? void 0 : details.age;
        this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${pathwayId ? ' Pathway ' + pathwayId : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type : '') : ''} ${url}`);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, {
            url: url,
            level: currentLevelIndex,
            levelInfo: currentLevel,
            pathwayId: currentLevel.attrs['PATHWAY-ID'],
            id: 0,
            // Deprecated Level urlId
            deliveryDirectives: hlsUrlParameters || null
        });
    }
    get nextLoadLevel() {
        if (this.manualLevelIndex !== -1) return this.manualLevelIndex;
        else return this.hls.nextAutoLevel;
    }
    set nextLoadLevel(nextLevel) {
        this.level = nextLevel;
        if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
    }
    removeLevel(levelIndex) {
        var _this$currentLevel;
        if (this._levels.length === 1) return;
        const levels = this._levels.filter((level, index)=>{
            if (index !== levelIndex) return true;
            if (this.steering) this.steering.removeLevel(level);
            if (level === this.currentLevel) {
                this.currentLevel = null;
                this.currentLevelIndex = -1;
                if (level.details) level.details.fragments.forEach((f)=>f.level = -1);
            }
            return false;
        });
        $99a156a15cd35eb3$var$reassignFragmentLevelIndexes(levels);
        this._levels = levels;
        if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
        if (this.manualLevelIndex > -1) this.manualLevelIndex = this.currentLevelIndex;
        const maxLevel = levels.length - 1;
        this._firstLevel = Math.min(this._firstLevel, maxLevel);
        if (this._startLevel) this._startLevel = Math.min(this._startLevel, maxLevel);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, {
            levels: levels
        });
    }
    onLevelsUpdated(event, { levels: levels }) {
        this._levels = levels;
    }
    checkMaxAutoUpdated() {
        const { autoLevelCapping: autoLevelCapping, maxAutoLevel: maxAutoLevel, maxHdcpLevel: maxHdcpLevel } = this.hls;
        if (this._maxAutoLevel !== maxAutoLevel) {
            this._maxAutoLevel = maxAutoLevel;
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MAX_AUTO_LEVEL_UPDATED, {
                autoLevelCapping: autoLevelCapping,
                levels: this.levels,
                maxAutoLevel: maxAutoLevel,
                minAutoLevel: this.hls.minAutoLevel,
                maxHdcpLevel: maxHdcpLevel
            });
        }
    }
}
function $99a156a15cd35eb3$var$assignTrackIdsByGroup(tracks) {
    const groups = {};
    tracks.forEach((track)=>{
        const groupId = track.groupId || '';
        track.id = groups[groupId] = groups[groupId] || 0;
        groups[groupId]++;
    });
}
function $99a156a15cd35eb3$var$getSourceBuffer() {
    return self.SourceBuffer || self.WebKitSourceBuffer;
}
function $99a156a15cd35eb3$export$e9e4a33dcf7638ad() {
    const mediaSource = $99a156a15cd35eb3$export$a92854129bc50f89();
    if (!mediaSource) return false;
    // if SourceBuffer is exposed ensure its API is valid
    // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    const sourceBuffer = $99a156a15cd35eb3$var$getSourceBuffer();
    return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
}
function $99a156a15cd35eb3$export$48c17662a6902497() {
    if (!$99a156a15cd35eb3$export$e9e4a33dcf7638ad()) return false;
    const mediaSource = $99a156a15cd35eb3$export$a92854129bc50f89();
    return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === 'function' && ([
        'avc1.42E01E,mp4a.40.2',
        'av01.0.01M.08',
        'vp09.00.50.08'
    ].some((codecsForVideoContainer)=>mediaSource.isTypeSupported($99a156a15cd35eb3$var$mimeTypeForCodec(codecsForVideoContainer, 'video'))) || [
        'mp4a.40.2',
        'fLaC'
    ].some((codecForAudioContainer)=>mediaSource.isTypeSupported($99a156a15cd35eb3$var$mimeTypeForCodec(codecForAudioContainer, 'audio'))));
}
function $99a156a15cd35eb3$var$changeTypeSupported() {
    var _sourceBuffer$prototy;
    const sourceBuffer = $99a156a15cd35eb3$var$getSourceBuffer();
    return typeof (sourceBuffer == null ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}
const $99a156a15cd35eb3$var$TICK_INTERVAL = 100; // how often to tick in ms
class $99a156a15cd35eb3$var$StreamController extends $99a156a15cd35eb3$export$946cb951577581c9 {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, 'stream-controller', $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
        this.audioCodecSwap = false;
        this.level = -1;
        this._forceStartLoad = false;
        this._hasEnoughToStart = false;
        this.altAudio = 0;
        this.audioOnly = false;
        this.fragPlaying = null;
        this.fragLastKbps = 0;
        this.couldBacktrack = false;
        this.backtrackFragment = null;
        this.audioCodecSwitch = false;
        this.videoBuffer = null;
        this.onMediaPlaying = ()=>{
            // tick to speed up FRAG_CHANGED triggering
            this.tick();
        };
        this.onMediaSeeked = ()=>{
            const media = this.media;
            const currentTime = media ? media.currentTime : null;
            if (currentTime === null || !$99a156a15cd35eb3$var$isFiniteNumber(currentTime)) return;
            this.log(`Media seeked to ${currentTime.toFixed(3)}`);
            // If seeked was issued before buffer was appended do not tick immediately
            if (!this.getBufferedFrag(currentTime)) return;
            const bufferInfo = this.getFwdBufferInfoAtPos(media, currentTime, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN, 0);
            if (bufferInfo === null || bufferInfo.len === 0) {
                this.warn(`Main forward buffer length at ${currentTime} on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
                return;
            }
            // tick to speed up FRAG_CHANGED triggering
            this.tick();
        };
        this.registerListeners();
    }
    registerListeners() {
        super.registerListeners();
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    unregisterListeners() {
        super.unregisterListeners();
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    onHandlerDestroying() {
        // @ts-ignore
        this.onMediaPlaying = this.onMediaSeeked = null;
        this.unregisterListeners();
        super.onHandlerDestroying();
    }
    startLoad(startPosition, skipSeekToStartPosition) {
        if (this.levels) {
            const { lastCurrentTime: lastCurrentTime, hls: hls } = this;
            this.stopLoad();
            this.setInterval($99a156a15cd35eb3$var$TICK_INTERVAL);
            this.level = -1;
            if (!this.startFragRequested) {
                // determine load level
                let startLevel = hls.startLevel;
                if (startLevel === -1) {
                    if (hls.config.testBandwidth && this.levels.length > 1) {
                        // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                        startLevel = 0;
                        this.bitrateTest = true;
                    } else startLevel = hls.firstAutoLevel;
                }
                // set new level to playlist loader : this will trigger start level load
                // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                hls.nextLoadLevel = startLevel;
                this.level = hls.loadLevel;
                this._hasEnoughToStart = !!skipSeekToStartPosition;
            }
            // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
            if (lastCurrentTime > 0 && startPosition === -1 && !skipSeekToStartPosition) {
                this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
                startPosition = lastCurrentTime;
            }
            this.state = $99a156a15cd35eb3$var$State.IDLE;
            this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
            this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
            this.tick();
        } else {
            this._forceStartLoad = true;
            this.state = $99a156a15cd35eb3$var$State.STOPPED;
        }
    }
    stopLoad() {
        this._forceStartLoad = false;
        super.stopLoad();
    }
    doTick() {
        switch(this.state){
            case $99a156a15cd35eb3$var$State.WAITING_LEVEL:
                {
                    const { levels: levels, level: level } = this;
                    const currentLevel = levels == null ? void 0 : levels[level];
                    const details = currentLevel == null ? void 0 : currentLevel.details;
                    if (details && (!details.live || this.levelLastLoaded === currentLevel && !this.waitForLive(currentLevel))) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = $99a156a15cd35eb3$var$State.IDLE;
                        break;
                    } else if (this.hls.nextLoadLevel !== this.level) {
                        this.state = $99a156a15cd35eb3$var$State.IDLE;
                        break;
                    }
                    break;
                }
            case $99a156a15cd35eb3$var$State.FRAG_LOADING_WAITING_RETRY:
                {
                    var _this$media;
                    const now = self.performance.now();
                    const retryDate = this.retryDate;
                    // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                    if (!retryDate || now >= retryDate || (_this$media = this.media) != null && _this$media.seeking) {
                        const { levels: levels, level: level } = this;
                        const currentLevel = levels == null ? void 0 : levels[level];
                        this.resetStartWhenNotLoaded(currentLevel || null);
                        this.state = $99a156a15cd35eb3$var$State.IDLE;
                    }
                }
                break;
        }
        if (this.state === $99a156a15cd35eb3$var$State.IDLE) this.doTickIdle();
        this.onTickEnd();
    }
    onTickEnd() {
        var _this$media2;
        super.onTickEnd();
        if ((_this$media2 = this.media) != null && _this$media2.readyState && this.media.seeking === false) this.lastCurrentTime = this.media.currentTime;
        this.checkFragmentChanged();
    }
    doTickIdle() {
        const { hls: hls, levelLastLoaded: levelLastLoaded, levels: levels, media: media } = this;
        // if start level not parsed yet OR
        // if video not attached AND start fragment already requested OR start frag prefetch not enabled
        // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
        if (levelLastLoaded === null || !media && !this.primaryPrefetch && (this.startFragRequested || !hls.config.startFragPrefetch)) return;
        // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
        if (this.altAudio && this.audioOnly) return;
        const level = this.buffering ? hls.nextLoadLevel : hls.loadLevel;
        if (!(levels != null && levels[level])) return;
        const levelInfo = levels[level];
        // if buffer length is less than maxBufLen try to load a new fragment
        const bufferInfo = this.getMainFwdBufferInfo();
        if (bufferInfo === null) return;
        const lastDetails = this.getLevelDetails();
        if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
            const data = {};
            if (this.altAudio === 2) data.type = 'video';
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_EOS, data);
            this.state = $99a156a15cd35eb3$var$State.ENDED;
            return;
        }
        if (!this.buffering) return;
        // set next load level : this will trigger a playlist load if needed
        if (hls.loadLevel !== level && hls.manualLevel === -1) this.log(`Adapting to level ${level} from level ${this.level}`);
        this.level = hls.nextLoadLevel = level;
        const levelDetails = levelInfo.details;
        // if level info not retrieved yet, switch state and wait for level retrieval
        // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
        // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
        if (!levelDetails || this.state === $99a156a15cd35eb3$var$State.WAITING_LEVEL || this.waitForLive(levelInfo)) {
            this.level = level;
            this.state = $99a156a15cd35eb3$var$State.WAITING_LEVEL;
            this.startFragRequested = false;
            return;
        }
        const bufferLen = bufferInfo.len;
        // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
        const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);
        // Stay idle if we are still with buffer margins
        if (bufferLen >= maxBufLen) return;
        if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) this.backtrackFragment = null;
        const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
        let frag = this.getNextFragment(targetBufferTime, levelDetails);
        // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
        if (this.couldBacktrack && !this.fragPrevious && frag && $99a156a15cd35eb3$var$isMediaFragment(frag) && this.fragmentTracker.getState(frag) !== $99a156a15cd35eb3$var$FragmentState.OK) {
            var _this$backtrackFragme;
            const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
            const fragIdx = backtrackSn - levelDetails.startSN;
            const backtrackFrag = levelDetails.fragments[fragIdx - 1];
            if (backtrackFrag && frag.cc === backtrackFrag.cc) {
                frag = backtrackFrag;
                this.fragmentTracker.removeFragment(backtrackFrag);
            }
        } else if (this.backtrackFragment && bufferInfo.len) this.backtrackFragment = null;
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) {
            const gapStart = frag.gap;
            if (!gapStart) {
                // Cleanup the fragment tracker before trying to find the next unbuffered fragment
                const type = this.audioOnly && !this.altAudio ? $99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO : $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO;
                const mediaBuffer = (type === $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                if (mediaBuffer) this.afterBufferFlushed(mediaBuffer, type, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
            }
            frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN, maxBufLen);
        }
        if (!frag) return;
        if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) frag = frag.initSegment;
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    loadFragment(frag, level, targetBufferTime) {
        // Check if fragment is not loaded
        const fragState = this.fragmentTracker.getState(frag);
        if (fragState === $99a156a15cd35eb3$var$FragmentState.NOT_LOADED || fragState === $99a156a15cd35eb3$var$FragmentState.PARTIAL) {
            if (!$99a156a15cd35eb3$var$isMediaFragment(frag)) this._loadInitSegment(frag, level);
            else if (this.bitrateTest) {
                this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
                this._loadBitrateTestFrag(frag, level);
            } else super.loadFragment(frag, level, targetBufferTime);
        } else this.clearTrackerIfNeeded(frag);
    }
    getBufferedFrag(position) {
        return this.fragmentTracker.getBufferedFrag(position, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
    }
    followingBufferedFrag(frag) {
        if (frag) // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.end + 0.5);
        return null;
    }
    /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */ immediateLevelSwitch() {
        this.abortCurrentFrag();
        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    }
    /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */ nextLevelSwitch() {
        const { levels: levels, media: media } = this;
        // ensure that media is defined and that metadata are available (to retrieve currentTime)
        if (media != null && media.readyState) {
            let fetchdelay;
            const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
            if (fragPlayingCurrent && fragPlayingCurrent.start > 1) // flush buffer preceding current fragment (flush until current fragment start offset)
            // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
            this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
            const levelDetails = this.getLevelDetails();
            if (levelDetails != null && levelDetails.live) {
                const bufferInfo = this.getMainFwdBufferInfo();
                // Do not flush in live stream with low buffer
                if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) return;
            }
            if (!media.paused && levels) {
                // add a safety delay of 1s
                const nextLevelId = this.hls.nextLoadLevel;
                const nextLevel = levels[nextLevelId];
                const fragLastKbps = this.fragLastKbps;
                if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
                else fetchdelay = 0;
            } else fetchdelay = 0;
            // this.log('fetchdelay:'+fetchdelay);
            // find buffer range that will be reached once new fragment will be fetched
            const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
            if (bufferedFrag) {
                // we can flush buffer range following this one without stalling playback
                const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
                if (nextBufferedFrag) {
                    // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                    this.abortCurrentFrag();
                    // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
                    const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
                    const fragDuration = nextBufferedFrag.duration;
                    const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? 0.5 : 0.125)), fragDuration * (this.couldBacktrack ? 0.75 : 0.25)));
                    this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
                }
            }
        }
    }
    abortCurrentFrag() {
        const fragCurrent = this.fragCurrent;
        this.fragCurrent = null;
        this.backtrackFragment = null;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.fragmentTracker.removeFragment(fragCurrent);
        }
        switch(this.state){
            case $99a156a15cd35eb3$var$State.KEY_LOADING:
            case $99a156a15cd35eb3$var$State.FRAG_LOADING:
            case $99a156a15cd35eb3$var$State.FRAG_LOADING_WAITING_RETRY:
            case $99a156a15cd35eb3$var$State.PARSING:
            case $99a156a15cd35eb3$var$State.PARSED:
                this.state = $99a156a15cd35eb3$var$State.IDLE;
                break;
        }
        this.nextLoadPosition = this.getLoadPosition();
    }
    flushMainBuffer(startOffset, endOffset) {
        super.flushMainBuffer(startOffset, endOffset, this.altAudio === 2 ? 'video' : null);
    }
    onMediaAttached(event, data) {
        super.onMediaAttached(event, data);
        const media = data.media;
        $99a156a15cd35eb3$var$addEventListener(media, 'playing', this.onMediaPlaying);
        $99a156a15cd35eb3$var$addEventListener(media, 'seeked', this.onMediaSeeked);
    }
    onMediaDetaching(event, data) {
        const { media: media } = this;
        if (media) {
            $99a156a15cd35eb3$var$removeEventListener(media, 'playing', this.onMediaPlaying);
            $99a156a15cd35eb3$var$removeEventListener(media, 'seeked', this.onMediaSeeked);
        }
        this.videoBuffer = null;
        this.fragPlaying = null;
        super.onMediaDetaching(event, data);
        const transferringMedia = !!data.transferMedia;
        if (transferringMedia) return;
        this._hasEnoughToStart = false;
    }
    onManifestLoading() {
        super.onManifestLoading();
        // reset buffer on manifest loading
        this.log('Trigger BUFFER_RESET');
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_RESET, undefined);
        this.couldBacktrack = false;
        this.fragLastKbps = 0;
        this.fragPlaying = this.backtrackFragment = null;
        this.altAudio = 0;
        this.audioOnly = false;
    }
    onManifestParsed(event, data) {
        // detect if we have different kind of audio codecs used amongst playlists
        let aac = false;
        let heaac = false;
        data.levels.forEach((level)=>{
            const codec = level.audioCodec;
            if (codec) {
                aac = aac || codec.indexOf('mp4a.40.2') !== -1;
                heaac = heaac || codec.indexOf('mp4a.40.5') !== -1;
            }
        });
        this.audioCodecSwitch = aac && heaac && !$99a156a15cd35eb3$var$changeTypeSupported();
        if (this.audioCodecSwitch) this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
        this.levels = data.levels;
        this.startFragRequested = false;
    }
    onLevelLoading(event, data) {
        const { levels: levels } = this;
        if (!levels || this.state !== $99a156a15cd35eb3$var$State.IDLE) return;
        const level = data.levelInfo;
        if (!level.details || level.details.live && (this.levelLastLoaded !== level || level.details.expired) || this.waitForCdnTuneIn(level.details)) this.state = $99a156a15cd35eb3$var$State.WAITING_LEVEL;
    }
    onLevelLoaded(event, data) {
        var _curLevel$details;
        const { levels: levels, startFragRequested: startFragRequested } = this;
        const newLevelId = data.level;
        const newDetails = data.details;
        const duration = newDetails.totalduration;
        if (!levels) {
            this.warn(`Levels were reset while loading level ${newLevelId}`);
            return;
        }
        this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
        const curLevel = data.levelInfo;
        const fragCurrent = this.fragCurrent;
        if (fragCurrent && (this.state === $99a156a15cd35eb3$var$State.FRAG_LOADING || this.state === $99a156a15cd35eb3$var$State.FRAG_LOADING_WAITING_RETRY)) {
            if (fragCurrent.level !== data.level && fragCurrent.loader) this.abortCurrentFrag();
        }
        let sliding = 0;
        if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
            var _this$levelLastLoaded;
            this.checkLiveUpdate(newDetails);
            if (newDetails.deltaUpdateFailed) return;
            sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
        }
        // override level info
        curLevel.details = newDetails;
        this.levelLastLoaded = curLevel;
        if (!startFragRequested) this.setStartPosition(newDetails, sliding);
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_UPDATED, {
            details: newDetails,
            level: newLevelId
        });
        // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
        if (this.state === $99a156a15cd35eb3$var$State.WAITING_LEVEL) {
            if (this.waitForCdnTuneIn(newDetails)) // Wait for Low-Latency CDN Tune-in
            return;
            this.state = $99a156a15cd35eb3$var$State.IDLE;
        }
        if (startFragRequested && newDetails.live) this.synchronizeToLiveEdge(newDetails);
        // trigger handler right now
        this.tick();
    }
    synchronizeToLiveEdge(levelDetails) {
        const { config: config, media: media } = this;
        if (!media) return;
        const liveSyncPosition = this.hls.liveSyncPosition;
        const currentTime = this.getLoadPosition();
        const start = levelDetails.fragmentStart;
        const end = levelDetails.edge;
        const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
        // Continue if we can seek forward to sync position or if current time is outside of sliding window
        if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
            // Continue if buffer is starving or if current time is behind max latency
            const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
            if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
                if (!this._hasEnoughToStart) this.nextLoadPosition = liveSyncPosition;
                // Only seek if ready and there is not a significant forward buffer available for playback
                if (media.readyState) {
                    this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
                    if (this.config.liveSyncMode === 'buffered') {
                        var _bufferInfo$buffered;
                        const bufferInfo = $99a156a15cd35eb3$var$BufferHelper.bufferInfo(media, liveSyncPosition, 0);
                        if (!(bufferInfo != null && (_bufferInfo$buffered = bufferInfo.buffered) != null && _bufferInfo$buffered.length)) {
                            media.currentTime = liveSyncPosition;
                            return;
                        }
                        const isLiveSyncInBuffer = bufferInfo.start <= currentTime;
                        if (isLiveSyncInBuffer) {
                            media.currentTime = liveSyncPosition;
                            return;
                        }
                        const { nextStart: nextStart } = $99a156a15cd35eb3$var$BufferHelper.bufferedInfo(bufferInfo.buffered, currentTime, 0);
                        if (nextStart) media.currentTime = nextStart;
                    } else media.currentTime = liveSyncPosition;
                }
            }
        }
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const frag = data.frag;
        const { part: part, payload: payload } = data;
        const { levels: levels } = this;
        if (!levels) {
            this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const currentLevel = levels[frag.level];
        if (!currentLevel) {
            this.warn(`Level ${frag.level} not found on progress`);
            return;
        }
        const details = currentLevel.details;
        if (!details) {
            this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        const videoCodec = currentLevel.videoCodec;
        // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
        const accurateTimeOffset = details.PTSKnown || !details.live;
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        const audioCodec = this._getAudioCodec(currentLevel);
        // transmux the MPEG-TS data to ISO-BMFF segments
        // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
        const transmuxer = this.transmuxer = this.transmuxer || new $99a156a15cd35eb3$var$TransmuxerInterface(this.hls, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        const partIndex = part ? part.index : -1;
        const partial = partIndex !== -1;
        const chunkMeta = new $99a156a15cd35eb3$export$ce0708ece532c9c(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
        const initPTS = this.initPTS[frag.cc];
        transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    }
    onAudioTrackSwitching(event, data) {
        const hls = this.hls;
        // if any URL found on new audio track, it is an alternate audio track
        const fromAltAudio = this.altAudio === 2;
        const altAudio = $99a156a15cd35eb3$var$useAlternateAudio(data.url, hls);
        // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
        // don't do anything if we switch to alt audio: audio stream controller is handling it.
        // we will just have to change buffer scheduling on audioTrackSwitched
        if (!altAudio) {
            if (this.mediaBuffer !== this.media) {
                this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
                this.mediaBuffer = this.media;
                const fragCurrent = this.fragCurrent;
                // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                if (fragCurrent) {
                    this.log('Switching to main audio track, cancel main fragment load');
                    fragCurrent.abortRequests();
                    this.fragmentTracker.removeFragment(fragCurrent);
                }
                // destroy transmuxer to force init segment generation (following audio switch)
                this.resetTransmuxer();
                // switch to IDLE state to load new fragment
                this.resetLoadingState();
            } else if (this.audioOnly) // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
            this.resetTransmuxer();
            // If switching from alt to main audio, flush all audio and trigger track switched
            if (fromAltAudio) {
                this.fragmentTracker.removeAllFragments();
                hls.once($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHED, ()=>{
                    var _this$hls;
                    (_this$hls = this.hls) == null || _this$hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, data);
                });
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_FLUSHING, {
                    startOffset: 0,
                    endOffset: Number.POSITIVE_INFINITY,
                    type: null
                });
                return;
            }
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, data);
        } else this.altAudio = 1;
    }
    onAudioTrackSwitched(event, data) {
        const altAudio = $99a156a15cd35eb3$var$useAlternateAudio(data.url, this.hls);
        if (altAudio) {
            const videoBuffer = this.videoBuffer;
            // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
            if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
                this.mediaBuffer = videoBuffer;
            }
        }
        this.altAudio = altAudio ? 2 : 0;
        this.tick();
    }
    onBufferCreated(event, data) {
        const tracks = data.tracks;
        let mediaTrack;
        let name;
        let alternate = false;
        for(const type in tracks){
            const track = tracks[type];
            if (track.id === 'main') {
                name = type;
                mediaTrack = track;
                // keep video source buffer reference
                if (type === 'video') {
                    const videoTrack = tracks[type];
                    if (videoTrack) this.videoBuffer = videoTrack.buffer;
                }
            } else alternate = true;
        }
        if (alternate && mediaTrack) {
            this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
            this.mediaBuffer = mediaTrack.buffer;
        } else this.mediaBuffer = this.media;
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        const bufferedMainFragment = frag.type === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN;
        if (bufferedMainFragment) {
            if (this.fragContextChanged(frag)) {
                // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
                // Avoid setting state back to IDLE, since that will interfere with a level switch
                this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
                if (this.state === $99a156a15cd35eb3$var$State.PARSED) this.state = $99a156a15cd35eb3$var$State.IDLE;
                return;
            }
            const stats = part ? part.stats : frag.stats;
            this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
            if ($99a156a15cd35eb3$var$isMediaFragment(frag)) this.fragPrevious = frag;
            this.fragBufferedComplete(frag, part);
        }
        const media = this.media;
        if (!media) return;
        if (!this._hasEnoughToStart && $99a156a15cd35eb3$var$BufferHelper.getBuffered(media).length) {
            this._hasEnoughToStart = true;
            this.seekToStartPos();
        }
        if (bufferedMainFragment) this.tick();
    }
    get hasEnoughToStart() {
        return this._hasEnoughToStart;
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = $99a156a15cd35eb3$var$State.ERROR;
            return;
        }
        switch(data.details){
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_GAP:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_PARSING_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError($99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN, data);
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
                if (!data.levelRetry && this.state === $99a156a15cd35eb3$var$State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === $99a156a15cd35eb3$var$PlaylistContextType.LEVEL) this.state = $99a156a15cd35eb3$var$State.IDLE;
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                if (data.parent !== 'main') return;
                this.resetLoadingState();
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.BUFFER_FULL_ERROR:
                if (data.parent !== 'main') return;
                if (this.reduceLengthAndFlushBuffer(data)) this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                break;
            case $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    onFragLoadEmergencyAborted() {
        this.state = $99a156a15cd35eb3$var$State.IDLE;
        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
        // in that case, reset startFragRequested flag
        if (!this._hasEnoughToStart) {
            this.startFragRequested = false;
            this.nextLoadPosition = this.lastCurrentTime;
        }
        this.tickImmediate();
    }
    onBufferFlushed(event, { type: type }) {
        if (type !== $99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO || !this.altAudio) {
            const mediaBuffer = (type === $99a156a15cd35eb3$var$ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
            if (mediaBuffer) {
                this.afterBufferFlushed(mediaBuffer, type, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
                this.tick();
            }
        }
    }
    onLevelsUpdated(event, data) {
        if (this.level > -1 && this.fragCurrent) {
            this.level = this.fragCurrent.level;
            if (this.level === -1) this.resetWhenMissingContext(this.fragCurrent);
        }
        this.levels = data.levels;
    }
    swapAudioCodec() {
        this.audioCodecSwap = !this.audioCodecSwap;
    }
    /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */ seekToStartPos() {
        const { media: media } = this;
        if (!media) return;
        const currentTime = media.currentTime;
        let startPosition = this.startPosition;
        // only adjust currentTime if different from startPosition or if startPosition not buffered
        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
        if (startPosition >= 0 && currentTime < startPosition) {
            if (media.seeking) {
                this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
                return;
            }
            // Offset start position by timeline offset
            const timelineOffset = this.timelineOffset;
            if (timelineOffset && startPosition) startPosition += timelineOffset;
            const details = this.getLevelDetails();
            const buffered = $99a156a15cd35eb3$var$BufferHelper.getBuffered(media);
            const bufferStart = buffered.length ? buffered.start(0) : 0;
            const delta = bufferStart - startPosition;
            const skipTolerance = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
            if (this.config.startOnSegmentBoundary || delta > 0 && (delta < skipTolerance || this.loadingParts && delta < 2 * ((details == null ? void 0 : details.partTarget) || 0))) {
                this.log(`adjusting start position by ${delta} to match buffer start`);
                startPosition += delta;
                this.startPosition = startPosition;
            }
            if (currentTime < startPosition) {
                this.log(`seek to target start position ${startPosition} from current time ${currentTime} buffer start ${bufferStart}`);
                media.currentTime = startPosition;
            }
        }
    }
    _getAudioCodec(currentLevel) {
        let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
        if (this.audioCodecSwap && audioCodec) {
            this.log('Swapping audio codec');
            if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
            else audioCodec = 'mp4a.40.5';
        }
        return audioCodec;
    }
    _loadBitrateTestFrag(fragment, level) {
        fragment.bitrateTest = true;
        this._doFragLoad(fragment, level).then((data)=>{
            const { hls: hls } = this;
            const frag = data == null ? void 0 : data.frag;
            if (!frag || this.fragContextChanged(frag)) return;
            level.fragmentError = 0;
            this.state = $99a156a15cd35eb3$var$State.IDLE;
            this.startFragRequested = false;
            this.bitrateTest = false;
            const stats = frag.stats;
            // Bitrate tests fragments are neither parsed nor buffered
            stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_LOADED, data);
            frag.bitrateTest = false;
        });
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = this.playlistType;
        const { hls: hls } = this;
        const { remuxResult: remuxResult, chunkMeta: chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const { video: video, text: text, id3: id3, initSegment: initSegment } = remuxResult;
        const { details: details } = level;
        // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
        const audio = this.altAudio ? undefined : remuxResult.audio;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag)) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = $99a156a15cd35eb3$var$State.PARSING;
        if (initSegment) {
            if (initSegment != null && initSegment.tracks) {
                const mapFragment = frag.initSegment || frag;
                this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_INIT_SEGMENT, {
                    frag: mapFragment,
                    id: id,
                    tracks: initSegment.tracks
                });
            }
            // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
            const initPTS = initSegment.initPTS;
            const timescale = initSegment.timescale;
            if ($99a156a15cd35eb3$var$isFiniteNumber(initPTS)) {
                this.initPTS[frag.cc] = {
                    baseTime: initPTS,
                    timescale: timescale
                };
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.INIT_PTS_FOUND, {
                    frag: frag,
                    id: id,
                    initPTS: initPTS,
                    timescale: timescale
                });
            }
        }
        // Avoid buffering if backtracking this fragment
        if (video && details) {
            if (audio && video.type === 'audiovideo') this.logMuxedErr(frag);
            const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
            const isFirstFragment = frag.sn === details.startSN;
            const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
            if (remuxResult.independent !== false) {
                const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = video;
                if (part) part.elementaryStreams[video.type] = {
                    startPTS: startPTS,
                    endPTS: endPTS,
                    startDTS: startDTS,
                    endDTS: endDTS
                };
                else {
                    if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) this.couldBacktrack = true;
                    if (video.dropped && video.independent) {
                        // Backtrack if dropped frames create a gap after currentTime
                        const bufferInfo = this.getMainFwdBufferInfo();
                        const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
                        const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
                        if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
                            this.backtrack(frag);
                            return;
                        } else if (isFirstInDiscontinuity) // Mark segment with a gap to avoid loop loading
                        frag.gap = true;
                        // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
                        frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
                    } else if (isFirstFragment && startPTS - (details.appliedTimelineOffset || 0) > $99a156a15cd35eb3$var$MAX_START_GAP_JUMP) // Mark segment with a gap to skip large start gap
                    frag.gap = true;
                }
                frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
                if (this.backtrackFragment) this.backtrackFragment = frag;
                this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
            } else if (isFirstFragment || isFirstInDiscontinuity) // Mark segment with a gap to avoid loop loading
            frag.gap = true;
            else {
                this.backtrack(frag);
                return;
            }
        }
        if (audio) {
            const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = audio;
            if (part) part.elementaryStreams[$99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS
            };
            frag.setElementaryStreamInfo($99a156a15cd35eb3$var$ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (details && id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = {
                id: id,
                frag: frag,
                details: details,
                samples: id3.samples
            };
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_METADATA, emittedID3);
        }
        if (details && text) {
            const emittedText = {
                id: id,
                frag: frag,
                details: details,
                samples: text.samples
            };
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    logMuxedErr(frag) {
        this.warn(`${$99a156a15cd35eb3$var$isMediaFragment(frag) ? 'Media' : 'Init'} segment with muxed audiovideo where only video expected: ${frag.url}`);
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== $99a156a15cd35eb3$var$State.PARSING) return;
        this.audioOnly = !!tracks.audio && !tracks.video;
        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (this.altAudio && !this.audioOnly) {
            delete tracks.audio;
            if (tracks.audiovideo) this.logMuxedErr(frag);
        }
        // include levelCodec in audio and video tracks
        const { audio: audio, video: video, audiovideo: audiovideo } = tracks;
        if (audio) {
            let audioCodec = $99a156a15cd35eb3$var$pickMostCompleteCodecName(audio.codec, currentLevel.audioCodec);
            // Add level and profile to make up for passthrough-remuxer not being able to parse full codec
            // (logger warning "Unhandled audio codec...")
            if (audioCodec === 'mp4a') audioCodec = 'mp4a.40.5';
            // Handle `audioCodecSwitch`
            const ua = navigator.userAgent.toLowerCase();
            if (this.audioCodecSwitch) {
                if (audioCodec) {
                    if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
                    else audioCodec = 'mp4a.40.5';
                }
                // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
                // force HE-AAC, as it seems that most browsers prefers it.
                // don't force HE-AAC if mono stream, or in Firefox
                const audioMetadata = audio.metadata;
                if (audioMetadata && 'channelCount' in audioMetadata && (audioMetadata.channelCount || 1) !== 1 && ua.indexOf('firefox') === -1) audioCodec = 'mp4a.40.5';
            }
            // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
            if (audioCodec && audioCodec.indexOf('mp4a.40.5') !== -1 && ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
                // Exclude mpeg audio
                audioCodec = 'mp4a.40.2';
                this.log(`Android: force audio codec to ${audioCodec}`);
            }
            if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) this.log(`Swapping manifest audio codec "${currentLevel.audioCodec}" for "${audioCodec}"`);
            audio.levelCodec = audioCodec;
            audio.id = $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN;
            this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${currentLevel.audioCodec || ''}/${audio.codec}]`);
            delete tracks.audiovideo;
        }
        if (video) {
            video.levelCodec = currentLevel.videoCodec;
            video.id = $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN;
            const parsedVideoCodec = video.codec;
            if ((parsedVideoCodec == null ? void 0 : parsedVideoCodec.length) === 4) // Make up for passthrough-remuxer not being able to parse full codec
            // (logger warning "Unhandled video codec...")
            switch(parsedVideoCodec){
                case 'hvc1':
                case 'hev1':
                    video.codec = 'hvc1.1.6.L120.90';
                    break;
                case 'av01':
                    video.codec = 'av01.0.04M.08';
                    break;
                case 'avc1':
                    video.codec = 'avc1.42e01e';
                    break;
            }
            this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${parsedVideoCodec}]${video.codec !== parsedVideoCodec ? ' parsed-corrected=' + video.codec : ''}${video.supplemental ? ' supplemental=' + video.supplemental : ''}`);
            delete tracks.audiovideo;
        }
        if (audiovideo) {
            this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
            delete tracks.video;
            delete tracks.audio;
        }
        const trackTypes = Object.keys(tracks);
        if (trackTypes.length) {
            this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_CODECS, tracks);
            if (!this.hls) // Exit after fatal tracks error
            return;
            // loop through tracks that are going to be provided to bufferController
            trackTypes.forEach((trackName)=>{
                const track = tracks[trackName];
                const initSegment = track.initSegment;
                if (initSegment != null && initSegment.byteLength) this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.BUFFER_APPENDING, {
                    type: trackName,
                    data: initSegment,
                    frag: frag,
                    part: null,
                    chunkMeta: chunkMeta,
                    parent: frag.type
                });
            });
        }
        // trigger handler right now
        this.tickImmediate();
    }
    getMainFwdBufferInfo() {
        // Observe video SourceBuffer (this.mediaBuffer) only when alt-audio is used, otherwise observe combined media buffer
        const bufferOutput = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
        return this.getFwdBufferInfo(bufferOutput, $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN);
    }
    get maxBufferLength() {
        const { levels: levels, level: level } = this;
        const levelInfo = levels == null ? void 0 : levels[level];
        if (!levelInfo) return this.config.maxBufferLength;
        return this.getMaxBufferLength(levelInfo.maxBitrate);
    }
    backtrack(frag) {
        this.couldBacktrack = true;
        // Causes findFragments to backtrack through fragments to find the keyframe
        this.backtrackFragment = frag;
        this.resetTransmuxer();
        this.flushBufferGap(frag);
        this.fragmentTracker.removeFragment(frag);
        this.fragPrevious = null;
        this.nextLoadPosition = frag.start;
        this.state = $99a156a15cd35eb3$var$State.IDLE;
    }
    checkFragmentChanged() {
        const video = this.media;
        let fragPlayingCurrent = null;
        if (video && video.readyState > 1 && video.seeking === false) {
            const currentTime = video.currentTime;
            /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */ if ($99a156a15cd35eb3$var$BufferHelper.isBuffered(video, currentTime)) fragPlayingCurrent = this.getAppendedFrag(currentTime);
            else if ($99a156a15cd35eb3$var$BufferHelper.isBuffered(video, currentTime + 0.1)) /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */ fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
            if (fragPlayingCurrent) {
                this.backtrackFragment = null;
                const fragPlaying = this.fragPlaying;
                const fragCurrentLevel = fragPlayingCurrent.level;
                if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
                    this.fragPlaying = fragPlayingCurrent;
                    this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.FRAG_CHANGED, {
                        frag: fragPlayingCurrent
                    });
                    if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_SWITCHED, {
                        level: fragCurrentLevel
                    });
                }
            }
        }
    }
    get nextLevel() {
        const frag = this.nextBufferedFrag;
        if (frag) return frag.level;
        return -1;
    }
    get currentFrag() {
        var _this$media3;
        if (this.fragPlaying) return this.fragPlaying;
        const currentTime = ((_this$media3 = this.media) == null ? void 0 : _this$media3.currentTime) || this.lastCurrentTime;
        if ($99a156a15cd35eb3$var$isFiniteNumber(currentTime)) return this.getAppendedFrag(currentTime);
        return null;
    }
    get currentProgramDateTime() {
        var _this$media4;
        const currentTime = ((_this$media4 = this.media) == null ? void 0 : _this$media4.currentTime) || this.lastCurrentTime;
        if ($99a156a15cd35eb3$var$isFiniteNumber(currentTime)) {
            const details = this.getLevelDetails();
            const frag = this.currentFrag || (details ? $99a156a15cd35eb3$var$findFragmentByPTS(null, details.fragments, currentTime) : null);
            if (frag) {
                const programDateTime = frag.programDateTime;
                if (programDateTime !== null) {
                    const epocMs = programDateTime + (currentTime - frag.start) * 1000;
                    return new Date(epocMs);
                }
            }
        }
        return null;
    }
    get currentLevel() {
        const frag = this.currentFrag;
        if (frag) return frag.level;
        return -1;
    }
    get nextBufferedFrag() {
        const frag = this.currentFrag;
        if (frag) return this.followingBufferedFrag(frag);
        return null;
    }
    get forceStartLoad() {
        return this._forceStartLoad;
    }
}
class $99a156a15cd35eb3$var$KeyLoader {
    constructor(config){
        this.config = void 0;
        this.keyUriToKeyInfo = {};
        this.emeController = null;
        this.config = config;
    }
    abort(type) {
        for(const uri in this.keyUriToKeyInfo){
            const loader = this.keyUriToKeyInfo[uri].loader;
            if (loader) {
                var _loader$context;
                if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) return;
                loader.abort();
            }
        }
    }
    detach() {
        for(const uri in this.keyUriToKeyInfo){
            const keyInfo = this.keyUriToKeyInfo[uri];
            // Remove cached EME keys on detach
            if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) delete this.keyUriToKeyInfo[uri];
        }
    }
    destroy() {
        this.detach();
        for(const uri in this.keyUriToKeyInfo){
            const loader = this.keyUriToKeyInfo[uri].loader;
            if (loader) loader.destroy();
        }
        this.keyUriToKeyInfo = {};
    }
    createKeyLoadError(frag, details = $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR, error, networkDetails, response) {
        return new $99a156a15cd35eb3$var$LoadError({
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: details,
            fatal: false,
            frag: frag,
            response: response,
            error: error,
            networkDetails: networkDetails
        });
    }
    loadClear(loadingFrag, encryptedFragments) {
        if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
            // access key-system with nearest key on start (loading frag is unencrypted)
            if (encryptedFragments.length) {
                const { sn: sn, cc: cc } = loadingFrag;
                for(let i = 0; i < encryptedFragments.length; i++){
                    const frag = encryptedFragments[i];
                    if (cc <= frag.cc && (sn === 'initSegment' || frag.sn === 'initSegment' || sn < frag.sn)) return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
                        frag.setKeyFormat(keySystemFormat);
                        if (this.emeController && this.config.requireKeySystemAccessOnStart) {
                            const keySystem = $99a156a15cd35eb3$var$keySystemFormatToKeySystemDomain(keySystemFormat);
                            if (keySystem) return this.emeController.getKeySystemAccess([
                                keySystem
                            ]);
                        }
                    });
                }
            } else if (this.config.requireKeySystemAccessOnStart) {
                const keySystemsInConfig = $99a156a15cd35eb3$var$getKeySystemsForConfig(this.config);
                if (keySystemsInConfig.length) return this.emeController.getKeySystemAccess(keySystemsInConfig);
            }
        }
        return null;
    }
    load(frag) {
        if (!frag.decryptdata && frag.encrypted && this.emeController && this.config.emeEnabled) // Multiple keys, but none selected, resolve in eme-controller
        return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
            return this.loadInternal(frag, keySystemFormat);
        });
        return this.loadInternal(frag);
    }
    loadInternal(frag, keySystemFormat) {
        var _keyInfo, _keyInfo2;
        if (keySystemFormat) frag.setKeyFormat(keySystemFormat);
        const decryptdata = frag.decryptdata;
        if (!decryptdata) {
            const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : 'Missing decryption data on fragment in onKeyLoading');
            return Promise.reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR, error));
        }
        const uri = decryptdata.uri;
        if (!uri) return Promise.reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
        let keyInfo = this.keyUriToKeyInfo[uri];
        if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
            decryptdata.key = keyInfo.decryptdata.key;
            return Promise.resolve({
                frag: frag,
                keyInfo: keyInfo
            });
        }
        // Return key load promise as long as it does not have a mediakey session with an unusable key status
        if ((_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
            var _keyInfo$mediaKeySess;
            switch((_keyInfo$mediaKeySess = keyInfo.mediaKeySessionContext) == null ? void 0 : _keyInfo$mediaKeySess.keyStatus){
                case undefined:
                case 'status-pending':
                case 'usable':
                case 'usable-in-future':
                    return keyInfo.keyLoadPromise.then((keyLoadedData)=>{
                        // Return the correct fragment with updated decryptdata key and loaded keyInfo
                        decryptdata.key = keyLoadedData.keyInfo.decryptdata.key;
                        return {
                            frag: frag,
                            keyInfo: keyInfo
                        };
                    });
            }
        // If we have a key session and status and it is not pending or usable, continue
        // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
        }
        // Load the key or return the loading promise
        keyInfo = this.keyUriToKeyInfo[uri] = {
            decryptdata: decryptdata,
            keyLoadPromise: null,
            loader: null,
            mediaKeySessionContext: null
        };
        switch(decryptdata.method){
            case 'ISO-23001-7':
            case 'SAMPLE-AES':
            case 'SAMPLE-AES-CENC':
            case 'SAMPLE-AES-CTR':
                if (decryptdata.keyFormat === 'identity') // loadKeyHTTP handles http(s) and data URLs
                return this.loadKeyHTTP(keyInfo, frag);
                return this.loadKeyEME(keyInfo, frag);
            case 'AES-128':
            case 'AES-256':
            case 'AES-256-CTR':
                return this.loadKeyHTTP(keyInfo, frag);
            default:
                return Promise.reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
        }
    }
    loadKeyEME(keyInfo, frag) {
        const keyLoadedData = {
            frag: frag,
            keyInfo: keyInfo
        };
        if (this.emeController && this.config.emeEnabled) {
            const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
            if (keySessionContextPromise) return (keyInfo.keyLoadPromise = keySessionContextPromise.then((keySessionContext)=>{
                keyInfo.mediaKeySessionContext = keySessionContext;
                return keyLoadedData;
            })).catch((error)=>{
                // Remove promise for license renewal or retry
                keyInfo.keyLoadPromise = null;
                throw error;
            });
        }
        return Promise.resolve(keyLoadedData);
    }
    loadKeyHTTP(keyInfo, frag) {
        const config = this.config;
        const Loader = config.loader;
        const keyLoader = new Loader(config);
        frag.keyLoader = keyInfo.loader = keyLoader;
        return keyInfo.keyLoadPromise = new Promise((resolve, reject)=>{
            const loaderContext = {
                keyInfo: keyInfo,
                frag: frag,
                responseType: 'arraybuffer',
                url: keyInfo.decryptdata.uri
            };
            // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
            // key-loader will trigger an error and rely on stream-controller to handle retry logic.
            // this will also align retry logic with fragment-loader
            const loadPolicy = config.keyLoadPolicy.default;
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    const { frag: frag, keyInfo: keyInfo, url: uri } = context;
                    if (!frag.decryptdata || keyInfo !== this.keyUriToKeyInfo[uri]) return reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
                    keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);
                    // detach fragment key loader on load success
                    frag.keyLoader = null;
                    keyInfo.loader = null;
                    resolve({
                        frag: frag,
                        keyInfo: keyInfo
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, $99a156a15cd35eb3$var$_objectSpread2({
                        url: loaderContext.url,
                        data: undefined
                    }, response)));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
                }
            };
            keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    resetLoader(context) {
        const { frag: frag, keyInfo: keyInfo, url: uri } = context;
        const loader = keyInfo.loader;
        if (frag.keyLoader === loader) {
            frag.keyLoader = null;
            keyInfo.loader = null;
        }
        delete this.keyUriToKeyInfo[uri];
        if (loader) loader.destroy();
    }
}
function $99a156a15cd35eb3$var$mapContextToLevelType(context) {
    const { type: type } = context;
    switch(type){
        case $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK:
            return $99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO;
        case $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK:
            return $99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE;
        default:
            return $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN;
    }
}
function $99a156a15cd35eb3$var$getResponseUrl(response, context) {
    let url = response.url;
    // responseURL not supported on some browsers (it is used to detect URL redirection)
    // data-uri mode also not supported (but no need to detect redirection)
    if (url === undefined || url.indexOf('data:') === 0) // fallback to initial URL
    url = context.url;
    return url;
}
class $99a156a15cd35eb3$var$PlaylistLoader {
    constructor(hls){
        this.hls = void 0;
        this.loaders = Object.create(null);
        this.variableList = null;
        this.onManifestLoaded = this.checkAutostartLoad;
        this.hls = hls;
        this.registerListeners();
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.destroyInternalLoaders();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
        hls.on($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
        hls.off($99a156a15cd35eb3$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
    }
    /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */ createInternalLoader(context) {
        const config = this.hls.config;
        const PLoader = config.pLoader;
        const Loader = config.loader;
        const InternalLoader = PLoader || Loader;
        const loader = new InternalLoader(config);
        this.loaders[context.type] = loader;
        return loader;
    }
    getInternalLoader(context) {
        return this.loaders[context.type];
    }
    resetInternalLoader(contextType) {
        if (this.loaders[contextType]) delete this.loaders[contextType];
    }
    /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */ destroyInternalLoaders() {
        for(const contextType in this.loaders){
            const loader = this.loaders[contextType];
            if (loader) loader.destroy();
            this.resetInternalLoader(contextType);
        }
    }
    destroy() {
        this.variableList = null;
        this.unregisterListeners();
        this.destroyInternalLoaders();
    }
    onManifestLoading(event, data) {
        const { url: url } = data;
        this.variableList = null;
        this.load({
            id: null,
            level: 0,
            responseType: 'text',
            type: $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST,
            url: url,
            deliveryDirectives: null,
            levelOrTrack: null
        });
    }
    onLevelLoading(event, data) {
        const { id: id, level: level, pathwayId: pathwayId, url: url, deliveryDirectives: deliveryDirectives, levelInfo: levelInfo } = data;
        this.load({
            id: id,
            level: level,
            pathwayId: pathwayId,
            responseType: 'text',
            type: $99a156a15cd35eb3$var$PlaylistContextType.LEVEL,
            url: url,
            deliveryDirectives: deliveryDirectives,
            levelOrTrack: levelInfo
        });
    }
    onAudioTrackLoading(event, data) {
        const { id: id, groupId: groupId, url: url, deliveryDirectives: deliveryDirectives, track: track } = data;
        this.load({
            id: id,
            groupId: groupId,
            level: null,
            responseType: 'text',
            type: $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK,
            url: url,
            deliveryDirectives: deliveryDirectives,
            levelOrTrack: track
        });
    }
    onSubtitleTrackLoading(event, data) {
        const { id: id, groupId: groupId, url: url, deliveryDirectives: deliveryDirectives, track: track } = data;
        this.load({
            id: id,
            groupId: groupId,
            level: null,
            responseType: 'text',
            type: $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK,
            url: url,
            deliveryDirectives: deliveryDirectives,
            levelOrTrack: track
        });
    }
    onLevelsUpdated(event, data) {
        // abort and delete loader of removed levels
        const loader = this.loaders[$99a156a15cd35eb3$var$PlaylistContextType.LEVEL];
        if (loader) {
            const context = loader.context;
            if (context && !data.levels.some((lvl)=>lvl === context.levelOrTrack)) {
                loader.abort();
                delete this.loaders[$99a156a15cd35eb3$var$PlaylistContextType.LEVEL];
            }
        }
    }
    load(context) {
        var _context$deliveryDire;
        const config = this.hls.config;
        // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);
        // Check if a loader for this context already exists
        let loader = this.getInternalLoader(context);
        if (loader) {
            const logger = this.hls.logger;
            const loaderContext = loader.context;
            if (loaderContext && loaderContext.levelOrTrack === context.levelOrTrack && (loaderContext.url === context.url || loaderContext.deliveryDirectives && !context.deliveryDirectives)) {
                // same URL can't overlap, or wait for blocking request
                if (loaderContext.url === context.url) logger.log(`[playlist-loader]: ignore ${context.url} ongoing request`);
                else logger.log(`[playlist-loader]: ignore ${context.url} in favor of ${loaderContext.url}`);
                return;
            }
            logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
            loader.abort();
        }
        // apply different configs for retries depending on
        // context (manifest, level, audio/subs playlist)
        let loadPolicy;
        if (context.type === $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST) loadPolicy = config.manifestLoadPolicy.default;
        else loadPolicy = $99a156a15cd35eb3$var$_extends({}, config.playlistLoadPolicy.default, {
            timeoutRetry: null,
            errorRetry: null
        });
        loader = this.createInternalLoader(context);
        // Override level/track timeout for LL-HLS requests
        // (the default of 10000ms is counter productive to blocking playlist reload requests)
        if ($99a156a15cd35eb3$var$isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
            let levelDetails;
            if (context.type === $99a156a15cd35eb3$var$PlaylistContextType.LEVEL && context.level !== null) levelDetails = this.hls.levels[context.level].details;
            else if (context.type === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK && context.id !== null) levelDetails = this.hls.audioTracks[context.id].details;
            else if (context.type === $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK && context.id !== null) levelDetails = this.hls.subtitleTracks[context.id].details;
            if (levelDetails) {
                const partTarget = levelDetails.partTarget;
                const targetDuration = levelDetails.targetduration;
                if (partTarget && targetDuration) {
                    const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
                    loadPolicy = $99a156a15cd35eb3$var$_extends({}, loadPolicy, {
                        maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
                        maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
                    });
                }
            }
        }
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const loaderCallbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                const loader = this.getInternalLoader(context);
                this.resetInternalLoader(context.type);
                const string = response.data;
                // Validate if it is an M3U8 at all
                if (string.indexOf('#EXTM3U') !== 0) {
                    this.handleManifestParsingError(response, context, new Error('no EXTM3U delimiter'), networkDetails || null, stats);
                    return;
                }
                stats.parsing.start = performance.now();
                if ($99a156a15cd35eb3$export$c1bd440a1b47590d.isMediaPlaylist(string) || context.type !== $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST) this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
                else this.handleMasterPlaylist(response, stats, context, networkDetails);
            },
            onError: (response, context, networkDetails, stats)=>{
                this.handleNetworkError(context, networkDetails, false, response, stats);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.handleNetworkError(context, networkDetails, true, undefined, stats);
            }
        };
        // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);
        loader.load(context, loaderConfig, loaderCallbacks);
    }
    checkAutostartLoad() {
        if (!this.hls) return;
        const { config: { autoStartLoad: autoStartLoad, startPosition: startPosition }, forceStartLoad: forceStartLoad } = this.hls;
        if (autoStartLoad || forceStartLoad) {
            this.hls.logger.log(`${autoStartLoad ? 'auto' : 'force'} startLoad with configured startPosition ${startPosition}`);
            this.hls.startLoad(startPosition);
        }
    }
    handleMasterPlaylist(response, stats, context, networkDetails) {
        const hls = this.hls;
        const string = response.data;
        const url = $99a156a15cd35eb3$var$getResponseUrl(response, context);
        const parsedResult = $99a156a15cd35eb3$export$c1bd440a1b47590d.parseMasterPlaylist(string, url);
        if (parsedResult.playlistParsingError) {
            this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
            return;
        }
        const { contentSteering: contentSteering, levels: levels, sessionData: sessionData, sessionKeys: sessionKeys, startTimeOffset: startTimeOffset, variableList: variableList } = parsedResult;
        this.variableList = variableList;
        const { AUDIO: audioTracks = [], SUBTITLES: subtitles, 'CLOSED-CAPTIONS': captions } = $99a156a15cd35eb3$export$c1bd440a1b47590d.parseMasterPlaylistMedia(string, url, parsedResult);
        if (audioTracks.length) {
            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
            const embeddedAudioFound = audioTracks.some((audioTrack)=>!audioTrack.url);
            // if no embedded audio track defined, but audio codec signaled in quality level,
            // we need to signal this main audio track this could happen with playlists with
            // alt audio rendition in which quality levels (main)
            // contains both audio+video. but with mixed audio track not signaled
            if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                this.hls.logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({
                    type: 'main',
                    name: 'main',
                    groupId: 'main',
                    default: false,
                    autoselect: false,
                    forced: false,
                    id: -1,
                    attrs: new $99a156a15cd35eb3$export$3b2a5864ee72b619({}),
                    bitrate: 0,
                    url: ''
                });
            }
        }
        hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, {
            levels: levels,
            audioTracks: audioTracks,
            subtitles: subtitles,
            captions: captions,
            contentSteering: contentSteering,
            url: url,
            stats: stats,
            networkDetails: networkDetails,
            sessionData: sessionData,
            sessionKeys: sessionKeys,
            startTimeOffset: startTimeOffset,
            variableList: variableList
        });
    }
    handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { id: id, level: level, type: type } = context;
        const url = $99a156a15cd35eb3$var$getResponseUrl(response, context);
        const levelId = $99a156a15cd35eb3$var$isFiniteNumber(level) ? level : $99a156a15cd35eb3$var$isFiniteNumber(id) ? id : 0;
        const levelType = $99a156a15cd35eb3$var$mapContextToLevelType(context);
        const levelDetails = $99a156a15cd35eb3$export$c1bd440a1b47590d.parseLevelPlaylist(response.data, url, levelId, levelType, 0, this.variableList);
        // We have done our first request (Manifest-type) and receive
        // not a master playlist but a chunk-list (track/level)
        // We fire the manifest-loaded event anyway with the parsed level-details
        // by creating a single-level structure for it.
        if (type === $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST) {
            const singleLevel = {
                attrs: new $99a156a15cd35eb3$export$3b2a5864ee72b619({}),
                bitrate: 0,
                details: levelDetails,
                name: '',
                url: url
            };
            levelDetails.requestScheduled = stats.loading.start + $99a156a15cd35eb3$var$computeReloadInterval(levelDetails, 0);
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, {
                levels: [
                    singleLevel
                ],
                audioTracks: [],
                url: url,
                stats: stats,
                networkDetails: networkDetails,
                sessionData: null,
                sessionKeys: null,
                contentSteering: null,
                startTimeOffset: null,
                variableList: null
            });
        }
        // save parsing time
        stats.parsing.end = performance.now();
        // extend the context with the new levelDetails property
        context.levelDetails = levelDetails;
        this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
    }
    handleManifestParsingError(response, context, error, networkDetails, stats) {
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: $99a156a15cd35eb3$export$d053ec805ce391aa.MANIFEST_PARSING_ERROR,
            fatal: context.type === $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST,
            url: response.url,
            err: error,
            error: error,
            reason: error.message,
            response: response,
            context: context,
            networkDetails: networkDetails,
            stats: stats
        });
    }
    handleNetworkError(context, networkDetails, timeout = false, response, stats) {
        let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
        if (context.type === $99a156a15cd35eb3$var$PlaylistContextType.LEVEL) message += `: ${context.level} id: ${context.id}`;
        else if (context.type === $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK || context.type === $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK) message += ` id: ${context.id} group-id: "${context.groupId}"`;
        const error = new Error(message);
        this.hls.logger.warn(`[playlist-loader]: ${message}`);
        let details = $99a156a15cd35eb3$export$d053ec805ce391aa.UNKNOWN;
        let fatal = false;
        const loader = this.getInternalLoader(context);
        switch(context.type){
            case $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST:
                details = timeout ? $99a156a15cd35eb3$export$d053ec805ce391aa.MANIFEST_LOAD_TIMEOUT : $99a156a15cd35eb3$export$d053ec805ce391aa.MANIFEST_LOAD_ERROR;
                fatal = true;
                break;
            case $99a156a15cd35eb3$var$PlaylistContextType.LEVEL:
                details = timeout ? $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT : $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_LOAD_ERROR;
                fatal = false;
                break;
            case $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK:
                details = timeout ? $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_TIMEOUT : $99a156a15cd35eb3$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR;
                fatal = false;
                break;
            case $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK:
                details = timeout ? $99a156a15cd35eb3$export$d053ec805ce391aa.SUBTITLE_TRACK_LOAD_TIMEOUT : $99a156a15cd35eb3$export$d053ec805ce391aa.SUBTITLE_LOAD_ERROR;
                fatal = false;
                break;
        }
        if (loader) this.resetInternalLoader(context.type);
        const errorData = {
            type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: details,
            fatal: fatal,
            url: context.url,
            loader: loader,
            context: context,
            error: error,
            networkDetails: networkDetails,
            stats: stats
        };
        if (response) {
            const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
            errorData.response = $99a156a15cd35eb3$var$_objectSpread2({
                url: url,
                data: undefined
            }, response);
        }
        this.hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, errorData);
    }
    handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { type: type, level: level, id: id, groupId: groupId, deliveryDirectives: deliveryDirectives } = context;
        const url = $99a156a15cd35eb3$var$getResponseUrl(response, context);
        const parent = $99a156a15cd35eb3$var$mapContextToLevelType(context);
        const levelIndex = typeof context.level === 'number' && parent === $99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN ? level : undefined;
        if (!levelDetails.fragments.length) {
            const _error = levelDetails.playlistParsingError = new Error('No Segments found in Playlist');
            hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_EMPTY_ERROR,
                fatal: false,
                url: url,
                error: _error,
                reason: _error.message,
                response: response,
                context: context,
                level: levelIndex,
                parent: parent,
                networkDetails: networkDetails,
                stats: stats
            });
            return;
        }
        if (!levelDetails.targetduration) levelDetails.playlistParsingError = new Error('Missing Target Duration');
        const error = levelDetails.playlistParsingError;
        if (error) {
            this.hls.logger.warn(error);
            if (!hls.config.ignorePlaylistParsingErrors) {
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.NETWORK_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.LEVEL_PARSING_ERROR,
                    fatal: false,
                    url: url,
                    error: error,
                    reason: error.message,
                    response: response,
                    context: context,
                    level: levelIndex,
                    parent: parent,
                    networkDetails: networkDetails,
                    stats: stats
                });
                return;
            }
            levelDetails.playlistParsingError = null;
        }
        if (levelDetails.live && loader) {
            if (loader.getCacheAge) levelDetails.ageHeader = loader.getCacheAge() || 0;
            if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) levelDetails.ageHeader = 0;
        }
        switch(type){
            case $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST:
            case $99a156a15cd35eb3$var$PlaylistContextType.LEVEL:
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.LEVEL_LOADED, {
                    details: levelDetails,
                    levelInfo: context.levelOrTrack || hls.levels[0],
                    level: levelIndex || 0,
                    id: id || 0,
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives,
                    withoutMultiVariant: type === $99a156a15cd35eb3$var$PlaylistContextType.MANIFEST
                });
                break;
            case $99a156a15cd35eb3$var$PlaylistContextType.AUDIO_TRACK:
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.AUDIO_TRACK_LOADED, {
                    details: levelDetails,
                    track: context.levelOrTrack,
                    id: id || 0,
                    groupId: groupId || '',
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
            case $99a156a15cd35eb3$var$PlaylistContextType.SUBTITLE_TRACK:
                hls.trigger($99a156a15cd35eb3$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, {
                    details: levelDetails,
                    track: context.levelOrTrack,
                    id: id || 0,
                    groupId: groupId || '',
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
        }
    }
}
/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */ class $99a156a15cd35eb3$export$1f323ed185d61c3 {
    /**
   * Get the video-dev/hls.js package version.
   */ static get version() {
        return $99a156a15cd35eb3$var$version;
    }
    /**
   * Check if the required MediaSource Extensions are available.
   */ static isMSESupported() {
        return $99a156a15cd35eb3$export$e9e4a33dcf7638ad();
    }
    /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */ static isSupported() {
        return $99a156a15cd35eb3$export$48c17662a6902497();
    }
    /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */ static getMediaSource() {
        return $99a156a15cd35eb3$export$a92854129bc50f89();
    }
    static get Events() {
        return $99a156a15cd35eb3$export$ada873a34909da65;
    }
    static get MetadataSchema() {
        return $99a156a15cd35eb3$export$3f0d1211c87abf7f;
    }
    static get ErrorTypes() {
        return $99a156a15cd35eb3$export$43a750ddd9f2303e;
    }
    static get ErrorDetails() {
        return $99a156a15cd35eb3$export$d053ec805ce391aa;
    }
    /**
   * Get the default configuration applied to new instances.
   */ static get DefaultConfig() {
        if (!$99a156a15cd35eb3$export$1f323ed185d61c3.defaultConfig) return $99a156a15cd35eb3$var$hlsDefaultConfig;
        return $99a156a15cd35eb3$export$1f323ed185d61c3.defaultConfig;
    }
    /**
   * Replace the default configuration applied to new instances.
   */ static set DefaultConfig(defaultConfig) {
        $99a156a15cd35eb3$export$1f323ed185d61c3.defaultConfig = defaultConfig;
    }
    /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */ constructor(userConfig = {}){
        /**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */ this.config = void 0;
        /**
     * The configuration object provided on player instantiation.
     */ this.userConfig = void 0;
        /**
     * The logger functions used by this player instance, configured on player instantiation.
     */ this.logger = void 0;
        this.coreComponents = void 0;
        this.networkControllers = void 0;
        this._emitter = new $99a156a15cd35eb3$var$EventEmitter();
        this._autoLevelCapping = -1;
        this._maxHdcpLevel = null;
        this.abrController = void 0;
        this.bufferController = void 0;
        this.capLevelController = void 0;
        this.latencyController = void 0;
        this.levelController = void 0;
        this.streamController = void 0;
        this.audioStreamController = void 0;
        this.subtititleStreamController = void 0;
        this.audioTrackController = void 0;
        this.subtitleTrackController = void 0;
        this.interstitialsController = void 0;
        this.gapController = void 0;
        this.emeController = void 0;
        this.cmcdController = void 0;
        this._media = null;
        this._url = null;
        this._sessionId = void 0;
        this.triggeringException = void 0;
        this.started = false;
        const logger = this.logger = $99a156a15cd35eb3$var$enableLogs(userConfig.debug || false, 'Hls instance', userConfig.assetPlayerId);
        const config = this.config = $99a156a15cd35eb3$var$mergeConfig($99a156a15cd35eb3$export$1f323ed185d61c3.DefaultConfig, userConfig, logger);
        this.userConfig = userConfig;
        if (config.progressive) $99a156a15cd35eb3$var$enableStreamingMode(config, logger);
        // core controllers and network loaders
        const { abrController: _AbrController, bufferController: _BufferController, capLevelController: _CapLevelController, errorController: _ErrorController, fpsController: _FpsController } = config;
        const errorController = new _ErrorController(this);
        const abrController = this.abrController = new _AbrController(this);
        // FragmentTracker must be defined before StreamController because the order of event handling is important
        const fragmentTracker = new $99a156a15cd35eb3$var$FragmentTracker(this);
        const _InterstitialsController = config.interstitialsController;
        const interstitialsController = _InterstitialsController ? this.interstitialsController = new _InterstitialsController(this, $99a156a15cd35eb3$export$1f323ed185d61c3) : null;
        const bufferController = this.bufferController = new _BufferController(this, fragmentTracker);
        const capLevelController = this.capLevelController = new _CapLevelController(this);
        const fpsController = new _FpsController(this);
        const playListLoader = new $99a156a15cd35eb3$var$PlaylistLoader(this);
        const _ContentSteeringController = config.contentSteeringController;
        // Instantiate ConentSteeringController before LevelController to receive Multivariant Playlist events first
        const contentSteering = _ContentSteeringController ? new _ContentSteeringController(this) : null;
        const levelController = this.levelController = new $99a156a15cd35eb3$var$LevelController(this, contentSteering);
        const id3TrackController = new $99a156a15cd35eb3$var$ID3TrackController(this);
        const keyLoader = new $99a156a15cd35eb3$var$KeyLoader(this.config);
        const streamController = this.streamController = new $99a156a15cd35eb3$var$StreamController(this, fragmentTracker, keyLoader);
        const gapController = this.gapController = new $99a156a15cd35eb3$var$GapController(this, fragmentTracker);
        // Cap level controller uses streamController to flush the buffer
        capLevelController.setStreamController(streamController);
        // fpsController uses streamController to switch when frames are being dropped
        fpsController.setStreamController(streamController);
        const networkControllers = [
            playListLoader,
            levelController,
            streamController
        ];
        if (interstitialsController) networkControllers.splice(1, 0, interstitialsController);
        if (contentSteering) networkControllers.splice(1, 0, contentSteering);
        this.networkControllers = networkControllers;
        const coreComponents = [
            abrController,
            bufferController,
            gapController,
            capLevelController,
            fpsController,
            id3TrackController,
            fragmentTracker
        ];
        this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
        const AudioStreamControllerClass = config.audioStreamController;
        if (AudioStreamControllerClass) networkControllers.push(this.audioStreamController = new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
        // Instantiate subtitleTrackController before SubtitleStreamController to receive level events first
        this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
        const SubtitleStreamControllerClass = config.subtitleStreamController;
        if (SubtitleStreamControllerClass) networkControllers.push(this.subtititleStreamController = new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
        this.createController(config.timelineController, coreComponents);
        keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
        this.cmcdController = this.createController(config.cmcdController, coreComponents);
        this.latencyController = this.createController($99a156a15cd35eb3$var$LatencyController, coreComponents);
        this.coreComponents = coreComponents;
        // Error controller handles errors before and after all other controllers
        // This listener will be invoked after all other controllers error listeners
        networkControllers.push(errorController);
        const onErrorOut = errorController.onErrorOut;
        if (typeof onErrorOut === 'function') this.on($99a156a15cd35eb3$export$ada873a34909da65.ERROR, onErrorOut, errorController);
        // Autostart load handler
        this.on($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADED, playListLoader.onManifestLoaded, playListLoader);
    }
    createController(ControllerClass, components) {
        if (ControllerClass) {
            const controllerInstance = new ControllerClass(this);
            if (components) components.push(controllerInstance);
            return controllerInstance;
        }
        return null;
    }
    // Delegate the EventEmitter through the public API of Hls.js
    on(event, listener, context = this) {
        this._emitter.on(event, listener, context);
    }
    once(event, listener, context = this) {
        this._emitter.once(event, listener, context);
    }
    removeAllListeners(event) {
        this._emitter.removeAllListeners(event);
    }
    off(event, listener, context = this, once) {
        this._emitter.off(event, listener, context, once);
    }
    listeners(event) {
        return this._emitter.listeners(event);
    }
    emit(event, name, eventObject) {
        return this._emitter.emit(event, name, eventObject);
    }
    trigger(event, eventObject) {
        if (this.config.debug) return this.emit(event, event, eventObject);
        else try {
            return this.emit(event, event, eventObject);
        } catch (error) {
            this.logger.error('An internal error happened while handling event ' + event + '. Error message: "' + error.message + '". Here is a stacktrace:', error);
            // Prevent recursion in error event handlers that throw #5497
            if (!this.triggeringException) {
                this.triggeringException = true;
                const fatal = event === $99a156a15cd35eb3$export$ada873a34909da65.ERROR;
                this.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                    type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $99a156a15cd35eb3$export$d053ec805ce391aa.INTERNAL_EXCEPTION,
                    fatal: fatal,
                    event: event,
                    error: error
                });
                this.triggeringException = false;
            }
        }
        return false;
    }
    listenerCount(event) {
        return this._emitter.listenerCount(event);
    }
    /**
   * Dispose of the instance
   */ destroy() {
        this.logger.log('destroy');
        this.trigger($99a156a15cd35eb3$export$ada873a34909da65.DESTROYING, undefined);
        this.detachMedia();
        this.removeAllListeners();
        this._autoLevelCapping = -1;
        this._url = null;
        this.networkControllers.forEach((component)=>component.destroy());
        this.networkControllers.length = 0;
        this.coreComponents.forEach((component)=>component.destroy());
        this.coreComponents.length = 0;
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.xhrSetup = config.fetchSetup = undefined;
        // @ts-ignore
        this.userConfig = null;
    }
    /**
   * Attaches Hls.js to a media element
   */ attachMedia(data) {
        if (!data || 'media' in data && !data.media) {
            const error = new Error(`attachMedia failed: invalid argument (${data})`);
            this.trigger($99a156a15cd35eb3$export$ada873a34909da65.ERROR, {
                type: $99a156a15cd35eb3$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $99a156a15cd35eb3$export$d053ec805ce391aa.ATTACH_MEDIA_ERROR,
                fatal: true,
                error: error
            });
            return;
        }
        this.logger.log(`attachMedia`);
        if (this._media) {
            this.logger.warn(`media must be detached before attaching`);
            this.detachMedia();
        }
        const attachMediaSource = 'media' in data;
        const media = attachMediaSource ? data.media : data;
        const attachingData = attachMediaSource ? data : {
            media: media
        };
        this._media = media;
        this.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_ATTACHING, attachingData);
    }
    /**
   * Detach Hls.js from the media
   */ detachMedia() {
        this.logger.log('detachMedia');
        this.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, {});
        this._media = null;
    }
    /**
   * Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
   */ transferMedia() {
        this._media = null;
        const transferMedia = this.bufferController.transferMedia();
        this.trigger($99a156a15cd35eb3$export$ada873a34909da65.MEDIA_DETACHING, {
            transferMedia: transferMedia
        });
        return transferMedia;
    }
    /**
   * Set the source URL. Can be relative or absolute.
   */ loadSource(url) {
        this.stopLoad();
        const media = this.media;
        const loadedSource = this._url;
        const loadingSource = this._url = $99a156a15cd35eb3$var$urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
            alwaysNormalize: true
        });
        this._autoLevelCapping = -1;
        this._maxHdcpLevel = null;
        this.logger.log(`loadSource:${loadingSource}`);
        if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
            // Remove and re-create MediaSource
            this.detachMedia();
            this.attachMedia(media);
        }
        // when attaching to a source URL, trigger a playlist load
        this.trigger($99a156a15cd35eb3$export$ada873a34909da65.MANIFEST_LOADING, {
            url: url
        });
    }
    /**
   * Gets the currently loaded URL
   */ get url() {
        return this._url;
    }
    /**
   * Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
   */ get hasEnoughToStart() {
        return this.streamController.hasEnoughToStart;
    }
    /**
   * Get the startPosition set on startLoad(position) or on autostart with config.startPosition
   */ get startPosition() {
        return this.streamController.startPositionValue;
    }
    /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */ startLoad(startPosition = -1, skipSeekToStartPosition) {
        this.logger.log(`startLoad(${startPosition + (skipSeekToStartPosition ? ', <skip seek to start>' : '')})`);
        this.started = true;
        this.resumeBuffering();
        for(let i = 0; i < this.networkControllers.length; i++){
            this.networkControllers[i].startLoad(startPosition, skipSeekToStartPosition);
            if (!this.started || !this.networkControllers) break;
        }
    }
    /**
   * Stop loading of any stream data.
   */ stopLoad() {
        this.logger.log('stopLoad');
        this.started = false;
        for(let i = 0; i < this.networkControllers.length; i++){
            this.networkControllers[i].stopLoad();
            if (this.started || !this.networkControllers) break;
        }
    }
    /**
   * Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
   */ get loadingEnabled() {
        return this.started;
    }
    /**
   * Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
   */ get bufferingEnabled() {
        return this.streamController.bufferingEnabled;
    }
    /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */ resumeBuffering() {
        if (!this.bufferingEnabled) {
            this.logger.log(`resume buffering`);
            this.networkControllers.forEach((controller)=>{
                if (controller.resumeBuffering) controller.resumeBuffering();
            });
        }
    }
    /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */ pauseBuffering() {
        if (this.bufferingEnabled) {
            this.logger.log(`pause buffering`);
            this.networkControllers.forEach((controller)=>{
                if (controller.pauseBuffering) controller.pauseBuffering();
            });
        }
    }
    get inFlightFragments() {
        const inFlightData = {
            [$99a156a15cd35eb3$export$e15fb1a9320a1882.MAIN]: this.streamController.inFlightFrag
        };
        if (this.audioStreamController) inFlightData[$99a156a15cd35eb3$export$e15fb1a9320a1882.AUDIO] = this.audioStreamController.inFlightFrag;
        if (this.subtititleStreamController) inFlightData[$99a156a15cd35eb3$export$e15fb1a9320a1882.SUBTITLE] = this.subtititleStreamController.inFlightFrag;
        return inFlightData;
    }
    /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */ swapAudioCodec() {
        this.logger.log('swapAudioCodec');
        this.streamController.swapAudioCodec();
    }
    /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */ recoverMediaError() {
        this.logger.log('recoverMediaError');
        const media = this._media;
        const time1 = media == null ? void 0 : media.currentTime;
        this.detachMedia();
        if (media) {
            this.attachMedia(media);
            if (time1) this.startLoad(time1);
        }
    }
    removeLevel(levelIndex) {
        this.levelController.removeLevel(levelIndex);
    }
    /**
   * @returns a UUID for this player instance
   */ get sessionId() {
        let _sessionId = this._sessionId;
        if (!_sessionId) _sessionId = this._sessionId = $99a156a15cd35eb3$var$uuid();
        return _sessionId;
    }
    /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */ get levels() {
        const levels = this.levelController.levels;
        return levels ? levels : [];
    }
    /**
   * @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
   */ get latestLevelDetails() {
        return this.streamController.getLevelDetails() || null;
    }
    /**
   * @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
   */ get loadLevelObj() {
        return this.levelController.loadLevelObj;
    }
    /**
   * Index of quality level (variant) currently played
   */ get currentLevel() {
        return this.streamController.currentLevel;
    }
    /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */ set currentLevel(newLevel) {
        this.logger.log(`set currentLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.immediateLevelSwitch();
    }
    /**
   * Index of next quality level loaded as scheduled by stream controller.
   */ get nextLevel() {
        return this.streamController.nextLevel;
    }
    /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */ set nextLevel(newLevel) {
        this.logger.log(`set nextLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.nextLevelSwitch();
    }
    /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */ get loadLevel() {
        return this.levelController.level;
    }
    /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */ set loadLevel(newLevel) {
        this.logger.log(`set loadLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
    }
    /**
   * get next quality level loaded
   */ get nextLoadLevel() {
        return this.levelController.nextLoadLevel;
    }
    /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */ set nextLoadLevel(level) {
        this.levelController.nextLoadLevel = level;
    }
    /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */ get firstLevel() {
        return Math.max(this.levelController.firstLevel, this.minAutoLevel);
    }
    /**
   * Sets "first-level", see getter.
   */ set firstLevel(newLevel) {
        this.logger.log(`set firstLevel:${newLevel}`);
        this.levelController.firstLevel = newLevel;
    }
    /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */ get startLevel() {
        const startLevel = this.levelController.startLevel;
        if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) return this.abrController.forcedAutoLevel;
        return startLevel;
    }
    /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */ set startLevel(newLevel) {
        this.logger.log(`set startLevel:${newLevel}`);
        // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
        if (newLevel !== -1) newLevel = Math.max(newLevel, this.minAutoLevel);
        this.levelController.startLevel = newLevel;
    }
    /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */ get capLevelToPlayerSize() {
        return this.config.capLevelToPlayerSize;
    }
    /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */ set capLevelToPlayerSize(shouldStartCapping) {
        const newCapLevelToPlayerSize = !!shouldStartCapping;
        if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
            if (newCapLevelToPlayerSize) this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
            else {
                this.capLevelController.stopCapping();
                this.autoLevelCapping = -1;
                this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
            }
            this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
        }
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ get autoLevelCapping() {
        return this._autoLevelCapping;
    }
    /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */ get bandwidthEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimate();
    }
    set bandwidthEstimate(abrEwmaDefaultEstimate) {
        this.abrController.resetEstimator(abrEwmaDefaultEstimate);
    }
    get abrEwmaDefaultEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.defaultEstimate;
    }
    /**
   * get time to first byte estimate
   * @type {number}
   */ get ttfbEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimateTTFB();
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ set autoLevelCapping(newLevel) {
        if (this._autoLevelCapping !== newLevel) {
            this.logger.log(`set autoLevelCapping:${newLevel}`);
            this._autoLevelCapping = newLevel;
            this.levelController.checkMaxAutoUpdated();
        }
    }
    get maxHdcpLevel() {
        return this._maxHdcpLevel;
    }
    set maxHdcpLevel(value) {
        if ($99a156a15cd35eb3$var$isHdcpLevel(value) && this._maxHdcpLevel !== value) {
            this._maxHdcpLevel = value;
            this.levelController.checkMaxAutoUpdated();
        }
    }
    /**
   * True when automatic level selection enabled
   */ get autoLevelEnabled() {
        return this.levelController.manualLevel === -1;
    }
    /**
   * Level set manually (if any)
   */ get manualLevel() {
        return this.levelController.manualLevel;
    }
    /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */ get minAutoLevel() {
        const { levels: levels, config: { minAutoBitrate: minAutoBitrate } } = this;
        if (!levels) return 0;
        const len = levels.length;
        for(let i = 0; i < len; i++){
            if (levels[i].maxBitrate >= minAutoBitrate) return i;
        }
        return 0;
    }
    /**
   * max level selectable in auto mode according to autoLevelCapping
   */ get maxAutoLevel() {
        const { levels: levels, autoLevelCapping: autoLevelCapping, maxHdcpLevel: maxHdcpLevel } = this;
        let maxAutoLevel;
        if (autoLevelCapping === -1 && levels != null && levels.length) maxAutoLevel = levels.length - 1;
        else maxAutoLevel = autoLevelCapping;
        if (maxHdcpLevel) for(let i = maxAutoLevel; i--;){
            const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
            if (hdcpLevel && hdcpLevel <= maxHdcpLevel) return i;
        }
        return maxAutoLevel;
    }
    get firstAutoLevel() {
        return this.abrController.firstAutoLevel;
    }
    /**
   * next automatically selected quality level
   */ get nextAutoLevel() {
        return this.abrController.nextAutoLevel;
    }
    /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */ set nextAutoLevel(nextLevel) {
        this.abrController.nextAutoLevel = nextLevel;
    }
    /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */ get playingDate() {
        return this.streamController.currentProgramDateTime;
    }
    get mainForwardBufferInfo() {
        return this.streamController.getMainFwdBufferInfo();
    }
    get maxBufferLength() {
        return this.streamController.maxBufferLength;
    }
    /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */ setAudioOption(audioOption) {
        var _this$audioTrackContr;
        return ((_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption)) || null;
    }
    /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */ setSubtitleOption(subtitleOption) {
        var _this$subtitleTrackCo;
        return ((_this$subtitleTrackCo = this.subtitleTrackController) == null ? void 0 : _this$subtitleTrackCo.setSubtitleOption(subtitleOption)) || null;
    }
    /**
   * Get the complete list of audio tracks across all media groups
   */ get allAudioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.allAudioTracks : [];
    }
    /**
   * Get the list of selectable audio tracks
   */ get audioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTracks : [];
    }
    /**
   * index of the selected audio track (index in audio track lists)
   */ get audioTrack() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTrack : -1;
    }
    /**
   * selects an audio track, based on its index in audio track lists
   */ set audioTrack(audioTrackId) {
        const audioTrackController = this.audioTrackController;
        if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
    }
    /**
   * get the complete list of subtitle tracks across all media groups
   */ get allSubtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
    }
    /**
   * get alternate subtitle tracks list from playlist
   */ get subtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
    }
    /**
   * index of the selected subtitle track (index in subtitle track lists)
   */ get subtitleTrack() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
    }
    get media() {
        return this._media;
    }
    /**
   * select an subtitle track, based on its index in subtitle track lists
   */ set subtitleTrack(subtitleTrackId) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
    /**
   * Whether subtitle display is enabled or not
   */ get subtitleDisplay() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
    }
    /**
   * Enable/disable subtitle display rendering
   */ set subtitleDisplay(value) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
    }
    /**
   * get mode for Low-Latency HLS loading
   */ get lowLatencyMode() {
        return this.config.lowLatencyMode;
    }
    /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */ set lowLatencyMode(mode) {
        this.config.lowLatencyMode = mode;
    }
    /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */ get liveSyncPosition() {
        return this.latencyController.liveSyncPosition;
    }
    /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */ get latency() {
        return this.latencyController.latency;
    }
    /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */ get maxLatency() {
        return this.latencyController.maxLatency;
    }
    /**
   * target distance from the edge as calculated by the latency controller
   */ get targetLatency() {
        return this.latencyController.targetLatency;
    }
    set targetLatency(latency) {
        this.latencyController.targetLatency = latency;
    }
    /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */ get drift() {
        return this.latencyController.drift;
    }
    /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */ get forceStartLoad() {
        return this.streamController.forceStartLoad;
    }
    /**
   * ContentSteering pathways getter
   */ get pathways() {
        return this.levelController.pathways;
    }
    /**
   * ContentSteering pathwayPriority getter/setter
   */ get pathwayPriority() {
        return this.levelController.pathwayPriority;
    }
    set pathwayPriority(pathwayPriority) {
        this.levelController.pathwayPriority = pathwayPriority;
    }
    /**
   * returns true when all SourceBuffers are buffered to the end
   */ get bufferedToEnd() {
        var _this$bufferControlle;
        return !!((_this$bufferControlle = this.bufferController) != null && _this$bufferControlle.bufferedToEnd);
    }
    /**
   * returns Interstitials Program Manager
   */ get interstitialsManager() {
        var _this$interstitialsCo;
        return ((_this$interstitialsCo = this.interstitialsController) == null ? void 0 : _this$interstitialsCo.interstitialsManager) || null;
    }
    /**
   * returns mediaCapabilities.decodingInfo for a variant/rendition
   */ getMediaDecodingInfo(level, audioTracks = this.allAudioTracks) {
        const audioTracksByGroup = $99a156a15cd35eb3$var$getAudioTracksByGroup(audioTracks);
        return $99a156a15cd35eb3$var$getMediaDecodingInfoPromise(level, audioTracksByGroup, navigator.mediaCapabilities);
    }
}
$99a156a15cd35eb3$export$1f323ed185d61c3.defaultConfig = void 0;



var $acw62 = parcelRequire("acw62");


const $6159fe6c43206810$var$supabaseAPI = `${"https://xqdwpfytjayobvmxvhwj.supabase.co"}/functions/v1`;
async function $6159fe6c43206810$var$getUserAccessToken() {
    const { data: { session: session } } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.getSession();
    return session?.access_token;
}
const $6159fe6c43206810$var$gridItemStyles = (0, $jjlaj.css)({
    objectFit: 'cover',
    width: '100%',
    boxSizing: 'border-box',
    background: (0, $533ab0667c222708$export$2e2bcd8739ae039)('elevation.surface.raised', '#FFF'),
    padding: (0, $533ab0667c222708$export$2e2bcd8739ae039)('space.050', '4px'),
    borderRadius: (0, $533ab0667c222708$export$2e2bcd8739ae039)('border.radius.100', '4px'),
    boxShadow: (0, $533ab0667c222708$export$2e2bcd8739ae039)('elevation.shadow.raised', 'none'),
    transition: `all ${(0, $d145bd79772829f1$export$38b928a7167ce124).small}ms ${(0, $e9ca40ca2325ac8e$export$c07234257a03d5e9)}`,
    '-webkit-touch-callout': 'none'
});
const $6159fe6c43206810$var$itemStateStyles = {
    idle: (0, $jjlaj.css)({
        ':hover': {
            background: (0, $533ab0667c222708$export$2e2bcd8739ae039)('elevation.surface.overlay', '#FFF'),
            boxShadow: (0, $533ab0667c222708$export$2e2bcd8739ae039)('elevation.shadow.overlay', 'none')
        }
    }),
    dragging: (0, $jjlaj.css)({
        filter: 'grayscale(0.8)'
    }),
    over: (0, $jjlaj.css)({
        transform: 'scale(0.9)',
        filter: 'brightness(1.15)',
        boxShadow: (0, $533ab0667c222708$export$2e2bcd8739ae039)('elevation.shadow.overlay', 'none')
    })
};
const $6159fe6c43206810$var$CameraBox = ({ camera: camera, isValidHttpUrl: isValidHttpUrl, isAdmin: isAdmin })=>{
    const ref = (0, $acw62.useRef)(null);
    const videoRef = (0, $acw62.useRef)(null);
    const [state, setState] = (0, $acw62.useState)('idle');
    const instanceId = (0, $acw62.useContext)((0, $326c34f35d3a59c7$export$1e0e5b7cca87e494));
    const accessTokenRef = (0, $acw62.useRef)(null);
    const extractDeviceSerialFromUrl = (url)=>{
        const match = url.match(/openlive\/([A-Z0-9]+)_/i);
        return match ? match[1] : null;
    };
    const getValidAccessToken = async ()=>{
        const now = Date.now();
        const cachedToken = accessTokenRef.current;
        if (cachedToken) {
            const expiresAt = parseInt(localStorage.getItem('ezviz_token_expire') || '0', 10);
            if (now < expiresAt - 60000) return cachedToken;
        }
        try {
            const response = await fetch(`${$6159fe6c43206810$var$supabaseAPI}/fetchEZVIZAccessToken`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${await $6159fe6c43206810$var$getUserAccessToken()}`
                }
            });
            const result = await response.json();
            if (result.error) {
                console.error('Error fetching EZVIZ token:', result.error);
                return Promise.reject(new Error(result.error));
            }
            accessTokenRef.current = result.accessToken;
            const expireInSeconds = Number(result.expireTime);
            if (!isNaN(expireInSeconds)) {
                const expireAt = Date.now() + expireInSeconds * 1000;
                localStorage.setItem('ezviz_token_expire', expireAt.toString());
            } else console.warn('Invalid expire time received:', result.expireTime);
            return result.accessToken;
        } catch (error) {
            console.error('Failed to fetch EZVIZ token:', error);
            throw error;
        }
    };
    (0, $acw62.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        return (0, $d453ec773833617e$export$1be1fc439b849fdf)((0, $6ba4b1aafdc6c74e$export$c746a5152d4ba26c)({
            element: el,
            getInitialData: ()=>({
                    type: 'grid-item',
                    id: camera.id,
                    instanceId: instanceId
                }),
            onDragStart: ()=>setState('dragging'),
            onDrop: ()=>setState('idle')
        }), (0, $6ba4b1aafdc6c74e$export$e7140b68045b5036)({
            element: el,
            getData: ()=>({
                    id: camera.id
                }),
            getIsSticky: ()=>false,
            canDrop: ({ source: source })=>source.data.instanceId === instanceId && source.data.type === 'grid-item' && source.data.id !== camera.id,
            onDragEnter: ()=>setState('over'),
            onDragLeave: ()=>setState('idle'),
            onDrop: ()=>setState('idle')
        }));
    }, [
        camera.id,
        instanceId
    ]);
    // hls.js setup / teardown
    (0, $acw62.useEffect)(()=>{
        const video = videoRef.current;
        if (!video || !isValidHttpUrl(camera.stream_url)) return;
        const setLiveEdge = (hlsInstance)=>{
            const livePos = hlsInstance?.liveSyncPosition;
            if (typeof livePos === 'number' && isFinite(livePos)) video.currentTime = livePos;
            else if (typeof video.duration === 'number' && isFinite(video.duration)) video.currentTime = video.duration;
        };
        if ((0, $99a156a15cd35eb3$export$1f323ed185d61c3).isSupported()) {
            const hls = new (0, $99a156a15cd35eb3$export$1f323ed185d61c3)({
                liveSyncDurationCount: 1,
                liveMaxLatencyDurationCount: 3,
                lowLatencyMode: true,
                maxBufferLength: 5,
                liveDurationInfinity: true
            });
            hls.loadSource(camera.stream_url);
            hls.attachMedia(video);
            hls.on((0, $99a156a15cd35eb3$export$1f323ed185d61c3).Events.MANIFEST_PARSED, ()=>{
                console.log(`Manifest parsed for ${camera.name}`);
                hls.startLoad();
                video.play().catch((err)=>{
                    console.error(`Play error for ${camera.name}:`, err);
                });
            });
            hls.on((0, $99a156a15cd35eb3$export$1f323ed185d61c3).Events.ERROR, (event, data)=>{
                console.error(`HLS error for ${camera.name}: ${data.type} - ${data.details}`, data);
            });
            hls.on((0, $99a156a15cd35eb3$export$1f323ed185d61c3).Events.LEVEL_UPDATED, ()=>{
                setLiveEdge(hls);
            });
            return ()=>{
                hls.destroy();
            };
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = camera.stream_url;
            video.addEventListener('loadedmetadata', setLiveEdge);
            video.addEventListener('error', ()=>{
                console.error(`Video error for ${camera.name}`);
            });
            return ()=>{
                video.removeEventListener('loadedmetadata', setLiveEdge);
                video.removeEventListener('error', ()=>{});
            };
        } else console.error(`HLS is not supported for ${camera.name}`);
    }, [
        camera.stream_url,
        camera.name,
        isValidHttpUrl
    ]);
    const startPTZControl = async (direction, speed = 1)=>{
        const deviceSerial = extractDeviceSerialFromUrl(camera.stream_url);
        if (!deviceSerial) return console.error('Invalid stream URL');
        try {
            const accessToken = await getValidAccessToken();
            const params = new URLSearchParams({
                accessToken: accessToken,
                deviceSerial: deviceSerial,
                channelNo: '1',
                direction: direction.toString(),
                speed: speed.toString()
            });
            const response = await fetch(`https://open.ezvizlife.com/api/lapp/device/ptz/start?${params}`, {
                method: 'POST'
            });
            const data = await response.json();
            console.log('PTZ Start:', data);
        } catch (error) {
            console.error('PTZ start error:', error);
        }
    };
    const stopPTZControl = async (direction)=>{
        const deviceSerial = extractDeviceSerialFromUrl(camera.stream_url);
        if (!deviceSerial) return console.error('Invalid stream URL');
        try {
            const accessToken = await getValidAccessToken();
            const params = new URLSearchParams({
                accessToken: accessToken,
                deviceSerial: deviceSerial,
                channelNo: '1',
                direction: direction.toString()
            });
            const response = await fetch(`https://open.ezvizlife.com/api/lapp/device/ptz/stop?${params}`, {
                method: 'POST'
            });
            const data = await response.json();
            console.log('PTZ Stop:', data);
        } catch (error) {
            console.error('PTZ stop error:', error);
        }
    };
    return /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$25062201e9e25d76)("div", {
        // component={"div"}
        ref: ref,
        "data-id": camera.id,
        // eslint-disable-next-line react/no-unknown-property
        css: [
            $6159fe6c43206810$var$gridItemStyles,
            $6159fe6c43206810$var$itemStateStyles[state]
        ],
        style: {
            backgroundColor: 'grey.200',
            border: '1px solid black',
            borderRadius: 1,
            width: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0px 1px 3px rgba(0,0,0,0.2)'
        },
        children: [
            /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                sx: {
                    flex: '0 0 auto',
                    fontWeight: 'bold',
                    p: 1
                },
                children: camera.name
            }),
            /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    flex: 1,
                    position: 'relative',
                    justifyContent: 'center',
                    justifyItems: 'center',
                    display: 'flex'
                },
                children: isValidHttpUrl(camera.stream_url) ? /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)("video", {
                    ref: videoRef,
                    title: camera.name,
                    muted: true,
                    autoPlay: true,
                    playsInline: true,
                    // controls
                    style: {
                        maxWidth: '100%',
                        maxHeight: '100%',
                        border: 'none',
                        borderRadius: 4,
                        objectFit: 'contain'
                    }
                }) : /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'grey.300',
                        borderRadius: 4
                    },
                    children: /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "subtitle1",
                        color: "text.secondary",
                        children: "No data available"
                    })
                })
            }),
            camera.stream_url.includes("ezvizlife.com") && isAdmin && /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$25062201e9e25d76)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    p: 1,
                    gap: 1,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        onMouseDown: ()=>startPTZControl(0),
                        onMouseUp: ()=>stopPTZControl(0),
                        onTouchStart: ()=>startPTZControl(0),
                        onTouchEnd: ()=>stopPTZControl(0),
                        sx: {
                            transition: 'all 0.2s',
                            '&:hover': {
                                backgroundColor: 'primary.main',
                                color: 'white',
                                borderColor: 'primary.main'
                            }
                        },
                        children: "Up"
                    }),
                    /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        onMouseDown: ()=>startPTZControl(1),
                        onMouseUp: ()=>stopPTZControl(1),
                        onTouchStart: ()=>startPTZControl(1),
                        onTouchEnd: ()=>stopPTZControl(1),
                        sx: {
                            transition: 'all 0.2s',
                            '&:hover': {
                                backgroundColor: 'primary.main',
                                color: 'white',
                                borderColor: 'primary.main'
                            }
                        },
                        children: "Down"
                    }),
                    /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        onMouseDown: ()=>startPTZControl(2),
                        onMouseUp: ()=>stopPTZControl(2),
                        onTouchStart: ()=>startPTZControl(2),
                        onTouchEnd: ()=>stopPTZControl(2),
                        sx: {
                            transition: 'all 0.2s',
                            '&:hover': {
                                backgroundColor: 'primary.main',
                                color: 'white',
                                borderColor: 'primary.main'
                            }
                        },
                        children: "Left"
                    }),
                    /*#__PURE__*/ (0, $67eb8f8e9d5e3981$export$34b9dba7ce09269b)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        size: "small",
                        onMouseDown: ()=>startPTZControl(3),
                        onMouseUp: ()=>stopPTZControl(3),
                        onTouchStart: ()=>startPTZControl(3),
                        onTouchEnd: ()=>stopPTZControl(3),
                        sx: {
                            transition: 'all 0.2s',
                            '&:hover': {
                                backgroundColor: 'primary.main',
                                color: 'white',
                                borderColor: 'primary.main'
                            }
                        },
                        children: "Right"
                    })
                ]
            })
        ]
    });
};
var $6159fe6c43206810$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($6159fe6c43206810$var$CameraBox);



// Helper function: Returns true if the URL is non-empty and starts with http(s) or rtmp
function $326c34f35d3a59c7$var$isValidHttpUrl(urlString) {
    if (!urlString || urlString.trim() === '') return false;
    try {
        const url = new URL(urlString);
        return [
            'http:',
            'https:',
            'rtmp:'
        ].includes(url.protocol);
    } catch (error) {
        return false;
    }
}
// Pragmatic DND
function $326c34f35d3a59c7$var$getInstanceId() {
    return Symbol('instance-id');
}
const $326c34f35d3a59c7$export$1e0e5b7cca87e494 = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $326c34f35d3a59c7$export$2e2bcd8739ae039({ userId: userId, isAdmin: isAdmin }) {
    const [cameras, setCameras] = (0, $acw62.useState)([]);
    const [allCameras, setAllCameras] = (0, $acw62.useState)([]);
    const [selectedCameraIds, setSelectedCameraIds] = (0, $acw62.useState)([]);
    const [layout, setLayout] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [columns, setColumns] = (0, $acw62.useState)(4); // Default to 4 columns
    const [availableWidth, setAvailableWidth] = (0, $acw62.useState)(window.innerWidth > 840 ? window.innerWidth - 240 : window.innerWidth);
    // Pragmatic DND
    const [instanceId] = (0, $acw62.useState)($326c34f35d3a59c7$var$getInstanceId);
    (0, $acw62.useEffect)(()=>{
        return (0, $6ba4b1aafdc6c74e$export$59a074bac4c54f54)({
            canMonitor ({ source: source }) {
                return source.data.instanceId === instanceId;
            },
            onDrop ({ source: source, location: location }) {
                const dest = location.current.dropTargets[0];
                if (!dest) return;
                const fromId = source.data.id;
                const toId = dest.data.id;
                if (fromId === toId) return;
                // swap positions
                setCameras((prev)=>{
                    const next = [
                        ...prev
                    ];
                    const i = next.findIndex((c)=>c.id === fromId);
                    const j = next.findIndex((c)=>c.id === toId);
                    [next[i], next[j]] = [
                        next[j],
                        next[i]
                    ];
                    const newLayout = next.map((c)=>c.id);
                    setLayout(newLayout);
                    saveLayout(newLayout, columns);
                    return next;
                });
            }
        });
    }, [
        instanceId
    ]);
    // calculate dynamic width
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>{
            setAvailableWidth(window.innerWidth > 840 ? window.innerWidth - 240 : window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        // Cleanup the event listener on component unmount
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    // END: Pragmatic DND
    // Fetch cameras
    const fetchCameras = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        setError(null);
        console.log('fetchCameras: isAdmin=', isAdmin, 'userId=', userId);
        try {
            if (isAdmin) {
                const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('cameras').select('*');
                if (error) {
                    console.error('Error fetching all cameras:', error);
                    setError('Failed to fetch cameras: ' + error.message);
                    setAllCameras([]);
                    setCameras([]);
                    setIsLoading(false);
                    return;
                }
                // sort camera list
                const sortedCameras = (0, $28770b279d7ab5b1$export$7932064324870761)(data);
                console.log('All cameras fetched:', sortedCameras);
                setAllCameras(sortedCameras);
                const { data: userData, error: userError } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users').select('selected_cameras, columns').eq('id', userId).single();
                if (userError) {
                    console.error('Error fetching user data:', userError);
                    setError('Failed to fetch user data: ' + userError.message);
                    setCameras([]);
                    setSelectedCameraIds([]);
                    setIsLoading(false);
                    return;
                }
                const selectedIds = Array.isArray(userData?.selected_cameras) ? userData.selected_cameras : [];
                console.log('Selected camera IDs:', selectedIds);
                setSelectedCameraIds(selectedIds);
                setCameras(sortedCameras.filter((camera)=>selectedIds.includes(camera.id)));
                setColumns(userData?.columns || 4);
            } else {
                // customers
                const { data: userData, error: userError } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users_cameras').select(`cameras (
                        id,
                        name,
                        stream_url)
                        `).eq('user_id', userId);
                if (userError) {
                    console.error('Error fetching user data:', userError);
                    setError('Failed to fetch user data: ' + userError.message);
                    setCameras([]);
                    setIsLoading(false);
                    return;
                }
                const data = userData.flatMap((row)=>row.cameras ?? []);
                if (data.length > 0) {
                    console.log('Customer camera fetched:', data);
                    setCameras(data);
                } else {
                    console.log('No camera assigned for customer');
                    setCameras([]);
                }
            }
        } catch (err) {
            console.error('Unexpected error in fetchCameras:', err);
            setError('Unexpected error occurred');
        }
        setIsLoading(false);
    }, [
        userId,
        isAdmin
    ]);
    // Fetch layout
    const fetchLayout = (0, $acw62.useCallback)(async ()=>{
        try {
            const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users').select('layout').eq('id', userId).single();
            if (error) {
                console.error('Error fetching layout:', error);
                setError('Failed to fetch layout: ' + error.message);
                return;
            }
            if (data?.layout) {
                console.log('Layout fetched:', data.layout);
                setLayout(data.layout);
            }
        } catch (err) {
            console.error('Unexpected error in fetchLayout:', err);
            setError('Unexpected error occurred');
        }
    }, [
        userId
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchCameras();
        fetchLayout();
    }, [
        fetchCameras,
        fetchLayout
    ]);
    // Generate initial layout
    (0, $acw62.useEffect)(()=>{
        if (cameras.length > 0 && (layout.length === 0 || layout.length !== cameras.length)) {
            setLayout(layout);
            saveLayout(layout, columns);
        }
    }, [
        cameras,
        columns,
        layout.length
    ]);
    // Save layout and columns
    const saveLayout = (0, $acw62.useCallback)(async (newLayout, columnsToSave)=>{
        const updates = {
            layout: newLayout
        };
        if (isAdmin) {
            updates.selected_cameras = newLayout;
            updates.columns = columnsToSave;
        }
        console.log('Saving layout, columns, and selected cameras:', updates);
        try {
            const { error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users').update(updates).eq('id', userId);
            if (error) {
                console.error('Error saving layout:', error);
                setError('Failed to save layout: ' + error.message);
            }
        } catch (err) {
            console.error('Unexpected error in saveLayout:', err);
            setError('Unexpected error occurred');
        }
    }, [
        userId,
        isAdmin,
        cameras
    ]);
    function generateLayout(selectedCameraIds, prevLayout) {
        // 1. keep the ones still selected, in their old order
        const kept = prevLayout.filter((id)=>selectedCameraIds.includes(id));
        // 2. find newly added IDs
        const added = selectedCameraIds.filter((id)=>!kept.includes(id));
        // 3. merge
        return [
            ...kept,
            ...added
        ];
    }
    // Handle camera selection
    const handleCameraSelection = async (event)=>{
        const selectedIds = Array.isArray(event.target.value) ? event.target.value : [];
        console.log('Camera selection changed:', selectedIds);
        setSelectedCameraIds(selectedIds);
        const newCameras = allCameras.filter((camera)=>selectedIds.includes(camera.id));
        setCameras(newCameras);
        // Generate new layout for all cameras
        const newLayout = generateLayout(selectedIds, layout);
        setLayout(newLayout);
        saveLayout(newLayout, columns);
    };
    // Handle column selection
    const handleColumnSelection = async (event)=>{
        const newColumns = Number(event.target.value);
        setColumns(newColumns);
        console.log('Columns changed to:', newColumns);
        setLayout(layout);
        saveLayout(layout, newColumns);
    };
    const camerasToShow = isAdmin ? layout.map((id)=>allCameras.find((c)=>c.id === id)).filter((c)=>!!c) : cameras;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            bgcolor: 'background.default',
            overflow: 'auto'
        },
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    position: 'fixed',
                    top: '80px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    color: 'red',
                    bgcolor: 'white',
                    p: 1,
                    borderRadius: 1,
                    zIndex: 5000
                },
                children: error
            }),
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1000
                },
                children: "Loading cameras..."
            }),
            !isLoading && cameras.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1000
                },
                children: "No cameras assigned."
            }),
            isAdmin && !isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    gap: 2,
                    position: 'fixed',
                    top: 80,
                    right: 16,
                    zIndex: 6000
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: 250,
                            bgcolor: 'white',
                            borderRadius: 1,
                            boxShadow: 3,
                            p: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                                id: "camera-select-label",
                                children: "Select Cameras"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                labelId: "camera-select-label",
                                multiple: true,
                                value: selectedCameraIds,
                                onChange: handleCameraSelection,
                                label: "Select Cameras",
                                renderValue: (selected)=>selected.map((id)=>allCameras.find((c)=>c.id === id)?.name || '').join(', '),
                                sx: {
                                    bgcolor: 'white',
                                    minWidth: 200
                                },
                                children: allCameras.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                    disabled: true,
                                    children: "No cameras available"
                                }) : allCameras.map((camera)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                        value: camera.id,
                                        children: camera.name
                                    }, camera.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                        sx: {
                            minWidth: 120,
                            bgcolor: 'white',
                            borderRadius: 1,
                            boxShadow: 3,
                            p: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                                id: "columns-select-label",
                                children: "Columns"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                labelId: "columns-select-label",
                                value: columns,
                                onChange: handleColumnSelection,
                                label: "Columns",
                                sx: {
                                    bgcolor: 'white'
                                },
                                children: [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10
                                ].map((num)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                        value: num,
                                        children: num
                                    }, num))
                            })
                        ]
                    })
                ]
            }),
            !isLoading && cameras.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($326c34f35d3a59c7$export$1e0e5b7cca87e494.Provider, {
                value: instanceId,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'grid',
                        gridTemplateColumns: `repeat(${isAdmin ? columns : 1}, 1fr)`,
                        width: availableWidth,
                        maxHeight: `calc(100vh - ${156}px)`,
                        marginLeft: window.innerWidth > 840 ? '240px' : 0,
                        marginTop: '156px'
                    },
                    children: camerasToShow.map((camera)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6159fe6c43206810$export$2e2bcd8739ae039), {
                            camera: camera,
                            isValidHttpUrl: $326c34f35d3a59c7$var$isValidHttpUrl,
                            isAdmin: isAdmin
                        }, camera.id);
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0311b3215a1d8d4a$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12m0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17"
    }, "1")
], 'AdminPanelSettings');


var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2e0d0dae486f6346$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "3.2"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5"
    }, "1")
], 'CameraAlt');


var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f5914ec65526728e$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), 'ExitToApp');


var $hGPki = parcelRequire("hGPki");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b365cde8773d1e3d$export$2e2bcd8739ae039 = (0, $hGPki.createSvgIcon)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8z"
}), 'Login');


var $794d5dbdb05a5402$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $794d5dbdb05a5402$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($794d5dbdb05a5402$exports, "__esModule", {
    value: true
});
$794d5dbdb05a5402$exports.default = void 0;

var $794d5dbdb05a5402$var$_createSvgIcon = $794d5dbdb05a5402$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $794d5dbdb05a5402$var$_default = $794d5dbdb05a5402$exports.default = (0, $794d5dbdb05a5402$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");







var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $ecc4a2c716d1152c$export$47a2da616e55e8e9(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiAppBar', slot);
}
const $ecc4a2c716d1152c$var$appBarClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $ecc4a2c716d1152c$export$2e2bcd8739ae039 = $ecc4a2c716d1152c$var$appBarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $75f50dd5200dc7fd$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(position)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $ecc4a2c716d1152c$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $75f50dd5200dc7fd$var$joinVars = (var1, var2)=>var1 ? `${var1?.replace(')', '')}, ${var2})` : var2;
const $75f50dd5200dc7fd$var$AppBarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.position)}`],
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $75f50dd5200dc7fd$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $75f50dd5200dc7fd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($75f50dd5200dc7fd$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $9QePP.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $75f50dd5200dc7fd$export$2e2bcd8739ae039 = $75f50dd5200dc7fd$var$AppBar;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c2e2000df495a70f$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $0fc9796113f6362d$export$46f01d01378ec5a2), classes);
};
const $c2e2000df495a70f$var$DividerRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $h61zw.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $c2e2000df495a70f$var$DividerWrapper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $c2e2000df495a70f$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $c2e2000df495a70f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c2e2000df495a70f$var$DividerRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($c2e2000df495a70f$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($c2e2000df495a70f$var$Divider) $c2e2000df495a70f$var$Divider.muiSkipListHighlight = true;
var $c2e2000df495a70f$export$2e2bcd8739ae039 = $c2e2000df495a70f$var$Divider;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $3Hg1x = parcelRequire("3Hg1x");

var $9uEev = parcelRequire("9uEev");


var $acw62 = parcelRequire("acw62");












var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $a15b5db10b6f7d3d$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a15b5db10b6f7d3d$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a15b5db10b6f7d3d$var$resolveContainer(containerProp);
    const transform = $a15b5db10b6f7d3d$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a15b5db10b6f7d3d$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($1e42b4067cc53dea$exports)))(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $a15b5db10b6f7d3d$export$2e2bcd8739ae039 = $a15b5db10b6f7d3d$var$Slide;









var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $546564c0c42a58ae$export$b801318a856c9cd2(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiDrawer', slot);
}
const $546564c0c42a58ae$var$drawerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $546564c0c42a58ae$export$2e2bcd8739ae039 = $546564c0c42a58ae$var$drawerClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3c5e6c7e7e283ee4$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $3c5e6c7e7e283ee4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchor)}`
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $546564c0c42a58ae$export$b801318a856c9cd2), classes);
};
const $3c5e6c7e7e283ee4$var$DrawerRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $3c5e6c7e7e283ee4$var$overridesResolver
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $3c5e6c7e7e283ee4$var$DrawerDockedRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $3c5e6c7e7e283ee4$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $3c5e6c7e7e283ee4$var$DrawerPaper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchor)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $3c5e6c7e7e283ee4$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $3c5e6c7e7e283ee4$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $3c5e6c7e7e283ee4$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $3c5e6c7e7e283ee4$export$2a62b49acb270576(anchor) ? $3c5e6c7e7e283ee4$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $3c5e6c7e7e283ee4$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = (0, $9uEev.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $3c5e6c7e7e283ee4$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $3c5e6c7e7e283ee4$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $b748e9827e4898eb$export$2e2bcd8739ae039)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $3c5e6c7e7e283ee4$var$DrawerRoot,
        className: (0, $9QePP.default)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        elementType: $3c5e6c7e7e283ee4$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $9QePP.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('docked', {
        elementType: $3c5e6c7e7e283ee4$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $a15b5db10b6f7d3d$export$2e2bcd8739ae039),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $3c5e6c7e7e283ee4$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var $3c5e6c7e7e283ee4$export$2e2bcd8739ae039 = $3c5e6c7e7e283ee4$var$Drawer;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");










var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $f57d788b3d4818ce$export$5682c366c0c669d9(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiListItem', slot);
}
const $f57d788b3d4818ce$var$listItemClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $f57d788b3d4818ce$export$2e2bcd8739ae039 = $f57d788b3d4818ce$var$listItemClasses;



var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $9ec0b6032559d604$export$c09531d8563c67a5(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiListItemButton', slot);
}
const $9ec0b6032559d604$var$listItemButtonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $9ec0b6032559d604$export$2e2bcd8739ae039 = $9ec0b6032559d604$var$listItemButtonClasses;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");




var $5nY49 = parcelRequire("5nY49");

var $b14cZ = parcelRequire("b14cZ");
function $6e4beb15e8922c23$export$ccdb26aeba48a86e(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b14cZ)))('MuiListItemSecondaryAction', slot);
}
const $6e4beb15e8922c23$var$listItemSecondaryActionClasses = (0, (/*@__PURE__*/$parcel$interopDefault($5nY49)))('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $6e4beb15e8922c23$export$2e2bcd8739ae039 = $6e4beb15e8922c23$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $220479a88558a65e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $6e4beb15e8922c23$export$ccdb26aeba48a86e), classes);
};
const $220479a88558a65e$var$ListItemSecondaryActionRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $220479a88558a65e$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $220479a88558a65e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($220479a88558a65e$var$ListItemSecondaryActionRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$220479a88558a65e$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $220479a88558a65e$export$2e2bcd8739ae039 = $220479a88558a65e$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c1d275280a204574$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $c1d275280a204574$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $f57d788b3d4818ce$export$5682c366c0c669d9), classes);
};
const $c1d275280a204574$export$aed538f7519abe89 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $c1d275280a204574$export$4334bb34c76fef24
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $c1d275280a204574$var$ListItemContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $c1d275280a204574$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $a313fb4a2074834f$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $c1d275280a204574$var$useUtilityClasses(ownerState);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $c1d275280a204574$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($c1d275280a204574$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $31c91637cf4b438e$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $31c91637cf4b438e$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $220479a88558a65e$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $c1d275280a204574$export$2e2bcd8739ae039 = $c1d275280a204574$var$ListItem;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");

var $h61zw = parcelRequire("h61zw");










var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $05fc2614afb1a620$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $05fc2614afb1a620$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $9ec0b6032559d604$export$c09531d8563c67a5), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $05fc2614afb1a620$var$ListItemButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $05fc2614afb1a620$export$4334bb34c76fef24
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $h61zw.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            }
        ]
    })));
const $05fc2614afb1a620$var$ListItemButton = /*#__PURE__*/ $acw62.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    };
    const classes = $05fc2614afb1a620$var$useUtilityClasses(ownerState);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($05fc2614afb1a620$var$ListItemButtonRoot, {
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            classes: classes,
            children: children
        })
    });
});
var $05fc2614afb1a620$export$2e2bcd8739ae039 = $05fc2614afb1a620$var$ListItemButton;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab586b5c8bd0ab7a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $863c8b42c24a5d20$export$81478e24460c57f2), classes);
};
const $ab586b5c8bd0ab7a$var$ListItemIconRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $ab586b5c8bd0ab7a$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $ab586b5c8bd0ab7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab586b5c8bd0ab7a$var$ListItemIconRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $ab586b5c8bd0ab7a$export$2e2bcd8739ae039 = $ab586b5c8bd0ab7a$var$ListItemIcon;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3Hg1x = parcelRequire("3Hg1x");







var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a7cd8ac1360c47a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3Hg1x)))(slots, (0, $8ffc2f5b8ea69aff$export$1061006a0db3aeb5), classes);
};
const $a7cd8ac1360c47a2$var$ListItemTextRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $6e9163c6dd169139$export$2e2bcd8739ae039).root}:where(& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $6e9163c6dd169139$export$2e2bcd8739ae039).root}:where(& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $a7cd8ac1360c47a2$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $a7cd8ac1360c47a2$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $a7cd8ac1360c47a2$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $a7cd8ac1360c47a2$export$2e2bcd8739ae039 = $a7cd8ac1360c47a2$var$ListItemText;



var $0d3d65c0582fd03d$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0d3d65c0582fd03d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0d3d65c0582fd03d$exports, "__esModule", {
    value: true
});
$0d3d65c0582fd03d$exports.default = void 0;
var $60639c4e52e8e25a$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $60639c4e52e8e25a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty($60639c4e52e8e25a$exports, "__esModule", {
    value: true
});
var $60639c4e52e8e25a$var$_exportNames = {};
Object.defineProperty($60639c4e52e8e25a$exports, "default", {
    enumerable: true,
    get: function() {
        return $60639c4e52e8e25a$var$_useMediaQuery.default;
    }
});

var $60639c4e52e8e25a$var$_useMediaQuery = $60639c4e52e8e25a$require$_interopRequireWildcard((parcelRequire("78KYM")));
Object.keys($60639c4e52e8e25a$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($60639c4e52e8e25a$var$_exportNames, key)) return;
    if (key in $60639c4e52e8e25a$exports && $60639c4e52e8e25a$exports[key] === $60639c4e52e8e25a$var$_useMediaQuery[key]) return;
    Object.defineProperty($60639c4e52e8e25a$exports, key, {
        enumerable: true,
        get: function() {
            return $60639c4e52e8e25a$var$_useMediaQuery[key];
        }
    });
});



var $0d3d65c0582fd03d$var$_identifier = $0d3d65c0582fd03d$require$_interopRequireDefault((parcelRequire("4jPsi")));
const $0d3d65c0582fd03d$var$useMediaQuery = (0, $60639c4e52e8e25a$exports.unstable_createUseMediaQuery)({
    themeId: $0d3d65c0582fd03d$var$_identifier.default
});
var $0d3d65c0582fd03d$var$_default = $0d3d65c0582fd03d$exports.default = $0d3d65c0582fd03d$var$useMediaQuery;




const $e1728930272c3f7b$var$DRAWER_WIDTH = 240;
function $e1728930272c3f7b$export$2e2bcd8739ae039({ isAdmin: isAdmin, session: session, children: children }) {
    const theme = (0, $019ad789c5f8c324$exports.useTheme)();
    const isMobile = (0, (/*@__PURE__*/$parcel$interopDefault($0d3d65c0582fd03d$exports)))(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const handleDrawerToggle = ()=>{
        setMobileOpen(!mobileOpen);
    };
    const handleNavigation = (path)=>{
        navigate(path);
        // Close drawer on mobile after a navigation
        if (isMobile) setMobileOpen(false);
    };
    // Compute the page title based on the current location.
    let pageTitle = 'Dashboard';
    switch(location.pathname){
        case '/camera':
            pageTitle = 'Camera';
            break;
        case '/admin':
            pageTitle = 'Admin Panel';
            break;
        case '/login':
            pageTitle = 'Login';
            break;
        default:
            pageTitle = 'Dashboard';
            break;
    }
    // Logout handler that calls supabase.auth.signOut()
    const handleLogout = async ()=>{
        const { error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.signOut({
            scope: 'local'
        });
        if (error) console.error('Error signing out:', error);
        else // Optionally clear any local session state here
        navigate('/login');
    };
    const drawerContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h6",
                    noWrap: true,
                    children: "Petscast"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                children: session ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $05fc2614afb1a620$export$2e2bcd8739ae039), {
                                selected: location.pathname === '/camera',
                                onClick: ()=>handleNavigation('/camera'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e0d0dae486f6346$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                                        primary: "Camera"
                                    })
                                ]
                            })
                        }),
                        isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $05fc2614afb1a620$export$2e2bcd8739ae039), {
                                selected: location.pathname === '/admin',
                                onClick: ()=>handleNavigation('/admin'),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0311b3215a1d8d4a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                                        primary: "Admin Panel"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $05fc2614afb1a620$export$2e2bcd8739ae039), {
                                onClick: handleLogout,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5914ec65526728e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                                        primary: "Logout"
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                    button: true,
                    selected: location.pathname === '/login',
                    onClick: ()=>handleNavigation('/login'),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b365cde8773d1e3d$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                            primary: "Login"
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $888b8a9d3c5d3650$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75f50dd5200dc7fd$export$2e2bcd8739ae039), {
                position: "fixed",
                sx: {
                    ml: {
                        md: `${$e1728930272c3f7b$var$DRAWER_WIDTH}px`
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {
                    children: [
                        isMobile && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                            color: "inherit",
                            "aria-label": "open drawer",
                            edge: "start",
                            onClick: handleDrawerToggle,
                            sx: {
                                mr: 2,
                                display: {
                                    md: 'none'
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($794d5dbdb05a5402$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h6",
                            noWrap: true,
                            component: "div",
                            children: pageTitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                component: "nav",
                sx: {
                    width: {
                        md: $e1728930272c3f7b$var$DRAWER_WIDTH
                    },
                    flexShrink: {
                        md: 0
                    }
                },
                "aria-label": "navigation drawer",
                children: isMobile ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c5e6c7e7e283ee4$export$2e2bcd8739ae039), {
                    variant: "temporary",
                    open: mobileOpen,
                    onClose: handleDrawerToggle,
                    ModalProps: {
                        keepMounted: true
                    },
                    sx: {
                        display: {
                            xs: 'block',
                            md: 'none'
                        },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: $e1728930272c3f7b$var$DRAWER_WIDTH
                        }
                    },
                    children: drawerContent
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c5e6c7e7e283ee4$export$2e2bcd8739ae039), {
                    variant: "permanent",
                    sx: {
                        display: {
                            xs: 'none',
                            md: 'block'
                        },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            width: $e1728930272c3f7b$var$DRAWER_WIDTH
                        }
                    },
                    open: true,
                    children: drawerContent
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                component: "main",
                sx: {
                    flexGrow: 1,
                    p: 3,
                    width: {
                        md: `calc(100% - ${$e1728930272c3f7b$var$DRAWER_WIDTH}px)`
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {}),
                    " ",
                    children
                ]
            })
        ]
    });
}



var $11df18e2f038bad8$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $11df18e2f038bad8$exports = factory();
})($11df18e2f038bad8$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


function $cd93687958c8007e$export$2e2bcd8739ae039() {
    const [session, setSession] = (0, $acw62.useState)(null);
    const [isAdmin, setIsAdmin] = (0, $acw62.useState)(false);
    const [brand, setBrand] = (0, $acw62.useState)(null);
    // falls back to some default until loaded
    const brandColor = brand?.color ?? '#0994b1';
    // Compute contrast text color based on your brand color for legibility.
    const primaryContrastText = (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(brandColor).isLight() ? '#000000' : '#ffffff';
    // Using tinycolor2 to generate related colors for the theme.
    const theme = (0, $019ad789c5f8c324$exports.createTheme)({
        palette: {
            primary: {
                main: brandColor,
                contrastText: primaryContrastText
            },
            background: {
            },
            text: {
                primary: (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(brandColor).darken(10).toString(),
                secondary: (0, (/*@__PURE__*/$parcel$interopDefault($11df18e2f038bad8$exports)))(brandColor).darken(10).toString()
            }
        },
        components: {
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: brandColor,
                        color: primaryContrastText
                    }
                }
            },
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        color: 'inherit'
                    }
                }
            }
        }
    });
    (0, $acw62.useEffect)(()=>{
        (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.getSession().then(({ data: { session: session } })=>{
            setSession(session);
            if (session) checkUserRole(session.user.id);
        });
        (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.onAuthStateChange((_event, session)=>{
            setSession(session);
            if (session) checkUserRole(session.user.id);
            else setIsAdmin(false);
        });
        const fetchBrand = async ()=>{
            const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('brand').select('id,color').single();
            if (error) console.error('fetchBrand error', error);
            else setBrand(data);
        };
        fetchBrand();
    }, []);
    async function checkUserRole(userId) {
        const { data: data, error: error } = await (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).from('users').select('role').eq('id', userId).single();
        if (data && !error) setIsAdmin(data.role === 'admin');
    }
    (0, $acw62.useEffect)(()=>{
        if (!session) return;
        const channel = (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).channel('public:users').on('postgres_changes', {
            event: 'DELETE',
            schema: 'public',
            table: 'users',
            filter: `id=eq.${session.user.id}`
        }, (payload)=>{
            console.log('User record deleted. Forcing logout:', payload);
            (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).auth.signOut();
        }).subscribe();
        return ()=>{
            // Clean up by removing the channel subscription on unmount or session change
            (0, $6a5394f247e70ce7$export$a0b632a28672d3c0).removeChannel(channel);
        };
    }, [
        session
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $019ad789c5f8c324$exports.ThemeProvider), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $888b8a9d3c5d3650$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                children: session ? // Wrap authenticated routes with the responsive drawer
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1728930272c3f7b$export$2e2bcd8739ae039), {
                    isAdmin: isAdmin,
                    session: session,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/admin",
                                element: isAdmin ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e4133e18ff83f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/login"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/camera",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $326c34f35d3a59c7$export$2e2bcd8739ae039), {
                                    userId: session.user.id,
                                    isAdmin: isAdmin
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/camera"
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    minHeight: '100vh',
                                    backgroundColor: brandColor
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57722e66549ea09a$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/login"
                            })
                        })
                    ]
                })
            })
        ]
    });
}



(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=pawradise.ef895ce3.js.map
